//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @param flag (optional) 
     * @return OK
     */
    sendTenantEmailActivationLink(input: string | undefined, flag: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendTenantEmailActivationLink?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTenantEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTenantEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTenantEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    passEmailLoginLink(emailAddress: string | undefined, tenantId: number | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/PassEmailLoginLink?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPassEmailLoginLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPassEmailLoginLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processPassEmailLoginLink(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getClientInfo(emailAddress: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetClientInfo?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetClientInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isBackToImpersonator (optional) 
     * @return OK
     */
    generateImpersonationToken(tenantId: number | undefined, userId: number | undefined, isBackToImpersonator: boolean | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/GenerateImpersonationToken?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isBackToImpersonator === null)
            throw new globalThis.Error("The parameter 'isBackToImpersonator' cannot be null.");
        else if (isBackToImpersonator !== undefined)
            url_ += "isBackToImpersonator=" + encodeURIComponent("" + isBackToImpersonator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateImpersonationToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateImpersonationToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processGenerateImpersonationToken(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfImporsenatedUserDetails> {
        let url_ = this.baseUrl + "/api/services/app/Account/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfImporsenatedUserDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfImporsenatedUserDetails>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfImporsenatedUserDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfImporsenatedUserDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkUserTenantBeforLogin(body: CheckUserLoginWithTenant | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/CheckUserTenantBeforLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserTenantBeforLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserTenantBeforLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processCheckUserTenantBeforLogin(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTenancyInfo(): Observable<TenantUserIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetTenancyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantUserIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantUserIdDto>;
        }));
    }

    protected processGetTenancyInfo(response: HttpResponseBase): Observable<TenantUserIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantUserIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTenancyName(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetTenancyName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTenancyName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param currDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getRealTimeTeamTracking(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: number[] | undefined, orgUnitId: number[] | undefined, currDate: DateTime | undefined, timeZoneOffset: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserListWorkingStatus> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetRealTimeTeamTracking?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "CurrDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealTimeTeamTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealTimeTeamTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListWorkingStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListWorkingStatus>;
        }));
    }

    protected processGetRealTimeTeamTracking(response: HttpResponseBase): Observable<UserListWorkingStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListWorkingStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param connectionId (optional) 
     * @param deviceType (optional) 
     * @return OK
     */
    setConnectionId(userId: number | undefined, tenantId: number | undefined, connectionId: string | undefined, deviceType: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/SetConnectionId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (connectionId === null)
            throw new globalThis.Error("The parameter 'connectionId' cannot be null.");
        else if (connectionId !== undefined)
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";
        if (deviceType === null)
            throw new globalThis.Error("The parameter 'deviceType' cannot be null.");
        else if (deviceType !== undefined)
            url_ += "DeviceType=" + encodeURIComponent("" + deviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetConnectionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetConnectionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetConnectionId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param connectionId (optional) 
     * @return OK
     */
    deleteConnectionId(connectionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/DeleteConnectionId?";
        if (connectionId === null)
            throw new globalThis.Error("The parameter 'connectionId' cannot be null.");
        else if (connectionId !== undefined)
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConnectionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConnectionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConnectionId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getConnectionIds(userId: number | undefined, tenantId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetConnectionIds?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetConnectionIds(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUserApplicationActivity(body: UserActivityTempCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateUserApplicationActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserApplicationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserApplicationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserApplicationActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUserActiveWindowDetails(body: UserActiveWindowDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateUserActiveWindowDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserActiveWindowDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserActiveWindowDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserActiveWindowDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationName (optional) 
     * @param currDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getActiveWindowsHistoryForApp(applicationName: string | undefined, currDate: DateTime | undefined, userId: number | undefined, tenantId: number | undefined): Observable<ActiveWindowHistoryDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetActiveWindowsHistoryForApp?";
        if (applicationName === null)
            throw new globalThis.Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "ApplicationName=" + encodeURIComponent("" + applicationName) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "CurrDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveWindowsHistoryForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveWindowsHistoryForApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveWindowHistoryDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveWindowHistoryDetailsDto[]>;
        }));
    }

    protected processGetActiveWindowsHistoryForApp(response: HttpResponseBase): Observable<ActiveWindowHistoryDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveWindowHistoryDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApplicationProductiveTypesForAgentApp(userId: number | undefined, tenantId: number | undefined): Observable<AgentApplicationProductiveTypes[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetApplicationProductiveTypesForAgentApp?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationProductiveTypesForAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationProductiveTypesForAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationProductiveTypes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationProductiveTypes[]>;
        }));
    }

    protected processGetApplicationProductiveTypesForAgentApp(response: HttpResponseBase): Observable<AgentApplicationProductiveTypes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationProductiveTypes.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param search (optional) 
     * @param skipCount (optional) 
     * @param maxCount (optional) 
     * @return OK
     */
    getAllUserActivity(tenantId: number | undefined, userId: number | undefined, search: string | undefined, skipCount: number | undefined, maxCount: number | undefined): Observable<GetAllUserActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAllUserActivity?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxCount === null)
            throw new globalThis.Error("The parameter 'maxCount' cannot be null.");
        else if (maxCount !== undefined)
            url_ += "maxCount=" + encodeURIComponent("" + maxCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllUserActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllUserActivityDto>;
        }));
    }

    protected processGetAllUserActivity(response: HttpResponseBase): Observable<GetAllUserActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllUserActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSystemInformation(body: UserDeviceCreareOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateSystemInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSystemInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSystemInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSystemInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRealTimeLocation(body: UserRealTimeLocationCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateRealTimeLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRealTimeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRealTimeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRealTimeLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pLatitude (optional) 
     * @param pLogitude (optional) 
     * @return OK
     */
    getDevicePosition(pLatitude: number | undefined, pLogitude: number | undefined): Observable<RootRealTime> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetDevicePosition?";
        if (pLatitude === null)
            throw new globalThis.Error("The parameter 'pLatitude' cannot be null.");
        else if (pLatitude !== undefined)
            url_ += "pLatitude=" + encodeURIComponent("" + pLatitude) + "&";
        if (pLogitude === null)
            throw new globalThis.Error("The parameter 'pLogitude' cannot be null.");
        else if (pLogitude !== undefined)
            url_ += "pLogitude=" + encodeURIComponent("" + pLogitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RootRealTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RootRealTime>;
        }));
    }

    protected processGetDevicePosition(response: HttpResponseBase): Observable<RootRealTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RootRealTime.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRealTimeLocation(): Observable<UserRealTimeLocationCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetRealTimeLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealTimeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealTimeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRealTimeLocationCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRealTimeLocationCreateOrEditDto[]>;
        }));
    }

    protected processGetRealTimeLocation(response: HttpResponseBase): Observable<UserRealTimeLocationCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRealTimeLocationCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createScreenShot(body: ScreenShotCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateScreenShot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateScreenShot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offLineCreateScreenShot(body: ScreenShotCreateOrEditDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/OffLineCreateScreenShot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOffLineCreateScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffLineCreateScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOffLineCreateScreenShot(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offlineScreenshotData(body: string[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/OfflineScreenshotData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineScreenshotData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineScreenshotData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineScreenshotData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offlineAppTrackingData(body: string[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/OfflineAppTrackingData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineAppTrackingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineAppTrackingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineAppTrackingData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    offlineScreeShotDataForMAC(userId: number | undefined, body: OfflineScreenShotDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/OfflineScreeShotDataForMAC?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineScreeShotDataForMAC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineScreeShotDataForMAC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineScreeShotDataForMAC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    offlineAppTrackingDataForMAC(userId: number | undefined, body: OfflineApptrackingDataDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/OfflineAppTrackingDataForMAC?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineAppTrackingDataForMAC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineAppTrackingDataForMAC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineAppTrackingDataForMAC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param filterDate (optional) 
     * @param takeCount (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getPerticularUserWiseScreenShot(userId: number | undefined, tenantId: number | undefined, filterDate: DateTime | undefined, takeCount: number | undefined, timeZoneOffset: number | undefined): Observable<GetUserWiseScreenShotDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetPerticularUserWiseScreenShot?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' cannot be null.");
        else if (filterDate !== undefined)
            url_ += "filterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toString() : "") + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerticularUserWiseScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerticularUserWiseScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserWiseScreenShotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserWiseScreenShotDto[]>;
        }));
    }

    protected processGetPerticularUserWiseScreenShot(response: HttpResponseBase): Observable<GetUserWiseScreenShotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserWiseScreenShotDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteBunchOfScreenShot(id: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/DeleteBunchOfScreenShot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBunchOfScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBunchOfScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBunchOfScreenShot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserActiveScreenShot(userId: number | undefined, tenantId: number | undefined): Observable<TakeScreenShotDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUserActiveScreenShot?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActiveScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActiveScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TakeScreenShotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TakeScreenShotDto>;
        }));
    }

    protected processGetUserActiveScreenShot(response: HttpResponseBase): Observable<TakeScreenShotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TakeScreenShotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserCurrentScreenShot(userId: number | undefined, tenantId: number | undefined): Observable<TakeScreenShotDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUserCurrentScreenShot?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCurrentScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCurrentScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TakeScreenShotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TakeScreenShotDto>;
        }));
    }

    protected processGetUserCurrentScreenShot(response: HttpResponseBase): Observable<TakeScreenShotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TakeScreenShotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    createLiveScreenShotCall(userId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateLiveScreenShotCall?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLiveScreenShotCall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLiveScreenShotCall(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLiveScreenShotCall(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getFilterApplicationDropdown(filter: string | undefined): Observable<UserActivityTempGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetFilterApplicationDropdown?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterApplicationDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterApplicationDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivityTempGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivityTempGetAllDto[]>;
        }));
    }

    protected processGetFilterApplicationDropdown(response: HttpResponseBase): Observable<UserActivityTempGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivityTempGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param currDate (optional) 
     * @return OK
     */
    getCountNumberOfUserCheckIn(timeZoneOffset: number | undefined, currDate: DateTime | undefined): Observable<NumberOfEmployeeDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetCountNumberOfUserCheckIn?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountNumberOfUserCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountNumberOfUserCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NumberOfEmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NumberOfEmployeeDto>;
        }));
    }

    protected processGetCountNumberOfUserCheckIn(response: HttpResponseBase): Observable<NumberOfEmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NumberOfEmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTotalEmployeeCount(): Observable<NumberOfEmployeeDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetTotalEmployeeCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalEmployeeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalEmployeeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NumberOfEmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NumberOfEmployeeDto>;
        }));
    }

    protected processGetTotalEmployeeCount(response: HttpResponseBase): Observable<NumberOfEmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NumberOfEmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPerticularUserCheckInCheckOutStatus(id: number | undefined): Observable<CheckinDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetPerticularUserCheckInCheckOutStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerticularUserCheckInCheckOutStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerticularUserCheckInCheckOutStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinDto>;
        }));
    }

    protected processGetPerticularUserCheckInCheckOutStatus(response: HttpResponseBase): Observable<CheckinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveScreenShot(body: ScreenShotCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/SaveScreenShot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveScreenShot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserWiseCurrentScreenShot(userId: number | undefined, tenantId: number | undefined): Observable<GetUserWiseScreenShotDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUserWiseCurrentScreenShot?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWiseCurrentScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWiseCurrentScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserWiseScreenShotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserWiseScreenShotDto>;
        }));
    }

    protected processGetUserWiseCurrentScreenShot(response: HttpResponseBase): Observable<GetUserWiseScreenShotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserWiseScreenShotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    isCheckLiveScreenShot(userId: number | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/IsCheckLiveScreenShot?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckLiveScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckLiveScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCheckLiveScreenShot(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteScreenShotImage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/DeleteScreenShotImage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScreenShotImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScreenShotImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteScreenShotImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param cAId (optional) 
     * @return OK
     */
    deleteCurrentApplication(userId: number | undefined, tenantId: number | undefined, cAId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/DeleteCurrentApplication?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (cAId === null)
            throw new globalThis.Error("The parameter 'cAId' cannot be null.");
        else if (cAId !== undefined)
            url_ += "cAId=" + encodeURIComponent("" + cAId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCurrentApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCurrentApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCurrentApplication(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllProductivityType(): Observable<ProductivityTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAllProductivityType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProductivityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductivityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityTypeDto[]>;
        }));
    }

    protected processGetAllProductivityType(response: HttpResponseBase): Observable<ProductivityTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductivityTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllApplicationType(): Observable<ApplicationTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAllApplicationType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationTypeDto[]>;
        }));
    }

    protected processGetAllApplicationType(response: HttpResponseBase): Observable<ApplicationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllBrowserList(): Observable<BrowserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAllBrowserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBrowserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBrowserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BrowserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BrowserDto[]>;
        }));
    }

    protected processGetAllBrowserList(response: HttpResponseBase): Observable<BrowserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrowserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentAppId (optional) 
     * @param sSComments (optional) 
     * @return OK
     */
    addScreenShotComment(currentAppId: number | undefined, sSComments: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/AddScreenShotComment?";
        if (currentAppId === null)
            throw new globalThis.Error("The parameter 'currentAppId' cannot be null.");
        else if (currentAppId !== undefined)
            url_ += "currentAppId=" + encodeURIComponent("" + currentAppId) + "&";
        if (sSComments === null)
            throw new globalThis.Error("The parameter 'sSComments' cannot be null.");
        else if (sSComments !== undefined)
            url_ += "sSComments=" + encodeURIComponent("" + sSComments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddScreenShotComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddScreenShotComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddScreenShotComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getOrganizationUnitsList(filter: string | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetOrganizationUnitsList?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetOrganizationUnitsList(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param currentDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getInActiveUser(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, currentDate: DateTime | undefined, timeZoneOffset: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfInActiveUserDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetInActiveUser?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInActiveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInActiveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfInActiveUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfInActiveUserDto>;
        }));
    }

    protected processGetInActiveUser(response: HttpResponseBase): Observable<PagedResultDtoOfInActiveUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfInActiveUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param currentDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getInActiveUserWithWorkType(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, currentDate: DateTime | undefined, timeZoneOffset: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfInActiveUserWithWorkTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetInActiveUserWithWorkType?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInActiveUserWithWorkType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInActiveUserWithWorkType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfInActiveUserWithWorkTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfInActiveUserWithWorkTypeDto>;
        }));
    }

    protected processGetInActiveUserWithWorkType(response: HttpResponseBase): Observable<PagedResultDtoOfInActiveUserWithWorkTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfInActiveUserWithWorkTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param currentDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getActiveUser(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, currentDate: DateTime | undefined, timeZoneOffset: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfActiveUserDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetActiveUser?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfActiveUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfActiveUserDto>;
        }));
    }

    protected processGetActiveUser(response: HttpResponseBase): Observable<PagedResultDtoOfActiveUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActiveUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param currentDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getSlackingUser(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, currentDate: DateTime | undefined, timeZoneOffset: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ActiveUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetSlackingUser?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlackingUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlackingUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveUserDto[]>;
        }));
    }

    protected processGetSlackingUser(response: HttpResponseBase): Observable<ActiveUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offlineCreateUserApplicationActivity(body: UserActivityTempCreateOrEditDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Activity/OfflineCreateUserApplicationActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineCreateUserApplicationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineCreateUserApplicationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineCreateUserApplicationActivity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param prodCalDate (optional) 
     * @param timezoneOffset (optional) 
     * @param currDate (optional) 
     * @return OK
     */
    getUserProductivityPercentage(userId: number | undefined, tenantId: number | undefined, prodCalDate: DateTime | undefined, timezoneOffset: number | undefined, currDate: DateTime | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUserProductivityPercentage?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "prodCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (timezoneOffset === null)
            throw new globalThis.Error("The parameter 'timezoneOffset' cannot be null.");
        else if (timezoneOffset !== undefined)
            url_ += "TimezoneOffset=" + encodeURIComponent("" + timezoneOffset) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProductivityPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProductivityPercentage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserProductivityPercentage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param currDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param orgIds (optional) 
     * @param proIds (optional) 
     * @param useIds (optional) 
     * @return OK
     */
    getTenantProductivityPercentage(tenantId: number | undefined, currDate: DateTime | undefined, timeZoneOffset: number | undefined, orgIds: number[] | undefined, proIds: number[] | undefined, useIds: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetTenantProductivityPercentage?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (orgIds === null)
            throw new globalThis.Error("The parameter 'orgIds' cannot be null.");
        else if (orgIds !== undefined)
            orgIds && orgIds.forEach(item => { url_ += "orgIds=" + encodeURIComponent("" + item) + "&"; });
        if (proIds === null)
            throw new globalThis.Error("The parameter 'proIds' cannot be null.");
        else if (proIds !== undefined)
            proIds && proIds.forEach(item => { url_ += "proIds=" + encodeURIComponent("" + item) + "&"; });
        if (useIds === null)
            throw new globalThis.Error("The parameter 'useIds' cannot be null.");
        else if (useIds !== undefined)
            useIds && useIds.forEach(item => { url_ += "useIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantProductivityPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantProductivityPercentage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantProductivityPercentage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getProductivityFormulaByTenantId(tenantId: number | undefined): Observable<ProductivityFormulaDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetProductivityFormulaByTenantId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityFormulaByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityFormulaByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityFormulaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityFormulaDto>;
        }));
    }

    protected processGetProductivityFormulaByTenantId(response: HttpResponseBase): Observable<ProductivityFormulaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductivityFormulaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateProductivityFormula(body: ProductivityFormulaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateOrUpdateProductivityFormula";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProductivityFormula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProductivityFormula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateProductivityFormula(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @return OK
     */
    uploadScreenShotToBlob(tenantID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/UploadScreenShotToBlob?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadScreenShotToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadScreenShotToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadScreenShotToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    truncateScreenShotTable(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/TruncateScreenShotTable?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruncateScreenShotTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruncateScreenShotTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTruncateScreenShotTable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uploadWindowsTrackingDataToBlob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/UploadWindowsTrackingDataToBlob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadWindowsTrackingDataToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadWindowsTrackingDataToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadWindowsTrackingDataToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    agentAppVersionNo(): Observable<AgentVersionDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/AgentAppVersionNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentAppVersionNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentAppVersionNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentVersionDto>;
        }));
    }

    protected processAgentAppVersionNo(response: HttpResponseBase): Observable<AgentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    electronMICOAppVersionNo(): Observable<AgentVersionDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/ElectronMICOAppVersionNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElectronMICOAppVersionNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElectronMICOAppVersionNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentVersionDto>;
        }));
    }

    protected processElectronMICOAppVersionNo(response: HttpResponseBase): Observable<AgentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    mAcAppVersionNo(): Observable<AgentVersionDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/MAcAppVersionNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMAcAppVersionNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMAcAppVersionNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentVersionDto>;
        }));
    }

    protected processMAcAppVersionNo(response: HttpResponseBase): Observable<AgentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param projectIdFilter (optional) 
     * @return OK
     */
    getUserWiseLiveScreenShots(userIds: number[] | undefined, projectIdFilter: number[] | undefined): Observable<UserWiseLiveScreenShotDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUserWiseLiveScreenShots?";
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectIdFilter === null)
            throw new globalThis.Error("The parameter 'projectIdFilter' cannot be null.");
        else if (projectIdFilter !== undefined)
            projectIdFilter && projectIdFilter.forEach(item => { url_ += "projectIdFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWiseLiveScreenShots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWiseLiveScreenShots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWiseLiveScreenShotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWiseLiveScreenShotDto[]>;
        }));
    }

    protected processGetUserWiseLiveScreenShots(response: HttpResponseBase): Observable<UserWiseLiveScreenShotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWiseLiveScreenShotDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @param passDate (optional) 
     * @return OK
     */
    manualUploadScreenShotToBlob(tenantID: number | undefined, passDate: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/ManualUploadScreenShotToBlob?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        if (passDate === null)
            throw new globalThis.Error("The parameter 'passDate' cannot be null.");
        else if (passDate !== undefined)
            url_ += "passDate=" + encodeURIComponent("" + passDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManualUploadScreenShotToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualUploadScreenShotToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processManualUploadScreenShotToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uplodeUserUserScreenShortJson(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/UplodeUserUserScreenShortJson?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeUserUserScreenShortJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeUserUserScreenShortJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUplodeUserUserScreenShortJson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addApplicationTrackingAndWindowsTrackingCombine(body: ApplicationTrackingAndWindowsTrackingCombineDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/AddApplicationTrackingAndWindowsTrackingCombine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddApplicationTrackingAndWindowsTrackingCombine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddApplicationTrackingAndWindowsTrackingCombine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddApplicationTrackingAndWindowsTrackingCombine(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param screenshotInterval (optional) 
     * @return OK
     */
    giveIntervalTime(screenshotInterval: number | undefined): Observable<ScreenShotCaptureTime> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GiveIntervalTime?";
        if (screenshotInterval === null)
            throw new globalThis.Error("The parameter 'screenshotInterval' cannot be null.");
        else if (screenshotInterval !== undefined)
            url_ += "screenshotInterval=" + encodeURIComponent("" + screenshotInterval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGiveIntervalTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGiveIntervalTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScreenShotCaptureTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScreenShotCaptureTime>;
        }));
    }

    protected processGiveIntervalTime(response: HttpResponseBase): Observable<ScreenShotCaptureTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param filterDate (optional) 
     * @return OK
     */
    getScreenShotInfoOnTheBasisOfHours(tenantId: number | undefined, filterDate: DateTime | undefined): Observable<UserScreenShotCountBasedOnSlotGroup[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetScreenShotInfoOnTheBasisOfHours?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' cannot be null.");
        else if (filterDate !== undefined)
            url_ += "filterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScreenShotInfoOnTheBasisOfHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScreenShotInfoOnTheBasisOfHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserScreenShotCountBasedOnSlotGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserScreenShotCountBasedOnSlotGroup[]>;
        }));
    }

    protected processGetScreenShotInfoOnTheBasisOfHours(response: HttpResponseBase): Observable<UserScreenShotCountBasedOnSlotGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserScreenShotCountBasedOnSlotGroup.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationName (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getActiveWindowsHistoryForDateRange(applicationName: string | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, userId: number | undefined, tenantId: number | undefined): Observable<ActiveWindowHistoryDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetActiveWindowsHistoryForDateRange?";
        if (applicationName === null)
            throw new globalThis.Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "ApplicationName=" + encodeURIComponent("" + applicationName) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveWindowsHistoryForDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveWindowsHistoryForDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveWindowHistoryDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveWindowHistoryDetailsDto[]>;
        }));
    }

    protected processGetActiveWindowsHistoryForDateRange(response: HttpResponseBase): Observable<ActiveWindowHistoryDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveWindowHistoryDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AddAwayTimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: AddAwayTimeCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: AddAwayTimeCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTimeOffComments(body: AddTimeOffCommentsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/CreateTimeOffComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTimeOffComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTimeOffComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTimeOffComments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getTimeOffComments(taskId: number | undefined): Observable<GetTimeOffCommentsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetTimeOffComments?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeOffComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeOffComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTimeOffCommentsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTimeOffCommentsDto[]>;
        }));
    }

    protected processGetTimeOffComments(response: HttpResponseBase): Observable<GetTimeOffCommentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTimeOffCommentsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getAllAddTimeList(projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllAddTimeList?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAddTimeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAddTimeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllAddTimeList(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getApprovalDataById(id: number | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetApprovalDataById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalDataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalDataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetApprovalDataById(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param awayTimeTypeId (optional) 
     * @param statusId (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllForApprovals(filter: string | undefined, awayTimeTypeId: (number | undefined)[] | undefined, statusId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllForApprovals?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (awayTimeTypeId === null)
            throw new globalThis.Error("The parameter 'awayTimeTypeId' cannot be null.");
        else if (awayTimeTypeId !== undefined)
            awayTimeTypeId && awayTimeTypeId.forEach(item => { url_ += "AwayTimeTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            statusId && statusId.forEach(item => { url_ += "statusId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllForApprovals(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param awayTimeTypeId (optional) 
     * @param statusId (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllForMyTimeOff(filter: string | undefined, awayTimeTypeId: (number | undefined)[] | undefined, statusId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllForMyTimeOff?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (awayTimeTypeId === null)
            throw new globalThis.Error("The parameter 'awayTimeTypeId' cannot be null.");
        else if (awayTimeTypeId !== undefined)
            awayTimeTypeId && awayTimeTypeId.forEach(item => { url_ += "AwayTimeTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            statusId && statusId.forEach(item => { url_ += "statusId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForMyTimeOff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForMyTimeOff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllForMyTimeOff(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllCalendarViewById(id: number | undefined): Observable<AddAwayTimeGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllCalendarViewById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalendarViewById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalendarViewById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto>;
        }));
    }

    protected processGetAllCalendarViewById(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAwayTimeGetAllDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param locationId (optional) 
     * @param isShowAll (optional) 
     * @return OK
     */
    getAllCalendarView(filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, locationId: number[] | undefined, isShowAll: boolean | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllCalendarView?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "isShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalendarView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalendarView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllCalendarView(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataSourceLoadOptions (optional) 
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param locationId (optional) 
     * @param isShowAll (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllCalendarViewV2(dataSourceLoadOptions: string | undefined, timeZoneOffset: number | undefined, filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, locationId: string[] | undefined, isShowAll: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllCalendarViewV2?";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "isShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalendarViewV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalendarViewV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto>;
        }));
    }

    protected processGetAllCalendarViewV2(response: HttpResponseBase): Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getApproveDataById(id: number | undefined): Observable<AddAwayTimeGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetApproveDataById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApproveDataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApproveDataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto>;
        }));
    }

    protected processGetApproveDataById(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAwayTimeGetAllDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param awayTimeTypes (optional) 
     * @param addTimeStatus (optional) 
     * @param sortId (optional) 
     * @param filterText (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getAllForPerticularUser(userId: number | undefined, awayTimeTypes: number[] | undefined, addTimeStatus: number[] | undefined, sortId: number | undefined, filterText: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllForPerticularUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (awayTimeTypes === null)
            throw new globalThis.Error("The parameter 'awayTimeTypes' cannot be null.");
        else if (awayTimeTypes !== undefined)
            awayTimeTypes && awayTimeTypes.forEach(item => { url_ += "awayTimeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (addTimeStatus === null)
            throw new globalThis.Error("The parameter 'addTimeStatus' cannot be null.");
        else if (addTimeStatus !== undefined)
            addTimeStatus && addTimeStatus.forEach(item => { url_ += "addTimeStatus=" + encodeURIComponent("" + item) + "&"; });
        if (sortId === null)
            throw new globalThis.Error("The parameter 'sortId' cannot be null.");
        else if (sortId !== undefined)
            url_ += "sortId=" + encodeURIComponent("" + sortId) + "&";
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForPerticularUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForPerticularUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllForPerticularUser(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editTimeoffId (optional) 
     * @param isAddMode (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkDuplicateAddAwayTime(editTimeoffId: number | undefined, isAddMode: boolean | undefined, body: AddAwayTimeCreateOrEditDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/CheckDuplicateAddAwayTime?";
        if (editTimeoffId === null)
            throw new globalThis.Error("The parameter 'editTimeoffId' cannot be null.");
        else if (editTimeoffId !== undefined)
            url_ += "editTimeoffId=" + encodeURIComponent("" + editTimeoffId) + "&";
        if (isAddMode === null)
            throw new globalThis.Error("The parameter 'isAddMode' cannot be null.");
        else if (isAddMode !== undefined)
            url_ += "isAddMode=" + encodeURIComponent("" + isAddMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicateAddAwayTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicateAddAwayTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicateAddAwayTime(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param flag (optional) 
     * @return OK
     */
    updateTimesheetRequestStatus(id: number | undefined, flag: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/UpdateTimesheetRequestStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimesheetRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimesheetRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTimesheetRequestStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timeSheetApproval(body: AddAwayTimeInputDto | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/TimeSheetApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeSheetApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeSheetApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processTimeSheetApproval(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUserLeaveData(userId: number | undefined): Observable<TimeOffLeaveDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetUserLeaveData?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLeaveData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLeaveData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeOffLeaveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeOffLeaveDto>;
        }));
    }

    protected processGetUserLeaveData(response: HttpResponseBase): Observable<TimeOffLeaveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeOffLeaveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUsersProjects(userId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetUsersProjects?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetUsersProjects(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param flag (optional) 
     * @param approvedLeaveCount (optional) 
     * @param userId (optional) 
     * @param leaveType (optional) 
     * @param approverId (optional) 
     * @return OK
     */
    updateRequestStatus(id: number | undefined, flag: string | undefined, approvedLeaveCount: number | undefined, userId: number | undefined, leaveType: number | undefined, approverId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/UpdateRequestStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (approvedLeaveCount === null)
            throw new globalThis.Error("The parameter 'approvedLeaveCount' cannot be null.");
        else if (approvedLeaveCount !== undefined)
            url_ += "approvedLeaveCount=" + encodeURIComponent("" + approvedLeaveCount) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (leaveType === null)
            throw new globalThis.Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        if (approverId === null)
            throw new globalThis.Error("The parameter 'approverId' cannot be null.");
        else if (approverId !== undefined)
            url_ += "approverId=" + encodeURIComponent("" + approverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRequestStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getAllApprovals(filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, locationId: number[] | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllApprovals?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllApprovals(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getCalendarViewLeaveHoliday(filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, locationId: number[] | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetCalendarViewLeaveHoliday?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarViewLeaveHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarViewLeaveHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetCalendarViewLeaveHoliday(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getCalendarViewLeavePlusPublicHoliday(filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, locationId: number[] | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetCalendarViewLeavePlusPublicHoliday?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarViewLeavePlusPublicHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarViewLeavePlusPublicHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetCalendarViewLeavePlusPublicHoliday(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getUsersCalendar(filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, locationId: number[] | undefined): Observable<UsersCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetUsersCalendar?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersCalendarDto>;
        }));
    }

    protected processGetUsersCalendar(response: HttpResponseBase): Observable<UsersCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteTimeOfById(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/DeleteTimeOfById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTimeOfById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTimeOfById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTimeOfById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTimeoffById(id: number | undefined): Observable<AddAwayTimeCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetTimeoffById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeoffById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeoffById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeCreateOrEditDto>;
        }));
    }

    protected processGetTimeoffById(response: HttpResponseBase): Observable<AddAwayTimeCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAwayTimeCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param awayTimeId (optional) 
     * @return OK
     */
    getAwayTimeProjects(awayTimeId: number | undefined): Observable<ProjectInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAwayTimeProjects?";
        if (awayTimeId === null)
            throw new globalThis.Error("The parameter 'awayTimeId' cannot be null.");
        else if (awayTimeId !== undefined)
            url_ += "awayTimeId=" + encodeURIComponent("" + awayTimeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwayTimeProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwayTimeProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectInfo[]>;
        }));
    }

    protected processGetAwayTimeProjects(response: HttpResponseBase): Observable<ProjectInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkHolidaySelected(body: AddAwayTimeCreateOrEditDto | undefined): Observable<LeaveValiditityDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/CheckHolidaySelected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHolidaySelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHolidaySelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveValiditityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveValiditityDto>;
        }));
    }

    protected processCheckHolidaySelected(response: HttpResponseBase): Observable<LeaveValiditityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveValiditityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editTimeoffId (optional) 
     * @param isAddMode (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkAwayTimeValidity(editTimeoffId: number | undefined, isAddMode: boolean | undefined, body: AddAwayTimeCreateOrEditDto | undefined): Observable<LeaveValiditityDto> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/CheckAwayTimeValidity?";
        if (editTimeoffId === null)
            throw new globalThis.Error("The parameter 'editTimeoffId' cannot be null.");
        else if (editTimeoffId !== undefined)
            url_ += "editTimeoffId=" + encodeURIComponent("" + editTimeoffId) + "&";
        if (isAddMode === null)
            throw new globalThis.Error("The parameter 'isAddMode' cannot be null.");
        else if (isAddMode !== undefined)
            url_ += "isAddMode=" + encodeURIComponent("" + isAddMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAwayTimeValidity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAwayTimeValidity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveValiditityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveValiditityDto>;
        }));
    }

    protected processCheckAwayTimeValidity(response: HttpResponseBase): Observable<LeaveValiditityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveValiditityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCalendarViewdashbord(): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetAllCalendarViewdashbord";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalendarViewdashbord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalendarViewdashbord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetAllCalendarViewdashbord(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param allUserDetails (optional) 
     * @param locationDetails (optional) 
     * @param publicHolidayDetails (optional) 
     * @param publicHolidayLocationDetails (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getDaysTaken(allUserDetails: UserListDto[] | undefined, locationDetails: LocationSetting[] | undefined, publicHolidayDetails: PublicHolidayCacheDto[] | undefined, publicHolidayLocationDetails: PublicHolidayLocationCacheDto[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, userId: number | undefined, leaveTypeInfo: LeaveTypeInfo): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetDaysTaken?";
        if (allUserDetails === null)
            throw new globalThis.Error("The parameter 'allUserDetails' cannot be null.");
        else if (allUserDetails !== undefined)
            allUserDetails && allUserDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "allUserDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locationDetails === null)
            throw new globalThis.Error("The parameter 'locationDetails' cannot be null.");
        else if (locationDetails !== undefined)
            locationDetails && locationDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "locationDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (publicHolidayDetails === null)
            throw new globalThis.Error("The parameter 'publicHolidayDetails' cannot be null.");
        else if (publicHolidayDetails !== undefined)
            publicHolidayDetails && publicHolidayDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "publicHolidayDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (publicHolidayLocationDetails === null)
            throw new globalThis.Error("The parameter 'publicHolidayLocationDetails' cannot be null.");
        else if (publicHolidayLocationDetails !== undefined)
            publicHolidayLocationDetails && publicHolidayLocationDetails.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "publicHolidayLocationDetails[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (leaveTypeInfo === undefined || leaveTypeInfo === null)
            throw new globalThis.Error("The parameter 'leaveTypeInfo' must be defined and cannot be null.");
        else
            url_ += "LeaveTypeInfo=" + encodeURIComponent("" + leaveTypeInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDaysTaken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDaysTaken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDaysTaken(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    daysCount(fromDate: DateTime | undefined, toDate: DateTime | undefined, userId: number | undefined, body: LeaveType | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/DaysCount?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaysCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaysCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDaysCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startD (optional) 
     * @param endD (optional) 
     * @return OK
     */
    getWorkingDays(startD: DateTime | undefined, endD: DateTime | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/GetWorkingDays?";
        if (startD === null)
            throw new globalThis.Error("The parameter 'startD' cannot be null.");
        else if (startD !== undefined)
            url_ += "startD=" + encodeURIComponent(startD ? "" + startD.toString() : "") + "&";
        if (endD === null)
            throw new globalThis.Error("The parameter 'endD' cannot be null.");
        else if (endD !== undefined)
            url_ += "endD=" + encodeURIComponent(endD ? "" + endD.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetWorkingDays(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    updateLeaveDiffBaseOnLeaveAsPerMonth(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/UpdateLeaveDiffBaseOnLeaveAsPerMonth?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeaveDiffBaseOnLeaveAsPerMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeaveDiffBaseOnLeaveAsPerMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLeaveDiffBaseOnLeaveAsPerMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    leavesCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/LeavesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeavesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeavesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLeavesCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    updateYearchangeLevae(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/UpdateYearchangeLevae?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateYearchangeLevae(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateYearchangeLevae(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateYearchangeLevae(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    changeLeaveStatusPreviousLeaves(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AddAwayTime/ChangeLeaveStatusPreviousLeaves?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLeaveStatusPreviousLeaves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLeaveStatusPreviousLeaves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLeaveStatusPreviousLeaves(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgentDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserInfoForDashboard(userId: number | undefined, tenantId: number | undefined): Observable<GetUserInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentDashboard/GetUserInfoForDashboard?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfoForDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfoForDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserInfoDto>;
        }));
    }

    protected processGetUserInfoForDashboard(response: HttpResponseBase): Observable<GetUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param mode (optional) 
     * @return OK
     */
    userTaskPresentModeCount(userId: number | undefined, tenantId: number | undefined, mode: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgentDashboard/UserTaskPresentModeCount?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (mode === null)
            throw new globalThis.Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserTaskPresentModeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserTaskPresentModeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUserTaskPresentModeCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgentHelperServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentDateTime(): Observable<DateTime> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/GetCurrentDateTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime>;
        }));
    }

    protected processGetCurrentDateTime(response: HttpResponseBase): Observable<DateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    agentCreateOrEditUserProjectTask(body: UserProjectTaskInputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/AgentCreateOrEditUserProjectTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentCreateOrEditUserProjectTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentCreateOrEditUserProjectTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAgentCreateOrEditUserProjectTask(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taksId (optional) 
     * @return OK
     */
    agentGetTaskById(taksId: number | undefined): Observable<ProjectTaskCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/AgentGetTaskById?";
        if (taksId === null)
            throw new globalThis.Error("The parameter 'taksId' cannot be null.");
        else if (taksId !== undefined)
            url_ += "TaksId=" + encodeURIComponent("" + taksId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentGetTaskById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentGetTaskById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskCreateOrEditDto>;
        }));
    }

    protected processAgentGetTaskById(response: HttpResponseBase): Observable<ProjectTaskCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTaskCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditAgentAppSetting(body: CreateOrEditAgentAppSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/CreateOrEditAgentAppSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAgentAppSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAgentAppSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditAgentAppSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getAgentAppSettingForEditView(tenantId: number | undefined, userId: number | undefined): Observable<CreateOrEditAgentAppSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/GetAgentAppSettingForEditView?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentAppSettingForEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentAppSettingForEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditAgentAppSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditAgentAppSettingDto>;
        }));
    }

    protected processGetAgentAppSettingForEditView(response: HttpResponseBase): Observable<CreateOrEditAgentAppSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditAgentAppSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkVersionUpdateAvailable(): Observable<AutoUpdaterDTO> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/CheckVersionUpdateAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckVersionUpdateAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckVersionUpdateAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutoUpdaterDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutoUpdaterDTO>;
        }));
    }

    protected processCheckVersionUpdateAvailable(response: HttpResponseBase): Observable<AutoUpdaterDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutoUpdaterDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param mACAddress (optional) 
     * @return OK
     */
    checkVersionUpdatedMACAddress(id: number | undefined, mACAddress: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/CheckVersionUpdatedMACAddress?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (mACAddress === null)
            throw new globalThis.Error("The parameter 'mACAddress' cannot be null.");
        else if (mACAddress !== undefined)
            url_ += "MACAddress=" + encodeURIComponent("" + mACAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckVersionUpdatedMACAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckVersionUpdatedMACAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckVersionUpdatedMACAddress(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param computerName (optional) 
     * @param mACAddress (optional) 
     * @return OK
     */
    checkMyCurrentVersion(computerName: string | undefined, mACAddress: string | undefined): Observable<AgentAppMachineDto> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/CheckMyCurrentVersion?";
        if (computerName === null)
            throw new globalThis.Error("The parameter 'computerName' cannot be null.");
        else if (computerName !== undefined)
            url_ += "ComputerName=" + encodeURIComponent("" + computerName) + "&";
        if (mACAddress === null)
            throw new globalThis.Error("The parameter 'mACAddress' cannot be null.");
        else if (mACAddress !== undefined)
            url_ += "MACAddress=" + encodeURIComponent("" + mACAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMyCurrentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMyCurrentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentAppMachineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentAppMachineDto>;
        }));
    }

    protected processCheckMyCurrentVersion(response: HttpResponseBase): Observable<AgentAppMachineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentAppMachineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentVersionId (optional) 
     * @param computerName (optional) 
     * @param mACAddress (optional) 
     * @return OK
     */
    insertAutoUpdateMACAddress(currentVersionId: number | undefined, computerName: string | undefined, mACAddress: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/InsertAutoUpdateMACAddress?";
        if (currentVersionId === null)
            throw new globalThis.Error("The parameter 'currentVersionId' cannot be null.");
        else if (currentVersionId !== undefined)
            url_ += "currentVersionId=" + encodeURIComponent("" + currentVersionId) + "&";
        if (computerName === null)
            throw new globalThis.Error("The parameter 'computerName' cannot be null.");
        else if (computerName !== undefined)
            url_ += "ComputerName=" + encodeURIComponent("" + computerName) + "&";
        if (mACAddress === null)
            throw new globalThis.Error("The parameter 'mACAddress' cannot be null.");
        else if (mACAddress !== undefined)
            url_ += "MACAddress=" + encodeURIComponent("" + mACAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertAutoUpdateMACAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertAutoUpdateMACAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertAutoUpdateMACAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCrashReport(body: CreateAgentAppCrashReportDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/CreateCrashReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCrashReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCrashReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCrashReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getCrashReport(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<CreateAgentAppCrashReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/GetCrashReport?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrashReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrashReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAgentAppCrashReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAgentAppCrashReportDto[]>;
        }));
    }

    protected processGetCrashReport(response: HttpResponseBase): Observable<CreateAgentAppCrashReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateAgentAppCrashReportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListOfIpaddress(): Observable<GetLocationIpAddress[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/GetListOfIpaddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListOfIpaddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListOfIpaddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationIpAddress[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationIpAddress[]>;
        }));
    }

    protected processGetListOfIpaddress(response: HttpResponseBase): Observable<GetLocationIpAddress[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLocationIpAddress.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param chekingTime (optional) 
     * @return OK
     */
    userAutoChecking(userId: number | undefined, tenantId: number | undefined, chekingTime: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/UserAutoChecking?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (chekingTime === null)
            throw new globalThis.Error("The parameter 'chekingTime' cannot be null.");
        else if (chekingTime !== undefined)
            url_ += "chekingTime=" + encodeURIComponent(chekingTime ? "" + chekingTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAutoChecking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAutoChecking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserAutoChecking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signalRetOrUpdateUserStatusFromAgentAPI(body: ProjectTaskStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/SignalRetOrUpdateUserStatusFromAgentAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalRetOrUpdateUserStatusFromAgentAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalRetOrUpdateUserStatusFromAgentAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignalRetOrUpdateUserStatusFromAgentAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signalRSetOrUpdateUserStatusOfflineAPI(body: OfflineStopDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/SignalRSetOrUpdateUserStatusOfflineAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalRSetOrUpdateUserStatusOfflineAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalRSetOrUpdateUserStatusOfflineAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignalRSetOrUpdateUserStatusOfflineAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getElectronReleaseDate(): Observable<DateTime> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/GetElectronReleaseDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectronReleaseDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectronReleaseDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime>;
        }));
    }

    protected processGetElectronReleaseDate(response: HttpResponseBase): Observable<DateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signalRStartOrStopUserProjectTaskTimerAPI(body: UserTaskInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgentHelper/SignalRStartOrStopUserProjectTaskTimerAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalRStartOrStopUserProjectTaskTimerAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalRStartOrStopUserProjectTaskTimerAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignalRStartOrStopUserProjectTaskTimerAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AllDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param currentDate (optional) 
     * @param prodCalDate (optional) 
     * @param weekRange (optional) 
     * @return OK
     */
    getUserTimeCalculation(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneOffset: number | undefined, currentDate: DateTime | undefined, prodCalDate: DateTime | undefined, weekRange: DateTime[] | undefined): Observable<CalculationTimeAndAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetUserTimeCalculation?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "ProdCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (weekRange === null)
            throw new globalThis.Error("The parameter 'weekRange' cannot be null.");
        else if (weekRange !== undefined)
            weekRange && weekRange.forEach(item_ => { url_ += "WeekRange=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTimeCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTimeCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationTimeAndAttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationTimeAndAttendanceDto>;
        }));
    }

    protected processGetUserTimeCalculation(response: HttpResponseBase): Observable<CalculationTimeAndAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationTimeAndAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param currentDate (optional) 
     * @param prodCalDate (optional) 
     * @param weekRange (optional) 
     * @return OK
     */
    getUserTimeCalculationForMobile(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneOffset: number | undefined, currentDate: DateTime | undefined, prodCalDate: DateTime | undefined, weekRange: DateTime[] | undefined): Observable<CalculationTimeAndAttendanceDtoForMobile> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetUserTimeCalculationForMobile?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "ProdCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (weekRange === null)
            throw new globalThis.Error("The parameter 'weekRange' cannot be null.");
        else if (weekRange !== undefined)
            weekRange && weekRange.forEach(item_ => { url_ += "WeekRange=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTimeCalculationForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTimeCalculationForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationTimeAndAttendanceDtoForMobile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationTimeAndAttendanceDtoForMobile>;
        }));
    }

    protected processGetUserTimeCalculationForMobile(response: HttpResponseBase): Observable<CalculationTimeAndAttendanceDtoForMobile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationTimeAndAttendanceDtoForMobile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param statusId (optional) 
     * @param isTimesheet (optional) 
     * @return OK
     */
    getTaskList(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, statusId: number | undefined, isTimesheet: boolean | undefined): Observable<UserProjectTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetTaskList?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isTimesheet === null)
            throw new globalThis.Error("The parameter 'isTimesheet' cannot be null.");
        else if (isTimesheet !== undefined)
            url_ += "IsTimesheet=" + encodeURIComponent("" + isTimesheet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskListDto[]>;
        }));
    }

    protected processGetTaskList(response: HttpResponseBase): Observable<UserProjectTaskListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    myTimesheet(): Observable<DashboardMyTimesheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/MyTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardMyTimesheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardMyTimesheetDto[]>;
        }));
    }

    protected processMyTimesheet(response: HttpResponseBase): Observable<DashboardMyTimesheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardMyTimesheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUserWiseProductiveApplication(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetUserWiseProductiveApplication?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWiseProductiveApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWiseProductiveApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetUserWiseProductiveApplication(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUserWiseUnProductiveApplication(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetUserWiseUnProductiveApplication?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWiseUnProductiveApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWiseUnProductiveApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetUserWiseUnProductiveApplication(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isShowAll (optional) 
     * @param applicationCategoryId (optional) 
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @return OK
     */
    getUserNuetralApplication(isShowAll: boolean | undefined, applicationCategoryId: number | undefined, timeZoneOffset: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetUserNuetralApplication?";
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNuetralApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNuetralApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetUserNuetralApplication(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkInCheckOut(body: CheckInCheckOutDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/CheckInCheckOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckInCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckInCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckInCheckOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param timeZoneOffset (optional) 
     * @param date (optional) 
     * @return OK
     */
    getCurrentStateCheckInCheckOut(userId: number | undefined, tenantId: number | undefined, timeZoneOffset: number | undefined, date: DateTime | undefined): Observable<UserCurrentStateCheckInCheckOutDto> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetCurrentStateCheckInCheckOut?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentStateCheckInCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentStateCheckInCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentStateCheckInCheckOutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentStateCheckInCheckOutDto>;
        }));
    }

    protected processGetCurrentStateCheckInCheckOut(response: HttpResponseBase): Observable<UserCurrentStateCheckInCheckOutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCurrentStateCheckInCheckOutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userInfo(): Observable<TimeAndAttendanceUserInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/UserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeAndAttendanceUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeAndAttendanceUserInfoDto>;
        }));
    }

    protected processUserInfo(response: HttpResponseBase): Observable<TimeAndAttendanceUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAndAttendanceUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTeamMember(): Observable<TeamMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetTeamMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamMemberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamMemberDto[]>;
        }));
    }

    protected processGetTeamMember(response: HttpResponseBase): Observable<TeamMemberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param awayTimeTypeId (optional) 
     * @param statusId (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getTimeOffInfo(filter: string | undefined, awayTimeTypeId: (number | undefined)[] | undefined, statusId: (number | undefined)[] | undefined, userId: (number | undefined)[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProjectTypeCountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetTimeOffInfo?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (awayTimeTypeId === null)
            throw new globalThis.Error("The parameter 'awayTimeTypeId' cannot be null.");
        else if (awayTimeTypeId !== undefined)
            awayTimeTypeId && awayTimeTypeId.forEach(item => { url_ += "AwayTimeTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            statusId && statusId.forEach(item => { url_ += "statusId=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeOffInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeOffInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTypeCountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTypeCountDto[]>;
        }));
    }

    protected processGetTimeOffInfo(response: HttpResponseBase): Observable<ProjectTypeCountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTypeCountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectType(): Observable<ProjectTypeCountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetProjectType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTypeCountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTypeCountDto[]>;
        }));
    }

    protected processGetProjectType(response: HttpResponseBase): Observable<ProjectTypeCountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTypeCountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isManager (optional) 
     * @return OK
     */
    getAllTeamCount(projectType: ProjectType2, isManager: boolean | undefined): Observable<TeamCountDto> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetAllTeamCount?";
        if (projectType === undefined || projectType === null)
            throw new globalThis.Error("The parameter 'projectType' must be defined and cannot be null.");
        else
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTeamCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTeamCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamCountDto>;
        }));
    }

    protected processGetAllTeamCount(response: HttpResponseBase): Observable<TeamCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isManager (optional) 
     * @return OK
     */
    getNewJoiner(isManager: boolean | undefined): Observable<DashboardUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetNewJoiner?";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewJoiner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewJoiner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardUserDto[]>;
        }));
    }

    protected processGetNewJoiner(response: HttpResponseBase): Observable<DashboardUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBirthDaysList(): Observable<DashboardUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetBirthDaysList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBirthDaysList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBirthDaysList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardUserDto[]>;
        }));
    }

    protected processGetBirthDaysList(response: HttpResponseBase): Observable<DashboardUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isManager (optional) 
     * @return OK
     */
    getBillableNonBillableProject(isManager: boolean | undefined): Observable<ProjectTypeCountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetBillableNonBillableProject?";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillableNonBillableProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillableNonBillableProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTypeCountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTypeCountDto[]>;
        }));
    }

    protected processGetBillableNonBillableProject(response: HttpResponseBase): Observable<ProjectTypeCountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTypeCountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isManager (optional) 
     * @return OK
     */
    getProjectDetails(isManager: boolean | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetProjectDetails?";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetProjectDetails(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isManager (optional) 
     * @return OK
     */
    getLeaveRequest(isManager: boolean | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetLeaveRequest?";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processGetLeaveRequest(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getTeamDetails(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<TeamDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetTeamDetails?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamDetailDto[]>;
        }));
    }

    protected processGetTeamDetails(response: HttpResponseBase): Observable<TeamDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUserProject(userId: number | undefined): Observable<ProjectUsers[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetUserProject?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUsers[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUsers[]>;
        }));
    }

    protected processGetUserProject(response: HttpResponseBase): Observable<ProjectUsers[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectUsers.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentProjects(): Observable<GetAllCurrentProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetAllCurrentProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllCurrentProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllCurrentProjectDto[]>;
        }));
    }

    protected processGetAllCurrentProjects(response: HttpResponseBase): Observable<GetAllCurrentProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllCurrentProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param chekingTime (optional) 
     * @return OK
     */
    userAutoChecking(userId: number | undefined, tenantId: number | undefined, chekingTime: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/UserAutoChecking?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (chekingTime === null)
            throw new globalThis.Error("The parameter 'chekingTime' cannot be null.");
        else if (chekingTime !== undefined)
            url_ += "chekingTime=" + encodeURIComponent(chekingTime ? "" + chekingTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAutoChecking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAutoChecking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserAutoChecking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    agentAppInstallNotificationAfterCheck(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/AgentAppInstallNotificationAfterCheck?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentAppInstallNotificationAfterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentAppInstallNotificationAfterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAgentAppInstallNotificationAfterCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param val (optional) 
     * @return OK
     */
    autoCheckingMidnight(val: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/AutoCheckingMidnight?";
        if (val === null)
            throw new globalThis.Error("The parameter 'val' cannot be null.");
        else if (val !== undefined)
            url_ += "val=" + encodeURIComponent("" + val) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoCheckingMidnight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoCheckingMidnight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAutoCheckingMidnight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @return OK
     */
    sendNotificationSetPrivateTimeUser(tenantID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/SendNotificationSetPrivateTimeUser?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotificationSetPrivateTimeUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotificationSetPrivateTimeUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendNotificationSetPrivateTimeUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getProgramManDashboardCardInfo(userId: number | undefined): Observable<TeamCountDto> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetProgramManDashboardCardInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramManDashboardCardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramManDashboardCardInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamCountDto>;
        }));
    }

    protected processGetProgramManDashboardCardInfo(response: HttpResponseBase): Observable<TeamCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param timesheetId (optional) 
     * @param includeMine (optional) 
     * @param sortByNewestOnTop (optional) 
     * @param timesheetStatus (optional) 
     * @param isSummary (optional) 
     * @param isExport (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTeamTimesheetDetailsDashbord(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, timesheetId: number | undefined, includeMine: boolean | undefined, sortByNewestOnTop: boolean | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, isSummary: boolean | undefined, isExport: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto> {
        let url_ = this.baseUrl + "/api/services/app/AllDashboard/GetTeamTimesheetDetailsDashbord?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (includeMine === null)
            throw new globalThis.Error("The parameter 'includeMine' cannot be null.");
        else if (includeMine !== undefined)
            url_ += "IncludeMine=" + encodeURIComponent("" + includeMine) + "&";
        if (sortByNewestOnTop === null)
            throw new globalThis.Error("The parameter 'sortByNewestOnTop' cannot be null.");
        else if (sortByNewestOnTop !== undefined)
            url_ += "sortByNewestOnTop=" + encodeURIComponent("" + sortByNewestOnTop) + "&";
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (isSummary === null)
            throw new globalThis.Error("The parameter 'isSummary' cannot be null.");
        else if (isSummary !== undefined)
            url_ += "IsSummary=" + encodeURIComponent("" + isSummary) + "&";
        if (isExport === null)
            throw new globalThis.Error("The parameter 'isExport' cannot be null.");
        else if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamTimesheetDetailsDashbord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamTimesheetDetailsDashbord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto>;
        }));
    }

    protected processGetTeamTimesheetDetailsDashbord(response: HttpResponseBase): Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOutPutGetApprovalGridDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppAndWebsiteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    allAppsAndWebsitesTenantWise(body: InputTotalUses | undefined): Observable<UserActivityTempCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AppAndWebsite/AllAppsAndWebsitesTenantWise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllAppsAndWebsitesTenantWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllAppsAndWebsitesTenantWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivityTempCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivityTempCreateOrEditDto[]>;
        }));
    }

    protected processAllAppsAndWebsitesTenantWise(response: HttpResponseBase): Observable<UserActivityTempCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivityTempCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AppAndWebsite/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param filterDate (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getTotalUsagesChart(filter: string | undefined, userId: number[] | undefined, projectId: number[] | undefined, orgUnitId: number[] | undefined, filterDate: DateTime | undefined, timeZoneOffset: number | undefined): Observable<AppAndWebSiteDto> {
        let url_ = this.baseUrl + "/api/services/app/AppAndWebsite/GetTotalUsagesChart?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' cannot be null.");
        else if (filterDate !== undefined)
            url_ += "FilterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalUsagesChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalUsagesChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppAndWebSiteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppAndWebSiteDto>;
        }));
    }

    protected processGetTotalUsagesChart(response: HttpResponseBase): Observable<AppAndWebSiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppAndWebSiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    usagePerEmployee(body: InputeUsagePerEmployee | undefined): Observable<UsagePerEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AppAndWebsite/UsagePerEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsagePerEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsagePerEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsagePerEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsagePerEmployeeDto[]>;
        }));
    }

    protected processUsagePerEmployee(response: HttpResponseBase): Observable<UsagePerEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsagePerEmployeeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationId (optional) 
     * @param filterDate (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUsagePerTeam(applicationId: number | undefined, filterDate: DateTime | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<UsagePerEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AppAndWebsite/GetUsagePerTeam?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "ApplicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' cannot be null.");
        else if (filterDate !== undefined)
            url_ += "FilterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toString() : "") + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsagePerTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsagePerTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsagePerEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsagePerEmployeeDto[]>;
        }));
    }

    protected processGetUsagePerTeam(response: HttpResponseBase): Observable<UsagePerEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsagePerEmployeeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditApplicationCategory(body: ApplicationCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/CreateOrEditApplicationCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditApplicationCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditApplicationCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditApplicationCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addAppsInOtherCategoryByDefaultFirstTime(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/AddAppsInOtherCategoryByDefaultFirstTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAppsInOtherCategoryByDefaultFirstTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAppsInOtherCategoryByDefaultFirstTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAppsInOtherCategoryByDefaultFirstTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param applicationCategoryId (optional) 
     * @param agentApplicationId (optional) 
     * @param filterFlag (optional) 
     * @return OK
     */
    getAllApplicationCategory(filter: string | undefined, applicationCategoryId: (number | undefined)[] | undefined, agentApplicationId: (number | undefined)[] | undefined, filterFlag: number | undefined): Observable<ApplicationCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetAllApplicationCategory?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            applicationCategoryId && applicationCategoryId.forEach(item => { url_ += "ApplicationCategoryId=" + encodeURIComponent("" + item) + "&"; });
        if (agentApplicationId === null)
            throw new globalThis.Error("The parameter 'agentApplicationId' cannot be null.");
        else if (agentApplicationId !== undefined)
            agentApplicationId && agentApplicationId.forEach(item => { url_ += "AgentApplicationId=" + encodeURIComponent("" + item) + "&"; });
        if (filterFlag === null)
            throw new globalThis.Error("The parameter 'filterFlag' cannot be null.");
        else if (filterFlag !== undefined)
            url_ += "FilterFlag=" + encodeURIComponent("" + filterFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCategoryDto[]>;
        }));
    }

    protected processGetAllApplicationCategory(response: HttpResponseBase): Observable<ApplicationCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCategory(): Observable<ApplicationCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetAllCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCategoryDto[]>;
        }));
    }

    protected processGetAllCategory(response: HttpResponseBase): Observable<ApplicationCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    editCategory(input: number | undefined): Observable<ApplicationCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/EditCategory?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCategoryDto>;
        }));
    }

    protected processEditCategory(response: HttpResponseBase): Observable<ApplicationCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    addAgentApplication(filter: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/AddAgentApplication?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgentApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgentApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAgentApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    productivityTypeDropDown(): Observable<ProductivityTypeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/ProductivityTypeDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductivityTypeDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductivityTypeDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityTypeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityTypeGetAllDto[]>;
        }));
    }

    protected processProductivityTypeDropDown(response: HttpResponseBase): Observable<ProductivityTypeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductivityTypeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    applicationTypeDropDown(): Observable<ApplicationTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/ApplicationTypeDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationTypeDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationTypeDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationTypeDto[]>;
        }));
    }

    protected processApplicationTypeDropDown(response: HttpResponseBase): Observable<ApplicationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getApplications(filter: string | undefined): Observable<AgentApplicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetApplications?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationDto[]>;
        }));
    }

    protected processGetApplications(response: HttpResponseBase): Observable<AgentApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignApplicationToUser(body: AssignApplicationToUserDto | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/AssignApplicationToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignApplicationToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignApplicationToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processAssignApplicationToUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userApplication (optional) 
     * @return OK
     */
    deleteExistingApplication(userApplication: UserApplication[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/DeleteExistingApplication?";
        if (userApplication === null)
            throw new globalThis.Error("The parameter 'userApplication' cannot be null.");
        else if (userApplication !== undefined)
            userApplication && userApplication.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "userApplication[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExistingApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExistingApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExistingApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getProductiveApplicationForDashboard(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetProductiveApplicationForDashboard?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductiveApplicationForDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductiveApplicationForDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetProductiveApplicationForDashboard(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationCategoryId (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getProductiveApplication(applicationCategoryId: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetProductiveApplication?";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductiveApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductiveApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetProductiveApplication(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationCategoryId (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @return OK
     */
    getProductiveApplicationPagination(applicationCategoryId: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, skipCount: number | undefined, takeCount: number | undefined): Observable<PagedResultDtoOfGetApplicationsDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetProductiveApplicationPagination?";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductiveApplicationPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductiveApplicationPagination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetApplicationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetApplicationsDto>;
        }));
    }

    protected processGetProductiveApplicationPagination(response: HttpResponseBase): Observable<PagedResultDtoOfGetApplicationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetApplicationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUnProductiveApplicationForDashboard(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetUnProductiveApplicationForDashboard?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnProductiveApplicationForDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnProductiveApplicationForDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetUnProductiveApplicationForDashboard(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationCategoryId (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUnProductiveApplication(applicationCategoryId: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetUnProductiveApplication?";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnProductiveApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnProductiveApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetUnProductiveApplication(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationCategoryId (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @return OK
     */
    getUnProductiveApplicationPagination(applicationCategoryId: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, skipCount: number | undefined, takeCount: number | undefined): Observable<PagedResultDtoOfGetApplicationsDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetUnProductiveApplicationPagination?";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnProductiveApplicationPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnProductiveApplicationPagination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetApplicationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetApplicationsDto>;
        }));
    }

    protected processGetUnProductiveApplicationPagination(response: HttpResponseBase): Observable<PagedResultDtoOfGetApplicationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetApplicationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isShowAll (optional) 
     * @param applicationCategoryId (optional) 
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @return OK
     */
    getNutralApplicationForDashboard(isShowAll: boolean | undefined, applicationCategoryId: number | undefined, timeZoneOffset: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetNutralApplicationForDashboard?";
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutralApplicationForDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutralApplicationForDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetNutralApplicationForDashboard(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isShowAll (optional) 
     * @param applicationCategoryId (optional) 
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @return OK
     */
    getNutralApplication(isShowAll: boolean | undefined, applicationCategoryId: number | undefined, timeZoneOffset: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined): Observable<GetApplicationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetNutralApplication?";
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutralApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutralApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationsDto[]>;
        }));
    }

    protected processGetNutralApplication(response: HttpResponseBase): Observable<GetApplicationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApplicationsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isShowAll (optional) 
     * @param applicationCategoryId (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @return OK
     */
    getNeutralApplicationPagination(isShowAll: boolean | undefined, applicationCategoryId: number | undefined, filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, skipCount: number | undefined, takeCount: number | undefined): Observable<PagedResultDtoOfGetApplicationsDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetNeutralApplicationPagination?";
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (applicationCategoryId === null)
            throw new globalThis.Error("The parameter 'applicationCategoryId' cannot be null.");
        else if (applicationCategoryId !== undefined)
            url_ += "ApplicationCategoryId=" + encodeURIComponent("" + applicationCategoryId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeutralApplicationPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeutralApplicationPagination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetApplicationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetApplicationsDto>;
        }));
    }

    protected processGetNeutralApplicationPagination(response: HttpResponseBase): Observable<PagedResultDtoOfGetApplicationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetApplicationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return OK
     */
    getCategoryWiseApplication(categoryId: number | undefined): Observable<CategoryWiseApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetCategoryWiseApplication?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryWiseApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryWiseApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryWiseApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryWiseApplicationDto>;
        }));
    }

    protected processGetCategoryWiseApplication(response: HttpResponseBase): Observable<CategoryWiseApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryWiseApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param applicationId (optional) 
     * @return OK
     */
    deleteApplication(applicationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/DeleteApplication?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return OK
     */
    deleteCategory(categoryId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/DeleteCategory?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectUnderUser(): Observable<ProjectTeamCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetProjectUnderUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectUnderUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectUnderUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTeamCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTeamCreateOrEditDto[]>;
        }));
    }

    protected processGetProjectUnderUser(response: HttpResponseBase): Observable<ProjectTeamCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTeamCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getProductiveUnproductiveNeutral(fromDate: DateTime | undefined, toDate: DateTime | undefined, userId: number | undefined, tenantId: number | undefined, filterType: TimeAndAttendanceEnum): Observable<ProductiveApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetProductiveUnproductiveNeutral?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterType === undefined || filterType === null)
            throw new globalThis.Error("The parameter 'filterType' must be defined and cannot be null.");
        else
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductiveUnproductiveNeutral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductiveUnproductiveNeutral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductiveApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductiveApplicationDto>;
        }));
    }

    protected processGetProductiveUnproductiveNeutral(response: HttpResponseBase): Observable<ProductiveApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductiveApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getAllApplicationCategorWeeKandmonth(fromDate: DateTime | undefined, toDate: DateTime | undefined, userId: number | undefined, tenantId: number | undefined, filterType: TimeAndAttendanceEnum): Observable<ApplicationCategoryWeekAndMonthDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetAllApplicationCategorWeeKandmonth?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterType === undefined || filterType === null)
            throw new globalThis.Error("The parameter 'filterType' must be defined and cannot be null.");
        else
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationCategorWeeKandmonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationCategorWeeKandmonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCategoryWeekAndMonthDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCategoryWeekAndMonthDto[]>;
        }));
    }

    protected processGetAllApplicationCategorWeeKandmonth(response: HttpResponseBase): Observable<ApplicationCategoryWeekAndMonthDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationCategoryWeekAndMonthDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationCategory/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AttendanceReportDistributionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<AttendanceReportDistributionGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceReportDistribution/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceReportDistributionGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceReportDistributionGroupDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AttendanceReportDistributionGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceReportDistributionGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<AttendanceReportDistributionGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceReportDistribution/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceReportDistributionGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceReportDistributionGroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AttendanceReportDistributionGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceReportDistributionGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateGroup(body: AttendanceReportDistributionGroupDto | undefined): Observable<AttendanceReportDistributionGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceReportDistribution/CreateOrUpdateGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceReportDistributionGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceReportDistributionGroupDto>;
        }));
    }

    protected processCreateOrUpdateGroup(response: HttpResponseBase): Observable<AttendanceReportDistributionGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceReportDistributionGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteGroup(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceReportDistribution/DeleteGroup?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new globalThis.Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new globalThis.Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new globalThis.Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new globalThis.Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new globalThis.Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new globalThis.Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new globalThis.Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new globalThis.Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new globalThis.Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new globalThis.Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new globalThis.Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new globalThis.Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new globalThis.Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return OK
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new globalThis.Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BlobHelperServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param tenancyName (optional) 
     * @param tenantName (optional) 
     * @return OK
     */
    getTenantBlobFolderPath(tenantId: number | undefined, tenancyName: string | undefined, tenantName: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetTenantBlobFolderPath?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (tenancyName === null)
            throw new globalThis.Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (tenantName === null)
            throw new globalThis.Error("The parameter 'tenantName' cannot be null.");
        else if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantBlobFolderPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantBlobFolderPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTenantBlobFolderPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUrlAfterImageBlobStorage(body: StoreImageOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetUrlAfterImageBlobStorage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlAfterImageBlobStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlAfterImageBlobStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlAfterImageBlobStorage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param imgBase64String (optional) 
     * @param subStorePath (optional) 
     * @param imgName (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param mgtToken (optional) 
     * @param id (optional) 
     * @return OK
     */
    getUrlAfterImageBlobStorageOffline(imgBase64String: string | undefined, subStorePath: string | undefined, imgName: string | undefined, requestSource: RequestSource, tenantId: number | undefined, userId: number | undefined, mgtToken: string | undefined, id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetUrlAfterImageBlobStorageOffline?";
        if (imgBase64String === null)
            throw new globalThis.Error("The parameter 'imgBase64String' cannot be null.");
        else if (imgBase64String !== undefined)
            url_ += "ImgBase64String=" + encodeURIComponent("" + imgBase64String) + "&";
        if (subStorePath === null)
            throw new globalThis.Error("The parameter 'subStorePath' cannot be null.");
        else if (subStorePath !== undefined)
            url_ += "SubStorePath=" + encodeURIComponent("" + subStorePath) + "&";
        if (imgName === null)
            throw new globalThis.Error("The parameter 'imgName' cannot be null.");
        else if (imgName !== undefined)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (requestSource === undefined || requestSource === null)
            throw new globalThis.Error("The parameter 'requestSource' must be defined and cannot be null.");
        else
            url_ += "RequestSource=" + encodeURIComponent("" + requestSource) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (mgtToken === null)
            throw new globalThis.Error("The parameter 'mgtToken' cannot be null.");
        else if (mgtToken !== undefined)
            url_ += "MgtToken=" + encodeURIComponent("" + mgtToken) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlAfterImageBlobStorageOffline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlAfterImageBlobStorageOffline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlAfterImageBlobStorageOffline(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param period (optional) 
     * @param tableName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getProductivityDataFROMAzureBLOB(fileName: string | undefined, period: string | undefined, tableName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetProductivityDataFROMAzureBLOB?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (period === null)
            throw new globalThis.Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (tableName === null)
            throw new globalThis.Error("The parameter 'tableName' cannot be null.");
        else if (tableName !== undefined)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityDataFROMAzureBLOB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityDataFROMAzureBLOB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProductivityDataFROMAzureBLOB(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param period (optional) 
     * @param tableName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getDataFROMAzureBLOB(fileName: string | undefined, period: string | undefined, tableName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetDataFROMAzureBLOB?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (period === null)
            throw new globalThis.Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (tableName === null)
            throw new globalThis.Error("The parameter 'tableName' cannot be null.");
        else if (tableName !== undefined)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataFROMAzureBLOB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataFROMAzureBLOB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDataFROMAzureBLOB(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param files (optional) 
     * @return OK
     */
    getUrlAfterBlobStorageUpload(files: FileParameter[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetUrlAfterBlobStorageUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlAfterBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlAfterBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlAfterBlobStorageUpload(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tennatId (optional) 
     * @param body (optional) 
     * @return OK
     */
    productivityBarBlobStorageUpload(tennatId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/ProductivityBarBlobStorageUpload?";
        if (tennatId === null)
            throw new globalThis.Error("The parameter 'tennatId' cannot be null.");
        else if (tennatId !== undefined)
            url_ += "tennatId=" + encodeURIComponent("" + tennatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductivityBarBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductivityBarBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProductivityBarBlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userActivityTempBlobStorageUpload(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UserActivityTempBlobStorageUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActivityTempBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActivityTempBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActivityTempBlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    invalidUserNameFileUpload(tenantId: number | undefined, body: UserInvalidUplodDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/InvalidUserNameFileUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvalidUserNameFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvalidUserNameFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInvalidUserNameFileUpload(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    screenShotBlobStorageUpload(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/ScreenShotBlobStorageUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScreenShotBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScreenShotBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScreenShotBlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    windowsTrackingDataBlobStorageUpload(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/WindowsTrackingDataBlobStorageUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWindowsTrackingDataBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWindowsTrackingDataBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWindowsTrackingDataBlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getJsonFromBlob(fileName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetJsonFromBlob?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJsonFromBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJsonFromBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetJsonFromBlob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userStatusBlobStorageUpload(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UserStatusBlobStorageUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserStatusBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserStatusBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserStatusBlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userActivityWindowlobStorageUpload(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UserActivityWindowlobStorageUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActivityWindowlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActivityWindowlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActivityWindowlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnvironmentName(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetEnvironmentName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironmentName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironmentName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEnvironmentName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnvironmentNameForHangfire(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetEnvironmentNameForHangfire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironmentNameForHangfire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironmentNameForHangfire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEnvironmentNameForHangfire(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDataBaseName(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetDataBaseName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataBaseName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataBaseName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDataBaseName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    isExist(fileName: string | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/IsExist?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileNmae (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    deleteUploadFile(fileNmae: string | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/DeleteUploadFile?";
        if (fileNmae === null)
            throw new globalThis.Error("The parameter 'fileNmae' cannot be null.");
        else if (fileNmae !== undefined)
            url_ += "fileNmae=" + encodeURIComponent("" + fileNmae) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    uplodeReporttoBlob(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UplodeReporttoBlob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeReporttoBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeReporttoBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUplodeReporttoBlob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    uploadReportExcelToBlob(fileName: string | undefined, tenantId: number | undefined, body: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UploadReportExcelToBlob?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReportExcelToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReportExcelToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadReportExcelToBlob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getReportBlobFile(fileName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetReportBlobFile?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportBlobFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportBlobFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetReportBlobFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getReportBlobFileBytes(fileName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetReportBlobFileBytes?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportBlobFileBytes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportBlobFileBytes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetReportBlobFileBytes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getReportBlobFileUrl(fileName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetReportBlobFileUrl?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportBlobFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportBlobFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetReportBlobFileUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param storedFileName (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    uploadReportFileToReportsFolder(storedFileName: string | undefined, tenantId: number | undefined, body: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UploadReportFileToReportsFolder?";
        if (storedFileName === null)
            throw new globalThis.Error("The parameter 'storedFileName' cannot be null.");
        else if (storedFileName !== undefined)
            url_ += "storedFileName=" + encodeURIComponent("" + storedFileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReportFileToReportsFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReportFileToReportsFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadReportFileToReportsFolder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    uplodeProductivityBarJsonFile(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UplodeProductivityBarJsonFile?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeProductivityBarJsonFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeProductivityBarJsonFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUplodeProductivityBarJsonFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getProductivityBarJson(fileName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetProductivityBarJson?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityBarJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityBarJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProductivityBarJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userCalculationBlobStorageUpload(tenantId: number | undefined, body: UploadTimeAndAttendanceDataOnBlobDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UserCalculationBlobStorageUpload?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCalculationBlobStorageUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCalculationBlobStorageUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserCalculationBlobStorageUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    uplodeApplicationJsonFile(tenantId: number | undefined, body: ProductivityJsonUploadDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/UplodeApplicationJsonFile?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeApplicationJsonFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeApplicationJsonFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUplodeApplicationJsonFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApplicationJson(fileName: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetApplicationJson?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetApplicationJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUrlAfterProfileImageBlobStorage(body: StoreImageOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetUrlAfterProfileImageBlobStorage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlAfterProfileImageBlobStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlAfterProfileImageBlobStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlAfterProfileImageBlobStorage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUrlAfterProjectDocumentBlobStorage(body: StoreProjectDocumentOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/GetUrlAfterProjectDocumentBlobStorage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlAfterProjectDocumentBlobStorage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlAfterProjectDocumentBlobStorage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlAfterProjectDocumentBlobStorage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filePath (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    deleteProjectDocumentBlob(filePath: string | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BlobHelper/DeleteProjectDocumentBlob?";
        if (filePath === null)
            throw new globalThis.Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectDocumentBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectDocumentBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectDocumentBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CalendarConfigurationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUserCalendarConfigSettings(body: CalendarConfigurationSettingsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CalendarConfigurationSettings/CreateOrUpdateUserCalendarConfigSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserCalendarConfigSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserCalendarConfigSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateUserCalendarConfigSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCalendarConfigSettings(): Observable<CalendarConfigurationSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarConfigurationSettings/GetAllCalendarConfigSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalendarConfigSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalendarConfigSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarConfigurationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarConfigurationSettingsDto>;
        }));
    }

    protected processGetAllCalendarConfigSettings(response: HttpResponseBase): Observable<CalendarConfigurationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarConfigurationSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return OK
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId === null)
            throw new globalThis.Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: ClientCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteContact(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/DeleteContact?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllClients(clientType: ClientType2): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllClients?";
        if (clientType === undefined || clientType === null)
            throw new globalThis.Error("The parameter 'clientType' must be defined and cannot be null.");
        else
            url_ += "clientType=" + encodeURIComponent("" + clientType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetAllClients(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    getClientById(clientId: number | undefined): Observable<ClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientById?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processGetClientById(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientname (optional) 
     * @return OK
     */
    getClientByName(clientname: string | undefined, clientType: ClientType3): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientByName?";
        if (clientname === null)
            throw new globalThis.Error("The parameter 'clientname' cannot be null.");
        else if (clientname !== undefined)
            url_ += "clientname=" + encodeURIComponent("" + clientname) + "&";
        if (clientType === undefined || clientType === null)
            throw new globalThis.Error("The parameter 'clientType' must be defined and cannot be null.");
        else
            url_ += "clientType=" + encodeURIComponent("" + clientType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetClientByName(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getClientByDeleteStatus(deleteStatus: number | undefined): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientByDeleteStatus?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByDeleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByDeleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetClientByDeleteStatus(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    recendaryUpdateClient(): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/RecendaryUpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecendaryUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecendaryUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processRecendaryUpdateClient(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrencyListForDropdown(): Observable<ClientCurrencyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllCurrencyListForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyListForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyListForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientCurrencyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientCurrencyDto[]>;
        }));
    }

    protected processGetAllCurrencyListForDropdown(response: HttpResponseBase): Observable<ClientCurrencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientCurrencyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param clientId (optional) 
     * @param isEdit (optional) 
     * @return OK
     */
    checkDuplicateClient(name: string | undefined, clientId: number | undefined, isEdit: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Client/CheckDuplicateClient?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (isEdit === null)
            throw new globalThis.Error("The parameter 'isEdit' cannot be null.");
        else if (isEdit !== undefined)
            url_ += "isEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicateClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllApplicationLanguageForDropdown(): Observable<ClientApplicationLanguageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllApplicationLanguageForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationLanguageForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationLanguageForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientApplicationLanguageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientApplicationLanguageDto[]>;
        }));
    }

    protected processGetAllApplicationLanguageForDropdown(response: HttpResponseBase): Observable<ClientApplicationLanguageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientApplicationLanguageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @param name (optional) 
     * @return OK
     */
    getAllClientWithNameOrDeleteFilter(deleteStatus: number | undefined, name: string | undefined): Observable<ClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllClientWithNameOrDeleteFilter?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientWithNameOrDeleteFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientWithNameOrDeleteFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto[]>;
        }));
    }

    protected processGetAllClientWithNameOrDeleteFilter(response: HttpResponseBase): Observable<ClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    unDeleteClient(clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UnDeleteClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    updateStatusClientArchive(clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UpdateStatusClientArchive?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusClientArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusClientArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusClientArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    archiveClientByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/ArchiveClientByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveClientByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveClientByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveClientByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    updateStatusClientUnArchive(clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UpdateStatusClientUnArchive?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusClientUnArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusClientUnArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusClientUnArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unArchiveClinetByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UnArchiveClinetByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnArchiveClinetByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnArchiveClinetByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnArchiveClinetByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    updateStatusClientUnDelete(clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UpdateStatusClientUnDelete?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusClientUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusClientUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusClientUnDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    deleteClientByList(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/DeleteClientByList?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClientByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClientByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClientByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    permanantDeleteClientByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/PermanantDeleteClientByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermanantDeleteClientByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermanantDeleteClientByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPermanantDeleteClientByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unDeleteClientByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UnDeleteClientByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteClientByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteClientByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteClientByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    updateStatusProjectDelete(clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/UpdateStatusProjectDelete?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusProjectDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusProjectDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusProjectDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLanguage(): Observable<IdNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameDto[]>;
        }));
    }

    protected processGetAllLanguage(response: HttpResponseBase): Observable<IdNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdNameDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    sendOtpToClientLogin(emailAddress: string | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/SendOtpToClientLogin?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOtpToClientLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOtpToClientLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOtpToClientLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param otp (optional) 
     * @return OK
     */
    verifyOtp(emailAddress: string | undefined, otp: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Client/VerifyOtp?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (otp === null)
            throw new globalThis.Error("The parameter 'otp' cannot be null.");
        else if (otp !== undefined)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyOtp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getClientIdByUserId(userId: number | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetClientIdByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientIdByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientIdByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processGetClientIdByUserId(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    allowUserToRestoreForClient(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Client/AllowUserToRestoreForClient?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowUserToRestoreForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowUserToRestoreForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAllowUserToRestoreForClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    restoreClientContact(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/RestoreClientContact?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreClientContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreClientContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreClientContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonCacheServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllUsersFromRedisCache(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetAllUsersFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetAllUsersFromRedisCache(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTenantWiseOrgnizationDetails(): Observable<UserWiseOrgnizationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetTenantWiseOrgnizationDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantWiseOrgnizationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantWiseOrgnizationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWiseOrgnizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWiseOrgnizationDto[]>;
        }));
    }

    protected processGetTenantWiseOrgnizationDetails(response: HttpResponseBase): Observable<UserWiseOrgnizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWiseOrgnizationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllProjectDetailsFromRedisCache(): Observable<ProjectGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetAllProjectDetailsFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectDetailsFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectDetailsFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto[]>;
        }));
    }

    protected processGetAllProjectDetailsFromRedisCache(response: HttpResponseBase): Observable<ProjectGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTenantWiseProjectTeamDetailsFromRedisCache(): Observable<ProjectTeamCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetAllTenantWiseProjectTeamDetailsFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTenantWiseProjectTeamDetailsFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTenantWiseProjectTeamDetailsFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTeamCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTeamCreateOrEditDto[]>;
        }));
    }

    protected processGetAllTenantWiseProjectTeamDetailsFromRedisCache(response: HttpResponseBase): Observable<ProjectTeamCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTeamCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllLocationSettingFromRedis(): Observable<LocationSettingCreateOrEdit[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetAllLocationSettingFromRedis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationSettingFromRedis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationSettingFromRedis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSettingCreateOrEdit[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSettingCreateOrEdit[]>;
        }));
    }

    protected processGetAllLocationSettingFromRedis(response: HttpResponseBase): Observable<LocationSettingCreateOrEdit[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationSettingCreateOrEdit.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectProjectManagerDetails(): Observable<ProjectProjectManagerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetProjectProjectManagerDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectProjectManagerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectProjectManagerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectProjectManagerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectProjectManagerDto[]>;
        }));
    }

    protected processGetProjectProjectManagerDetails(response: HttpResponseBase): Observable<ProjectProjectManagerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectProjectManagerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDeletedArchiveAndActiveUserDetailsUsersFromRedisCache(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetAllDeletedArchiveAndActiveUserDetailsUsersFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeletedArchiveAndActiveUserDetailsUsersFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeletedArchiveAndActiveUserDetailsUsersFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetAllDeletedArchiveAndActiveUserDetailsUsersFromRedisCache(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    clearAllCaches(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/ClearAllCaches?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserRealTimeLocationFromRedisCache(): Observable<UserRealTimeLocationCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetUserRealTimeLocationFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRealTimeLocationFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRealTimeLocationFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRealTimeLocationCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRealTimeLocationCreateOrEditDto[]>;
        }));
    }

    protected processGetUserRealTimeLocationFromRedisCache(response: HttpResponseBase): Observable<UserRealTimeLocationCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRealTimeLocationCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addRedisCacheInUserProjectTask(): Observable<UserProjectTaskLiveStreamingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/AddRedisCacheInUserProjectTask";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRedisCacheInUserProjectTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRedisCacheInUserProjectTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskLiveStreamingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskLiveStreamingDto[]>;
        }));
    }

    protected processAddRedisCacheInUserProjectTask(response: HttpResponseBase): Observable<UserProjectTaskLiveStreamingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskLiveStreamingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompanyProfileDetailsFromRedisCache(): Observable<CompanyProfileDetailCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetCompanyProfileDetailsFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProfileDetailsFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProfileDetailsFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
        }));
    }

    protected processGetCompanyProfileDetailsFromRedisCache(response: HttpResponseBase): Observable<CompanyProfileDetailCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProfileDetailCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getOrganizationUnitDetailsFromRedisCache(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetOrganizationUnitDetailsFromRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitDetailsFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitDetailsFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetOrganizationUnitDetailsFromRedisCache(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getUserWorkDaySettingForEdit(tenantId: number | undefined, userId: number | undefined): Observable<UserWorkDaySettingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetUserWorkDaySettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWorkDaySettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWorkDaySettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWorkDaySettingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWorkDaySettingCreateOrEditDto>;
        }));
    }

    protected processGetUserWorkDaySettingForEdit(response: HttpResponseBase): Observable<UserWorkDaySettingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWorkDaySettingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    filterByMemberData(): Observable<FilerMeberDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/FilterByMemberData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterByMemberData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterByMemberData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilerMeberDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilerMeberDataDto[]>;
        }));
    }

    protected processFilterByMemberData(response: HttpResponseBase): Observable<FilerMeberDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilerMeberDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getUserTrackOtherSettingForEdit(tenantId: number | undefined, userId: number | undefined): Observable<UserTrackOtherSettingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetUserTrackOtherSettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTrackOtherSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTrackOtherSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrackOtherSettingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrackOtherSettingCreateOrEditDto>;
        }));
    }

    protected processGetUserTrackOtherSettingForEdit(response: HttpResponseBase): Observable<UserTrackOtherSettingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrackOtherSettingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getDownloadAgentAppPopupDetailFromRedisCache(tenantId: number | undefined, userId: number | undefined): Observable<DownloadAgentAppPopupDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetDownloadAgentAppPopupDetailFromRedisCache?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadAgentAppPopupDetailFromRedisCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadAgentAppPopupDetailFromRedisCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadAgentAppPopupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadAgentAppPopupDto>;
        }));
    }

    protected processGetDownloadAgentAppPopupDetailFromRedisCache(response: HttpResponseBase): Observable<DownloadAgentAppPopupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadAgentAppPopupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getPublicHolidayLocationFromCache(tenantId: number | undefined): Observable<PublicHolidayLocationCacheDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetPublicHolidayLocationFromCache?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicHolidayLocationFromCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicHolidayLocationFromCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicHolidayLocationCacheDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicHolidayLocationCacheDto[]>;
        }));
    }

    protected processGetPublicHolidayLocationFromCache(response: HttpResponseBase): Observable<PublicHolidayLocationCacheDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayLocationCacheDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getPublicHolidayFromCache(tenantId: number | undefined): Observable<PublicHolidayCacheDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetPublicHolidayFromCache?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicHolidayFromCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicHolidayFromCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicHolidayCacheDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicHolidayCacheDto[]>;
        }));
    }

    protected processGetPublicHolidayFromCache(response: HttpResponseBase): Observable<PublicHolidayCacheDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayCacheDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getConnectionIdsComman(userId: number | undefined, tenantId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetConnectionIdsComman?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionIdsComman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionIdsComman(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetConnectionIdsComman(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getContainerName(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetContainerName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetContainerName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    eachCalendarDayList(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<DateTime[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/EachCalendarDayList?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEachCalendarDayList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEachCalendarDayList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime[]>;
        }));
    }

    protected processEachCalendarDayList(response: HttpResponseBase): Observable<DateTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DateTime.fromISO(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentDate (optional) 
     * @return OK
     */
    getallWeekRange(currentDate: DateTime | undefined): Observable<ValueTupleOfDateTimeDateTime[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetallWeekRange?";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetallWeekRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetallWeekRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfDateTimeDateTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfDateTimeDateTime[]>;
        }));
    }

    protected processGetallWeekRange(response: HttpResponseBase): Observable<ValueTupleOfDateTimeDateTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValueTupleOfDateTimeDateTime.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param weekRanges (optional) 
     * @param currentDate (optional) 
     * @return OK
     */
    getCurrentWeekDates(weekRanges: ValueTupleOfDateTimeDateTime[] | undefined, currentDate: DateTime | undefined): Observable<ValueTupleOfDateTimeDateTime> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetCurrentWeekDates?";
        if (weekRanges === null)
            throw new globalThis.Error("The parameter 'weekRanges' cannot be null.");
        else if (weekRanges !== undefined)
            weekRanges && weekRanges.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "weekRanges[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentWeekDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentWeekDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfDateTimeDateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfDateTimeDateTime>;
        }));
    }

    protected processGetCurrentWeekDates(response: HttpResponseBase): Observable<ValueTupleOfDateTimeDateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfDateTimeDateTime.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param utcDateTime (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getMidnightInIST(utcDateTime: DateTime | undefined, tenantId: number | undefined): Observable<DateTime> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetMidnightInIST?";
        if (utcDateTime === null)
            throw new globalThis.Error("The parameter 'utcDateTime' cannot be null.");
        else if (utcDateTime !== undefined)
            url_ += "utcDateTime=" + encodeURIComponent(utcDateTime ? "" + utcDateTime.toString() : "") + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMidnightInIST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMidnightInIST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime>;
        }));
    }

    protected processGetMidnightInIST(response: HttpResponseBase): Observable<DateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    resolveUserTimeZone(userId: number | undefined, tenantId: number | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/ResolveUserTimeZone?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveUserTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveUserTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processResolveUserTimeZone(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    resolveCompanyTimeZone(tenantId: number | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/ResolveCompanyTimeZone?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveCompanyTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveCompanyTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processResolveCompanyTimeZone(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calendarDate (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUserDayWindow(userId: number | undefined, tenantId: number | undefined, calendarDate: DateTime | undefined, timeZoneOffset: number | undefined): Observable<ValueTupleOfDateTimeDateTimeTimeZoneInfo> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/GetUserDayWindow?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calendarDate === null)
            throw new globalThis.Error("The parameter 'calendarDate' cannot be null.");
        else if (calendarDate !== undefined)
            url_ += "calendarDate=" + encodeURIComponent(calendarDate ? "" + calendarDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDayWindow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDayWindow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfDateTimeDateTimeTimeZoneInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfDateTimeDateTimeTimeZoneInfo>;
        }));
    }

    protected processGetUserDayWindow(response: HttpResponseBase): Observable<ValueTupleOfDateTimeDateTimeTimeZoneInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfDateTimeDateTimeTimeZoneInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedStartDate (optional) 
     * @param selectedEndDate (optional) 
     * @return OK
     */
    currentWeekCheck(selectedStartDate: DateTime | undefined, selectedEndDate: DateTime | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/CurrentWeekCheck?";
        if (selectedStartDate === null)
            throw new globalThis.Error("The parameter 'selectedStartDate' cannot be null.");
        else if (selectedStartDate !== undefined)
            url_ += "selectedStartDate=" + encodeURIComponent(selectedStartDate ? "" + selectedStartDate.toString() : "") + "&";
        if (selectedEndDate === null)
            throw new globalThis.Error("The parameter 'selectedEndDate' cannot be null.");
        else if (selectedEndDate !== undefined)
            url_ += "selectedEndDate=" + encodeURIComponent(selectedEndDate ? "" + selectedEndDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentWeekCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentWeekCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCurrentWeekCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterStartDate (optional) 
     * @param filterEndDate (optional) 
     * @return OK
     */
    currentMonth(filterStartDate: DateTime | undefined, filterEndDate: DateTime | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/CurrentMonth?";
        if (filterStartDate === null)
            throw new globalThis.Error("The parameter 'filterStartDate' cannot be null.");
        else if (filterStartDate !== undefined)
            url_ += "FilterStartDate=" + encodeURIComponent(filterStartDate ? "" + filterStartDate.toString() : "") + "&";
        if (filterEndDate === null)
            throw new globalThis.Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "FilterEndDate=" + encodeURIComponent(filterEndDate ? "" + filterEndDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCurrentMonth(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    isLastDayOfMonth(date: DateTime | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/IsLastDayOfMonth?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsLastDayOfMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsLastDayOfMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsLastDayOfMonth(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insertUpdatedUserActivity(body: UpdateUserDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommonCache/InsertUpdatedUserActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertUpdatedUserActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertUpdatedUserActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertUpdatedUserActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return OK
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new globalThis.Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCurrentRole(id: number | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetCurrentRole?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto>;
        }));
    }

    protected processGetCurrentRole(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param filter (optional) 
     * @param sortId (optional) 
     * @param locations (optional) 
     * @return OK
     */
    getAllLocationSetting(tenantId: number | undefined, filter: string | undefined, sortId: number | undefined, locations: number[] | undefined): Observable<LocationSettingInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllLocationSetting?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (sortId === null)
            throw new globalThis.Error("The parameter 'sortId' cannot be null.");
        else if (sortId !== undefined)
            url_ += "sortId=" + encodeURIComponent("" + sortId) + "&";
        if (locations === null)
            throw new globalThis.Error("The parameter 'locations' cannot be null.");
        else if (locations !== undefined)
            locations && locations.forEach(item => { url_ += "locations=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSettingInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSettingInfoDto[]>;
        }));
    }

    protected processGetAllLocationSetting(response: HttpResponseBase): Observable<LocationSettingInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationSettingInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLocationSetting(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/DeleteLocationSetting?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLocationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLocationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLocationSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getLocationSettingForEdit(tenantId: number | undefined, id: number | undefined): Observable<LocationSettingCreateOrEdit> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetLocationSettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSettingCreateOrEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSettingCreateOrEdit>;
        }));
    }

    protected processGetLocationSettingForEdit(response: HttpResponseBase): Observable<LocationSettingCreateOrEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationSettingCreateOrEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getDefaultLocationForEdit(tenantId: number | undefined): Observable<LocationSettingCreateOrEdit> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetDefaultLocationForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSettingCreateOrEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSettingCreateOrEdit>;
        }));
    }

    protected processGetDefaultLocationForEdit(response: HttpResponseBase): Observable<LocationSettingCreateOrEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationSettingCreateOrEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditLocationSetting(body: LocationSettingCreateOrEdit | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateOrEditLocationSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLocationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLocationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLocationSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param sortId (optional) 
     * @param holidayName (optional) 
     * @param locations (optional) 
     * @return OK
     */
    getAllPublicHolidays(tenantId: number | undefined, sortId: number | undefined, holidayName: string[] | undefined, locations: string[] | undefined): Observable<PublicHolidayCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllPublicHolidays?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sortId === null)
            throw new globalThis.Error("The parameter 'sortId' cannot be null.");
        else if (sortId !== undefined)
            url_ += "sortId=" + encodeURIComponent("" + sortId) + "&";
        if (holidayName === null)
            throw new globalThis.Error("The parameter 'holidayName' cannot be null.");
        else if (holidayName !== undefined)
            holidayName && holidayName.forEach(item => { url_ += "holidayName=" + encodeURIComponent("" + item) + "&"; });
        if (locations === null)
            throw new globalThis.Error("The parameter 'locations' cannot be null.");
        else if (locations !== undefined)
            locations && locations.forEach(item => { url_ += "locations=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPublicHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublicHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicHolidayCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicHolidayCreateOrEditDto[]>;
        }));
    }

    protected processGetAllPublicHolidays(response: HttpResponseBase): Observable<PublicHolidayCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createHoliday(body: HolidayDtoExcel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateHoliday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getPublicHolidayForEditView(tenantId: number | undefined, id: number | undefined): Observable<PublicHolidayCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetPublicHolidayForEditView?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicHolidayForEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicHolidayForEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicHolidayCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicHolidayCreateOrEditDto>;
        }));
    }

    protected processGetPublicHolidayForEditView(response: HttpResponseBase): Observable<PublicHolidayCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicHolidayCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditPublicHoliday(body: PublicHolidayCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateOrEditPublicHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditPublicHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPublicHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditPublicHoliday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deletePublicHoliday(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/DeletePublicHoliday?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePublicHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePublicHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePublicHoliday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditCaptureSetting(body: CreateOrEditCaptureSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateOrEditCaptureSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCaptureSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCaptureSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditCaptureSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getCaptureSettingForEditView(tenantId: number | undefined): Observable<CreateOrEditCaptureSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCaptureSettingForEditView?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaptureSettingForEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaptureSettingForEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditCaptureSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditCaptureSettingDto>;
        }));
    }

    protected processGetCaptureSettingForEditView(response: HttpResponseBase): Observable<CreateOrEditCaptureSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditCaptureSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditCompanyProfileDetail(body: CompanyProfileDetailCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateOrEditCompanyProfileDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCompanyProfileDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCompanyProfileDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditCompanyProfileDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getCompanyProfileByTenantId(tenantId: number | undefined): Observable<CompanyProfileDetailCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyProfileByTenantId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProfileByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProfileByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
        }));
    }

    protected processGetCompanyProfileByTenantId(response: HttpResponseBase): Observable<CompanyProfileDetailCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProfileDetailCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getCompanyProfileDetailsForEditView(tenantId: number | undefined): Observable<CompanyProfileDetailCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyProfileDetailsForEditView?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProfileDetailsForEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProfileDetailsForEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
        }));
    }

    protected processGetCompanyProfileDetailsForEditView(response: HttpResponseBase): Observable<CompanyProfileDetailCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProfileDetailCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: CompanyProfileCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCompanyProfileForEditView(id: number | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyProfileForEditView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProfileForEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProfileForEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processGetCompanyProfileForEditView(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCompanyProfile(): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllCompanyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processGetAllCompanyProfile(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompanyDetailsDateFormat(): Observable<CompanyProfileDetailCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyDetailsDateFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetailsDateFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetailsDateFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDetailCreateOrEditDto>;
        }));
    }

    protected processGetCompanyDetailsDateFormat(response: HttpResponseBase): Observable<CompanyProfileDetailCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProfileDetailCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getCompanyDetailsDateFormatForMobile(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyDetailsDateFormatForMobile?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetailsDateFormatForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetailsDateFormatForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCompanyDetailsDateFormatForMobile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getCompanyProfileByDeleteStatus(deleteStatus: number | undefined): Observable<CompanyProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyProfileByDeleteStatus?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyProfileByDeleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProfileByDeleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto[]>;
        }));
    }

    protected processGetCompanyProfileByDeleteStatus(response: HttpResponseBase): Observable<CompanyProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyProfileDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCountryForTableDropdown(): Observable<CompanyProfileCountryLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllCountryForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountryForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountryForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileCountryLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileCountryLookupTableDto[]>;
        }));
    }

    protected processGetAllCountryForTableDropdown(response: HttpResponseBase): Observable<CompanyProfileCountryLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyProfileCountryLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrencyForTableDropdown(): Observable<CompanyProfileCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileCurrencyLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileCurrencyLookupTableDto[]>;
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<CompanyProfileCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyProfileCurrencyLookupTableDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getOnBoardingOrgNameOnTenantId(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetOnBoardingOrgNameOnTenantId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnBoardingOrgNameOnTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnBoardingOrgNameOnTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOnBoardingOrgNameOnTenantId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditTrackWorkingDetail(body: TrackWorkingDetailCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/CreateOrEditTrackWorkingDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditTrackWorkingDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditTrackWorkingDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditTrackWorkingDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locId (optional) 
     * @return OK
     */
    getTrackWorkingDetailForEditView(locId: number | undefined): Observable<TrackWorkingDetailCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetTrackWorkingDetailForEditView?";
        if (locId === null)
            throw new globalThis.Error("The parameter 'locId' cannot be null.");
        else if (locId !== undefined)
            url_ += "locId=" + encodeURIComponent("" + locId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrackWorkingDetailForEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrackWorkingDetailForEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrackWorkingDetailCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrackWorkingDetailCreateOrEditDto>;
        }));
    }

    protected processGetTrackWorkingDetailForEditView(response: HttpResponseBase): Observable<TrackWorkingDetailCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrackWorkingDetailCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    agentGetCompanyWiseTrackWorkingDaySetting(tenantId: number | undefined, userId: number | undefined): Observable<TrackWorkingDetailCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/AgentGetCompanyWiseTrackWorkingDaySetting?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentGetCompanyWiseTrackWorkingDaySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentGetCompanyWiseTrackWorkingDaySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrackWorkingDetailCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrackWorkingDetailCreateOrEditDto>;
        }));
    }

    protected processAgentGetCompanyWiseTrackWorkingDaySetting(response: HttpResponseBase): Observable<TrackWorkingDetailCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrackWorkingDetailCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAllCompanySettingDailyMailTimes(tenantId: number | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllCompanySettingDailyMailTimes?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanySettingDailyMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanySettingDailyMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processGetAllCompanySettingDailyMailTimes(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sentDailyMailForCompanyUser(body: User[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/SentDailyMailForCompanyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentDailyMailForCompanyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentDailyMailForCompanyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSentDailyMailForCompanyUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAllCompanySettingWeeklyMailTimes(tenantId: number | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllCompanySettingWeeklyMailTimes?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanySettingWeeklyMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanySettingWeeklyMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processGetAllCompanySettingWeeklyMailTimes(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAllCompanySettingMonthlyMailTimes(tenantId: number | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAllCompanySettingMonthlyMailTimes?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanySettingMonthlyMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanySettingMonthlyMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processGetAllCompanySettingMonthlyMailTimes(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    runCompanySettingWiseCheckInMailTimes(): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/RunCompanySettingWiseCheckInMailTimes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunCompanySettingWiseCheckInMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunCompanySettingWiseCheckInMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processRunCompanySettingWiseCheckInMailTimes(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendDailyEmails(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/SendDailyEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDailyEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDailyEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDailyEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    runCompanySettingWiseCheckOutMailTimes(): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/RunCompanySettingWiseCheckOutMailTimes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunCompanySettingWiseCheckOutMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunCompanySettingWiseCheckOutMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processRunCompanySettingWiseCheckOutMailTimes(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserForProfileImage(): Observable<LocationEmailReceiverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetUserForProfileImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForProfileImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForProfileImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationEmailReceiverDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationEmailReceiverDto[]>;
        }));
    }

    protected processGetUserForProfileImage(response: HttpResponseBase): Observable<LocationEmailReceiverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationEmailReceiverDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param address (optional) 
     * @return OK
     */
    getLatAndLongOnBasisofAddress(address: string | undefined): Observable<CoordinatesDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetLatAndLongOnBasisofAddress?";
        if (address === null)
            throw new globalThis.Error("The parameter 'address' cannot be null.");
        else if (address !== undefined)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatAndLongOnBasisofAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatAndLongOnBasisofAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoordinatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoordinatesDto>;
        }));
    }

    protected processGetLatAndLongOnBasisofAddress(response: HttpResponseBase): Observable<CoordinatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoordinatesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    adminUserTrakDataSeed(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/AdminUserTrakDataSeed?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminUserTrakDataSeed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminUserTrakDataSeed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdminUserTrakDataSeed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountryStateCityAppserviceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    insetBulkAllData(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountryStateCityAppservice/InsetBulkAllData?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsetBulkAllData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsetBulkAllData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsetBulkAllData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCountry(): Observable<CountryMasterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CountryStateCityAppservice/GetAllCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryMasterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryMasterDto[]>;
        }));
    }

    protected processGetAllCountry(response: HttpResponseBase): Observable<CountryMasterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryMasterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param countryId (optional) 
     * @return OK
     */
    getStateByCountryId(countryId: number | undefined): Observable<StateMasterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CountryStateCityAppservice/GetStateByCountryId?";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateByCountryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateByCountryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateMasterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateMasterDto[]>;
        }));
    }

    protected processGetStateByCountryId(response: HttpResponseBase): Observable<StateMasterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateMasterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stateId (optional) 
     * @return OK
     */
    getCityByCountryId(stateId: number | undefined): Observable<CityMasterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CountryStateCityAppservice/GetCityByCountryId?";
        if (stateId === null)
            throw new globalThis.Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityByCountryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityByCountryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityMasterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityMasterDto[]>;
        }));
    }

    protected processGetCityByCountryId(response: HttpResponseBase): Observable<CityMasterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityMasterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    getUserDashboard(dashboardName: string | undefined, application: string | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName === null)
            throw new globalThis.Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new globalThis.Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Dashboard>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Dashboard>;
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    savePage(body: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renamePage(body: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddNewPageOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddNewPageOutput>;
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    deletePage(id: string | undefined, dashboardName: string | undefined, application: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dashboardName === null)
            throw new globalThis.Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new globalThis.Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Widget>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Widget>;
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    getDashboardDefinition(dashboardName: string | undefined, application: string | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName === null)
            throw new globalThis.Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new globalThis.Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOutput>;
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    getAllWidgetDefinitions(dashboardName: string | undefined, application: string | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName === null)
            throw new globalThis.Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new globalThis.Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @param pageId (optional) 
     * @return OK
     */
    getAllAvailableWidgetDefinitionsForPage(dashboardName: string | undefined, application: string | undefined, pageId: string | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllAvailableWidgetDefinitionsForPage?";
        if (dashboardName === null)
            throw new globalThis.Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new globalThis.Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        if (pageId === null)
            throw new globalThis.Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "PageId=" + encodeURIComponent("" + pageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableWidgetDefinitionsForPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableWidgetDefinitionsForPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
        }));
    }

    protected processGetAllAvailableWidgetDefinitionsForPage(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @return OK
     */
    getSettingName(application: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application === null)
            throw new globalThis.Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSettingName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    sendAndGetDate(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    sendAndGetDateTime(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    sendAndGetDateRange(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return OK
     */
    getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringOutput>;
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicEntityPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityFullName (optional) 
     * @return OK
     */
    getAllPropertiesOfAnEntity(entityFullName: string | undefined): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllPropertiesOfAnEntity?";
        if (entityFullName === null)
            throw new globalThis.Error("The parameter 'entityFullName' cannot be null.");
        else if (entityFullName !== undefined)
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPropertiesOfAnEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPropertiesOfAnEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }));
    }

    protected processGetAllPropertiesOfAnEntity(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEntitiesHasDynamicProperty(): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllEntitiesHasDynamicProperty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntitiesHasDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntitiesHasDynamicProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
        }));
    }

    protected processGetAllEntitiesHasDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyDefinitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllAllowedInputTypeNames(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllAllowedInputTypeNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAllowedInputTypeNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAllowedInputTypeNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllAllowedInputTypeNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEntities(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllEntities(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicEntityPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicEntityPropertyValueDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param propertyId (optional) 
     * @return OK
     */
    getAll(entityId: string | undefined, propertyId: number | undefined): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAll?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDynamicEntityPropertyValues(entityFullName: string, entityId: string): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAllDynamicEntityPropertyValues?";
        if (entityFullName === undefined || entityFullName === null)
            throw new globalThis.Error("The parameter 'entityFullName' must be defined and cannot be null.");
        else
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDynamicEntityPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDynamicEntityPropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
        }));
    }

    protected processGetAllDynamicEntityPropertyValues(response: HttpResponseBase): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllDynamicEntityPropertyValuesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insertOrUpdateAllValues(body: InsertOrUpdateAllValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/InsertOrUpdateAllValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdateAllValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdateAllValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertOrUpdateAllValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cleanValues(body: CleanValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/CleanValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCleanValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ListResultDtoOfDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    findAllowedInputType(name: string | undefined): Observable<IInputType> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/FindAllowedInputType?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAllowedInputType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAllowedInputType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IInputType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IInputType>;
        }));
    }

    protected processFindAllowedInputType(response: HttpResponseBase): Observable<IInputType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IInputType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<DynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicPropertyValueDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllValuesOfDynamicProperty(id: number | undefined): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/GetAllValuesOfDynamicProperty?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValuesOfDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValuesOfDynamicProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
        }));
    }

    protected processGetAllValuesOfDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFreeTrialEditionId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetFreeTrialEditionId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreeTrialEditionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreeTrialEditionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetFreeTrialEditionId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEditonForsubscriptionData(): Observable<SubscriptionMgtDataDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/getEditonForsubscriptionData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditonForsubscriptionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditonForsubscriptionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionMgtDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionMgtDataDto>;
        }));
    }

    protected processGetEditonForsubscriptionData(response: HttpResponseBase): Observable<SubscriptionMgtDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionMgtDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param currencyCode (optional) 
     * @return OK
     */
    getLocalCurrencyValue(startDate: DateTime | undefined, endDate: DateTime | undefined, currencyCode: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetLocalCurrencyValue?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "CurrencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalCurrencyValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalCurrencyValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLocalCurrencyValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param localCurrency (optional) 
     * @return OK
     */
    getLocalValue(localCurrency: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetLocalValue?";
        if (localCurrency === null)
            throw new globalThis.Error("The parameter 'localCurrency' cannot be null.");
        else if (localCurrency !== undefined)
            url_ += "localCurrency=" + encodeURIComponent("" + localCurrency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLocalValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userCount (optional) 
     * @return OK
     */
    createEditionBasedOnUser(userCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEditionBasedOnUser?";
        if (userCount === null)
            throw new globalThis.Error("The parameter 'userCount' cannot be null.");
        else if (userCount !== undefined)
            url_ += "userCount=" + encodeURIComponent("" + userCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEditionBasedOnUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEditionBasedOnUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEditionBasedOnUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return OK
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new globalThis.Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new globalThis.Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new globalThis.Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ElectronServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    captureScreenShot(body: ScreenShotCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/CaptureScreenShot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptureScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptureScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCaptureScreenShot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUserStatusFromAgent(body: ProjectTaskStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/CreateOrUpdateUserStatusFromAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserStatusFromAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserStatusFromAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUserStatusFromAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param taskSort (optional) 
     * @param statusId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param oldnew (optional) 
     * @return OK
     */
    getProjectWiseUserTasks(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, taskSort: boolean | undefined, statusId: number | undefined, tenantId: number | undefined, userId: number | undefined, oldnew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetProjectWiseUserTasks?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (taskSort === null)
            throw new globalThis.Error("The parameter 'taskSort' cannot be null.");
        else if (taskSort !== undefined)
            url_ += "TaskSort=" + encodeURIComponent("" + taskSort) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (oldnew === null)
            throw new globalThis.Error("The parameter 'oldnew' cannot be null.");
        else if (oldnew !== undefined)
            url_ += "oldnew=" + encodeURIComponent("" + oldnew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseUserTasks(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userActivityAndWindowsTracking(body: ApplicationTrackingAndWindowsTrackingCombineDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/UserActivityAndWindowsTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActivityAndWindowsTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActivityAndWindowsTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActivityAndWindowsTracking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    flutterGetUserActiveTimeSummaryForUser(body: InputeCalculationTimeAndAttendanceDto | undefined): Observable<ActiveTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/Electron/FlutterGetUserActiveTimeSummaryForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFlutterGetUserActiveTimeSummaryForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlutterGetUserActiveTimeSummaryForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTimeDto>;
        }));
    }

    protected processFlutterGetUserActiveTimeSummaryForUser(response: HttpResponseBase): Observable<ActiveTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAppiconList(tenantId: number | undefined): Observable<AgentApplicationDtoAgentApp[]> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetAppiconList?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppiconList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppiconList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationDtoAgentApp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationDtoAgentApp[]>;
        }));
    }

    protected processGetAppiconList(response: HttpResponseBase): Observable<AgentApplicationDtoAgentApp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationDtoAgentApp.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    storeImageOnBlobAndGetUrl(body: StoreImageOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Electron/StoreImageOnBlobAndGetUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreImageOnBlobAndGetUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreImageOnBlobAndGetUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStoreImageOnBlobAndGetUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    storeImageOnBlobAndGetUrlOffline(body: StoreImageOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Electron/StoreImageOnBlobAndGetUrlOffline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreImageOnBlobAndGetUrlOffline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreImageOnBlobAndGetUrlOffline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStoreImageOnBlobAndGetUrlOffline(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUserRealtimeLocation(body: UserRealTimeLocationCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/CreateUserRealtimeLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserRealtimeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserRealtimeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserRealtimeLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    offlineAppTrackingDataForMACUser(userId: number | undefined, body: OfflineApptrackingDataDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Electron/OfflineAppTrackingDataForMACUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineAppTrackingDataForMACUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineAppTrackingDataForMACUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineAppTrackingDataForMACUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApplicationProductiveTypesOfAgentApp(userId: number | undefined, tenantId: number | undefined): Observable<AgentApplicationProductiveTypes[]> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetApplicationProductiveTypesOfAgentApp?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationProductiveTypesOfAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationProductiveTypesOfAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationProductiveTypes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationProductiveTypes[]>;
        }));
    }

    protected processGetApplicationProductiveTypesOfAgentApp(response: HttpResponseBase): Observable<AgentApplicationProductiveTypes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationProductiveTypes.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signalRCreateOrEditUserStatusFromAgentAPI(body: ProjectTaskStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/SignalRCreateOrEditUserStatusFromAgentAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalRCreateOrEditUserStatusFromAgentAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalRCreateOrEditUserStatusFromAgentAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignalRCreateOrEditUserStatusFromAgentAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserProjectTaskByTaskIdForElectron(projectTaskId: number | undefined, tenantId: number | undefined): Observable<UserProjectTaskInputFromAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetUserProjectTaskByTaskIdForElectron?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskByTaskIdForElectron(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskByTaskIdForElectron(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskInputFromAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskInputFromAgentDto>;
        }));
    }

    protected processGetUserProjectTaskByTaskIdForElectron(response: HttpResponseBase): Observable<UserProjectTaskInputFromAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectTaskInputFromAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    liveScreenshotByUsingSignalR(body: LiveScreenshotCreateSignalRDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/LiveScreenshotByUsingSignalR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLiveScreenshotByUsingSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLiveScreenshotByUsingSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLiveScreenshotByUsingSignalR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offlineUserStatus(body: OfflineUserStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Electron/OfflineUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOfflineUserStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUserStatus(userId: number | undefined): Observable<UserStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetUserStatus?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserStatusDto>;
        }));
    }

    protected processGetUserStatus(response: HttpResponseBase): Observable<UserStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAppConfiguration(body: AppConfigurationDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Electron/SaveAppConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAppConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAppConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveAppConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAppConfiguration(): Observable<AppConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetAllAppConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppConfigurationDto[]>;
        }));
    }

    protected processGetAllAppConfiguration(response: HttpResponseBase): Observable<AppConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppConfigurationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param s (optional) 
     * @return OK
     */
    isBase64String(s: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Electron/IsBase64String?";
        if (s === null)
            throw new globalThis.Error("The parameter 's' cannot be null.");
        else if (s !== undefined)
            url_ += "s=" + encodeURIComponent("" + s) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsBase64String(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsBase64String(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsBase64String(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pLatitude (optional) 
     * @param pLogitude (optional) 
     * @return OK
     */
    getDevicePosition(pLatitude: number | undefined, pLogitude: number | undefined): Observable<RootRealTime> {
        let url_ = this.baseUrl + "/api/services/app/Electron/GetDevicePosition?";
        if (pLatitude === null)
            throw new globalThis.Error("The parameter 'pLatitude' cannot be null.");
        else if (pLatitude !== undefined)
            url_ += "pLatitude=" + encodeURIComponent("" + pLatitude) + "&";
        if (pLogitude === null)
            throw new globalThis.Error("The parameter 'pLogitude' cannot be null.");
        else if (pLogitude !== undefined)
            url_ += "pLogitude=" + encodeURIComponent("" + pLogitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RootRealTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RootRealTime>;
        }));
    }

    protected processGetDevicePosition(response: HttpResponseBase): Observable<RootRealTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RootRealTime.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    openIdKey(): Observable<OpenIdKeyDto> {
        let url_ = this.baseUrl + "/api/services/app/Electron/OpenIdKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenIdKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenIdKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpenIdKeyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpenIdKeyDto>;
        }));
    }

    protected processOpenIdKey(response: HttpResponseBase): Observable<OpenIdKeyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpenIdKeyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlutterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getHeaderForUser(tenantId: number | undefined, userId: number | undefined): Observable<GetHeaderForUserDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetHeaderForUser?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeaderForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeaderForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHeaderForUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHeaderForUserDto>;
        }));
    }

    protected processGetHeaderForUser(response: HttpResponseBase): Observable<GetHeaderForUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHeaderForUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param statusId (optional) 
     * @param filter (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    getAllProjectsAndTeamMemberDetailsForFlutter(projectType: ProjectType3, tenantId: number | undefined, userId: number | undefined, statusId: number | undefined, filter: string | undefined, isManager: boolean | undefined): Observable<GetAllProjectDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetAllProjectsAndTeamMemberDetailsForFlutter?";
        if (projectType === undefined || projectType === null)
            throw new globalThis.Error("The parameter 'projectType' must be defined and cannot be null.");
        else
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsAndTeamMemberDetailsForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsAndTeamMemberDetailsForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDetailsDto[]>;
        }));
    }

    protected processGetAllProjectsAndTeamMemberDetailsForFlutter(response: HttpResponseBase): Observable<GetAllProjectDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    leavesDetailsForFlutter(userId: number | undefined, tenantId: number | undefined): Observable<AddAwayTimeGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/LeavesDetailsForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeavesDetailsForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeavesDetailsForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeGetAllDto[]>;
        }));
    }

    protected processLeavesDetailsForFlutter(response: HttpResponseBase): Observable<AddAwayTimeGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createLeaveForFlutter(userId: number | undefined, body: AddAwayTimeCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/CreateLeaveForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeaveForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLeaveForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    editLeaveForFlutter(userId: number | undefined, body: AddAwayTimeCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/EditLeaveForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLeaveForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLeaveForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditLeaveForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    leaveDataForFlutter(userId: number | undefined, tenantId: number | undefined): Observable<TimeOffLeaveDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/LeaveDataForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveDataForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveDataForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeOffLeaveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeOffLeaveDto>;
        }));
    }

    protected processLeaveDataForFlutter(response: HttpResponseBase): Observable<TimeOffLeaveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeOffLeaveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserDetailsForEditForFlutter(id: number | undefined, tenantId: number | undefined): Observable<GetUserForEditOutputForFlutter> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetUserDetailsForEditForFlutter?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetailsForEditForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetailsForEditForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutputForFlutter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutputForFlutter>;
        }));
    }

    protected processGetUserDetailsForEditForFlutter(response: HttpResponseBase): Observable<GetUserForEditOutputForFlutter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutputForFlutter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserForFlutter(body: UpdateUserForFlutter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/UpdateUserForFlutter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param password (optional) 
     * @param tenatId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    insertdatatoalltenatndbForFlutter(email: string | undefined, password: string | undefined, tenatId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/InsertdatatoalltenatndbForFlutter?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (tenatId === null)
            throw new globalThis.Error("The parameter 'tenatId' cannot be null.");
        else if (tenatId !== undefined)
            url_ += "tenatId=" + encodeURIComponent("" + tenatId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertdatatoalltenatndbForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertdatatoalltenatndbForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertdatatoalltenatndbForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    changePasswordForUserForFlutter(userId: number | undefined, tenantId: number | undefined, body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/ChangePasswordForUserForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePasswordForUserForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordForUserForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePasswordForUserForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenanId (optional) 
     * @param projectId (optional) 
     * @param isDelete (optional) 
     * @return OK
     */
    getJobTaskDetailsForFlutter(userId: number | undefined, tenanId: number | undefined, projectId: number | undefined, isDelete: boolean | undefined): Observable<OutPutTaskJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetJobTaskDetailsForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenanId === null)
            throw new globalThis.Error("The parameter 'tenanId' cannot be null.");
        else if (tenanId !== undefined)
            url_ += "tenanId=" + encodeURIComponent("" + tenanId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (isDelete === null)
            throw new globalThis.Error("The parameter 'isDelete' cannot be null.");
        else if (isDelete !== undefined)
            url_ += "isDelete=" + encodeURIComponent("" + isDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobTaskDetailsForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobTaskDetailsForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTaskJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTaskJobDto[]>;
        }));
    }

    protected processGetJobTaskDetailsForFlutter(response: HttpResponseBase): Observable<OutPutTaskJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTaskJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getBillablityTypeOfProjectForFlutter(projectId: number | undefined, tenantId: number | undefined, userId: number | undefined): Observable<ProjectBillingType> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetBillablityTypeOfProjectForFlutter?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillablityTypeOfProjectForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillablityTypeOfProjectForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBillingType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBillingType>;
        }));
    }

    protected processGetBillablityTypeOfProjectForFlutter(response: HttpResponseBase): Observable<ProjectBillingType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param filter (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param weeks (optional) 
     * @param submittedHourDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getFilledTaskDetailsBaseOnProjectForFlutter(projectId: number[] | undefined, filter: string | undefined, billabilityStatus: number | undefined, timeZoneOffset: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, weeks: string[] | undefined, submittedHourDate: string | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum, userId: number | undefined, tenantId: number | undefined): Observable<OutPutDayViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetFilledTaskDetailsBaseOnProjectForFlutter?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            url_ += "BillabilityStatus=" + encodeURIComponent("" + billabilityStatus) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (submittedHourDate === null)
            throw new globalThis.Error("The parameter 'submittedHourDate' cannot be null.");
        else if (submittedHourDate !== undefined)
            url_ += "SubmittedHourDate=" + encodeURIComponent("" + submittedHourDate) + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilledTaskDetailsBaseOnProjectForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilledTaskDetailsBaseOnProjectForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutDayViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutDayViewDto>;
        }));
    }

    protected processGetFilledTaskDetailsBaseOnProjectForFlutter(response: HttpResponseBase): Observable<OutPutDayViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutDayViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetAddManualTaskForFlutter(userId: number | undefined, tenantId: number | undefined, body: InputManualAddTimesheet | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/TimesheetAddManualTaskForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetAddManualTaskForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetAddManualTaskForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTimesheetAddManualTaskForFlutter(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateTimesheetManualTaskForFlutter(userId: number | undefined, tenantId: number | undefined, body: InputManualAddTimesheet | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/UpdateTimesheetManualTaskForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimesheetManualTaskForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimesheetManualTaskForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTimesheetManualTaskForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    submitTimesheet(userId: number | undefined, tenantId: number | undefined, body: InputSendTimesheetDto[] | undefined): Observable<OutPutSendTimesheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/SubmitTimesheet?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutSendTimesheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutSendTimesheetDto[]>;
        }));
    }

    protected processSubmitTimesheet(response: HttpResponseBase): Observable<OutPutSendTimesheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutSendTimesheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    submittedTimesheetGridForFlutter(userId: number | undefined, tenantId: number | undefined, body: InputSubmittedTimesheetDto | undefined): Observable<OutPutSubmittedTimesheetDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/SubmittedTimesheetGridForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmittedTimesheetGridForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmittedTimesheetGridForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutSubmittedTimesheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutSubmittedTimesheetDto>;
        }));
    }

    protected processSubmittedTimesheetGridForFlutter(response: HttpResponseBase): Observable<OutPutSubmittedTimesheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutSubmittedTimesheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param timesheetId (optional) 
     * @param timeZoneOffset (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param weeks (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getSubmittedTimesheetTaskDetailsForFlutter(userId: number | undefined, projectId: number | undefined, timesheetId: number | undefined, timeZoneOffset: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, weeks: string[] | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum, tenantId: number | undefined): Observable<OutPutSubmittedTimesheetTaskDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetSubmittedTimesheetTaskDetailsForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmittedTimesheetTaskDetailsForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedTimesheetTaskDetailsForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutSubmittedTimesheetTaskDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutSubmittedTimesheetTaskDetailDto[]>;
        }));
    }

    protected processGetSubmittedTimesheetTaskDetailsForFlutter(response: HttpResponseBase): Observable<OutPutSubmittedTimesheetTaskDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutSubmittedTimesheetTaskDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editTimeoffId (optional) 
     * @param isAddMode (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkAwayTimeValidityForFlutter(editTimeoffId: number | undefined, isAddMode: boolean | undefined, body: CheckValidityforLeavesDtoForFlutter | undefined): Observable<LeaveValiditityDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/CheckAwayTimeValidityForFlutter?";
        if (editTimeoffId === null)
            throw new globalThis.Error("The parameter 'editTimeoffId' cannot be null.");
        else if (editTimeoffId !== undefined)
            url_ += "editTimeoffId=" + encodeURIComponent("" + editTimeoffId) + "&";
        if (isAddMode === null)
            throw new globalThis.Error("The parameter 'isAddMode' cannot be null.");
        else if (isAddMode !== undefined)
            url_ += "isAddMode=" + encodeURIComponent("" + isAddMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAwayTimeValidityForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAwayTimeValidityForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveValiditityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveValiditityDto>;
        }));
    }

    protected processCheckAwayTimeValidityForFlutter(response: HttpResponseBase): Observable<LeaveValiditityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveValiditityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    allAppsAndWebsitesForFlutter(body: InputTotalUsesForFlutter | undefined): Observable<UserActivityDtoForFlutter[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/AllAppsAndWebsitesForFlutter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllAppsAndWebsitesForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllAppsAndWebsitesForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivityDtoForFlutter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivityDtoForFlutter[]>;
        }));
    }

    protected processAllAppsAndWebsitesForFlutter(response: HttpResponseBase): Observable<UserActivityDtoForFlutter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivityDtoForFlutter.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param isTeamTask (optional) 
     * @return OK
     */
    projectTaskHistoryForFlutter(projectTaskId: number | undefined, userId: number | undefined, tenantId: number | undefined, isTeamTask: boolean | undefined): Observable<UserTaskHistoryDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/ProjectTaskHistoryForFlutter?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (isTeamTask === null)
            throw new globalThis.Error("The parameter 'isTeamTask' cannot be null.");
        else if (isTeamTask !== undefined)
            url_ += "isTeamTask=" + encodeURIComponent("" + isTeamTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectTaskHistoryForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectTaskHistoryForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTaskHistoryDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTaskHistoryDetailsDto>;
        }));
    }

    protected processProjectTaskHistoryForFlutter(response: HttpResponseBase): Observable<UserTaskHistoryDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTaskHistoryDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getAllProjectsForDropDownForFlutter(tenantId: number | undefined, userId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<ProjectDtoForFlutter[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetAllProjectsForDropDownForFlutter?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsForDropDownForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsForDropDownForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoForFlutter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoForFlutter[]>;
        }));
    }

    protected processGetAllProjectsForDropDownForFlutter(response: HttpResponseBase): Observable<ProjectDtoForFlutter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDtoForFlutter.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManualHourseInManualTimesheetForFlutter(body: InputAddManualTimeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/AddManualHourseInManualTimesheetForFlutter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualHourseInManualTimesheetForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualHourseInManualTimesheetForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddManualHourseInManualTimesheetForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApplicationsDetailsForFlutter(userId: number | undefined, tenantId: number | undefined): Observable<OutPutGetApplicationsDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetApplicationsDetailsForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationsDetailsForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationsDetailsForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutGetApplicationsDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutGetApplicationsDetailsDto[]>;
        }));
    }

    protected processGetApplicationsDetailsForFlutter(response: HttpResponseBase): Observable<OutPutGetApplicationsDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutGetApplicationsDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    deleteTimesheetTaskForFlutter(taskId: number | undefined, tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/DeleteTimesheetTaskForFlutter?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTimesheetTaskForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTimesheetTaskForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTimesheetTaskForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param taskId (optional) 
     * @return OK
     */
    getTaskLevelCommentForFlutter(userId: number | undefined, tenantId: number | undefined, taskId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetTaskLevelCommentForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLevelCommentForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLevelCommentForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetTaskLevelCommentForFlutter(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param comment (optional) 
     * @return OK
     */
    addCommentUserProjectTaskForFlutter(taskId: number | undefined, userId: number | undefined, tenantId: number | undefined, comment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/AddCommentUserProjectTaskForFlutter?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (comment === null)
            throw new globalThis.Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCommentUserProjectTaskForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCommentUserProjectTaskForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCommentUserProjectTaskForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserProjectTaskLevelCommentForFlutter(taskId: number | undefined, tenantId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetUserProjectTaskLevelCommentForFlutter?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskLevelCommentForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskLevelCommentForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetUserProjectTaskLevelCommentForFlutter(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param projectIds (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getTaskDescriptionHistoryForFlutter(userId: number | undefined, tenantId: number | undefined, projectIds: number[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<OutPutGetTaskDescriptionHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetTaskDescriptionHistoryForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskDescriptionHistoryForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskDescriptionHistoryForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutGetTaskDescriptionHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutGetTaskDescriptionHistoryDto[]>;
        }));
    }

    protected processGetTaskDescriptionHistoryForFlutter(response: HttpResponseBase): Observable<OutPutGetTaskDescriptionHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutGetTaskDescriptionHistoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataSourceLoadOptions (optional) 
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param userIds (optional) 
     * @param statusId (optional) 
     * @param filter (optional) 
     * @param filterSearch (optional) 
     * @param newestOnTop (optional) 
     * @param oldestOnTop (optional) 
     * @param isExport (optional) 
     * @param columnFilters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getTeamTaskListForFlutter(dataSourceLoadOptions: string | undefined, projectIds: number[] | undefined, projectTaskIds: number[] | undefined, userIds: number[] | undefined, statusId: number | undefined, filter: string | undefined, filterSearch: string | undefined, newestOnTop: boolean | undefined, oldestOnTop: boolean | undefined, isExport: boolean | undefined, columnFilters: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, userId: number | undefined, tenantId: number | undefined): Observable<TeamTaskResult> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetTeamTaskListForFlutter?";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (filterSearch === null)
            throw new globalThis.Error("The parameter 'filterSearch' cannot be null.");
        else if (filterSearch !== undefined)
            url_ += "FilterSearch=" + encodeURIComponent("" + filterSearch) + "&";
        if (newestOnTop === null)
            throw new globalThis.Error("The parameter 'newestOnTop' cannot be null.");
        else if (newestOnTop !== undefined)
            url_ += "NewestOnTop=" + encodeURIComponent("" + newestOnTop) + "&";
        if (oldestOnTop === null)
            throw new globalThis.Error("The parameter 'oldestOnTop' cannot be null.");
        else if (oldestOnTop !== undefined)
            url_ += "OldestOnTop=" + encodeURIComponent("" + oldestOnTop) + "&";
        if (isExport === null)
            throw new globalThis.Error("The parameter 'isExport' cannot be null.");
        else if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&";
        if (columnFilters === null)
            throw new globalThis.Error("The parameter 'columnFilters' cannot be null.");
        else if (columnFilters !== undefined)
            url_ += "ColumnFilters=" + encodeURIComponent("" + columnFilters) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamTaskListForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamTaskListForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamTaskResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamTaskResult>;
        }));
    }

    protected processGetTeamTaskListForFlutter(response: HttpResponseBase): Observable<TeamTaskResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamTaskResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    reSubmiteRejectedTimesheetForFlutter(tenantId: number | undefined, userId: number | undefined, body: InputReSubmiteRejectedTimesheetDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/ReSubmiteRejectedTimesheetForFlutter?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSubmiteRejectedTimesheetForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSubmiteRejectedTimesheetForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReSubmiteRejectedTimesheetForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getLeaveByIdForFlutter(id: number | undefined, tenantId: number | undefined, userId: number | undefined): Observable<AddAwayTimeCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetLeaveByIdForFlutter?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveByIdForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveByIdForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAwayTimeCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAwayTimeCreateOrEditDto>;
        }));
    }

    protected processGetLeaveByIdForFlutter(response: HttpResponseBase): Observable<AddAwayTimeCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAwayTimeCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectedTimesheetAddOrUpdateTimeForFlutter(body: DraftedTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/RejectedTimesheetAddOrUpdateTimeForFlutter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectedTimesheetAddOrUpdateTimeForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectedTimesheetAddOrUpdateTimeForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectedTimesheetAddOrUpdateTimeForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param week (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getWeekViewDetailsForFlutter(timeZoneOffset: number | undefined, filter: string | undefined, week: string[] | undefined, tenantId: number | undefined, userId: number | undefined): Observable<OutPutWeekViewDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetWeekViewDetailsForFlutter?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (week === null)
            throw new globalThis.Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            week && week.forEach(item => { url_ += "Week=" + encodeURIComponent("" + item) + "&"; });
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeekViewDetailsForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeekViewDetailsForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutWeekViewDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutWeekViewDetailsDto>;
        }));
    }

    protected processGetWeekViewDetailsForFlutter(response: HttpResponseBase): Observable<OutPutWeekViewDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutWeekViewDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTaskDescriptionBaseOnDateForFlutter(body: InputUpdateTaskDescriptionBaseOnDateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/UpdateTaskDescriptionBaseOnDateForFlutter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskDescriptionBaseOnDateForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskDescriptionBaseOnDateForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTaskDescriptionBaseOnDateForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param osname (optional) 
     * @return OK
     */
    getFlutterAppVersion(osname: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetFlutterAppVersion?";
        if (osname === null)
            throw new globalThis.Error("The parameter 'osname' cannot be null.");
        else if (osname !== undefined)
            url_ += "osname=" + encodeURIComponent("" + osname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlutterAppVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlutterAppVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFlutterAppVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param take (optional) 
     * @param skip (optional) 
     * @return OK
     */
    getUserNotifications(userId: number | undefined, tenantId: number | undefined, take: number | undefined, skip: number | undefined): Observable<FlutterNotificationsDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetUserNotifications?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlutterNotificationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlutterNotificationsDto>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<FlutterNotificationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlutterNotificationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAllNotificationsAsReadFlutter(body: FlutterNotificationsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/SetAllNotificationsAsReadFlutter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsReadFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsReadFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsReadFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    setNotificationAsReadFlutter(id: string | undefined, body: FlutterNotificationsInputDto | undefined): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/SetNotificationAsReadFlutter?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsReadFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsReadFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetNotificationAsReadFlutter(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    nonWorkingDays(userId: number | undefined, tenantId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/NonWorkingDays?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNonWorkingDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNonWorkingDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processNonWorkingDays(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUsertrackedApplicationForFlutter(userId: number | undefined, tenantId: number | undefined): Observable<TrackedApplicationDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetUsertrackedApplicationForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsertrackedApplicationForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsertrackedApplicationForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrackedApplicationDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrackedApplicationDataDto[]>;
        }));
    }

    protected processGetUsertrackedApplicationForFlutter(response: HttpResponseBase): Observable<TrackedApplicationDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrackedApplicationDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getUsertrackedApplicationWithConfigForFlutter(userId: number | undefined, tenantId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<TrackedApplicationByDateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetUsertrackedApplicationWithConfigForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsertrackedApplicationWithConfigForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsertrackedApplicationWithConfigForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrackedApplicationByDateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrackedApplicationByDateDto[]>;
        }));
    }

    protected processGetUsertrackedApplicationWithConfigForFlutter(response: HttpResponseBase): Observable<TrackedApplicationByDateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrackedApplicationByDateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataSourceLoadOptions (optional) 
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param projectId (optional) 
     * @param userIdQuery (optional) 
     * @param locationId (optional) 
     * @param isShowAll (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getAllCalendarViewV2ForFlutter(dataSourceLoadOptions: string | undefined, timeZoneOffset: number | undefined, filter: string | undefined, organizationId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, userIdQuery: (number | undefined)[] | undefined, locationId: string[] | undefined, isShowAll: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetAllCalendarViewV2ForFlutter?";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            organizationId && organizationId.forEach(item => { url_ += "organizationId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (userIdQuery === null)
            throw new globalThis.Error("The parameter 'userIdQuery' cannot be null.");
        else if (userIdQuery !== undefined)
            userIdQuery && userIdQuery.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            locationId && locationId.forEach(item => { url_ += "locationId=" + encodeURIComponent("" + item) + "&"; });
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "isShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalendarViewV2ForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalendarViewV2ForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto>;
        }));
    }

    protected processGetAllCalendarViewV2ForFlutter(response: HttpResponseBase): Observable<PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param flag (optional) 
     * @param approvedLeaveCount (optional) 
     * @param userId (optional) 
     * @param leaveType (optional) 
     * @param approverId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    updateRequestStatusForFlutter(id: number | undefined, flag: string | undefined, approvedLeaveCount: number | undefined, userId: number | undefined, leaveType: number | undefined, approverId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/UpdateRequestStatusForFlutter?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (approvedLeaveCount === null)
            throw new globalThis.Error("The parameter 'approvedLeaveCount' cannot be null.");
        else if (approvedLeaveCount !== undefined)
            url_ += "approvedLeaveCount=" + encodeURIComponent("" + approvedLeaveCount) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (leaveType === null)
            throw new globalThis.Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        if (approverId === null)
            throw new globalThis.Error("The parameter 'approverId' cannot be null.");
        else if (approverId !== undefined)
            url_ += "approverId=" + encodeURIComponent("" + approverId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestStatusForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestStatusForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRequestStatusForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param notificationMessage (optional) 
     * @return OK
     */
    sendActivityTimeOffNotificationToManagersForFlutter(userId: number | undefined, notificationMessage: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/SendActivityTimeOffNotificationToManagersForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (notificationMessage === null)
            throw new globalThis.Error("The parameter 'notificationMessage' cannot be null.");
        else if (notificationMessage !== undefined)
            url_ += "notificationMessage=" + encodeURIComponent("" + notificationMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendActivityTimeOffNotificationToManagersForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendActivityTimeOffNotificationToManagersForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendActivityTimeOffNotificationToManagersForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTimeOffComments(body: AddTimeOffCommentsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/CreateTimeOffComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTimeOffComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTimeOffComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTimeOffComments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param isShowAll (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param dataSourceLoadOptions (optional) 
     * @param projectIds (optional) 
     * @param timesheetStatus (optional) 
     * @param isprojectLevelcall (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApprovalGridDataForFlutter(timeZoneOffset: number | undefined, isShowAll: boolean | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, dataSourceLoadOptions: string | undefined, projectIds: number[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, isprojectLevelcall: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined, userId: number | undefined, tenantId: number | undefined): Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/GetApprovalGridDataForFlutter?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (isprojectLevelcall === null)
            throw new globalThis.Error("The parameter 'isprojectLevelcall' cannot be null.");
        else if (isprojectLevelcall !== undefined)
            url_ += "IsprojectLevelcall=" + encodeURIComponent("" + isprojectLevelcall) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalGridDataForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalGridDataForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto>;
        }));
    }

    protected processGetApprovalGridDataForFlutter(response: HttpResponseBase): Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOutPutGetApprovalGridDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetStatusUpdateAfterApprovedForFlutter(userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/TimesheetStatusUpdateAfterApprovedForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetStatusUpdateAfterApprovedForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetStatusUpdateAfterApprovedForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetStatusUpdateAfterApprovedForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetApproveRejectActionForFlutter(userId: number | undefined, tenantId: number | undefined, body: ApproveRejectDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/TimesheetApproveRejectActionForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetApproveRejectActionForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetApproveRejectActionForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetApproveRejectActionForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param offsetMinutes (optional) 
     * @return OK
     */
    checkLast30DaysTimesheetCompletion(userId: number | undefined, tenantId: number | undefined, offsetMinutes: number | undefined): Observable<TimesheetCompletionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/CheckLast30DaysTimesheetCompletion?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (offsetMinutes === null)
            throw new globalThis.Error("The parameter 'offsetMinutes' cannot be null.");
        else if (offsetMinutes !== undefined)
            url_ += "offsetMinutes=" + encodeURIComponent("" + offsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLast30DaysTimesheetCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLast30DaysTimesheetCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetCompletionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetCompletionStatusDto>;
        }));
    }

    protected processCheckLast30DaysTimesheetCompletion(response: HttpResponseBase): Observable<TimesheetCompletionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetCompletionStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param userTimeZone (optional) 
     * @return OK
     */
    updateUserTimeZoneForFlutter(userId: number | undefined, tenantId: number | undefined, userTimeZone: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flutter/UpdateUserTimeZoneForFlutter?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userTimeZone === null)
            throw new globalThis.Error("The parameter 'userTimeZone' cannot be null.");
        else if (userTimeZone !== undefined)
            url_ += "userTimeZone=" + encodeURIComponent("" + userTimeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserTimeZoneForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserTimeZoneForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserTimeZoneForFlutter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlutterActivityTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    captureScreenShot(body: ScreenShotCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/CaptureScreenShot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptureScreenShot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptureScreenShot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCaptureScreenShot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUserStatusFromAgent(body: ProjectTaskStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/CreateOrUpdateUserStatusFromAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserStatusFromAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserStatusFromAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUserStatusFromAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param taskSort (optional) 
     * @param statusId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param oldnew (optional) 
     * @return OK
     */
    getProjectWiseUserTasks(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, taskSort: boolean | undefined, statusId: number | undefined, tenantId: number | undefined, userId: number | undefined, oldnew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetProjectWiseUserTasks?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (taskSort === null)
            throw new globalThis.Error("The parameter 'taskSort' cannot be null.");
        else if (taskSort !== undefined)
            url_ += "TaskSort=" + encodeURIComponent("" + taskSort) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (oldnew === null)
            throw new globalThis.Error("The parameter 'oldnew' cannot be null.");
        else if (oldnew !== undefined)
            url_ += "oldnew=" + encodeURIComponent("" + oldnew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseUserTasks(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userActivityAndWindowsTracking(body: ApplicationTrackingAndWindowsTrackingCombineDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/UserActivityAndWindowsTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActivityAndWindowsTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActivityAndWindowsTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActivityAndWindowsTracking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAppConfiguration(body: AppConfigurationDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/SaveAppConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAppConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAppConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveAppConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAppConfiguration(): Observable<AppConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetAllAppConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppConfigurationDto[]>;
        }));
    }

    protected processGetAllAppConfiguration(response: HttpResponseBase): Observable<AppConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppConfigurationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    flutterGetUserActiveTimeSummaryForUser(body: InputeCalculationTimeAndAttendanceDto | undefined): Observable<ActiveTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/FlutterGetUserActiveTimeSummaryForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFlutterGetUserActiveTimeSummaryForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlutterGetUserActiveTimeSummaryForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTimeDto>;
        }));
    }

    protected processFlutterGetUserActiveTimeSummaryForUser(response: HttpResponseBase): Observable<ActiveTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAppiconList(tenantId: number | undefined): Observable<AgentApplicationDtoAgentApp[]> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetAppiconList?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppiconList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppiconList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationDtoAgentApp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationDtoAgentApp[]>;
        }));
    }

    protected processGetAppiconList(response: HttpResponseBase): Observable<AgentApplicationDtoAgentApp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationDtoAgentApp.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    storeImageOnBlobAndGetUrlOffline(body: StoreImageOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/StoreImageOnBlobAndGetUrlOffline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreImageOnBlobAndGetUrlOffline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreImageOnBlobAndGetUrlOffline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStoreImageOnBlobAndGetUrlOffline(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param s (optional) 
     * @return OK
     */
    isBase64String(s: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/IsBase64String?";
        if (s === null)
            throw new globalThis.Error("The parameter 's' cannot be null.");
        else if (s !== undefined)
            url_ += "s=" + encodeURIComponent("" + s) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsBase64String(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsBase64String(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsBase64String(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    storeImageOnBlobAndGetUrl(body: StoreImageOnBlobDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/StoreImageOnBlobAndGetUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreImageOnBlobAndGetUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreImageOnBlobAndGetUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStoreImageOnBlobAndGetUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUserRealtimeLocation(body: UserRealTimeLocationCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/CreateUserRealtimeLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserRealtimeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserRealtimeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserRealtimeLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pLatitude (optional) 
     * @param pLogitude (optional) 
     * @return OK
     */
    getDevicePosition(pLatitude: number | undefined, pLogitude: number | undefined): Observable<RootRealTime> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetDevicePosition?";
        if (pLatitude === null)
            throw new globalThis.Error("The parameter 'pLatitude' cannot be null.");
        else if (pLatitude !== undefined)
            url_ += "pLatitude=" + encodeURIComponent("" + pLatitude) + "&";
        if (pLogitude === null)
            throw new globalThis.Error("The parameter 'pLogitude' cannot be null.");
        else if (pLogitude !== undefined)
            url_ += "pLogitude=" + encodeURIComponent("" + pLogitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RootRealTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RootRealTime>;
        }));
    }

    protected processGetDevicePosition(response: HttpResponseBase): Observable<RootRealTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RootRealTime.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    offlineAppTrackingDataForMACUser(userId: number | undefined, body: OfflineApptrackingDataDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/OfflineAppTrackingDataForMACUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineAppTrackingDataForMACUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineAppTrackingDataForMACUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOfflineAppTrackingDataForMACUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApplicationProductiveTypesOfAgentApp(userId: number | undefined, tenantId: number | undefined): Observable<AgentApplicationProductiveTypes[]> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetApplicationProductiveTypesOfAgentApp?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationProductiveTypesOfAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationProductiveTypesOfAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationProductiveTypes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationProductiveTypes[]>;
        }));
    }

    protected processGetApplicationProductiveTypesOfAgentApp(response: HttpResponseBase): Observable<AgentApplicationProductiveTypes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationProductiveTypes.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signalRCreateOrEditUserStatusFromAgentAPI(body: ProjectTaskStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/SignalRCreateOrEditUserStatusFromAgentAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalRCreateOrEditUserStatusFromAgentAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalRCreateOrEditUserStatusFromAgentAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignalRCreateOrEditUserStatusFromAgentAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserProjectTaskByTaskIdForElectron(projectTaskId: number | undefined, tenantId: number | undefined): Observable<UserProjectTaskInputFromAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetUserProjectTaskByTaskIdForElectron?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskByTaskIdForElectron(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskByTaskIdForElectron(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskInputFromAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskInputFromAgentDto>;
        }));
    }

    protected processGetUserProjectTaskByTaskIdForElectron(response: HttpResponseBase): Observable<UserProjectTaskInputFromAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectTaskInputFromAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    liveScreenshotByUsingSignalR(body: LiveScreenshotCreateSignalRDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/LiveScreenshotByUsingSignalR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLiveScreenshotByUsingSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLiveScreenshotByUsingSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLiveScreenshotByUsingSignalR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offlineUserStatus(body: OfflineUserStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/OfflineUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOfflineUserStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    openIdKey(): Observable<OpenIdKeyDto> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/OpenIdKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenIdKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenIdKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpenIdKeyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpenIdKeyDto>;
        }));
    }

    protected processOpenIdKey(response: HttpResponseBase): Observable<OpenIdKeyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpenIdKeyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUserStatus(userId: number | undefined): Observable<UserStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/FlutterActivityTracking/GetUserStatus?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserStatusDto>;
        }));
    }

    protected processGetUserStatus(response: HttpResponseBase): Observable<UserStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new globalThis.Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IdentityProviderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: IdentityProviderDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IdentityProvider/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllIdentityProviders(): Observable<IdentityProviderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IdentityProvider/GetAllIdentityProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIdentityProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIdentityProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityProviderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityProviderDto[]>;
        }));
    }

    protected processGetAllIdentityProviders(response: HttpResponseBase): Observable<IdentityProviderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdentityProviderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCatalog(): Observable<IntegrationCatalogItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationCatalogItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationCatalogItemDto[]>;
        }));
    }

    protected processGetCatalog(response: HttpResponseBase): Observable<IntegrationCatalogItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationCatalogItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCatalogForUser(id: number | undefined): Observable<IntegrationCatalogItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetCatalogForUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationCatalogItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationCatalogItemDto[]>;
        }));
    }

    protected processGetCatalogForUser(response: HttpResponseBase): Observable<IntegrationCatalogItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationCatalogItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConnection(provider: Provider): Observable<IntegrationConnectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetConnection?";
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined and cannot be null.");
        else
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationConnectionDto>;
        }));
    }

    protected processGetConnection(response: HttpResponseBase): Observable<IntegrationConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    beginOAuth(body: BeginIntegrationOAuthInput | undefined): Observable<IntegrationOAuthBeginResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/BeginOAuth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginOAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginOAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationOAuthBeginResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationOAuthBeginResultDto>;
        }));
    }

    protected processBeginOAuth(response: HttpResponseBase): Observable<IntegrationOAuthBeginResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationOAuthBeginResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    connectWithApiKey(body: ConnectIntegrationApiKeyInput | undefined): Observable<IntegrationConnectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/ConnectWithApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectWithApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectWithApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationConnectionDto>;
        }));
    }

    protected processConnectWithApiKey(response: HttpResponseBase): Observable<IntegrationConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    disconnect(body: IntegrationProvider | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refreshTokenUsage(body: IntegrationProvider | undefined): Observable<IntegrationConnectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/RefreshTokenUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshTokenUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTokenUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationConnectionDto>;
        }));
    }

    protected processRefreshTokenUsage(response: HttpResponseBase): Observable<IntegrationConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDevOpsProjects(): Observable<DevOpsProjectConnectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetDevOpsProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevOpsProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevOpsProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DevOpsProjectConnectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DevOpsProjectConnectionDto[]>;
        }));
    }

    protected processGetDevOpsProjects(response: HttpResponseBase): Observable<DevOpsProjectConnectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DevOpsProjectConnectionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    connectDevOpsProject(body: ConnectDevOpsProjectInput | undefined): Observable<DevOpsProjectConnectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/ConnectDevOpsProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectDevOpsProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectDevOpsProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DevOpsProjectConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DevOpsProjectConnectionDto>;
        }));
    }

    protected processConnectDevOpsProject(response: HttpResponseBase): Observable<DevOpsProjectConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevOpsProjectConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    disconnectDevOpsProject(body: DisconnectDevOpsProjectInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/DisconnectDevOpsProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnectDevOpsProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnectDevOpsProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisconnectDevOpsProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OauthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param code (optional) 
     * @param state (optional) 
     * @param error (optional) 
     * @param error_description (optional) 
     * @return OK
     */
    callback(code: string | undefined, state: string | undefined, error: string | undefined, error_description: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/integrations/oauth/callback?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (error === null)
            throw new globalThis.Error("The parameter 'error' cannot be null.");
        else if (error !== undefined)
            url_ += "error=" + encodeURIComponent("" + error) + "&";
        if (error_description === null)
            throw new globalThis.Error("The parameter 'error_description' cannot be null.");
        else if (error_description !== undefined)
            url_ += "error_description=" + encodeURIComponent("" + error_description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param success (optional) 
     * @param provider (optional) 
     * @return OK
     */
    status(success: boolean | undefined, provider: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/integrations/oauth/status?";
        if (success === null)
            throw new globalThis.Error("The parameter 'success' cannot be null.");
        else if (success !== undefined)
            url_ += "success=" + encodeURIComponent("" + success) + "&";
        if (provider === null)
            throw new globalThis.Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ITPAbpUserConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/ITPAbpUserConfiguration/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class KekaManagerApprovalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateKekaManagerApprovalInput | undefined): Observable<KekaManagerApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<KekaManagerApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaManagerApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOnProjectUpdate(body: CreateKekaManagerApprovalOnProjectUpdateInput | undefined): Observable<KekaManagerApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/CreateOnProjectUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOnProjectUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOnProjectUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto>;
        }));
    }

    protected processCreateOnProjectUpdate(response: HttpResponseBase): Observable<KekaManagerApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaManagerApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<KekaManagerApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<KekaManagerApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaManagerApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param status (optional) 
     * @param projectId (optional) 
     * @param managerId (optional) 
     * @return OK
     */
    getAll(status: KekaManagerApprovalStatus | undefined, projectId: number | undefined, managerId: number | undefined): Observable<KekaManagerApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/GetAll?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (managerId === null)
            throw new globalThis.Error("The parameter 'managerId' cannot be null.");
        else if (managerId !== undefined)
            url_ += "ManagerId=" + encodeURIComponent("" + managerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<KekaManagerApprovalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KekaManagerApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param recentDays (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getUserProjectManagers(filter: string | undefined, userId: number | undefined, recentDays: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfUserProjectManagerDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/GetUserProjectManagers?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (recentDays === null)
            throw new globalThis.Error("The parameter 'recentDays' cannot be null.");
        else if (recentDays !== undefined)
            url_ += "RecentDays=" + encodeURIComponent("" + recentDays) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectManagers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectManagers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserProjectManagerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserProjectManagerDto>;
        }));
    }

    protected processGetUserProjectManagers(response: HttpResponseBase): Observable<PagedResultDtoOfUserProjectManagerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProjectManagerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPendingForMe(): Observable<KekaManagerApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/GetPendingForMe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingForMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingForMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto[]>;
        }));
    }

    protected processGetPendingForMe(response: HttpResponseBase): Observable<KekaManagerApprovalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KekaManagerApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approve(body: ApproveKekaManagerApprovalInput | undefined): Observable<KekaManagerApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<KekaManagerApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaManagerApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reject(body: RejectKekaManagerApprovalInput | undefined): Observable<KekaManagerApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaManagerApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaManagerApprovalDto>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<KekaManagerApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaManagerApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkApprove(body: BulkKekaManagerApprovalInput | undefined): Observable<BulkKekaManagerApprovalResultDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/BulkApprove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkKekaManagerApprovalResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkKekaManagerApprovalResultDto>;
        }));
    }

    protected processBulkApprove(response: HttpResponseBase): Observable<BulkKekaManagerApprovalResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkKekaManagerApprovalResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkReject(body: BulkKekaManagerApprovalInput | undefined): Observable<BulkKekaManagerApprovalResultDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/BulkReject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkKekaManagerApprovalResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkKekaManagerApprovalResultDto>;
        }));
    }

    protected processBulkReject(response: HttpResponseBase): Observable<BulkKekaManagerApprovalResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkKekaManagerApprovalResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getApprovers(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/GetApprovers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetApprovers(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeApprovers(body: ChangeKekaApproversInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/ChangeApprovers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeApprovers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyAccess(): Observable<KekaAccessDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/GetMyAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaAccessDto>;
        }));
    }

    protected processGetMyAccess(response: HttpResponseBase): Observable<KekaAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaAccessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSyncReport(): Observable<KekaSyncReportDto> {
        let url_ = this.baseUrl + "/api/services/app/KekaManagerApproval/GetSyncReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSyncReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSyncReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KekaSyncReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KekaSyncReportDto>;
        }));
    }

    protected processGetSyncReport(response: HttpResponseBase): Observable<KekaSyncReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KekaSyncReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return OK
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new globalThis.Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new globalThis.Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter === null)
            throw new globalThis.Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUserLocationInfo(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetUserLocationInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LocationTracking/GetUserLocationInfo?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLocationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLocationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserLocationInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserLocationInfoDto[]>;
        }));
    }

    protected processGetUserLocationInfo(response: HttpResponseBase): Observable<GetUserLocationInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserLocationInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param isManager (optional) 
     * @param userIDFromScreenshotSignalR (optional) 
     * @param isDashboard (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getUserLocationInfoWithWorkType(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, orgUnitId: (number | undefined)[] | undefined, isManager: boolean | undefined, userIDFromScreenshotSignalR: number | undefined, isDashboard: boolean | undefined, timeZoneOffset: number | undefined): Observable<GetUserLocationInfoWithWorkDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LocationTracking/GetUserLocationInfoWithWorkType?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (userIDFromScreenshotSignalR === null)
            throw new globalThis.Error("The parameter 'userIDFromScreenshotSignalR' cannot be null.");
        else if (userIDFromScreenshotSignalR !== undefined)
            url_ += "userIDFromScreenshotSignalR=" + encodeURIComponent("" + userIDFromScreenshotSignalR) + "&";
        if (isDashboard === null)
            throw new globalThis.Error("The parameter 'isDashboard' cannot be null.");
        else if (isDashboard !== undefined)
            url_ += "IsDashboard=" + encodeURIComponent("" + isDashboard) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLocationInfoWithWorkType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLocationInfoWithWorkType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserLocationInfoWithWorkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserLocationInfoWithWorkDto[]>;
        }));
    }

    protected processGetUserLocationInfoWithWorkType(response: HttpResponseBase): Observable<GetUserLocationInfoWithWorkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserLocationInfoWithWorkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUserLocationTrackingViewMoreDetail(userId: number | undefined): Observable<UserLocationTrackingViewMoreDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/LocationTracking/GetUserLocationTrackingViewMoreDetail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLocationTrackingViewMoreDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLocationTrackingViewMoreDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLocationTrackingViewMoreDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLocationTrackingViewMoreDetail[]>;
        }));
    }

    protected processGetUserLocationTrackingViewMoreDetail(response: HttpResponseBase): Observable<UserLocationTrackingViewMoreDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLocationTrackingViewMoreDetail.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManualTimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManualEntry(body: UserActivityTempCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/AddManualEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddManualEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteManualEntry(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/DeleteManualEntry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteManualEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param flag (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getManualTimePendingList(userId: number | undefined, flag: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfPendingTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetManualTimePendingList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualTimePendingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualTimePendingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPendingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPendingTimeDto>;
        }));
    }

    protected processGetManualTimePendingList(response: HttpResponseBase): Observable<PagedResultDtoOfPendingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPendingTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getManualTimeDeclinedList(userId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfPendingTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetManualTimeDeclinedList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualTimeDeclinedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualTimeDeclinedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPendingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPendingTimeDto>;
        }));
    }

    protected processGetManualTimeDeclinedList(response: HttpResponseBase): Observable<PagedResultDtoOfPendingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPendingTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getManualTeamTimeDeclinedList(userId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfPendingTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetManualTeamTimeDeclinedList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualTeamTimeDeclinedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualTeamTimeDeclinedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPendingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPendingTimeDto>;
        }));
    }

    protected processGetManualTeamTimeDeclinedList(response: HttpResponseBase): Observable<PagedResultDtoOfPendingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPendingTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getPendingApprovalDecliendCountForTeam(userId: number | undefined): Observable<PendingApproveDeclienCount> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetPendingApprovalDecliendCountForTeam?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApprovalDecliendCountForTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApprovalDecliendCountForTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApproveDeclienCount>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApproveDeclienCount>;
        }));
    }

    protected processGetPendingApprovalDecliendCountForTeam(response: HttpResponseBase): Observable<PendingApproveDeclienCount> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingApproveDeclienCount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getPendingApprovalDecliendCount(userId: number | undefined): Observable<PendingApproveDeclienCount> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetPendingApprovalDecliendCount?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApprovalDecliendCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApprovalDecliendCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApproveDeclienCount>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApproveDeclienCount>;
        }));
    }

    protected processGetPendingApprovalDecliendCount(response: HttpResponseBase): Observable<PendingApproveDeclienCount> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingApproveDeclienCount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param flag (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getManualTeamTimePendingList(userId: number | undefined, flag: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfPendingTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetManualTeamTimePendingList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (flag === null)
            throw new globalThis.Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualTeamTimePendingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualTeamTimePendingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPendingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPendingTimeDto>;
        }));
    }

    protected processGetManualTeamTimePendingList(response: HttpResponseBase): Observable<PagedResultDtoOfPendingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPendingTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getApproveManualTime(userId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfPendingTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetApproveManualTime?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApproveManualTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApproveManualTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPendingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPendingTimeDto>;
        }));
    }

    protected processGetApproveManualTime(response: HttpResponseBase): Observable<PagedResultDtoOfPendingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPendingTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTeamApproveManualTime(userId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfPendingTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetTeamApproveManualTime?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamApproveManualTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamApproveManualTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPendingTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPendingTimeDto>;
        }));
    }

    protected processGetTeamApproveManualTime(response: HttpResponseBase): Observable<PagedResultDtoOfPendingTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPendingTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param approveOrPending (optional) 
     * @return OK
     */
    createApproveOrRejectManualTime(id: number | undefined, approveOrPending: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/CreateApproveOrRejectManualTime?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (approveOrPending === null)
            throw new globalThis.Error("The parameter 'approveOrPending' cannot be null.");
        else if (approveOrPending !== undefined)
            url_ += "approveOrPending=" + encodeURIComponent("" + approveOrPending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateApproveOrRejectManualTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateApproveOrRejectManualTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateApproveOrRejectManualTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param approveOrPending (optional) 
     * @param startIdealTime (optional) 
     * @param endIdealTime (optional) 
     * @return OK
     */
    createApproveOrRejectManualTimeWithDate(id: number | undefined, approveOrPending: number | undefined, startIdealTime: DateTime | undefined, endIdealTime: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/CreateApproveOrRejectManualTimeWithDate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (approveOrPending === null)
            throw new globalThis.Error("The parameter 'approveOrPending' cannot be null.");
        else if (approveOrPending !== undefined)
            url_ += "approveOrPending=" + encodeURIComponent("" + approveOrPending) + "&";
        if (startIdealTime === null)
            throw new globalThis.Error("The parameter 'startIdealTime' cannot be null.");
        else if (startIdealTime !== undefined)
            url_ += "StartIdealTime=" + encodeURIComponent(startIdealTime ? "" + startIdealTime.toString() : "") + "&";
        if (endIdealTime === null)
            throw new globalThis.Error("The parameter 'endIdealTime' cannot be null.");
        else if (endIdealTime !== undefined)
            url_ += "EndIdealTime=" + encodeURIComponent(endIdealTime ? "" + endIdealTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateApproveOrRejectManualTimeWithDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateApproveOrRejectManualTimeWithDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateApproveOrRejectManualTimeWithDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserTempActivityBlob(body: ManualActivityTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/UpdateUserTempActivityBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserTempActivityBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserTempActivityBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserTempActivityBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProductivityJsonBlob(body: ManualActivityTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/UpdateProductivityJsonBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductivityJsonBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductivityJsonBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProductivityJsonBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getProductivityBlobFileName(userId: number | undefined, tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetProductivityBlobFileName?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProductivityBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateProductivityJsonBlobFromDelete(id: number | undefined, body: ManualActivityTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/UpdateProductivityJsonBlobFromDelete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductivityJsonBlobFromDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductivityJsonBlobFromDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProductivityJsonBlobFromDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param approveOrPending (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateApproveOrRejectManualTime(approveOrPending: number | undefined, tenantId: number | undefined, userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/BulkUpdateApproveOrRejectManualTime?";
        if (approveOrPending === null)
            throw new globalThis.Error("The parameter 'approveOrPending' cannot be null.");
        else if (approveOrPending !== undefined)
            url_ += "approveOrPending=" + encodeURIComponent("" + approveOrPending) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateApproveOrRejectManualTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateApproveOrRejectManualTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateApproveOrRejectManualTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param approveOrPending (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateApproveOrRejectManualTimeJob(approveOrPending: number | undefined, tenantId: number | undefined, userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualTime/BulkUpdateApproveOrRejectManualTimeJob?";
        if (approveOrPending === null)
            throw new globalThis.Error("The parameter 'approveOrPending' cannot be null.");
        else if (approveOrPending !== undefined)
            url_ += "approveOrPending=" + encodeURIComponent("" + approveOrPending) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateApproveOrRejectManualTimeJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateApproveOrRejectManualTimeJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateApproveOrRejectManualTimeJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MemberAllocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getMemberAllocationList(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfMemberAllocationListDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/GetMemberAllocationList?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberAllocationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberAllocationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMemberAllocationListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMemberAllocationListDto>;
        }));
    }

    protected processGetMemberAllocationList(response: HttpResponseBase): Observable<PagedResultDtoOfMemberAllocationListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMemberAllocationListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMemberAllocationDetail(id: number | undefined): Observable<MemberAllocationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/GetMemberAllocationDetail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberAllocationDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberAllocationDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberAllocationDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberAllocationDetailDto>;
        }));
    }

    protected processGetMemberAllocationDetail(response: HttpResponseBase): Observable<MemberAllocationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberAllocationDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUserSummary(body: CreateOrUpdateUserSummaryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/CreateOrUpdateUserSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUserSummary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllocationsByUserId(id: number | undefined): Observable<UserProjectAllocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/GetAllocationsByUserId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllocationsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllocationsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectAllocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectAllocationDto[]>;
        }));
    }

    protected processGetAllocationsByUserId(response: HttpResponseBase): Observable<UserProjectAllocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectAllocationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateAllocation(body: CreateOrUpdateUserProjectAllocationDto | undefined): Observable<UserProjectAllocationDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/CreateOrUpdateAllocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectAllocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectAllocationDto>;
        }));
    }

    protected processCreateOrUpdateAllocation(response: HttpResponseBase): Observable<UserProjectAllocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectAllocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    deleteAllocation(id: number | undefined, userId: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/DeleteAllocation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadUserCv(body: UploadUserCvDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/UploadUserCv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadUserCv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadUserCv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadUserCv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteUserCv(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/DeleteUserCv?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserCv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserCv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserCv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getProjectLookup(filter: string | undefined): Observable<MemberAllocationProjectLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MemberAllocation/GetProjectLookup?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberAllocationProjectLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberAllocationProjectLookupDto[]>;
        }));
    }

    protected processGetProjectLookup(response: HttpResponseBase): Observable<MemberAllocationProjectLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberAllocationProjectLookupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MobileNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMobileNotification(body: MobileNotificationInputDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileNotification/CreateMobileNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMobileNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMobileNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMobileNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getAllMobileNotification(tenantID: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileNotification/GetAllMobileNotification?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "TenantID=" + encodeURIComponent("" + tenantID) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMobileNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMobileNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllMobileNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @param userId (optional) 
     * @return OK
     */
    readMobileNotifications(tenantID: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileNotification/ReadMobileNotifications?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadMobileNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadMobileNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReadMobileNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param ids (optional) 
     * @return OK
     */
    deleteMobileNotifications(tenantId: number | undefined, userId: number | undefined, ids: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileNotification/DeleteMobileNotifications?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMobileNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMobileNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMobileNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @param userId (optional) 
     * @return OK
     */
    unReadMobileNotificationsCount(tenantID: number | undefined, userId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MobileNotification/UnReadMobileNotificationsCount?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnReadMobileNotificationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnReadMobileNotificationsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnReadMobileNotificationsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationHubServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateInstallation(body: DeviceInstallation | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/CreateOrUpdateInstallation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateInstallation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateInstallation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateOrUpdateInstallation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param installationId (optional) 
     * @return OK
     */
    deleteInstallationById(installationId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/DeleteInstallationById?";
        if (installationId === null)
            throw new globalThis.Error("The parameter 'installationId' cannot be null.");
        else if (installationId !== undefined)
            url_ += "installationId=" + encodeURIComponent("" + installationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInstallationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInstallationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteInstallationById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestNotification(body: NotificationRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/RequestNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRequestNotification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payloadStr (optional) 
     * @param badge (optional) 
     * @return OK
     */
    iTPPayloadStringForIOS(payloadStr: string | undefined, badge: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/ITPPayloadStringForIOS?";
        if (payloadStr === null)
            throw new globalThis.Error("The parameter 'payloadStr' cannot be null.");
        else if (payloadStr !== undefined)
            url_ += "payloadStr=" + encodeURIComponent("" + payloadStr) + "&";
        if (badge === null)
            throw new globalThis.Error("The parameter 'badge' cannot be null.");
        else if (badge !== undefined)
            url_ += "badge=" + encodeURIComponent("" + badge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processITPPayloadStringForIOS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processITPPayloadStringForIOS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processITPPayloadStringForIOS(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payloadStr (optional) 
     * @return OK
     */
    iTPPayloadStringForAndroid(payloadStr: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/ITPPayloadStringForAndroid?";
        if (payloadStr === null)
            throw new globalThis.Error("The parameter 'payloadStr' cannot be null.");
        else if (payloadStr !== undefined)
            url_ += "payloadStr=" + encodeURIComponent("" + payloadStr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processITPPayloadStringForAndroid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processITPPayloadStringForAndroid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processITPPayloadStringForAndroid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param message (optional) 
     * @return OK
     */
    azureHubNotifyToUser(tenantId: number | undefined, userId: number | undefined, message: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/AzureHubNotifyToUser?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "Message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAzureHubNotifyToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAzureHubNotifyToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAzureHubNotifyToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param body (optional) 
     * @return OK
     */
    triggerAzureHubNotification(message: string | undefined, body: AzureNotificationUser | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/TriggerAzureHubNotification?";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "Message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerAzureHubNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerAzureHubNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerAzureHubNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateAzureHubNotification(body: AzureNotificationUserInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationHub/CreateOrUpdateAzureHubNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAzureHubNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAzureHubNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateAzureHubNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OnBoardingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: OnBoardingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnBoarding/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantName (optional) 
     * @return OK
     */
    checkTenantNamePresent(tenantName: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OnBoarding/CheckTenantNamePresent?";
        if (tenantName === null)
            throw new globalThis.Error("The parameter 'tenantName' cannot be null.");
        else if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTenantNamePresent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTenantNamePresent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckTenantNamePresent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orgnizationName (optional) 
     * @return OK
     */
    updateTenancyName(orgnizationName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnBoarding/UpdateTenancyName?";
        if (orgnizationName === null)
            throw new globalThis.Error("The parameter 'orgnizationName' cannot be null.");
        else if (orgnizationName !== undefined)
            url_ += "orgnizationName=" + encodeURIComponent("" + orgnizationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenancyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenancyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenancyName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTeamSizeForTableDropdown(): Observable<CommonNameIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OnBoarding/GetAllTeamSizeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTeamSizeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTeamSizeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNameIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNameIdDto[]>;
        }));
    }

    protected processGetAllTeamSizeForTableDropdown(response: HttpResponseBase): Observable<CommonNameIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNameIdDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getOrganizationUnits(filter: string | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOrganizationUnitUsers(id: number | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @param filter (optional) 
     * @return OK
     */
    updatedGetOrganizationUnitUsers(input: number | undefined, filter: string | undefined): Observable<OrganizationUnitUserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdatedGetOrganizationUnitUsers?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatedGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatedGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitUserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitUserListDto[]>;
        }));
    }

    protected processUpdatedGetOrganizationUnitUsers(response: HttpResponseBase): Observable<OrganizationUnitUserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitUserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getDesignationUnits(filter: string | undefined): Observable<ListResultDtoOfDesignationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetDesignationUnits?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDesignationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDesignationUnitDto>;
        }));
    }

    protected processGetDesignationUnits(response: HttpResponseBase): Observable<ListResultDtoOfDesignationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDesignationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @param filter (optional) 
     * @return OK
     */
    updatedGetDesignationUnitUsers(input: number | undefined, filter: string | undefined): Observable<DesignationUnitUserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdatedGetDesignationUnitUsers?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatedGetDesignationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatedGetDesignationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationUnitUserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationUnitUserListDto[]>;
        }));
    }

    protected processUpdatedGetDesignationUnitUsers(response: HttpResponseBase): Observable<DesignationUnitUserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignationUnitUserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createDesignationUnit(body: CreateDesignationUnitInput | undefined): Observable<DesignationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateDesignationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDesignationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDesignationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationUnitDto>;
        }));
    }

    protected processCreateDesignationUnit(response: HttpResponseBase): Observable<DesignationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDesignationUnit(body: UpdateDesignationUnitInput | undefined): Observable<DesignationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateDesignationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDesignationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDesignationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationUnitDto>;
        }));
    }

    protected processUpdateDesignationUnit(response: HttpResponseBase): Observable<DesignationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteDesignationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteDesignationUnit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDesignationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDesignationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDesignationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addUsersToDesignationUnit(body: UsersToDesignationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToDesignationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToDesignationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToDesignationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToDesignationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @param filter (optional) 
     * @return OK
     */
    updateDesignationFilterUser(input: number | undefined, filter: string | undefined): Observable<NameValueOrganization[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateDesignationFilterUser?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDesignationFilterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDesignationFilterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOrganization[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOrganization[]>;
        }));
    }

    protected processUpdateDesignationFilterUser(response: HttpResponseBase): Observable<NameValueOrganization[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOrganization.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return OK
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new globalThis.Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return OK
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new globalThis.Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    filterUser(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueOrganization> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FilterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueOrganization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueOrganization>;
        }));
    }

    protected processFilterUser(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueOrganization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueOrganization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @param filter (optional) 
     * @return OK
     */
    updateFilterUser(input: number | undefined, filter: string | undefined): Observable<NameValueOrganization[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateFilterUser?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOrganization[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOrganization[]>;
        }));
    }

    protected processUpdateFilterUser(response: HttpResponseBase): Observable<NameValueOrganization[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOrganization.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getOrganizationUnitByUserId(tenantId: number | undefined, userId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitByUserId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOrganizationUnitByUserId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OutlookCalendarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userID (optional) 
     * @return OK
     */
    checkIfOutlookIsAuthorized(userID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/CheckIfOutlookIsAuthorized?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfOutlookIsAuthorized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfOutlookIsAuthorized(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfOutlookIsAuthorized(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @param emailAddress (optional) 
     * @return OK
     */
    checkIfMicrosoftLogin(userID: number | undefined, emailAddress: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/CheckIfMicrosoftLogin?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfMicrosoftLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfMicrosoftLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfMicrosoftLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @return OK
     */
    getOutlookUserEmail(userID: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/GetOutlookUserEmail?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutlookUserEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutlookUserEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOutlookUserEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getLinkedOutlookAccounts(userId: number | undefined): Observable<OutlookLinkedAccountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/GetLinkedOutlookAccounts?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedOutlookAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedOutlookAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutlookLinkedAccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutlookLinkedAccountDto[]>;
        }));
    }

    protected processGetLinkedOutlookAccounts(response: HttpResponseBase): Observable<OutlookLinkedAccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutlookLinkedAccountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    setActiveOutlookAccount(userId: number | undefined, accountId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/SetActiveOutlookAccount?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetActiveOutlookAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetActiveOutlookAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetActiveOutlookAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    deleteOutlookAccount(userId: number | undefined, accountId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/DeleteOutlookAccount?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutlookAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutlookAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteOutlookAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @return OK
     */
    deleteOutlookAccountByUserId(userID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/DeleteOutlookAccountByUserId?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutlookAccountByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutlookAccountByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteOutlookAccountByUserId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @return OK
     */
    getAuthorizationRequestUrl(state: string | undefined): Observable<OutlookAuthUrlResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/GetAuthorizationRequestUrl?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationRequestUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationRequestUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutlookAuthUrlResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutlookAuthUrlResponseDto>;
        }));
    }

    protected processGetAuthorizationRequestUrl(response: HttpResponseBase): Observable<OutlookAuthUrlResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutlookAuthUrlResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param authCode (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getAccessTokenFromCode(authCode: string | undefined, userId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/GetAccessTokenFromCode?";
        if (authCode === null)
            throw new globalThis.Error("The parameter 'authCode' cannot be null.");
        else if (authCode !== undefined)
            url_ += "AuthCode=" + encodeURIComponent("" + authCode) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessTokenFromCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessTokenFromCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAccessTokenFromCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    storeUserTokenInfo(body: OutlookTokenInfoDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/StoreUserTokenInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreUserTokenInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreUserTokenInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processStoreUserTokenInfo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createEvents(body: OutlookEventWithUserInputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/CreateEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateEvents(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEventSeries(body: OutlookEventWithUserInputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/UpdateEventSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateEventSeries(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @param systemEventID (optional) 
     * @param providerEventID (optional) 
     * @return OK
     */
    deleteEvent(email: string | undefined, userId: number | undefined, systemEventID: number | undefined, providerEventID: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/DeleteEvent?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (systemEventID === null)
            throw new globalThis.Error("The parameter 'systemEventID' cannot be null.");
        else if (systemEventID !== undefined)
            url_ += "SystemEventID=" + encodeURIComponent("" + systemEventID) + "&";
        if (providerEventID === null)
            throw new globalThis.Error("The parameter 'providerEventID' cannot be null.");
        else if (providerEventID !== undefined)
            url_ += "ProviderEventID=" + encodeURIComponent("" + providerEventID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOutlookEvent(body: OutlookEventWithUserInputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/UpdateOutlookEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOutlookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOutlookEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateOutlookEvent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @param systemEventID (optional) 
     * @param providerEventID (optional) 
     * @return OK
     */
    deleteOutlookEvent(email: string | undefined, userId: number | undefined, systemEventID: number | undefined, providerEventID: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/DeleteOutlookEvent?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (systemEventID === null)
            throw new globalThis.Error("The parameter 'systemEventID' cannot be null.");
        else if (systemEventID !== undefined)
            url_ += "SystemEventID=" + encodeURIComponent("" + systemEventID) + "&";
        if (providerEventID === null)
            throw new globalThis.Error("The parameter 'providerEventID' cannot be null.");
        else if (providerEventID !== undefined)
            url_ += "ProviderEventID=" + encodeURIComponent("" + providerEventID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutlookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutlookEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteOutlookEvent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @return OK
     */
    fetchAndSaveEventsInUserTable(userID: number | undefined): Observable<UserOutlookCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OutlookCalendar/FetchAndSaveEventsInUserTable?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchAndSaveEventsInUserTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchAndSaveEventsInUserTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOutlookCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOutlookCalendarEventDto[]>;
        }));
    }

    protected processFetchAndSaveEventsInUserTable(response: HttpResponseBase): Observable<UserOutlookCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOutlookCalendarEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @param currencyCode (optional) 
     * @return OK
     */
    getPaymentInfo(upgradeEditionId: number | undefined, currencyCode: string | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId === null)
            throw new globalThis.Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        if (currencyCode === null)
            throw new globalThis.Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "CurrencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfoDto>;
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getPaymentHistory(sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param recurringPaymentsEnabled (optional) 
     * @return OK
     */
    getActiveGateways(recurringPaymentsEnabled: boolean | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled === null)
            throw new globalThis.Error("The parameter 'recurringPaymentsEnabled' cannot be null.");
        else if (recurringPaymentsEnabled !== undefined)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentGatewayModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentGatewayModel[]>;
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    buyNowSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    upgradeSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    extendSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    paymentFailed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return OK
     */
    switchBetweenFreeEditions(upgradeEditionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/SwitchBetweenFreeEditions?";
        if (upgradeEditionId === null)
            throw new globalThis.Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchBetweenFreeEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchBetweenFreeEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitchBetweenFreeEditions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    upgradeSubscriptionCostsLessThenMinAmount(editionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSubscriptionCostsLessThenMinAmount?";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeSubscriptionCostsLessThenMinAmount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    hasAnyPayment(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Payment/HasAnyPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAnyPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAnyPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAnyPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param paymentId (optional) 
     * @param paypalOrderId (optional) 
     * @return OK
     */
    confirmPayment(paymentId: number | undefined, paypalOrderId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalOrderId === null)
            throw new globalThis.Error("The parameter 'paypalOrderId' cannot be null.");
        else if (paypalOrderId !== undefined)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayPalConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayPalConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAllPermissions(tenantId: number | undefined): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductivityBarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getMonthlyProductivityBarData(): Observable<ConvertMonthlyCalculatedDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetMonthlyProductivityBarData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyProductivityBarData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyProductivityBarData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvertMonthlyCalculatedDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvertMonthlyCalculatedDataDto[]>;
        }));
    }

    protected processGetMonthlyProductivityBarData(response: HttpResponseBase): Observable<ConvertMonthlyCalculatedDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConvertMonthlyCalculatedDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param passMinute (optional) 
     * @param filterStartDate (optional) 
     * @param filterEndDate (optional) 
     * @param isBagroundJobCall (optional) 
     * @param timeZoneOffset (optional) 
     * @param currDate (optional) 
     * @param isMidNightJob (optional) 
     * @return OK
     */
    getWeeklyProductiveBarData(userId: number | undefined, tenantId: number | undefined, passMinute: number | undefined, filterStartDate: DateTime | undefined, filterEndDate: DateTime | undefined, isBagroundJobCall: boolean | undefined, timeZoneOffset: number | undefined, currDate: DateTime | undefined, isMidNightJob: boolean | undefined): Observable<ConvertWeeklyDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetWeeklyProductiveBarData?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (passMinute === null)
            throw new globalThis.Error("The parameter 'passMinute' cannot be null.");
        else if (passMinute !== undefined)
            url_ += "PassMinute=" + encodeURIComponent("" + passMinute) + "&";
        if (filterStartDate === null)
            throw new globalThis.Error("The parameter 'filterStartDate' cannot be null.");
        else if (filterStartDate !== undefined)
            url_ += "FilterStartDate=" + encodeURIComponent(filterStartDate ? "" + filterStartDate.toString() : "") + "&";
        if (filterEndDate === null)
            throw new globalThis.Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "FilterEndDate=" + encodeURIComponent(filterEndDate ? "" + filterEndDate.toString() : "") + "&";
        if (isBagroundJobCall === null)
            throw new globalThis.Error("The parameter 'isBagroundJobCall' cannot be null.");
        else if (isBagroundJobCall !== undefined)
            url_ += "IsBagroundJobCall=" + encodeURIComponent("" + isBagroundJobCall) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (isMidNightJob === null)
            throw new globalThis.Error("The parameter 'isMidNightJob' cannot be null.");
        else if (isMidNightJob !== undefined)
            url_ += "IsMidNightJob=" + encodeURIComponent("" + isMidNightJob) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeeklyProductiveBarData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeeklyProductiveBarData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvertWeeklyDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvertWeeklyDataDto[]>;
        }));
    }

    protected processGetWeeklyProductiveBarData(response: HttpResponseBase): Observable<ConvertWeeklyDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConvertWeeklyDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportSpan (optional) 
     * @return OK
     */
    sendEmail(reportSpan: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/SendEmail?";
        if (reportSpan === null)
            throw new globalThis.Error("The parameter 'reportSpan' cannot be null.");
        else if (reportSpan !== undefined)
            url_ += "reportSpan=" + encodeURIComponent("" + reportSpan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param passMinute (optional) 
     * @param filterStartDate (optional) 
     * @param filterEndDate (optional) 
     * @param isBagroundJobCall (optional) 
     * @param timeZoneOffset (optional) 
     * @param currDate (optional) 
     * @param isMidNightJob (optional) 
     * @return OK
     */
    getProductivityBarInfo(userId: number | undefined, tenantId: number | undefined, passMinute: number | undefined, filterStartDate: DateTime | undefined, filterEndDate: DateTime | undefined, isBagroundJobCall: boolean | undefined, timeZoneOffset: number | undefined, currDate: DateTime | undefined, isMidNightJob: boolean | undefined): Observable<ProductivityBarDetailInfo> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetProductivityBarInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (passMinute === null)
            throw new globalThis.Error("The parameter 'passMinute' cannot be null.");
        else if (passMinute !== undefined)
            url_ += "PassMinute=" + encodeURIComponent("" + passMinute) + "&";
        if (filterStartDate === null)
            throw new globalThis.Error("The parameter 'filterStartDate' cannot be null.");
        else if (filterStartDate !== undefined)
            url_ += "FilterStartDate=" + encodeURIComponent(filterStartDate ? "" + filterStartDate.toString() : "") + "&";
        if (filterEndDate === null)
            throw new globalThis.Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "FilterEndDate=" + encodeURIComponent(filterEndDate ? "" + filterEndDate.toString() : "") + "&";
        if (isBagroundJobCall === null)
            throw new globalThis.Error("The parameter 'isBagroundJobCall' cannot be null.");
        else if (isBagroundJobCall !== undefined)
            url_ += "IsBagroundJobCall=" + encodeURIComponent("" + isBagroundJobCall) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (isMidNightJob === null)
            throw new globalThis.Error("The parameter 'isMidNightJob' cannot be null.");
        else if (isMidNightJob !== undefined)
            url_ += "IsMidNightJob=" + encodeURIComponent("" + isMidNightJob) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityBarInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityBarInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityBarDetailInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityBarDetailInfo>;
        }));
    }

    protected processGetProductivityBarInfo(response: HttpResponseBase): Observable<ProductivityBarDetailInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductivityBarDetailInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isAllTypes (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffSet (optional) 
     * @return OK
     */
    getTypeBaseApplicationSpendTime(tenantId: number | undefined, userId: number | undefined, productivityTypes: ProductivityTypes, isAllTypes: boolean | undefined, calenderDate: DateTime | undefined, timeZoneOffSet: number | undefined): Observable<ApplicationAndSpendTimeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetTypeBaseApplicationSpendTime?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (productivityTypes === undefined || productivityTypes === null)
            throw new globalThis.Error("The parameter 'productivityTypes' must be defined and cannot be null.");
        else
            url_ += "ProductivityTypes=" + encodeURIComponent("" + productivityTypes) + "&";
        if (isAllTypes === null)
            throw new globalThis.Error("The parameter 'isAllTypes' cannot be null.");
        else if (isAllTypes !== undefined)
            url_ += "IsAllTypes=" + encodeURIComponent("" + isAllTypes) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffSet === null)
            throw new globalThis.Error("The parameter 'timeZoneOffSet' cannot be null.");
        else if (timeZoneOffSet !== undefined)
            url_ += "TimeZoneOffSet=" + encodeURIComponent("" + timeZoneOffSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeBaseApplicationSpendTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeBaseApplicationSpendTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationAndSpendTimeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationAndSpendTimeDto[]>;
        }));
    }

    protected processGetTypeBaseApplicationSpendTime(response: HttpResponseBase): Observable<ApplicationAndSpendTimeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationAndSpendTimeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneSet (optional) 
     * @return OK
     */
    getUserWiseProductiveUnProductiveAndNuetralData(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneSet: number | undefined): Observable<UserWiseProductiveUnproductiveAndNuetralTimeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetUserWiseProductiveUnProductiveAndNuetralData?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "calenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneSet === null)
            throw new globalThis.Error("The parameter 'timeZoneSet' cannot be null.");
        else if (timeZoneSet !== undefined)
            url_ += "timeZoneSet=" + encodeURIComponent("" + timeZoneSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWiseProductiveUnProductiveAndNuetralData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWiseProductiveUnProductiveAndNuetralData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWiseProductiveUnproductiveAndNuetralTimeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWiseProductiveUnproductiveAndNuetralTimeDto[]>;
        }));
    }

    protected processGetUserWiseProductiveUnProductiveAndNuetralData(response: HttpResponseBase): Observable<UserWiseProductiveUnproductiveAndNuetralTimeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWiseProductiveUnproductiveAndNuetralTimeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isAllTypes (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffSet (optional) 
     * @return OK
     */
    getTypeWiseCategotyAndApplication(tenantId: number | undefined, userId: number | undefined, productivityTypes: ProductivityTypes, isAllTypes: boolean | undefined, calenderDate: DateTime | undefined, timeZoneOffSet: number | undefined): Observable<ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetTypeWiseCategotyAndApplication?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (productivityTypes === undefined || productivityTypes === null)
            throw new globalThis.Error("The parameter 'productivityTypes' must be defined and cannot be null.");
        else
            url_ += "ProductivityTypes=" + encodeURIComponent("" + productivityTypes) + "&";
        if (isAllTypes === null)
            throw new globalThis.Error("The parameter 'isAllTypes' cannot be null.");
        else if (isAllTypes !== undefined)
            url_ += "IsAllTypes=" + encodeURIComponent("" + isAllTypes) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffSet === null)
            throw new globalThis.Error("The parameter 'timeZoneOffSet' cannot be null.");
        else if (timeZoneOffSet !== undefined)
            url_ += "TimeZoneOffSet=" + encodeURIComponent("" + timeZoneOffSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeWiseCategotyAndApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeWiseCategotyAndApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto[]>;
        }));
    }

    protected processGetTypeWiseCategotyAndApplication(response: HttpResponseBase): Observable<ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateProperPercentage(body: ProdData[] | undefined): Observable<ProddataResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/CalculateProperPercentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateProperPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateProperPercentage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProddataResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProddataResult[]>;
        }));
    }

    protected processCalculateProperPercentage(response: HttpResponseBase): Observable<ProddataResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProddataResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param passMinute (optional) 
     * @param filterStartDate (optional) 
     * @param filterEndDate (optional) 
     * @param isBagroundJobCall (optional) 
     * @param timeZoneOffset (optional) 
     * @param currDate (optional) 
     * @param isMidNightJob (optional) 
     * @return OK
     */
    getDaywiseProductivityBarInfo(userId: number | undefined, tenantId: number | undefined, passMinute: number | undefined, filterStartDate: DateTime | undefined, filterEndDate: DateTime | undefined, isBagroundJobCall: boolean | undefined, timeZoneOffset: number | undefined, currDate: DateTime | undefined, isMidNightJob: boolean | undefined): Observable<ProductivityCalculationWeekDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetDaywiseProductivityBarInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (passMinute === null)
            throw new globalThis.Error("The parameter 'passMinute' cannot be null.");
        else if (passMinute !== undefined)
            url_ += "PassMinute=" + encodeURIComponent("" + passMinute) + "&";
        if (filterStartDate === null)
            throw new globalThis.Error("The parameter 'filterStartDate' cannot be null.");
        else if (filterStartDate !== undefined)
            url_ += "FilterStartDate=" + encodeURIComponent(filterStartDate ? "" + filterStartDate.toString() : "") + "&";
        if (filterEndDate === null)
            throw new globalThis.Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "FilterEndDate=" + encodeURIComponent(filterEndDate ? "" + filterEndDate.toString() : "") + "&";
        if (isBagroundJobCall === null)
            throw new globalThis.Error("The parameter 'isBagroundJobCall' cannot be null.");
        else if (isBagroundJobCall !== undefined)
            url_ += "IsBagroundJobCall=" + encodeURIComponent("" + isBagroundJobCall) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (isMidNightJob === null)
            throw new globalThis.Error("The parameter 'isMidNightJob' cannot be null.");
        else if (isMidNightJob !== undefined)
            url_ += "IsMidNightJob=" + encodeURIComponent("" + isMidNightJob) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDaywiseProductivityBarInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDaywiseProductivityBarInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityCalculationWeekDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityCalculationWeekDto[]>;
        }));
    }

    protected processGetDaywiseProductivityBarInfo(response: HttpResponseBase): Observable<ProductivityCalculationWeekDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductivityCalculationWeekDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param passMinute (optional) 
     * @param filterType (optional) 
     * @param filterStartDate (optional) 
     * @param filterEndDate (optional) 
     * @param currDate (optional) 
     * @return OK
     */
    getWeeklyProductivityBarInfo(userId: number | undefined, tenantId: number | undefined, passMinute: number | undefined, filterType: string | undefined, filterStartDate: DateTime | undefined, filterEndDate: DateTime | undefined, currDate: DateTime | undefined): Observable<ProductivityChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetWeeklyProductivityBarInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (passMinute === null)
            throw new globalThis.Error("The parameter 'passMinute' cannot be null.");
        else if (passMinute !== undefined)
            url_ += "PassMinute=" + encodeURIComponent("" + passMinute) + "&";
        if (filterType === null)
            throw new globalThis.Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (filterStartDate === null)
            throw new globalThis.Error("The parameter 'filterStartDate' cannot be null.");
        else if (filterStartDate !== undefined)
            url_ += "FilterStartDate=" + encodeURIComponent(filterStartDate ? "" + filterStartDate.toString() : "") + "&";
        if (filterEndDate === null)
            throw new globalThis.Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "FilterEndDate=" + encodeURIComponent(filterEndDate ? "" + filterEndDate.toString() : "") + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "currDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeeklyProductivityBarInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeeklyProductivityBarInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityChartDto[]>;
        }));
    }

    protected processGetWeeklyProductivityBarInfo(response: HttpResponseBase): Observable<ProductivityChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductivityChartDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param fromDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    calenderMontlyDataData(tenantId: number | undefined, userId: number | undefined, fromDate: DateTime | undefined, endDate: DateTime | undefined): Observable<MonthlyCalculationData[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/CalenderMontlyDataData?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalenderMontlyDataData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalenderMontlyDataData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyCalculationData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyCalculationData[]>;
        }));
    }

    protected processCalenderMontlyDataData(response: HttpResponseBase): Observable<MonthlyCalculationData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyCalculationData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentDate (optional) 
     * @param body (optional) 
     * @return OK
     */
    workingDayChecker(currentDate: DateTime | undefined, body: UserWorkDaySetting | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/WorkingDayChecker?";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkingDayChecker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkingDayChecker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWorkingDayChecker(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param dateList (optional) 
     * @return OK
     */
    getCalCulatedUsersTimeAndAttendanceFiles(tenantId: number | undefined, fileType: FileType, dateList: DateTime[] | undefined): Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductivityBar/GetCalCulatedUsersTimeAndAttendanceFiles?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fileType === undefined || fileType === null)
            throw new globalThis.Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (dateList === null)
            throw new globalThis.Error("The parameter 'dateList' cannot be null.");
        else if (dateList !== undefined)
            dateList && dateList.forEach(item_ => { url_ += "dateList=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalCulatedUsersTimeAndAttendanceFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalCulatedUsersTimeAndAttendanceFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]>;
        }));
    }

    protected processGetCalCulatedUsersTimeAndAttendanceFiles(response: HttpResponseBase): Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTimeAndAttendanceUserDaillyCalculationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePasswordWithStatus(body: ChangePasswordInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePasswordWithStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePasswordWithStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordWithStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePasswordWithStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @param body (optional) 
     * @return OK
     */
    changePasswordForEditUser(userID: number | undefined, body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePasswordForEditUser?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePasswordForEditUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordForEditUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePasswordForEditUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    getProfilePictureByUserName(username: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username === null)
            throw new globalThis.Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getProfilePictureByUserId(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserId(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param profilePictureId (optional) 
     * @return OK
     */
    getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === null)
            throw new globalThis.Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editMyProfile(body: MyProfileOutput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/EditMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditMyProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    myProfileInfo(): Observable<MyProfileOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/MyProfileInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyProfileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyProfileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyProfileOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyProfileOutput>;
        }));
    }

    protected processMyProfileInfo(response: HttpResponseBase): Observable<MyProfileOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyProfileOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    checkEmail(email: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Profile/CheckEmail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    updateUserProfileImage(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateUserProfileImage?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserProfileImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserProfileImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserProfileImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: ProjectCreateOrEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unarchiveExtendedProjects(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/UnarchiveExtendedProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchiveExtendedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchiveExtendedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnarchiveExtendedProjects(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectById(projectId: number | undefined): Observable<ProjectGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectById?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto>;
        }));
    }

    protected processGetProjectById(response: HttpResponseBase): Observable<ProjectGetAllDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectGetAllDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getTeamMemberByprojectId(projectId: number | undefined): Observable<ProjectGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetTeamMemberByprojectId?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamMemberByprojectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamMemberByprojectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto>;
        }));
    }

    protected processGetTeamMemberByprojectId(response: HttpResponseBase): Observable<ProjectGetAllDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectGetAllDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTeamMemberByprojectIdFilterd(projectId: number | undefined, filter: string | undefined): Observable<ProjectTeamGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetTeamMemberByprojectIdFilterd?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamMemberByprojectIdFilterd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamMemberByprojectIdFilterd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTeamGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTeamGetAllDto[]>;
        }));
    }

    protected processGetTeamMemberByprojectIdFilterd(response: HttpResponseBase): Observable<ProjectTeamGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTeamGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getAllProjectsForAddTask(userId: number | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetAllProjectsForAddTask?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsForAddTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsForAddTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetAllProjectsForAddTask(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    getAllProjects(projectType: ProjectType4, filter: string | undefined, isManager: boolean | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetAllProjects?";
        if (projectType === undefined || projectType === null)
            throw new globalThis.Error("The parameter 'projectType' must be defined and cannot be null.");
        else
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetAllProjects(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param projectIdFilter (optional) 
     * @param filter (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    getProjectsByUserIds(userIds: (number | undefined)[] | undefined, projectType: ProjectType5, projectIdFilter: (number | undefined)[] | undefined, filter: string | undefined, isManager: boolean | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsByUserIds?";
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectType === undefined || projectType === null)
            throw new globalThis.Error("The parameter 'projectType' must be defined and cannot be null.");
        else
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (projectIdFilter === null)
            throw new globalThis.Error("The parameter 'projectIdFilter' cannot be null.");
        else if (projectIdFilter !== undefined)
            projectIdFilter && projectIdFilter.forEach(item => { url_ += "ProjectIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsByUserIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsByUserIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetProjectsByUserIds(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param projectIdFilter (optional) 
     * @param filter (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    getProjectsByUserIdForListView(userIds: (number | undefined)[] | undefined, projectTypeForListView: ProjectTypeForListView, projectIdFilter: (number | undefined)[] | undefined, filter: string | undefined, isManager: boolean | undefined): Observable<GetAllProjectForListViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsByUserIdForListView?";
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTypeForListView === undefined || projectTypeForListView === null)
            throw new globalThis.Error("The parameter 'projectTypeForListView' must be defined and cannot be null.");
        else
            url_ += "projectTypeForListView=" + encodeURIComponent("" + projectTypeForListView) + "&";
        if (projectIdFilter === null)
            throw new globalThis.Error("The parameter 'projectIdFilter' cannot be null.");
        else if (projectIdFilter !== undefined)
            projectIdFilter && projectIdFilter.forEach(item => { url_ += "ProjectIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsByUserIdForListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsByUserIdForListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectForListViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectForListViewDto[]>;
        }));
    }

    protected processGetProjectsByUserIdForListView(response: HttpResponseBase): Observable<GetAllProjectForListViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectForListViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param deleteStatus (optional) 
     * @param projectIdFilter (optional) 
     * @return OK
     */
    getProjectsByUserId(userId: number | undefined, deleteStatus: number | undefined, projectIdFilter: (number | undefined)[] | undefined): Observable<ProjectGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        if (projectIdFilter === null)
            throw new globalThis.Error("The parameter 'projectIdFilter' cannot be null.");
        else if (projectIdFilter !== undefined)
            projectIdFilter && projectIdFilter.forEach(item => { url_ += "ProjectIdFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto[]>;
        }));
    }

    protected processGetProjectsByUserId(response: HttpResponseBase): Observable<ProjectGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getMyProjects(deleteStatus: number | undefined): Observable<ProjectGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetMyProjects?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto[]>;
        }));
    }

    protected processGetMyProjects(response: HttpResponseBase): Observable<ProjectGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getProjectByDeleteStatus(deleteStatus: number | undefined): Observable<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectByDeleteStatus?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectByDeleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectByDeleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto[]>;
        }));
    }

    protected processGetProjectByDeleteStatus(response: HttpResponseBase): Observable<ProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param projectId (optional) 
     * @param isEdit (optional) 
     * @return OK
     */
    checkDuplicateProject(name: string | undefined, projectId: number | undefined, isEdit: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Project/CheckDuplicateProject?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (isEdit === null)
            throw new globalThis.Error("The parameter 'isEdit' cannot be null.");
        else if (isEdit !== undefined)
            url_ += "isEdit=" + encodeURIComponent("" + isEdit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicateProject(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    unDeleteProject(projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/UnDeleteProject?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @param name (optional) 
     * @param projIds (optional) 
     * @return OK
     */
    getAllProjectsOnNameFilter(deleteStatus: number | undefined, name: string | undefined, projIds: number[] | undefined, projType: ProjType): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetAllProjectsOnNameFilter?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (projIds === null)
            throw new globalThis.Error("The parameter 'projIds' cannot be null.");
        else if (projIds !== undefined)
            projIds && projIds.forEach(item => { url_ += "projIds=" + encodeURIComponent("" + item) + "&"; });
        if (projType === undefined || projType === null)
            throw new globalThis.Error("The parameter 'projType' must be defined and cannot be null.");
        else
            url_ += "projType=" + encodeURIComponent("" + projType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsOnNameFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsOnNameFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetAllProjectsOnNameFilter(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param deleteStatus (optional) 
     * @return OK
     */
    getProjectsByClientId(clientId: number | undefined, deleteStatus: number | undefined): Observable<ProjectGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsByClientId?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto[]>;
        }));
    }

    protected processGetProjectsByClientId(response: HttpResponseBase): Observable<ProjectGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param deleteStatus (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getProjectsByClientIdFiltered(clientId: number | undefined, deleteStatus: number | undefined, filter: string | undefined): Observable<ProjectGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsByClientIdFiltered?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsByClientIdFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsByClientIdFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectGetAllDto[]>;
        }));
    }

    protected processGetProjectsByClientIdFiltered(response: HttpResponseBase): Observable<ProjectGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    updateStatusProjectArchive(projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateStatusProjectArchive?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusProjectArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusProjectArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusProjectArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    updateStatusProjectUnArchive(projectId: number | undefined): Observable<ProjectRestorMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateStatusProjectUnArchive?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusProjectUnArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusProjectUnArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectRestorMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectRestorMessageDto>;
        }));
    }

    protected processUpdateStatusProjectUnArchive(response: HttpResponseBase): Observable<ProjectRestorMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRestorMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    updateStatusProjectUnDelete(projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateStatusProjectUnDelete?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusProjectUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusProjectUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusProjectUnDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    updateStatusProjectDelete(projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateStatusProjectDelete?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusProjectDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusProjectDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusProjectDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    archiveProjectByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/ArchiveProjectByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveProjectByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveProjectByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveProjectByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unArchiveProjectByList(body: number[] | undefined): Observable<ProjectRestorMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/UnArchiveProjectByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnArchiveProjectByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnArchiveProjectByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectRestorMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectRestorMessageDto[]>;
        }));
    }

    protected processUnArchiveProjectByList(response: HttpResponseBase): Observable<ProjectRestorMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectRestorMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    deleteProjectByList(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectByList?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unDeleteProjectByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/UnDeleteProjectByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteProjectByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteProjectByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteProjectByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param isOnlyMyProject (optional) 
     * @return OK
     */
    dropdownProjectList(userId: number | undefined, tenantId: number | undefined, isOnlyMyProject: boolean | undefined): Observable<DropdownProjectListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/DropdownProjectList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (isOnlyMyProject === null)
            throw new globalThis.Error("The parameter 'isOnlyMyProject' cannot be null.");
        else if (isOnlyMyProject !== undefined)
            url_ += "isOnlyMyProject=" + encodeURIComponent("" + isOnlyMyProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDropdownProjectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDropdownProjectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownProjectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownProjectListDto[]>;
        }));
    }

    protected processDropdownProjectList(response: HttpResponseBase): Observable<DropdownProjectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownProjectListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    mobileGetActiveProjectAndActiveTask(userId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/MobileGetActiveProjectAndActiveTask?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileGetActiveProjectAndActiveTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileGetActiveProjectAndActiveTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMobileGetActiveProjectAndActiveTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isUserProject (optional) 
     * @return OK
     */
    agentGetAllProject(tenantId: number | undefined, userId: number | undefined, isUserProject: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/AgentGetAllProject?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isUserProject === null)
            throw new globalThis.Error("The parameter 'isUserProject' cannot be null.");
        else if (isUserProject !== undefined)
            url_ += "isUserProject=" + encodeURIComponent("" + isUserProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentGetAllProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentGetAllProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAgentGetAllProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param takeCount (optional) 
     * @return OK
     */
    getUserWiseProjectDetails(takeCount: number | undefined): Observable<ProjectDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetUserWiseProjectDetails?";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWiseProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWiseProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDetailsDto[]>;
        }));
    }

    protected processGetUserWiseProjectDetails(response: HttpResponseBase): Observable<ProjectDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param takeCount (optional) 
     * @return OK
     */
    getClientWiseProjectDetails(userId: number | undefined, takeCount: number | undefined): Observable<ProjectDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetClientWiseProjectDetails?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientWiseProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientWiseProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDetailsDto[]>;
        }));
    }

    protected processGetClientWiseProjectDetails(response: HttpResponseBase): Observable<ProjectDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveEndedProjects(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/ArchiveEndedProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveEndedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveEndedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveEndedProjects(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @return OK
     */
    getProjectDropDownForManager(userID: number | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectDropDownForManager?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDropDownForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDropDownForManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetProjectDropDownForManager(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectMemberImages(): Observable<ProjectMemberImagesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectMemberImages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectMemberImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectMemberImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMemberImagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMemberImagesDto[]>;
        }));
    }

    protected processGetProjectMemberImages(response: HttpResponseBase): Observable<ProjectMemberImagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectMemberImagesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getProjectsbyUserIdForOutlook(userId: number | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsbyUserIdForOutlook?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsbyUserIdForOutlook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsbyUserIdForOutlook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetProjectsbyUserIdForOutlook(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    getAllProjectsForListView(projectType: ProjectType6, filter: string | undefined, isManager: boolean | undefined): Observable<GetAllProjectForListViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetAllProjectsForListView?";
        if (projectType === undefined || projectType === null)
            throw new globalThis.Error("The parameter 'projectType' must be defined and cannot be null.");
        else
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsForListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsForListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectForListViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectForListViewDto[]>;
        }));
    }

    protected processGetAllProjectsForListView(response: HttpResponseBase): Observable<GetAllProjectForListViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectForListViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    getAllProjectsForDashboard(projectType: ProjectType7, filter: string | undefined, isManager: boolean | undefined): Observable<GetAllProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetAllProjectsForDashboard?";
        if (projectType === undefined || projectType === null)
            throw new globalThis.Error("The parameter 'projectType' must be defined and cannot be null.");
        else
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsForDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsForDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectDto[]>;
        }));
    }

    protected processGetAllProjectsForDashboard(response: HttpResponseBase): Observable<GetAllProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectWiseApprovalFlow(projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectWiseApprovalFlow?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseApprovalFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseApprovalFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetProjectWiseApprovalFlow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    loginWithGitHub(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Project/LoginWithGitHub";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginWithGitHub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginWithGitHub(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLoginWithGitHub(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReminderSetting(body: UpdateReminderSettingDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateReminderSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReminderSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReminderSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateReminderSetting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getReminderSetting(projectId: number | undefined): Observable<UpdateReminderSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetReminderSetting?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReminderSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReminderSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateReminderSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateReminderSettingDto>;
        }));
    }

    protected processGetReminderSetting(response: HttpResponseBase): Observable<UpdateReminderSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateReminderSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectDocuments(projectId: number | undefined): Observable<ProjectDocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectDocuments?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDocumentDto[]>;
        }));
    }

    protected processGetProjectDocuments(response: HttpResponseBase): Observable<ProjectDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadProjectDocument(body: UploadProjectDocumentInput | undefined): Observable<ProjectDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UploadProjectDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProjectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProjectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDocumentDto>;
        }));
    }

    protected processUploadProjectDocument(response: HttpResponseBase): Observable<ProjectDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    deleteProjectDocument(documentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectDocument?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param taskId (optional) 
     * @return OK
     */
    getAttachmentForUserTasks(userId: number | undefined, tenantId: number | undefined, taskId: number | undefined): Observable<TaskAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAttachmentForUserTasks?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentForUserTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentForUserTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskAttachmentDto[]>;
        }));
    }

    protected processGetAttachmentForUserTasks(response: HttpResponseBase): Observable<TaskAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserProjectTask(body: UserProjectTaskInputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/CreateOrEditUserProjectTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserProjectTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserProjectTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEditUserProjectTask(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param comment (optional) 
     * @return OK
     */
    addCommentUserProjectTask(taskId: number | undefined, comment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/AddCommentUserProjectTask?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (comment === null)
            throw new globalThis.Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCommentUserProjectTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCommentUserProjectTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCommentUserProjectTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param comment (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    addCommentUserProjectTaskViaAgentApp(taskId: number | undefined, comment: string | undefined, userId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/AddCommentUserProjectTaskViaAgentApp?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (comment === null)
            throw new globalThis.Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCommentUserProjectTaskViaAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCommentUserProjectTaskViaAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCommentUserProjectTaskViaAgentApp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getUserProjectTaskLevelComment(taskId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectTaskLevelComment?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskLevelComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskLevelComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetUserProjectTaskLevelComment(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: ProjectTaskCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userProjectTaskId (optional) 
     * @return OK
     */
    deleteCurrentProjectTask(userProjectTaskId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/DeleteCurrentProjectTask?";
        if (userProjectTaskId === null)
            throw new globalThis.Error("The parameter 'userProjectTaskId' cannot be null.");
        else if (userProjectTaskId !== undefined)
            url_ += "userProjectTaskId=" + encodeURIComponent("" + userProjectTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCurrentProjectTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCurrentProjectTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCurrentProjectTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    unDeleteTask(taskId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/UnDeleteTask?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @return OK
     */
    getUserProjectTaskByTaskId(projectTaskId: number | undefined): Observable<UserProjectTaskInputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectTaskByTaskId?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskInputDto>;
        }));
    }

    protected processGetUserProjectTaskByTaskId(response: HttpResponseBase): Observable<UserProjectTaskInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectTaskInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserProjectTaskByTaskIdForMobile(projectTaskId: number | undefined, tenantId: number | undefined): Observable<UserProjectTaskInputDtoForMobile> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectTaskByTaskIdForMobile?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskByTaskIdForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskByTaskIdForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskInputDtoForMobile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskInputDtoForMobile>;
        }));
    }

    protected processGetUserProjectTaskByTaskIdForMobile(response: HttpResponseBase): Observable<UserProjectTaskInputDtoForMobile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectTaskInputDtoForMobile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getTaskIdByTaskInfo(taskId: number | undefined): Observable<TaskInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskIdByTaskInfo?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskIdByTaskInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskIdByTaskInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskInfoDto>;
        }));
    }

    protected processGetTaskIdByTaskInfo(response: HttpResponseBase): Observable<TaskInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getTaskInfoByTaskIdForMobile(taskId: number | undefined, userId: number | undefined, tenantId: number | undefined): Observable<TaskInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskInfoByTaskIdForMobile?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskInfoByTaskIdForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskInfoByTaskIdForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskInfoDto>;
        }));
    }

    protected processGetTaskInfoByTaskIdForMobile(response: HttpResponseBase): Observable<TaskInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taksId (optional) 
     * @return OK
     */
    getTaskById(taksId: number | undefined): Observable<ProjectTaskCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskById?";
        if (taksId === null)
            throw new globalThis.Error("The parameter 'taksId' cannot be null.");
        else if (taksId !== undefined)
            url_ += "TaksId=" + encodeURIComponent("" + taksId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskCreateOrEditDto>;
        }));
    }

    protected processGetTaskById(response: HttpResponseBase): Observable<ProjectTaskCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTaskCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getAllTask(deleteStatus: number | undefined): Observable<ProjectTaskGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAllTask?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskGetAllDto[]>;
        }));
    }

    protected processGetAllTask(response: HttpResponseBase): Observable<ProjectTaskGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllPriority(): Observable<CommonNameIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAllPriority";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNameIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNameIdDto[]>;
        }));
    }

    protected processGetAllPriority(response: HttpResponseBase): Observable<CommonNameIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNameIdDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllActivity(): Observable<CommonNameIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAllActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNameIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNameIdDto[]>;
        }));
    }

    protected processGetAllActivity(response: HttpResponseBase): Observable<CommonNameIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNameIdDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllSeverity(): Observable<CommonNameIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAllSeverity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSeverity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSeverity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNameIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNameIdDto[]>;
        }));
    }

    protected processGetAllSeverity(response: HttpResponseBase): Observable<CommonNameIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNameIdDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTaskState(): Observable<CommonNameIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAllTaskState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNameIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNameIdDto[]>;
        }));
    }

    protected processGetAllTaskState(response: HttpResponseBase): Observable<CommonNameIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNameIdDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTaskType(): Observable<CommonNameIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetAllTaskType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNameIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNameIdDto[]>;
        }));
    }

    protected processGetAllTaskType(response: HttpResponseBase): Observable<CommonNameIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNameIdDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param deleteStatus (optional) 
     * @return OK
     */
    getTaskByUserId(userId: number | undefined, deleteStatus: number | undefined): Observable<ProjectTaskGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskGetAllDto[]>;
        }));
    }

    protected processGetTaskByUserId(response: HttpResponseBase): Observable<ProjectTaskGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param deleteStatus (optional) 
     * @return OK
     */
    getTasksByProjectId(projectId: number | undefined, deleteStatus: number | undefined): Observable<ProjectTaskGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTasksByProjectId?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskGetAllDto[]>;
        }));
    }

    protected processGetTasksByProjectId(response: HttpResponseBase): Observable<ProjectTaskGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param deleteStatus (optional) 
     * @return OK
     */
    getTasksByClientId(clientId: number | undefined, deleteStatus: number | undefined): Observable<ProjectTaskGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTasksByClientId?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskGetAllDto[]>;
        }));
    }

    protected processGetTasksByClientId(response: HttpResponseBase): Observable<ProjectTaskGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getMyTasks(deleteStatus: number | undefined): Observable<ProjectTaskGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetMyTasks?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskGetAllDto[]>;
        }));
    }

    protected processGetMyTasks(response: HttpResponseBase): Observable<ProjectTaskGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getTaskByDeleteStatus(deleteStatus: number | undefined): Observable<ProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskByDeleteStatus?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskByDeleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskByDeleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskDto[]>;
        }));
    }

    protected processGetTaskByDeleteStatus(response: HttpResponseBase): Observable<ProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param projectId (optional) 
     * @param taskId (optional) 
     * @return OK
     */
    checkDuplicateTask(name: string | undefined, projectId: number | undefined, taskId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/CheckDuplicateTask?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicateTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @param takeCount (optional) 
     * @return OK
     */
    getTaskListForParticularUserDashBoard(userID: number | undefined, takeCount: number | undefined): Observable<UserTaskListDashBoard[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskListForParticularUserDashBoard?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskListForParticularUserDashBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskListForParticularUserDashBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTaskListDashBoard[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTaskListDashBoard[]>;
        }));
    }

    protected processGetTaskListForParticularUserDashBoard(response: HttpResponseBase): Observable<UserTaskListDashBoard[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTaskListDashBoard.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param statusId (optional) 
     * @param isTimesheet (optional) 
     * @param oldNew (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getProjectWiseUserTaskListTimeTracking(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, statusId: number | undefined, isTimesheet: boolean | undefined, oldNew: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserProjectTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectWiseUserTaskListTimeTracking?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isTimesheet === null)
            throw new globalThis.Error("The parameter 'isTimesheet' cannot be null.");
        else if (isTimesheet !== undefined)
            url_ += "IsTimesheet=" + encodeURIComponent("" + isTimesheet) + "&";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTaskListTimeTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTaskListTimeTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserProjectTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserProjectTaskDto>;
        }));
    }

    protected processGetProjectWiseUserTaskListTimeTracking(response: HttpResponseBase): Observable<PagedResultDtoOfUserProjectTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProjectTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getJobTaskDetails(projectId: number | undefined): Observable<OutPutTaskJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetJobTaskDetails?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobTaskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobTaskDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTaskJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTaskJobDto[]>;
        }));
    }

    protected processGetJobTaskDetails(response: HttpResponseBase): Observable<OutPutTaskJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTaskJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectBillabilityType(projectId: number | undefined): Observable<ProjectBillingType> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectBillabilityType?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectBillabilityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectBillabilityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBillingType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBillingType>;
        }));
    }

    protected processGetProjectBillabilityType(response: HttpResponseBase): Observable<ProjectBillingType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param statusId (optional) 
     * @param isTimesheet (optional) 
     * @param oldNew (optional) 
     * @return OK
     */
    getProjectWiseUserTaskList(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, statusId: number | undefined, isTimesheet: boolean | undefined, oldNew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectWiseUserTaskList?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isTimesheet === null)
            throw new globalThis.Error("The parameter 'isTimesheet' cannot be null.");
        else if (isTimesheet !== undefined)
            url_ += "IsTimesheet=" + encodeURIComponent("" + isTimesheet) + "&";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTaskList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTaskList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseUserTaskList(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param oldNew (optional) 
     * @param body (optional) 
     * @return OK
     */
    manualAddedTaskForTimesheetDropdown(oldNew: boolean | undefined, body: ProjectTaskInput | undefined): Observable<ManualTaskForTimesheet[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/ManualAddedTaskForTimesheetDropdown?";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManualAddedTaskForTimesheetDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualAddedTaskForTimesheetDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualTaskForTimesheet[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualTaskForTimesheet[]>;
        }));
    }

    protected processManualAddedTaskForTimesheetDropdown(response: HttpResponseBase): Observable<ManualTaskForTimesheet[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManualTaskForTimesheet.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param statusId (optional) 
     * @param isTimesheet (optional) 
     * @param oldNew (optional) 
     * @return OK
     */
    getProjectWiseUserTaskListV2(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, statusId: number | undefined, isTimesheet: boolean | undefined, oldNew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectWiseUserTaskListV2?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isTimesheet === null)
            throw new globalThis.Error("The parameter 'isTimesheet' cannot be null.");
        else if (isTimesheet !== undefined)
            url_ += "IsTimesheet=" + encodeURIComponent("" + isTimesheet) + "&";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTaskListV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTaskListV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseUserTaskListV2(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param statusId (optional) 
     * @param isTimesheet (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param oldNew (optional) 
     * @return OK
     */
    getProjectWiseUserTaskListAdditonalTerms(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, statusId: number | undefined, isTimesheet: boolean | undefined, userId: number | undefined, tenantId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, oldNew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectWiseUserTaskListAdditonalTerms?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isTimesheet === null)
            throw new globalThis.Error("The parameter 'isTimesheet' cannot be null.");
        else if (isTimesheet !== undefined)
            url_ += "IsTimesheet=" + encodeURIComponent("" + isTimesheet) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTaskListAdditonalTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTaskListAdditonalTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseUserTaskListAdditonalTerms(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param taskStatusId (optional) 
     * @return OK
     */
    addTaskTimeLogByTimmer(taskId: number | undefined, taskStatusId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/AddTaskTimeLogByTimmer?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (taskStatusId === null)
            throw new globalThis.Error("The parameter 'taskStatusId' cannot be null.");
        else if (taskStatusId !== undefined)
            url_ += "taskStatusId=" + encodeURIComponent("" + taskStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTaskTimeLogByTimmer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTaskTimeLogByTimmer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTaskTimeLogByTimmer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param taskStatus (optional) 
     * @return OK
     */
    setTaskStatus(taskId: number | undefined, taskStatus: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/SetTaskStatus?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (taskStatus === null)
            throw new globalThis.Error("The parameter 'taskStatus' cannot be null.");
        else if (taskStatus !== undefined)
            url_ += "taskStatus=" + encodeURIComponent("" + taskStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetTaskStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startOrStopUserProjectTaskTimer(body: UserTaskInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/StartOrStopUserProjectTaskTimer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOrStopUserProjectTaskTimer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOrStopUserProjectTaskTimer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartOrStopUserProjectTaskTimer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startStopTaskTimeHistory(body: UserTaskTimeCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/StartStopTaskTimeHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartStopTaskTimeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartStopTaskTimeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartStopTaskTimeHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startOrStopUserPRojectTaskTimerOnAgentAppRestart(body: UserTaskInputDtoAgentMidNight | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/StartOrStopUserPRojectTaskTimerOnAgentAppRestart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOrStopUserPRojectTaskTimerOnAgentAppRestart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOrStopUserPRojectTaskTimerOnAgentAppRestart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartOrStopUserPRojectTaskTimerOnAgentAppRestart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setUserStatus(body: UserStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/SetUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setOrUpdateUserStatus(body: SetUserStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/SetOrUpdateUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrUpdateUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrUpdateUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetOrUpdateUserStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setOrUpdateUserStatusFromAgent(body: ProjectTaskStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/SetOrUpdateUserStatusFromAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrUpdateUserStatusFromAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrUpdateUserStatusFromAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetOrUpdateUserStatusFromAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param date (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getLatestUserStatusByIds(timeZoneOffset: number | undefined, date: DateTime | undefined, tenantId: number | undefined, userId: number | undefined): Observable<GetUserStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetLatestUserStatusByIds?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestUserStatusByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestUserStatusByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserStatusDto>;
        }));
    }

    protected processGetLatestUserStatusByIds(response: HttpResponseBase): Observable<GetUserStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userStatusList (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getLatestUserStatusByIdsforProjects(userStatusList: UserStatus[] | undefined, tenantId: number | undefined, userId: number | undefined): Observable<GetUserStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetLatestUserStatusByIdsforProjects?";
        if (userStatusList === null)
            throw new globalThis.Error("The parameter 'userStatusList' cannot be null.");
        else if (userStatusList !== undefined)
            userStatusList && userStatusList.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "userStatusList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestUserStatusByIdsforProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestUserStatusByIdsforProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserStatusDto>;
        }));
    }

    protected processGetLatestUserStatusByIdsforProjects(response: HttpResponseBase): Observable<GetUserStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param userIds (optional) 
     * @param statusId (optional) 
     * @param filter (optional) 
     * @param newestOnTop (optional) 
     * @param oldestOnTop (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTeamTaskList(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, userIds: number[] | undefined, statusId: number | undefined, filter: string | undefined, newestOnTop: boolean | undefined, oldestOnTop: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTeamTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTeamTaskList?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (newestOnTop === null)
            throw new globalThis.Error("The parameter 'newestOnTop' cannot be null.");
        else if (newestOnTop !== undefined)
            url_ += "NewestOnTop=" + encodeURIComponent("" + newestOnTop) + "&";
        if (oldestOnTop === null)
            throw new globalThis.Error("The parameter 'oldestOnTop' cannot be null.");
        else if (oldestOnTop !== undefined)
            url_ += "OldestOnTop=" + encodeURIComponent("" + oldestOnTop) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamTaskList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamTaskList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTeamTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTeamTaskDto>;
        }));
    }

    protected processGetTeamTaskList(response: HttpResponseBase): Observable<PagedResultDtoOfTeamTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTeamTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataSourceLoadOptions (optional) 
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param userIds (optional) 
     * @param statusId (optional) 
     * @param filter (optional) 
     * @param filterSearch (optional) 
     * @param newestOnTop (optional) 
     * @param oldestOnTop (optional) 
     * @param isExport (optional) 
     * @param columnFilters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getTeamTaskListV2(dataSourceLoadOptions: string | undefined, projectIds: number[] | undefined, projectTaskIds: number[] | undefined, userIds: number[] | undefined, statusId: number | undefined, filter: string | undefined, filterSearch: string | undefined, newestOnTop: boolean | undefined, oldestOnTop: boolean | undefined, isExport: boolean | undefined, columnFilters: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTeamTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTeamTaskListV2?";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (filterSearch === null)
            throw new globalThis.Error("The parameter 'filterSearch' cannot be null.");
        else if (filterSearch !== undefined)
            url_ += "FilterSearch=" + encodeURIComponent("" + filterSearch) + "&";
        if (newestOnTop === null)
            throw new globalThis.Error("The parameter 'newestOnTop' cannot be null.");
        else if (newestOnTop !== undefined)
            url_ += "NewestOnTop=" + encodeURIComponent("" + newestOnTop) + "&";
        if (oldestOnTop === null)
            throw new globalThis.Error("The parameter 'oldestOnTop' cannot be null.");
        else if (oldestOnTop !== undefined)
            url_ += "OldestOnTop=" + encodeURIComponent("" + oldestOnTop) + "&";
        if (isExport === null)
            throw new globalThis.Error("The parameter 'isExport' cannot be null.");
        else if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&";
        if (columnFilters === null)
            throw new globalThis.Error("The parameter 'columnFilters' cannot be null.");
        else if (columnFilters !== undefined)
            url_ += "ColumnFilters=" + encodeURIComponent("" + columnFilters) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamTaskListV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamTaskListV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTeamTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTeamTaskDto>;
        }));
    }

    protected processGetTeamTaskListV2(response: HttpResponseBase): Observable<PagedResultDtoOfTeamTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTeamTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param taskMode (optional) 
     * @param isSort (optional) 
     * @param oldNew (optional) 
     * @return OK
     */
    getProjectAndTaskListByUserIdForAgentApp(userId: number | undefined, tenantId: number | undefined, taskMode: number | undefined, isSort: boolean | undefined, oldNew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectAndTaskListByUserIdForAgentApp?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (taskMode === null)
            throw new globalThis.Error("The parameter 'taskMode' cannot be null.");
        else if (taskMode !== undefined)
            url_ += "taskMode=" + encodeURIComponent("" + taskMode) + "&";
        if (isSort === null)
            throw new globalThis.Error("The parameter 'isSort' cannot be null.");
        else if (isSort !== undefined)
            url_ += "isSort=" + encodeURIComponent("" + isSort) + "&";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAndTaskListByUserIdForAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAndTaskListByUserIdForAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectAndTaskListByUserIdForAgentApp(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    userCurrentTaskActiveInfo(userId: number | undefined, tenantId: number | undefined): Observable<UserCurrentTaskActiveInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/UserCurrentTaskActiveInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCurrentTaskActiveInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCurrentTaskActiveInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentTaskActiveInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentTaskActiveInfoDto>;
        }));
    }

    protected processUserCurrentTaskActiveInfo(response: HttpResponseBase): Observable<UserCurrentTaskActiveInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCurrentTaskActiveInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param userId (optional) 
     * @param isTeamTask (optional) 
     * @return OK
     */
    getUserProjectTaskTimeHistoryDetails(projectTaskId: number | undefined, userId: number | undefined, isTeamTask: boolean | undefined): Observable<UserTaskHistoryDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectTaskTimeHistoryDetails?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isTeamTask === null)
            throw new globalThis.Error("The parameter 'isTeamTask' cannot be null.");
        else if (isTeamTask !== undefined)
            url_ += "isTeamTask=" + encodeURIComponent("" + isTeamTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskTimeHistoryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskTimeHistoryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTaskHistoryDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTaskHistoryDetailsDto>;
        }));
    }

    protected processGetUserProjectTaskTimeHistoryDetails(response: HttpResponseBase): Observable<UserTaskHistoryDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTaskHistoryDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUserProjectTaskTimeHistoryDetailsForMyCalender(body: UserTaskHistoryInput | undefined): Observable<UserTaskHistoryDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectTaskTimeHistoryDetailsForMyCalender";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskTimeHistoryDetailsForMyCalender(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskTimeHistoryDetailsForMyCalender(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTaskHistoryDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTaskHistoryDetailsDto>;
        }));
    }

    protected processGetUserProjectTaskTimeHistoryDetailsForMyCalender(response: HttpResponseBase): Observable<UserTaskHistoryDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTaskHistoryDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    markCurrentUserTaskAsComplete(body: MarkTaskInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/MarkCurrentUserTaskAsComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCurrentUserTaskAsComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCurrentUserTaskAsComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkCurrentUserTaskAsComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param date (optional) 
     * @return OK
     */
    getUserProjectDetailsByLoggedInUser(timeZoneOffset: number | undefined, date: DateTime | undefined): Observable<UserProjectTaskDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectDetailsByLoggedInUser?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectDetailsByLoggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectDetailsByLoggedInUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDetailsDto>;
        }));
    }

    protected processGetUserProjectDetailsByLoggedInUser(response: HttpResponseBase): Observable<UserProjectTaskDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectTaskDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getActiveUserProjectTask(tenantId: number | undefined, userId: number | undefined): Observable<UserProjectTaskInputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetActiveUserProjectTask?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserProjectTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserProjectTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskInputDto>;
        }));
    }

    protected processGetActiveUserProjectTask(response: HttpResponseBase): Observable<UserProjectTaskInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProjectTaskInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param taskSort (optional) 
     * @param statusId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param oldnew (optional) 
     * @return OK
     */
    getProjectWiseUserTaskListAgent(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, taskSort: boolean | undefined, statusId: number | undefined, tenantId: number | undefined, userId: number | undefined, oldnew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectWiseUserTaskListAgent?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (taskSort === null)
            throw new globalThis.Error("The parameter 'taskSort' cannot be null.");
        else if (taskSort !== undefined)
            url_ += "TaskSort=" + encodeURIComponent("" + taskSort) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (oldnew === null)
            throw new globalThis.Error("The parameter 'oldnew' cannot be null.");
        else if (oldnew !== undefined)
            url_ += "oldnew=" + encodeURIComponent("" + oldnew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseUserTaskListAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseUserTaskListAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseUserTaskListAgent(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTaskState(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/UpdateTaskState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTaskState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManualTask(body: InputeAddManualTask | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/AddManualTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddManualTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateManualTask(body: InputeAddManualTask | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/UpdateManualTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateManualTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateManualTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateManualTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param projectId (optional) 
     * @param projectTaskId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param taskName (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    deleteManualTask(id: number | undefined, projectId: number | undefined, projectTaskId: number | undefined, startTime: DateTime | undefined, endTime: DateTime | undefined, taskName: string | undefined, userId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/DeleteManualTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "ProjectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toString() : "") + "&";
        if (taskName === null)
            throw new globalThis.Error("The parameter 'taskName' cannot be null.");
        else if (taskName !== undefined)
            url_ += "TaskName=" + encodeURIComponent("" + taskName) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteManualTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param timeZoneOffset (optional) 
     * @param date (optional) 
     * @return OK
     */
    getUserStatusCheckInCheckOut(userId: number | undefined, tenantId: number | undefined, timeZoneOffset: number | undefined, date: DateTime | undefined): Observable<UserCurrentStateCheckInCheckOutDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserStatusCheckInCheckOut?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserStatusCheckInCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserStatusCheckInCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentStateCheckInCheckOutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentStateCheckInCheckOutDto>;
        }));
    }

    protected processGetUserStatusCheckInCheckOut(response: HttpResponseBase): Observable<UserCurrentStateCheckInCheckOutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCurrentStateCheckInCheckOutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param filterProjectId (optional) 
     * @param filterTask (optional) 
     * @return OK
     */
    getTaskStatus(userId: number | undefined, tenantId: number | undefined, filterProjectId: number | undefined, filterTask: string | undefined): Observable<TaskStatusCountDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskStatus?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterProjectId === null)
            throw new globalThis.Error("The parameter 'filterProjectId' cannot be null.");
        else if (filterProjectId !== undefined)
            url_ += "filterProjectId=" + encodeURIComponent("" + filterProjectId) + "&";
        if (filterTask === null)
            throw new globalThis.Error("The parameter 'filterTask' cannot be null.");
        else if (filterTask !== undefined)
            url_ += "filterTask=" + encodeURIComponent("" + filterTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskStatusCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskStatusCountDto>;
        }));
    }

    protected processGetTaskStatus(response: HttpResponseBase): Observable<TaskStatusCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskStatusCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mobileAppGetTaskStatus(body: MobileGetTaskStatusInput | undefined): Observable<TaskStatusCountDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/MobileAppGetTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileAppGetTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileAppGetTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskStatusCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskStatusCountDto>;
        }));
    }

    protected processMobileAppGetTaskStatus(response: HttpResponseBase): Observable<TaskStatusCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskStatusCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param fileurl (optional) 
     * @return OK
     */
    deleteAttachment(taskId: number | undefined, fileurl: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/DeleteAttachment?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (fileurl === null)
            throw new globalThis.Error("The parameter 'fileurl' cannot be null.");
        else if (fileurl !== undefined)
            url_ += "fileurl=" + encodeURIComponent("" + fileurl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOldData(body: AddAttachmentInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/addOldData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOldData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOldData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOldData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param projectTaskIds (optional) 
     * @param taskNameSearch (optional) 
     * @param statusId (optional) 
     * @param isTimesheet (optional) 
     * @param oldNew (optional) 
     * @return OK
     */
    getProjectWiseTaskList(projectIds: number[] | undefined, projectTaskIds: number[] | undefined, taskNameSearch: string | undefined, statusId: number | undefined, isTimesheet: boolean | undefined, oldNew: boolean | undefined): Observable<UserProjectTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetProjectWiseTaskList?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTaskIds === null)
            throw new globalThis.Error("The parameter 'projectTaskIds' cannot be null.");
        else if (projectTaskIds !== undefined)
            projectTaskIds && projectTaskIds.forEach(item => { url_ += "ProjectTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (taskNameSearch === null)
            throw new globalThis.Error("The parameter 'taskNameSearch' cannot be null.");
        else if (taskNameSearch !== undefined)
            url_ += "TaskNameSearch=" + encodeURIComponent("" + taskNameSearch) + "&";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isTimesheet === null)
            throw new globalThis.Error("The parameter 'isTimesheet' cannot be null.");
        else if (isTimesheet !== undefined)
            url_ += "IsTimesheet=" + encodeURIComponent("" + isTimesheet) + "&";
        if (oldNew === null)
            throw new globalThis.Error("The parameter 'oldNew' cannot be null.");
        else if (oldNew !== undefined)
            url_ += "oldNew=" + encodeURIComponent("" + oldNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseTaskList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseTaskList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProjectTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProjectTaskDto[]>;
        }));
    }

    protected processGetProjectWiseTaskList(response: HttpResponseBase): Observable<UserProjectTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProjectTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTaskImportFormat(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetTaskImportFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskImportFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskImportFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTaskImportFormat(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    offlineUserStatus(body: OfflineUserStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/OfflineUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfflineUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfflineUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOfflineUserStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param billableStatus (optional) 
     * @return OK
     */
    updateProjectOutlookTask(projectTaskId: number | undefined, userId: number | undefined, projectId: number | undefined, billableStatus: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/UpdateProjectOutlookTask?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (billableStatus === null)
            throw new globalThis.Error("The parameter 'billableStatus' cannot be null.");
        else if (billableStatus !== undefined)
            url_ += "billableStatus=" + encodeURIComponent("" + billableStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectOutlookTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectOutlookTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProjectOutlookTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signalROutlookTaskUpdateAPI(body: UserTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/SignalROutlookTaskUpdateAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalROutlookTaskUpdateAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalROutlookTaskUpdateAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignalROutlookTaskUpdateAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectTaskId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserProjectTaskByIdForFlutter(projectTaskId: number | undefined, tenantId: number | undefined): Observable<UserTaskInputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTask/GetUserProjectTaskByIdForFlutter?";
        if (projectTaskId === null)
            throw new globalThis.Error("The parameter 'projectTaskId' cannot be null.");
        else if (projectTaskId !== undefined)
            url_ += "projectTaskId=" + encodeURIComponent("" + projectTaskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProjectTaskByIdForFlutter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProjectTaskByIdForFlutter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTaskInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTaskInputDto>;
        }));
    }

    protected processGetUserProjectTaskByIdForFlutter(response: HttpResponseBase): Observable<UserTaskInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTaskInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    getTimesheetOverAllSummaryReport(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined): Observable<OverAllSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTimesheetOverAllSummaryReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetOverAllSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetOverAllSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverAllSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverAllSummaryDto[]>;
        }));
    }

    protected processGetTimesheetOverAllSummaryReport(response: HttpResponseBase): Observable<OverAllSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OverAllSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    getTimeSheetDateWiseReport(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined): Observable<TimeSheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTimeSheetDateWiseReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeSheetDateWiseReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeSheetDateWiseReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSheetDto[]>;
        }));
    }

    protected processGetTimeSheetDateWiseReport(response: HttpResponseBase): Observable<TimeSheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeSheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetSummaryReport(body: InputeTimesheetReport | undefined): Observable<OverAllSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimesheetSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverAllSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverAllSummaryDto[]>;
        }));
    }

    protected processTimesheetSummaryReport(response: HttpResponseBase): Observable<OverAllSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OverAllSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    getTimesheetEmployeeWiseSummaryReport(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined): Observable<EmployeeWiseSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTimesheetEmployeeWiseSummaryReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetEmployeeWiseSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetEmployeeWiseSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeWiseSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeWiseSummaryDto[]>;
        }));
    }

    protected processGetTimesheetEmployeeWiseSummaryReport(response: HttpResponseBase): Observable<EmployeeWiseSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeWiseSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dateWiseAttendanceReport(body: InputeTimesheetReport | undefined): Observable<AttendanceReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/DateWiseAttendanceReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDateWiseAttendanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDateWiseAttendanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceReportDto[]>;
        }));
    }

    protected processDateWiseAttendanceReport(response: HttpResponseBase): Observable<AttendanceReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceReportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceReportEmployeeWise(body: InputeTimesheetReport | undefined): Observable<AttendanceReportEmployeeWiseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceReportEmployeeWise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceReportEmployeeWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceReportEmployeeWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceReportEmployeeWiseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceReportEmployeeWiseDto[]>;
        }));
    }

    protected processAttendanceReportEmployeeWise(response: HttpResponseBase): Observable<AttendanceReportEmployeeWiseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceReportEmployeeWiseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceOverAllSummaryReport(body: InputeTimesheetReport | undefined): Observable<OverAllSummaryRootDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceOverAllSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceOverAllSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceOverAllSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OverAllSummaryRootDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OverAllSummaryRootDto>;
        }));
    }

    protected processAttendanceOverAllSummaryReport(response: HttpResponseBase): Observable<OverAllSummaryRootDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OverAllSummaryRootDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timeOffReport(body: InputeTimesheetReport | undefined): Observable<TimeOffReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimeOffReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeOffReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeOffReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeOffReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeOffReportDto>;
        }));
    }

    protected processTimeOffReport(response: HttpResponseBase): Observable<TimeOffReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeOffReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    reportProjectDropdownList(userId: number | undefined, tenantId: number | undefined): Observable<DropdownProjectListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/ReportProjectDropdownList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportProjectDropdownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportProjectDropdownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownProjectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownProjectListDto[]>;
        }));
    }

    protected processReportProjectDropdownList(response: HttpResponseBase): Observable<DropdownProjectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownProjectListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeManagers (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param body (optional) 
     * @return OK
     */
    reportProjectUnderUsersList(includeManagers: boolean | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, body: number[] | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/ReportProjectUnderUsersList?";
        if (includeManagers === null)
            throw new globalThis.Error("The parameter 'includeManagers' cannot be null.");
        else if (includeManagers !== undefined)
            url_ += "includeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportProjectUnderUsersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportProjectUnderUsersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processReportProjectUnderUsersList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    employeeWorkingStatusReport(body: InputeTimesheetReport | undefined): Observable<WorkStatusUser[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/EmployeeWorkingStatusReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeWorkingStatusReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeWorkingStatusReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkStatusUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkStatusUser[]>;
        }));
    }

    protected processEmployeeWorkingStatusReport(response: HttpResponseBase): Observable<WorkStatusUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStatusUser.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userReportingLocation (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserReportingLocationTimeZone(userReportingLocation: number | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetUserReportingLocationTimeZone?";
        if (userReportingLocation === null)
            throw new globalThis.Error("The parameter 'userReportingLocation' cannot be null.");
        else if (userReportingLocation !== undefined)
            url_ += "userReportingLocation=" + encodeURIComponent("" + userReportingLocation) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserReportingLocationTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserReportingLocationTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserReportingLocationTimeZone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param userIds (optional) 
     * @return OK
     */
    getAppProductivityBarReport(fromDate: DateTime | undefined, toDate: DateTime | undefined, userIds: number[] | undefined): Observable<ProductivityBarReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAppProductivityBarReport?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppProductivityBarReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppProductivityBarReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityBarReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityBarReportDto[]>;
        }));
    }

    protected processGetAppProductivityBarReport(response: HttpResponseBase): Observable<ProductivityBarReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductivityBarReportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetNotSubmitReport(body: InputeTimesheetReport | undefined): Observable<NotFIllTImesheet[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimesheetNotSubmitReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetNotSubmitReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetNotSubmitReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotFIllTImesheet[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotFIllTImesheet[]>;
        }));
    }

    protected processTimesheetNotSubmitReport(response: HttpResponseBase): Observable<NotFIllTImesheet[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotFIllTImesheet.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceOverAllSummaryReportJob(body: InputeAttandanceReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceOverAllSummaryReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceOverAllSummaryReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceOverAllSummaryReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAttendanceOverAllSummaryReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param projectId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @param jobId (optional) 
     * @return OK
     */
    getAttendanceOverAllSummaryReport(userId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, projectId: (number | undefined)[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined, jobId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAttendanceOverAllSummaryReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceOverAllSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceOverAllSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAttendanceOverAllSummaryReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceTeamMemberWiseReportJob(body: InputeTeamMemberWiseAttendenceReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceTeamMemberWiseReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceTeamMemberWiseReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceTeamMemberWiseReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAttendanceTeamMemberWiseReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param projectId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @param jobId (optional) 
     * @return OK
     */
    getAttendanceReportEmployeeWiseReport(userId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, projectId: (number | undefined)[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined, jobId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAttendanceReportEmployeeWiseReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceReportEmployeeWiseReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceReportEmployeeWiseReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAttendanceReportEmployeeWiseReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceReportDateWiseNewBackgroundJob(body: InputeTeamMemberWiseAttendenceReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceReportDateWiseNewBackgroundJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceReportDateWiseNewBackgroundJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceReportDateWiseNewBackgroundJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAttendanceReportDateWiseNewBackgroundJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param body (optional) 
     * @return OK
     */
    attendanceReportDateWiseNew(jobId: string | undefined, body: InputeTeamMemberWiseAttendenceReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceReportDateWiseNew?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceReportDateWiseNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceReportDateWiseNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttendanceReportDateWiseNew(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceDateWiseReportJob(body: InputeDateWiseAttendenceReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceDateWiseReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceDateWiseReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceDateWiseReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttendanceDateWiseReportJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @return OK
     */
    getDateWiseAttendance(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetDateWiseAttendance?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDateWiseAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDateWiseAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetDateWiseAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    attendanceWorkingStatusWiseReportJob(body: InputeWorkStatusReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendanceWorkingStatusWiseReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceWorkingStatusWiseReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceWorkingStatusWiseReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAttendanceWorkingStatusWiseReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param body (optional) 
     * @return OK
     */
    attendenceEmployeeWorkingStatusReport(jobId: string | undefined, body: InputeWorkStatusReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/AttendenceEmployeeWorkingStatusReport?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendenceEmployeeWorkingStatusReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendenceEmployeeWorkingStatusReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttendenceEmployeeWorkingStatusReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    leaveReportJob(body: InputeLeaveReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/LeaveReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLeaveReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param currentUserId (optional) 
     * @param tenantId (optional) 
     * @param projectId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fileName (optional) 
     * @param jobId (optional) 
     * @return OK
     */
    getLeaveReport(userId: (number | undefined)[] | undefined, currentUserId: number | undefined, tenantId: number | undefined, projectId: (number | undefined)[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, billabilityStatus: (number | undefined)[] | undefined, timesheetGroupByReportType: TimesheetReportGroupByType, timesheetSaveAsReportType: TimesheetReportSaveAsType, inputReportType: ReportType, timeZoneOffset: number | undefined, fileName: string | undefined, jobId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetLeaveReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            billabilityStatus && billabilityStatus.forEach(item => { url_ += "BillabilityStatus=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetGroupByReportType === undefined || timesheetGroupByReportType === null)
            throw new globalThis.Error("The parameter 'timesheetGroupByReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetGroupByReportType=" + encodeURIComponent("" + timesheetGroupByReportType) + "&";
        if (timesheetSaveAsReportType === undefined || timesheetSaveAsReportType === null)
            throw new globalThis.Error("The parameter 'timesheetSaveAsReportType' must be defined and cannot be null.");
        else
            url_ += "TimesheetSaveAsReportType=" + encodeURIComponent("" + timesheetSaveAsReportType) + "&";
        if (inputReportType === undefined || inputReportType === null)
            throw new globalThis.Error("The parameter 'inputReportType' must be defined and cannot be null.");
        else
            url_ += "InputReportType=" + encodeURIComponent("" + inputReportType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetLeaveReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productivityBarReportJob(body: ProductivityBarReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/productivityBarReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductivityBarReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductivityBarReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processProductivityBarReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param body (optional) 
     * @return OK
     */
    productivityBarReport(jobId: string | undefined, body: ProductivityBarReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/ProductivityBarReport?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductivityBarReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductivityBarReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProductivityBarReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timeSheetOverAllSummaryReportJob(body: InputeTimesheetReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimeSheetOverAllSummaryReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeSheetOverAllSummaryReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeSheetOverAllSummaryReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTimeSheetOverAllSummaryReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    projectDetailForTimesheetOverAllSummaryReport(userId: number | undefined, tenantId: number | undefined): Observable<DropdownProjectListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/ProjectDetailForTimesheetOverAllSummaryReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectDetailForTimesheetOverAllSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectDetailForTimesheetOverAllSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownProjectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownProjectListDto[]>;
        }));
    }

    protected processProjectDetailForTimesheetOverAllSummaryReport(response: HttpResponseBase): Observable<DropdownProjectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownProjectListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetOverAllSummaryReportV2(jobId: string | undefined, body: InputeTimesheetReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimesheetOverAllSummaryReportV2?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetOverAllSummaryReportV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetOverAllSummaryReportV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetOverAllSummaryReportV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetNotSubmitReportJob(body: InputeTimesheetReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimesheetNotSubmitReportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetNotSubmitReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetNotSubmitReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTimesheetNotSubmitReportJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetNotSubmitReportV2(jobId: string | undefined, body: InputeTimesheetReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/TimesheetNotSubmitReportV2?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetNotSubmitReportV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetNotSubmitReportV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetNotSubmitReportV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getReportHistory(tenantId: number | undefined, userId: number | undefined, reportType: ReportTypeEnum, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetReportHistoryData[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetReportHistory?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (reportType === undefined || reportType === null)
            throw new globalThis.Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportHistoryData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportHistoryData[]>;
        }));
    }

    protected processGetReportHistory(response: HttpResponseBase): Observable<GetReportHistoryData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReportHistoryData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportHistoryId (optional) 
     * @return OK
     */
    deleteReport(reportHistoryId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/DeleteReport?";
        if (reportHistoryId === null)
            throw new globalThis.Error("The parameter 'reportHistoryId' cannot be null.");
        else if (reportHistoryId !== undefined)
            url_ += "ReportHistoryId=" + encodeURIComponent("" + reportHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportHistoryIds (optional) 
     * @return OK
     */
    deleteMultipleReports(reportHistoryIds: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/DeleteMultipleReports?";
        if (reportHistoryIds === null)
            throw new globalThis.Error("The parameter 'reportHistoryIds' cannot be null.");
        else if (reportHistoryIds !== undefined)
            reportHistoryIds && reportHistoryIds.forEach(item => { url_ += "reportHistoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMultipleReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMultipleReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportHistoryId (optional) 
     * @return OK
     */
    downLoadReport(reportHistoryId: number | undefined): Observable<ReportExportData> {
        let url_ = this.baseUrl + "/api/services/app/Report/DownLoadReport?";
        if (reportHistoryId === null)
            throw new globalThis.Error("The parameter 'reportHistoryId' cannot be null.");
        else if (reportHistoryId !== undefined)
            url_ += "ReportHistoryId=" + encodeURIComponent("" + reportHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportExportData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportExportData>;
        }));
    }

    protected processDownLoadReport(response: HttpResponseBase): Observable<ReportExportData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportExportData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @return OK
     */
    getProgress(jobId: string | undefined): Observable<ProgressDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetProgress?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgressDto>;
        }));
    }

    protected processGetProgress(response: HttpResponseBase): Observable<ProgressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    projectReportingAllocationJob(body: InputeTimesheetReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/ProjectReportingAllocationJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectReportingAllocationJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectReportingAllocationJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processProjectReportingAllocationJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param recordId (optional) 
     * @param body (optional) 
     * @return OK
     */
    projectReportingAllocation(jobId: string | undefined, recordId: number | undefined, body: InputeTimesheetReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/ProjectReportingAllocation?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (recordId === null)
            throw new globalThis.Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectReportingAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectReportingAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProjectReportingAllocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    newProjectAllocatonReportjob(body: InputeTimesheetReport | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/NewProjectAllocatonReportjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewProjectAllocatonReportjob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewProjectAllocatonReportjob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processNewProjectAllocatonReportjob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobId (optional) 
     * @param recordId (optional) 
     * @param body (optional) 
     * @return OK
     */
    newProjectAllocatonReport(jobId: string | undefined, recordId: number | undefined, body: InputeTimesheetReport | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/NewProjectAllocatonReport?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (recordId === null)
            throw new globalThis.Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewProjectAllocatonReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewProjectAllocatonReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNewProjectAllocatonReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param length (optional) 
     * @return OK
     */
    generateRandomString(length: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateRandomString?";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRandomString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRandomString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateRandomString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportExportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    projectDetailForTimesheetOverAllSummaryReport(userId: number | undefined, tenantId: number | undefined): Observable<DropdownProjectListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportExport/ProjectDetailForTimesheetOverAllSummaryReport?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectDetailForTimesheetOverAllSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectDetailForTimesheetOverAllSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownProjectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownProjectListDto[]>;
        }));
    }

    protected processProjectDetailForTimesheetOverAllSummaryReport(response: HttpResponseBase): Observable<DropdownProjectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownProjectListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportHistoryId (optional) 
     * @return OK
     */
    downLoadTimesheetReport(reportHistoryId: number | undefined): Observable<ReportExportData> {
        let url_ = this.baseUrl + "/api/services/app/ReportExport/DownLoadTimesheetReport?";
        if (reportHistoryId === null)
            throw new globalThis.Error("The parameter 'reportHistoryId' cannot be null.");
        else if (reportHistoryId !== undefined)
            url_ += "reportHistoryId=" + encodeURIComponent("" + reportHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadTimesheetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadTimesheetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportExportData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportExportData>;
        }));
    }

    protected processDownLoadTimesheetReport(response: HttpResponseBase): Observable<ReportExportData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportExportData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getTotalHoursActivityData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetTotalHoursActivityData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalHoursActivityData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalHoursActivityData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTotalHoursActivityData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTotalHoursActivityDataAllSP(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetTotalHoursActivityDataAllSP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalHoursActivityDataAllSP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalHoursActivityDataAllSP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetTotalHoursActivityDataAllSP(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param loginProvider (optional) 
     * @param providerKey (optional) 
     * @return OK
     */
    saveUserLoginsDetail(tenantId: number | undefined, userId: number | undefined, loginProvider: string | undefined, providerKey: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/SaveUserLoginsDetail?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (loginProvider === null)
            throw new globalThis.Error("The parameter 'loginProvider' cannot be null.");
        else if (loginProvider !== undefined)
            url_ += "loginProvider=" + encodeURIComponent("" + loginProvider) + "&";
        if (providerKey === null)
            throw new globalThis.Error("The parameter 'providerKey' cannot be null.");
        else if (providerKey !== undefined)
            url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserLoginsDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserLoginsDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveUserLoginsDetail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    updateUserStatus(userId: number | undefined, tenantId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/UpdateUserStatus?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUserStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateTimesheetApprovalPermission(body: TimesheetApprovalPermissionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/AddOrUpdateTimesheetApprovalPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateTimesheetApprovalPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateTimesheetApprovalPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateTimesheetApprovalPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRoles(body: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getRoleForEdit(id: number | undefined, tenantId: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    deleteRole(id: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceCalendarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateServiceCalendarEvent(body: ServiceCalendarEventDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/CreateOrUpdateServiceCalendarEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateServiceCalendarEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateServiceCalendarEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateServiceCalendarEvent(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateServiceProviderEvents(userId: number | undefined, body: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/AddOrUpdateServiceProviderEvents?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateServiceProviderEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateServiceProviderEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateServiceProviderEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param providerEventId (optional) 
     * @return OK
     */
    deleteServiceCalendarEventByProviderEventID(providerEventId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/DeleteServiceCalendarEventByProviderEventID?";
        if (providerEventId === null)
            throw new globalThis.Error("The parameter 'providerEventId' cannot be null.");
        else if (providerEventId !== undefined)
            url_ += "providerEventId=" + encodeURIComponent("" + providerEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceCalendarEventByProviderEventID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceCalendarEventByProviderEventID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteServiceCalendarEventByProviderEventID(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param systemEventId (optional) 
     * @return OK
     */
    deleteServiceCalendarEventBySystemEventID(systemEventId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/DeleteServiceCalendarEventBySystemEventID?";
        if (systemEventId === null)
            throw new globalThis.Error("The parameter 'systemEventId' cannot be null.");
        else if (systemEventId !== undefined)
            url_ += "systemEventId=" + encodeURIComponent("" + systemEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceCalendarEventBySystemEventID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceCalendarEventBySystemEventID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteServiceCalendarEventBySystemEventID(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllServiceCalendarEvents(): Observable<PagedResultDtoOfServiceCalendarEventDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/GetAllServiceCalendarEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceCalendarEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceCalendarEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfServiceCalendarEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfServiceCalendarEventDto>;
        }));
    }

    protected processGetAllServiceCalendarEvents(response: HttpResponseBase): Observable<PagedResultDtoOfServiceCalendarEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceCalendarEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceEventId (optional) 
     * @return OK
     */
    getServiceCalendarEventById(serviceEventId: number | undefined): Observable<ServiceCalendarEventDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/GetServiceCalendarEventById?";
        if (serviceEventId === null)
            throw new globalThis.Error("The parameter 'serviceEventId' cannot be null.");
        else if (serviceEventId !== undefined)
            url_ += "serviceEventId=" + encodeURIComponent("" + serviceEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCalendarEventById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCalendarEventById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCalendarEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCalendarEventDto>;
        }));
    }

    protected processGetServiceCalendarEventById(response: HttpResponseBase): Observable<ServiceCalendarEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCalendarEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param systemEventId (optional) 
     * @return OK
     */
    getServiceCalendarEventBySystemEventId(systemEventId: number | undefined): Observable<ServiceCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/GetServiceCalendarEventBySystemEventId?";
        if (systemEventId === null)
            throw new globalThis.Error("The parameter 'systemEventId' cannot be null.");
        else if (systemEventId !== undefined)
            url_ += "systemEventId=" + encodeURIComponent("" + systemEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCalendarEventBySystemEventId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCalendarEventBySystemEventId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCalendarEventDto[]>;
        }));
    }

    protected processGetServiceCalendarEventBySystemEventId(response: HttpResponseBase): Observable<ServiceCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCalendarEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getServiceCalendarEventByUserId(userId: number | undefined): Observable<ServiceCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/GetServiceCalendarEventByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCalendarEventByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCalendarEventByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCalendarEventDto[]>;
        }));
    }

    protected processGetServiceCalendarEventByUserId(response: HttpResponseBase): Observable<ServiceCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCalendarEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getServiceCalendarEventByProvider(calType: CalType): Observable<ServiceCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/GetServiceCalendarEventByProvider?";
        if (calType === undefined || calType === null)
            throw new globalThis.Error("The parameter 'calType' must be defined and cannot be null.");
        else
            url_ += "calType=" + encodeURIComponent("" + calType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCalendarEventByProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCalendarEventByProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCalendarEventDto[]>;
        }));
    }

    protected processGetServiceCalendarEventByProvider(response: HttpResponseBase): Observable<ServiceCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCalendarEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getServiceCalendarEventByUserIdAndProvider(userId: number | undefined, calType: CalType2): Observable<ServiceCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCalendar/GetServiceCalendarEventByUserIdAndProvider?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (calType === undefined || calType === null)
            throw new globalThis.Error("The parameter 'calType' must be defined and cannot be null.");
        else
            url_ += "calType=" + encodeURIComponent("" + calType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCalendarEventByUserIdAndProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCalendarEventByUserIdAndProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCalendarEventDto[]>;
        }));
    }

    protected processGetServiceCalendarEventByUserIdAndProvider(response: HttpResponseBase): Observable<ServiceCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCalendarEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stripeSessionId (optional) 
     * @return OK
     */
    getPayment(stripeSessionId: string | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
        if (stripeSessionId === null)
            throw new globalThis.Error("The parameter 'stripeSessionId' cannot be null.");
        else if (stripeSessionId !== undefined)
            url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPaymentSession(body: StripeCreatePaymentSessionInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    getPaymentResult(paymentId: number | undefined): Observable<StripePaymentResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripePaymentResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripePaymentResultOutput>;
        }));
    }

    protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripePaymentResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TaskLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    logTaskTime(body: TaskLogDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskLog/LogTaskTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogTaskTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogTaskTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogTaskTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param isdeleteshow (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, isdeleteshow: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart === null)
            throw new globalThis.Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd === null)
            throw new globalThis.Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart === null)
            throw new globalThis.Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd === null)
            throw new globalThis.Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new globalThis.Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (isdeleteshow === null)
            throw new globalThis.Error("The parameter 'isdeleteshow' cannot be null.");
        else if (isdeleteshow !== undefined)
            url_ += "Isdeleteshow=" + encodeURIComponent("" + isdeleteshow) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantId(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTenantId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    addOrUpdateHangFireJobsForNewTenant(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/AddOrUpdateHangFireJobsForNewTenant?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateHangFireJobsForNewTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateHangFireJobsForNewTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateHangFireJobsForNewTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isRestore (optional) 
     * @return OK
     */
    deleteTenant(id: number | undefined, isRestore: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (isRestore === null)
            throw new globalThis.Error("The parameter 'isRestore' cannot be null.");
        else if (isRestore !== undefined)
            url_ += "isRestore=" + encodeURIComponent("" + isRestore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dropDatabase(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DropDatabase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDropDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDropDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDropDatabase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTenantForAgent(): Observable<Tenant[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForAgent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenant[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenant[]>;
        }));
    }

    protected processGetTenantForAgent(response: HttpResponseBase): Observable<Tenant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tenant.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return OK
     */
    getTenancyDropDownByEmailAddress(emailAddress: string | undefined): Observable<Tenant[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenancyDropDownByEmailAddress?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyDropDownByEmailAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyDropDownByEmailAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenant[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenant[]>;
        }));
    }

    protected processGetTenancyDropDownByEmailAddress(response: HttpResponseBase): Observable<Tenant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tenant.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getTenantLogo(skin: string, tenantId: number, extension: string): Observable<void> {
        let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}/{extension}";
        if (skin === undefined || skin === null)
            throw new globalThis.Error("The parameter 'skin' must be defined.");
        url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (extension === undefined || extension === null)
            throw new globalThis.Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new globalThis.Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopStatsOutput>;
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfitShareOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfitShareOutput>;
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailySalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailySalesOutput>;
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new globalThis.Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEdit(body: TenantProductServiceCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    getAllProducts(productType: ProductType2, name: string | undefined): Observable<TenantProductServiceGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/GetAllProducts?";
        if (productType === undefined || productType === null)
            throw new globalThis.Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProductServiceGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProductServiceGetAllDto[]>;
        }));
    }

    protected processGetAllProducts(response: HttpResponseBase): Observable<TenantProductServiceGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantProductServiceGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param isBillable (optional) 
     * @return OK
     */
    getAllServices(serviceType: ServiceType2, name: string | undefined, isBillable: boolean | undefined): Observable<TenantProductServiceGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/GetAllServices?";
        if (serviceType === undefined || serviceType === null)
            throw new globalThis.Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "serviceType=" + encodeURIComponent("" + serviceType) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (isBillable === null)
            throw new globalThis.Error("The parameter 'isBillable' cannot be null.");
        else if (isBillable !== undefined)
            url_ += "IsBillable=" + encodeURIComponent("" + isBillable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProductServiceGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProductServiceGetAllDto[]>;
        }));
    }

    protected processGetAllServices(response: HttpResponseBase): Observable<TenantProductServiceGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantProductServiceGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unDeleteProductAndService(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/UnDeleteProductAndService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteProductAndService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteProductAndService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteProductAndService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    archiveProductAndService(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/ArchiveProductAndService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveProductAndService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveProductAndService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveProductAndService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unArchiveProductAndService(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/UnArchiveProductAndService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnArchiveProductAndService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnArchiveProductAndService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnArchiveProductAndService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @param productServiceTypeId (optional) 
     * @return OK
     */
    getProductServicesByTypeId(deleteStatus: number | undefined, productServiceTypeId: number | undefined): Observable<TenantProductServiceGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/GetProductServicesByTypeId?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        if (productServiceTypeId === null)
            throw new globalThis.Error("The parameter 'productServiceTypeId' cannot be null.");
        else if (productServiceTypeId !== undefined)
            url_ += "productServiceTypeId=" + encodeURIComponent("" + productServiceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductServicesByTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductServicesByTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProductServiceGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProductServiceGetAllDto[]>;
        }));
    }

    protected processGetProductServicesByTypeId(response: HttpResponseBase): Observable<TenantProductServiceGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantProductServiceGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    getTenantProductServiceById(input: number | undefined): Observable<TenantProductServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/GetTenantProductServiceById?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantProductServiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantProductServiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProductServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProductServiceDto>;
        }));
    }

    protected processGetTenantProductServiceById(response: HttpResponseBase): Observable<TenantProductServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantProductServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @param name (optional) 
     * @return OK
     */
    getAllproductWithNameOrDeleteFilter(deleteStatus: number | undefined, name: string | undefined): Observable<TenantProductServiceGetAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/GetAllproductWithNameOrDeleteFilter?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllproductWithNameOrDeleteFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllproductWithNameOrDeleteFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProductServiceGetAllDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProductServiceGetAllDto[]>;
        }));
    }

    protected processGetAllproductWithNameOrDeleteFilter(response: HttpResponseBase): Observable<TenantProductServiceGetAllDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantProductServiceGetAllDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteStatus (optional) 
     * @return OK
     */
    getTenantProductServiceByDeleteStatus(deleteStatus: number | undefined): Observable<TenantProductServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/GetTenantProductServiceByDeleteStatus?";
        if (deleteStatus === null)
            throw new globalThis.Error("The parameter 'deleteStatus' cannot be null.");
        else if (deleteStatus !== undefined)
            url_ += "deleteStatus=" + encodeURIComponent("" + deleteStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantProductServiceByDeleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantProductServiceByDeleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProductServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProductServiceDto[]>;
        }));
    }

    protected processGetTenantProductServiceByDeleteStatus(response: HttpResponseBase): Observable<TenantProductServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantProductServiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    checkDuplicateProductService(name: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/CheckDuplicateProductService?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicateProductService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicateProductService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicateProductService(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productServiceId (optional) 
     * @return OK
     */
    unDelete(productServiceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/UnDelete?";
        if (productServiceId === null)
            throw new globalThis.Error("The parameter 'productServiceId' cannot be null.");
        else if (productServiceId !== undefined)
            url_ += "ProductServiceId=" + encodeURIComponent("" + productServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    deleteProductAndService(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantProduct/DeleteProductAndService?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductAndService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductAndService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductAndService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addAgentApplicationInNewTenant(tenantId: number | undefined, body: AgentApplication[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/AddAgentApplicationInNewTenant?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgentApplicationInNewTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgentApplicationInNewTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAgentApplicationInNewTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerTenantFreeTrailRequest(body: RegisterTenantInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenantFreeTrailRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenantFreeTrailRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenantFreeTrailRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRegisterTenantFreeTrailRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getfreeTrailRequests(): Observable<TrailRequesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetfreeTrailRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetfreeTrailRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetfreeTrailRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrailRequesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrailRequesDto[]>;
        }));
    }

    protected processGetfreeTrailRequests(response: HttpResponseBase): Observable<TrailRequesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrailRequesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trailRequestId (optional) 
     * @return OK
     */
    approveTrailRequest(trailRequestId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/ApproveTrailRequest?";
        if (trailRequestId === null)
            throw new globalThis.Error("The parameter 'trailRequestId' cannot be null.");
        else if (trailRequestId !== undefined)
            url_ += "TrailRequestId=" + encodeURIComponent("" + trailRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTrailRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTrailRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveTrailRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trailRequestId (optional) 
     * @return OK
     */
    deleteTrailRequest(trailRequestId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/DeleteTrailRequest?";
        if (trailRequestId === null)
            throw new globalThis.Error("The parameter 'trailRequestId' cannot be null.");
        else if (trailRequestId !== undefined)
            url_ += "TrailRequestId=" + encodeURIComponent("" + trailRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrailRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrailRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTrailRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    deleteDataBase(name: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/DeleteDataBase?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDataBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDataBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteDataBase(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    addOrUpdateHangFireJobsForNewTenant(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/AddOrUpdateHangFireJobsForNewTenant?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateHangFireJobsForNewTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateHangFireJobsForNewTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateHangFireJobsForNewTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addHanFireJobsForAlltenantIds(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/AddHanFireJobsForAlltenantIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddHanFireJobsForAlltenantIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddHanFireJobsForAlltenantIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddHanFireJobsForAlltenantIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobid (optional) 
     * @return OK
     */
    deleteHangFireJobById(jobid: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/DeleteHangFireJobById?";
        if (jobid === null)
            throw new globalThis.Error("The parameter 'jobid' cannot be null.");
        else if (jobid !== undefined)
            url_ += "jobid=" + encodeURIComponent("" + jobid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHangFireJobById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHangFireJobById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHangFireJobById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteAllHangFireJobs(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/DeleteAllHangFireJobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllHangFireJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllHangFireJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllHangFireJobs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    deleteAllHangFireJobsForParticaularTenantId(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/DeleteAllHangFireJobsForParticaularTenantId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllHangFireJobsForParticaularTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllHangFireJobsForParticaularTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllHangFireJobsForParticaularTenantId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLocalCurrencyData(): Observable<LocalCurrencyData> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetLocalCurrencyData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalCurrencyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalCurrencyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocalCurrencyData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocalCurrencyData>;
        }));
    }

    protected processGetLocalCurrencyData(response: HttpResponseBase): Observable<LocalCurrencyData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocalCurrencyData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userCount (optional) 
     * @return OK
     */
    getEditionsForSelect(userCount: number | undefined): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect?";
        if (userCount === null)
            throw new globalThis.Error("The parameter 'userCount' cannot be null.");
        else if (userCount !== undefined)
            url_ += "userCount=" + encodeURIComponent("" + userCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new globalThis.Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    checkEmail(email: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/CheckEmail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserByEmailAddress(email: string | undefined, tenantId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetUserByEmailAddress?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByEmailAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByEmailAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserByEmailAddress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    getTenantByEmailAddress(email: string | undefined): Observable<CurrentTenantInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetTenantByEmailAddress?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantByEmailAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantByEmailAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentTenantInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentTenantInfoDto>;
        }));
    }

    protected processGetTenantByEmailAddress(response: HttpResponseBase): Observable<CurrentTenantInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentTenantInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param companyName (optional) 
     * @return OK
     */
    checkTenantCreationEmail(email: string | undefined, companyName: string | undefined): Observable<TenantCreationVerifyEmailAndCompanyName> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/CheckTenantCreationEmail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (companyName === null)
            throw new globalThis.Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTenantCreationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTenantCreationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantCreationVerifyEmailAndCompanyName>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantCreationVerifyEmailAndCompanyName>;
        }));
    }

    protected processCheckTenantCreationEmail(response: HttpResponseBase): Observable<TenantCreationVerifyEmailAndCompanyName> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantCreationVerifyEmailAndCompanyName.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimeAndAttendanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param isFlag (optional) 
     * @return OK
     */
    getTimeAndAttendanceUserInfo(userId: number | undefined, isFlag: boolean | undefined): Observable<TimeAndAttendanceUserInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetTimeAndAttendanceUserInfo?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isFlag === null)
            throw new globalThis.Error("The parameter 'isFlag' cannot be null.");
        else if (isFlag !== undefined)
            url_ += "isFlag=" + encodeURIComponent("" + isFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeAndAttendanceUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeAndAttendanceUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeAndAttendanceUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeAndAttendanceUserInfoDto>;
        }));
    }

    protected processGetTimeAndAttendanceUserInfo(response: HttpResponseBase): Observable<TimeAndAttendanceUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAndAttendanceUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param isFlag (optional) 
     * @return OK
     */
    getTimeAndAttendanceListOfUserInfo(userIds: number[] | undefined, isFlag: boolean | undefined): Observable<TimeAndAttendanceUserInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetTimeAndAttendanceListOfUserInfo?";
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        if (isFlag === null)
            throw new globalThis.Error("The parameter 'isFlag' cannot be null.");
        else if (isFlag !== undefined)
            url_ += "isFlag=" + encodeURIComponent("" + isFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeAndAttendanceListOfUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeAndAttendanceListOfUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeAndAttendanceUserInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeAndAttendanceUserInfoDto[]>;
        }));
    }

    protected processGetTimeAndAttendanceListOfUserInfo(response: HttpResponseBase): Observable<TimeAndAttendanceUserInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeAndAttendanceUserInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param timeZoneOffset (optional) 
     * @param calenderDate (optional) 
     * @return OK
     */
    getProductiviyBarStartTime(userId: number | undefined, tenantId: number | undefined, timeZoneOffset: number | undefined, calenderDate: DateTime | undefined): Observable<ProductivityBarStartTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetProductiviyBarStartTime?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductiviyBarStartTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductiviyBarStartTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductivityBarStartTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductivityBarStartTimeDto>;
        }));
    }

    protected processGetProductiviyBarStartTime(response: HttpResponseBase): Observable<ProductivityBarStartTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductivityBarStartTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param currentDate (optional) 
     * @param prodCalDate (optional) 
     * @param weekRange (optional) 
     * @return OK
     */
    getActiveTimeSummaryForUser(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneOffset: number | undefined, currentDate: DateTime | undefined, prodCalDate: DateTime | undefined, weekRange: DateTime[] | undefined): Observable<ActiveTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetActiveTimeSummaryForUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "ProdCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (weekRange === null)
            throw new globalThis.Error("The parameter 'weekRange' cannot be null.");
        else if (weekRange !== undefined)
            weekRange && weekRange.forEach(item_ => { url_ += "WeekRange=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTimeSummaryForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTimeSummaryForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTimeDto>;
        }));
    }

    protected processGetActiveTimeSummaryForUser(response: HttpResponseBase): Observable<ActiveTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param currentDate (optional) 
     * @param prodCalDate (optional) 
     * @param weekRange (optional) 
     * @return OK
     */
    getCalculationOnTimeAndAttendance(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneOffset: number | undefined, currentDate: DateTime | undefined, prodCalDate: DateTime | undefined, weekRange: DateTime[] | undefined): Observable<CalculationTimeAndAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetCalculationOnTimeAndAttendance?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "ProdCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (weekRange === null)
            throw new globalThis.Error("The parameter 'weekRange' cannot be null.");
        else if (weekRange !== undefined)
            weekRange && weekRange.forEach(item_ => { url_ += "WeekRange=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationOnTimeAndAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationOnTimeAndAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationTimeAndAttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationTimeAndAttendanceDto>;
        }));
    }

    protected processGetCalculationOnTimeAndAttendance(response: HttpResponseBase): Observable<CalculationTimeAndAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationTimeAndAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param currentDate (optional) 
     * @param prodCalDate (optional) 
     * @param weekRange (optional) 
     * @return OK
     */
    getUserCalculationBaseOnActivity(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneOffset: number | undefined, currentDate: DateTime | undefined, prodCalDate: DateTime | undefined, weekRange: DateTime[] | undefined): Observable<CalculationTimeAndAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetUserCalculationBaseOnActivity?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "ProdCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (weekRange === null)
            throw new globalThis.Error("The parameter 'weekRange' cannot be null.");
        else if (weekRange !== undefined)
            weekRange && weekRange.forEach(item_ => { url_ += "WeekRange=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCalculationBaseOnActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCalculationBaseOnActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationTimeAndAttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationTimeAndAttendanceDto>;
        }));
    }

    protected processGetUserCalculationBaseOnActivity(response: HttpResponseBase): Observable<CalculationTimeAndAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationTimeAndAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param calenderDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param currentDate (optional) 
     * @param prodCalDate (optional) 
     * @param weekRange (optional) 
     * @return OK
     */
    getTimeATWorkAgentApp(userId: number | undefined, tenantId: number | undefined, calenderDate: DateTime | undefined, timeZoneOffset: number | undefined, currentDate: DateTime | undefined, prodCalDate: DateTime | undefined, weekRange: DateTime[] | undefined): Observable<CalculationTimeAndAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetTimeATWorkAgentApp?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (calenderDate === null)
            throw new globalThis.Error("The parameter 'calenderDate' cannot be null.");
        else if (calenderDate !== undefined)
            url_ += "CalenderDate=" + encodeURIComponent(calenderDate ? "" + calenderDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (currentDate === null)
            throw new globalThis.Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toString() : "") + "&";
        if (prodCalDate === null)
            throw new globalThis.Error("The parameter 'prodCalDate' cannot be null.");
        else if (prodCalDate !== undefined)
            url_ += "ProdCalDate=" + encodeURIComponent(prodCalDate ? "" + prodCalDate.toString() : "") + "&";
        if (weekRange === null)
            throw new globalThis.Error("The parameter 'weekRange' cannot be null.");
        else if (weekRange !== undefined)
            weekRange && weekRange.forEach(item_ => { url_ += "WeekRange=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeATWorkAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeATWorkAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationTimeAndAttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationTimeAndAttendanceDto>;
        }));
    }

    protected processGetTimeATWorkAgentApp(response: HttpResponseBase): Observable<CalculationTimeAndAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationTimeAndAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserTimeZoneDetails(userId: number | undefined, tenantId: number | undefined): Observable<UserTimeZoneDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetUserTimeZoneDetails?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTimeZoneDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTimeZoneDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTimeZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTimeZoneDto>;
        }));
    }

    protected processGetUserTimeZoneDetails(response: HttpResponseBase): Observable<UserTimeZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTimeZoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getProductivityBlobFileName(userId: number | undefined, tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetProductivityBlobFileName?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProductivityBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserTempActivityBlob(body: ManualActivityTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/UpdateUserTempActivityBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserTempActivityBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserTempActivityBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserTempActivityBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProductivityJsonBlob(body: ManualActivityTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/UpdateProductivityJsonBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductivityJsonBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductivityJsonBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProductivityJsonBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isManager (optional) 
     * @return OK
     */
    timeAndAttendanceHeaderDetails(tenantId: number | undefined, userId: number | undefined, isManager: boolean | undefined): Observable<TimeAndAttendanceHeaderDetails> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/TimeAndAttendanceHeaderDetails?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isManager === null)
            throw new globalThis.Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "isManager=" + encodeURIComponent("" + isManager) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeAndAttendanceHeaderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeAndAttendanceHeaderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeAndAttendanceHeaderDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeAndAttendanceHeaderDetails>;
        }));
    }

    protected processTimeAndAttendanceHeaderDetails(response: HttpResponseBase): Observable<TimeAndAttendanceHeaderDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeAndAttendanceHeaderDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param isFlag (optional) 
     * @return OK
     */
    combineUserDetails(userId: number | undefined, tenantId: number | undefined, isFlag: boolean | undefined): Observable<CombineUserInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/CombineUserDetails?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (isFlag === null)
            throw new globalThis.Error("The parameter 'isFlag' cannot be null.");
        else if (isFlag !== undefined)
            url_ += "isFlag=" + encodeURIComponent("" + isFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCombineUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCombineUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombineUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombineUserInfoDto>;
        }));
    }

    protected processCombineUserDetails(response: HttpResponseBase): Observable<CombineUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombineUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    listofUserVersionNotShowing(tenantId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/ListofUserVersionNotShowing?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListofUserVersionNotShowing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListofUserVersionNotShowing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processListofUserVersionNotShowing(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    listofUserLocationNotShowing(tenantId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/ListofUserLocationNotShowing?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListofUserLocationNotShowing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListofUserLocationNotShowing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processListofUserLocationNotShowing(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    serverDateAndTime(userId: number | undefined, tenantId: number | undefined): Observable<UserServerDateAndTimezone> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/ServerDateAndTime?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServerDateAndTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServerDateAndTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserServerDateAndTimezone>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserServerDateAndTimezone>;
        }));
    }

    protected processServerDateAndTime(response: HttpResponseBase): Observable<UserServerDateAndTimezone> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserServerDateAndTimezone.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param approveOrPending (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateApproveOrRejectManualTimeJob(approveOrPending: number | undefined, tenantId: number | undefined, userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendance/BulkUpdateApproveOrRejectManualTimeJob?";
        if (approveOrPending === null)
            throw new globalThis.Error("The parameter 'approveOrPending' cannot be null.");
        else if (approveOrPending !== undefined)
            url_ += "approveOrPending=" + encodeURIComponent("" + approveOrPending) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateApproveOrRejectManualTimeJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateApproveOrRejectManualTimeJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateApproveOrRejectManualTimeJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimeAndAttendanceDataSyncServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uploadProductivityBarToBlob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UploadProductivityBarToBlob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProductivityBarToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProductivityBarToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadProductivityBarToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uploadUserActivityTempToBlob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UploadUserActivityTempToBlob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadUserActivityTempToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadUserActivityTempToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadUserActivityTempToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getProductivityBlobFileName(userId: number | undefined, tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/GetProductivityBlobFileName?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivityBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivityBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetProductivityBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @return OK
     */
    getUserActivityTempBlobFileName(tenantId: number | undefined, startDate: DateTime | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/GetUserActivityTempBlobFileName?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTempBlobFileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTempBlobFileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserActivityTempBlobFileName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    truncateActivityTempTable(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/TruncateActivityTempTable?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruncateActivityTempTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruncateActivityTempTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTruncateActivityTempTable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param passDate (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    manualUploadUserActivityTempToBlob(passDate: string | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/ManualUploadUserActivityTempToBlob?";
        if (passDate === null)
            throw new globalThis.Error("The parameter 'passDate' cannot be null.");
        else if (passDate !== undefined)
            url_ += "passDate=" + encodeURIComponent("" + passDate) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManualUploadUserActivityTempToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualUploadUserActivityTempToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processManualUploadUserActivityTempToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    manuallyCheckTimeAndAttendanceCalculation(body: InputManuallyCalculationUserCalculation | undefined): Observable<ManuallyCalculationTimeAndAttendanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/ManuallyCheckTimeAndAttendanceCalculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManuallyCheckTimeAndAttendanceCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManuallyCheckTimeAndAttendanceCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManuallyCalculationTimeAndAttendanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManuallyCalculationTimeAndAttendanceDto[]>;
        }));
    }

    protected processManuallyCheckTimeAndAttendanceCalculation(response: HttpResponseBase): Observable<ManuallyCalculationTimeAndAttendanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManuallyCalculationTimeAndAttendanceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    submittedPendingOfflineTimeSummaryToEmail(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/SubmittedPendingOfflineTimeSummaryToEmail?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmittedPendingOfflineTimeSummaryToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmittedPendingOfflineTimeSummaryToEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmittedPendingOfflineTimeSummaryToEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    truncateProductivityBarCalculationDataTable(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/TruncateProductivityBarCalculationDataTable?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruncateProductivityBarCalculationDataTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruncateProductivityBarCalculationDataTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTruncateProductivityBarCalculationDataTable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uplodeUserStatustojso(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UplodeUserStatustojso?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeUserStatustojso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeUserStatustojso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUplodeUserStatustojso(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uplodeUserActivityTempjso(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UplodeUserActivityTempjso?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeUserActivityTempjso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeUserActivityTempjso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUplodeUserActivityTempjso(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uploadTenDaysUserScreenShotToJson(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UploadTenDaysUserScreenShotToJson?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTenDaysUserScreenShotToJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTenDaysUserScreenShotToJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadTenDaysUserScreenShotToJson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uploadTenDaysUserAvctivityToJson(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UploadTenDaysUserAvctivityToJson?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTenDaysUserAvctivityToJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTenDaysUserAvctivityToJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadTenDaysUserAvctivityToJson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    uploadTenDaysUserStatusToJson(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/UploadTenDaysUserStatusToJson?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTenDaysUserStatusToJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTenDaysUserStatusToJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadTenDaysUserStatusToJson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    timeAndAttendanceUserDaillyCalculation(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/TimeAndAttendanceUserDaillyCalculation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeAndAttendanceUserDaillyCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeAndAttendanceUserDaillyCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimeAndAttendanceUserDaillyCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param dateList (optional) 
     * @return OK
     */
    getCalCulatedUsersTimeAndAttendanceFiles(tenantId: number | undefined, fileType: FileType2, dateList: DateTime[] | undefined): Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/GetCalCulatedUsersTimeAndAttendanceFiles?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fileType === undefined || fileType === null)
            throw new globalThis.Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (dateList === null)
            throw new globalThis.Error("The parameter 'dateList' cannot be null.");
        else if (dateList !== undefined)
            dateList && dateList.forEach(item_ => { url_ += "dateList=" + encodeURIComponent(item_ ? "" + item_.toString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalCulatedUsersTimeAndAttendanceFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalCulatedUsersTimeAndAttendanceFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]>;
        }));
    }

    protected processGetCalCulatedUsersTimeAndAttendanceFiles(response: HttpResponseBase): Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTimeAndAttendanceUserDaillyCalculationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    calculateWeeklyTimeAndAttendanceUsersCalculation(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/CalculateWeeklyTimeAndAttendanceUsersCalculation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateWeeklyTimeAndAttendanceUsersCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateWeeklyTimeAndAttendanceUsersCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateWeeklyTimeAndAttendanceUsersCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param fileDate (optional) 
     * @return OK
     */
    getDaillyWeeklyMonthlyCalCulatedTimeAndAttendanceData(tenantId: number | undefined, userId: number | undefined, fileType: FileType3, fileDate: DateTime | undefined): Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/GetDaillyWeeklyMonthlyCalCulatedTimeAndAttendanceData?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (fileType === undefined || fileType === null)
            throw new globalThis.Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (fileDate === null)
            throw new globalThis.Error("The parameter 'fileDate' cannot be null.");
        else if (fileDate !== undefined)
            url_ += "fileDate=" + encodeURIComponent(fileDate ? "" + fileDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDaillyWeeklyMonthlyCalCulatedTimeAndAttendanceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDaillyWeeklyMonthlyCalCulatedTimeAndAttendanceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto>;
        }));
    }

    protected processGetDaillyWeeklyMonthlyCalCulatedTimeAndAttendanceData(response: HttpResponseBase): Observable<OutPutTimeAndAttendanceUserDaillyCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutTimeAndAttendanceUserDaillyCalculationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    calculateMonthlyTimeAndAttendanceUsersCalculation(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceDataSync/CalculateMonthlyTimeAndAttendanceUsersCalculation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateMonthlyTimeAndAttendanceUsersCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateMonthlyTimeAndAttendanceUsersCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateMonthlyTimeAndAttendanceUsersCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimeAndAttendanceReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAppiconList(): Observable<AgentApplicationDtoAgentApp[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceReport/GetAppiconList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppiconList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppiconList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationDtoAgentApp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationDtoAgentApp[]>;
        }));
    }

    protected processGetAppiconList(response: HttpResponseBase): Observable<AgentApplicationDtoAgentApp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationDtoAgentApp.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAppiconListV1(tenantId: number | undefined): Observable<AgentApplicationDtoAgentApp[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceReport/GetAppiconListV1?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppiconListV1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppiconListV1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentApplicationDtoAgentApp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentApplicationDtoAgentApp[]>;
        }));
    }

    protected processGetAppiconListV1(response: HttpResponseBase): Observable<AgentApplicationDtoAgentApp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentApplicationDtoAgentApp.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    combineApplicationDetails(body: InputeTypeWiseCategoryAndApplicationDto | undefined): Observable<CombineApplicationTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceReport/CombineApplicationDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCombineApplicationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCombineApplicationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CombineApplicationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CombineApplicationTypeDto>;
        }));
    }

    protected processCombineApplicationDetails(response: HttpResponseBase): Observable<CombineApplicationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CombineApplicationTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getweeklyReport(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceReport/GetweeklyReport?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetweeklyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetweeklyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetweeklyReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userReportingLocation (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getUserReportingLocationTimeZone(userReportingLocation: number | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TimeAndAttendanceReport/GetUserReportingLocationTimeZone?";
        if (userReportingLocation === null)
            throw new globalThis.Error("The parameter 'userReportingLocation' cannot be null.");
        else if (userReportingLocation !== undefined)
            url_ += "userReportingLocation=" + encodeURIComponent("" + userReportingLocation) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserReportingLocationTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserReportingLocationTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserReportingLocationTimeZone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimesheetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendForApprovalTimesheet(timeZoneOffset: number | undefined, body: SendForApprovalTimesheetDto | undefined): Observable<IsCheckTimesheetFlag> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/SendForApprovalTimesheet?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendForApprovalTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendForApprovalTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsCheckTimesheetFlag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsCheckTimesheetFlag>;
        }));
    }

    protected processSendForApprovalTimesheet(response: HttpResponseBase): Observable<IsCheckTimesheetFlag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsCheckTimesheetFlag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editMyTimesheet(body: DraftedTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/EditMyTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditMyTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditMyTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditMyTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editMyTimesheetForMobile(body: DraftedTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/EditMyTimesheetForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditMyTimesheetForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditMyTimesheetForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditMyTimesheetForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditDraftTimesheet(body: DraftedTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/CreateOrEditDraftTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditDraftTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditDraftTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditDraftTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditTimeSheet(body: InputeCreateOrEditTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/CreateOrEditTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reSubmiteTimesheet(body: SendForApprovalTimesheetDto[] | undefined): Observable<IsCheckTimesheetFlag> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/ReSubmiteTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSubmiteTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSubmiteTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsCheckTimesheetFlag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsCheckTimesheetFlag>;
        }));
    }

    protected processReSubmiteTimesheet(response: HttpResponseBase): Observable<IsCheckTimesheetFlag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsCheckTimesheetFlag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param userId (optional) 
     * @param isMytimesheet (optional) 
     * @param dateTime (optional) 
     * @return OK
     */
    getTaskLogByTaskId(taskId: number | undefined, userId: number | undefined, isMytimesheet: boolean | undefined, dateTime: DateTime | undefined): Observable<TaskLogOutPutDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTaskLogByTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isMytimesheet === null)
            throw new globalThis.Error("The parameter 'isMytimesheet' cannot be null.");
        else if (isMytimesheet !== undefined)
            url_ += "isMytimesheet=" + encodeURIComponent("" + isMytimesheet) + "&";
        if (dateTime === null)
            throw new globalThis.Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLogByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLogByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLogOutPutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLogOutPutDto>;
        }));
    }

    protected processGetTaskLogByTaskId(response: HttpResponseBase): Observable<TaskLogOutPutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskLogOutPutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getTaskEsstimateHoursByTaskId(taskId: number | undefined): Observable<GetTaskEsstimateHoursByTaskId> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTaskEsstimateHoursByTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskEsstimateHoursByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskEsstimateHoursByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskEsstimateHoursByTaskId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskEsstimateHoursByTaskId>;
        }));
    }

    protected processGetTaskEsstimateHoursByTaskId(response: HttpResponseBase): Observable<GetTaskEsstimateHoursByTaskId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaskEsstimateHoursByTaskId.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param timesheetId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isMyTimesheet (optional) 
     * @return OK
     */
    getTaskLogByMyTimesheetAndTeamTimesheetTaskId(taskId: number | undefined, timesheetId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, isMyTimesheet: boolean | undefined): Observable<TaskLogOutPutDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTaskLogByMyTimesheetAndTeamTimesheetTaskId?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (isMyTimesheet === null)
            throw new globalThis.Error("The parameter 'isMyTimesheet' cannot be null.");
        else if (isMyTimesheet !== undefined)
            url_ += "IsMyTimesheet=" + encodeURIComponent("" + isMyTimesheet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLogByMyTimesheetAndTeamTimesheetTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLogByMyTimesheetAndTeamTimesheetTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLogOutPutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLogOutPutDto>;
        }));
    }

    protected processGetTaskLogByMyTimesheetAndTeamTimesheetTaskId(response: HttpResponseBase): Observable<TaskLogOutPutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskLogOutPutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param isAgentApp (optional) 
     * @param tenantId (optional) 
     * @param timesheetDuration (optional) 
     * @param timesheetStatus (optional) 
     * @param timesheetId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sortByNewestOnTop (optional) 
     * @param isCalledFromDashboard (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAllTimeSheets(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, isAgentApp: boolean | undefined, tenantId: number | undefined, timesheetDuration: (string | undefined)[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, timesheetId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, sortByNewestOnTop: boolean | undefined, isCalledFromDashboard: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<MyTimesheetGridDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetAllTimeSheets?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (isAgentApp === null)
            throw new globalThis.Error("The parameter 'isAgentApp' cannot be null.");
        else if (isAgentApp !== undefined)
            url_ += "IsAgentApp=" + encodeURIComponent("" + isAgentApp) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timesheetDuration === null)
            throw new globalThis.Error("The parameter 'timesheetDuration' cannot be null.");
        else if (timesheetDuration !== undefined)
            timesheetDuration && timesheetDuration.forEach(item => { url_ += "TimesheetDuration=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (sortByNewestOnTop === null)
            throw new globalThis.Error("The parameter 'sortByNewestOnTop' cannot be null.");
        else if (sortByNewestOnTop !== undefined)
            url_ += "sortByNewestOnTop=" + encodeURIComponent("" + sortByNewestOnTop) + "&";
        if (isCalledFromDashboard === null)
            throw new globalThis.Error("The parameter 'isCalledFromDashboard' cannot be null.");
        else if (isCalledFromDashboard !== undefined)
            url_ += "IsCalledFromDashboard=" + encodeURIComponent("" + isCalledFromDashboard) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTimeSheets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTimeSheets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyTimesheetGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyTimesheetGridDto>;
        }));
    }

    protected processGetAllTimeSheets(response: HttpResponseBase): Observable<MyTimesheetGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyTimesheetGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param isAgentApp (optional) 
     * @param tenantId (optional) 
     * @param timesheetDuration (optional) 
     * @param timesheetStatus (optional) 
     * @param timesheetId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sortByNewestOnTop (optional) 
     * @param isCalledFromDashboard (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getUserTimeSheetById(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, isAgentApp: boolean | undefined, tenantId: number | undefined, timesheetDuration: (string | undefined)[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, timesheetId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, sortByNewestOnTop: boolean | undefined, isCalledFromDashboard: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfTimeSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetUserTimeSheetById?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (isAgentApp === null)
            throw new globalThis.Error("The parameter 'isAgentApp' cannot be null.");
        else if (isAgentApp !== undefined)
            url_ += "IsAgentApp=" + encodeURIComponent("" + isAgentApp) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timesheetDuration === null)
            throw new globalThis.Error("The parameter 'timesheetDuration' cannot be null.");
        else if (timesheetDuration !== undefined)
            timesheetDuration && timesheetDuration.forEach(item => { url_ += "TimesheetDuration=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (sortByNewestOnTop === null)
            throw new globalThis.Error("The parameter 'sortByNewestOnTop' cannot be null.");
        else if (sortByNewestOnTop !== undefined)
            url_ += "sortByNewestOnTop=" + encodeURIComponent("" + sortByNewestOnTop) + "&";
        if (isCalledFromDashboard === null)
            throw new globalThis.Error("The parameter 'isCalledFromDashboard' cannot be null.");
        else if (isCalledFromDashboard !== undefined)
            url_ += "IsCalledFromDashboard=" + encodeURIComponent("" + isCalledFromDashboard) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTimeSheetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTimeSheetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTimeSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTimeSheetDto>;
        }));
    }

    protected processGetUserTimeSheetById(response: HttpResponseBase): Observable<PagedResultDtoOfTimeSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTimeSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param timesheetId (optional) 
     * @param userId (optional) 
     * @param weeks (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getAllMyTimesheetTaskByProjectId(projectId: number | undefined, timesheetId: number | undefined, userId: number | undefined, weeks: string[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum, timeZoneOffset: number | undefined): Observable<GetAllTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetAllMyTimesheetTaskByProjectId?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMyTimesheetTaskByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMyTimesheetTaskByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTaskDto[]>;
        }));
    }

    protected processGetAllMyTimesheetTaskByProjectId(response: HttpResponseBase): Observable<GetAllTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetIds (optional) 
     * @return OK
     */
    getSubmittedTimesheetStates(timesheetIds: number[] | undefined): Observable<TimesheetStatesDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetSubmittedTimesheetStates?";
        if (timesheetIds === null)
            throw new globalThis.Error("The parameter 'timesheetIds' cannot be null.");
        else if (timesheetIds !== undefined)
            timesheetIds && timesheetIds.forEach(item => { url_ += "timesheetIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmittedTimesheetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedTimesheetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetStatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetStatesDto>;
        }));
    }

    protected processGetSubmittedTimesheetStates(response: HttpResponseBase): Observable<TimesheetStatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetStatesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetId (optional) 
     * @return OK
     */
    getApprovalHistory(timesheetId: number | undefined): Observable<TimesheetApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetApprovalHistory?";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "timesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetApprovalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetApprovalDto[]>;
        }));
    }

    protected processGetApprovalHistory(response: HttpResponseBase): Observable<TimesheetApprovalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimesheetApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param timesheetId (optional) 
     * @param includeMine (optional) 
     * @param sortByNewestOnTop (optional) 
     * @param timesheetStatus (optional) 
     * @param isSummary (optional) 
     * @param isExport (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTeamsTimeSheet(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, timesheetId: number | undefined, includeMine: boolean | undefined, sortByNewestOnTop: boolean | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, isSummary: boolean | undefined, isExport: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfTimeSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTeamsTimeSheet?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (includeMine === null)
            throw new globalThis.Error("The parameter 'includeMine' cannot be null.");
        else if (includeMine !== undefined)
            url_ += "IncludeMine=" + encodeURIComponent("" + includeMine) + "&";
        if (sortByNewestOnTop === null)
            throw new globalThis.Error("The parameter 'sortByNewestOnTop' cannot be null.");
        else if (sortByNewestOnTop !== undefined)
            url_ += "sortByNewestOnTop=" + encodeURIComponent("" + sortByNewestOnTop) + "&";
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (isSummary === null)
            throw new globalThis.Error("The parameter 'isSummary' cannot be null.");
        else if (isSummary !== undefined)
            url_ += "IsSummary=" + encodeURIComponent("" + isSummary) + "&";
        if (isExport === null)
            throw new globalThis.Error("The parameter 'isExport' cannot be null.");
        else if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamsTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamsTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTimeSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTimeSheetDto>;
        }));
    }

    protected processGetTeamsTimeSheet(response: HttpResponseBase): Observable<PagedResultDtoOfTimeSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTimeSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataSourceLoadOptions (optional) 
     * @param timeZoneOffset (optional) 
     * @param timesheetStatus (optional) 
     * @param projectIds (optional) 
     * @param isShowAll (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTimesheetApproval(dataSourceLoadOptions: string | undefined, timeZoneOffset: number | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, projectIds: number[] | undefined, isShowAll: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfOutPutTimesheetApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTimesheetApproval?";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOutPutTimesheetApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOutPutTimesheetApprovalDto>;
        }));
    }

    protected processGetTimesheetApproval(response: HttpResponseBase): Observable<PagedResultDtoOfOutPutTimesheetApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOutPutTimesheetApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTeamTimesheetHeaderDetails(): Observable<TeamTimesheetHeaderFiledDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTeamTimesheetHeaderDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamTimesheetHeaderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamTimesheetHeaderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamTimesheetHeaderFiledDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamTimesheetHeaderFiledDto>;
        }));
    }

    protected processGetTeamTimesheetHeaderDetails(response: HttpResponseBase): Observable<TeamTimesheetHeaderFiledDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamTimesheetHeaderFiledDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTeamTimesheetStats(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTeamTimesheetStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamTimesheetStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamTimesheetStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTeamTimesheetStats(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param timesheetStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getMyTimesheetStats(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<MyTimesheetStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetMyTimesheetStats?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTimesheetStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTimesheetStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyTimesheetStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyTimesheetStatsDto>;
        }));
    }

    protected processGetMyTimesheetStats(response: HttpResponseBase): Observable<MyTimesheetStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyTimesheetStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param timesheetStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param timesheetId (optional) 
     * @param search (optional) 
     * @param includeMine (optional) 
     * @param usrId (optional) 
     * @param tenantId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTeamsTimeSheetForMobile(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, timesheetId: number | undefined, search: string | undefined, includeMine: boolean | undefined, usrId: number | undefined, tenantId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<GetTeamsTimeSheetForMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTeamsTimeSheetForMobile?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (includeMine === null)
            throw new globalThis.Error("The parameter 'includeMine' cannot be null.");
        else if (includeMine !== undefined)
            url_ += "IncludeMine=" + encodeURIComponent("" + includeMine) + "&";
        if (usrId === null)
            throw new globalThis.Error("The parameter 'usrId' cannot be null.");
        else if (usrId !== undefined)
            url_ += "usrId=" + encodeURIComponent("" + usrId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamsTimeSheetForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamsTimeSheetForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTeamsTimeSheetForMobileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTeamsTimeSheetForMobileDto>;
        }));
    }

    protected processGetTeamsTimeSheetForMobile(response: HttpResponseBase): Observable<GetTeamsTimeSheetForMobileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTeamsTimeSheetForMobileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTeamsTimeSheetById(id: number | undefined): Observable<TimeSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTeamsTimeSheetById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamsTimeSheetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamsTimeSheetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSheetDto>;
        }));
    }

    protected processGetTeamsTimeSheetById(response: HttpResponseBase): Observable<TimeSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param userIds (optional) 
     * @return OK
     */
    getProjectListForViewSummary(projectIds: number[] | undefined, userIds: number[] | undefined): Observable<ProjectListViewSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetProjectListForViewSummary?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectListForViewSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectListForViewSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectListViewSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectListViewSummaryDto[]>;
        }));
    }

    protected processGetProjectListForViewSummary(response: HttpResponseBase): Observable<ProjectListViewSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectListViewSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param userIds (optional) 
     * @return OK
     */
    getProjectListForClient(projectIds: number[] | undefined, userIds: number[] | undefined): Observable<ProjectListViewSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetProjectListForClient?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectListForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectListForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectListViewSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectListViewSummaryDto[]>;
        }));
    }

    protected processGetProjectListForClient(response: HttpResponseBase): Observable<ProjectListViewSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectListViewSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManualTimeSheet(body: AddTimesheetDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/AddManualTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddManualTimeSheet(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateManualTaskTimeSheet(body: AddTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/UpdateManualTaskTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateManualTaskTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateManualTaskTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateManualTaskTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteManualTaskTimeSheet(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/DeleteManualTaskTimeSheet?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualTaskTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualTaskTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteManualTaskTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetApproveReject(body: ApproveRejectTimesheetDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/TimesheetApproveReject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetApproveReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetApproveReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetApproveReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addCommentTaskWise(body: AddCommentTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/AddCommentTaskWise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCommentTaskWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCommentTaskWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCommentTaskWise(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCommentTask(body: AddCommentTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/UpdateCommentTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommentTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommentTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCommentTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param taskId (optional) 
     * @return OK
     */
    getTaskComment(userId: number | undefined, tenantId: number | undefined, taskId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTaskComment?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetTaskComment(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProjectLevelComment(body: ProjectLevelCommentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/AddProjectLevelComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectLevelComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectLevelComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProjectLevelComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectLevelComments(projectId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetProjectLevelComments?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectLevelComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectLevelComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetProjectLevelComments(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param billableType (optional) 
     * @param filter (optional) 
     * @param week (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getAllMonthlyProjectViewForTimesheet(projectId: (number | undefined)[] | undefined, billableType: ProjectBillingType | undefined, filter: string | undefined, week: string[] | undefined, timeZoneOffset: number | undefined): Observable<GetAllProjectTimeSheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetAllMonthlyProjectViewForTimesheet?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (billableType === null)
            throw new globalThis.Error("The parameter 'billableType' cannot be null.");
        else if (billableType !== undefined)
            url_ += "BillableType=" + encodeURIComponent("" + billableType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (week === null)
            throw new globalThis.Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            week && week.forEach(item => { url_ += "Week=" + encodeURIComponent("" + item) + "&"; });
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMonthlyProjectViewForTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMonthlyProjectViewForTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectTimeSheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectTimeSheetDto[]>;
        }));
    }

    protected processGetAllMonthlyProjectViewForTimesheet(response: HttpResponseBase): Observable<GetAllProjectTimeSheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectTimeSheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param billableType (optional) 
     * @param filter (optional) 
     * @param week (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getAllProjectListForTimeSheet(projectId: (number | undefined)[] | undefined, billableType: ProjectBillingType | undefined, filter: string | undefined, week: string[] | undefined, timeZoneOffset: number | undefined): Observable<GetAllProjectTimeSheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetAllProjectListForTimeSheet?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (billableType === null)
            throw new globalThis.Error("The parameter 'billableType' cannot be null.");
        else if (billableType !== undefined)
            url_ += "BillableType=" + encodeURIComponent("" + billableType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (week === null)
            throw new globalThis.Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            week && week.forEach(item => { url_ += "Week=" + encodeURIComponent("" + item) + "&"; });
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectListForTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectListForTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllProjectTimeSheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllProjectTimeSheetDto[]>;
        }));
    }

    protected processGetAllProjectListForTimeSheet(response: HttpResponseBase): Observable<GetAllProjectTimeSheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllProjectTimeSheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param weeks (optional) 
     * @param filter (optional) 
     * @param billabilityStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param timeZoneOffset (optional) 
     * @return OK
     */
    getAllTaskByProjectId(projectId: number | undefined, weeks: string[] | undefined, filter: string | undefined, billabilityStatus: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum, timeZoneOffset: number | undefined): Observable<GetAllTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetAllTaskByProjectId?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            url_ += "BillabilityStatus=" + encodeURIComponent("" + billabilityStatus) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTaskDto[]>;
        }));
    }

    protected processGetAllTaskByProjectId(response: HttpResponseBase): Observable<GetAllTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param weeks (optional) 
     * @param filter (optional) 
     * @param billabilityStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getTimesheetMonthlyView(projectId: number | undefined, weeks: string[] | undefined, filter: string | undefined, billabilityStatus: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum): Observable<GetAllTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTimesheetMonthlyView?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            url_ += "BillabilityStatus=" + encodeURIComponent("" + billabilityStatus) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetMonthlyView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetMonthlyView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTaskDto[]>;
        }));
    }

    protected processGetTimesheetMonthlyView(response: HttpResponseBase): Observable<GetAllTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getIncludeInTimesheet(timesheetDate: DateTime | undefined, userId: number | undefined, tenantId: number | undefined): Observable<TaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetIncludeInTimesheet?";
        if (timesheetDate === null)
            throw new globalThis.Error("The parameter 'timesheetDate' cannot be null.");
        else if (timesheetDate !== undefined)
            url_ += "TimesheetDate=" + encodeURIComponent(timesheetDate ? "" + timesheetDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncludeInTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncludeInTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskListDto[]>;
        }));
    }

    protected processGetIncludeInTimesheet(response: HttpResponseBase): Observable<TaskListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getEstimatedBillableLoggedBillableRemaining(projectId: number | undefined, userId: number | undefined): Observable<TimesheetFrequencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetEstimatedBillableLoggedBillableRemaining?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatedBillableLoggedBillableRemaining(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatedBillableLoggedBillableRemaining(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetFrequencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetFrequencyDto>;
        }));
    }

    protected processGetEstimatedBillableLoggedBillableRemaining(response: HttpResponseBase): Observable<TimesheetFrequencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetFrequencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param timeSheetStartDate (optional) 
     * @param timeSheetEndDate (optional) 
     * @param isInternalCall (optional) 
     * @return OK
     */
    getDraftedTimesheetStates(projectId: number | undefined, userId: number | undefined, timeSheetStartDate: DateTime | undefined, timeSheetEndDate: DateTime | undefined, isInternalCall: boolean | undefined): Observable<TimesheetStatesDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetDraftedTimesheetStates?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (timeSheetStartDate === null)
            throw new globalThis.Error("The parameter 'timeSheetStartDate' cannot be null.");
        else if (timeSheetStartDate !== undefined)
            url_ += "timeSheetStartDate=" + encodeURIComponent(timeSheetStartDate ? "" + timeSheetStartDate.toString() : "") + "&";
        if (timeSheetEndDate === null)
            throw new globalThis.Error("The parameter 'timeSheetEndDate' cannot be null.");
        else if (timeSheetEndDate !== undefined)
            url_ += "timeSheetEndDate=" + encodeURIComponent(timeSheetEndDate ? "" + timeSheetEndDate.toString() : "") + "&";
        if (isInternalCall === null)
            throw new globalThis.Error("The parameter 'isInternalCall' cannot be null.");
        else if (isInternalCall !== undefined)
            url_ += "isInternalCall=" + encodeURIComponent("" + isInternalCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftedTimesheetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftedTimesheetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetStatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetStatesDto>;
        }));
    }

    protected processGetDraftedTimesheetStates(response: HttpResponseBase): Observable<TimesheetStatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetStatesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getEstimatedBillableLoggedBillableRemainingWithTenantID(projectId: number | undefined, tenantId: number | undefined, userId: number | undefined): Observable<TimesheetFrequencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetEstimatedBillableLoggedBillableRemainingWithTenantID?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatedBillableLoggedBillableRemainingWithTenantID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatedBillableLoggedBillableRemainingWithTenantID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetFrequencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetFrequencyDto>;
        }));
    }

    protected processGetEstimatedBillableLoggedBillableRemainingWithTenantID(response: HttpResponseBase): Observable<TimesheetFrequencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetFrequencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProjectLevelShowInTimeSheet(body: ProjectLevelShowInTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/CreateProjectLevelShowInTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectLevelShowInTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectLevelShowInTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProjectLevelShowInTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProjectLevelShowInTimeSheetForMobile(body: ProjectLevelShowInTimesheetDtoForMobile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/CreateProjectLevelShowInTimeSheetForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectLevelShowInTimeSheetForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectLevelShowInTimeSheetForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProjectLevelShowInTimeSheetForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    overdueTimesheetEmailAndNotification(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/OverdueTimesheetEmailAndNotification?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverdueTimesheetEmailAndNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverdueTimesheetEmailAndNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOverdueTimesheetEmailAndNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    isTimeSheetApprovar(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/IsTimeSheetApprovar?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTimeSheetApprovar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTimeSheetApprovar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTimeSheetApprovar(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getTimeSheetsByProjectId(projectId: number | undefined, filter: string | undefined): Observable<TimeSheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTimeSheetsByProjectId?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeSheetsByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeSheetsByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSheetDto[]>;
        }));
    }

    protected processGetTimeSheetsByProjectId(response: HttpResponseBase): Observable<TimeSheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeSheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return OK
     */
    getProjectViewSummaryV2(projectId: number | undefined, skip: number | undefined, take: number | undefined): Observable<ViewSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetProjectViewSummaryV2?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectViewSummaryV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectViewSummaryV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewSummaryDto[]>;
        }));
    }

    protected processGetProjectViewSummaryV2(response: HttpResponseBase): Observable<ViewSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectViewSummary(projectId: number | undefined): Observable<ViewSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetProjectViewSummary?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectViewSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectViewSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewSummaryDto[]>;
        }));
    }

    protected processGetProjectViewSummary(response: HttpResponseBase): Observable<ViewSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getReminderUserList(projectId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<UserReminderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetReminderUserList?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReminderUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReminderUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReminderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReminderDto[]>;
        }));
    }

    protected processGetReminderUserList(response: HttpResponseBase): Observable<UserReminderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserReminderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendReminder(body: SendReminderDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/SendReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendReminder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approvedTimesheetSendToClient(body: SendTimesheetToClient | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/ApprovedTimesheetSendToClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedTimesheetSendToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedTimesheetSendToClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovedTimesheetSendToClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTimesheetLevelComments(body: AddTimesheetLevelCommentDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/AddTimesheetLevelComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTimesheetLevelComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTimesheetLevelComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTimesheetLevelComments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param myTimeSheetId (optional) 
     * @param comments (optional) 
     * @return OK
     */
    getTimesheetLevelComments(userId: number | undefined, tenantId: number | undefined, myTimeSheetId: number | undefined, comments: string | undefined): Observable<GetTimesheetLevelCommentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetTimesheetLevelComments?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (myTimeSheetId === null)
            throw new globalThis.Error("The parameter 'myTimeSheetId' cannot be null.");
        else if (myTimeSheetId !== undefined)
            url_ += "MyTimeSheetId=" + encodeURIComponent("" + myTimeSheetId) + "&";
        if (comments === null)
            throw new globalThis.Error("The parameter 'comments' cannot be null.");
        else if (comments !== undefined)
            url_ += "Comments=" + encodeURIComponent("" + comments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetLevelComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetLevelComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTimesheetLevelCommentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTimesheetLevelCommentDto[]>;
        }));
    }

    protected processGetTimesheetLevelComments(response: HttpResponseBase): Observable<GetTimesheetLevelCommentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTimesheetLevelCommentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isAlreadySubmmitedTimesheet(body: IsTimesheetSubmiteDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/IsAlreadySubmmitedTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAlreadySubmmitedTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAlreadySubmmitedTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsAlreadySubmmitedTimesheet(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenandId (optional) 
     * @return OK
     */
    reminderForSubmiteYourTimesheet(tenandId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/ReminderForSubmiteYourTimesheet?";
        if (tenandId === null)
            throw new globalThis.Error("The parameter 'tenandId' cannot be null.");
        else if (tenandId !== undefined)
            url_ += "tenandId=" + encodeURIComponent("" + tenandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReminderForSubmiteYourTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReminderForSubmiteYourTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReminderForSubmiteYourTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    setSequenceNoToTimesheetApprovals(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/SetSequenceNoToTimesheetApprovals?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSequenceNoToTimesheetApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSequenceNoToTimesheetApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetSequenceNoToTimesheetApprovals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    pendingTimesheetSendOneEmail(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/PendingTimesheetSendOneEmail?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingTimesheetSendOneEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingTimesheetSendOneEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPendingTimesheetSendOneEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    pendingTimesheetNextLevelApproverSummaryEmail(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/PendingTimesheetNextLevelApproverSummaryEmail?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingTimesheetNextLevelApproverSummaryEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingTimesheetNextLevelApproverSummaryEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPendingTimesheetNextLevelApproverSummaryEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    teamTimesheetDetailsDashbord(body: InputeTeamTimesheet | undefined): Observable<PagedResultDtoOfTimeSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/TeamTimesheetDetailsDashbord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTeamTimesheetDetailsDashbord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTeamTimesheetDetailsDashbord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTimeSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTimeSheetDto>;
        }));
    }

    protected processTeamTimesheetDetailsDashbord(response: HttpResponseBase): Observable<PagedResultDtoOfTimeSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTimeSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetUpdateStatusApproveAfterReject(userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/TimesheetUpdateStatusApproveAfterReject?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetUpdateStatusApproveAfterReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetUpdateStatusApproveAfterReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetUpdateStatusApproveAfterReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    updateTimesheetBilledLoggedAndRequiredHourseBaseOnTimesheet(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/UpdateTimesheetBilledLoggedAndRequiredHourseBaseOnTimesheet?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimesheetBilledLoggedAndRequiredHourseBaseOnTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimesheetBilledLoggedAndRequiredHourseBaseOnTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTimesheetBilledLoggedAndRequiredHourseBaseOnTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    publicholidayDate(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<Holidays[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/PublicholidayDate?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublicholidayDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublicholidayDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Holidays[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Holidays[]>;
        }));
    }

    protected processPublicholidayDate(response: HttpResponseBase): Observable<Holidays[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Holidays.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getLeaveDates(startDate: DateTime | undefined, endDate: DateTime | undefined, userId: number | undefined): Observable<LeaveDays[]> {
        let url_ = this.baseUrl + "/api/services/app/Timesheet/GetLeaveDates?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveDays[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveDays[]>;
        }));
    }

    protected processGetLeaveDates(response: HttpResponseBase): Observable<LeaveDays[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveDays.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimesheetMobileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param isAgentApp (optional) 
     * @param timesheetDuration (optional) 
     * @param timesheetStatus (optional) 
     * @param timesheetId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param usrId (optional) 
     * @param tenantId (optional) 
     * @param search (optional) 
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @return OK
     */
    getAllTimeSheetsForMobile(userId: (number | undefined)[] | undefined, projectId: (number | undefined)[] | undefined, isAgentApp: boolean | undefined, timesheetDuration: (string | undefined)[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, timesheetId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, usrId: number | undefined, tenantId: number | undefined, search: string | undefined, skipCount: number | undefined, takeCount: number | undefined): Observable<GetAllTimeSheetsForMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetAllTimeSheetsForMobile?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (isAgentApp === null)
            throw new globalThis.Error("The parameter 'isAgentApp' cannot be null.");
        else if (isAgentApp !== undefined)
            url_ += "IsAgentApp=" + encodeURIComponent("" + isAgentApp) + "&";
        if (timesheetDuration === null)
            throw new globalThis.Error("The parameter 'timesheetDuration' cannot be null.");
        else if (timesheetDuration !== undefined)
            timesheetDuration && timesheetDuration.forEach(item => { url_ += "TimesheetDuration=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (usrId === null)
            throw new globalThis.Error("The parameter 'usrId' cannot be null.");
        else if (usrId !== undefined)
            url_ += "usrId=" + encodeURIComponent("" + usrId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount === null)
            throw new globalThis.Error("The parameter 'takeCount' cannot be null.");
        else if (takeCount !== undefined)
            url_ += "takeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTimeSheetsForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTimeSheetsForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTimeSheetsForMobileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTimeSheetsForMobileDto>;
        }));
    }

    protected processGetAllTimeSheetsForMobile(response: HttpResponseBase): Observable<GetAllTimeSheetsForMobileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllTimeSheetsForMobileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateManualTaskTimeSheetForMobile(body: AddTimesheetDtoForMobile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/UpdateManualTaskTimeSheetForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateManualTaskTimeSheetForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateManualTaskTimeSheetForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateManualTaskTimeSheetForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManualTimeSheet(body: AddTimesheetDtoForMobile | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/AddManualTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddManualTimeSheet(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param timesheetId (optional) 
     * @param userId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getAllTimesheetTaskByProjectIdMobile(projectId: number | undefined, timesheetId: number | undefined, userId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, tenantId: number | undefined): Observable<GetTimesheetTasksMobile[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetAllTimesheetTaskByProjectIdMobile?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "timesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTimesheetTaskByProjectIdMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTimesheetTaskByProjectIdMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTimesheetTasksMobile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTimesheetTasksMobile[]>;
        }));
    }

    protected processGetAllTimesheetTaskByProjectIdMobile(response: HttpResponseBase): Observable<GetTimesheetTasksMobile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTimesheetTasksMobile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param timesheetId (optional) 
     * @param userId (optional) 
     * @param weeks (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param tenantId (optional) 
     * @param particularDate (optional) 
     * @return OK
     */
    getAllTimesheetTaskByProjectIdMobileForParticularDate(projectId: number | undefined, timesheetId: number | undefined, userId: number | undefined, weeks: string[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, tenantId: number | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum, particularDate: DateTime | undefined): Observable<GetAllTaskDtoForMoblie> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetAllTimesheetTaskByProjectIdMobileForParticularDate?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        if (particularDate === null)
            throw new globalThis.Error("The parameter 'particularDate' cannot be null.");
        else if (particularDate !== undefined)
            url_ += "particularDate=" + encodeURIComponent(particularDate ? "" + particularDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTimesheetTaskByProjectIdMobileForParticularDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTimesheetTaskByProjectIdMobileForParticularDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTaskDtoForMoblie>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTaskDtoForMoblie>;
        }));
    }

    protected processGetAllTimesheetTaskByProjectIdMobileForParticularDate(response: HttpResponseBase): Observable<GetAllTaskDtoForMoblie> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllTaskDtoForMoblie.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param timesheetId (optional) 
     * @param userId (optional) 
     * @param weeks (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getAllTimesheetTaskByProjectIdMobileNew(projectId: number | undefined, timesheetId: number | undefined, userId: number | undefined, weeks: string[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, tenantId: number | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum): Observable<GetAllTaskDtoForMoblie[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetAllTimesheetTaskByProjectIdMobileNew?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTimesheetTaskByProjectIdMobileNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTimesheetTaskByProjectIdMobileNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllTaskDtoForMoblie[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllTaskDtoForMoblie[]>;
        }));
    }

    protected processGetAllTimesheetTaskByProjectIdMobileNew(response: HttpResponseBase): Observable<GetAllTaskDtoForMoblie[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllTaskDtoForMoblie.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getEstimatedBillableLoggedBillableRemainingMobile(projectId: number | undefined, tenantId: number | undefined, userId: number | undefined): Observable<TimesheetFrequencyDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetEstimatedBillableLoggedBillableRemainingMobile?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatedBillableLoggedBillableRemainingMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatedBillableLoggedBillableRemainingMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetFrequencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetFrequencyDto>;
        }));
    }

    protected processGetEstimatedBillableLoggedBillableRemainingMobile(response: HttpResponseBase): Observable<TimesheetFrequencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetFrequencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApprovalHistoryMobile(timesheetId: number | undefined, tenantId: number | undefined): Observable<TimesheetApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetApprovalHistoryMobile?";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "timesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalHistoryMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalHistoryMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetApprovalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetApprovalDto[]>;
        }));
    }

    protected processGetApprovalHistoryMobile(response: HttpResponseBase): Observable<TimesheetApprovalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimesheetApprovalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getProjectLevelCommentsMobile(projectId: number | undefined, tenantId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetProjectLevelCommentsMobile?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectLevelCommentsMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectLevelCommentsMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetProjectLevelCommentsMobile(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getProfilePictureByUserIdForMobile(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetProfilePictureByUserIdForMobile?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserIdForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserIdForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserIdForMobile(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    deleteManualTaskTimeSheetForMobile(id: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/DeleteManualTaskTimeSheetForMobile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualTaskTimeSheetForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualTaskTimeSheetForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteManualTaskTimeSheetForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTimesheetLevelCommentsForMobile(body: AddTimesheetLevelCommentDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/AddTimesheetLevelCommentsForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTimesheetLevelCommentsForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTimesheetLevelCommentsForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTimesheetLevelCommentsForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTimesheetLevelSingleCommentsForMobile(body: AddTimesheetLevelCommentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/AddTimesheetLevelSingleCommentsForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTimesheetLevelSingleCommentsForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTimesheetLevelSingleCommentsForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTimesheetLevelSingleCommentsForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetApproveRejectForMobile(body: ApproveRejectTimesheetDtoForMobile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/TimesheetApproveRejectForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetApproveRejectForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetApproveRejectForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetApproveRejectForMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getApprovalPermissionForMobile(timesheetId: number | undefined, userId: number | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetApprovalPermissionForMobile?";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "timesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalPermissionForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalPermissionForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetApprovalPermissionForMobile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reSubmiteTimesheetForMobile(body: SendForApprovalTimesheetDto | undefined): Observable<IsCheckTimesheetFlag> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/ReSubmiteTimesheetForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSubmiteTimesheetForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSubmiteTimesheetForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsCheckTimesheetFlag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsCheckTimesheetFlag>;
        }));
    }

    protected processReSubmiteTimesheetForMobile(response: HttpResponseBase): Observable<IsCheckTimesheetFlag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsCheckTimesheetFlag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getTaskLogByTaskIdForMobile(taskId: number | undefined, tenantId: number | undefined, userId: number | undefined): Observable<TaskLogOutPutDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetTaskLogByTaskIdForMobile?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLogByTaskIdForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLogByTaskIdForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLogOutPutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLogOutPutDto>;
        }));
    }

    protected processGetTaskLogByTaskIdForMobile(response: HttpResponseBase): Observable<TaskLogOutPutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskLogOutPutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param taskId (optional) 
     * @param timesheetId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isMyTimesheet (optional) 
     * @return OK
     */
    getTaskLogByMyTimesheetAndTeamTimesheetForMobileTaskId(tenantId: number | undefined, taskId: number | undefined, timesheetId: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, isMyTimesheet: boolean | undefined): Observable<TaskLogOutPutDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetMobile/GetTaskLogByMyTimesheetAndTeamTimesheetForMobileTaskId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (isMyTimesheet === null)
            throw new globalThis.Error("The parameter 'isMyTimesheet' cannot be null.");
        else if (isMyTimesheet !== undefined)
            url_ += "IsMyTimesheet=" + encodeURIComponent("" + isMyTimesheet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLogByMyTimesheetAndTeamTimesheetForMobileTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLogByMyTimesheetAndTeamTimesheetForMobileTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLogOutPutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLogOutPutDto>;
        }));
    }

    protected processGetTaskLogByMyTimesheetAndTeamTimesheetForMobileTaskId(response: HttpResponseBase): Observable<TaskLogOutPutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskLogOutPutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimesheetReStructuringServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param week (optional) 
     * @return OK
     */
    getMonthViewDetails(timeZoneOffset: number | undefined, week: string[] | undefined): Observable<MonthViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetMonthViewDetails?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (week === null)
            throw new globalThis.Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            week && week.forEach(item => { url_ += "Week=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthViewDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthViewDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthViewDto>;
        }));
    }

    protected processGetMonthViewDetails(response: HttpResponseBase): Observable<MonthViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetAddManualTask(body: InputManualAddTimesheet | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/TimesheetAddManualTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetAddManualTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetAddManualTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTimesheetAddManualTask(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTimesheetManualTask(body: InputManualAddTimesheet | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/UpdateTimesheetManualTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimesheetManualTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimesheetManualTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTimesheetManualTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTaskDescriptionBaseOnDate(body: InputUpdateTaskDescriptionBaseOnDateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/UpdateTaskDescriptionBaseOnDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskDescriptionBaseOnDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskDescriptionBaseOnDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTaskDescriptionBaseOnDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobTaskDetails(): Observable<OutPutTaskJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetJobTaskDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobTaskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobTaskDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTaskJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTaskJobDto[]>;
        }));
    }

    protected processGetJobTaskDetails(response: HttpResponseBase): Observable<OutPutTaskJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTaskJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManualHourseInManualTimesheet(body: InputAddManualTimeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/AddManualHourseInManualTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualHourseInManualTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualHourseInManualTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddManualHourseInManualTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param filter (optional) 
     * @param billabilityStatus (optional) 
     * @param timeZoneOffset (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param weeks (optional) 
     * @param submittedHourDate (optional) 
     * @return OK
     */
    getFilledTaskDetailsBaseOnProject(projectId: number[] | undefined, filter: string | undefined, billabilityStatus: number | undefined, timeZoneOffset: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, weeks: string[] | undefined, submittedHourDate: string | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum): Observable<OutPutDayViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetFilledTaskDetailsBaseOnProject?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (billabilityStatus === null)
            throw new globalThis.Error("The parameter 'billabilityStatus' cannot be null.");
        else if (billabilityStatus !== undefined)
            url_ += "BillabilityStatus=" + encodeURIComponent("" + billabilityStatus) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (submittedHourDate === null)
            throw new globalThis.Error("The parameter 'submittedHourDate' cannot be null.");
        else if (submittedHourDate !== undefined)
            url_ += "SubmittedHourDate=" + encodeURIComponent("" + submittedHourDate) + "&";
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilledTaskDetailsBaseOnProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilledTaskDetailsBaseOnProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutDayViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutDayViewDto>;
        }));
    }

    protected processGetFilledTaskDetailsBaseOnProject(response: HttpResponseBase): Observable<OutPutDayViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutDayViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportinglocation (optional) 
     * @return OK
     */
    getHolidayListBaseOnReportingLocation(reportinglocation: number | undefined): Observable<DateTime[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetHolidayListBaseOnReportingLocation?";
        if (reportinglocation === null)
            throw new globalThis.Error("The parameter 'reportinglocation' cannot be null.");
        else if (reportinglocation !== undefined)
            url_ += "reportinglocation=" + encodeURIComponent("" + reportinglocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayListBaseOnReportingLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayListBaseOnReportingLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime[]>;
        }));
    }

    protected processGetHolidayListBaseOnReportingLocation(response: HttpResponseBase): Observable<DateTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DateTime.fromISO(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param userId (optional) 
     * @param isMytimesheet (optional) 
     * @param dateTime (optional) 
     * @return OK
     */
    getTaskLogHistory(taskId: number | undefined, userId: number | undefined, isMytimesheet: boolean | undefined, dateTime: DateTime | undefined): Observable<TaskLogOutPutDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTaskLogHistory?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isMytimesheet === null)
            throw new globalThis.Error("The parameter 'isMytimesheet' cannot be null.");
        else if (isMytimesheet !== undefined)
            url_ += "isMytimesheet=" + encodeURIComponent("" + isMytimesheet) + "&";
        if (dateTime === null)
            throw new globalThis.Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLogHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLogHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLogOutPutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLogOutPutDto>;
        }));
    }

    protected processGetTaskLogHistory(response: HttpResponseBase): Observable<TaskLogOutPutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskLogOutPutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param projectIds (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getTaskDescriptionHistory(userId: number | undefined, tenantId: number | undefined, projectIds: number[] | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<OutPutGetTaskDescriptionHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTaskDescriptionHistory?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskDescriptionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskDescriptionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutGetTaskDescriptionHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutGetTaskDescriptionHistoryDto[]>;
        }));
    }

    protected processGetTaskDescriptionHistory(response: HttpResponseBase): Observable<OutPutGetTaskDescriptionHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutGetTaskDescriptionHistoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTimesheetToApproval(body: InputSendTimesheetDto[] | undefined): Observable<OutPutSendTimesheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/SendTimesheetToApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTimesheetToApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTimesheetToApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutSendTimesheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutSendTimesheetDto[]>;
        }));
    }

    protected processSendTimesheetToApproval(response: HttpResponseBase): Observable<OutPutSendTimesheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutSendTimesheetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    countWorkingDays(body: WorkingTrack | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/CountWorkingDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountWorkingDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountWorkingDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountWorkingDays(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param isInternalCall (optional) 
     * @param timeSheetStartDate (optional) 
     * @param timeSheetEndDate (optional) 
     * @return OK
     */
    getDraftedTimesheetDetails(projectId: number | undefined, userId: number | undefined, isInternalCall: boolean | undefined, timeSheetStartDate: DateTime | undefined, timeSheetEndDate: DateTime | undefined): Observable<TimesheetStatesDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetDraftedTimesheetDetails?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isInternalCall === null)
            throw new globalThis.Error("The parameter 'isInternalCall' cannot be null.");
        else if (isInternalCall !== undefined)
            url_ += "IsInternalCall=" + encodeURIComponent("" + isInternalCall) + "&";
        if (timeSheetStartDate === null)
            throw new globalThis.Error("The parameter 'timeSheetStartDate' cannot be null.");
        else if (timeSheetStartDate !== undefined)
            url_ += "TimeSheetStartDate=" + encodeURIComponent(timeSheetStartDate ? "" + timeSheetStartDate.toString() : "") + "&";
        if (timeSheetEndDate === null)
            throw new globalThis.Error("The parameter 'timeSheetEndDate' cannot be null.");
        else if (timeSheetEndDate !== undefined)
            url_ += "TimeSheetEndDate=" + encodeURIComponent(timeSheetEndDate ? "" + timeSheetEndDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftedTimesheetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftedTimesheetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetStatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetStatesDto>;
        }));
    }

    protected processGetDraftedTimesheetDetails(response: HttpResponseBase): Observable<TimesheetStatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetStatesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTaskLevelComment(body: AddCommentTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/AddTaskLevelComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTaskLevelComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTaskLevelComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTaskLevelComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTaskLevelComment(body: AddCommentTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/UpdateTaskLevelComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskLevelComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskLevelComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTaskLevelComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param taskId (optional) 
     * @return OK
     */
    getTaskLevelComment(userId: number | undefined, tenantId: number | undefined, taskId: number | undefined): Observable<CommentTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTaskLevelComment?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLevelComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLevelComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTaskDto[]>;
        }));
    }

    protected processGetTaskLevelComment(response: HttpResponseBase): Observable<CommentTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addTimesheetApproveRejectLevelComments(body: AddTimesheetLevelCommentDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/AddTimesheetApproveRejectLevelComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTimesheetApproveRejectLevelComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTimesheetApproveRejectLevelComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTimesheetApproveRejectLevelComments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param myTimeSheetId (optional) 
     * @param comments (optional) 
     * @return OK
     */
    getTimesheetApproveRejectLevelComments(userId: number | undefined, tenantId: number | undefined, myTimeSheetId: number | undefined, comments: string | undefined): Observable<GetTimesheetLevelCommentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTimesheetApproveRejectLevelComments?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (myTimeSheetId === null)
            throw new globalThis.Error("The parameter 'myTimeSheetId' cannot be null.");
        else if (myTimeSheetId !== undefined)
            url_ += "MyTimeSheetId=" + encodeURIComponent("" + myTimeSheetId) + "&";
        if (comments === null)
            throw new globalThis.Error("The parameter 'comments' cannot be null.");
        else if (comments !== undefined)
            url_ += "Comments=" + encodeURIComponent("" + comments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetApproveRejectLevelComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetApproveRejectLevelComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTimesheetLevelCommentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTimesheetLevelCommentDto[]>;
        }));
    }

    protected processGetTimesheetApproveRejectLevelComments(response: HttpResponseBase): Observable<GetTimesheetLevelCommentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTimesheetLevelCommentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteInTimesheetTask(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/DeleteInTimesheetTask?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInTimesheetTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInTimesheetTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInTimesheetTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param filter (optional) 
     * @param week (optional) 
     * @return OK
     */
    getWeekViewDetails(timeZoneOffset: number | undefined, filter: string | undefined, week: string[] | undefined): Observable<OutPutWeekViewDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetWeekViewDetails?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (week === null)
            throw new globalThis.Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            week && week.forEach(item => { url_ += "Week=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeekViewDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeekViewDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutWeekViewDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutWeekViewDetailsDto>;
        }));
    }

    protected processGetWeekViewDetails(response: HttpResponseBase): Observable<OutPutWeekViewDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutWeekViewDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submittedTimesheetGrid(body: InputSubmittedTimesheetDto | undefined): Observable<OutPutSubmittedTimesheetDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/SubmittedTimesheetGrid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmittedTimesheetGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmittedTimesheetGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutSubmittedTimesheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutSubmittedTimesheetDto>;
        }));
    }

    protected processSubmittedTimesheetGrid(response: HttpResponseBase): Observable<OutPutSubmittedTimesheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutPutSubmittedTimesheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param timesheetId (optional) 
     * @param timeZoneOffset (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param weeks (optional) 
     * @return OK
     */
    getSubmittedTimesheetTaskDetails(userId: number | undefined, projectId: number | undefined, timesheetId: number | undefined, timeZoneOffset: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, weeks: string[] | undefined, timesheetFrequency: ProjectTimesheetFrequencyEnum): Observable<OutPutSubmittedTimesheetTaskDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetSubmittedTimesheetTaskDetails?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "TimesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (weeks === null)
            throw new globalThis.Error("The parameter 'weeks' cannot be null.");
        else if (weeks !== undefined)
            weeks && weeks.forEach(item => { url_ += "Weeks=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetFrequency === undefined || timesheetFrequency === null)
            throw new globalThis.Error("The parameter 'timesheetFrequency' must be defined and cannot be null.");
        else
            url_ += "TimesheetFrequency=" + encodeURIComponent("" + timesheetFrequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmittedTimesheetTaskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedTimesheetTaskDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutSubmittedTimesheetTaskDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutSubmittedTimesheetTaskDetailDto[]>;
        }));
    }

    protected processGetSubmittedTimesheetTaskDetails(response: HttpResponseBase): Observable<OutPutSubmittedTimesheetTaskDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutSubmittedTimesheetTaskDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDayOrWeekLevelShowInTimesheet(body: ProjectLevelShowInTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/SetDayOrWeekLevelShowInTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDayOrWeekLevelShowInTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDayOrWeekLevelShowInTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDayOrWeekLevelShowInTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetId (optional) 
     * @return OK
     */
    timesheetApprovalHistory(timesheetId: number | undefined): Observable<TimesheetApprovalHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/TimesheetApprovalHistory?";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "timesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetApprovalHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetApprovalHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetApprovalHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetApprovalHistoryDto[]>;
        }));
    }

    protected processTimesheetApprovalHistory(response: HttpResponseBase): Observable<TimesheetApprovalHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimesheetApprovalHistoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectedTimesheetAddOrUpdateTime(body: DraftedTimesheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/RejectedTimesheetAddOrUpdateTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectedTimesheetAddOrUpdateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectedTimesheetAddOrUpdateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectedTimesheetAddOrUpdateTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reSubmiteRejectedTimesheet(body: InputReSubmiteRejectedTimesheetDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/ReSubmiteRejectedTimesheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSubmiteRejectedTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSubmiteRejectedTimesheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReSubmiteRejectedTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timeZoneOffset (optional) 
     * @param isShowAll (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param dataSourceLoadOptions (optional) 
     * @param projectIds (optional) 
     * @param timesheetStatus (optional) 
     * @param isprojectLevelcall (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getApprovalGridData(timeZoneOffset: number | undefined, isShowAll: boolean | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, dataSourceLoadOptions: string | undefined, projectIds: number[] | undefined, timesheetStatus: TimesheetAndApprovalStatusEnum | undefined, isprojectLevelcall: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetApprovalGridData?";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (isShowAll === null)
            throw new globalThis.Error("The parameter 'isShowAll' cannot be null.");
        else if (isShowAll !== undefined)
            url_ += "IsShowAll=" + encodeURIComponent("" + isShowAll) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (dataSourceLoadOptions === null)
            throw new globalThis.Error("The parameter 'dataSourceLoadOptions' cannot be null.");
        else if (dataSourceLoadOptions !== undefined)
            url_ += "DataSourceLoadOptions=" + encodeURIComponent("" + dataSourceLoadOptions) + "&";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (timesheetStatus === null)
            throw new globalThis.Error("The parameter 'timesheetStatus' cannot be null.");
        else if (timesheetStatus !== undefined)
            url_ += "TimesheetStatus=" + encodeURIComponent("" + timesheetStatus) + "&";
        if (isprojectLevelcall === null)
            throw new globalThis.Error("The parameter 'isprojectLevelcall' cannot be null.");
        else if (isprojectLevelcall !== undefined)
            url_ += "IsprojectLevelcall=" + encodeURIComponent("" + isprojectLevelcall) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalGridData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalGridData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto>;
        }));
    }

    protected processGetApprovalGridData(response: HttpResponseBase): Observable<PagedResultDtoOfOutPutGetApprovalGridDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOutPutGetApprovalGridDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    timesheetApproveRejectAction(body: ApproveRejectDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/TimesheetApproveRejectAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetApproveRejectAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetApproveRejectAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetApproveRejectAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    timesheetStatusUpdateAfterApproved(userId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/TimesheetStatusUpdateAfterApproved?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetStatusUpdateAfterApproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetStatusUpdateAfterApproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTimesheetStatusUpdateAfterApproved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    afterApprovedTimesheetSendNotificationToClient(body: InputAfterApprovedTimesheetSendNotificationToClientDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/AfterApprovedTimesheetSendNotificationToClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAfterApprovedTimesheetSendNotificationToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAfterApprovedTimesheetSendNotificationToClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAfterApprovedTimesheetSendNotificationToClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param isOnlyMyProject (optional) 
     * @return OK
     */
    timesheetLevelProjectList(userId: number | undefined, tenantId: number | undefined, isOnlyMyProject: boolean | undefined): Observable<DropdownProjectListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/TimesheetLevelProjectList?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (isOnlyMyProject === null)
            throw new globalThis.Error("The parameter 'isOnlyMyProject' cannot be null.");
        else if (isOnlyMyProject !== undefined)
            url_ += "isOnlyMyProject=" + encodeURIComponent("" + isOnlyMyProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimesheetLevelProjectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimesheetLevelProjectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownProjectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownProjectListDto[]>;
        }));
    }

    protected processTimesheetLevelProjectList(response: HttpResponseBase): Observable<DropdownProjectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownProjectListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTimesheetCategory(body: InputTaskJobMasterDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/CreateTimesheetCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTimesheetCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTimesheetCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateTimesheetCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editTimesheetCategory(body: InputTaskJobMasterDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/EditTimesheetCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTimesheetCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTimesheetCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEditTimesheetCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTimesheetCategoryUnderTask(body: InputTaskJobMasterDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/CreateTimesheetCategoryUnderTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTimesheetCategoryUnderTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTimesheetCategoryUnderTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateTimesheetCategoryUnderTask(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editTimesheetCategoryUnderTask(body: InputTaskJobMasterDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/EditTimesheetCategoryUnderTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTimesheetCategoryUnderTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTimesheetCategoryUnderTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEditTimesheetCategoryUnderTask(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isDelete (optional) 
     * @return OK
     */
    getTimesheetMasterDetails(isDelete: boolean | undefined): Observable<OutPutTaskJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTimesheetMasterDetails?";
        if (isDelete === null)
            throw new globalThis.Error("The parameter 'isDelete' cannot be null.");
        else if (isDelete !== undefined)
            url_ += "isDelete=" + encodeURIComponent("" + isDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetMasterDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetMasterDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTaskJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTaskJobDto[]>;
        }));
    }

    protected processGetTimesheetMasterDetails(response: HttpResponseBase): Observable<OutPutTaskJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTaskJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param isDelete (optional) 
     * @return OK
     */
    getTimesheetMasterProjectLevel(projectId: number | undefined, isDelete: boolean | undefined): Observable<OutPutTaskJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTimesheetMasterProjectLevel?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (isDelete === null)
            throw new globalThis.Error("The parameter 'isDelete' cannot be null.");
        else if (isDelete !== undefined)
            url_ += "isDelete=" + encodeURIComponent("" + isDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimesheetMasterProjectLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimesheetMasterProjectLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutPutTaskJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutPutTaskJobDto[]>;
        }));
    }

    protected processGetTimesheetMasterProjectLevel(response: HttpResponseBase): Observable<OutPutTaskJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutPutTaskJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskJobId (optional) 
     * @param isProjectLevel (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    deleteCategory(taskJobId: number | undefined, isProjectLevel: boolean | undefined, projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/DeleteCategory?";
        if (taskJobId === null)
            throw new globalThis.Error("The parameter 'taskJobId' cannot be null.");
        else if (taskJobId !== undefined)
            url_ += "taskJobId=" + encodeURIComponent("" + taskJobId) + "&";
        if (isProjectLevel === null)
            throw new globalThis.Error("The parameter 'isProjectLevel' cannot be null.");
        else if (isProjectLevel !== undefined)
            url_ += "isProjectLevel=" + encodeURIComponent("" + isProjectLevel) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskMasterId (optional) 
     * @param taskJobId (optional) 
     * @param projectId (optional) 
     * @param isProjectLevel (optional) 
     * @return OK
     */
    deleteCategoryUnderTask(taskMasterId: number | undefined, taskJobId: number | undefined, projectId: number | undefined, isProjectLevel: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/DeleteCategoryUnderTask?";
        if (taskMasterId === null)
            throw new globalThis.Error("The parameter 'taskMasterId' cannot be null.");
        else if (taskMasterId !== undefined)
            url_ += "taskMasterId=" + encodeURIComponent("" + taskMasterId) + "&";
        if (taskJobId === null)
            throw new globalThis.Error("The parameter 'taskJobId' cannot be null.");
        else if (taskJobId !== undefined)
            url_ += "taskJobId=" + encodeURIComponent("" + taskJobId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (isProjectLevel === null)
            throw new globalThis.Error("The parameter 'isProjectLevel' cannot be null.");
        else if (isProjectLevel !== undefined)
            url_ += "isProjectLevel=" + encodeURIComponent("" + isProjectLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategoryUnderTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategoryUnderTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCategoryUnderTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskJobId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    restoreCategory(taskJobId: number | undefined, projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/RestoreCategory?";
        if (taskJobId === null)
            throw new globalThis.Error("The parameter 'taskJobId' cannot be null.");
        else if (taskJobId !== undefined)
            url_ += "taskJobId=" + encodeURIComponent("" + taskJobId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRestoreCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param taskJobId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    restoreCategoryUnderTask(taskId: number | undefined, taskJobId: number | undefined, projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/RestoreCategoryUnderTask?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (taskJobId === null)
            throw new globalThis.Error("The parameter 'taskJobId' cannot be null.");
        else if (taskJobId !== undefined)
            url_ += "taskJobId=" + encodeURIComponent("" + taskJobId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreCategoryUnderTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreCategoryUnderTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRestoreCategoryUnderTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkUnCheckProjectLevelCategory(body: InputProjectLevelCheckUnCheckDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/CheckUnCheckProjectLevelCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUnCheckProjectLevelCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUnCheckProjectLevelCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckUnCheckProjectLevelCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getTaskCategoriesDropdown(projectId: number | undefined): Observable<OutputGetTaskCategoriesDropdownDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetTaskCategoriesDropdown?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskCategoriesDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskCategoriesDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutputGetTaskCategoriesDropdownDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutputGetTaskCategoriesDropdownDto[]>;
        }));
    }

    protected processGetTaskCategoriesDropdown(response: HttpResponseBase): Observable<OutputGetTaskCategoriesDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutputGetTaskCategoriesDropdownDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param processingDateUtc (optional) 
     * @return OK
     */
    processAutomatedTimesheets(tenantId: number | undefined, processingDateUtc: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/ProcessAutomatedTimesheets?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (processingDateUtc === null)
            throw new globalThis.Error("The parameter 'processingDateUtc' cannot be null.");
        else if (processingDateUtc !== undefined)
            url_ += "processingDateUtc=" + encodeURIComponent(processingDateUtc ? "" + processingDateUtc.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessAutomatedTimesheets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessAutomatedTimesheets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessAutomatedTimesheets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    autoAddPreDefineTimesheetCategoryToProjects(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/AutoAddPreDefineTimesheetCategoryToProjects?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoAddPreDefineTimesheetCategoryToProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoAddPreDefineTimesheetCategoryToProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAutoAddPreDefineTimesheetCategoryToProjects(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timesheetId (optional) 
     * @return OK
     */
    getApprovalGridDataById(timesheetId: number | undefined): Observable<ApprovalGridDataDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetApprovalGridDataById?";
        if (timesheetId === null)
            throw new globalThis.Error("The parameter 'timesheetId' cannot be null.");
        else if (timesheetId !== undefined)
            url_ += "timesheetId=" + encodeURIComponent("" + timesheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalGridDataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalGridDataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalGridDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalGridDataDto>;
        }));
    }

    protected processGetApprovalGridDataById(response: HttpResponseBase): Observable<ApprovalGridDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalGridDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBillabity(body: ListSelectTimeSheet[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/UpdateBillabity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBillabity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillabity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBillabity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectWiseReason(projectId: number | undefined): Observable<NonBillableReasonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetProjectWiseReason?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWiseReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWiseReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonBillableReasonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonBillableReasonDto[]>;
        }));
    }

    protected processGetProjectWiseReason(response: HttpResponseBase): Observable<NonBillableReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NonBillableReasonDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param reasonId (optional) 
     * @return OK
     */
    deleteselectedProjectReason(projectId: number | undefined, reasonId: number[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/DeleteselectedProjectReason?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (reasonId === null)
            throw new globalThis.Error("The parameter 'reasonId' cannot be null.");
        else if (reasonId !== undefined)
            reasonId && reasonId.forEach(item => { url_ += "reasonId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteselectedProjectReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteselectedProjectReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteselectedProjectReason(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param reasone (optional) 
     * @return OK
     */
    addProjectWiseReasone(projectId: number | undefined, reasone: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/AddProjectWiseReasone?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (reasone === null)
            throw new globalThis.Error("The parameter 'reasone' cannot be null.");
        else if (reasone !== undefined)
            url_ += "reasone=" + encodeURIComponent("" + reasone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectWiseReasone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectWiseReasone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddProjectWiseReasone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param offsetMinutes (optional) 
     * @return OK
     */
    checkLast30DaysTimesheetCompletion(userId: number | undefined, offsetMinutes: number | undefined): Observable<TimesheetCompletionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/CheckLast30DaysTimesheetCompletion?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (offsetMinutes === null)
            throw new globalThis.Error("The parameter 'offsetMinutes' cannot be null.");
        else if (offsetMinutes !== undefined)
            url_ += "offsetMinutes=" + encodeURIComponent("" + offsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLast30DaysTimesheetCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLast30DaysTimesheetCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimesheetCompletionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimesheetCompletionStatusDto>;
        }));
    }

    protected processCheckLast30DaysTimesheetCompletion(response: HttpResponseBase): Observable<TimesheetCompletionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetCompletionStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @return OK
     */
    getReminderSettingsForAllProjects(projectIds: number[] | undefined): Observable<UpdateReminderSettingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimesheetReStructuring/GetReminderSettingsForAllProjects?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReminderSettingsForAllProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReminderSettingsForAllProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateReminderSettingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateReminderSettingDto[]>;
        }));
    }

    protected processGetReminderSettingsForAllProjects(response: HttpResponseBase): Observable<UpdateReminderSettingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UpdateReminderSettingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new globalThis.Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return OK
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new globalThis.Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticateAuto(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateAuto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateAuto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateAuto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticateAuto(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return OK
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new globalThis.Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return OK
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new globalThis.Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return OK
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new globalThis.Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken === null)
            throw new globalThis.Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return OK
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new globalThis.Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    agentExternalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<AgentExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AgentExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgentExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgentExternalAuthenticateResultModel>;
        }));
    }

    protected processAgentExternalAuthenticate(response: HttpResponseBase): Observable<AgentExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return OK
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message === null)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity === null)
            throw new globalThis.Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwitterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
        }));
    }

    protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param verifier (optional) 
     * @return OK
     */
    getAccessToken(token: string | undefined, verifier: string | undefined): Observable<TwitterGetAccessTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (verifier === null)
            throw new globalThis.Error("The parameter 'verifier' cannot be null.");
        else if (verifier !== undefined)
            url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
        }));
    }

    protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return OK
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new globalThis.Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UniversalSearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param query (optional) 
     * @param maxPerCategory (optional) 
     * @return OK
     */
    search(query: string | undefined, maxPerCategory: number | undefined): Observable<UniversalSearchResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UniversalSearch/Search?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (maxPerCategory === null)
            throw new globalThis.Error("The parameter 'maxPerCategory' cannot be null.");
        else if (maxPerCategory !== undefined)
            url_ += "maxPerCategory=" + encodeURIComponent("" + maxPerCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UniversalSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UniversalSearchResultDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<UniversalSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UniversalSearchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getDesignationUnitsFilter(filter: string | undefined): Observable<GetUserForEditOutputDesig> {
        let url_ = this.baseUrl + "/api/services/app/User/GetDesignationUnitsFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignationUnitsFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationUnitsFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutputDesig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutputDesig>;
        }));
    }

    protected processGetDesignationUnitsFilter(response: HttpResponseBase): Observable<GetUserForEditOutputDesig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutputDesig.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEmployeeImage(body: InputeUserProfileImageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateEmployeeImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployeeImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployeeImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmployeeImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getRegisteredTenantEmailAddress(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRegisteredTenantEmailAddress?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisteredTenantEmailAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisteredTenantEmailAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRegisteredTenantEmailAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEmployeeImageAgent(body: InputeUserProfileImageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateEmployeeImageAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployeeImageAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployeeImageAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmployeeImageAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userEmail (optional) 
     * @return OK
     */
    agentGetUserIdByUserMailAndTenancyId(tenantId: number | undefined, userEmail: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/AgentGetUserIdByUserMailAndTenancyId?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgentGetUserIdByUserMailAndTenancyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgentGetUserIdByUserMailAndTenancyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAgentGetUserIdByUserMailAndTenancyId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    isCheckUserSocialLoginForWeb(tenantId: number | undefined, userId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/IsCheckUserSocialLoginForWeb?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckUserSocialLoginForWeb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckUserSocialLoginForWeb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processIsCheckUserSocialLoginForWeb(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    isCheckUserSocialLoginForAgent(userId: number | undefined, tenantId: number | undefined): Observable<IsSocialLoginDto> {
        let url_ = this.baseUrl + "/api/services/app/User/IsCheckUserSocialLoginForAgent?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckUserSocialLoginForAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckUserSocialLoginForAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsSocialLoginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsSocialLoginDto>;
        }));
    }

    protected processIsCheckUserSocialLoginForAgent(response: HttpResponseBase): Observable<IsSocialLoginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsSocialLoginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param socialLoginID (optional) 
     * @param userMail (optional) 
     * @param userRole (optional) 
     * @param isLoginCall (optional) 
     * @return OK
     */
    isCheckUserSocialLogin(tenantId: number | undefined, userId: number | undefined, socialLoginID: number | undefined, userMail: string | undefined, userRole: string | undefined, isLoginCall: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsCheckUserSocialLogin?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (socialLoginID === null)
            throw new globalThis.Error("The parameter 'socialLoginID' cannot be null.");
        else if (socialLoginID !== undefined)
            url_ += "socialLoginID=" + encodeURIComponent("" + socialLoginID) + "&";
        if (userMail === null)
            throw new globalThis.Error("The parameter 'userMail' cannot be null.");
        else if (userMail !== undefined)
            url_ += "userMail=" + encodeURIComponent("" + userMail) + "&";
        if (userRole === null)
            throw new globalThis.Error("The parameter 'userRole' cannot be null.");
        else if (userRole !== undefined)
            url_ += "userRole=" + encodeURIComponent("" + userRole) + "&";
        if (isLoginCall === null)
            throw new globalThis.Error("The parameter 'isLoginCall' cannot be null.");
        else if (isLoginCall !== undefined)
            url_ += "isLoginCall=" + encodeURIComponent("" + isLoginCall) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckUserSocialLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckUserSocialLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCheckUserSocialLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    checkUserSocialLoginMessage(tenantId: number | undefined, userId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/CheckUserSocialLoginMessage?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserSocialLoginMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserSocialLoginMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckUserSocialLoginMessage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userId (optional) 
     * @param projectId (optional) 
     * @param orgUnitId (optional) 
     * @param getUsersInput_Filter (optional) 
     * @param getUsersInput_Permissions (optional) 
     * @param getUsersInput_Role (optional) 
     * @param getUsersInput_RoleArray (optional) 
     * @param getUsersInput_OnlyLockedUsers (optional) 
     * @param getUsersInput_IsAllUserDisplay (optional) 
     * @param getUsersInput_OrganizationUnit (optional) 
     * @param getUsersInput_Sorting (optional) 
     * @param getUsersInput_MaxResultCount (optional) 
     * @param getUsersInput_SkipCount (optional) 
     * @param currDate (optional) 
     * @param timeZoneOffset (optional) 
     * @param isSortByNew (optional) 
     * @param id (optional) 
     * @return OK
     */
    getRealTimeTracking(filter: string | undefined, userId: (number | undefined)[] | undefined, projectId: number[] | undefined, orgUnitId: number[] | undefined, getUsersInput_Filter: string | undefined, getUsersInput_Permissions: string[] | undefined, getUsersInput_Role: number | undefined, getUsersInput_RoleArray: (number | undefined)[] | undefined, getUsersInput_OnlyLockedUsers: boolean | undefined, getUsersInput_IsAllUserDisplay: boolean | undefined, getUsersInput_OrganizationUnit: OrganizationUnitDto[] | undefined, getUsersInput_Sorting: string | undefined, getUsersInput_MaxResultCount: number | undefined, getUsersInput_SkipCount: number | undefined, currDate: DateTime | undefined, timeZoneOffset: number | undefined, isSortByNew: boolean | undefined, id: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRealTimeTracking?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "UserId=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            orgUnitId && orgUnitId.forEach(item => { url_ += "OrgUnitId=" + encodeURIComponent("" + item) + "&"; });
        if (getUsersInput_Filter === null)
            throw new globalThis.Error("The parameter 'getUsersInput_Filter' cannot be null.");
        else if (getUsersInput_Filter !== undefined)
            url_ += "GetUsersInput.Filter=" + encodeURIComponent("" + getUsersInput_Filter) + "&";
        if (getUsersInput_Permissions === null)
            throw new globalThis.Error("The parameter 'getUsersInput_Permissions' cannot be null.");
        else if (getUsersInput_Permissions !== undefined)
            getUsersInput_Permissions && getUsersInput_Permissions.forEach(item => { url_ += "GetUsersInput.Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (getUsersInput_Role === null)
            throw new globalThis.Error("The parameter 'getUsersInput_Role' cannot be null.");
        else if (getUsersInput_Role !== undefined)
            url_ += "GetUsersInput.Role=" + encodeURIComponent("" + getUsersInput_Role) + "&";
        if (getUsersInput_RoleArray === null)
            throw new globalThis.Error("The parameter 'getUsersInput_RoleArray' cannot be null.");
        else if (getUsersInput_RoleArray !== undefined)
            getUsersInput_RoleArray && getUsersInput_RoleArray.forEach(item => { url_ += "GetUsersInput.RoleArray=" + encodeURIComponent("" + item) + "&"; });
        if (getUsersInput_OnlyLockedUsers === null)
            throw new globalThis.Error("The parameter 'getUsersInput_OnlyLockedUsers' cannot be null.");
        else if (getUsersInput_OnlyLockedUsers !== undefined)
            url_ += "GetUsersInput.OnlyLockedUsers=" + encodeURIComponent("" + getUsersInput_OnlyLockedUsers) + "&";
        if (getUsersInput_IsAllUserDisplay === null)
            throw new globalThis.Error("The parameter 'getUsersInput_IsAllUserDisplay' cannot be null.");
        else if (getUsersInput_IsAllUserDisplay !== undefined)
            url_ += "GetUsersInput.IsAllUserDisplay=" + encodeURIComponent("" + getUsersInput_IsAllUserDisplay) + "&";
        if (getUsersInput_OrganizationUnit === null)
            throw new globalThis.Error("The parameter 'getUsersInput_OrganizationUnit' cannot be null.");
        else if (getUsersInput_OrganizationUnit !== undefined)
            getUsersInput_OrganizationUnit && getUsersInput_OrganizationUnit.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "GetUsersInput.OrganizationUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (getUsersInput_Sorting === null)
            throw new globalThis.Error("The parameter 'getUsersInput_Sorting' cannot be null.");
        else if (getUsersInput_Sorting !== undefined)
            url_ += "GetUsersInput.Sorting=" + encodeURIComponent("" + getUsersInput_Sorting) + "&";
        if (getUsersInput_MaxResultCount === null)
            throw new globalThis.Error("The parameter 'getUsersInput_MaxResultCount' cannot be null.");
        else if (getUsersInput_MaxResultCount !== undefined)
            url_ += "GetUsersInput.MaxResultCount=" + encodeURIComponent("" + getUsersInput_MaxResultCount) + "&";
        if (getUsersInput_SkipCount === null)
            throw new globalThis.Error("The parameter 'getUsersInput_SkipCount' cannot be null.");
        else if (getUsersInput_SkipCount !== undefined)
            url_ += "GetUsersInput.SkipCount=" + encodeURIComponent("" + getUsersInput_SkipCount) + "&";
        if (currDate === null)
            throw new globalThis.Error("The parameter 'currDate' cannot be null.");
        else if (currDate !== undefined)
            url_ += "CurrDate=" + encodeURIComponent(currDate ? "" + currDate.toString() : "") + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (isSortByNew === null)
            throw new globalThis.Error("The parameter 'isSortByNew' cannot be null.");
        else if (isSortByNew !== undefined)
            url_ += "isSortByNew=" + encodeURIComponent("" + isSortByNew) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealTimeTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealTimeTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetRealTimeTracking(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @param userID (optional) 
     * @return OK
     */
    getWorkingTypeStatus(tenantID: number | undefined, userID: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetWorkingTypeStatus?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingTypeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingTypeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetWorkingTypeStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActiveUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetActiveUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetActiveUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param roleArray (optional) 
     * @param onlyLockedUsers (optional) 
     * @param isAllUserDisplay (optional) 
     * @param organizationUnit (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUsers(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, roleArray: (number | undefined)[] | undefined, onlyLockedUsers: boolean | undefined, isAllUserDisplay: boolean | undefined, organizationUnit: OrganizationUnitDto[] | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new globalThis.Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (roleArray === null)
            throw new globalThis.Error("The parameter 'roleArray' cannot be null.");
        else if (roleArray !== undefined)
            roleArray && roleArray.forEach(item => { url_ += "RoleArray=" + encodeURIComponent("" + item) + "&"; });
        if (onlyLockedUsers === null)
            throw new globalThis.Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (isAllUserDisplay === null)
            throw new globalThis.Error("The parameter 'isAllUserDisplay' cannot be null.");
        else if (isAllUserDisplay !== undefined)
            url_ += "IsAllUserDisplay=" + encodeURIComponent("" + isAllUserDisplay) + "&";
        if (organizationUnit === null)
            throw new globalThis.Error("The parameter 'organizationUnit' cannot be null.");
        else if (organizationUnit !== undefined)
            organizationUnit && organizationUnit.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "OrganizationUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    getRealTimeLocation(input: UserListDto[] | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRealTimeLocation?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "input[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealTimeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealTimeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetRealTimeLocation(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createClient(body: CreateOrUpdateUserInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    resendEmailAsPerType(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResendEmailAsPerType?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendEmailAsPerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendEmailAsPerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendEmailAsPerType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onbordingInviteUser(body: AddOnboardingInviteTeamDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/OnbordingInviteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnbordingInviteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnbordingInviteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnbordingInviteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLeavesByUser(body: LeaveByUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateLeavesByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeavesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeavesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLeavesByUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getAllLeavesByUser(userId: number | undefined, tenantId: number | undefined): Observable<LeaveByUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllLeavesByUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeavesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeavesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveByUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveByUserDto[]>;
        }));
    }

    protected processGetAllLeavesByUser(response: HttpResponseBase): Observable<LeaveByUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveByUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param itpJoiningDate (optional) 
     * @param leavesPerMonth (optional) 
     * @return OK
     */
    handleUserLeaves(userId: number | undefined, tenantId: number | undefined, itpJoiningDate: DateTime | undefined, leavesPerMonth: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/HandleUserLeaves?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (itpJoiningDate === null)
            throw new globalThis.Error("The parameter 'itpJoiningDate' cannot be null.");
        else if (itpJoiningDate !== undefined)
            url_ += "itpJoiningDate=" + encodeURIComponent(itpJoiningDate ? "" + itpJoiningDate.toString() : "") + "&";
        if (leavesPerMonth === null)
            throw new globalThis.Error("The parameter 'leavesPerMonth' cannot be null.");
        else if (leavesPerMonth !== undefined)
            url_ += "leavesPerMonth=" + encodeURIComponent("" + leavesPerMonth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleUserLeaves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleUserLeaves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleUserLeaves(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendEmailToNewManagerOnEdit(tenantId: number | undefined, body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SendEmailToNewManagerOnEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailToNewManagerOnEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToNewManagerOnEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToNewManagerOnEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendEmailToNewUserOnCreate(tenantId: number | undefined, body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SendEmailToNewUserOnCreate?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailToNewUserOnCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToNewUserOnCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToNewUserOnCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isCreate (optional) 
     * @param isOrgChanged (optional) 
     * @return OK
     */
    disableCacheForEditorCreateUser(tenantId: number | undefined, userId: number | undefined, isCreate: boolean | undefined, isOrgChanged: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DisableCacheForEditorCreateUser?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isCreate === null)
            throw new globalThis.Error("The parameter 'isCreate' cannot be null.");
        else if (isCreate !== undefined)
            url_ += "IsCreate=" + encodeURIComponent("" + isCreate) + "&";
        if (isOrgChanged === null)
            throw new globalThis.Error("The parameter 'isOrgChanged' cannot be null.");
        else if (isOrgChanged !== undefined)
            url_ += "isOrgChanged=" + encodeURIComponent("" + isOrgChanged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableCacheForEditorCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableCacheForEditorCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableCacheForEditorCreateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createCacheForEditUser(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateCacheForEditUser?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCacheForEditUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCacheForEditUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCacheForEditUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param password (optional) 
     * @param tenatId (optional) 
     * @return OK
     */
    insertdatatoalltenatndb(email: string | undefined, password: string | undefined, tenatId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Insertdatatoalltenatndb?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (tenatId === null)
            throw new globalThis.Error("The parameter 'tenatId' cannot be null.");
        else if (tenatId !== undefined)
            url_ += "tenatId=" + encodeURIComponent("" + tenatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertdatatoalltenatndb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertdatatoalltenatndb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertdatatoalltenatndb(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    getdataFromtoalltenatndb(email: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/GetdataFromtoalltenatndb?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetdataFromtoalltenatndb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetdataFromtoalltenatndb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetdataFromtoalltenatndb(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createUserEmailReportSettingAtUserCreationOrUpdation(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserEmailReportSettingAtUserCreationOrUpdation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserEmailReportSettingAtUserCreationOrUpdation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserEmailReportSettingAtUserCreationOrUpdation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserEmailReportSettingAtUserCreationOrUpdation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createUserTrackOtherSettingAtUserCreationOrUpdation(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserTrackOtherSettingAtUserCreationOrUpdation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserTrackOtherSettingAtUserCreationOrUpdation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserTrackOtherSettingAtUserCreationOrUpdation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserTrackOtherSettingAtUserCreationOrUpdation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createUserTrackSettingAtUserCreationOrUpdation(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserTrackSettingAtUserCreationOrUpdation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserTrackSettingAtUserCreationOrUpdation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserTrackSettingAtUserCreationOrUpdation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserTrackSettingAtUserCreationOrUpdation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createUserScreenShotSettingAtUserCreationOrUpdation(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserScreenShotSettingAtUserCreationOrUpdation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserScreenShotSettingAtUserCreationOrUpdation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserScreenShotSettingAtUserCreationOrUpdation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserScreenShotSettingAtUserCreationOrUpdation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createUserTrackDaySettingAtUserCreationOrUpdation(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserTrackDaySettingAtUserCreationOrUpdation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserTrackDaySettingAtUserCreationOrUpdation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserTrackDaySettingAtUserCreationOrUpdation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserTrackDaySettingAtUserCreationOrUpdation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    createUserWorkDaySettingAtUserCreationOrUpdation(tenantId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserWorkDaySettingAtUserCreationOrUpdation?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserWorkDaySettingAtUserCreationOrUpdation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserWorkDaySettingAtUserCreationOrUpdation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserWorkDaySettingAtUserCreationOrUpdation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUserLeave(body: LeaveDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUserLeave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUserLeave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param roleArray (optional) 
     * @param onlyLockedUsers (optional) 
     * @param organizationUnit (optional) 
     * @param organizationUnitIds (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUsersByStatusType(userType: IsUserType, filter: string | undefined, permissions: string[] | undefined, role: number | undefined, roleArray: (number | undefined)[] | undefined, onlyLockedUsers: boolean | undefined, organizationUnit: OrganizationUnitDto[] | undefined, organizationUnitIds: string[] | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersByStatusType?";
        if (userType === undefined || userType === null)
            throw new globalThis.Error("The parameter 'userType' must be defined and cannot be null.");
        else
            url_ += "UserType=" + encodeURIComponent("" + userType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new globalThis.Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (roleArray === null)
            throw new globalThis.Error("The parameter 'roleArray' cannot be null.");
        else if (roleArray !== undefined)
            roleArray && roleArray.forEach(item => { url_ += "RoleArray=" + encodeURIComponent("" + item) + "&"; });
        if (onlyLockedUsers === null)
            throw new globalThis.Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (organizationUnit === null)
            throw new globalThis.Error("The parameter 'organizationUnit' cannot be null.");
        else if (organizationUnit !== undefined)
            organizationUnit && organizationUnit.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "OrganizationUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (organizationUnitIds === null)
            throw new globalThis.Error("The parameter 'organizationUnitIds' cannot be null.");
        else if (organizationUnitIds !== undefined)
            organizationUnitIds && organizationUnitIds.forEach(item => { url_ += "OrganizationUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByStatusType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByStatusType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsersByStatusType(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param roleArray (optional) 
     * @param onlyLockedUsers (optional) 
     * @param organizationUnit (optional) 
     * @param organizationUnitIds (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUsersToExcel(userType: IsUserType, filter: string | undefined, permissions: string[] | undefined, role: number | undefined, roleArray: (number | undefined)[] | undefined, onlyLockedUsers: boolean | undefined, organizationUnit: OrganizationUnitDto[] | undefined, organizationUnitIds: string[] | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (userType === undefined || userType === null)
            throw new globalThis.Error("The parameter 'userType' must be defined and cannot be null.");
        else
            url_ += "UserType=" + encodeURIComponent("" + userType) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new globalThis.Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (roleArray === null)
            throw new globalThis.Error("The parameter 'roleArray' cannot be null.");
        else if (roleArray !== undefined)
            roleArray && roleArray.forEach(item => { url_ += "RoleArray=" + encodeURIComponent("" + item) + "&"; });
        if (onlyLockedUsers === null)
            throw new globalThis.Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (organizationUnit === null)
            throw new globalThis.Error("The parameter 'organizationUnit' cannot be null.");
        else if (organizationUnit !== undefined)
            organizationUnit && organizationUnit.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "OrganizationUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (organizationUnitIds === null)
            throw new globalThis.Error("The parameter 'organizationUnitIds' cannot be null.");
        else if (organizationUnitIds !== undefined)
            organizationUnitIds && organizationUnitIds.forEach(item => { url_ += "OrganizationUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUsersImportFormat(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersImportFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersImportFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersImportFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersImportFormat(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param includeManagers (optional) 
     * @return OK
     */
    getUserByProjectId(projectId: number | undefined, includeManagers: boolean | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserByProjectId?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (includeManagers === null)
            throw new globalThis.Error("The parameter 'includeManagers' cannot be null.");
        else if (includeManagers !== undefined)
            url_ += "includeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetUserByProjectId(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param includeManagers (optional) 
     * @return OK
     */
    getMultipleProjectUnderUserList(projectIds: (number | undefined)[] | undefined, includeManagers: boolean | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMultipleProjectUnderUserList?";
        if (projectIds === null)
            throw new globalThis.Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeManagers === null)
            throw new globalThis.Error("The parameter 'includeManagers' cannot be null.");
        else if (includeManagers !== undefined)
            url_ += "includeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultipleProjectUnderUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultipleProjectUnderUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetMultipleProjectUnderUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param includeManagers (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getProjectUnderUserList(projectId: number | undefined, includeManagers: boolean | undefined, userId: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetProjectUnderUserList?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (includeManagers === null)
            throw new globalThis.Error("The parameter 'includeManagers' cannot be null.");
        else if (includeManagers !== undefined)
            url_ += "includeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectUnderUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectUnderUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetProjectUnderUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param includeManagers (optional) 
     * @return OK
     */
    getUsersUnderProjectList(projectId: number | undefined, includeManagers: boolean | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersUnderProjectList?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (includeManagers === null)
            throw new globalThis.Error("The parameter 'includeManagers' cannot be null.");
        else if (includeManagers !== undefined)
            url_ += "includeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersUnderProjectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersUnderProjectList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetUsersUnderProjectList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAllUsersUnderProject(projectId: number[] | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUsersUnderProject?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "ProjectId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersUnderProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersUnderProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetAllUsersUnderProject(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getOrganizationUnitsFilter(filter: string | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOrganizationUnitsFilter?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitsFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitsFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetOrganizationUnitsFilter(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    updateStatusArchive(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateStatusArchive?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    updateStatusUnArchive(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateStatusUnArchive?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusUnArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusUnArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusUnArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    updateStatusUnDelete(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateStatusUnDelete?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusUnDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusUnDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusUnDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    updateStatusDelete(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateStatusDelete?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    deleteUserByList(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUserByList?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    archiveUserByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ArchiveUserByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveUserByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveUserByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveUserByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unArchiveUserByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnArchiveUserByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnArchiveUserByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnArchiveUserByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnArchiveUserByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unDeleteUserByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnDeleteUserByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteUserByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteUserByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteUserByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    permanantDeleteUserByList(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/PermanantDeleteUserByList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermanantDeleteUserByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermanantDeleteUserByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPermanantDeleteUserByList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    updateStatusPermanantDelete(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateStatusPermanantDelete?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusPermanantDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusPermanantDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusPermanantDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailId (optional) 
     * @return OK
     */
    isCheckEmail(emailId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsCheckEmail?";
        if (emailId === null)
            throw new globalThis.Error("The parameter 'emailId' cannot be null.");
        else if (emailId !== undefined)
            url_ += "emailId=" + encodeURIComponent("" + emailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCheckEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadAgentAppWindows(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/DownloadAgentAppWindows";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAgentAppWindows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAgentAppWindows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadAgentAppWindows(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadAgentAppMac(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/DownloadAgentAppMac";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAgentAppMac(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAgentAppMac(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadAgentAppMac(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param val (optional) 
     * @return OK
     */
    setRemindMeLaterForAgentApp(val: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SetRemindMeLaterForAgentApp?";
        if (val === null)
            throw new globalThis.Error("The parameter 'val' cannot be null.");
        else if (val !== undefined)
            url_ += "val=" + encodeURIComponent("" + val) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRemindMeLaterForAgentApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRemindMeLaterForAgentApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetRemindMeLaterForAgentApp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTaskListImportFile(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTaskListImportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskListImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskListImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTaskListImportFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getHolidayImportFile(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetHolidayImportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetHolidayImportFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserListImportFile(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserListImportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserListImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserListImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserListImportFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getMultipleUserWorkDaySetting(tenantId: number | undefined, userId: number[] | undefined): Observable<UserWorkDaySettingCreateOrEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMultipleUserWorkDaySetting?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            userId && userId.forEach(item => { url_ += "userId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultipleUserWorkDaySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultipleUserWorkDaySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWorkDaySettingCreateOrEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWorkDaySettingCreateOrEditDto[]>;
        }));
    }

    protected processGetMultipleUserWorkDaySetting(response: HttpResponseBase): Observable<UserWorkDaySettingCreateOrEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWorkDaySettingCreateOrEditDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserWorkDaySetting(body: UserWorkDaySettingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrEditUserWorkDaySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserWorkDaySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserWorkDaySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditUserWorkDaySetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getUserTrackDaySettingForEdit(tenantId: number | undefined, userId: number | undefined): Observable<UserTrackDaySettingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserTrackDaySettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTrackDaySettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTrackDaySettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrackDaySettingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrackDaySettingCreateOrEditDto>;
        }));
    }

    protected processGetUserTrackDaySettingForEdit(response: HttpResponseBase): Observable<UserTrackDaySettingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrackDaySettingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserTrackDaySetting(body: UserTrackDaySettingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrEditUserTrackDaySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserTrackDaySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserTrackDaySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditUserTrackDaySetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getUserTrackScreenSettingForEdit(tenantId: number | undefined, userId: number | undefined): Observable<UserTrackScreenSettingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserTrackScreenSettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTrackScreenSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTrackScreenSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrackScreenSettingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrackScreenSettingCreateOrEditDto>;
        }));
    }

    protected processGetUserTrackScreenSettingForEdit(response: HttpResponseBase): Observable<UserTrackScreenSettingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrackScreenSettingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserTrackScreenSetting(body: UserTrackScreenSettingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrEditUserTrackScreenSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserTrackScreenSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserTrackScreenSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditUserTrackScreenSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getUserTrackingSettingForEdit(tenantId: number | undefined, userId: number | undefined): Observable<UserTrackingSettingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserTrackingSettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTrackingSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTrackingSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTrackingSettingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTrackingSettingCreateOrEditDto>;
        }));
    }

    protected processGetUserTrackingSettingForEdit(response: HttpResponseBase): Observable<UserTrackingSettingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTrackingSettingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getAutomatedTimesheetSetting(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAutomatedTimesheetSetting?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutomatedTimesheetSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomatedTimesheetSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetAutomatedTimesheetSetting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param isEnabled (optional) 
     * @return OK
     */
    updateAutomatedTimesheetSetting(userId: number | undefined, isEnabled: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateAutomatedTimesheetSetting?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isEnabled === null)
            throw new globalThis.Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAutomatedTimesheetSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAutomatedTimesheetSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAutomatedTimesheetSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserTrackingSetting(body: UserTrackingSettingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrEditUserTrackingSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserTrackingSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserTrackingSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditUserTrackingSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserTrackOtherSetting(body: UserTrackOtherSettingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrEditUserTrackOtherSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserTrackOtherSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserTrackOtherSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditUserTrackOtherSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrEditUserEmailReportSetting(body: UserEmailSettingCreateOrEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrEditUserEmailReportSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserEmailReportSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserEmailReportSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditUserEmailReportSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getUserEmailReportSettingForEdit(tenantId: number | undefined, userId: number | undefined): Observable<UserEmailSettingCreateOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserEmailReportSettingForEdit?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEmailReportSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEmailReportSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailSettingCreateOrEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailSettingCreateOrEditDto>;
        }));
    }

    protected processGetUserEmailReportSettingForEdit(response: HttpResponseBase): Observable<UserEmailSettingCreateOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEmailSettingCreateOrEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    checkIfUserIsRegisteredTenant(tenantId: number | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/checkIfUserIsRegisteredTenant?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfUserIsRegisteredTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfUserIsRegisteredTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfUserIsRegisteredTenant(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    sendActivationMail(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SendActivationMail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendActivationMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendActivationMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendActivationMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sentDailyMailForUser(body: UserEmailReportSetting[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SentDailyMailForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentDailyMailForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentDailyMailForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSentDailyMailForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @return OK
     */
    getAllUserSettingDailyMailTimes(tenantID: number | undefined): Observable<UserEmailReportSetting[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUserSettingDailyMailTimes?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserSettingDailyMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserSettingDailyMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailReportSetting[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailReportSetting[]>;
        }));
    }

    protected processGetAllUserSettingDailyMailTimes(response: HttpResponseBase): Observable<UserEmailReportSetting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserEmailReportSetting.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sentWeeklyMailForUser(body: UserEmailReportSetting[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SentWeeklyMailForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentWeeklyMailForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentWeeklyMailForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSentWeeklyMailForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAllUserSettingWeeklyMailTimes(tenantId: number | undefined): Observable<UserEmailReportSetting[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUserSettingWeeklyMailTimes?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserSettingWeeklyMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserSettingWeeklyMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailReportSetting[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailReportSetting[]>;
        }));
    }

    protected processGetAllUserSettingWeeklyMailTimes(response: HttpResponseBase): Observable<UserEmailReportSetting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserEmailReportSetting.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sentMonthlyMailForUser(body: UserEmailReportSetting[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SentMonthlyMailForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentMonthlyMailForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentMonthlyMailForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSentMonthlyMailForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseWorkingCheckInJob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseWorkingCheckInJob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseWorkingCheckInJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseWorkingCheckInJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunUserWiseWorkingCheckInJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseWorkingCheckInJobTime(tenantId: number | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseWorkingCheckInJobTime?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseWorkingCheckInJobTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseWorkingCheckInJobTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processRunUserWiseWorkingCheckInJobTime(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sentCheckInMailToUser(body: User[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SentCheckInMailToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentCheckInMailToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentCheckInMailToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSentCheckInMailToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseWorkingCheckOutJob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseWorkingCheckOutJob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseWorkingCheckOutJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseWorkingCheckOutJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunUserWiseWorkingCheckOutJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseWorkingCheckOutJobTime(tenantId: number | undefined): Observable<User[]> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseWorkingCheckOutJobTime?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseWorkingCheckOutJobTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseWorkingCheckOutJobTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User[]>;
        }));
    }

    protected processRunUserWiseWorkingCheckOutJobTime(response: HttpResponseBase): Observable<User[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sentCheckOutMailToUser(body: User[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SentCheckOutMailToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSentCheckOutMailToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSentCheckOutMailToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSentCheckOutMailToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return OK
     */
    getUserByEmail(emailAddress: string | undefined): Observable<UserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserByEmail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto>;
        }));
    }

    protected processGetUserByEmail(response: HttpResponseBase): Observable<UserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param toRemove (optional) 
     * @return OK
     */
    archiveProjectTeams(userId: number | undefined, toRemove: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ArchiveProjectTeams?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (toRemove === null)
            throw new globalThis.Error("The parameter 'toRemove' cannot be null.");
        else if (toRemove !== undefined)
            url_ += "toRemove=" + encodeURIComponent("" + toRemove) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveProjectTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveProjectTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveProjectTeams(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    isCheckClient(userId: number | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsCheckClient?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCheckClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserById(id: number | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUserAccountInformation(body: User | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserAccountInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserAccountInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserAccountInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUserAccountInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param roleArray (optional) 
     * @param onlyLockedUsers (optional) 
     * @param isAllUserDisplay (optional) 
     * @param organizationUnit (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUsersDropDownForManager(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, roleArray: (number | undefined)[] | undefined, onlyLockedUsers: boolean | undefined, isAllUserDisplay: boolean | undefined, organizationUnit: OrganizationUnitDto[] | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersDropDownForManager?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new globalThis.Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (roleArray === null)
            throw new globalThis.Error("The parameter 'roleArray' cannot be null.");
        else if (roleArray !== undefined)
            roleArray && roleArray.forEach(item => { url_ += "RoleArray=" + encodeURIComponent("" + item) + "&"; });
        if (onlyLockedUsers === null)
            throw new globalThis.Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (isAllUserDisplay === null)
            throw new globalThis.Error("The parameter 'isAllUserDisplay' cannot be null.");
        else if (isAllUserDisplay !== undefined)
            url_ += "IsAllUserDisplay=" + encodeURIComponent("" + isAllUserDisplay) + "&";
        if (organizationUnit === null)
            throw new globalThis.Error("The parameter 'organizationUnit' cannot be null.");
        else if (organizationUnit !== undefined)
            organizationUnit && organizationUnit.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "OrganizationUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersDropDownForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersDropDownForManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetUsersDropDownForManager(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserTenantRoles(): Observable<UserTenantRolesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserTenantRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTenantRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTenantRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTenantRolesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTenantRolesDto[]>;
        }));
    }

    protected processGetUserTenantRoles(response: HttpResponseBase): Observable<UserTenantRolesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTenantRolesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param empId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    checkIfEmpIdUnique(empId: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/checkIfEmpIdUnique?";
        if (empId === null)
            throw new globalThis.Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfEmpIdUnique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfEmpIdUnique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfEmpIdUnique(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseEmailSettingDailyJob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseEmailSettingDailyJob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseEmailSettingDailyJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseEmailSettingDailyJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunUserWiseEmailSettingDailyJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseEmailSettingWeeklyJob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseEmailSettingWeeklyJob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseEmailSettingWeeklyJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseEmailSettingWeeklyJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunUserWiseEmailSettingWeeklyJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    runUserWiseEmailSettingMonthlyJob(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RunUserWiseEmailSettingMonthlyJob?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunUserWiseEmailSettingMonthlyJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunUserWiseEmailSettingMonthlyJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunUserWiseEmailSettingMonthlyJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getAllUserSettingMonthlyMailTimes(tenantId: number | undefined): Observable<UserEmailReportSetting[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUserSettingMonthlyMailTimes?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserSettingMonthlyMailTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserSettingMonthlyMailTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailReportSetting[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailReportSetting[]>;
        }));
    }

    protected processGetAllUserSettingMonthlyMailTimes(response: HttpResponseBase): Observable<UserEmailReportSetting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserEmailReportSetting.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fillAllUsersInDropdown(): Observable<FillAllUsersInDropDownDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/FillAllUsersInDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillAllUsersInDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillAllUsersInDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillAllUsersInDropDownDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillAllUsersInDropDownDto[]>;
        }));
    }

    protected processFillAllUsersInDropdown(response: HttpResponseBase): Observable<FillAllUsersInDropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FillAllUsersInDropDownDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @return OK
     */
    uploadUserStatusToBlob(tenantID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UploadUserStatusToBlob?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadUserStatusToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadUserStatusToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadUserStatusToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    truncateUserStatusTable(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/TruncateUserStatusTable?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruncateUserStatusTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruncateUserStatusTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTruncateUserStatusTable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @return OK
     */
    userActiveWindowStatusToBlob(tenantID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UserActiveWindowStatusToBlob?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActiveWindowStatusToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActiveWindowStatusToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActiveWindowStatusToBlob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    truncateUserActiveWindowTable(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/TruncateUserActiveWindowTable?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruncateUserActiveWindowTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruncateUserActiveWindowTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTruncateUserActiveWindowTable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantID (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    uplodeUserStatusBackdatatoblob(tenantID: number | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UplodeUserStatusBackdatatoblob?";
        if (tenantID === null)
            throw new globalThis.Error("The parameter 'tenantID' cannot be null.");
        else if (tenantID !== undefined)
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUplodeUserStatusBackdatatoblob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUplodeUserStatusBackdatatoblob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUplodeUserStatusBackdatatoblob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    sendEmailAppNotUsingUserListManager(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SendEmailAppNotUsingUserListManager?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailAppNotUsingUserListManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailAppNotUsingUserListManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailAppNotUsingUserListManager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param includeManagers (optional) 
     * @param userId (optional) 
     * @return OK
     */
    getProjectUnderUserListEditTaskView(projectId: number | undefined, includeManagers: boolean | undefined, userId: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetProjectUnderUserListEditTaskView?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (includeManagers === null)
            throw new globalThis.Error("The parameter 'includeManagers' cannot be null.");
        else if (includeManagers !== undefined)
            url_ += "includeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectUnderUserListEditTaskView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectUnderUserListEditTaskView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetProjectUnderUserListEditTaskView(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUsersForReportingManagerDropdown(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersForReportingManagerDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersForReportingManagerDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForReportingManagerDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetUsersForReportingManagerDropdown(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    deleteValidation(userId: number | undefined): Observable<DeleteValitaion> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteValidation?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteValitaion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteValitaion>;
        }));
    }

    protected processDeleteValidation(response: HttpResponseBase): Observable<DeleteValitaion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteValitaion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getallReportingManager(): Observable<ReportingManagerList[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetallReportingManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetallReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetallReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingManagerList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingManagerList[]>;
        }));
    }

    protected processGetallReportingManager(response: HttpResponseBase): Observable<ReportingManagerList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportingManagerList.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param managerId (optional) 
     * @return OK
     */
    getallReportees(managerId: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetallReportees?";
        if (managerId === null)
            throw new globalThis.Error("The parameter 'managerId' cannot be null.");
        else if (managerId !== undefined)
            url_ += "managerId=" + encodeURIComponent("" + managerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetallReportees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetallReportees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetallReportees(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param newManagerId (optional) 
     * @return OK
     */
    replaceReportingManager(userId: number | undefined, newManagerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ReplaceReportingManager?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (newManagerId === null)
            throw new globalThis.Error("The parameter 'newManagerId' cannot be null.");
        else if (newManagerId !== undefined)
            url_ += "newManagerId=" + encodeURIComponent("" + newManagerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceReportingManager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param oldManagerId (optional) 
     * @param newManagerId (optional) 
     * @return OK
     */
    replaceBuldReportingManager(oldManagerId: number | undefined, newManagerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ReplaceBuldReportingManager?";
        if (oldManagerId === null)
            throw new globalThis.Error("The parameter 'oldManagerId' cannot be null.");
        else if (oldManagerId !== undefined)
            url_ += "oldManagerId=" + encodeURIComponent("" + oldManagerId) + "&";
        if (newManagerId === null)
            throw new globalThis.Error("The parameter 'newManagerId' cannot be null.");
        else if (newManagerId !== undefined)
            url_ += "newManagerId=" + encodeURIComponent("" + newManagerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceBuldReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceBuldReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceBuldReportingManager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @return OK
     */
    deleteValidationFromMultipleUsers(userIds: number[] | undefined): Observable<ValueTupleOfStringListOfInt64> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteValidationFromMultipleUsers?";
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteValidationFromMultipleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValidationFromMultipleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfStringListOfInt64>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfStringListOfInt64>;
        }));
    }

    protected processDeleteValidationFromMultipleUsers(response: HttpResponseBase): Observable<ValueTupleOfStringListOfInt64> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfStringListOfInt64.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    updateApprovals(userId: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateApprovals?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateApprovals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newManagerId (optional) 
     * @param body (optional) 
     * @return OK
     */
    replaceBulkReportingManager(newManagerId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ReplaceBulkReportingManager?";
        if (newManagerId === null)
            throw new globalThis.Error("The parameter 'newManagerId' cannot be null.");
        else if (newManagerId !== undefined)
            url_ += "newManagerId=" + encodeURIComponent("" + newManagerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceBulkReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceBulkReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceBulkReportingManager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return OK
     */
    isTenantPresentForEmail(emailAddress: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsTenantPresentForEmail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantPresentForEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantPresentForEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTenantPresentForEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTheme(body: UpdateThemeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTheme(): Observable<ThemeDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTheme";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeDto>;
        }));
    }

    protected processGetTheme(response: HttpResponseBase): Observable<ThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param result (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUserLoginAttempts(filter: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, result: AbpLoginResultType | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (result === null)
            throw new globalThis.Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "Result=" + encodeURIComponent("" + result) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkLoginAttemts(): Observable<UserLoginAttemptOnboardingDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/CheckLoginAttemts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLoginAttemts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLoginAttemts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginAttemptOnboardingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginAttemptOnboardingDto>;
        }));
    }

    protected processCheckLoginAttemts(response: HttpResponseBase): Observable<UserLoginAttemptOnboardingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLoginAttemptOnboardingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserOutlookCalendarEventServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userID (optional) 
     * @return OK
     */
    getOutlookEventsFromUserTableByUserID(userID: number | undefined): Observable<UserOutlookCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserOutlookCalendarEventService/GetOutlookEventsFromUserTableByUserID?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutlookEventsFromUserTableByUserID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutlookEventsFromUserTableByUserID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOutlookCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOutlookCalendarEventDto[]>;
        }));
    }

    protected processGetOutlookEventsFromUserTableByUserID(response: HttpResponseBase): Observable<UserOutlookCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOutlookCalendarEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userID (optional) 
     * @param body (optional) 
     * @return OK
     */
    syncOutlookEventsInUserTable(userID: number | undefined, body: OutlookCalendarEventDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserOutlookCalendarEventService/SyncOutlookEventsInUserTable?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOutlookEventsInUserTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOutlookEventsInUserTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSyncOutlookEventsInUserTable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserUtilizationDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    cardDetialsforUserUtilizationDashboard(): Observable<UserUtilizationDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/CardDetialsforUserUtilizationDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardDetialsforUserUtilizationDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardDetialsforUserUtilizationDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserUtilizationDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserUtilizationDashboardDto>;
        }));
    }

    protected processCardDetialsforUserUtilizationDashboard(response: HttpResponseBase): Observable<UserUtilizationDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserUtilizationDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllActiveUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetAllActiveUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetAllActiveUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employeeName (optional) 
     * @param projectName (optional) 
     * @param designationId (optional) 
     * @param filterDate (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @param projectBillingType (optional) 
     * @param projectTypeId (optional) 
     * @return OK
     */
    getUsersOnBench(employeeName: string | undefined, projectName: string | undefined, designationId: number | undefined, filterDate: DateTime | undefined, month: number | undefined, year: number | undefined, projectBillingType: ProjectBillingType | undefined, projectTypeId: number | undefined): Observable<UserAllocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetUsersOnBench?";
        if (employeeName === null)
            throw new globalThis.Error("The parameter 'employeeName' cannot be null.");
        else if (employeeName !== undefined)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (projectName === null)
            throw new globalThis.Error("The parameter 'projectName' cannot be null.");
        else if (projectName !== undefined)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (designationId === null)
            throw new globalThis.Error("The parameter 'designationId' cannot be null.");
        else if (designationId !== undefined)
            url_ += "DesignationId=" + encodeURIComponent("" + designationId) + "&";
        if (filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' cannot be null.");
        else if (filterDate !== undefined)
            url_ += "filterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toString() : "") + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (projectBillingType === null)
            throw new globalThis.Error("The parameter 'projectBillingType' cannot be null.");
        else if (projectBillingType !== undefined)
            url_ += "ProjectBillingType=" + encodeURIComponent("" + projectBillingType) + "&";
        if (projectTypeId === null)
            throw new globalThis.Error("The parameter 'projectTypeId' cannot be null.");
        else if (projectTypeId !== undefined)
            url_ += "projectTypeId=" + encodeURIComponent("" + projectTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersOnBench(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersOnBench(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAllocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAllocationDto[]>;
        }));
    }

    protected processGetUsersOnBench(response: HttpResponseBase): Observable<UserAllocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAllocationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterDate (optional) 
     * @return OK
     */
    getAllUserOnBeachDropdown(filterDate: DateTime | undefined): Observable<FillAllUsersInDropDownDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetAllUserOnBeachDropdown?";
        if (filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' cannot be null.");
        else if (filterDate !== undefined)
            url_ += "filterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserOnBeachDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserOnBeachDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillAllUsersInDropDownDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillAllUsersInDropDownDto[]>;
        }));
    }

    protected processGetAllUserOnBeachDropdown(response: HttpResponseBase): Observable<FillAllUsersInDropDownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FillAllUsersInDropDownDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBillableUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetBillableUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetBillableUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNonBillableUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetNonBillableUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonBillableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonBillableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetNonBillableUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTrainingUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetTrainingUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetTrainingUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPartiallyEngagedUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetPartiallyEngagedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartiallyEngagedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartiallyEngagedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }));
    }

    protected processGetPartiallyEngagedUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userDetailsAccordingToProjectAllocation(body: UserAllocationFilterDto | undefined): Observable<UserAllocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/userDetailsAccordingToProjectAllocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDetailsAccordingToProjectAllocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDetailsAccordingToProjectAllocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAllocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAllocationDto[]>;
        }));
    }

    protected processUserDetailsAccordingToProjectAllocation(response: HttpResponseBase): Observable<UserAllocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAllocationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDesignationForDropDown(): Observable<DesignationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserUtilizationDashboard/GetDesignationForDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignationForDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationForDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationDto[]>;
        }));
    }

    protected processGetDesignationForDropDown(response: HttpResponseBase): Observable<DesignationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: string | undefined): Observable<WebhookEvent> {
        let url_ = this.baseUrl + "/api/services/app/WebhookEvent/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebhookEvent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebhookEvent>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WebhookEvent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookEvent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookSendAttemptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param subscriptionId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllSendAttempts(subscriptionId: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttempts?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
        }));
    }

    protected processGetAllSendAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllSendAttemptsOfWebhookEvent(id: string | undefined): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttemptsOfWebhookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttemptsOfWebhookEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
        }));
    }

    protected processGetAllSendAttemptsOfWebhookEvent(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sendAttemptId (optional) 
     * @return OK
     */
    resend(sendAttemptId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/Resend?";
        if (sendAttemptId === null)
            throw new globalThis.Error("The parameter 'sendAttemptId' cannot be null.");
        else if (sendAttemptId !== undefined)
            url_ += "sendAttemptId=" + encodeURIComponent("" + sendAttemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    publishTestWebhook(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/PublishTestWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishTestWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishTestWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPublishTestWebhook(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllSubscriptions(): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }));
    }

    protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriptionId (optional) 
     * @return OK
     */
    getSubscription(subscriptionId: string | undefined): Observable<WebhookSubscription> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetSubscription?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebhookSubscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebhookSubscription>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<WebhookSubscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookSubscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSubscription(body: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/AddSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSubscription(body: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateWebhookSubscription(body: ActivateWebhookSubscriptionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/ActivateWebhookSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateWebhookSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateWebhookSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateWebhookSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param webhookName (optional) 
     * @return OK
     */
    isSubscribed(webhookName: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/IsSubscribed?";
        if (webhookName === null)
            throw new globalThis.Error("The parameter 'webhookName' cannot be null.");
        else if (webhookName !== undefined)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSubscribed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSubscribed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSubscribed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param webhookName (optional) 
     * @return OK
     */
    getAllSubscriptionsIfFeaturesGranted(webhookName: string | undefined): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?";
        if (webhookName === null)
            throw new globalThis.Error("The parameter 'webhookName' cannot be null.");
        else if (webhookName !== undefined)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionsIfFeaturesGranted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionsIfFeaturesGranted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }));
    }

    protected processGetAllSubscriptionsIfFeaturesGranted(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAvailableWebhooks(): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllAvailableWebhooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableWebhooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
        }));
    }

    protected processGetAllAvailableWebhooks(response: HttpResponseBase): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum AbpLoginResultType {
    Success = 1,
    InvalidUserNameOrEmailAddress = 2,
    InvalidPassword = 3,
    UserIsNotActive = 4,
    InvalidTenancyName = 5,
    TenantIsNotActive = 6,
    UserEmailIsNotConfirmed = 7,
    UnknownExternalLogin = 8,
    LockedOut = 9,
    UserPhoneNumberIsNotConfirmed = 10,
    FailedForOtherReason = 11,
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ActivateWebhookSubscriptionInput implements IActivateWebhookSubscriptionInput {
    subscriptionId!: string;
    isActive!: boolean;

    constructor(data?: IActivateWebhookSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivateWebhookSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateWebhookSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivateWebhookSubscriptionInput {
    subscriptionId: string;
    isActive: boolean;
}

export class ActiveTimeDto implements IActiveTimeDto {
    totalActiveTime!: string;
    hours!: number;
    minutes!: number;
    arriavalTime!: DateTime;
    totalTimeAtWork!: string;

    constructor(data?: IActiveTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalActiveTime = _data["totalActiveTime"];
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
            this.arriavalTime = _data["arriavalTime"] ? DateTime.fromISO(_data["arriavalTime"].toString()) : undefined as any;
            this.totalTimeAtWork = _data["totalTimeAtWork"];
        }
    }

    static fromJS(data: any): ActiveTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalActiveTime"] = this.totalActiveTime;
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        data["arriavalTime"] = this.arriavalTime ? this.arriavalTime.toString() : undefined as any;
        data["totalTimeAtWork"] = this.totalTimeAtWork;
        return data;
    }
}

export interface IActiveTimeDto {
    totalActiveTime: string;
    hours: number;
    minutes: number;
    arriavalTime: DateTime;
    totalTimeAtWork: string;
}

export class ActiveUserDto implements IActiveUserDto {
    productiveTime!: string | undefined;
    inTimeProsTime!: string | undefined;
    arrivedAt!: string | undefined;
    leftAt!: string | undefined;
    atWork!: string | undefined;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    userLocation!: string | undefined;
    productivityTypeId!: number | undefined;
    projectId!: number[] | undefined;
    orgnizationId!: number;
    userStatusId!: UserStatusEnum;
    workingType!: WorkFromType;
    userName!: string | undefined;
    userRole!: string[] | undefined;
    userImage!: string | undefined;
    emailAddress!: string | undefined;
    contactNumber!: string | undefined;
    projectName!: string | undefined;
    projectIcon!: string | undefined;
    orgnizationName!: string | undefined;
    projectTaskState!: string | undefined;
    arriveDateTime!: DateTime | undefined;
    leftDateTime!: DateTime | undefined;
    id!: number;

    constructor(data?: IActiveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productiveTime = _data["productiveTime"];
            this.inTimeProsTime = _data["inTimeProsTime"];
            this.arrivedAt = _data["arrivedAt"];
            this.leftAt = _data["leftAt"];
            this.atWork = _data["atWork"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.userLocation = _data["userLocation"];
            this.productivityTypeId = _data["productivityTypeId"];
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.orgnizationId = _data["orgnizationId"];
            this.userStatusId = _data["userStatusId"];
            this.workingType = _data["workingType"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userImage = _data["userImage"];
            this.emailAddress = _data["emailAddress"];
            this.contactNumber = _data["contactNumber"];
            this.projectName = _data["projectName"];
            this.projectIcon = _data["projectIcon"];
            this.orgnizationName = _data["orgnizationName"];
            this.projectTaskState = _data["projectTaskState"];
            this.arriveDateTime = _data["arriveDateTime"] ? DateTime.fromISO(_data["arriveDateTime"].toString()) : undefined as any;
            this.leftDateTime = _data["leftDateTime"] ? DateTime.fromISO(_data["leftDateTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActiveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productiveTime"] = this.productiveTime;
        data["inTimeProsTime"] = this.inTimeProsTime;
        data["arrivedAt"] = this.arrivedAt;
        data["leftAt"] = this.leftAt;
        data["atWork"] = this.atWork;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["userLocation"] = this.userLocation;
        data["productivityTypeId"] = this.productivityTypeId;
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["orgnizationId"] = this.orgnizationId;
        data["userStatusId"] = this.userStatusId;
        data["workingType"] = this.workingType;
        data["userName"] = this.userName;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userImage"] = this.userImage;
        data["emailAddress"] = this.emailAddress;
        data["contactNumber"] = this.contactNumber;
        data["projectName"] = this.projectName;
        data["projectIcon"] = this.projectIcon;
        data["orgnizationName"] = this.orgnizationName;
        data["projectTaskState"] = this.projectTaskState;
        data["arriveDateTime"] = this.arriveDateTime ? this.arriveDateTime.toString() : undefined as any;
        data["leftDateTime"] = this.leftDateTime ? this.leftDateTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IActiveUserDto {
    productiveTime: string | undefined;
    inTimeProsTime: string | undefined;
    arrivedAt: string | undefined;
    leftAt: string | undefined;
    atWork: string | undefined;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    userLocation: string | undefined;
    productivityTypeId: number | undefined;
    projectId: number[] | undefined;
    orgnizationId: number;
    userStatusId: UserStatusEnum;
    workingType: WorkFromType;
    userName: string | undefined;
    userRole: string[] | undefined;
    userImage: string | undefined;
    emailAddress: string | undefined;
    contactNumber: string | undefined;
    projectName: string | undefined;
    projectIcon: string | undefined;
    orgnizationName: string | undefined;
    projectTaskState: string | undefined;
    arriveDateTime: DateTime | undefined;
    leftDateTime: DateTime | undefined;
    id: number;
}

export class ActiveWindowHistoryDetailsDto implements IActiveWindowHistoryDetailsDto {
    windowName!: string | undefined;
    hours!: string | undefined;
    minutes!: string | undefined;
    seconds!: string | undefined;

    constructor(data?: IActiveWindowHistoryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.windowName = _data["windowName"];
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
        }
    }

    static fromJS(data: any): ActiveWindowHistoryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveWindowHistoryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windowName"] = this.windowName;
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        return data;
    }
}

export interface IActiveWindowHistoryDetailsDto {
    windowName: string | undefined;
    hours: string | undefined;
    minutes: string | undefined;
    seconds: string | undefined;
}

export class AddAgentAppDto implements IAddAgentAppDto {
    applicationName!: string | undefined;
    icon!: string | undefined;
    tenantId!: number | undefined;
    webSiteIcon!: string | undefined;
    webSiteName!: string | undefined;
    id!: number;

    constructor(data?: IAddAgentAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.icon = _data["icon"];
            this.tenantId = _data["tenantId"];
            this.webSiteIcon = _data["webSiteIcon"];
            this.webSiteName = _data["webSiteName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddAgentAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgentAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["icon"] = this.icon;
        data["tenantId"] = this.tenantId;
        data["webSiteIcon"] = this.webSiteIcon;
        data["webSiteName"] = this.webSiteName;
        data["id"] = this.id;
        return data;
    }
}

export interface IAddAgentAppDto {
    applicationName: string | undefined;
    icon: string | undefined;
    tenantId: number | undefined;
    webSiteIcon: string | undefined;
    webSiteName: string | undefined;
    id: number;
}

export class AddAttachmentInput implements IAddAttachmentInput {
    projectTaskId!: number;
    fileName!: string | undefined;
    filePath!: string | undefined;
    tenantId!: number | undefined;
    fileSize!: number;
    fileType!: string | undefined;
    createdTime!: DateTime;

    constructor(data?: IAddAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTaskId = _data["projectTaskId"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.tenantId = _data["tenantId"];
            this.fileSize = _data["fileSize"];
            this.fileType = _data["fileType"];
            this.createdTime = _data["createdTime"] ? DateTime.fromISO(_data["createdTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AddAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTaskId"] = this.projectTaskId;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["tenantId"] = this.tenantId;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["createdTime"] = this.createdTime ? this.createdTime.toString() : undefined as any;
        return data;
    }
}

export interface IAddAttachmentInput {
    projectTaskId: number;
    fileName: string | undefined;
    filePath: string | undefined;
    tenantId: number | undefined;
    fileSize: number;
    fileType: string | undefined;
    createdTime: DateTime;
}

export class AddAwayTimeCreateOrEditDto implements IAddAwayTimeCreateOrEditDto {
    tenantId!: number;
    title!: string | undefined;
    addTimeStatus!: AddTimeStatus;
    awayTimeType!: AwayTimeType;
    description!: string | undefined;
    fromDate!: DateTime;
    toDate!: DateTime;
    addTimeTeams!: UserListDto[] | undefined;
    addTimeProject!: ProjectGetAllDto[] | undefined;
    leaveTypeInfo!: LeaveType;
    dayTypeInfo!: DayType;
    id!: number | undefined;

    constructor(data?: IAddAwayTimeCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.title = _data["title"];
            this.addTimeStatus = _data["addTimeStatus"];
            this.awayTimeType = _data["awayTimeType"];
            this.description = _data["description"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["addTimeTeams"])) {
                this.addTimeTeams = [] as any;
                for (let item of _data["addTimeTeams"])
                    this.addTimeTeams!.push(UserListDto.fromJS(item));
            }
            if (Array.isArray(_data["addTimeProject"])) {
                this.addTimeProject = [] as any;
                for (let item of _data["addTimeProject"])
                    this.addTimeProject!.push(ProjectGetAllDto.fromJS(item));
            }
            this.leaveTypeInfo = _data["leaveTypeInfo"];
            this.dayTypeInfo = _data["dayTypeInfo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddAwayTimeCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAwayTimeCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["addTimeStatus"] = this.addTimeStatus;
        data["awayTimeType"] = this.awayTimeType;
        data["description"] = this.description;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.addTimeTeams)) {
            data["addTimeTeams"] = [];
            for (let item of this.addTimeTeams)
                data["addTimeTeams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.addTimeProject)) {
            data["addTimeProject"] = [];
            for (let item of this.addTimeProject)
                data["addTimeProject"].push(item ? item.toJSON() : undefined as any);
        }
        data["leaveTypeInfo"] = this.leaveTypeInfo;
        data["dayTypeInfo"] = this.dayTypeInfo;
        data["id"] = this.id;
        return data;
    }
}

export interface IAddAwayTimeCreateOrEditDto {
    tenantId: number;
    title: string | undefined;
    addTimeStatus: AddTimeStatus;
    awayTimeType: AwayTimeType;
    description: string | undefined;
    fromDate: DateTime;
    toDate: DateTime;
    addTimeTeams: UserListDto[] | undefined;
    addTimeProject: ProjectGetAllDto[] | undefined;
    leaveTypeInfo: LeaveType;
    dayTypeInfo: DayType;
    id: number | undefined;
}

export class AddAwayTimeGetAllDto implements IAddAwayTimeGetAllDto {
    id!: number;
    title!: string | undefined;
    addTimeStatus!: AddTimeStatus;
    awayTimeType!: AwayTimeType;
    description!: string | undefined;
    fromDate!: DateTime;
    toDate!: DateTime;
    projectId!: number;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    userId!: number;
    userName!: string | undefined;
    userImage!: string | undefined;
    designation!: string | undefined;
    daysTaken!: number;
    daysOfRequest!: number;
    city!: string | undefined;
    reportingLocation!: string | undefined;
    reportingLocationId!: number;
    createdDateTime!: DateTime;
    firstApproverName!: string | undefined;
    firstApproverEmail!: string | undefined;
    firstApproverImage!: string | undefined;
    tenantId!: number;
    awayTimeTypeName!: string | undefined;
    addTimeStatusName!: string | undefined;
    organizationUnitId!: number | undefined;
    profilePictureId!: string | undefined;
    selectedProfileImage!: string | undefined;
    fromToDate!: string | undefined;
    availablePaidLeave!: number;
    availableUnPaidLeave!: number;
    availablePreviledgedLeave!: number;
    userRole!: string[] | undefined;
    userStatusId!: UserStatusEnum;
    managerId!: number | undefined;
    leaveTypeInfo!: LeaveType;
    dayTypeInfo!: DayType;
    timeOffApproversList!: AddTimeOffApprovers[] | undefined;
    currentUserHasPermissionToApprove!: boolean;
    employeeId!: string | undefined;

    constructor(data?: IAddAwayTimeGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.addTimeStatus = _data["addTimeStatus"];
            this.awayTimeType = _data["awayTimeType"];
            this.description = _data["description"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.designation = _data["designation"];
            this.daysTaken = _data["daysTaken"];
            this.daysOfRequest = _data["daysOfRequest"];
            this.city = _data["city"];
            this.reportingLocation = _data["reportingLocation"];
            this.reportingLocationId = _data["reportingLocationId"];
            this.createdDateTime = _data["createdDateTime"] ? DateTime.fromISO(_data["createdDateTime"].toString()) : undefined as any;
            this.firstApproverName = _data["firstApproverName"];
            this.firstApproverEmail = _data["firstApproverEmail"];
            this.firstApproverImage = _data["firstApproverImage"];
            this.tenantId = _data["tenantId"];
            this.awayTimeTypeName = _data["awayTimeTypeName"];
            this.addTimeStatusName = _data["addTimeStatusName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.profilePictureId = _data["profilePictureId"];
            this.selectedProfileImage = _data["selectedProfileImage"];
            this.fromToDate = _data["fromToDate"];
            this.availablePaidLeave = _data["availablePaidLeave"];
            this.availableUnPaidLeave = _data["availableUnPaidLeave"];
            this.availablePreviledgedLeave = _data["availablePreviledgedLeave"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userStatusId = _data["userStatusId"];
            this.managerId = _data["managerId"];
            this.leaveTypeInfo = _data["leaveTypeInfo"];
            this.dayTypeInfo = _data["dayTypeInfo"];
            if (Array.isArray(_data["timeOffApproversList"])) {
                this.timeOffApproversList = [] as any;
                for (let item of _data["timeOffApproversList"])
                    this.timeOffApproversList!.push(AddTimeOffApprovers.fromJS(item));
            }
            this.currentUserHasPermissionToApprove = _data["currentUserHasPermissionToApprove"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): AddAwayTimeGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAwayTimeGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["addTimeStatus"] = this.addTimeStatus;
        data["awayTimeType"] = this.awayTimeType;
        data["description"] = this.description;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["designation"] = this.designation;
        data["daysTaken"] = this.daysTaken;
        data["daysOfRequest"] = this.daysOfRequest;
        data["city"] = this.city;
        data["reportingLocation"] = this.reportingLocation;
        data["reportingLocationId"] = this.reportingLocationId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toString() : undefined as any;
        data["firstApproverName"] = this.firstApproverName;
        data["firstApproverEmail"] = this.firstApproverEmail;
        data["firstApproverImage"] = this.firstApproverImage;
        data["tenantId"] = this.tenantId;
        data["awayTimeTypeName"] = this.awayTimeTypeName;
        data["addTimeStatusName"] = this.addTimeStatusName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["profilePictureId"] = this.profilePictureId;
        data["selectedProfileImage"] = this.selectedProfileImage;
        data["fromToDate"] = this.fromToDate;
        data["availablePaidLeave"] = this.availablePaidLeave;
        data["availableUnPaidLeave"] = this.availableUnPaidLeave;
        data["availablePreviledgedLeave"] = this.availablePreviledgedLeave;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userStatusId"] = this.userStatusId;
        data["managerId"] = this.managerId;
        data["leaveTypeInfo"] = this.leaveTypeInfo;
        data["dayTypeInfo"] = this.dayTypeInfo;
        if (Array.isArray(this.timeOffApproversList)) {
            data["timeOffApproversList"] = [];
            for (let item of this.timeOffApproversList)
                data["timeOffApproversList"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentUserHasPermissionToApprove"] = this.currentUserHasPermissionToApprove;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IAddAwayTimeGetAllDto {
    id: number;
    title: string | undefined;
    addTimeStatus: AddTimeStatus;
    awayTimeType: AwayTimeType;
    description: string | undefined;
    fromDate: DateTime;
    toDate: DateTime;
    projectId: number;
    projectName: string | undefined;
    projectImage: string | undefined;
    userId: number;
    userName: string | undefined;
    userImage: string | undefined;
    designation: string | undefined;
    daysTaken: number;
    daysOfRequest: number;
    city: string | undefined;
    reportingLocation: string | undefined;
    reportingLocationId: number;
    createdDateTime: DateTime;
    firstApproverName: string | undefined;
    firstApproverEmail: string | undefined;
    firstApproverImage: string | undefined;
    tenantId: number;
    awayTimeTypeName: string | undefined;
    addTimeStatusName: string | undefined;
    organizationUnitId: number | undefined;
    profilePictureId: string | undefined;
    selectedProfileImage: string | undefined;
    fromToDate: string | undefined;
    availablePaidLeave: number;
    availableUnPaidLeave: number;
    availablePreviledgedLeave: number;
    userRole: string[] | undefined;
    userStatusId: UserStatusEnum;
    managerId: number | undefined;
    leaveTypeInfo: LeaveType;
    dayTypeInfo: DayType;
    timeOffApproversList: AddTimeOffApprovers[] | undefined;
    currentUserHasPermissionToApprove: boolean;
    employeeId: string | undefined;
}

export class AddAwayTimeGetAllDtoApprovalDto implements IAddAwayTimeGetAllDtoApprovalDto {
    addAwayTimeGetAllDto!: AddAwayTimeGetAllDto[] | undefined;
    pageCount!: number;
    totalCount!: number;
    id!: number;

    constructor(data?: IAddAwayTimeGetAllDtoApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addAwayTimeGetAllDto"])) {
                this.addAwayTimeGetAllDto = [] as any;
                for (let item of _data["addAwayTimeGetAllDto"])
                    this.addAwayTimeGetAllDto!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            this.pageCount = _data["pageCount"];
            this.totalCount = _data["totalCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddAwayTimeGetAllDtoApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAwayTimeGetAllDtoApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addAwayTimeGetAllDto)) {
            data["addAwayTimeGetAllDto"] = [];
            for (let item of this.addAwayTimeGetAllDto)
                data["addAwayTimeGetAllDto"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageCount"] = this.pageCount;
        data["totalCount"] = this.totalCount;
        data["id"] = this.id;
        return data;
    }
}

export interface IAddAwayTimeGetAllDtoApprovalDto {
    addAwayTimeGetAllDto: AddAwayTimeGetAllDto[] | undefined;
    pageCount: number;
    totalCount: number;
    id: number;
}

export class AddAwayTimeInputDto implements IAddAwayTimeInputDto {
    projectId!: (number | undefined)[] | undefined;
    userId!: (number | undefined)[] | undefined;

    constructor(data?: IAddAwayTimeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
        }
    }

    static fromJS(data: any): AddAwayTimeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAwayTimeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        return data;
    }
}

export interface IAddAwayTimeInputDto {
    projectId: (number | undefined)[] | undefined;
    userId: (number | undefined)[] | undefined;
}

export class AddCommentTaskDto implements IAddCommentTaskDto {
    comments!: string | undefined;
    commentId!: number;
    isRed!: boolean;
    userId!: number;
    tenantId!: number;
    taskId!: number;

    constructor(data?: IAddCommentTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
            this.commentId = _data["commentId"];
            this.isRed = _data["isRed"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): AddCommentTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCommentTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["commentId"] = this.commentId;
        data["isRed"] = this.isRed;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface IAddCommentTaskDto {
    comments: string | undefined;
    commentId: number;
    isRed: boolean;
    userId: number;
    tenantId: number;
    taskId: number;
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data;
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddOnboardingInviteTeamDto implements IAddOnboardingInviteTeamDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    organizationUnit!: string | undefined;
    managerEmail!: string | undefined;
    mobileNumber!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    reportingLocation!: string | undefined;
    loginAccess!: string | undefined;
    tenantId!: number;
    password!: string | undefined;
    assignedRoleNames!: string[] | undefined;
    exception!: string | undefined;
    isGoogleLogin!: boolean;
    isMicrosoftLogin!: boolean;
    isIntimeProLogin!: boolean;
    employeeId!: string | undefined;

    constructor(data?: IAddOnboardingInviteTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.organizationUnit = _data["organizationUnit"];
            this.managerEmail = _data["managerEmail"];
            this.mobileNumber = _data["mobileNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.reportingLocation = _data["reportingLocation"];
            this.loginAccess = _data["loginAccess"];
            this.tenantId = _data["tenantId"];
            this.password = _data["password"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.exception = _data["exception"];
            this.isGoogleLogin = _data["isGoogleLogin"];
            this.isMicrosoftLogin = _data["isMicrosoftLogin"];
            this.isIntimeProLogin = _data["isIntimeProLogin"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): AddOnboardingInviteTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddOnboardingInviteTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["organizationUnit"] = this.organizationUnit;
        data["managerEmail"] = this.managerEmail;
        data["mobileNumber"] = this.mobileNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["reportingLocation"] = this.reportingLocation;
        data["loginAccess"] = this.loginAccess;
        data["tenantId"] = this.tenantId;
        data["password"] = this.password;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["exception"] = this.exception;
        data["isGoogleLogin"] = this.isGoogleLogin;
        data["isMicrosoftLogin"] = this.isMicrosoftLogin;
        data["isIntimeProLogin"] = this.isIntimeProLogin;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IAddOnboardingInviteTeamDto {
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    organizationUnit: string | undefined;
    managerEmail: string | undefined;
    mobileNumber: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    reportingLocation: string | undefined;
    loginAccess: string | undefined;
    tenantId: number;
    password: string | undefined;
    assignedRoleNames: string[] | undefined;
    exception: string | undefined;
    isGoogleLogin: boolean;
    isMicrosoftLogin: boolean;
    isIntimeProLogin: boolean;
    employeeId: string | undefined;
}

export class AddTimeOffApprovers implements IAddTimeOffApprovers {
    timeOffApproverName!: string | undefined;
    timeOffApproverEmail!: string | undefined;
    timeOffApproverImage!: string | undefined;
    isManagar!: boolean;
    approverId!: number | undefined;
    addTimeStatus!: AddTimeStatus;
    timeOffApproverRole!: string | undefined;
    approvalTime!: DateTime | undefined;
    timeOffApproverProjectName!: string | undefined;
    sequenceId!: number;

    constructor(data?: IAddTimeOffApprovers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeOffApproverName = _data["timeOffApproverName"];
            this.timeOffApproverEmail = _data["timeOffApproverEmail"];
            this.timeOffApproverImage = _data["timeOffApproverImage"];
            this.isManagar = _data["isManagar"];
            this.approverId = _data["approverId"];
            this.addTimeStatus = _data["addTimeStatus"];
            this.timeOffApproverRole = _data["timeOffApproverRole"];
            this.approvalTime = _data["approvalTime"] ? DateTime.fromISO(_data["approvalTime"].toString()) : undefined as any;
            this.timeOffApproverProjectName = _data["timeOffApproverProjectName"];
            this.sequenceId = _data["sequenceId"];
        }
    }

    static fromJS(data: any): AddTimeOffApprovers {
        data = typeof data === 'object' ? data : {};
        let result = new AddTimeOffApprovers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeOffApproverName"] = this.timeOffApproverName;
        data["timeOffApproverEmail"] = this.timeOffApproverEmail;
        data["timeOffApproverImage"] = this.timeOffApproverImage;
        data["isManagar"] = this.isManagar;
        data["approverId"] = this.approverId;
        data["addTimeStatus"] = this.addTimeStatus;
        data["timeOffApproverRole"] = this.timeOffApproverRole;
        data["approvalTime"] = this.approvalTime ? this.approvalTime.toString() : undefined as any;
        data["timeOffApproverProjectName"] = this.timeOffApproverProjectName;
        data["sequenceId"] = this.sequenceId;
        return data;
    }
}

export interface IAddTimeOffApprovers {
    timeOffApproverName: string | undefined;
    timeOffApproverEmail: string | undefined;
    timeOffApproverImage: string | undefined;
    isManagar: boolean;
    approverId: number | undefined;
    addTimeStatus: AddTimeStatus;
    timeOffApproverRole: string | undefined;
    approvalTime: DateTime | undefined;
    timeOffApproverProjectName: string | undefined;
    sequenceId: number;
}

export class AddTimeOffCommentsDto implements IAddTimeOffCommentsDto {
    tenantId!: number;
    timeOffId!: number;
    userId!: number;
    comments!: string | undefined;
    id!: number | undefined;

    constructor(data?: IAddTimeOffCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.timeOffId = _data["timeOffId"];
            this.userId = _data["userId"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddTimeOffCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddTimeOffCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["timeOffId"] = this.timeOffId;
        data["userId"] = this.userId;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    }
}

export interface IAddTimeOffCommentsDto {
    tenantId: number;
    timeOffId: number;
    userId: number;
    comments: string | undefined;
    id: number | undefined;
}

export enum AddTimeStatus {
    Approved = 1,
    Pending = 2,
    Rejected = 3,
    Overdue = 4,
    SystemApproved = 5,
    NA = 6,
}

export class AddTimesheetDto implements IAddTimesheetDto {
    taskId!: number;
    taskName!: string | undefined;
    projectId!: number;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    totalSeconds!: number;
    description!: string | undefined;
    taskState!: TaskStateType;
    isCheck!: boolean;
    timesheetId!: number[] | undefined;
    billabilityStatus!: number;
    descDate!: DateTime | undefined;

    constructor(data?: IAddTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.projectId = _data["projectId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.totalSeconds = _data["totalSeconds"];
            this.description = _data["description"];
            this.taskState = _data["taskState"];
            this.isCheck = _data["isCheck"];
            if (Array.isArray(_data["timesheetId"])) {
                this.timesheetId = [] as any;
                for (let item of _data["timesheetId"])
                    this.timesheetId!.push(item);
            }
            this.billabilityStatus = _data["billabilityStatus"];
            this.descDate = _data["descDate"] ? DateTime.fromISO(_data["descDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AddTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["projectId"] = this.projectId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["totalSeconds"] = this.totalSeconds;
        data["description"] = this.description;
        data["taskState"] = this.taskState;
        data["isCheck"] = this.isCheck;
        if (Array.isArray(this.timesheetId)) {
            data["timesheetId"] = [];
            for (let item of this.timesheetId)
                data["timesheetId"].push(item);
        }
        data["billabilityStatus"] = this.billabilityStatus;
        data["descDate"] = this.descDate ? this.descDate.toString() : undefined as any;
        return data;
    }
}

export interface IAddTimesheetDto {
    taskId: number;
    taskName: string | undefined;
    projectId: number;
    startDateTime: DateTime;
    endDateTime: DateTime;
    totalSeconds: number;
    description: string | undefined;
    taskState: TaskStateType;
    isCheck: boolean;
    timesheetId: number[] | undefined;
    billabilityStatus: number;
    descDate: DateTime | undefined;
}

export class AddTimesheetDtoForMobile implements IAddTimesheetDtoForMobile {
    taskId!: number;
    taskName!: string | undefined;
    projectId!: number;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    totalSeconds!: number;
    description!: string | undefined;
    taskState!: TaskStateType;
    isCheck!: boolean;
    timesheetId!: number;
    billabilityStatus!: number;
    userId!: number;
    tenantId!: number;

    constructor(data?: IAddTimesheetDtoForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.projectId = _data["projectId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.totalSeconds = _data["totalSeconds"];
            this.description = _data["description"];
            this.taskState = _data["taskState"];
            this.isCheck = _data["isCheck"];
            this.timesheetId = _data["timesheetId"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AddTimesheetDtoForMobile {
        data = typeof data === 'object' ? data : {};
        let result = new AddTimesheetDtoForMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["projectId"] = this.projectId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["totalSeconds"] = this.totalSeconds;
        data["description"] = this.description;
        data["taskState"] = this.taskState;
        data["isCheck"] = this.isCheck;
        data["timesheetId"] = this.timesheetId;
        data["billabilityStatus"] = this.billabilityStatus;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAddTimesheetDtoForMobile {
    taskId: number;
    taskName: string | undefined;
    projectId: number;
    startDateTime: DateTime;
    endDateTime: DateTime;
    totalSeconds: number;
    description: string | undefined;
    taskState: TaskStateType;
    isCheck: boolean;
    timesheetId: number;
    billabilityStatus: number;
    userId: number;
    tenantId: number;
}

export class AddTimesheetLevelCommentDto implements IAddTimesheetLevelCommentDto {
    userId!: number;
    tenantId!: number;
    myTimeSheetId!: number;
    comments!: string | undefined;

    constructor(data?: IAddTimesheetLevelCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.myTimeSheetId = _data["myTimeSheetId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AddTimesheetLevelCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddTimesheetLevelCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["myTimeSheetId"] = this.myTimeSheetId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IAddTimesheetLevelCommentDto {
    userId: number;
    tenantId: number;
    myTimeSheetId: number;
    comments: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.pageId = _data["pageId"];
            this.dashboardName = _data["dashboardName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class Address2 implements IAddress2 {
    routeNumbers!: any[] | undefined;
    countryCode!: string | undefined;
    countrySubdivision!: string | undefined;
    countrySecondarySubdivision!: string | undefined;
    municipality!: string | undefined;
    postalCode!: string | undefined;
    municipalitySubdivision!: string | undefined;
    country!: string | undefined;
    countryCodeISO3!: string | undefined;
    freeformAddress!: string | undefined;
    boundingBox!: BoundingBox;
    countrySubdivisionName!: string | undefined;
    countrySubdivisionCode!: string | undefined;
    localName!: string | undefined;

    constructor(data?: IAddress2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["routeNumbers"])) {
                this.routeNumbers = [] as any;
                for (let item of _data["routeNumbers"])
                    this.routeNumbers!.push(item);
            }
            this.countryCode = _data["countryCode"];
            this.countrySubdivision = _data["countrySubdivision"];
            this.countrySecondarySubdivision = _data["countrySecondarySubdivision"];
            this.municipality = _data["municipality"];
            this.postalCode = _data["postalCode"];
            this.municipalitySubdivision = _data["municipalitySubdivision"];
            this.country = _data["country"];
            this.countryCodeISO3 = _data["countryCodeISO3"];
            this.freeformAddress = _data["freeformAddress"];
            this.boundingBox = _data["boundingBox"] ? BoundingBox.fromJS(_data["boundingBox"]) : undefined as any;
            this.countrySubdivisionName = _data["countrySubdivisionName"];
            this.countrySubdivisionCode = _data["countrySubdivisionCode"];
            this.localName = _data["localName"];
        }
    }

    static fromJS(data: any): Address2 {
        data = typeof data === 'object' ? data : {};
        let result = new Address2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.routeNumbers)) {
            data["routeNumbers"] = [];
            for (let item of this.routeNumbers)
                data["routeNumbers"].push(item);
        }
        data["countryCode"] = this.countryCode;
        data["countrySubdivision"] = this.countrySubdivision;
        data["countrySecondarySubdivision"] = this.countrySecondarySubdivision;
        data["municipality"] = this.municipality;
        data["postalCode"] = this.postalCode;
        data["municipalitySubdivision"] = this.municipalitySubdivision;
        data["country"] = this.country;
        data["countryCodeISO3"] = this.countryCodeISO3;
        data["freeformAddress"] = this.freeformAddress;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : undefined as any;
        data["countrySubdivisionName"] = this.countrySubdivisionName;
        data["countrySubdivisionCode"] = this.countrySubdivisionCode;
        data["localName"] = this.localName;
        return data;
    }
}

export interface IAddress2 {
    routeNumbers: any[] | undefined;
    countryCode: string | undefined;
    countrySubdivision: string | undefined;
    countrySecondarySubdivision: string | undefined;
    municipality: string | undefined;
    postalCode: string | undefined;
    municipalitySubdivision: string | undefined;
    country: string | undefined;
    countryCodeISO3: string | undefined;
    freeformAddress: string | undefined;
    boundingBox: BoundingBox;
    countrySubdivisionName: string | undefined;
    countrySubdivisionCode: string | undefined;
    localName: string | undefined;
}

export class Addresses implements IAddresses {
    address!: Address2;
    position!: string | undefined;
    id!: string | undefined;

    constructor(data?: IAddresses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? Address2.fromJS(_data["address"]) : undefined as any;
            this.position = _data["position"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Addresses {
        data = typeof data === 'object' ? data : {};
        let result = new Addresses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["position"] = this.position;
        data["id"] = this.id;
        return data;
    }
}

export interface IAddresses {
    address: Address2;
    position: string | undefined;
    id: string | undefined;
}

export enum AfterBeforeDay {
    After = 1,
    Before = 2,
}

export class AgentAppMachineDto implements IAgentAppMachineDto {
    id!: number;
    autoUpdaterId!: number | undefined;
    computerName!: string | undefined;
    macAddress!: string | undefined;
    updatedTime!: DateTime;

    constructor(data?: IAgentAppMachineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.autoUpdaterId = _data["autoUpdaterId"];
            this.computerName = _data["computerName"];
            this.macAddress = _data["macAddress"];
            this.updatedTime = _data["updatedTime"] ? DateTime.fromISO(_data["updatedTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AgentAppMachineDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAppMachineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["autoUpdaterId"] = this.autoUpdaterId;
        data["computerName"] = this.computerName;
        data["macAddress"] = this.macAddress;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toString() : undefined as any;
        return data;
    }
}

export interface IAgentAppMachineDto {
    id: number;
    autoUpdaterId: number | undefined;
    computerName: string | undefined;
    macAddress: string | undefined;
    updatedTime: DateTime;
}

export class AgentApplication implements IAgentApplication {
    tenantId!: number;
    applicationIcon!: string | undefined;
    applicationName!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAgentApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.applicationIcon = _data["applicationIcon"];
            this.applicationName = _data["applicationName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgentApplication {
        data = typeof data === 'object' ? data : {};
        let result = new AgentApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["applicationIcon"] = this.applicationIcon;
        data["applicationName"] = this.applicationName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAgentApplication {
    tenantId: number;
    applicationIcon: string | undefined;
    applicationName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AgentApplicationDto implements IAgentApplicationDto {
    agentApplicationId!: number;
    tenantId!: number;
    applicationIcon!: string | undefined;
    applicationName!: string | undefined;
    productivityTypeId!: number | undefined;
    id!: number;

    constructor(data?: IAgentApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentApplicationId = _data["agentApplicationId"];
            this.tenantId = _data["tenantId"];
            this.applicationIcon = _data["applicationIcon"];
            this.applicationName = _data["applicationName"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgentApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentApplicationId"] = this.agentApplicationId;
        data["tenantId"] = this.tenantId;
        data["applicationIcon"] = this.applicationIcon;
        data["applicationName"] = this.applicationName;
        data["productivityTypeId"] = this.productivityTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAgentApplicationDto {
    agentApplicationId: number;
    tenantId: number;
    applicationIcon: string | undefined;
    applicationName: string | undefined;
    productivityTypeId: number | undefined;
    id: number;
}

export class AgentApplicationDtoAgentApp implements IAgentApplicationDtoAgentApp {
    applicationIcon!: string | undefined;
    applicationName!: string | undefined;
    id!: number;

    constructor(data?: IAgentApplicationDtoAgentApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationIcon = _data["applicationIcon"];
            this.applicationName = _data["applicationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgentApplicationDtoAgentApp {
        data = typeof data === 'object' ? data : {};
        let result = new AgentApplicationDtoAgentApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationIcon"] = this.applicationIcon;
        data["applicationName"] = this.applicationName;
        data["id"] = this.id;
        return data;
    }
}

export interface IAgentApplicationDtoAgentApp {
    applicationIcon: string | undefined;
    applicationName: string | undefined;
    id: number;
}

export class AgentApplicationProductiveTypes implements IAgentApplicationProductiveTypes {
    applicationName!: string | undefined;
    productiveType!: number;

    constructor(data?: IAgentApplicationProductiveTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.productiveType = _data["productiveType"];
        }
    }

    static fromJS(data: any): AgentApplicationProductiveTypes {
        data = typeof data === 'object' ? data : {};
        let result = new AgentApplicationProductiveTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["productiveType"] = this.productiveType;
        return data;
    }
}

export interface IAgentApplicationProductiveTypes {
    applicationName: string | undefined;
    productiveType: number;
}

export class AgentExternalAuthenticateResultModel implements IAgentExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    tenantId!: number | undefined;
    userId!: number;
    userRole!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    userProfileImage!: string | undefined;
    fullName!: string | undefined;
    tenantName!: string | undefined;
    orgnizationName!: string | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IAgentExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userRole = _data["userRole"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.userProfileImage = _data["userProfileImage"];
            this.fullName = _data["fullName"];
            this.tenantName = _data["tenantName"];
            this.orgnizationName = _data["orgnizationName"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AgentExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userRole"] = this.userRole;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["userProfileImage"] = this.userProfileImage;
        data["fullName"] = this.fullName;
        data["tenantName"] = this.tenantName;
        data["orgnizationName"] = this.orgnizationName;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAgentExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    tenantId: number | undefined;
    userId: number;
    userRole: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    userProfileImage: string | undefined;
    fullName: string | undefined;
    tenantName: string | undefined;
    orgnizationName: string | undefined;
    errorMessage: string | undefined;
}

export class AgentVersionDto implements IAgentVersionDto {
    versionNumber!: string | undefined;

    constructor(data?: IAgentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): AgentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IAgentVersionDto {
    versionNumber: string | undefined;
}

export class AppAndWebSiteDto implements IAppAndWebSiteDto {
    appAndWebsiteUsageAppDetails!: UserActivityTempCreateOrEditDto[] | undefined;
    chartNameValueDetails!: ChartNameValueDto[] | undefined;

    constructor(data?: IAppAndWebSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["appAndWebsiteUsageAppDetails"])) {
                this.appAndWebsiteUsageAppDetails = [] as any;
                for (let item of _data["appAndWebsiteUsageAppDetails"])
                    this.appAndWebsiteUsageAppDetails!.push(UserActivityTempCreateOrEditDto.fromJS(item));
            }
            if (Array.isArray(_data["chartNameValueDetails"])) {
                this.chartNameValueDetails = [] as any;
                for (let item of _data["chartNameValueDetails"])
                    this.chartNameValueDetails!.push(ChartNameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppAndWebSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppAndWebSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appAndWebsiteUsageAppDetails)) {
            data["appAndWebsiteUsageAppDetails"] = [];
            for (let item of this.appAndWebsiteUsageAppDetails)
                data["appAndWebsiteUsageAppDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.chartNameValueDetails)) {
            data["chartNameValueDetails"] = [];
            for (let item of this.chartNameValueDetails)
                data["chartNameValueDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppAndWebSiteDto {
    appAndWebsiteUsageAppDetails: UserActivityTempCreateOrEditDto[] | undefined;
    chartNameValueDetails: ChartNameValueDto[] | undefined;
}

export class AppConfigurationDto implements IAppConfigurationDto {
    applicationName!: string;
    displayName!: string | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    productivityTypeId!: number | undefined;
    id!: number;

    constructor(data?: IAppConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.displayName = _data["displayName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["displayName"] = this.displayName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["productivityTypeId"] = this.productivityTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAppConfigurationDto {
    applicationName: string;
    displayName: string | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    productivityTypeId: number | undefined;
    id: number;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class ApplicationAndSpendTimeDto implements IApplicationAndSpendTimeDto {
    applicationName!: string | undefined;
    spendTime!: string;
    icon!: string | undefined;

    constructor(data?: IApplicationAndSpendTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.spendTime = _data["spendTime"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): ApplicationAndSpendTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAndSpendTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["spendTime"] = this.spendTime;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IApplicationAndSpendTimeDto {
    applicationName: string | undefined;
    spendTime: string;
    icon: string | undefined;
}

export class ApplicationAndTime implements IApplicationAndTime {
    applicationName!: string | undefined;
    usedTime!: string;
    productiveType!: number | undefined;

    constructor(data?: IApplicationAndTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.usedTime = _data["usedTime"];
            this.productiveType = _data["productiveType"];
        }
    }

    static fromJS(data: any): ApplicationAndTime {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAndTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["usedTime"] = this.usedTime;
        data["productiveType"] = this.productiveType;
        return data;
    }
}

export interface IApplicationAndTime {
    applicationName: string | undefined;
    usedTime: string;
    productiveType: number | undefined;
}

export class ApplicationCategoryDto implements IApplicationCategoryDto {
    tenantId!: number;
    name!: string | undefined;
    icon!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    productivityType!: string | undefined;
    applicationType!: string | undefined;
    isCategory!: boolean;
    applicationCount!: number;
    selectedCatId!: number;
    isDefaultCategory!: boolean;
    productiveApplicationCount!: number;
    unProductiveApplicationCount!: number;
    nuetralApplicationCount!: number;
    applicationList!: ApplicationCreateOrEditDto[] | undefined;
    id!: number;

    constructor(data?: IApplicationCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.productivityType = _data["productivityType"];
            this.applicationType = _data["applicationType"];
            this.isCategory = _data["isCategory"];
            this.applicationCount = _data["applicationCount"];
            this.selectedCatId = _data["selectedCatId"];
            this.isDefaultCategory = _data["isDefaultCategory"];
            this.productiveApplicationCount = _data["productiveApplicationCount"];
            this.unProductiveApplicationCount = _data["unProductiveApplicationCount"];
            this.nuetralApplicationCount = _data["nuetralApplicationCount"];
            if (Array.isArray(_data["applicationList"])) {
                this.applicationList = [] as any;
                for (let item of _data["applicationList"])
                    this.applicationList!.push(ApplicationCreateOrEditDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["code"] = this.code;
        data["description"] = this.description;
        data["productivityType"] = this.productivityType;
        data["applicationType"] = this.applicationType;
        data["isCategory"] = this.isCategory;
        data["applicationCount"] = this.applicationCount;
        data["selectedCatId"] = this.selectedCatId;
        data["isDefaultCategory"] = this.isDefaultCategory;
        data["productiveApplicationCount"] = this.productiveApplicationCount;
        data["unProductiveApplicationCount"] = this.unProductiveApplicationCount;
        data["nuetralApplicationCount"] = this.nuetralApplicationCount;
        if (Array.isArray(this.applicationList)) {
            data["applicationList"] = [];
            for (let item of this.applicationList)
                data["applicationList"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationCategoryDto {
    tenantId: number;
    name: string | undefined;
    icon: string | undefined;
    code: string | undefined;
    description: string | undefined;
    productivityType: string | undefined;
    applicationType: string | undefined;
    isCategory: boolean;
    applicationCount: number;
    selectedCatId: number;
    isDefaultCategory: boolean;
    productiveApplicationCount: number;
    unProductiveApplicationCount: number;
    nuetralApplicationCount: number;
    applicationList: ApplicationCreateOrEditDto[] | undefined;
    id: number;
}

export class ApplicationCategoryWeekAndMonthDto implements IApplicationCategoryWeekAndMonthDto {
    name!: string | undefined;
    precentage!: number;

    constructor(data?: IApplicationCategoryWeekAndMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.precentage = _data["precentage"];
        }
    }

    static fromJS(data: any): ApplicationCategoryWeekAndMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCategoryWeekAndMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["precentage"] = this.precentage;
        return data;
    }
}

export interface IApplicationCategoryWeekAndMonthDto {
    name: string | undefined;
    precentage: number;
}

export class ApplicationCategorys implements IApplicationCategorys {
    tenantId!: number;
    name!: string | undefined;
    icon!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    productivityTypeId!: number | undefined;
    productivityType!: ProductivityType;
    applicationTypeId!: number | undefined;
    applicationType!: ApplicationType;
    isCategory!: boolean;
    isDefaultCategory!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationCategorys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.productivityType = _data["productivityType"] ? ProductivityType.fromJS(_data["productivityType"]) : undefined as any;
            this.applicationTypeId = _data["applicationTypeId"];
            this.applicationType = _data["applicationType"] ? ApplicationType.fromJS(_data["applicationType"]) : undefined as any;
            this.isCategory = _data["isCategory"];
            this.isDefaultCategory = _data["isDefaultCategory"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationCategorys {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCategorys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["code"] = this.code;
        data["description"] = this.description;
        data["productivityTypeId"] = this.productivityTypeId;
        data["productivityType"] = this.productivityType ? this.productivityType.toJSON() : undefined as any;
        data["applicationTypeId"] = this.applicationTypeId;
        data["applicationType"] = this.applicationType ? this.applicationType.toJSON() : undefined as any;
        data["isCategory"] = this.isCategory;
        data["isDefaultCategory"] = this.isDefaultCategory;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationCategorys {
    tenantId: number;
    name: string | undefined;
    icon: string | undefined;
    code: string | undefined;
    description: string | undefined;
    productivityTypeId: number | undefined;
    productivityType: ProductivityType;
    applicationTypeId: number | undefined;
    applicationType: ApplicationType;
    isCategory: boolean;
    isDefaultCategory: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationCreateOrEditDto implements IApplicationCreateOrEditDto {
    tenantId!: number;
    name!: string | undefined;
    icon!: string | undefined;
    applicationCategoryId!: number;
    productivityTypeId!: number | undefined;
    applicationTypeId!: number | undefined;
    isWebSite!: boolean;
    parentWebURL!: string | undefined;
    browserId!: number;
    applicationId!: number;
    description!: string | undefined;
    id!: number;

    constructor(data?: IApplicationCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.applicationCategoryId = _data["applicationCategoryId"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.isWebSite = _data["isWebSite"];
            this.parentWebURL = _data["parentWebURL"];
            this.browserId = _data["browserId"];
            this.applicationId = _data["applicationId"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["applicationCategoryId"] = this.applicationCategoryId;
        data["productivityTypeId"] = this.productivityTypeId;
        data["applicationTypeId"] = this.applicationTypeId;
        data["isWebSite"] = this.isWebSite;
        data["parentWebURL"] = this.parentWebURL;
        data["browserId"] = this.browserId;
        data["applicationId"] = this.applicationId;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationCreateOrEditDto {
    tenantId: number;
    name: string | undefined;
    icon: string | undefined;
    applicationCategoryId: number;
    productivityTypeId: number | undefined;
    applicationTypeId: number | undefined;
    isWebSite: boolean;
    parentWebURL: string | undefined;
    browserId: number;
    applicationId: number;
    description: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : undefined as any;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = (this.features as any)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplicationLanguage implements IApplicationLanguage {
    tenantId!: number | undefined;
    name!: string;
    displayName!: string;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguage {
    tenantId: number | undefined;
    name: string;
    displayName: string;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationTrackingAndWindowsTrackingCombineDto implements IApplicationTrackingAndWindowsTrackingCombineDto {
    tenantId!: number;
    userId!: number | undefined;
    applicationName!: string | undefined;
    applicationId!: number | undefined;
    applicationTypeId!: number | undefined;
    browserName!: string | undefined;
    productivityTypeId!: number | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    icon!: string | undefined;
    isWebSite!: boolean;
    parentWebURL!: string | undefined;
    webSiteIcon!: string | undefined;
    internetProvider!: string | undefined;
    internetSpeed!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    sublocality!: string | undefined;
    deviceTypeId!: number;
    windowsTrackingData!: WindowsTrackingDataDto[] | undefined;
    activeWindowTitle!: string | undefined;
    dateTrackedFor!: string | undefined;
    creationTime!: DateTime;
    timeZoneOffset!: number;
    id!: number;

    constructor(data?: IApplicationTrackingAndWindowsTrackingCombineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.applicationName = _data["applicationName"];
            this.applicationId = _data["applicationId"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.browserName = _data["browserName"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.icon = _data["icon"];
            this.isWebSite = _data["isWebSite"];
            this.parentWebURL = _data["parentWebURL"];
            this.webSiteIcon = _data["webSiteIcon"];
            this.internetProvider = _data["internetProvider"];
            this.internetSpeed = _data["internetSpeed"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.sublocality = _data["sublocality"];
            this.deviceTypeId = _data["deviceTypeId"];
            if (Array.isArray(_data["windowsTrackingData"])) {
                this.windowsTrackingData = [] as any;
                for (let item of _data["windowsTrackingData"])
                    this.windowsTrackingData!.push(WindowsTrackingDataDto.fromJS(item));
            }
            this.activeWindowTitle = _data["activeWindowTitle"];
            this.dateTrackedFor = _data["dateTrackedFor"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationTrackingAndWindowsTrackingCombineDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationTrackingAndWindowsTrackingCombineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["applicationName"] = this.applicationName;
        data["applicationId"] = this.applicationId;
        data["applicationTypeId"] = this.applicationTypeId;
        data["browserName"] = this.browserName;
        data["productivityTypeId"] = this.productivityTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["icon"] = this.icon;
        data["isWebSite"] = this.isWebSite;
        data["parentWebURL"] = this.parentWebURL;
        data["webSiteIcon"] = this.webSiteIcon;
        data["internetProvider"] = this.internetProvider;
        data["internetSpeed"] = this.internetSpeed;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["sublocality"] = this.sublocality;
        data["deviceTypeId"] = this.deviceTypeId;
        if (Array.isArray(this.windowsTrackingData)) {
            data["windowsTrackingData"] = [];
            for (let item of this.windowsTrackingData)
                data["windowsTrackingData"].push(item ? item.toJSON() : undefined as any);
        }
        data["activeWindowTitle"] = this.activeWindowTitle;
        data["dateTrackedFor"] = this.dateTrackedFor;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationTrackingAndWindowsTrackingCombineDto {
    tenantId: number;
    userId: number | undefined;
    applicationName: string | undefined;
    applicationId: number | undefined;
    applicationTypeId: number | undefined;
    browserName: string | undefined;
    productivityTypeId: number | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    icon: string | undefined;
    isWebSite: boolean;
    parentWebURL: string | undefined;
    webSiteIcon: string | undefined;
    internetProvider: string | undefined;
    internetSpeed: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    sublocality: string | undefined;
    deviceTypeId: number;
    windowsTrackingData: WindowsTrackingDataDto[] | undefined;
    activeWindowTitle: string | undefined;
    dateTrackedFor: string | undefined;
    creationTime: DateTime;
    timeZoneOffset: number;
    id: number;
}

export class ApplicationType implements IApplicationType {
    name!: string;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationType {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationType {
    name: string;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationTypeDto implements IApplicationTypeDto {
    name!: string | undefined;
    code!: string | undefined;
    id!: number | undefined;

    constructor(data?: IApplicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationTypeDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export enum ApplicationTypeEnum {
    Productive = 1,
    UnProductive = 2,
    Neutral = 3,
}

export class Applications implements IApplications {
    tenantId!: number;
    name!: string | undefined;
    icon!: string | undefined;
    applicationCategoryId!: number;
    applicationCategory!: ApplicationCategorys;
    productivityTypeId!: number | undefined;
    productivityType!: ProductivityType;
    applicationTypeId!: number | undefined;
    applicationType!: ApplicationType;
    isWebSite!: boolean;
    parentWebURL!: string | undefined;
    browserId!: number;
    browser!: Browser;
    applicationId!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.applicationCategoryId = _data["applicationCategoryId"];
            this.applicationCategory = _data["applicationCategory"] ? ApplicationCategorys.fromJS(_data["applicationCategory"]) : undefined as any;
            this.productivityTypeId = _data["productivityTypeId"];
            this.productivityType = _data["productivityType"] ? ProductivityType.fromJS(_data["productivityType"]) : undefined as any;
            this.applicationTypeId = _data["applicationTypeId"];
            this.applicationType = _data["applicationType"] ? ApplicationType.fromJS(_data["applicationType"]) : undefined as any;
            this.isWebSite = _data["isWebSite"];
            this.parentWebURL = _data["parentWebURL"];
            this.browserId = _data["browserId"];
            this.browser = _data["browser"] ? Browser.fromJS(_data["browser"]) : undefined as any;
            this.applicationId = _data["applicationId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Applications {
        data = typeof data === 'object' ? data : {};
        let result = new Applications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["applicationCategoryId"] = this.applicationCategoryId;
        data["applicationCategory"] = this.applicationCategory ? this.applicationCategory.toJSON() : undefined as any;
        data["productivityTypeId"] = this.productivityTypeId;
        data["productivityType"] = this.productivityType ? this.productivityType.toJSON() : undefined as any;
        data["applicationTypeId"] = this.applicationTypeId;
        data["applicationType"] = this.applicationType ? this.applicationType.toJSON() : undefined as any;
        data["isWebSite"] = this.isWebSite;
        data["parentWebURL"] = this.parentWebURL;
        data["browserId"] = this.browserId;
        data["browser"] = this.browser ? this.browser.toJSON() : undefined as any;
        data["applicationId"] = this.applicationId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplications {
    tenantId: number;
    name: string | undefined;
    icon: string | undefined;
    applicationCategoryId: number;
    applicationCategory: ApplicationCategorys;
    productivityTypeId: number | undefined;
    productivityType: ProductivityType;
    applicationTypeId: number | undefined;
    applicationType: ApplicationType;
    isWebSite: boolean;
    parentWebURL: string | undefined;
    browserId: number;
    browser: Browser;
    applicationId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplocationDetails implements IApplocationDetails {
    applicationName!: string | undefined;
    icon!: string | undefined;
    productivityTypes!: ProductivityTypes;
    spendtime!: string;

    constructor(data?: IApplocationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.icon = _data["icon"];
            this.productivityTypes = _data["productivityTypes"];
            this.spendtime = _data["spendtime"];
        }
    }

    static fromJS(data: any): ApplocationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApplocationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["icon"] = this.icon;
        data["productivityTypes"] = this.productivityTypes;
        data["spendtime"] = this.spendtime;
        return data;
    }
}

export interface IApplocationDetails {
    applicationName: string | undefined;
    icon: string | undefined;
    productivityTypes: ProductivityTypes;
    spendtime: string;
}

export class ApprovalDetailsDto implements IApprovalDetailsDto {
    approvalSequence!: number;
    approvalName!: string | undefined;
    approvalImage!: string | undefined;
    approvalRole!: string[] | undefined;
    approvalLevelId!: number;

    constructor(data?: IApprovalDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalSequence = _data["approvalSequence"];
            this.approvalName = _data["approvalName"];
            this.approvalImage = _data["approvalImage"];
            if (Array.isArray(_data["approvalRole"])) {
                this.approvalRole = [] as any;
                for (let item of _data["approvalRole"])
                    this.approvalRole!.push(item);
            }
            this.approvalLevelId = _data["approvalLevelId"];
        }
    }

    static fromJS(data: any): ApprovalDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalSequence"] = this.approvalSequence;
        data["approvalName"] = this.approvalName;
        data["approvalImage"] = this.approvalImage;
        if (Array.isArray(this.approvalRole)) {
            data["approvalRole"] = [];
            for (let item of this.approvalRole)
                data["approvalRole"].push(item);
        }
        data["approvalLevelId"] = this.approvalLevelId;
        return data;
    }
}

export interface IApprovalDetailsDto {
    approvalSequence: number;
    approvalName: string | undefined;
    approvalImage: string | undefined;
    approvalRole: string[] | undefined;
    approvalLevelId: number;
}

export class ApprovalGridDataDto implements IApprovalGridDataDto {
    id!: number;
    totalTask!: number;
    submitedDate!: DateTime | undefined;
    timeSheetDate!: DateTime | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    requiredHours!: string;
    submitedHours!: string;
    billedHours!: string;
    userId!: number | undefined;
    userName!: string | undefined;
    userEmailAddress!: string | undefined;
    userProfileImage!: string | undefined;
    userRole!: string[] | undefined;
    user!: UserListDto;
    projectImage!: string | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    projectType!: ProjectBillingType;
    projectCurrentStatus!: ProjectStatus;
    fromDate!: DateTime;
    toDate!: DateTime;
    projectCreationDate!: DateTime | undefined;
    projectEndDate!: DateTime | undefined;
    leave!: number;
    isAdmin!: boolean;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    unReadCount!: number;
    isNextLevelClient!: boolean;
    employeeId!: string | undefined;
    userStatusId!: UserStatusEnum;
    dateWiseTimesheetIds!: TimesheetIdsDateWiseDto[] | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag!: boolean;
    timesheetApprovalDtos!: TimesheetLevelApprovalDto[] | undefined;

    constructor(data?: IApprovalGridDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalTask = _data["totalTask"];
            this.submitedDate = _data["submitedDate"] ? DateTime.fromISO(_data["submitedDate"].toString()) : undefined as any;
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.requiredHours = _data["requiredHours"];
            this.submitedHours = _data["submitedHours"];
            this.billedHours = _data["billedHours"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userProfileImage = _data["userProfileImage"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.user = _data["user"] ? UserListDto.fromJS(_data["user"]) : undefined as any;
            this.projectImage = _data["projectImage"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.projectType = _data["projectType"];
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.leave = _data["leave"];
            this.isAdmin = _data["isAdmin"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            this.unReadCount = _data["unReadCount"];
            this.isNextLevelClient = _data["isNextLevelClient"];
            this.employeeId = _data["employeeId"];
            this.userStatusId = _data["userStatusId"];
            if (Array.isArray(_data["dateWiseTimesheetIds"])) {
                this.dateWiseTimesheetIds = [] as any;
                for (let item of _data["dateWiseTimesheetIds"])
                    this.dateWiseTimesheetIds!.push(TimesheetIdsDateWiseDto.fromJS(item));
            }
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.isRejectedForMyTimesheetLevelFlag = _data["isRejectedForMyTimesheetLevelFlag"];
            if (Array.isArray(_data["timesheetApprovalDtos"])) {
                this.timesheetApprovalDtos = [] as any;
                for (let item of _data["timesheetApprovalDtos"])
                    this.timesheetApprovalDtos!.push(TimesheetLevelApprovalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalGridDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalGridDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalTask"] = this.totalTask;
        data["submitedDate"] = this.submitedDate ? this.submitedDate.toString() : undefined as any;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["requiredHours"] = this.requiredHours;
        data["submitedHours"] = this.submitedHours;
        data["billedHours"] = this.billedHours;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userProfileImage"] = this.userProfileImage;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["projectImage"] = this.projectImage;
        data["timesheetStatus"] = this.timesheetStatus;
        data["projectType"] = this.projectType;
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["leave"] = this.leave;
        data["isAdmin"] = this.isAdmin;
        data["timesheetFrequency"] = this.timesheetFrequency;
        data["unReadCount"] = this.unReadCount;
        data["isNextLevelClient"] = this.isNextLevelClient;
        data["employeeId"] = this.employeeId;
        data["userStatusId"] = this.userStatusId;
        if (Array.isArray(this.dateWiseTimesheetIds)) {
            data["dateWiseTimesheetIds"] = [];
            for (let item of this.dateWiseTimesheetIds)
                data["dateWiseTimesheetIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["isRejectedForMyTimesheetLevelFlag"] = this.isRejectedForMyTimesheetLevelFlag;
        if (Array.isArray(this.timesheetApprovalDtos)) {
            data["timesheetApprovalDtos"] = [];
            for (let item of this.timesheetApprovalDtos)
                data["timesheetApprovalDtos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApprovalGridDataDto {
    id: number;
    totalTask: number;
    submitedDate: DateTime | undefined;
    timeSheetDate: DateTime | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    requiredHours: string;
    submitedHours: string;
    billedHours: string;
    userId: number | undefined;
    userName: string | undefined;
    userEmailAddress: string | undefined;
    userProfileImage: string | undefined;
    userRole: string[] | undefined;
    user: UserListDto;
    projectImage: string | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    projectType: ProjectBillingType;
    projectCurrentStatus: ProjectStatus;
    fromDate: DateTime;
    toDate: DateTime;
    projectCreationDate: DateTime | undefined;
    projectEndDate: DateTime | undefined;
    leave: number;
    isAdmin: boolean;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    unReadCount: number;
    isNextLevelClient: boolean;
    employeeId: string | undefined;
    userStatusId: UserStatusEnum;
    dateWiseTimesheetIds: TimesheetIdsDateWiseDto[] | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag: boolean;
    timesheetApprovalDtos: TimesheetLevelApprovalDto[] | undefined;
}

export class ApprovalHeaderFiledDto implements IApprovalHeaderFiledDto {
    pendingTimesheetCount!: number;
    approvedTimesheetCount!: number;

    constructor(data?: IApprovalHeaderFiledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingTimesheetCount = _data["pendingTimesheetCount"];
            this.approvedTimesheetCount = _data["approvedTimesheetCount"];
        }
    }

    static fromJS(data: any): ApprovalHeaderFiledDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalHeaderFiledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingTimesheetCount"] = this.pendingTimesheetCount;
        data["approvedTimesheetCount"] = this.approvedTimesheetCount;
        return data;
    }
}

export interface IApprovalHeaderFiledDto {
    pendingTimesheetCount: number;
    approvedTimesheetCount: number;
}

export enum ApprovalWindowInEnum {
    Hours = 1,
    Days = 2,
}

export class ApproveKekaManagerApprovalInput implements IApproveKekaManagerApprovalInput {
    userIds!: number[] | undefined;
    id!: number;

    constructor(data?: IApproveKekaManagerApprovalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApproveKekaManagerApprovalInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveKekaManagerApprovalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IApproveKekaManagerApprovalInput {
    userIds: number[] | undefined;
    id: number;
}

export class ApproveRejectDto implements IApproveRejectDto {
    tenantId!: number;
    userId!: number;
    timesheetId!: number;
    timesheetInvoiceFromDate!: DateTime;
    timesheetInvoiceToDate!: DateTime;
    billingType!: ProjectBillingType;
    timesheetType!: ProjectTimesheetFrequencyEnum;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;

    constructor(data?: IApproveRejectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.timesheetId = _data["timesheetId"];
            this.timesheetInvoiceFromDate = _data["timesheetInvoiceFromDate"] ? DateTime.fromISO(_data["timesheetInvoiceFromDate"].toString()) : undefined as any;
            this.timesheetInvoiceToDate = _data["timesheetInvoiceToDate"] ? DateTime.fromISO(_data["timesheetInvoiceToDate"].toString()) : undefined as any;
            this.billingType = _data["billingType"];
            this.timesheetType = _data["timesheetType"];
            this.timesheetStatus = _data["timesheetStatus"];
        }
    }

    static fromJS(data: any): ApproveRejectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveRejectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["timesheetId"] = this.timesheetId;
        data["timesheetInvoiceFromDate"] = this.timesheetInvoiceFromDate ? this.timesheetInvoiceFromDate.toString() : undefined as any;
        data["timesheetInvoiceToDate"] = this.timesheetInvoiceToDate ? this.timesheetInvoiceToDate.toString() : undefined as any;
        data["billingType"] = this.billingType;
        data["timesheetType"] = this.timesheetType;
        data["timesheetStatus"] = this.timesheetStatus;
        return data;
    }
}

export interface IApproveRejectDto {
    tenantId: number;
    userId: number;
    timesheetId: number;
    timesheetInvoiceFromDate: DateTime;
    timesheetInvoiceToDate: DateTime;
    billingType: ProjectBillingType;
    timesheetType: ProjectTimesheetFrequencyEnum;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
}

export class ApproveRejectTimesheetDto implements IApproveRejectTimesheetDto {
    userId!: number;
    tenantId!: number;
    timesheetId!: number;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    taskList!: TaskListDto[] | undefined;
    timeSheetDate!: DateTime;
    timesheetInvoiceFromDate!: DateTime;
    timesheetInvoiceToDate!: DateTime;
    timesheetType!: ProjectTimesheetFrequencyEnum;

    constructor(data?: IApproveRejectTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.timesheetId = _data["timesheetId"];
            this.timesheetStatus = _data["timesheetStatus"];
            if (Array.isArray(_data["taskList"])) {
                this.taskList = [] as any;
                for (let item of _data["taskList"])
                    this.taskList!.push(TaskListDto.fromJS(item));
            }
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.timesheetInvoiceFromDate = _data["timesheetInvoiceFromDate"] ? DateTime.fromISO(_data["timesheetInvoiceFromDate"].toString()) : undefined as any;
            this.timesheetInvoiceToDate = _data["timesheetInvoiceToDate"] ? DateTime.fromISO(_data["timesheetInvoiceToDate"].toString()) : undefined as any;
            this.timesheetType = _data["timesheetType"];
        }
    }

    static fromJS(data: any): ApproveRejectTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveRejectTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["timesheetId"] = this.timesheetId;
        data["timesheetStatus"] = this.timesheetStatus;
        if (Array.isArray(this.taskList)) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item ? item.toJSON() : undefined as any);
        }
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["timesheetInvoiceFromDate"] = this.timesheetInvoiceFromDate ? this.timesheetInvoiceFromDate.toString() : undefined as any;
        data["timesheetInvoiceToDate"] = this.timesheetInvoiceToDate ? this.timesheetInvoiceToDate.toString() : undefined as any;
        data["timesheetType"] = this.timesheetType;
        return data;
    }
}

export interface IApproveRejectTimesheetDto {
    userId: number;
    tenantId: number;
    timesheetId: number;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    taskList: TaskListDto[] | undefined;
    timeSheetDate: DateTime;
    timesheetInvoiceFromDate: DateTime;
    timesheetInvoiceToDate: DateTime;
    timesheetType: ProjectTimesheetFrequencyEnum;
}

export class ApproveRejectTimesheetDtoForMobile implements IApproveRejectTimesheetDtoForMobile {
    userId!: number;
    tenantId!: number;
    timesheetId!: number;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    taskList!: TaskListDto[] | undefined;
    comments!: string | undefined;
    timeSheetDate!: DateTime;

    constructor(data?: IApproveRejectTimesheetDtoForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.timesheetId = _data["timesheetId"];
            this.timesheetStatus = _data["timesheetStatus"];
            if (Array.isArray(_data["taskList"])) {
                this.taskList = [] as any;
                for (let item of _data["taskList"])
                    this.taskList!.push(TaskListDto.fromJS(item));
            }
            this.comments = _data["comments"];
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ApproveRejectTimesheetDtoForMobile {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveRejectTimesheetDtoForMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["timesheetId"] = this.timesheetId;
        data["timesheetStatus"] = this.timesheetStatus;
        if (Array.isArray(this.taskList)) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item ? item.toJSON() : undefined as any);
        }
        data["comments"] = this.comments;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        return data;
    }
}

export interface IApproveRejectTimesheetDtoForMobile {
    userId: number;
    tenantId: number;
    timesheetId: number;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    taskList: TaskListDto[] | undefined;
    comments: string | undefined;
    timeSheetDate: DateTime;
}

export class AssignApplicationToUserDto implements IAssignApplicationToUserDto {
    tenantId!: number;
    appWebApplication!: AddAgentAppDto[] | undefined;
    categoryId!: number | undefined;
    orgUnitId!: (number | undefined)[] | undefined;
    projectId!: (number | undefined)[] | undefined;
    userId!: (number | undefined)[] | undefined;
    productivityTypeId!: number | undefined;
    currentUserId!: number;
    isCheck!: boolean;
    id!: number | undefined;

    constructor(data?: IAssignApplicationToUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["appWebApplication"])) {
                this.appWebApplication = [] as any;
                for (let item of _data["appWebApplication"])
                    this.appWebApplication!.push(AddAgentAppDto.fromJS(item));
            }
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["orgUnitId"])) {
                this.orgUnitId = [] as any;
                for (let item of _data["orgUnitId"])
                    this.orgUnitId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            this.productivityTypeId = _data["productivityTypeId"];
            this.currentUserId = _data["currentUserId"];
            this.isCheck = _data["isCheck"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignApplicationToUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignApplicationToUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.appWebApplication)) {
            data["appWebApplication"] = [];
            for (let item of this.appWebApplication)
                data["appWebApplication"].push(item ? item.toJSON() : undefined as any);
        }
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.orgUnitId)) {
            data["orgUnitId"] = [];
            for (let item of this.orgUnitId)
                data["orgUnitId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        data["productivityTypeId"] = this.productivityTypeId;
        data["currentUserId"] = this.currentUserId;
        data["isCheck"] = this.isCheck;
        data["id"] = this.id;
        return data;
    }
}

export interface IAssignApplicationToUserDto {
    tenantId: number;
    appWebApplication: AddAgentAppDto[] | undefined;
    categoryId: number | undefined;
    orgUnitId: (number | undefined)[] | undefined;
    projectId: (number | undefined)[] | undefined;
    userId: (number | undefined)[] | undefined;
    productivityTypeId: number | undefined;
    currentUserId: number;
    isCheck: boolean;
    id: number | undefined;
}

export class AttendanceReportDetails implements IAttendanceReportDetails {
    reportDate!: DateTime;
    clock_In_ArrivalTime!: string | undefined;
    clock_In_Early_Late!: string | undefined;
    clock_Out_Left_Time!: string | undefined;
    clock_Out_Early_Late!: string | undefined;
    totalTimeAtWork!: string | undefined;
    requiredHourse!: string | undefined;
    overTime_UnderTime!: string | undefined;
    total_Active_Time!: string | undefined;
    productivity!: number;
    effectiveness!: number;
    status!: string | undefined;
    productiveTime!: string | undefined;
    unProductiveTime!: string | undefined;
    nuetralTime!: string | undefined;

    constructor(data?: IAttendanceReportDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : undefined as any;
            this.clock_In_ArrivalTime = _data["clock_In_ArrivalTime"];
            this.clock_In_Early_Late = _data["clock_In_Early_Late"];
            this.clock_Out_Left_Time = _data["clock_Out_Left_Time"];
            this.clock_Out_Early_Late = _data["clock_Out_Early_Late"];
            this.totalTimeAtWork = _data["totalTimeAtWork"];
            this.requiredHourse = _data["requiredHourse"];
            this.overTime_UnderTime = _data["overTime_UnderTime"];
            this.total_Active_Time = _data["total_Active_Time"];
            this.productivity = _data["productivity"];
            this.effectiveness = _data["effectiveness"];
            this.status = _data["status"];
            this.productiveTime = _data["productiveTime"];
            this.unProductiveTime = _data["unProductiveTime"];
            this.nuetralTime = _data["nuetralTime"];
        }
    }

    static fromJS(data: any): AttendanceReportDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : undefined as any;
        data["clock_In_ArrivalTime"] = this.clock_In_ArrivalTime;
        data["clock_In_Early_Late"] = this.clock_In_Early_Late;
        data["clock_Out_Left_Time"] = this.clock_Out_Left_Time;
        data["clock_Out_Early_Late"] = this.clock_Out_Early_Late;
        data["totalTimeAtWork"] = this.totalTimeAtWork;
        data["requiredHourse"] = this.requiredHourse;
        data["overTime_UnderTime"] = this.overTime_UnderTime;
        data["total_Active_Time"] = this.total_Active_Time;
        data["productivity"] = this.productivity;
        data["effectiveness"] = this.effectiveness;
        data["status"] = this.status;
        data["productiveTime"] = this.productiveTime;
        data["unProductiveTime"] = this.unProductiveTime;
        data["nuetralTime"] = this.nuetralTime;
        return data;
    }
}

export interface IAttendanceReportDetails {
    reportDate: DateTime;
    clock_In_ArrivalTime: string | undefined;
    clock_In_Early_Late: string | undefined;
    clock_Out_Left_Time: string | undefined;
    clock_Out_Early_Late: string | undefined;
    totalTimeAtWork: string | undefined;
    requiredHourse: string | undefined;
    overTime_UnderTime: string | undefined;
    total_Active_Time: string | undefined;
    productivity: number;
    effectiveness: number;
    status: string | undefined;
    productiveTime: string | undefined;
    unProductiveTime: string | undefined;
    nuetralTime: string | undefined;
}

export class AttendanceReportDistributionGroupDto implements IAttendanceReportDistributionGroupDto {
    code!: string | undefined;
    name!: string | undefined;
    isEnabled!: boolean;
    employees!: AttendanceReportDistributionMemberDto[] | undefined;
    recipients!: AttendanceReportDistributionMemberDto[] | undefined;
    id!: number;

    constructor(data?: IAttendanceReportDistributionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(AttendanceReportDistributionMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(AttendanceReportDistributionMemberDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceReportDistributionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportDistributionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IAttendanceReportDistributionGroupDto {
    code: string | undefined;
    name: string | undefined;
    isEnabled: boolean;
    employees: AttendanceReportDistributionMemberDto[] | undefined;
    recipients: AttendanceReportDistributionMemberDto[] | undefined;
    id: number;
}

export class AttendanceReportDistributionMemberDto implements IAttendanceReportDistributionMemberDto {
    userId!: number | undefined;
    displayName!: string | undefined;
    email!: string | undefined;
    isUserResolved!: boolean;
    id!: number;

    constructor(data?: IAttendanceReportDistributionMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.isUserResolved = _data["isUserResolved"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceReportDistributionMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportDistributionMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["isUserResolved"] = this.isUserResolved;
        data["id"] = this.id;
        return data;
    }
}

export interface IAttendanceReportDistributionMemberDto {
    userId: number | undefined;
    displayName: string | undefined;
    email: string | undefined;
    isUserResolved: boolean;
    id: number;
}

export class AttendanceReportDto implements IAttendanceReportDto {
    reportDate!: string | undefined;
    reportType!: string | undefined;
    workingHours!: string | undefined;
    dayType!: string | undefined;
    present!: number;
    absent!: number;
    holiday!: number;
    weekEnd!: number;
    attendanceReportDetails!: AttendanceReportList[] | undefined;

    constructor(data?: IAttendanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDate = _data["reportDate"];
            this.reportType = _data["reportType"];
            this.workingHours = _data["workingHours"];
            this.dayType = _data["dayType"];
            this.present = _data["present"];
            this.absent = _data["absent"];
            this.holiday = _data["holiday"];
            this.weekEnd = _data["weekEnd"];
            if (Array.isArray(_data["attendanceReportDetails"])) {
                this.attendanceReportDetails = [] as any;
                for (let item of _data["attendanceReportDetails"])
                    this.attendanceReportDetails!.push(AttendanceReportList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttendanceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportDate"] = this.reportDate;
        data["reportType"] = this.reportType;
        data["workingHours"] = this.workingHours;
        data["dayType"] = this.dayType;
        data["present"] = this.present;
        data["absent"] = this.absent;
        data["holiday"] = this.holiday;
        data["weekEnd"] = this.weekEnd;
        if (Array.isArray(this.attendanceReportDetails)) {
            data["attendanceReportDetails"] = [];
            for (let item of this.attendanceReportDetails)
                data["attendanceReportDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttendanceReportDto {
    reportDate: string | undefined;
    reportType: string | undefined;
    workingHours: string | undefined;
    dayType: string | undefined;
    present: number;
    absent: number;
    holiday: number;
    weekEnd: number;
    attendanceReportDetails: AttendanceReportList[] | undefined;
}

export class AttendanceReportEmployeeWiseDto implements IAttendanceReportEmployeeWiseDto {
    employeeName!: string | undefined;
    employeeEmailId!: string | undefined;
    employeeId!: string | undefined;
    duration!: string | undefined;
    reportType!: string | undefined;
    typeOfExport!: string | undefined;
    workingHourse!: string | undefined;
    present!: number;
    absent!: number;
    holiday!: number;
    weekend!: number;
    attendanceDetails!: AttendanceReportDetails[] | undefined;

    constructor(data?: IAttendanceReportEmployeeWiseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.employeeEmailId = _data["employeeEmailId"];
            this.employeeId = _data["employeeId"];
            this.duration = _data["duration"];
            this.reportType = _data["reportType"];
            this.typeOfExport = _data["typeOfExport"];
            this.workingHourse = _data["workingHourse"];
            this.present = _data["present"];
            this.absent = _data["absent"];
            this.holiday = _data["holiday"];
            this.weekend = _data["weekend"];
            if (Array.isArray(_data["attendanceDetails"])) {
                this.attendanceDetails = [] as any;
                for (let item of _data["attendanceDetails"])
                    this.attendanceDetails!.push(AttendanceReportDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttendanceReportEmployeeWiseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportEmployeeWiseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["employeeEmailId"] = this.employeeEmailId;
        data["employeeId"] = this.employeeId;
        data["duration"] = this.duration;
        data["reportType"] = this.reportType;
        data["typeOfExport"] = this.typeOfExport;
        data["workingHourse"] = this.workingHourse;
        data["present"] = this.present;
        data["absent"] = this.absent;
        data["holiday"] = this.holiday;
        data["weekend"] = this.weekend;
        if (Array.isArray(this.attendanceDetails)) {
            data["attendanceDetails"] = [];
            for (let item of this.attendanceDetails)
                data["attendanceDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttendanceReportEmployeeWiseDto {
    employeeName: string | undefined;
    employeeEmailId: string | undefined;
    employeeId: string | undefined;
    duration: string | undefined;
    reportType: string | undefined;
    typeOfExport: string | undefined;
    workingHourse: string | undefined;
    present: number;
    absent: number;
    holiday: number;
    weekend: number;
    attendanceDetails: AttendanceReportDetails[] | undefined;
}

export class AttendanceReportList implements IAttendanceReportList {
    employeeEmailAddress!: string | undefined;
    employeeName!: string | undefined;
    employeeId!: string | undefined;
    arrivalTime!: string | undefined;
    arrival_Early_Late!: string | undefined;
    leftTime!: string | undefined;
    left_Early_Late!: string | undefined;
    totalTimeAtWork!: string | undefined;
    requiredHourse!: string | undefined;
    overTime_UnderTime!: string | undefined;
    totalActiveTime!: string | undefined;
    productivity!: number;
    effectiveness!: number;
    status!: string | undefined;
    productiveTime!: string | undefined;
    unProductiveTime!: string | undefined;
    nuetralTime!: string | undefined;

    constructor(data?: IAttendanceReportList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeEmailAddress = _data["employeeEmailAddress"];
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.arrivalTime = _data["arrivalTime"];
            this.arrival_Early_Late = _data["arrival_Early_Late"];
            this.leftTime = _data["leftTime"];
            this.left_Early_Late = _data["left_Early_Late"];
            this.totalTimeAtWork = _data["totalTimeAtWork"];
            this.requiredHourse = _data["requiredHourse"];
            this.overTime_UnderTime = _data["overTime_UnderTime"];
            this.totalActiveTime = _data["totalActiveTime"];
            this.productivity = _data["productivity"];
            this.effectiveness = _data["effectiveness"];
            this.status = _data["status"];
            this.productiveTime = _data["productiveTime"];
            this.unProductiveTime = _data["unProductiveTime"];
            this.nuetralTime = _data["nuetralTime"];
        }
    }

    static fromJS(data: any): AttendanceReportList {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeEmailAddress"] = this.employeeEmailAddress;
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["arrivalTime"] = this.arrivalTime;
        data["arrival_Early_Late"] = this.arrival_Early_Late;
        data["leftTime"] = this.leftTime;
        data["left_Early_Late"] = this.left_Early_Late;
        data["totalTimeAtWork"] = this.totalTimeAtWork;
        data["requiredHourse"] = this.requiredHourse;
        data["overTime_UnderTime"] = this.overTime_UnderTime;
        data["totalActiveTime"] = this.totalActiveTime;
        data["productivity"] = this.productivity;
        data["effectiveness"] = this.effectiveness;
        data["status"] = this.status;
        data["productiveTime"] = this.productiveTime;
        data["unProductiveTime"] = this.unProductiveTime;
        data["nuetralTime"] = this.nuetralTime;
        return data;
    }
}

export interface IAttendanceReportList {
    employeeEmailAddress: string | undefined;
    employeeName: string | undefined;
    employeeId: string | undefined;
    arrivalTime: string | undefined;
    arrival_Early_Late: string | undefined;
    leftTime: string | undefined;
    left_Early_Late: string | undefined;
    totalTimeAtWork: string | undefined;
    requiredHourse: string | undefined;
    overTime_UnderTime: string | undefined;
    totalActiveTime: string | undefined;
    productivity: number;
    effectiveness: number;
    status: string | undefined;
    productiveTime: string | undefined;
    unProductiveTime: string | undefined;
    nuetralTime: string | undefined;
}

export class AttendanceReportOverAllSummaryDto implements IAttendanceReportOverAllSummaryDto {
    attendanceDuration!: string | undefined;
    exportType!: string | undefined;
    attendanceReportOverAllSummaryList!: AttendanceReportOverAllSummaryListDto[] | undefined;
    months!: string[] | undefined;

    constructor(data?: IAttendanceReportOverAllSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDuration = _data["attendanceDuration"];
            this.exportType = _data["exportType"];
            if (Array.isArray(_data["attendanceReportOverAllSummaryList"])) {
                this.attendanceReportOverAllSummaryList = [] as any;
                for (let item of _data["attendanceReportOverAllSummaryList"])
                    this.attendanceReportOverAllSummaryList!.push(AttendanceReportOverAllSummaryListDto.fromJS(item));
            }
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
        }
    }

    static fromJS(data: any): AttendanceReportOverAllSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportOverAllSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDuration"] = this.attendanceDuration;
        data["exportType"] = this.exportType;
        if (Array.isArray(this.attendanceReportOverAllSummaryList)) {
            data["attendanceReportOverAllSummaryList"] = [];
            for (let item of this.attendanceReportOverAllSummaryList)
                data["attendanceReportOverAllSummaryList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        return data;
    }
}

export interface IAttendanceReportOverAllSummaryDto {
    attendanceDuration: string | undefined;
    exportType: string | undefined;
    attendanceReportOverAllSummaryList: AttendanceReportOverAllSummaryListDto[] | undefined;
    months: string[] | undefined;
}

export class AttendanceReportOverAllSummaryListDto implements IAttendanceReportOverAllSummaryListDto {
    emailAddress!: string | undefined;
    employeeName!: string | undefined;
    employeeId!: string | undefined;
    workedDays_BusinessTrip_Conference!: number;
    weekEndCount!: number;
    paidLeaveCount!: number;
    unPaidLeaveCount!: number;
    holidayCount!: number;
    unknownLeaveCount!: number;
    presentCount!: number;
    dayList!: DayWiseList[] | undefined;

    constructor(data?: IAttendanceReportOverAllSummaryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.workedDays_BusinessTrip_Conference = _data["workedDays_BusinessTrip_Conference"];
            this.weekEndCount = _data["weekEndCount"];
            this.paidLeaveCount = _data["paidLeaveCount"];
            this.unPaidLeaveCount = _data["unPaidLeaveCount"];
            this.holidayCount = _data["holidayCount"];
            this.unknownLeaveCount = _data["unknownLeaveCount"];
            this.presentCount = _data["presentCount"];
            if (Array.isArray(_data["dayList"])) {
                this.dayList = [] as any;
                for (let item of _data["dayList"])
                    this.dayList!.push(DayWiseList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttendanceReportOverAllSummaryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportOverAllSummaryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["workedDays_BusinessTrip_Conference"] = this.workedDays_BusinessTrip_Conference;
        data["weekEndCount"] = this.weekEndCount;
        data["paidLeaveCount"] = this.paidLeaveCount;
        data["unPaidLeaveCount"] = this.unPaidLeaveCount;
        data["holidayCount"] = this.holidayCount;
        data["unknownLeaveCount"] = this.unknownLeaveCount;
        data["presentCount"] = this.presentCount;
        if (Array.isArray(this.dayList)) {
            data["dayList"] = [];
            for (let item of this.dayList)
                data["dayList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAttendanceReportOverAllSummaryListDto {
    emailAddress: string | undefined;
    employeeName: string | undefined;
    employeeId: string | undefined;
    workedDays_BusinessTrip_Conference: number;
    weekEndCount: number;
    paidLeaveCount: number;
    unPaidLeaveCount: number;
    holidayCount: number;
    unknownLeaveCount: number;
    presentCount: number;
    dayList: DayWiseList[] | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : undefined as any;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : undefined as any;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
    tenantId: number | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    isError!: boolean;
    errorMessage!: string | undefined;
    tenantId!: number | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    fullName!: string | undefined;
    userProfileImage!: string | undefined;
    tenantName!: string | undefined;
    userRole!: string | undefined;
    userTimeZone!: string | undefined;
    orgnizationName!: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.userProfileImage = _data["userProfileImage"];
            this.tenantName = _data["tenantName"];
            this.userRole = _data["userRole"];
            this.userTimeZone = _data["userTimeZone"];
            this.orgnizationName = _data["orgnizationName"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["userProfileImage"] = this.userProfileImage;
        data["tenantName"] = this.tenantName;
        data["userRole"] = this.userRole;
        data["userTimeZone"] = this.userTimeZone;
        data["orgnizationName"] = this.orgnizationName;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    isError: boolean;
    errorMessage: string | undefined;
    tenantId: number | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    fullName: string | undefined;
    userProfileImage: string | undefined;
    tenantName: string | undefined;
    userRole: string | undefined;
    userTimeZone: string | undefined;
    orgnizationName: string | undefined;
}

export class AutoUpdaterDTO implements IAutoUpdaterDTO {
    id!: number;
    versionNumber!: string | undefined;
    creationTime!: DateTime;
    exeFileName!: string | undefined;
    localPath!: string | undefined;

    constructor(data?: IAutoUpdaterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.exeFileName = _data["exeFileName"];
            this.localPath = _data["localPath"];
        }
    }

    static fromJS(data: any): AutoUpdaterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutoUpdaterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["exeFileName"] = this.exeFileName;
        data["localPath"] = this.localPath;
        return data;
    }
}

export interface IAutoUpdaterDTO {
    id: number;
    versionNumber: string | undefined;
    creationTime: DateTime;
    exeFileName: string | undefined;
    localPath: string | undefined;
}

export enum AvailabilityStatus {
    Proposed = 0,
    Available = 1,
    NotAvailable = 2,
}

export enum AwayTimeType {
    Conference = 1,
    ParentalLeave = 2,
    BusinessTrip = 3,
    Vacation = 4,
    UnpaidLeave = 5,
    Sick = 6,
    CasualLeave = 7,
    OutOfOffice = 8,
    PublicHoliday = 9,
    HalfDay = 10,
    Unknown = 11,
}

export class AzureNotificationUser implements IAzureNotificationUser {
    tenantId!: number;
    userId!: number;
    deviceInstallId!: string | undefined;
    platform!: Platform;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAzureNotificationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.deviceInstallId = _data["deviceInstallId"];
            this.platform = _data["platform"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AzureNotificationUser {
        data = typeof data === 'object' ? data : {};
        let result = new AzureNotificationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["deviceInstallId"] = this.deviceInstallId;
        data["platform"] = this.platform;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAzureNotificationUser {
    tenantId: number;
    userId: number;
    deviceInstallId: string | undefined;
    platform: Platform;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AzureNotificationUserInputDto implements IAzureNotificationUserInputDto {
    tenantId!: number;
    userId!: number;
    deviceInstallId!: string | undefined;
    platform!: Platform;
    id!: number;

    constructor(data?: IAzureNotificationUserInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.deviceInstallId = _data["deviceInstallId"];
            this.platform = _data["platform"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AzureNotificationUserInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureNotificationUserInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["deviceInstallId"] = this.deviceInstallId;
        data["platform"] = this.platform;
        data["id"] = this.id;
        return data;
    }
}

export interface IAzureNotificationUserInputDto {
    tenantId: number;
    userId: number;
    deviceInstallId: string | undefined;
    platform: Platform;
    id: number;
}

export class BeginIntegrationOAuthInput implements IBeginIntegrationOAuthInput {
    provider!: IntegrationProvider;
    licenseAllocation!: IntegrationLicenseAllocation;
    kekaApprovalId!: number[] | undefined;
    clientId!: number | undefined;
    comment!: string | undefined;

    constructor(data?: IBeginIntegrationOAuthInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.licenseAllocation = _data["licenseAllocation"];
            if (Array.isArray(_data["kekaApprovalId"])) {
                this.kekaApprovalId = [] as any;
                for (let item of _data["kekaApprovalId"])
                    this.kekaApprovalId!.push(item);
            }
            this.clientId = _data["clientId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): BeginIntegrationOAuthInput {
        data = typeof data === 'object' ? data : {};
        let result = new BeginIntegrationOAuthInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["licenseAllocation"] = this.licenseAllocation;
        if (Array.isArray(this.kekaApprovalId)) {
            data["kekaApprovalId"] = [];
            for (let item of this.kekaApprovalId)
                data["kekaApprovalId"].push(item);
        }
        data["clientId"] = this.clientId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IBeginIntegrationOAuthInput {
    provider: IntegrationProvider;
    licenseAllocation: IntegrationLicenseAllocation;
    kekaApprovalId: number[] | undefined;
    clientId: number | undefined;
    comment: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class Body implements IBody {
    contentType!: string | undefined;
    content!: string | undefined;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["content"] = this.content;
        return data;
    }
}

export interface IBody {
    contentType: string | undefined;
    content: string | undefined;
}

export class BoundingBox implements IBoundingBox {
    northEast!: string | undefined;
    southWest!: string | undefined;
    entity!: string | undefined;

    constructor(data?: IBoundingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.northEast = _data["northEast"];
            this.southWest = _data["southWest"];
            this.entity = _data["entity"];
        }
    }

    static fromJS(data: any): BoundingBox {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["northEast"] = this.northEast;
        data["southWest"] = this.southWest;
        data["entity"] = this.entity;
        return data;
    }
}

export interface IBoundingBox {
    northEast: string | undefined;
    southWest: string | undefined;
    entity: string | undefined;
}

export class Browser implements IBrowser {
    name!: string | undefined;
    code!: string | undefined;
    icon!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IBrowser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.icon = _data["icon"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Browser {
        data = typeof data === 'object' ? data : {};
        let result = new Browser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["icon"] = this.icon;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBrowser {
    name: string | undefined;
    code: string | undefined;
    icon: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BrowserDto implements IBrowserDto {
    name!: string | undefined;
    code!: string | undefined;
    icon!: string | undefined;
    id!: number | undefined;

    constructor(data?: IBrowserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.icon = _data["icon"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BrowserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrowserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["icon"] = this.icon;
        data["id"] = this.id;
        return data;
    }
}

export interface IBrowserDto {
    name: string | undefined;
    code: string | undefined;
    icon: string | undefined;
    id: number | undefined;
}

export class BulkKekaManagerApprovalFailureDto implements IBulkKekaManagerApprovalFailureDto {
    id!: number;
    reason!: string | undefined;

    constructor(data?: IBulkKekaManagerApprovalFailureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): BulkKekaManagerApprovalFailureDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkKekaManagerApprovalFailureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IBulkKekaManagerApprovalFailureDto {
    id: number;
    reason: string | undefined;
}

export class BulkKekaManagerApprovalInput implements IBulkKekaManagerApprovalInput {
    ids!: number[] | undefined;
    comment!: string | undefined;

    constructor(data?: IBulkKekaManagerApprovalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): BulkKekaManagerApprovalInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkKekaManagerApprovalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["comment"] = this.comment;
        return data;
    }
}

export interface IBulkKekaManagerApprovalInput {
    ids: number[] | undefined;
    comment: string | undefined;
}

export class BulkKekaManagerApprovalResultDto implements IBulkKekaManagerApprovalResultDto {
    decidedIds!: number[] | undefined;
    failed!: BulkKekaManagerApprovalFailureDto[] | undefined;
    syncFailed!: BulkKekaManagerApprovalFailureDto[] | undefined;

    constructor(data?: IBulkKekaManagerApprovalResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["decidedIds"])) {
                this.decidedIds = [] as any;
                for (let item of _data["decidedIds"])
                    this.decidedIds!.push(item);
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [] as any;
                for (let item of _data["failed"])
                    this.failed!.push(BulkKekaManagerApprovalFailureDto.fromJS(item));
            }
            if (Array.isArray(_data["syncFailed"])) {
                this.syncFailed = [] as any;
                for (let item of _data["syncFailed"])
                    this.syncFailed!.push(BulkKekaManagerApprovalFailureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkKekaManagerApprovalResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkKekaManagerApprovalResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.decidedIds)) {
            data["decidedIds"] = [];
            for (let item of this.decidedIds)
                data["decidedIds"].push(item);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.syncFailed)) {
            data["syncFailed"] = [];
            for (let item of this.syncFailed)
                data["syncFailed"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBulkKekaManagerApprovalResultDto {
    decidedIds: number[] | undefined;
    failed: BulkKekaManagerApprovalFailureDto[] | undefined;
    syncFailed: BulkKekaManagerApprovalFailureDto[] | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CalculationTimeAndAttendanceDto implements ICalculationTimeAndAttendanceDto {
    productivityTime!: string;
    effectiveness!: number;
    productivity!: number;
    trackedTime!: string;
    rank!: number;
    timeAtWork!: string;
    arrivalTime!: DateTime;
    leftTime!: string | undefined;
    leftDateTime!: DateTime | undefined;
    productivityBarStartTime!: DateTime;
    isPRodTimePresent!: boolean;
    minimumUsererWorkingHours!: number;
    workStartDate!: DateTime;
    workEndDate!: DateTime;
    productivityPercentage!: number;

    constructor(data?: ICalculationTimeAndAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productivityTime = _data["productivityTime"];
            this.effectiveness = _data["effectiveness"];
            this.productivity = _data["productivity"];
            this.trackedTime = _data["trackedTime"];
            this.rank = _data["rank"];
            this.timeAtWork = _data["timeAtWork"];
            this.arrivalTime = _data["arrivalTime"] ? DateTime.fromISO(_data["arrivalTime"].toString()) : undefined as any;
            this.leftTime = _data["leftTime"];
            this.leftDateTime = _data["leftDateTime"] ? DateTime.fromISO(_data["leftDateTime"].toString()) : undefined as any;
            this.productivityBarStartTime = _data["productivityBarStartTime"] ? DateTime.fromISO(_data["productivityBarStartTime"].toString()) : undefined as any;
            this.isPRodTimePresent = _data["isPRodTimePresent"];
            this.minimumUsererWorkingHours = _data["minimumUsererWorkingHours"];
            this.workStartDate = _data["workStartDate"] ? DateTime.fromISO(_data["workStartDate"].toString()) : undefined as any;
            this.workEndDate = _data["workEndDate"] ? DateTime.fromISO(_data["workEndDate"].toString()) : undefined as any;
            this.productivityPercentage = _data["productivityPercentage"];
        }
    }

    static fromJS(data: any): CalculationTimeAndAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationTimeAndAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productivityTime"] = this.productivityTime;
        data["effectiveness"] = this.effectiveness;
        data["productivity"] = this.productivity;
        data["trackedTime"] = this.trackedTime;
        data["rank"] = this.rank;
        data["timeAtWork"] = this.timeAtWork;
        data["arrivalTime"] = this.arrivalTime ? this.arrivalTime.toString() : undefined as any;
        data["leftTime"] = this.leftTime;
        data["leftDateTime"] = this.leftDateTime ? this.leftDateTime.toString() : undefined as any;
        data["productivityBarStartTime"] = this.productivityBarStartTime ? this.productivityBarStartTime.toString() : undefined as any;
        data["isPRodTimePresent"] = this.isPRodTimePresent;
        data["minimumUsererWorkingHours"] = this.minimumUsererWorkingHours;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toString() : undefined as any;
        data["workEndDate"] = this.workEndDate ? this.workEndDate.toString() : undefined as any;
        data["productivityPercentage"] = this.productivityPercentage;
        return data;
    }
}

export interface ICalculationTimeAndAttendanceDto {
    productivityTime: string;
    effectiveness: number;
    productivity: number;
    trackedTime: string;
    rank: number;
    timeAtWork: string;
    arrivalTime: DateTime;
    leftTime: string | undefined;
    leftDateTime: DateTime | undefined;
    productivityBarStartTime: DateTime;
    isPRodTimePresent: boolean;
    minimumUsererWorkingHours: number;
    workStartDate: DateTime;
    workEndDate: DateTime;
    productivityPercentage: number;
}

export class CalculationTimeAndAttendanceDtoForMobile implements ICalculationTimeAndAttendanceDtoForMobile {
    productivityTime!: string;
    effectiveness!: number;
    productivity!: number;
    trackedTime!: string;
    rank!: number;
    timeAtWork!: string;
    arrivalTime!: DateTime;
    leftTime!: string | undefined;
    leftDateTime!: DateTime | undefined;
    timeAtWorkTotalSec!: string | undefined;

    constructor(data?: ICalculationTimeAndAttendanceDtoForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productivityTime = _data["productivityTime"];
            this.effectiveness = _data["effectiveness"];
            this.productivity = _data["productivity"];
            this.trackedTime = _data["trackedTime"];
            this.rank = _data["rank"];
            this.timeAtWork = _data["timeAtWork"];
            this.arrivalTime = _data["arrivalTime"] ? DateTime.fromISO(_data["arrivalTime"].toString()) : undefined as any;
            this.leftTime = _data["leftTime"];
            this.leftDateTime = _data["leftDateTime"] ? DateTime.fromISO(_data["leftDateTime"].toString()) : undefined as any;
            this.timeAtWorkTotalSec = _data["timeAtWorkTotalSec"];
        }
    }

    static fromJS(data: any): CalculationTimeAndAttendanceDtoForMobile {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationTimeAndAttendanceDtoForMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productivityTime"] = this.productivityTime;
        data["effectiveness"] = this.effectiveness;
        data["productivity"] = this.productivity;
        data["trackedTime"] = this.trackedTime;
        data["rank"] = this.rank;
        data["timeAtWork"] = this.timeAtWork;
        data["arrivalTime"] = this.arrivalTime ? this.arrivalTime.toString() : undefined as any;
        data["leftTime"] = this.leftTime;
        data["leftDateTime"] = this.leftDateTime ? this.leftDateTime.toString() : undefined as any;
        data["timeAtWorkTotalSec"] = this.timeAtWorkTotalSec;
        return data;
    }
}

export interface ICalculationTimeAndAttendanceDtoForMobile {
    productivityTime: string;
    effectiveness: number;
    productivity: number;
    trackedTime: string;
    rank: number;
    timeAtWork: string;
    arrivalTime: DateTime;
    leftTime: string | undefined;
    leftDateTime: DateTime | undefined;
    timeAtWorkTotalSec: string | undefined;
}

export class CalendarConfigurationSettingsDto implements ICalendarConfigurationSettingsDto {
    googleEventsEndpoint!: string | undefined;
    googleTokenEndpoint!: string | undefined;
    googleClientId!: string | undefined;
    googleClientSecret!: string | undefined;
    googleApiKey!: string | undefined;
    googleScope!: string | undefined;
    googleRedirectURL!: string | undefined;
    outlookEventEndPoint!: string | undefined;
    outlookAuthorizationEndpoint!: string | undefined;
    outlookTokenEndpoint!: string | undefined;
    outlookClientId!: string | undefined;
    outlookClientSecret!: string | undefined;
    outlookScope!: string | undefined;
    outlookRedirectURL!: string | undefined;
    id!: number;

    constructor(data?: ICalendarConfigurationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleEventsEndpoint = _data["googleEventsEndpoint"];
            this.googleTokenEndpoint = _data["googleTokenEndpoint"];
            this.googleClientId = _data["googleClientId"];
            this.googleClientSecret = _data["googleClientSecret"];
            this.googleApiKey = _data["googleApiKey"];
            this.googleScope = _data["googleScope"];
            this.googleRedirectURL = _data["googleRedirectURL"];
            this.outlookEventEndPoint = _data["outlookEventEndPoint"];
            this.outlookAuthorizationEndpoint = _data["outlookAuthorizationEndpoint"];
            this.outlookTokenEndpoint = _data["outlookTokenEndpoint"];
            this.outlookClientId = _data["outlookClientId"];
            this.outlookClientSecret = _data["outlookClientSecret"];
            this.outlookScope = _data["outlookScope"];
            this.outlookRedirectURL = _data["outlookRedirectURL"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CalendarConfigurationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarConfigurationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleEventsEndpoint"] = this.googleEventsEndpoint;
        data["googleTokenEndpoint"] = this.googleTokenEndpoint;
        data["googleClientId"] = this.googleClientId;
        data["googleClientSecret"] = this.googleClientSecret;
        data["googleApiKey"] = this.googleApiKey;
        data["googleScope"] = this.googleScope;
        data["googleRedirectURL"] = this.googleRedirectURL;
        data["outlookEventEndPoint"] = this.outlookEventEndPoint;
        data["outlookAuthorizationEndpoint"] = this.outlookAuthorizationEndpoint;
        data["outlookTokenEndpoint"] = this.outlookTokenEndpoint;
        data["outlookClientId"] = this.outlookClientId;
        data["outlookClientSecret"] = this.outlookClientSecret;
        data["outlookScope"] = this.outlookScope;
        data["outlookRedirectURL"] = this.outlookRedirectURL;
        data["id"] = this.id;
        return data;
    }
}

export interface ICalendarConfigurationSettingsDto {
    googleEventsEndpoint: string | undefined;
    googleTokenEndpoint: string | undefined;
    googleClientId: string | undefined;
    googleClientSecret: string | undefined;
    googleApiKey: string | undefined;
    googleScope: string | undefined;
    googleRedirectURL: string | undefined;
    outlookEventEndPoint: string | undefined;
    outlookAuthorizationEndpoint: string | undefined;
    outlookTokenEndpoint: string | undefined;
    outlookClientId: string | undefined;
    outlookClientSecret: string | undefined;
    outlookScope: string | undefined;
    outlookRedirectURL: string | undefined;
    id: number;
}

export enum CalendarServiceProviderType {
    Google = 0,
    Outlook = 1,
    System = 2,
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export enum CaptureQualityType {
    Capture640X40 = 1,
    Capture1024X660 = 2,
}

export class CategoryWiseApplicationDto implements ICategoryWiseApplicationDto {
    productiveApplication!: GetApplicationsDto[] | undefined;
    unProductiveApplication!: GetApplicationsDto[] | undefined;

    constructor(data?: ICategoryWiseApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productiveApplication"])) {
                this.productiveApplication = [] as any;
                for (let item of _data["productiveApplication"])
                    this.productiveApplication!.push(GetApplicationsDto.fromJS(item));
            }
            if (Array.isArray(_data["unProductiveApplication"])) {
                this.unProductiveApplication = [] as any;
                for (let item of _data["unProductiveApplication"])
                    this.unProductiveApplication!.push(GetApplicationsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryWiseApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWiseApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productiveApplication)) {
            data["productiveApplication"] = [];
            for (let item of this.productiveApplication)
                data["productiveApplication"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unProductiveApplication)) {
            data["unProductiveApplication"] = [];
            for (let item of this.unProductiveApplication)
                data["unProductiveApplication"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryWiseApplicationDto {
    productiveApplication: GetApplicationsDto[] | undefined;
    unProductiveApplication: GetApplicationsDto[] | undefined;
}

export class ChangeKekaApproversInput implements IChangeKekaApproversInput {
    userIds!: number[] | undefined;

    constructor(data?: IChangeKekaApproversInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ChangeKekaApproversInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeKekaApproversInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface IChangeKekaApproversInput {
    userIds: number[] | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChargeLateFeeCreateOrEditDto implements IChargeLateFeeCreateOrEditDto {
    clientId!: number;
    feeValueType!: FeeValueTypes;
    days!: number | undefined;
    invoiceValue!: number;
    tenantId!: number;
    charelateFeeTaxDetail!: TenantProductServiceTaxesDto[] | undefined;
    id!: number;

    constructor(data?: IChargeLateFeeCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.feeValueType = _data["feeValueType"];
            this.days = _data["days"];
            this.invoiceValue = _data["invoiceValue"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["charelateFeeTaxDetail"])) {
                this.charelateFeeTaxDetail = [] as any;
                for (let item of _data["charelateFeeTaxDetail"])
                    this.charelateFeeTaxDetail!.push(TenantProductServiceTaxesDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChargeLateFeeCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeLateFeeCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["feeValueType"] = this.feeValueType;
        data["days"] = this.days;
        data["invoiceValue"] = this.invoiceValue;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.charelateFeeTaxDetail)) {
            data["charelateFeeTaxDetail"] = [];
            for (let item of this.charelateFeeTaxDetail)
                data["charelateFeeTaxDetail"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IChargeLateFeeCreateOrEditDto {
    clientId: number;
    feeValueType: FeeValueTypes;
    days: number | undefined;
    invoiceValue: number;
    tenantId: number;
    charelateFeeTaxDetail: TenantProductServiceTaxesDto[] | undefined;
    id: number;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class ChartNameValueDto implements IChartNameValueDto {
    name!: string | undefined;
    value!: number;
    icon!: string | undefined;
    noOfEmp!: string | undefined;
    totalTime!: string | undefined;

    constructor(data?: IChartNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.icon = _data["icon"];
            this.noOfEmp = _data["noOfEmp"];
            this.totalTime = _data["totalTime"];
        }
    }

    static fromJS(data: any): ChartNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["icon"] = this.icon;
        data["noOfEmp"] = this.noOfEmp;
        data["totalTime"] = this.totalTime;
        return data;
    }
}

export interface IChartNameValueDto {
    name: string | undefined;
    value: number;
    icon: string | undefined;
    noOfEmp: string | undefined;
    totalTime: string | undefined;
}

export class ChartPrductiveUnProductiveValueDto implements IChartPrductiveUnProductiveValueDto {
    productive!: number;
    unProductive!: number;
    neutral!: number;
    private!: number;

    constructor(data?: IChartPrductiveUnProductiveValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productive = _data["productive"];
            this.unProductive = _data["unProductive"];
            this.neutral = _data["neutral"];
            this.private = _data["private"];
        }
    }

    static fromJS(data: any): ChartPrductiveUnProductiveValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartPrductiveUnProductiveValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productive"] = this.productive;
        data["unProductive"] = this.unProductive;
        data["neutral"] = this.neutral;
        data["private"] = this.private;
        return data;
    }
}

export interface IChartPrductiveUnProductiveValueDto {
    productive: number;
    unProductive: number;
    neutral: number;
    private: number;
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: DateTime;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: DateTime;
    sharedMessageId: string | undefined;
    id: number;
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class CheckInCheckOutDto implements ICheckInCheckOutDto {
    status!: UserStatusEnum;
    userId!: number;

    constructor(data?: ICheckInCheckOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CheckInCheckOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInCheckOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICheckInCheckOutDto {
    status: UserStatusEnum;
    userId: number;
}

export class CheckUserLoginWithTenant implements ICheckUserLoginWithTenant {
    userNameOrEmailAddress!: string | undefined;

    constructor(data?: ICheckUserLoginWithTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
        }
    }

    static fromJS(data: any): CheckUserLoginWithTenant {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserLoginWithTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        return data;
    }
}

export interface ICheckUserLoginWithTenant {
    userNameOrEmailAddress: string | undefined;
}

export class CheckValidityforLeavesDtoForFlutter implements ICheckValidityforLeavesDtoForFlutter {
    userId!: number;
    tenantId!: number;
    fromDate!: DateTime;
    toDate!: DateTime;
    leaveTypeInfo!: LeaveType;
    dayTypeInfo!: DayType;
    id!: number | undefined;

    constructor(data?: ICheckValidityforLeavesDtoForFlutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.leaveTypeInfo = _data["leaveTypeInfo"];
            this.dayTypeInfo = _data["dayTypeInfo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CheckValidityforLeavesDtoForFlutter {
        data = typeof data === 'object' ? data : {};
        let result = new CheckValidityforLeavesDtoForFlutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["leaveTypeInfo"] = this.leaveTypeInfo;
        data["dayTypeInfo"] = this.dayTypeInfo;
        data["id"] = this.id;
        return data;
    }
}

export interface ICheckValidityforLeavesDtoForFlutter {
    userId: number;
    tenantId: number;
    fromDate: DateTime;
    toDate: DateTime;
    leaveTypeInfo: LeaveType;
    dayTypeInfo: DayType;
    id: number | undefined;
}

export class CheckinDto implements ICheckinDto {
    checkinDate!: string | undefined;
    checkoutDate!: string | undefined;
    employeeID!: number | undefined;
    checkinTime!: string | undefined;
    checkoutTime!: string | undefined;
    totalHours!: string | undefined;
    tenantId!: number;
    id!: number;

    constructor(data?: ICheckinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkinDate = _data["checkinDate"];
            this.checkoutDate = _data["checkoutDate"];
            this.employeeID = _data["employeeID"];
            this.checkinTime = _data["checkinTime"];
            this.checkoutTime = _data["checkoutTime"];
            this.totalHours = _data["totalHours"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CheckinDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkinDate"] = this.checkinDate;
        data["checkoutDate"] = this.checkoutDate;
        data["employeeID"] = this.employeeID;
        data["checkinTime"] = this.checkinTime;
        data["checkoutTime"] = this.checkoutTime;
        data["totalHours"] = this.totalHours;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICheckinDto {
    checkinDate: string | undefined;
    checkoutDate: string | undefined;
    employeeID: number | undefined;
    checkinTime: string | undefined;
    checkoutTime: string | undefined;
    totalHours: string | undefined;
    tenantId: number;
    id: number;
}

export class CityMasterDto implements ICityMasterDto {
    name!: string | undefined;
    state_id!: number;
    state_code!: string | undefined;
    state_name!: string | undefined;
    country_id!: number;
    country_code!: string | undefined;
    country_name!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    wikiDataId!: string | undefined;
    id!: number;

    constructor(data?: ICityMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.state_id = _data["state_id"];
            this.state_code = _data["state_code"];
            this.state_name = _data["state_name"];
            this.country_id = _data["country_id"];
            this.country_code = _data["country_code"];
            this.country_name = _data["country_name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.wikiDataId = _data["wikiDataId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state_id"] = this.state_id;
        data["state_code"] = this.state_code;
        data["state_name"] = this.state_name;
        data["country_id"] = this.country_id;
        data["country_code"] = this.country_code;
        data["country_name"] = this.country_name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["wikiDataId"] = this.wikiDataId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICityMasterDto {
    name: string | undefined;
    state_id: number;
    state_code: string | undefined;
    state_name: string | undefined;
    country_id: number;
    country_code: string | undefined;
    country_name: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    wikiDataId: string | undefined;
    id: number;
}

export class CleanValuesInput implements ICleanValuesInput {
    dynamicEntityPropertyId!: number;
    entityId!: string | undefined;

    constructor(data?: ICleanValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): CleanValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CleanValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ICleanValuesInput {
    dynamicEntityPropertyId: number;
    entityId: string | undefined;
}

export class Client implements IClient {
    tenantId!: number;
    name!: string;
    clientImageURL!: string | undefined;
    note!: string | undefined;
    street!: string | undefined;
    city!: number;
    state!: number;
    zipCode!: string | undefined;
    website!: string | undefined;
    timeZone!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModifiedUser!: User;
    countryId!: number | undefined;
    currencyId!: number | undefined;
    currency!: Currency;
    applicationLanguageId!: number | undefined;
    applicationLanguage!: ApplicationLanguage;
    isArchived!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.clientImageURL = _data["clientImageURL"];
            this.note = _data["note"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.website = _data["website"];
            this.timeZone = _data["timeZone"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifiedUser = _data["lastModifiedUser"] ? User.fromJS(_data["lastModifiedUser"]) : undefined as any;
            this.countryId = _data["countryId"];
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : undefined as any;
            this.applicationLanguageId = _data["applicationLanguageId"];
            this.applicationLanguage = _data["applicationLanguage"] ? ApplicationLanguage.fromJS(_data["applicationLanguage"]) : undefined as any;
            this.isArchived = _data["isArchived"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["clientImageURL"] = this.clientImageURL;
        data["note"] = this.note;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["website"] = this.website;
        data["timeZone"] = this.timeZone;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifiedUser"] = this.lastModifiedUser ? this.lastModifiedUser.toJSON() : undefined as any;
        data["countryId"] = this.countryId;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : undefined as any;
        data["applicationLanguageId"] = this.applicationLanguageId;
        data["applicationLanguage"] = this.applicationLanguage ? this.applicationLanguage.toJSON() : undefined as any;
        data["isArchived"] = this.isArchived;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IClient {
    tenantId: number;
    name: string;
    clientImageURL: string | undefined;
    note: string | undefined;
    street: string | undefined;
    city: number;
    state: number;
    zipCode: string | undefined;
    website: string | undefined;
    timeZone: string | undefined;
    lastModifierUserId: number | undefined;
    lastModifiedUser: User;
    countryId: number | undefined;
    currencyId: number | undefined;
    currency: Currency;
    applicationLanguageId: number | undefined;
    applicationLanguage: ApplicationLanguage;
    isArchived: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ClientApplicationLanguageDto implements IClientApplicationLanguageDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IClientApplicationLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ClientApplicationLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApplicationLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IClientApplicationLanguageDto {
    id: number;
    displayName: string | undefined;
}

export class ClientContactCreateOrEditDto implements IClientContactCreateOrEditDto {
    firstName!: string;
    lastName!: string;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    isPrimary!: boolean;
    clientContactRoleId!: number;
    clientId!: number;
    userId!: number;
    id!: number | undefined;

    constructor(data?: IClientContactCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPrimary = _data["isPrimary"];
            this.clientContactRoleId = _data["clientContactRoleId"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientContactCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientContactCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isPrimary"] = this.isPrimary;
        data["clientContactRoleId"] = this.clientContactRoleId;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientContactCreateOrEditDto {
    firstName: string;
    lastName: string;
    email: string | undefined;
    phoneNumber: string | undefined;
    isPrimary: boolean;
    clientContactRoleId: number;
    clientId: number;
    userId: number;
    id: number | undefined;
}

export class ClientContactDto implements IClientContactDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    isPrimary!: boolean;
    clientContactRoleId!: number;
    clientId!: number;
    userId!: number | undefined;
    fullName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IClientContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPrimary = _data["isPrimary"];
            this.clientContactRoleId = _data["clientContactRoleId"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isPrimary"] = this.isPrimary;
        data["clientContactRoleId"] = this.clientContactRoleId;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientContactDto {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    isPrimary: boolean;
    clientContactRoleId: number;
    clientId: number;
    userId: number | undefined;
    fullName: string | undefined;
    id: number | undefined;
}

export class ClientCreateOrEditDto implements IClientCreateOrEditDto {
    tenantId!: number;
    name!: string;
    clientImageURL!: string | undefined;
    note!: string | undefined;
    street!: string | undefined;
    city!: number;
    state!: number;
    zipCode!: string | undefined;
    countryId!: number;
    country!: CountryDto;
    website!: string | undefined;
    timeZone!: string | undefined;
    currencyId!: number | undefined;
    applicationLanguageId!: number | undefined;
    chargeLateFee!: ChargeLateFeeCreateOrEditDto;
    paymentReminder!: CreateOrEditPaymentRemainder[] | undefined;
    charelateFeeTaxDetail!: TenantProductServiceTaxesDto[] | undefined;
    clientContacts!: ClientContactCreateOrEditDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IClientCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.clientImageURL = _data["clientImageURL"];
            this.note = _data["note"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : undefined as any;
            this.website = _data["website"];
            this.timeZone = _data["timeZone"];
            this.currencyId = _data["currencyId"];
            this.applicationLanguageId = _data["applicationLanguageId"];
            this.chargeLateFee = _data["chargeLateFee"] ? ChargeLateFeeCreateOrEditDto.fromJS(_data["chargeLateFee"]) : undefined as any;
            if (Array.isArray(_data["paymentReminder"])) {
                this.paymentReminder = [] as any;
                for (let item of _data["paymentReminder"])
                    this.paymentReminder!.push(CreateOrEditPaymentRemainder.fromJS(item));
            }
            if (Array.isArray(_data["charelateFeeTaxDetail"])) {
                this.charelateFeeTaxDetail = [] as any;
                for (let item of _data["charelateFeeTaxDetail"])
                    this.charelateFeeTaxDetail!.push(TenantProductServiceTaxesDto.fromJS(item));
            }
            if (Array.isArray(_data["clientContacts"])) {
                this.clientContacts = [] as any;
                for (let item of _data["clientContacts"])
                    this.clientContacts!.push(ClientContactCreateOrEditDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["clientImageURL"] = this.clientImageURL;
        data["note"] = this.note;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["website"] = this.website;
        data["timeZone"] = this.timeZone;
        data["currencyId"] = this.currencyId;
        data["applicationLanguageId"] = this.applicationLanguageId;
        data["chargeLateFee"] = this.chargeLateFee ? this.chargeLateFee.toJSON() : undefined as any;
        if (Array.isArray(this.paymentReminder)) {
            data["paymentReminder"] = [];
            for (let item of this.paymentReminder)
                data["paymentReminder"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.charelateFeeTaxDetail)) {
            data["charelateFeeTaxDetail"] = [];
            for (let item of this.charelateFeeTaxDetail)
                data["charelateFeeTaxDetail"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.clientContacts)) {
            data["clientContacts"] = [];
            for (let item of this.clientContacts)
                data["clientContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IClientCreateOrEditDto {
    tenantId: number;
    name: string;
    clientImageURL: string | undefined;
    note: string | undefined;
    street: string | undefined;
    city: number;
    state: number;
    zipCode: string | undefined;
    countryId: number;
    country: CountryDto;
    website: string | undefined;
    timeZone: string | undefined;
    currencyId: number | undefined;
    applicationLanguageId: number | undefined;
    chargeLateFee: ChargeLateFeeCreateOrEditDto;
    paymentReminder: CreateOrEditPaymentRemainder[] | undefined;
    charelateFeeTaxDetail: TenantProductServiceTaxesDto[] | undefined;
    clientContacts: ClientContactCreateOrEditDto[] | undefined;
    id: number | undefined;
}

export class ClientCurrencyDto implements IClientCurrencyDto {
    id!: number;
    displayName!: string | undefined;
    symbol!: string | undefined;
    flag!: string | undefined;
    code!: string | undefined;

    constructor(data?: IClientCurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.symbol = _data["symbol"];
            this.flag = _data["flag"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ClientCurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["symbol"] = this.symbol;
        data["flag"] = this.flag;
        data["code"] = this.code;
        return data;
    }
}

export interface IClientCurrencyDto {
    id: number;
    displayName: string | undefined;
    symbol: string | undefined;
    flag: string | undefined;
    code: string | undefined;
}

export class ClientDto implements IClientDto {
    lastModifiedUser!: UserListDto;
    tenantId!: number;
    name!: string;
    clientImageURL!: string | undefined;
    note!: string | undefined;
    street!: string | undefined;
    city!: number;
    state!: number;
    zipCode!: string | undefined;
    website!: string | undefined;
    timeZone!: string | undefined;
    lastModificationTime!: string | undefined;
    lastModifiedUserName!: string | undefined;
    lastUser!: string | undefined;
    firstContact!: string | undefined;
    isDeleted!: boolean;
    currencyId!: number | undefined;
    applicationLanguageId!: number | undefined;
    clientContacts!: ClientContactDto[] | undefined;
    contactDetails!: ClientContactDto;
    clientContactDetails!: ClientContactDto;
    countryId!: number | undefined;
    creatorId!: number | undefined;
    isDelete!: string | undefined;
    projectCount!: number;
    country!: CountryDto;
    contactDetailsInString!: string | undefined;
    chargeLateFee!: ChargeLateFeeCreateOrEditDto;
    paymentReminder!: CreateOrEditPaymentRemainder[] | undefined;
    charelateFeeTaxDetail!: TenantProductServiceTaxesDto[] | undefined;
    clientTypeDetails!: ClientType;
    orgnizationCreationDate!: DateTime;
    id!: number | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastModifiedUser = _data["lastModifiedUser"] ? UserListDto.fromJS(_data["lastModifiedUser"]) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.clientImageURL = _data["clientImageURL"];
            this.note = _data["note"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.website = _data["website"];
            this.timeZone = _data["timeZone"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifiedUserName = _data["lastModifiedUserName"];
            this.lastUser = _data["lastUser"];
            this.firstContact = _data["firstContact"];
            this.isDeleted = _data["isDeleted"];
            this.currencyId = _data["currencyId"];
            this.applicationLanguageId = _data["applicationLanguageId"];
            if (Array.isArray(_data["clientContacts"])) {
                this.clientContacts = [] as any;
                for (let item of _data["clientContacts"])
                    this.clientContacts!.push(ClientContactDto.fromJS(item));
            }
            this.contactDetails = _data["contactDetails"] ? ClientContactDto.fromJS(_data["contactDetails"]) : undefined as any;
            this.clientContactDetails = _data["clientContactDetails"] ? ClientContactDto.fromJS(_data["clientContactDetails"]) : undefined as any;
            this.countryId = _data["countryId"];
            this.creatorId = _data["creatorId"];
            this.isDelete = _data["isDelete"];
            this.projectCount = _data["projectCount"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : undefined as any;
            this.contactDetailsInString = _data["contactDetailsInString"];
            this.chargeLateFee = _data["chargeLateFee"] ? ChargeLateFeeCreateOrEditDto.fromJS(_data["chargeLateFee"]) : undefined as any;
            if (Array.isArray(_data["paymentReminder"])) {
                this.paymentReminder = [] as any;
                for (let item of _data["paymentReminder"])
                    this.paymentReminder!.push(CreateOrEditPaymentRemainder.fromJS(item));
            }
            if (Array.isArray(_data["charelateFeeTaxDetail"])) {
                this.charelateFeeTaxDetail = [] as any;
                for (let item of _data["charelateFeeTaxDetail"])
                    this.charelateFeeTaxDetail!.push(TenantProductServiceTaxesDto.fromJS(item));
            }
            this.clientTypeDetails = _data["clientTypeDetails"];
            this.orgnizationCreationDate = _data["orgnizationCreationDate"] ? DateTime.fromISO(_data["orgnizationCreationDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModifiedUser"] = this.lastModifiedUser ? this.lastModifiedUser.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["clientImageURL"] = this.clientImageURL;
        data["note"] = this.note;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["website"] = this.website;
        data["timeZone"] = this.timeZone;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifiedUserName"] = this.lastModifiedUserName;
        data["lastUser"] = this.lastUser;
        data["firstContact"] = this.firstContact;
        data["isDeleted"] = this.isDeleted;
        data["currencyId"] = this.currencyId;
        data["applicationLanguageId"] = this.applicationLanguageId;
        if (Array.isArray(this.clientContacts)) {
            data["clientContacts"] = [];
            for (let item of this.clientContacts)
                data["clientContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["contactDetails"] = this.contactDetails ? this.contactDetails.toJSON() : undefined as any;
        data["clientContactDetails"] = this.clientContactDetails ? this.clientContactDetails.toJSON() : undefined as any;
        data["countryId"] = this.countryId;
        data["creatorId"] = this.creatorId;
        data["isDelete"] = this.isDelete;
        data["projectCount"] = this.projectCount;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["contactDetailsInString"] = this.contactDetailsInString;
        data["chargeLateFee"] = this.chargeLateFee ? this.chargeLateFee.toJSON() : undefined as any;
        if (Array.isArray(this.paymentReminder)) {
            data["paymentReminder"] = [];
            for (let item of this.paymentReminder)
                data["paymentReminder"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.charelateFeeTaxDetail)) {
            data["charelateFeeTaxDetail"] = [];
            for (let item of this.charelateFeeTaxDetail)
                data["charelateFeeTaxDetail"].push(item ? item.toJSON() : undefined as any);
        }
        data["clientTypeDetails"] = this.clientTypeDetails;
        data["orgnizationCreationDate"] = this.orgnizationCreationDate ? this.orgnizationCreationDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientDto {
    lastModifiedUser: UserListDto;
    tenantId: number;
    name: string;
    clientImageURL: string | undefined;
    note: string | undefined;
    street: string | undefined;
    city: number;
    state: number;
    zipCode: string | undefined;
    website: string | undefined;
    timeZone: string | undefined;
    lastModificationTime: string | undefined;
    lastModifiedUserName: string | undefined;
    lastUser: string | undefined;
    firstContact: string | undefined;
    isDeleted: boolean;
    currencyId: number | undefined;
    applicationLanguageId: number | undefined;
    clientContacts: ClientContactDto[] | undefined;
    contactDetails: ClientContactDto;
    clientContactDetails: ClientContactDto;
    countryId: number | undefined;
    creatorId: number | undefined;
    isDelete: string | undefined;
    projectCount: number;
    country: CountryDto;
    contactDetailsInString: string | undefined;
    chargeLateFee: ChargeLateFeeCreateOrEditDto;
    paymentReminder: CreateOrEditPaymentRemainder[] | undefined;
    charelateFeeTaxDetail: TenantProductServiceTaxesDto[] | undefined;
    clientTypeDetails: ClientType;
    orgnizationCreationDate: DateTime;
    id: number | undefined;
}

export enum ClientType {
    AllClients = 1,
    ArchivedClients = 2,
    DeletedClients = 3,
    TotalClients = 4,
}

export class CombineApplicationTypeDto implements ICombineApplicationTypeDto {
    productiveUnProductiveNuetralDetail!: ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto[] | undefined;
    applicationTimeDetail!: ApplicationAndSpendTimeDto[] | undefined;

    constructor(data?: ICombineApplicationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productiveUnProductiveNuetralDetail"])) {
                this.productiveUnProductiveNuetralDetail = [] as any;
                for (let item of _data["productiveUnProductiveNuetralDetail"])
                    this.productiveUnProductiveNuetralDetail!.push(ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationTimeDetail"])) {
                this.applicationTimeDetail = [] as any;
                for (let item of _data["applicationTimeDetail"])
                    this.applicationTimeDetail!.push(ApplicationAndSpendTimeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CombineApplicationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombineApplicationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productiveUnProductiveNuetralDetail)) {
            data["productiveUnProductiveNuetralDetail"] = [];
            for (let item of this.productiveUnProductiveNuetralDetail)
                data["productiveUnProductiveNuetralDetail"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.applicationTimeDetail)) {
            data["applicationTimeDetail"] = [];
            for (let item of this.applicationTimeDetail)
                data["applicationTimeDetail"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICombineApplicationTypeDto {
    productiveUnProductiveNuetralDetail: ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto[] | undefined;
    applicationTimeDetail: ApplicationAndSpendTimeDto[] | undefined;
}

export class CombineUserInfoDto implements ICombineUserInfoDto {
    userInfoDetail!: TimeAndAttendanceUserInfoDto;
    workingType!: WorkFromType;
    userCurrentStatus!: UserStatusEnum;
    time!: DateTime | undefined;
    lastCheckInTime!: DateTime | undefined;
    offset!: number;
    activeTimeDetail!: ActiveTimeDto;

    constructor(data?: ICombineUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInfoDetail = _data["userInfoDetail"] ? TimeAndAttendanceUserInfoDto.fromJS(_data["userInfoDetail"]) : undefined as any;
            this.workingType = _data["workingType"];
            this.userCurrentStatus = _data["userCurrentStatus"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : undefined as any;
            this.lastCheckInTime = _data["lastCheckInTime"] ? DateTime.fromISO(_data["lastCheckInTime"].toString()) : undefined as any;
            this.offset = _data["offset"];
            this.activeTimeDetail = _data["activeTimeDetail"] ? ActiveTimeDto.fromJS(_data["activeTimeDetail"]) : undefined as any;
        }
    }

    static fromJS(data: any): CombineUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombineUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInfoDetail"] = this.userInfoDetail ? this.userInfoDetail.toJSON() : undefined as any;
        data["workingType"] = this.workingType;
        data["userCurrentStatus"] = this.userCurrentStatus;
        data["time"] = this.time ? this.time.toString() : undefined as any;
        data["lastCheckInTime"] = this.lastCheckInTime ? this.lastCheckInTime.toString() : undefined as any;
        data["offset"] = this.offset;
        data["activeTimeDetail"] = this.activeTimeDetail ? this.activeTimeDetail.toJSON() : undefined as any;
        return data;
    }
}

export interface ICombineUserInfoDto {
    userInfoDetail: TimeAndAttendanceUserInfoDto;
    workingType: WorkFromType;
    userCurrentStatus: UserStatusEnum;
    time: DateTime | undefined;
    lastCheckInTime: DateTime | undefined;
    offset: number;
    activeTimeDetail: ActiveTimeDto;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class CommentTaskDto implements ICommentTaskDto {
    id!: number;
    userName!: string | undefined;
    userImage!: string | undefined;
    commentDate!: DateTime;
    comment!: string | undefined;
    isRed!: boolean;
    commentId!: number;
    fromUserId!: number;
    tenantId!: number;

    constructor(data?: ICommentTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.commentDate = _data["commentDate"] ? DateTime.fromISO(_data["commentDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.isRed = _data["isRed"];
            this.commentId = _data["commentId"];
            this.fromUserId = _data["fromUserId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CommentTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["commentDate"] = this.commentDate ? this.commentDate.toString() : undefined as any;
        data["comment"] = this.comment;
        data["isRed"] = this.isRed;
        data["commentId"] = this.commentId;
        data["fromUserId"] = this.fromUserId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICommentTaskDto {
    id: number;
    userName: string | undefined;
    userImage: string | undefined;
    commentDate: DateTime;
    comment: string | undefined;
    isRed: boolean;
    commentId: number;
    fromUserId: number;
    tenantId: number;
}

export class CommonNameIdDto implements ICommonNameIdDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ICommonNameIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CommonNameIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommonNameIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICommonNameIdDto {
    id: number;
    name: string | undefined;
}

export class CompanyProfileCountryLookupTableDto implements ICompanyProfileCountryLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    symbol!: string | undefined;
    flag!: string | undefined;

    constructor(data?: ICompanyProfileCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.symbol = _data["symbol"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): CompanyProfileCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["symbol"] = this.symbol;
        data["flag"] = this.flag;
        return data;
    }
}

export interface ICompanyProfileCountryLookupTableDto {
    id: number;
    displayName: string | undefined;
    symbol: string | undefined;
    flag: string | undefined;
}

export class CompanyProfileCreateOrEditDto implements ICompanyProfileCreateOrEditDto {
    tenantId!: number;
    name!: string | undefined;
    companyLogoURL!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryId!: number;
    currencyId!: number | undefined;
    website!: string | undefined;
    timeZone!: string | undefined;
    dateFormat!: number;
    phone1!: string | undefined;
    phone2!: string | undefined;
    faxNumber!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICompanyProfileCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.companyLogoURL = _data["companyLogoURL"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.currencyId = _data["currencyId"];
            this.website = _data["website"];
            this.timeZone = _data["timeZone"];
            this.dateFormat = _data["dateFormat"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.faxNumber = _data["faxNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyProfileCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["companyLogoURL"] = this.companyLogoURL;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["currencyId"] = this.currencyId;
        data["website"] = this.website;
        data["timeZone"] = this.timeZone;
        data["dateFormat"] = this.dateFormat;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["faxNumber"] = this.faxNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface ICompanyProfileCreateOrEditDto {
    tenantId: number;
    name: string | undefined;
    companyLogoURL: string | undefined;
    street: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryId: number;
    currencyId: number | undefined;
    website: string | undefined;
    timeZone: string | undefined;
    dateFormat: number;
    phone1: string | undefined;
    phone2: string | undefined;
    faxNumber: string | undefined;
    id: number | undefined;
}

export class CompanyProfileCurrencyLookupTableDto implements ICompanyProfileCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    symbol!: string | undefined;
    flag!: string | undefined;
    code!: string | undefined;

    constructor(data?: ICompanyProfileCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.symbol = _data["symbol"];
            this.flag = _data["flag"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompanyProfileCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["symbol"] = this.symbol;
        data["flag"] = this.flag;
        data["code"] = this.code;
        return data;
    }
}

export interface ICompanyProfileCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
    symbol: string | undefined;
    flag: string | undefined;
    code: string | undefined;
}

export class CompanyProfileDetailCreateOrEditDto implements ICompanyProfileDetailCreateOrEditDto {
    tenantId!: number;
    companyName!: string | undefined;
    companyImgURL!: string | undefined;
    address!: string | undefined;
    owner!: string | undefined;
    city!: number;
    cityName!: string | undefined;
    state!: number;
    zipCode!: string | undefined;
    countryId!: number;
    dateFormat!: number;
    hourlyRate!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    phone1Flag!: string | undefined;
    phone2Flag!: string | undefined;
    currencyId!: number;
    currencyIdFlag!: string | undefined;
    industryId!: number;
    timeZone!: string | undefined;
    day!: Days;
    mailInterval!: MailIntervalType;
    emailDispatchTime!: DateTime | undefined;
    monthlyDate!: number;
    locationFlag!: string | undefined;
    reportEmailer!: string | undefined;
    longitude!: string | undefined;
    latitude!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICompanyProfileDetailCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.companyName = _data["companyName"];
            this.companyImgURL = _data["companyImgURL"];
            this.address = _data["address"];
            this.owner = _data["owner"];
            this.city = _data["city"];
            this.cityName = _data["cityName"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.dateFormat = _data["dateFormat"];
            this.hourlyRate = _data["hourlyRate"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.phone1Flag = _data["phone1Flag"];
            this.phone2Flag = _data["phone2Flag"];
            this.currencyId = _data["currencyId"];
            this.currencyIdFlag = _data["currencyIdFlag"];
            this.industryId = _data["industryId"];
            this.timeZone = _data["timeZone"];
            this.day = _data["day"];
            this.mailInterval = _data["mailInterval"];
            this.emailDispatchTime = _data["emailDispatchTime"] ? DateTime.fromISO(_data["emailDispatchTime"].toString()) : undefined as any;
            this.monthlyDate = _data["monthlyDate"];
            this.locationFlag = _data["locationFlag"];
            this.reportEmailer = _data["reportEmailer"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyProfileDetailCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileDetailCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["companyName"] = this.companyName;
        data["companyImgURL"] = this.companyImgURL;
        data["address"] = this.address;
        data["owner"] = this.owner;
        data["city"] = this.city;
        data["cityName"] = this.cityName;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["dateFormat"] = this.dateFormat;
        data["hourlyRate"] = this.hourlyRate;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["phone1Flag"] = this.phone1Flag;
        data["phone2Flag"] = this.phone2Flag;
        data["currencyId"] = this.currencyId;
        data["currencyIdFlag"] = this.currencyIdFlag;
        data["industryId"] = this.industryId;
        data["timeZone"] = this.timeZone;
        data["day"] = this.day;
        data["mailInterval"] = this.mailInterval;
        data["emailDispatchTime"] = this.emailDispatchTime ? this.emailDispatchTime.toString() : undefined as any;
        data["monthlyDate"] = this.monthlyDate;
        data["locationFlag"] = this.locationFlag;
        data["reportEmailer"] = this.reportEmailer;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["id"] = this.id;
        return data;
    }
}

export interface ICompanyProfileDetailCreateOrEditDto {
    tenantId: number;
    companyName: string | undefined;
    companyImgURL: string | undefined;
    address: string | undefined;
    owner: string | undefined;
    city: number;
    cityName: string | undefined;
    state: number;
    zipCode: string | undefined;
    countryId: number;
    dateFormat: number;
    hourlyRate: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    phone1Flag: string | undefined;
    phone2Flag: string | undefined;
    currencyId: number;
    currencyIdFlag: string | undefined;
    industryId: number;
    timeZone: string | undefined;
    day: Days;
    mailInterval: MailIntervalType;
    emailDispatchTime: DateTime | undefined;
    monthlyDate: number;
    locationFlag: string | undefined;
    reportEmailer: string | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
    id: number | undefined;
}

export class CompanyProfileDto implements ICompanyProfileDto {
    tenantId!: number;
    name!: string | undefined;
    companyLogoURL!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryId!: number;
    currencyId!: number | undefined;
    website!: string | undefined;
    timeZone!: string | undefined;
    dateFormat!: number;
    phone1!: string | undefined;
    phone2!: string | undefined;
    faxNumber!: string | undefined;
    ownerEmailId!: string | undefined;
    setReportTime!: string | undefined;
    setReportDay!: string | undefined;
    setRepotDate!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: ICompanyProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.companyLogoURL = _data["companyLogoURL"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.currencyId = _data["currencyId"];
            this.website = _data["website"];
            this.timeZone = _data["timeZone"];
            this.dateFormat = _data["dateFormat"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.faxNumber = _data["faxNumber"];
            this.ownerEmailId = _data["ownerEmailId"];
            this.setReportTime = _data["setReportTime"];
            this.setReportDay = _data["setReportDay"];
            this.setRepotDate = _data["setRepotDate"] ? DateTime.fromISO(_data["setRepotDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["companyLogoURL"] = this.companyLogoURL;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["currencyId"] = this.currencyId;
        data["website"] = this.website;
        data["timeZone"] = this.timeZone;
        data["dateFormat"] = this.dateFormat;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["faxNumber"] = this.faxNumber;
        data["ownerEmailId"] = this.ownerEmailId;
        data["setReportTime"] = this.setReportTime;
        data["setReportDay"] = this.setReportDay;
        data["setRepotDate"] = this.setRepotDate ? this.setRepotDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ICompanyProfileDto {
    tenantId: number;
    name: string | undefined;
    companyLogoURL: string | undefined;
    street: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryId: number;
    currencyId: number | undefined;
    website: string | undefined;
    timeZone: string | undefined;
    dateFormat: number;
    phone1: string | undefined;
    phone2: string | undefined;
    faxNumber: string | undefined;
    ownerEmailId: string | undefined;
    setReportTime: string | undefined;
    setReportDay: string | undefined;
    setRepotDate: DateTime | undefined;
    id: number | undefined;
}

export class ConnectDevOpsProjectInput implements IConnectDevOpsProjectInput {
    projectId!: number;
    devProjectName!: string | undefined;
    projectUrl!: string | undefined;
    personalAccessToken!: string | undefined;

    constructor(data?: IConnectDevOpsProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.devProjectName = _data["devProjectName"];
            this.projectUrl = _data["projectUrl"];
            this.personalAccessToken = _data["personalAccessToken"];
        }
    }

    static fromJS(data: any): ConnectDevOpsProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectDevOpsProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["devProjectName"] = this.devProjectName;
        data["projectUrl"] = this.projectUrl;
        data["personalAccessToken"] = this.personalAccessToken;
        return data;
    }
}

export interface IConnectDevOpsProjectInput {
    projectId: number;
    devProjectName: string | undefined;
    projectUrl: string | undefined;
    personalAccessToken: string | undefined;
}

export class ConnectIntegrationApiKeyInput implements IConnectIntegrationApiKeyInput {
    provider!: IntegrationProvider;
    licenseAllocation!: IntegrationLicenseAllocation;
    clientId!: number | undefined;
    comment!: string | undefined;
    apiKey!: string;

    constructor(data?: IConnectIntegrationApiKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.licenseAllocation = _data["licenseAllocation"];
            this.clientId = _data["clientId"];
            this.comment = _data["comment"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): ConnectIntegrationApiKeyInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectIntegrationApiKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["licenseAllocation"] = this.licenseAllocation;
        data["clientId"] = this.clientId;
        data["comment"] = this.comment;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IConnectIntegrationApiKeyInput {
    provider: IntegrationProvider;
    licenseAllocation: IntegrationLicenseAllocation;
    clientId: number | undefined;
    comment: string | undefined;
    apiKey: string;
}

export class ConvertMonthlyCalculatedDataDto implements IConvertMonthlyCalculatedDataDto {
    neutral!: number;
    productive!: number;
    unProdictive!: number;
    time!: DateTime;
    userId!: number;
    tenantId!: number;

    constructor(data?: IConvertMonthlyCalculatedDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neutral = _data["neutral"];
            this.productive = _data["productive"];
            this.unProdictive = _data["unProdictive"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ConvertMonthlyCalculatedDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertMonthlyCalculatedDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neutral"] = this.neutral;
        data["productive"] = this.productive;
        data["unProdictive"] = this.unProdictive;
        data["time"] = this.time ? this.time.toString() : undefined as any;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IConvertMonthlyCalculatedDataDto {
    neutral: number;
    productive: number;
    unProdictive: number;
    time: DateTime;
    userId: number;
    tenantId: number;
}

export class ConvertWeeklyDataDto implements IConvertWeeklyDataDto {
    neutral!: number;
    productive!: number;
    unProdictive!: number;
    time!: DateTime;
    userId!: number;
    tenantId!: number;

    constructor(data?: IConvertWeeklyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neutral = _data["neutral"];
            this.productive = _data["productive"];
            this.unProdictive = _data["unProdictive"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ConvertWeeklyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertWeeklyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neutral"] = this.neutral;
        data["productive"] = this.productive;
        data["unProdictive"] = this.unProdictive;
        data["time"] = this.time ? this.time.toString() : undefined as any;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IConvertWeeklyDataDto {
    neutral: number;
    productive: number;
    unProdictive: number;
    time: DateTime;
    userId: number;
    tenantId: number;
}

export class Coordinates implements ICoordinates {

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICoordinates {
}

export class CoordinatesDto implements ICoordinatesDto {
    longitude!: number;
    latitude!: number;

    constructor(data?: ICoordinatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): CoordinatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

export interface ICoordinatesDto {
    longitude: number;
    latitude: number;
}

export class CountryDto implements ICountryDto {
    name!: string | undefined;
    countryCode!: number;
    symbol!: string | undefined;
    flag!: string | undefined;
    id!: number;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
            this.symbol = _data["symbol"];
            this.flag = _data["flag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        data["symbol"] = this.symbol;
        data["flag"] = this.flag;
        data["id"] = this.id;
        return data;
    }
}

export interface ICountryDto {
    name: string | undefined;
    countryCode: number;
    symbol: string | undefined;
    flag: string | undefined;
    id: number;
}

export class CountryMasterDto implements ICountryMasterDto {
    name!: string | undefined;
    iso3!: string | undefined;
    iso2!: string | undefined;
    numeric_code!: string | undefined;
    phone_code!: string | undefined;
    currency!: string | undefined;
    currency_name!: string | undefined;
    currency_symbol!: string | undefined;
    tld!: string | undefined;
    id!: number;

    constructor(data?: ICountryMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.iso3 = _data["iso3"];
            this.iso2 = _data["iso2"];
            this.numeric_code = _data["numeric_code"];
            this.phone_code = _data["phone_code"];
            this.currency = _data["currency"];
            this.currency_name = _data["currency_name"];
            this.currency_symbol = _data["currency_symbol"];
            this.tld = _data["tld"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountryMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["iso3"] = this.iso3;
        data["iso2"] = this.iso2;
        data["numeric_code"] = this.numeric_code;
        data["phone_code"] = this.phone_code;
        data["currency"] = this.currency;
        data["currency_name"] = this.currency_name;
        data["currency_symbol"] = this.currency_symbol;
        data["tld"] = this.tld;
        data["id"] = this.id;
        return data;
    }
}

export interface ICountryMasterDto {
    name: string | undefined;
    iso3: string | undefined;
    iso2: string | undefined;
    numeric_code: string | undefined;
    phone_code: string | undefined;
    currency: string | undefined;
    currency_name: string | undefined;
    currency_symbol: string | undefined;
    tld: string | undefined;
    id: number;
}

export class CreateAgentAppCrashReportDto implements ICreateAgentAppCrashReportDto {
    id!: number | undefined;
    productName!: string | undefined;
    version!: string | undefined;
    platform!: string | undefined;
    processType!: string | undefined;
    stackMsg!: string | undefined;
    systemInfo!: string | undefined;
    osInfo!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: ICreateAgentAppCrashReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.version = _data["version"];
            this.platform = _data["platform"];
            this.processType = _data["processType"];
            this.stackMsg = _data["stackMsg"];
            this.systemInfo = _data["systemInfo"];
            this.osInfo = _data["osInfo"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateAgentAppCrashReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentAppCrashReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["version"] = this.version;
        data["platform"] = this.platform;
        data["processType"] = this.processType;
        data["stackMsg"] = this.stackMsg;
        data["systemInfo"] = this.systemInfo;
        data["osInfo"] = this.osInfo;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateAgentAppCrashReportDto {
    id: number | undefined;
    productName: string | undefined;
    version: string | undefined;
    platform: string | undefined;
    processType: string | undefined;
    stackMsg: string | undefined;
    systemInfo: string | undefined;
    osInfo: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
}

export class CreateDesignationUnitInput implements ICreateDesignationUnitInput {
    parentId!: number | undefined;
    displayName!: string;
    designationDescription!: DesignationDescriptionDto;
    tenantId!: number | undefined;

    constructor(data?: ICreateDesignationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
            this.designationDescription = _data["designationDescription"] ? DesignationDescriptionDto.fromJS(_data["designationDescription"]) : undefined as any;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateDesignationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDesignationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["designationDescription"] = this.designationDescription ? this.designationDescription.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateDesignationUnitInput {
    parentId: number | undefined;
    displayName: string;
    designationDescription: DesignationDescriptionDto;
    tenantId: number | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateKekaManagerApprovalInput implements ICreateKekaManagerApprovalInput {
    projectId!: number;
    fromProjectId!: number | undefined;
    changeType!: KekaMemberChangeType;
    projectManagerId!: number;
    userIds!: number[] | undefined;

    constructor(data?: ICreateKekaManagerApprovalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.fromProjectId = _data["fromProjectId"];
            this.changeType = _data["changeType"];
            this.projectManagerId = _data["projectManagerId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateKekaManagerApprovalInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKekaManagerApprovalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["fromProjectId"] = this.fromProjectId;
        data["changeType"] = this.changeType;
        data["projectManagerId"] = this.projectManagerId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface ICreateKekaManagerApprovalInput {
    projectId: number;
    fromProjectId: number | undefined;
    changeType: KekaMemberChangeType;
    projectManagerId: number;
    userIds: number[] | undefined;
}

export class CreateKekaManagerApprovalOnProjectUpdateInput implements ICreateKekaManagerApprovalOnProjectUpdateInput {
    projectId!: number;
    oldManagerIds!: number[] | undefined;
    oldMemberIds!: number[] | undefined;
    newManagerIds!: number[] | undefined;
    newMemberIds!: number[] | undefined;

    constructor(data?: ICreateKekaManagerApprovalOnProjectUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["oldManagerIds"])) {
                this.oldManagerIds = [] as any;
                for (let item of _data["oldManagerIds"])
                    this.oldManagerIds!.push(item);
            }
            if (Array.isArray(_data["oldMemberIds"])) {
                this.oldMemberIds = [] as any;
                for (let item of _data["oldMemberIds"])
                    this.oldMemberIds!.push(item);
            }
            if (Array.isArray(_data["newManagerIds"])) {
                this.newManagerIds = [] as any;
                for (let item of _data["newManagerIds"])
                    this.newManagerIds!.push(item);
            }
            if (Array.isArray(_data["newMemberIds"])) {
                this.newMemberIds = [] as any;
                for (let item of _data["newMemberIds"])
                    this.newMemberIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateKekaManagerApprovalOnProjectUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKekaManagerApprovalOnProjectUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.oldManagerIds)) {
            data["oldManagerIds"] = [];
            for (let item of this.oldManagerIds)
                data["oldManagerIds"].push(item);
        }
        if (Array.isArray(this.oldMemberIds)) {
            data["oldMemberIds"] = [];
            for (let item of this.oldMemberIds)
                data["oldMemberIds"].push(item);
        }
        if (Array.isArray(this.newManagerIds)) {
            data["newManagerIds"] = [];
            for (let item of this.newManagerIds)
                data["newManagerIds"].push(item);
        }
        if (Array.isArray(this.newMemberIds)) {
            data["newMemberIds"] = [];
            for (let item of this.newMemberIds)
                data["newMemberIds"].push(item);
        }
        return data;
    }
}

export interface ICreateKekaManagerApprovalOnProjectUpdateInput {
    projectId: number;
    oldManagerIds: number[] | undefined;
    oldMemberIds: number[] | undefined;
    newManagerIds: number[] | undefined;
    newMemberIds: number[] | undefined;
}

export class CreateOrEditAgentAppSettingDto implements ICreateOrEditAgentAppSettingDto {
    tenantId!: number;
    userId!: number;
    isHideWindow!: boolean;
    isAllowDrag!: boolean;
    isTimeInTray!: boolean;
    isSound!: boolean;
    soundId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAgentAppSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isHideWindow = _data["isHideWindow"];
            this.isAllowDrag = _data["isAllowDrag"];
            this.isTimeInTray = _data["isTimeInTray"];
            this.isSound = _data["isSound"];
            this.soundId = _data["soundId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAgentAppSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAgentAppSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isHideWindow"] = this.isHideWindow;
        data["isAllowDrag"] = this.isAllowDrag;
        data["isTimeInTray"] = this.isTimeInTray;
        data["isSound"] = this.isSound;
        data["soundId"] = this.soundId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAgentAppSettingDto {
    tenantId: number;
    userId: number;
    isHideWindow: boolean;
    isAllowDrag: boolean;
    isTimeInTray: boolean;
    isSound: boolean;
    soundId: number;
    id: number | undefined;
}

export class CreateOrEditCaptureSettingDto implements ICreateOrEditCaptureSettingDto {
    tenantId!: number;
    enableScreenShot!: boolean;
    isBlurScreen!: boolean;
    isApp!: boolean;
    isUrl!: boolean;
    isWindow!: boolean;
    isPrivateTime!: boolean;
    isMobile!: boolean;
    isCalSync!: boolean;
    isMouseClick!: boolean;
    isMouseMove!: boolean;
    isPrjCost!: boolean;
    isOwner!: boolean;
    isDashboard!: boolean;
    isProjectSec!: boolean;
    isOffTimeSec!: boolean;
    isExptSec!: boolean;
    isTMSec!: boolean;
    isWrkSch!: boolean;
    isHideSS!: boolean;
    isHideInvSec!: boolean;
    isNwPrjCreate!: boolean;
    isCollSec!: boolean;
    isAbsCal!: boolean;
    isReportSec!: boolean;
    idleTimeInterval!: IdleTimeIntervalType;
    offlineTime!: OfflineTimeType;
    captureQuality!: CaptureQualityType;
    defaultApplicationProductivity!: DefaultApplicationProductivityType;
    screenCaptureInterval!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCaptureSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.enableScreenShot = _data["enableScreenShot"];
            this.isBlurScreen = _data["isBlurScreen"];
            this.isApp = _data["isApp"];
            this.isUrl = _data["isUrl"];
            this.isWindow = _data["isWindow"];
            this.isPrivateTime = _data["isPrivateTime"];
            this.isMobile = _data["isMobile"];
            this.isCalSync = _data["isCalSync"];
            this.isMouseClick = _data["isMouseClick"];
            this.isMouseMove = _data["isMouseMove"];
            this.isPrjCost = _data["isPrjCost"];
            this.isOwner = _data["isOwner"];
            this.isDashboard = _data["isDashboard"];
            this.isProjectSec = _data["isProjectSec"];
            this.isOffTimeSec = _data["isOffTimeSec"];
            this.isExptSec = _data["isExptSec"];
            this.isTMSec = _data["isTMSec"];
            this.isWrkSch = _data["isWrkSch"];
            this.isHideSS = _data["isHideSS"];
            this.isHideInvSec = _data["isHideInvSec"];
            this.isNwPrjCreate = _data["isNwPrjCreate"];
            this.isCollSec = _data["isCollSec"];
            this.isAbsCal = _data["isAbsCal"];
            this.isReportSec = _data["isReportSec"];
            this.idleTimeInterval = _data["idleTimeInterval"];
            this.offlineTime = _data["offlineTime"];
            this.captureQuality = _data["captureQuality"];
            this.defaultApplicationProductivity = _data["defaultApplicationProductivity"];
            this.screenCaptureInterval = _data["screenCaptureInterval"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCaptureSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCaptureSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["enableScreenShot"] = this.enableScreenShot;
        data["isBlurScreen"] = this.isBlurScreen;
        data["isApp"] = this.isApp;
        data["isUrl"] = this.isUrl;
        data["isWindow"] = this.isWindow;
        data["isPrivateTime"] = this.isPrivateTime;
        data["isMobile"] = this.isMobile;
        data["isCalSync"] = this.isCalSync;
        data["isMouseClick"] = this.isMouseClick;
        data["isMouseMove"] = this.isMouseMove;
        data["isPrjCost"] = this.isPrjCost;
        data["isOwner"] = this.isOwner;
        data["isDashboard"] = this.isDashboard;
        data["isProjectSec"] = this.isProjectSec;
        data["isOffTimeSec"] = this.isOffTimeSec;
        data["isExptSec"] = this.isExptSec;
        data["isTMSec"] = this.isTMSec;
        data["isWrkSch"] = this.isWrkSch;
        data["isHideSS"] = this.isHideSS;
        data["isHideInvSec"] = this.isHideInvSec;
        data["isNwPrjCreate"] = this.isNwPrjCreate;
        data["isCollSec"] = this.isCollSec;
        data["isAbsCal"] = this.isAbsCal;
        data["isReportSec"] = this.isReportSec;
        data["idleTimeInterval"] = this.idleTimeInterval;
        data["offlineTime"] = this.offlineTime;
        data["captureQuality"] = this.captureQuality;
        data["defaultApplicationProductivity"] = this.defaultApplicationProductivity;
        data["screenCaptureInterval"] = this.screenCaptureInterval;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCaptureSettingDto {
    tenantId: number;
    enableScreenShot: boolean;
    isBlurScreen: boolean;
    isApp: boolean;
    isUrl: boolean;
    isWindow: boolean;
    isPrivateTime: boolean;
    isMobile: boolean;
    isCalSync: boolean;
    isMouseClick: boolean;
    isMouseMove: boolean;
    isPrjCost: boolean;
    isOwner: boolean;
    isDashboard: boolean;
    isProjectSec: boolean;
    isOffTimeSec: boolean;
    isExptSec: boolean;
    isTMSec: boolean;
    isWrkSch: boolean;
    isHideSS: boolean;
    isHideInvSec: boolean;
    isNwPrjCreate: boolean;
    isCollSec: boolean;
    isAbsCal: boolean;
    isReportSec: boolean;
    idleTimeInterval: IdleTimeIntervalType;
    offlineTime: OfflineTimeType;
    captureQuality: CaptureQualityType;
    defaultApplicationProductivity: DefaultApplicationProductivityType;
    screenCaptureInterval: number;
    id: number | undefined;
}

export class CreateOrEditPaymentRemainder implements ICreateOrEditPaymentRemainder {
    clientId!: number;
    days!: string | undefined;
    afterBeforeDay!: AfterBeforeDay;
    remainder!: number;
    invoiceId!: number;
    personalMessage!: string | undefined;
    isDeleted!: boolean;
    tenantId!: number;
    id!: number;

    constructor(data?: ICreateOrEditPaymentRemainder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.days = _data["days"];
            this.afterBeforeDay = _data["afterBeforeDay"];
            this.remainder = _data["remainder"];
            this.invoiceId = _data["invoiceId"];
            this.personalMessage = _data["personalMessage"];
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPaymentRemainder {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPaymentRemainder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["days"] = this.days;
        data["afterBeforeDay"] = this.afterBeforeDay;
        data["remainder"] = this.remainder;
        data["invoiceId"] = this.invoiceId;
        data["personalMessage"] = this.personalMessage;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPaymentRemainder {
    clientId: number;
    days: string | undefined;
    afterBeforeDay: AfterBeforeDay;
    remainder: number;
    invoiceId: number;
    personalMessage: string | undefined;
    isDeleted: boolean;
    tenantId: number;
    id: number;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];
    tenantId!: number | undefined;

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
    tenantId: number | undefined;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;
    microsoftLogin!: boolean;
    googleLogin!: boolean;
    inTimeProsLogin!: boolean;
    appleLogin!: boolean;
    tenantId!: number;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
            this.microsoftLogin = _data["microsoftLogin"];
            this.googleLogin = _data["googleLogin"];
            this.inTimeProsLogin = _data["inTimeProsLogin"];
            this.appleLogin = _data["appleLogin"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["microsoftLogin"] = this.microsoftLogin;
        data["googleLogin"] = this.googleLogin;
        data["inTimeProsLogin"] = this.inTimeProsLogin;
        data["appleLogin"] = this.appleLogin;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
    microsoftLogin: boolean;
    googleLogin: boolean;
    inTimeProsLogin: boolean;
    appleLogin: boolean;
    tenantId: number;
}

export class CreateOrUpdateUserProjectAllocationDto implements ICreateOrUpdateUserProjectAllocationDto {
    id!: number | undefined;
    userId!: number;
    projectId!: number;
    isBillable!: boolean;
    allocationPercentage!: number;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    description!: string | undefined;

    constructor(data?: ICreateOrUpdateUserProjectAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.isBillable = _data["isBillable"];
            this.allocationPercentage = _data["allocationPercentage"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserProjectAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserProjectAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["isBillable"] = this.isBillable;
        data["allocationPercentage"] = this.allocationPercentage;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateOrUpdateUserProjectAllocationDto {
    id: number | undefined;
    userId: number;
    projectId: number;
    isBillable: boolean;
    allocationPercentage: number;
    startDate: DateTime;
    endDate: DateTime | undefined;
    description: string | undefined;
}

export class CreateOrUpdateUserSummaryDto implements ICreateOrUpdateUserSummaryDto {
    userId!: number;
    experienceYears!: number;
    experienceMonths!: number;
    availableFrom!: DateTime | undefined;
    availabilityStatus!: AvailabilityStatus;
    assignedLearningPathCount!: number;

    constructor(data?: ICreateOrUpdateUserSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.experienceYears = _data["experienceYears"];
            this.experienceMonths = _data["experienceMonths"];
            this.availableFrom = _data["availableFrom"] ? DateTime.fromISO(_data["availableFrom"].toString()) : undefined as any;
            this.availabilityStatus = _data["availabilityStatus"];
            this.assignedLearningPathCount = _data["assignedLearningPathCount"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["experienceYears"] = this.experienceYears;
        data["experienceMonths"] = this.experienceMonths;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toString() : undefined as any;
        data["availabilityStatus"] = this.availabilityStatus;
        data["assignedLearningPathCount"] = this.assignedLearningPathCount;
        return data;
    }
}

export interface ICreateOrUpdateUserSummaryDto {
    userId: number;
    experienceYears: number;
    experienceMonths: number;
    availableFrom: DateTime | undefined;
    availabilityStatus: AvailabilityStatus;
    assignedLearningPathCount: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;
    oragnizationDescription!: OragnizationDescriptionDto;
    tenantId!: number | undefined;
    code!: string | undefined;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
            this.oragnizationDescription = _data["oragnizationDescription"] ? OragnizationDescriptionDto.fromJS(_data["oragnizationDescription"]) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        data["oragnizationDescription"] = this.oragnizationDescription ? this.oragnizationDescription.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
    oragnizationDescription: OragnizationDescriptionDto;
    tenantId: number | undefined;
    code: string | undefined;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number;
    editionPaymentType!: EditionPaymentType;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean;
    successUrl!: string | undefined;
    currency!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionId = _data["editionId"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = _data["recurringPaymentEnabled"];
            this.successUrl = _data["successUrl"];
            this.currency = _data["currency"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["currency"] = this.currency;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean;
    successUrl: string | undefined;
    currency: string | undefined;
    errorUrl: string | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class Currency implements ICurrency {
    name!: string | undefined;
    code!: string | undefined;
    symbol!: string | undefined;
    flag!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.symbol = _data["symbol"];
            this.flag = _data["flag"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["symbol"] = this.symbol;
        data["flag"] = this.flag;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICurrency {
    name: string | undefined;
    code: string | undefined;
    symbol: string | undefined;
    flag: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CurrentTenantInfoDto implements ICurrentTenantInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    id!: number;

    constructor(data?: ICurrentTenantInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurrentTenantInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTenantInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICurrentTenantInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

export class DashboardMyTimesheetDto implements IDashboardMyTimesheetDto {
    submitedHours!: string;
    approvedHours!: string;
    submitedDate!: DateTime | undefined;
    timeSheetDate!: DateTime | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    requiredHours!: string;
    billedHours!: string;
    userId!: number | undefined;
    userName!: string | undefined;
    userEmailAddress!: string | undefined;
    userProfileImage!: string | undefined;
    userRole!: string[] | undefined;
    user!: UserListDto;
    projectImage!: string | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    projectType!: ProjectBillingType;
    projectCurrentStatus!: ProjectStatus;
    fromDate!: DateTime;
    toDate!: DateTime;
    projectCreationDate!: DateTime | undefined;
    projectEndDate!: DateTime | undefined;
    leave!: number;
    isAdmin!: boolean;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    unReadCount!: number;
    isNextLevelClient!: boolean;
    employeeId!: string | undefined;
    userStatusId!: UserStatusEnum;
    dateWiseTimesheetIds!: TimesheetIdsDateWise[] | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag!: boolean;
    timesheetApprovalDtos!: TimesheetApprovalDto[] | undefined;
    id!: number;

    constructor(data?: IDashboardMyTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitedHours = _data["submitedHours"];
            this.approvedHours = _data["approvedHours"];
            this.submitedDate = _data["submitedDate"] ? DateTime.fromISO(_data["submitedDate"].toString()) : undefined as any;
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.requiredHours = _data["requiredHours"];
            this.billedHours = _data["billedHours"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userProfileImage = _data["userProfileImage"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.user = _data["user"] ? UserListDto.fromJS(_data["user"]) : undefined as any;
            this.projectImage = _data["projectImage"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.projectType = _data["projectType"];
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.leave = _data["leave"];
            this.isAdmin = _data["isAdmin"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            this.unReadCount = _data["unReadCount"];
            this.isNextLevelClient = _data["isNextLevelClient"];
            this.employeeId = _data["employeeId"];
            this.userStatusId = _data["userStatusId"];
            if (Array.isArray(_data["dateWiseTimesheetIds"])) {
                this.dateWiseTimesheetIds = [] as any;
                for (let item of _data["dateWiseTimesheetIds"])
                    this.dateWiseTimesheetIds!.push(TimesheetIdsDateWise.fromJS(item));
            }
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.isRejectedForMyTimesheetLevelFlag = _data["isRejectedForMyTimesheetLevelFlag"];
            if (Array.isArray(_data["timesheetApprovalDtos"])) {
                this.timesheetApprovalDtos = [] as any;
                for (let item of _data["timesheetApprovalDtos"])
                    this.timesheetApprovalDtos!.push(TimesheetApprovalDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DashboardMyTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMyTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitedHours"] = this.submitedHours;
        data["approvedHours"] = this.approvedHours;
        data["submitedDate"] = this.submitedDate ? this.submitedDate.toString() : undefined as any;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["requiredHours"] = this.requiredHours;
        data["billedHours"] = this.billedHours;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userProfileImage"] = this.userProfileImage;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["projectImage"] = this.projectImage;
        data["timesheetStatus"] = this.timesheetStatus;
        data["projectType"] = this.projectType;
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["leave"] = this.leave;
        data["isAdmin"] = this.isAdmin;
        data["timesheetFrequency"] = this.timesheetFrequency;
        data["unReadCount"] = this.unReadCount;
        data["isNextLevelClient"] = this.isNextLevelClient;
        data["employeeId"] = this.employeeId;
        data["userStatusId"] = this.userStatusId;
        if (Array.isArray(this.dateWiseTimesheetIds)) {
            data["dateWiseTimesheetIds"] = [];
            for (let item of this.dateWiseTimesheetIds)
                data["dateWiseTimesheetIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["isRejectedForMyTimesheetLevelFlag"] = this.isRejectedForMyTimesheetLevelFlag;
        if (Array.isArray(this.timesheetApprovalDtos)) {
            data["timesheetApprovalDtos"] = [];
            for (let item of this.timesheetApprovalDtos)
                data["timesheetApprovalDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IDashboardMyTimesheetDto {
    submitedHours: string;
    approvedHours: string;
    submitedDate: DateTime | undefined;
    timeSheetDate: DateTime | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    requiredHours: string;
    billedHours: string;
    userId: number | undefined;
    userName: string | undefined;
    userEmailAddress: string | undefined;
    userProfileImage: string | undefined;
    userRole: string[] | undefined;
    user: UserListDto;
    projectImage: string | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    projectType: ProjectBillingType;
    projectCurrentStatus: ProjectStatus;
    fromDate: DateTime;
    toDate: DateTime;
    projectCreationDate: DateTime | undefined;
    projectEndDate: DateTime | undefined;
    leave: number;
    isAdmin: boolean;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    unReadCount: number;
    isNextLevelClient: boolean;
    employeeId: string | undefined;
    userStatusId: UserStatusEnum;
    dateWiseTimesheetIds: TimesheetIdsDateWise[] | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag: boolean;
    timesheetApprovalDtos: TimesheetApprovalDto[] | undefined;
    id: number;
}

export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DashboardUserDto implements IDashboardUserDto {
    userName!: string | undefined;
    usersRole!: string[] | undefined;
    userImage!: string | undefined;
    contactNumber!: string | undefined;
    email!: string | undefined;
    userJoinDate!: DateTime;

    constructor(data?: IDashboardUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            if (Array.isArray(_data["usersRole"])) {
                this.usersRole = [] as any;
                for (let item of _data["usersRole"])
                    this.usersRole!.push(item);
            }
            this.userImage = _data["userImage"];
            this.contactNumber = _data["contactNumber"];
            this.email = _data["email"];
            this.userJoinDate = _data["userJoinDate"] ? DateTime.fromISO(_data["userJoinDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DashboardUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        if (Array.isArray(this.usersRole)) {
            data["usersRole"] = [];
            for (let item of this.usersRole)
                data["usersRole"].push(item);
        }
        data["userImage"] = this.userImage;
        data["contactNumber"] = this.contactNumber;
        data["email"] = this.email;
        data["userJoinDate"] = this.userJoinDate ? this.userJoinDate.toString() : undefined as any;
        return data;
    }
}

export interface IDashboardUserDto {
    userName: string | undefined;
    usersRole: string[] | undefined;
    userImage: string | undefined;
    contactNumber: string | undefined;
    email: string | undefined;
    userJoinDate: DateTime;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export enum DayOfWeekObject {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export enum DayType {
    FirstHalf = 1,
    SecondHalf = 2,
}

export class DayWiseList implements IDayWiseList {
    day!: string | undefined;
    status!: StatusDate;
    leaveType!: string | undefined;

    constructor(data?: IDayWiseList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.status = _data["status"] ? StatusDate.fromJS(_data["status"]) : undefined as any;
            this.leaveType = _data["leaveType"];
        }
    }

    static fromJS(data: any): DayWiseList {
        data = typeof data === 'object' ? data : {};
        let result = new DayWiseList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["leaveType"] = this.leaveType;
        return data;
    }
}

export interface IDayWiseList {
    day: string | undefined;
    status: StatusDate;
    leaveType: string | undefined;
}

export enum Days {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}

export class DaysListDto implements IDaysListDto {
    monday!: string;
    mondayDate!: DateTime | undefined;
    tuesday!: string;
    tuesdayDate!: DateTime | undefined;
    wednesday!: string;
    wednesdayDate!: DateTime | undefined;
    thursday!: string;
    thursdayDate!: DateTime | undefined;
    friday!: string;
    fridayDate!: DateTime | undefined;
    saturday!: string;
    saturdayDate!: DateTime | undefined;
    sunday!: string;
    sundayDate!: DateTime | undefined;

    constructor(data?: IDaysListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monday = _data["monday"];
            this.mondayDate = _data["mondayDate"] ? DateTime.fromISO(_data["mondayDate"].toString()) : undefined as any;
            this.tuesday = _data["tuesday"];
            this.tuesdayDate = _data["tuesdayDate"] ? DateTime.fromISO(_data["tuesdayDate"].toString()) : undefined as any;
            this.wednesday = _data["wednesday"];
            this.wednesdayDate = _data["wednesdayDate"] ? DateTime.fromISO(_data["wednesdayDate"].toString()) : undefined as any;
            this.thursday = _data["thursday"];
            this.thursdayDate = _data["thursdayDate"] ? DateTime.fromISO(_data["thursdayDate"].toString()) : undefined as any;
            this.friday = _data["friday"];
            this.fridayDate = _data["fridayDate"] ? DateTime.fromISO(_data["fridayDate"].toString()) : undefined as any;
            this.saturday = _data["saturday"];
            this.saturdayDate = _data["saturdayDate"] ? DateTime.fromISO(_data["saturdayDate"].toString()) : undefined as any;
            this.sunday = _data["sunday"];
            this.sundayDate = _data["sundayDate"] ? DateTime.fromISO(_data["sundayDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DaysListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DaysListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday;
        data["mondayDate"] = this.mondayDate ? this.mondayDate.toString() : undefined as any;
        data["tuesday"] = this.tuesday;
        data["tuesdayDate"] = this.tuesdayDate ? this.tuesdayDate.toString() : undefined as any;
        data["wednesday"] = this.wednesday;
        data["wednesdayDate"] = this.wednesdayDate ? this.wednesdayDate.toString() : undefined as any;
        data["thursday"] = this.thursday;
        data["thursdayDate"] = this.thursdayDate ? this.thursdayDate.toString() : undefined as any;
        data["friday"] = this.friday;
        data["fridayDate"] = this.fridayDate ? this.fridayDate.toString() : undefined as any;
        data["saturday"] = this.saturday;
        data["saturdayDate"] = this.saturdayDate ? this.saturdayDate.toString() : undefined as any;
        data["sunday"] = this.sunday;
        data["sundayDate"] = this.sundayDate ? this.sundayDate.toString() : undefined as any;
        return data;
    }
}

export interface IDaysListDto {
    monday: string;
    mondayDate: DateTime | undefined;
    tuesday: string;
    tuesdayDate: DateTime | undefined;
    wednesday: string;
    wednesdayDate: DateTime | undefined;
    thursday: string;
    thursdayDate: DateTime | undefined;
    friday: string;
    fridayDate: DateTime | undefined;
    saturday: string;
    saturdayDate: DateTime | undefined;
    sunday: string;
    sundayDate: DateTime | undefined;
}

export enum DefaultApplicationProductivityType {
    Neutral = 1,
    Productive = 2,
    UnProductive = 3,
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class DeleteValitaion implements IDeleteValitaion {
    userLeaveDatewithLevels!: UserLeaveDatewithLevel[] | undefined;
    isValide!: boolean;

    constructor(data?: IDeleteValitaion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userLeaveDatewithLevels"])) {
                this.userLeaveDatewithLevels = [] as any;
                for (let item of _data["userLeaveDatewithLevels"])
                    this.userLeaveDatewithLevels!.push(UserLeaveDatewithLevel.fromJS(item));
            }
            this.isValide = _data["isValide"];
        }
    }

    static fromJS(data: any): DeleteValitaion {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteValitaion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userLeaveDatewithLevels)) {
            data["userLeaveDatewithLevels"] = [];
            for (let item of this.userLeaveDatewithLevels)
                data["userLeaveDatewithLevels"].push(item ? item.toJSON() : undefined as any);
        }
        data["isValide"] = this.isValide;
        return data;
    }
}

export interface IDeleteValitaion {
    userLeaveDatewithLevels: UserLeaveDatewithLevel[] | undefined;
    isValide: boolean;
}

export class DesignationDescriptionDto implements IDesignationDescriptionDto {
    designationUnitId!: number;
    description!: string | undefined;
    flag!: string | undefined;
    tenantId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IDesignationDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designationUnitId = _data["designationUnitId"];
            this.description = _data["description"];
            this.flag = _data["flag"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DesignationDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationUnitId"] = this.designationUnitId;
        data["description"] = this.description;
        data["flag"] = this.flag;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDesignationDescriptionDto {
    designationUnitId: number;
    description: string | undefined;
    flag: string | undefined;
    tenantId: number | undefined;
    id: number | undefined;
}

export class DesignationDto implements IDesignationDto {
    id!: number;
    displayName!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): DesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IDesignationDto {
    id: number;
    displayName: string | undefined;
    tenantId: number | undefined;
}

export class DesignationUnitDto implements IDesignationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    profileImage!: string | undefined;
    designationDescriptions!: DesignationDescriptionDto;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDesignationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.profileImage = _data["profileImage"];
            this.designationDescriptions = _data["designationDescriptions"] ? DesignationDescriptionDto.fromJS(_data["designationDescriptions"]) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DesignationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["profileImage"] = this.profileImage;
        data["designationDescriptions"] = this.designationDescriptions ? this.designationDescriptions.toJSON() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDesignationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    profileImage: string | undefined;
    designationDescriptions: DesignationDescriptionDto;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DesignationUnitUserListDto implements IDesignationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    profileImage!: string | undefined;
    addedTime!: DateTime;
    userRoles!: string | undefined;
    id!: number;

    constructor(data?: IDesignationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.profileImage = _data["profileImage"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : undefined as any;
            this.userRoles = _data["userRoles"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DesignationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["profileImage"] = this.profileImage;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : undefined as any;
        data["userRoles"] = this.userRoles;
        data["id"] = this.id;
        return data;
    }
}

export interface IDesignationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    profileImage: string | undefined;
    addedTime: DateTime;
    userRoles: string | undefined;
    id: number;
}

export class DevOpsProjectConnectionDto implements IDevOpsProjectConnectionDto {
    projectId!: number;
    projectName!: string | undefined;
    isConnected!: boolean;
    devProjectName!: string | undefined;
    projectUrl!: string | undefined;
    tokenExpireDate!: DateTime | undefined;

    constructor(data?: IDevOpsProjectConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.isConnected = _data["isConnected"];
            this.devProjectName = _data["devProjectName"];
            this.projectUrl = _data["projectUrl"];
            this.tokenExpireDate = _data["tokenExpireDate"] ? DateTime.fromISO(_data["tokenExpireDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DevOpsProjectConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevOpsProjectConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["isConnected"] = this.isConnected;
        data["devProjectName"] = this.devProjectName;
        data["projectUrl"] = this.projectUrl;
        data["tokenExpireDate"] = this.tokenExpireDate ? this.tokenExpireDate.toString() : undefined as any;
        return data;
    }
}

export interface IDevOpsProjectConnectionDto {
    projectId: number;
    projectName: string | undefined;
    isConnected: boolean;
    devProjectName: string | undefined;
    projectUrl: string | undefined;
    tokenExpireDate: DateTime | undefined;
}

export class DeviceInstallation implements IDeviceInstallation {
    installationId!: string;
    platform!: string;
    pushChannel!: string;
    tags!: string[] | undefined;
    tenantId!: number;
    userId!: number;

    constructor(data?: IDeviceInstallation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.platform = _data["platform"];
            this.pushChannel = _data["pushChannel"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DeviceInstallation {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceInstallation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["platform"] = this.platform;
        data["pushChannel"] = this.pushChannel;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDeviceInstallation {
    installationId: string;
    platform: string;
    pushChannel: string;
    tags: string[] | undefined;
    tenantId: number;
    userId: number;
}

export class DeviceType implements IDeviceType {
    name!: string;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDeviceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeviceType {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeviceType {
    name: string;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DisconnectDevOpsProjectInput implements IDisconnectDevOpsProjectInput {
    projectId!: number;

    constructor(data?: IDisconnectDevOpsProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DisconnectDevOpsProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisconnectDevOpsProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDisconnectDevOpsProjectInput {
    projectId: number;
}

export class DownloadAgentAppPopupDto implements IDownloadAgentAppPopupDto {
    tenantId!: number;
    isDownloaded!: boolean;
    remindMeLater!: boolean;
    userId!: number;
    id!: number;

    constructor(data?: IDownloadAgentAppPopupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.isDownloaded = _data["isDownloaded"];
            this.remindMeLater = _data["remindMeLater"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadAgentAppPopupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadAgentAppPopupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isDownloaded"] = this.isDownloaded;
        data["remindMeLater"] = this.remindMeLater;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDownloadAgentAppPopupDto {
    tenantId: number;
    isDownloaded: boolean;
    remindMeLater: boolean;
    userId: number;
    id: number;
}

export class DraftedTimesheetDto implements IDraftedTimesheetDto {
    userId!: number;
    tenantId!: number;
    projectId!: number | undefined;
    userProjectTaskId!: number | undefined;
    manualAddTime!: string;
    manualAddDate!: DateTime;
    myTimeSheetId!: number | undefined;
    isRejectedTimesheet!: boolean;
    id!: number;

    constructor(data?: IDraftedTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.manualAddTime = _data["manualAddTime"];
            this.manualAddDate = _data["manualAddDate"] ? DateTime.fromISO(_data["manualAddDate"].toString()) : undefined as any;
            this.myTimeSheetId = _data["myTimeSheetId"];
            this.isRejectedTimesheet = _data["isRejectedTimesheet"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DraftedTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new DraftedTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["manualAddTime"] = this.manualAddTime;
        data["manualAddDate"] = this.manualAddDate ? this.manualAddDate.toString() : undefined as any;
        data["myTimeSheetId"] = this.myTimeSheetId;
        data["isRejectedTimesheet"] = this.isRejectedTimesheet;
        data["id"] = this.id;
        return data;
    }
}

export interface IDraftedTimesheetDto {
    userId: number;
    tenantId: number;
    projectId: number | undefined;
    userProjectTaskId: number | undefined;
    manualAddTime: string;
    manualAddDate: DateTime;
    myTimeSheetId: number | undefined;
    isRejectedTimesheet: boolean;
    id: number;
}

export class DropdownProjectListDto implements IDropdownProjectListDto {
    id!: number;
    name!: string | undefined;
    projectImage!: string | undefined;
    projectType!: number;
    projectBillingType!: ProjectBillingType;
    isArchived!: boolean;
    isDeleted!: boolean;
    isActive!: boolean;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    isTimesheetReminderEnable!: boolean;

    constructor(data?: IDropdownProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectImage = _data["projectImage"];
            this.projectType = _data["projectType"];
            this.projectBillingType = _data["projectBillingType"];
            this.isArchived = _data["isArchived"];
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isTimesheetReminderEnable = _data["isTimesheetReminderEnable"];
        }
    }

    static fromJS(data: any): DropdownProjectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectImage"] = this.projectImage;
        data["projectType"] = this.projectType;
        data["projectBillingType"] = this.projectBillingType;
        data["isArchived"] = this.isArchived;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isTimesheetReminderEnable"] = this.isTimesheetReminderEnable;
        return data;
    }
}

export interface IDropdownProjectListDto {
    id: number;
    name: string | undefined;
    projectImage: string | undefined;
    projectType: number;
    projectBillingType: ProjectBillingType;
    isArchived: boolean;
    isDeleted: boolean;
    isActive: boolean;
    startDate: DateTime;
    endDate: DateTime | undefined;
    isTimesheetReminderEnable: boolean;
}

export class DynamicEntityPropertyDto implements IDynamicEntityPropertyDto {
    entityFullName!: string | undefined;
    dynamicPropertyName!: string | undefined;
    dynamicPropertyId!: number;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
            this.dynamicPropertyName = _data["dynamicPropertyName"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        data["dynamicPropertyName"] = this.dynamicPropertyName;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicEntityPropertyDto {
    entityFullName: string | undefined;
    dynamicPropertyName: string | undefined;
    dynamicPropertyId: number;
    tenantId: number | undefined;
    id: number;
}

export class DynamicEntityPropertyValueDto implements IDynamicEntityPropertyValueDto {
    value!: string | undefined;
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    id!: number;

    constructor(data?: IDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicEntityPropertyValueDto {
    value: string | undefined;
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    id: number;
}

export class DynamicPropertyDto implements IDynamicPropertyDto {
    propertyName!: string | undefined;
    displayName!: string | undefined;
    inputType!: string | undefined;
    permission!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.displayName = _data["displayName"];
            this.inputType = _data["inputType"];
            this.permission = _data["permission"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["displayName"] = this.displayName;
        data["inputType"] = this.inputType;
        data["permission"] = this.permission;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicPropertyDto {
    propertyName: string | undefined;
    displayName: string | undefined;
    inputType: string | undefined;
    permission: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class DynamicPropertyValueDto implements IDynamicPropertyValueDto {
    value!: string | undefined;
    tenantId!: number | undefined;
    dynamicPropertyId!: number;
    id!: number;

    constructor(data?: IDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicPropertyValueDto {
    value: string | undefined;
    tenantId: number | undefined;
    dynamicPropertyId: number;
    id: number;
}

export class Edition implements IEdition {
    name!: string;
    displayName!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    monthlyPriceINR!: number | undefined;
    annualPriceINR!: number | undefined;
    monthlyPriceEURO!: number | undefined;
    annualPriceEURO!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.monthlyPriceINR = _data["monthlyPriceINR"];
            this.annualPriceINR = _data["annualPriceINR"];
            this.monthlyPriceEURO = _data["monthlyPriceEURO"];
            this.annualPriceEURO = _data["annualPriceEURO"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["monthlyPriceINR"] = this.monthlyPriceINR;
        data["annualPriceINR"] = this.annualPriceINR;
        data["monthlyPriceEURO"] = this.monthlyPriceEURO;
        data["annualPriceEURO"] = this.annualPriceEURO;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    monthlyPriceINR: number | undefined;
    annualPriceINR: number | undefined;
    monthlyPriceEURO: number | undefined;
    annualPriceEURO: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    monthlyPriceINR!: number | undefined;
    annualPriceINR!: number | undefined;
    monthlyPriceEURO!: number | undefined;
    annualPriceEURO!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.monthlyPriceINR = _data["monthlyPriceINR"];
            this.annualPriceINR = _data["annualPriceINR"];
            this.monthlyPriceEURO = _data["monthlyPriceEURO"];
            this.annualPriceEURO = _data["annualPriceEURO"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["monthlyPriceINR"] = this.monthlyPriceINR;
        data["annualPriceINR"] = this.annualPriceINR;
        data["monthlyPriceEURO"] = this.monthlyPriceEURO;
        data["annualPriceEURO"] = this.annualPriceEURO;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    monthlyPriceINR: number | undefined;
    annualPriceINR: number | undefined;
    monthlyPriceEURO: number | undefined;
    annualPriceEURO: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    monthlyPriceINR!: number | undefined;
    annualPriceINR!: number | undefined;
    monthlyPriceEURO!: number | undefined;
    annualPriceEURO!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.monthlyPriceINR = _data["monthlyPriceINR"];
            this.annualPriceINR = _data["annualPriceINR"];
            this.monthlyPriceEURO = _data["monthlyPriceEURO"];
            this.annualPriceEURO = _data["annualPriceEURO"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["monthlyPriceINR"] = this.monthlyPriceINR;
        data["annualPriceINR"] = this.annualPriceINR;
        data["monthlyPriceEURO"] = this.monthlyPriceEURO;
        data["annualPriceEURO"] = this.annualPriceEURO;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    monthlyPriceINR: number | undefined;
    annualPriceINR: number | undefined;
    monthlyPriceEURO: number | undefined;
    annualPriceEURO: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export enum EditionPaymentType {
    NewRegistration = 0,
    BuyNow = 1,
    Upgrade = 2,
    Extend = 3,
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    monthlyPriceINR!: number | undefined;
    annualPriceINR!: number | undefined;
    monthlyPriceEURO!: number | undefined;
    annualPriceEURO!: number | undefined;
    currency!: string | undefined;
    localCurrencyRate!: number;
    euroCurrencyRate!: number;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.monthlyPriceINR = _data["monthlyPriceINR"];
            this.annualPriceINR = _data["annualPriceINR"];
            this.monthlyPriceEURO = _data["monthlyPriceEURO"];
            this.annualPriceEURO = _data["annualPriceEURO"];
            this.currency = _data["currency"];
            this.localCurrencyRate = _data["localCurrencyRate"];
            this.euroCurrencyRate = _data["euroCurrencyRate"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : undefined as any;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["monthlyPriceINR"] = this.monthlyPriceINR;
        data["annualPriceINR"] = this.annualPriceINR;
        data["monthlyPriceEURO"] = this.monthlyPriceEURO;
        data["annualPriceEURO"] = this.annualPriceEURO;
        data["currency"] = this.currency;
        data["localCurrencyRate"] = this.localCurrencyRate;
        data["euroCurrencyRate"] = this.euroCurrencyRate;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : undefined as any;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    monthlyPriceINR: number | undefined;
    annualPriceINR: number | undefined;
    monthlyPriceEURO: number | undefined;
    annualPriceEURO: number | undefined;
    currency: string | undefined;
    localCurrencyRate: number;
    euroCurrencyRate: number;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;
    userCount!: number | undefined;
    inrCurrencyRate!: number;
    euroCurrencyRate!: number;
    maxUserCount!: number;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.userCount = _data["userCount"];
            this.inrCurrencyRate = _data["inrCurrencyRate"];
            this.euroCurrencyRate = _data["euroCurrencyRate"];
            this.maxUserCount = _data["maxUserCount"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        data["userCount"] = this.userCount;
        data["inrCurrencyRate"] = this.inrCurrencyRate;
        data["euroCurrencyRate"] = this.euroCurrencyRate;
        data["maxUserCount"] = this.maxUserCount;
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    userCount: number | undefined;
    inrCurrencyRate: number;
    euroCurrencyRate: number;
    maxUserCount: number;
}

export class EmailAddress implements IEmailAddress {
    name!: string | undefined;
    address!: string | undefined;

    constructor(data?: IEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): EmailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        return data;
    }
}

export interface IEmailAddress {
    name: string | undefined;
    address: string | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    outboundEmailEnabled!: boolean | undefined;
    graphTenantId!: string | undefined;
    graphClientId!: string | undefined;
    graphClientSecret!: string | undefined;
    graphSenderUserPrincipalName!: string | undefined;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.outboundEmailEnabled = _data["outboundEmailEnabled"];
            this.graphTenantId = _data["graphTenantId"];
            this.graphClientId = _data["graphClientId"];
            this.graphClientSecret = _data["graphClientSecret"];
            this.graphSenderUserPrincipalName = _data["graphSenderUserPrincipalName"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["outboundEmailEnabled"] = this.outboundEmailEnabled;
        data["graphTenantId"] = this.graphTenantId;
        data["graphClientId"] = this.graphClientId;
        data["graphClientSecret"] = this.graphClientSecret;
        data["graphSenderUserPrincipalName"] = this.graphSenderUserPrincipalName;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    outboundEmailEnabled: boolean | undefined;
    graphTenantId: string | undefined;
    graphClientId: string | undefined;
    graphClientSecret: string | undefined;
    graphSenderUserPrincipalName: string | undefined;
}

export class EmployeeDetailsList implements IEmployeeDetailsList {
    employeeEmailAddress!: string | undefined;
    employeeName!: string | undefined;
    employeeId!: string | undefined;
    expectedPayabledays!: number;
    workedDays_BusinessTrip_Coference!: number;
    paidLeaves!: number;
    unPaidLeaves!: number;
    holiday!: number;
    unknown!: number;
    totalPayableDay!: number;

    constructor(data?: IEmployeeDetailsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeEmailAddress = _data["employeeEmailAddress"];
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.expectedPayabledays = _data["expectedPayabledays"];
            this.workedDays_BusinessTrip_Coference = _data["workedDays_BusinessTrip_Coference"];
            this.paidLeaves = _data["paidLeaves"];
            this.unPaidLeaves = _data["unPaidLeaves"];
            this.holiday = _data["holiday"];
            this.unknown = _data["unknown"];
            this.totalPayableDay = _data["totalPayableDay"];
        }
    }

    static fromJS(data: any): EmployeeDetailsList {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeEmailAddress"] = this.employeeEmailAddress;
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["expectedPayabledays"] = this.expectedPayabledays;
        data["workedDays_BusinessTrip_Coference"] = this.workedDays_BusinessTrip_Coference;
        data["paidLeaves"] = this.paidLeaves;
        data["unPaidLeaves"] = this.unPaidLeaves;
        data["holiday"] = this.holiday;
        data["unknown"] = this.unknown;
        data["totalPayableDay"] = this.totalPayableDay;
        return data;
    }
}

export interface IEmployeeDetailsList {
    employeeEmailAddress: string | undefined;
    employeeName: string | undefined;
    employeeId: string | undefined;
    expectedPayabledays: number;
    workedDays_BusinessTrip_Coference: number;
    paidLeaves: number;
    unPaidLeaves: number;
    holiday: number;
    unknown: number;
    totalPayableDay: number;
}

export class EmployeeWiseSummaryDto implements IEmployeeWiseSummaryDto {
    userId!: number;
    projectId!: number;
    employeeName!: string | undefined;
    emailAddress!: string | undefined;
    projectName!: string | undefined;
    timesheetDate!: string | undefined;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    employeeWiseTaskDetailList!: EmployeeWiseTaskDetailsDto[] | undefined;

    constructor(data?: IEmployeeWiseSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.employeeName = _data["employeeName"];
            this.emailAddress = _data["emailAddress"];
            this.projectName = _data["projectName"];
            this.timesheetDate = _data["timesheetDate"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            if (Array.isArray(_data["employeeWiseTaskDetailList"])) {
                this.employeeWiseTaskDetailList = [] as any;
                for (let item of _data["employeeWiseTaskDetailList"])
                    this.employeeWiseTaskDetailList!.push(EmployeeWiseTaskDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeWiseSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeWiseSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["employeeName"] = this.employeeName;
        data["emailAddress"] = this.emailAddress;
        data["projectName"] = this.projectName;
        data["timesheetDate"] = this.timesheetDate;
        data["timesheetFrequency"] = this.timesheetFrequency;
        if (Array.isArray(this.employeeWiseTaskDetailList)) {
            data["employeeWiseTaskDetailList"] = [];
            for (let item of this.employeeWiseTaskDetailList)
                data["employeeWiseTaskDetailList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmployeeWiseSummaryDto {
    userId: number;
    projectId: number;
    employeeName: string | undefined;
    emailAddress: string | undefined;
    projectName: string | undefined;
    timesheetDate: string | undefined;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    employeeWiseTaskDetailList: EmployeeWiseTaskDetailsDto[] | undefined;
}

export class EmployeeWiseTaskDetailsDto implements IEmployeeWiseTaskDetailsDto {
    userId!: number;
    projectId!: number;
    timesheetDate!: string | undefined;
    taskName!: string | undefined;
    estimatedHours!: number | undefined;
    trackedHours!: number;
    taskBillability!: number | undefined;
    filterDate!: DateTime;
    status!: string | undefined;
    timesheetStatus!: string | undefined;

    constructor(data?: IEmployeeWiseTaskDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.timesheetDate = _data["timesheetDate"];
            this.taskName = _data["taskName"];
            this.estimatedHours = _data["estimatedHours"];
            this.trackedHours = _data["trackedHours"];
            this.taskBillability = _data["taskBillability"];
            this.filterDate = _data["filterDate"] ? DateTime.fromISO(_data["filterDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.timesheetStatus = _data["timesheetStatus"];
        }
    }

    static fromJS(data: any): EmployeeWiseTaskDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeWiseTaskDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["timesheetDate"] = this.timesheetDate;
        data["taskName"] = this.taskName;
        data["estimatedHours"] = this.estimatedHours;
        data["trackedHours"] = this.trackedHours;
        data["taskBillability"] = this.taskBillability;
        data["filterDate"] = this.filterDate ? this.filterDate.toString() : undefined as any;
        data["status"] = this.status;
        data["timesheetStatus"] = this.timesheetStatus;
        return data;
    }
}

export interface IEmployeeWiseTaskDetailsDto {
    userId: number;
    projectId: number;
    timesheetDate: string | undefined;
    taskName: string | undefined;
    estimatedHours: number | undefined;
    trackedHours: number;
    taskBillability: number | undefined;
    filterDate: DateTime;
    status: string | undefined;
    timesheetStatus: string | undefined;
}

export class End implements IEnd {
    dateTime!: DateTime;
    timeZone!: string | undefined;

    constructor(data?: IEnd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): End {
        data = typeof data === 'object' ? data : {};
        let result = new End();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : undefined as any;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IEnd {
    dateTime: DateTime;
    timeZone: string | undefined;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : undefined as any;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (this as any).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : undefined as any;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class EventBody implements IEventBody {
    content!: string | undefined;
    contentType!: string | undefined;

    constructor(data?: IEventBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): EventBody {
        data = typeof data === 'object' ? data : {};
        let result = new EventBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IEventBody {
    content: string | undefined;
    contentType: string | undefined;
}

export class EventDateTimeTimeZone implements IEventDateTimeTimeZone {
    dateTime!: string | undefined;
    timeZone!: string | undefined;

    constructor(data?: IEventDateTimeTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): EventDateTimeTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new EventDateTimeTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IEventDateTimeTimeZone {
    dateTime: string | undefined;
    timeZone: string | undefined;
}

export class EventLocation implements IEventLocation {
    displayName!: string | undefined;

    constructor(data?: IEventLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EventLocation {
        data = typeof data === 'object' ? data : {};
        let result = new EventLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEventLocation {
    displayName: string | undefined;
}

export class EventPatternedRecurrence implements IEventPatternedRecurrence {
    pattern!: EventRecurrencePattern;
    range!: EventRecurrenceRange;

    constructor(data?: IEventPatternedRecurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"] ? EventRecurrencePattern.fromJS(_data["pattern"]) : undefined as any;
            this.range = _data["range"] ? EventRecurrenceRange.fromJS(_data["range"]) : undefined as any;
        }
    }

    static fromJS(data: any): EventPatternedRecurrence {
        data = typeof data === 'object' ? data : {};
        let result = new EventPatternedRecurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern ? this.pattern.toJSON() : undefined as any;
        data["range"] = this.range ? this.range.toJSON() : undefined as any;
        return data;
    }
}

export interface IEventPatternedRecurrence {
    pattern: EventRecurrencePattern;
    range: EventRecurrenceRange;
}

export class EventRecurrencePattern implements IEventRecurrencePattern {
    dayOfMonth!: number | undefined;
    daysOfWeek!: DayOfWeekObject[] | undefined;
    firstDayOfWeek!: DayOfWeekObject;
    index!: WeekIndex;
    interval!: number | undefined;
    month!: number | undefined;
    type!: RecurrencePatternType;

    constructor(data?: IEventRecurrencePattern) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfMonth = _data["dayOfMonth"];
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.index = _data["index"];
            this.interval = _data["interval"];
            this.month = _data["month"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EventRecurrencePattern {
        data = typeof data === 'object' ? data : {};
        let result = new EventRecurrencePattern();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfMonth"] = this.dayOfMonth;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["index"] = this.index;
        data["interval"] = this.interval;
        data["month"] = this.month;
        data["type"] = this.type;
        return data;
    }
}

export interface IEventRecurrencePattern {
    dayOfMonth: number | undefined;
    daysOfWeek: DayOfWeekObject[] | undefined;
    firstDayOfWeek: DayOfWeekObject;
    index: WeekIndex;
    interval: number | undefined;
    month: number | undefined;
    type: RecurrencePatternType;
}

export class EventRecurrenceRange implements IEventRecurrenceRange {
    endDate!: string | undefined;
    numberOfOccurrences!: number | undefined;
    recurrenceTimeZone!: string | undefined;
    startDate!: string | undefined;
    type!: RecurrenceRangeType;

    constructor(data?: IEventRecurrenceRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endDate = _data["endDate"];
            this.numberOfOccurrences = _data["numberOfOccurrences"];
            this.recurrenceTimeZone = _data["recurrenceTimeZone"];
            this.startDate = _data["startDate"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EventRecurrenceRange {
        data = typeof data === 'object' ? data : {};
        let result = new EventRecurrenceRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate;
        data["numberOfOccurrences"] = this.numberOfOccurrences;
        data["recurrenceTimeZone"] = this.recurrenceTimeZone;
        data["startDate"] = this.startDate;
        data["type"] = this.type;
        return data;
    }
}

export interface IEventRecurrenceRange {
    endDate: string | undefined;
    numberOfOccurrences: number | undefined;
    recurrenceTimeZone: string | undefined;
    startDate: string | undefined;
    type: RecurrenceRangeType;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    accessToken!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;
    identityProviderName!: string | undefined;
    isSignUp!: boolean;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.accessToken = _data["accessToken"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.identityProviderName = _data["identityProviderName"];
            this.isSignUp = _data["isSignUp"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["accessToken"] = this.accessToken;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["identityProviderName"] = this.identityProviderName;
        data["isSignUp"] = this.isSignUp;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    accessToken: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
    identityProviderName: string | undefined;
    isSignUp: boolean;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    errorMessage!: string | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    errorMessage: string | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;
    isSignUp!: boolean;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (this.additionalParams as any)![key] = _data["additionalParams"][key];
                }
            }
            this.isSignUp = _data["isSignUp"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (data["additionalParams"] as any)[key] = (this.additionalParams as any)[key];
            }
        }
        data["isSignUp"] = this.isSignUp;
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
    isSignUp: boolean;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : undefined as any;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : undefined as any;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : undefined as any;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : undefined as any;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : undefined as any;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : undefined as any;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : undefined as any;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : undefined as any;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : undefined as any;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : undefined as any;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : undefined as any;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item ? item.toJSON() : undefined as any);
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : undefined as any;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (this.attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : undefined as any;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : undefined as any;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined as any;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : undefined as any;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export enum FeeValueTypes {
    Percentage = 1,
    FlatFee = 2,
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class FilerMeberDataDto implements IFilerMeberDataDto {
    profileImage!: string | undefined;
    fullName!: string | undefined;
    roleNames!: string[] | undefined;
    emailAddress!: string | undefined;
    name!: string | undefined;
    id!: number;

    constructor(data?: IFilerMeberDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileImage = _data["profileImage"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FilerMeberDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilerMeberDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileImage"] = this.profileImage;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IFilerMeberDataDto {
    profileImage: string | undefined;
    fullName: string | undefined;
    roleNames: string[] | undefined;
    emailAddress: string | undefined;
    name: string | undefined;
    id: number;
}

export class FillAllUsersInDropDownDto implements IFillAllUsersInDropDownDto {
    userId!: number;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profileImage!: string | undefined;
    userRoles!: string[] | undefined;

    constructor(data?: IFillAllUsersInDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profileImage = _data["profileImage"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): FillAllUsersInDropDownDto {
        data = typeof data === 'object' ? data : {};
        let result = new FillAllUsersInDropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profileImage"] = this.profileImage;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        return data;
    }
}

export interface IFillAllUsersInDropDownDto {
    userId: number;
    userName: string | undefined;
    emailAddress: string | undefined;
    profileImage: string | undefined;
    userRoles: string[] | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : undefined as any;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : undefined as any;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlutterNotificationsDto implements IFlutterNotificationsDto {
    unreadCOunt!: number;
    totalcount!: number;
    flutterNotificationsMsgDtos!: FlutterNotificationsMsgDto[] | undefined;

    constructor(data?: IFlutterNotificationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCOunt = _data["unreadCOunt"];
            this.totalcount = _data["totalcount"];
            if (Array.isArray(_data["flutterNotificationsMsgDtos"])) {
                this.flutterNotificationsMsgDtos = [] as any;
                for (let item of _data["flutterNotificationsMsgDtos"])
                    this.flutterNotificationsMsgDtos!.push(FlutterNotificationsMsgDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlutterNotificationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlutterNotificationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCOunt"] = this.unreadCOunt;
        data["totalcount"] = this.totalcount;
        if (Array.isArray(this.flutterNotificationsMsgDtos)) {
            data["flutterNotificationsMsgDtos"] = [];
            for (let item of this.flutterNotificationsMsgDtos)
                data["flutterNotificationsMsgDtos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFlutterNotificationsDto {
    unreadCOunt: number;
    totalcount: number;
    flutterNotificationsMsgDtos: FlutterNotificationsMsgDto[] | undefined;
}

export class FlutterNotificationsInputDto implements IFlutterNotificationsInputDto {
    userId!: number;
    tenantId!: number;
    take!: number;
    skip!: number;

    constructor(data?: IFlutterNotificationsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.take = _data["take"];
            this.skip = _data["skip"];
        }
    }

    static fromJS(data: any): FlutterNotificationsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlutterNotificationsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["take"] = this.take;
        data["skip"] = this.skip;
        return data;
    }
}

export interface IFlutterNotificationsInputDto {
    userId: number;
    tenantId: number;
    take: number;
    skip: number;
}

export class FlutterNotificationsMsgDto implements IFlutterNotificationsMsgDto {
    message!: string | undefined;
    id!: string;
    creationTime!: DateTime;
    state!: UserNotificationState;

    constructor(data?: IFlutterNotificationsMsgDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FlutterNotificationsMsgDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlutterNotificationsMsgDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["state"] = this.state;
        return data;
    }
}

export interface IFlutterNotificationsMsgDto {
    message: string | undefined;
    id: string;
    creationTime: DateTime;
    state: UserNotificationState;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class GetAllAvailableWebhooksOutput implements IGetAllAvailableWebhooksOutput {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetAllAvailableWebhooksOutput {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetAllCurrentProjectDto implements IGetAllCurrentProjectDto {
    id!: number;
    name!: string | undefined;
    teamProfileImage!: UserDetailsDto[] | undefined;
    tenantId!: number;
    projectImage!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    userId!: number | undefined;
    isDeleted!: boolean;
    projectType!: number;
    projectBillingType!: ProjectBillingType;
    assignedProgramManager!: number;
    assignedProjectManager!: UserDetailsDto[] | undefined;
    hourlyBudget!: number;

    constructor(data?: IGetAllCurrentProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["teamProfileImage"])) {
                this.teamProfileImage = [] as any;
                for (let item of _data["teamProfileImage"])
                    this.teamProfileImage!.push(UserDetailsDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.projectImage = _data["projectImage"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.isDeleted = _data["isDeleted"];
            this.projectType = _data["projectType"];
            this.projectBillingType = _data["projectBillingType"];
            this.assignedProgramManager = _data["assignedProgramManager"];
            if (Array.isArray(_data["assignedProjectManager"])) {
                this.assignedProjectManager = [] as any;
                for (let item of _data["assignedProjectManager"])
                    this.assignedProjectManager!.push(UserDetailsDto.fromJS(item));
            }
            this.hourlyBudget = _data["hourlyBudget"];
        }
    }

    static fromJS(data: any): GetAllCurrentProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCurrentProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.teamProfileImage)) {
            data["teamProfileImage"] = [];
            for (let item of this.teamProfileImage)
                data["teamProfileImage"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantId"] = this.tenantId;
        data["projectImage"] = this.projectImage;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["isDeleted"] = this.isDeleted;
        data["projectType"] = this.projectType;
        data["projectBillingType"] = this.projectBillingType;
        data["assignedProgramManager"] = this.assignedProgramManager;
        if (Array.isArray(this.assignedProjectManager)) {
            data["assignedProjectManager"] = [];
            for (let item of this.assignedProjectManager)
                data["assignedProjectManager"].push(item ? item.toJSON() : undefined as any);
        }
        data["hourlyBudget"] = this.hourlyBudget;
        return data;
    }
}

export interface IGetAllCurrentProjectDto {
    id: number;
    name: string | undefined;
    teamProfileImage: UserDetailsDto[] | undefined;
    tenantId: number;
    projectImage: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    userId: number | undefined;
    isDeleted: boolean;
    projectType: number;
    projectBillingType: ProjectBillingType;
    assignedProgramManager: number;
    assignedProjectManager: UserDetailsDto[] | undefined;
    hourlyBudget: number;
}

export class GetAllDynamicEntityPropertyValuesOutput implements IGetAllDynamicEntityPropertyValuesOutput {
    items!: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllDynamicEntityPropertyValuesOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutput {
    items: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutputItem implements IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId!: number;
    propertyName!: string | undefined;
    inputType!: IInputType;
    selectedValues!: string[] | undefined;
    allValuesInputTypeHas!: string[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.propertyName = _data["propertyName"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : undefined as any;
            if (Array.isArray(_data["selectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["selectedValues"])
                    this.selectedValues!.push(item);
            }
            if (Array.isArray(_data["allValuesInputTypeHas"])) {
                this.allValuesInputTypeHas = [] as any;
                for (let item of _data["allValuesInputTypeHas"])
                    this.allValuesInputTypeHas!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["propertyName"] = this.propertyName;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        if (Array.isArray(this.selectedValues)) {
            data["selectedValues"] = [];
            for (let item of this.selectedValues)
                data["selectedValues"].push(item);
        }
        if (Array.isArray(this.allValuesInputTypeHas)) {
            data["allValuesInputTypeHas"] = [];
            for (let item of this.allValuesInputTypeHas)
                data["allValuesInputTypeHas"].push(item);
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId: number;
    propertyName: string | undefined;
    inputType: IInputType;
    selectedValues: string[] | undefined;
    allValuesInputTypeHas: string[] | undefined;
}

export class GetAllEntitiesHasDynamicPropertyOutput implements IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName!: string | undefined;

    constructor(data?: IGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
        }
    }

    static fromJS(data: any): GetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        return data;
    }
}

export interface IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName: string | undefined;
}

export class GetAllProjectDetailsDto implements IGetAllProjectDetailsDto {
    id!: number | undefined;
    name!: string | undefined;
    isActive!: string | undefined;
    lastModificationTime!: string | undefined;
    isDelete!: string | undefined;
    modifiedUserName!: string | undefined;
    teamProfileImage!: TeamProfileImageDto[] | undefined;
    clientId!: number;
    trackedHour!: string;
    tenantId!: number;
    projectImage!: string | undefined;
    tags!: string | undefined;
    description!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    userId!: number | undefined;
    isDeleted!: boolean;
    projectType!: number;
    projectStatus!: ProjectStatus;
    projectBillingType!: ProjectBillingType;
    assignedProgramManager!: number;
    billedHours!: string;
    projectManagers!: string | undefined;
    toatalTask!: number;

    constructor(data?: IGetAllProjectDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.isDelete = _data["isDelete"];
            this.modifiedUserName = _data["modifiedUserName"];
            if (Array.isArray(_data["teamProfileImage"])) {
                this.teamProfileImage = [] as any;
                for (let item of _data["teamProfileImage"])
                    this.teamProfileImage!.push(TeamProfileImageDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
            this.trackedHour = _data["trackedHour"];
            this.tenantId = _data["tenantId"];
            this.projectImage = _data["projectImage"];
            this.tags = _data["tags"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.isDeleted = _data["isDeleted"];
            this.projectType = _data["projectType"];
            this.projectStatus = _data["projectStatus"];
            this.projectBillingType = _data["projectBillingType"];
            this.assignedProgramManager = _data["assignedProgramManager"];
            this.billedHours = _data["billedHours"];
            this.projectManagers = _data["projectManagers"];
            this.toatalTask = _data["toatalTask"];
        }
    }

    static fromJS(data: any): GetAllProjectDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProjectDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime;
        data["isDelete"] = this.isDelete;
        data["modifiedUserName"] = this.modifiedUserName;
        if (Array.isArray(this.teamProfileImage)) {
            data["teamProfileImage"] = [];
            for (let item of this.teamProfileImage)
                data["teamProfileImage"].push(item ? item.toJSON() : undefined as any);
        }
        data["clientId"] = this.clientId;
        data["trackedHour"] = this.trackedHour;
        data["tenantId"] = this.tenantId;
        data["projectImage"] = this.projectImage;
        data["tags"] = this.tags;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["isDeleted"] = this.isDeleted;
        data["projectType"] = this.projectType;
        data["projectStatus"] = this.projectStatus;
        data["projectBillingType"] = this.projectBillingType;
        data["assignedProgramManager"] = this.assignedProgramManager;
        data["billedHours"] = this.billedHours;
        data["projectManagers"] = this.projectManagers;
        data["toatalTask"] = this.toatalTask;
        return data;
    }
}

export interface IGetAllProjectDetailsDto {
    id: number | undefined;
    name: string | undefined;
    isActive: string | undefined;
    lastModificationTime: string | undefined;
    isDelete: string | undefined;
    modifiedUserName: string | undefined;
    teamProfileImage: TeamProfileImageDto[] | undefined;
    clientId: number;
    trackedHour: string;
    tenantId: number;
    projectImage: string | undefined;
    tags: string | undefined;
    description: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    userId: number | undefined;
    isDeleted: boolean;
    projectType: number;
    projectStatus: ProjectStatus;
    projectBillingType: ProjectBillingType;
    assignedProgramManager: number;
    billedHours: string;
    projectManagers: string | undefined;
    toatalTask: number;
}

export class GetAllProjectDto implements IGetAllProjectDto {
    id!: number | undefined;
    name!: string | undefined;
    isActive!: string | undefined;
    lastModificationTime!: string | undefined;
    isDelete!: string | undefined;
    clientName!: string | undefined;
    modifiedUserName!: string | undefined;
    clientPhoneNumber!: string | undefined;
    teamProfileImage!: TeamProfileImageDto[] | undefined;
    clientId!: number;
    trackedHour!: string;
    tenantProductService!: TenantProductServiceDto[] | undefined;
    tenantId!: number;
    projectImage!: string | undefined;
    tags!: string | undefined;
    description!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    userId!: number | undefined;
    isDeleted!: boolean;
    projectType!: number;
    projectStatus!: ProjectStatus;
    projectBillingType!: ProjectBillingType;
    assignedProgramManager!: number;
    billedHours!: string;
    clientContact!: string | undefined;
    projectManagers!: string | undefined;

    constructor(data?: IGetAllProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.isDelete = _data["isDelete"];
            this.clientName = _data["clientName"];
            this.modifiedUserName = _data["modifiedUserName"];
            this.clientPhoneNumber = _data["clientPhoneNumber"];
            if (Array.isArray(_data["teamProfileImage"])) {
                this.teamProfileImage = [] as any;
                for (let item of _data["teamProfileImage"])
                    this.teamProfileImage!.push(TeamProfileImageDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
            this.trackedHour = _data["trackedHour"];
            if (Array.isArray(_data["tenantProductService"])) {
                this.tenantProductService = [] as any;
                for (let item of _data["tenantProductService"])
                    this.tenantProductService!.push(TenantProductServiceDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.projectImage = _data["projectImage"];
            this.tags = _data["tags"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.isDeleted = _data["isDeleted"];
            this.projectType = _data["projectType"];
            this.projectStatus = _data["projectStatus"];
            this.projectBillingType = _data["projectBillingType"];
            this.assignedProgramManager = _data["assignedProgramManager"];
            this.billedHours = _data["billedHours"];
            this.clientContact = _data["clientContact"];
            this.projectManagers = _data["projectManagers"];
        }
    }

    static fromJS(data: any): GetAllProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime;
        data["isDelete"] = this.isDelete;
        data["clientName"] = this.clientName;
        data["modifiedUserName"] = this.modifiedUserName;
        data["clientPhoneNumber"] = this.clientPhoneNumber;
        if (Array.isArray(this.teamProfileImage)) {
            data["teamProfileImage"] = [];
            for (let item of this.teamProfileImage)
                data["teamProfileImage"].push(item ? item.toJSON() : undefined as any);
        }
        data["clientId"] = this.clientId;
        data["trackedHour"] = this.trackedHour;
        if (Array.isArray(this.tenantProductService)) {
            data["tenantProductService"] = [];
            for (let item of this.tenantProductService)
                data["tenantProductService"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantId"] = this.tenantId;
        data["projectImage"] = this.projectImage;
        data["tags"] = this.tags;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["isDeleted"] = this.isDeleted;
        data["projectType"] = this.projectType;
        data["projectStatus"] = this.projectStatus;
        data["projectBillingType"] = this.projectBillingType;
        data["assignedProgramManager"] = this.assignedProgramManager;
        data["billedHours"] = this.billedHours;
        data["clientContact"] = this.clientContact;
        data["projectManagers"] = this.projectManagers;
        return data;
    }
}

export interface IGetAllProjectDto {
    id: number | undefined;
    name: string | undefined;
    isActive: string | undefined;
    lastModificationTime: string | undefined;
    isDelete: string | undefined;
    clientName: string | undefined;
    modifiedUserName: string | undefined;
    clientPhoneNumber: string | undefined;
    teamProfileImage: TeamProfileImageDto[] | undefined;
    clientId: number;
    trackedHour: string;
    tenantProductService: TenantProductServiceDto[] | undefined;
    tenantId: number;
    projectImage: string | undefined;
    tags: string | undefined;
    description: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    userId: number | undefined;
    isDeleted: boolean;
    projectType: number;
    projectStatus: ProjectStatus;
    projectBillingType: ProjectBillingType;
    assignedProgramManager: number;
    billedHours: string;
    clientContact: string | undefined;
    projectManagers: string | undefined;
}

export class GetAllProjectForListViewDto implements IGetAllProjectForListViewDto {
    tenantId!: number;
    id!: number | undefined;
    name!: string | undefined;
    isActive!: string | undefined;
    lastModificationTime!: string | undefined;
    isDelete!: string | undefined;
    clientId!: number;
    clientName!: string | undefined;
    projectImage!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    isDeleted!: boolean;
    projectType!: number;
    assignedProgramManager!: number;
    assignedProgramManagerName!: string | undefined;
    billedHours!: string;
    projectStatus!: ProjectStatus;
    description!: string | undefined;
    projectBillingType!: ProjectBillingType;
    clientContact!: string | undefined;
    projectManagers!: string | undefined;
    billedType!: string | undefined;

    constructor(data?: IGetAllProjectForListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.isDelete = _data["isDelete"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.projectImage = _data["projectImage"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.projectType = _data["projectType"];
            this.assignedProgramManager = _data["assignedProgramManager"];
            this.assignedProgramManagerName = _data["assignedProgramManagerName"];
            this.billedHours = _data["billedHours"];
            this.projectStatus = _data["projectStatus"];
            this.description = _data["description"];
            this.projectBillingType = _data["projectBillingType"];
            this.clientContact = _data["clientContact"];
            this.projectManagers = _data["projectManagers"];
            this.billedType = _data["billedType"];
        }
    }

    static fromJS(data: any): GetAllProjectForListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProjectForListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime;
        data["isDelete"] = this.isDelete;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["projectImage"] = this.projectImage;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["projectType"] = this.projectType;
        data["assignedProgramManager"] = this.assignedProgramManager;
        data["assignedProgramManagerName"] = this.assignedProgramManagerName;
        data["billedHours"] = this.billedHours;
        data["projectStatus"] = this.projectStatus;
        data["description"] = this.description;
        data["projectBillingType"] = this.projectBillingType;
        data["clientContact"] = this.clientContact;
        data["projectManagers"] = this.projectManagers;
        data["billedType"] = this.billedType;
        return data;
    }
}

export interface IGetAllProjectForListViewDto {
    tenantId: number;
    id: number | undefined;
    name: string | undefined;
    isActive: string | undefined;
    lastModificationTime: string | undefined;
    isDelete: string | undefined;
    clientId: number;
    clientName: string | undefined;
    projectImage: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    isDeleted: boolean;
    projectType: number;
    assignedProgramManager: number;
    assignedProgramManagerName: string | undefined;
    billedHours: string;
    projectStatus: ProjectStatus;
    description: string | undefined;
    projectBillingType: ProjectBillingType;
    clientContact: string | undefined;
    projectManagers: string | undefined;
    billedType: string | undefined;
}

export class GetAllProjectTimeSheetDto implements IGetAllProjectTimeSheetDto {
    projectId!: number;
    projectImage!: string | undefined;
    projectName!: string | undefined;
    billableType!: ProjectBillingType;
    daysListDtos!: DaysListDto[] | undefined;
    totalTime!: string;
    perdayTotalTime!: string;
    projectCreationDate!: DateTime | undefined;
    projectStartDate!: DateTime;
    projectEndDate!: DateTime | undefined;
    taskHistoryDate!: DateTime[] | undefined;
    projectCurrentStatus!: ProjectStatus;
    userRole!: string | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    projectIsArchived!: boolean;
    projectIsActive!: boolean;
    timesheetSubmissionFrequency!: ProjectTimesheetFrequencyEnum;
    holidayslist!: Holidays[] | undefined;
    leaveDayslist!: LeaveDays[] | undefined;
    id!: number;

    constructor(data?: IGetAllProjectTimeSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectImage = _data["projectImage"];
            this.projectName = _data["projectName"];
            this.billableType = _data["billableType"];
            if (Array.isArray(_data["daysListDtos"])) {
                this.daysListDtos = [] as any;
                for (let item of _data["daysListDtos"])
                    this.daysListDtos!.push(DaysListDto.fromJS(item));
            }
            this.totalTime = _data["totalTime"];
            this.perdayTotalTime = _data["perdayTotalTime"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectStartDate = _data["projectStartDate"] ? DateTime.fromISO(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.userRole = _data["userRole"];
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.projectIsArchived = _data["projectIsArchived"];
            this.projectIsActive = _data["projectIsActive"];
            this.timesheetSubmissionFrequency = _data["timesheetSubmissionFrequency"];
            if (Array.isArray(_data["holidayslist"])) {
                this.holidayslist = [] as any;
                for (let item of _data["holidayslist"])
                    this.holidayslist!.push(Holidays.fromJS(item));
            }
            if (Array.isArray(_data["leaveDayslist"])) {
                this.leaveDayslist = [] as any;
                for (let item of _data["leaveDayslist"])
                    this.leaveDayslist!.push(LeaveDays.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllProjectTimeSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProjectTimeSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectImage"] = this.projectImage;
        data["projectName"] = this.projectName;
        data["billableType"] = this.billableType;
        if (Array.isArray(this.daysListDtos)) {
            data["daysListDtos"] = [];
            for (let item of this.daysListDtos)
                data["daysListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalTime"] = this.totalTime;
        data["perdayTotalTime"] = this.perdayTotalTime;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["userRole"] = this.userRole;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["projectIsArchived"] = this.projectIsArchived;
        data["projectIsActive"] = this.projectIsActive;
        data["timesheetSubmissionFrequency"] = this.timesheetSubmissionFrequency;
        if (Array.isArray(this.holidayslist)) {
            data["holidayslist"] = [];
            for (let item of this.holidayslist)
                data["holidayslist"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.leaveDayslist)) {
            data["leaveDayslist"] = [];
            for (let item of this.leaveDayslist)
                data["leaveDayslist"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllProjectTimeSheetDto {
    projectId: number;
    projectImage: string | undefined;
    projectName: string | undefined;
    billableType: ProjectBillingType;
    daysListDtos: DaysListDto[] | undefined;
    totalTime: string;
    perdayTotalTime: string;
    projectCreationDate: DateTime | undefined;
    projectStartDate: DateTime;
    projectEndDate: DateTime | undefined;
    taskHistoryDate: DateTime[] | undefined;
    projectCurrentStatus: ProjectStatus;
    userRole: string | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    projectIsArchived: boolean;
    projectIsActive: boolean;
    timesheetSubmissionFrequency: ProjectTimesheetFrequencyEnum;
    holidayslist: Holidays[] | undefined;
    leaveDayslist: LeaveDays[] | undefined;
    id: number;
}

export class GetAllSendAttemptsOfWebhookEventOutput implements IGetAllSendAttemptsOfWebhookEventOutput {
    id!: string;
    webhookUri!: string | undefined;
    webhookSubscriptionId!: string;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: IGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookUri = _data["webhookUri"];
            this.webhookSubscriptionId = _data["webhookSubscriptionId"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookUri"] = this.webhookUri;
        data["webhookSubscriptionId"] = this.webhookSubscriptionId;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        return data;
    }
}

export interface IGetAllSendAttemptsOfWebhookEventOutput {
    id: string;
    webhookUri: string | undefined;
    webhookSubscriptionId: string;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
}

export class GetAllSendAttemptsOutput implements IGetAllSendAttemptsOutput {
    id!: string;
    webhookEventId!: string;
    webhookName!: string | undefined;
    data!: string | undefined;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: DateTime;

    constructor(data?: IGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookEventId = _data["webhookEventId"];
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookEventId"] = this.webhookEventId;
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IGetAllSendAttemptsOutput {
    id: string;
    webhookEventId: string;
    webhookName: string | undefined;
    data: string | undefined;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: DateTime;
}

export class GetAllSubscriptionsOutput implements IGetAllSubscriptionsOutput {
    webhookUri!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    id!: string;

    constructor(data?: IGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webhookUri = _data["webhookUri"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookUri"] = this.webhookUri;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllSubscriptionsOutput {
    webhookUri: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    id: string;
}

export class GetAllTaskDto implements IGetAllTaskDto {
    taskName!: string | undefined;
    totalTime!: string;
    creationDay!: DateTime | undefined;
    daysListDtos!: DaysListDto[] | undefined;
    userTaskId!: number;
    taskHistoryDate!: DateTime[] | undefined;
    totalTaskTrackedTime!: string;
    taskStatus!: number | undefined;
    isManualTimeSheet!: boolean;
    taskDescription!: string | undefined;
    projectCreationDate!: DateTime | undefined;
    taskIdList!: number[] | undefined;
    fromDate!: DateTime[] | undefined;
    toDate!: DateTime[] | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    approvalName!: string | undefined;
    includeInTimesheet!: boolean;
    billabilityStatus!: number | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    holidayslist!: Holidays[] | undefined;
    leaveDayslist!: LeaveDays[] | undefined;
    isTaskDelete!: boolean;
    id!: number;

    constructor(data?: IGetAllTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.totalTime = _data["totalTime"];
            this.creationDay = _data["creationDay"] ? DateTime.fromISO(_data["creationDay"].toString()) : undefined as any;
            if (Array.isArray(_data["daysListDtos"])) {
                this.daysListDtos = [] as any;
                for (let item of _data["daysListDtos"])
                    this.daysListDtos!.push(DaysListDto.fromJS(item));
            }
            this.userTaskId = _data["userTaskId"];
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            this.totalTaskTrackedTime = _data["totalTaskTrackedTime"];
            this.taskStatus = _data["taskStatus"];
            this.isManualTimeSheet = _data["isManualTimeSheet"];
            this.taskDescription = _data["taskDescription"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taskIdList"])) {
                this.taskIdList = [] as any;
                for (let item of _data["taskIdList"])
                    this.taskIdList!.push(item);
            }
            if (Array.isArray(_data["fromDate"])) {
                this.fromDate = [] as any;
                for (let item of _data["fromDate"])
                    this.fromDate!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["toDate"])) {
                this.toDate = [] as any;
                for (let item of _data["toDate"])
                    this.toDate!.push(DateTime.fromISO(item));
            }
            this.timesheetStatus = _data["timesheetStatus"];
            this.approvalName = _data["approvalName"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["holidayslist"])) {
                this.holidayslist = [] as any;
                for (let item of _data["holidayslist"])
                    this.holidayslist!.push(Holidays.fromJS(item));
            }
            if (Array.isArray(_data["leaveDayslist"])) {
                this.leaveDayslist = [] as any;
                for (let item of _data["leaveDayslist"])
                    this.leaveDayslist!.push(LeaveDays.fromJS(item));
            }
            this.isTaskDelete = _data["isTaskDelete"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["totalTime"] = this.totalTime;
        data["creationDay"] = this.creationDay ? this.creationDay.toString() : undefined as any;
        if (Array.isArray(this.daysListDtos)) {
            data["daysListDtos"] = [];
            for (let item of this.daysListDtos)
                data["daysListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["userTaskId"] = this.userTaskId;
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        data["totalTaskTrackedTime"] = this.totalTaskTrackedTime;
        data["taskStatus"] = this.taskStatus;
        data["isManualTimeSheet"] = this.isManualTimeSheet;
        data["taskDescription"] = this.taskDescription;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        if (Array.isArray(this.taskIdList)) {
            data["taskIdList"] = [];
            for (let item of this.taskIdList)
                data["taskIdList"].push(item);
        }
        if (Array.isArray(this.fromDate)) {
            data["fromDate"] = [];
            for (let item of this.fromDate)
                data["fromDate"].push(item.toString());
        }
        if (Array.isArray(this.toDate)) {
            data["toDate"] = [];
            for (let item of this.toDate)
                data["toDate"].push(item.toString());
        }
        data["timesheetStatus"] = this.timesheetStatus;
        data["approvalName"] = this.approvalName;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["billabilityStatus"] = this.billabilityStatus;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        if (Array.isArray(this.holidayslist)) {
            data["holidayslist"] = [];
            for (let item of this.holidayslist)
                data["holidayslist"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.leaveDayslist)) {
            data["leaveDayslist"] = [];
            for (let item of this.leaveDayslist)
                data["leaveDayslist"].push(item ? item.toJSON() : undefined as any);
        }
        data["isTaskDelete"] = this.isTaskDelete;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllTaskDto {
    taskName: string | undefined;
    totalTime: string;
    creationDay: DateTime | undefined;
    daysListDtos: DaysListDto[] | undefined;
    userTaskId: number;
    taskHistoryDate: DateTime[] | undefined;
    totalTaskTrackedTime: string;
    taskStatus: number | undefined;
    isManualTimeSheet: boolean;
    taskDescription: string | undefined;
    projectCreationDate: DateTime | undefined;
    taskIdList: number[] | undefined;
    fromDate: DateTime[] | undefined;
    toDate: DateTime[] | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    approvalName: string | undefined;
    includeInTimesheet: boolean;
    billabilityStatus: number | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    holidayslist: Holidays[] | undefined;
    leaveDayslist: LeaveDays[] | undefined;
    isTaskDelete: boolean;
    id: number;
}

export class GetAllTaskDtoForMoblie implements IGetAllTaskDtoForMoblie {
    taskName!: string | undefined;
    totalTime!: string;
    totalTimeInSec!: string | undefined;
    creationDay!: DateTime | undefined;
    daysListDtos!: DaysListDto[] | undefined;
    userTaskId!: number;
    taskHistoryDate!: DateTime[] | undefined;
    totalTaskTrackedTime!: string;
    taskStatus!: number | undefined;
    isManualTimeSheet!: boolean;
    taskDescription!: string | undefined;
    projectCreationDate!: DateTime | undefined;
    taskIdList!: number[] | undefined;
    fromDate!: DateTime[] | undefined;
    toDate!: DateTime[] | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    approvalName!: string | undefined;
    includeInTimesheet!: boolean;
    billabilityStatus!: number | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    id!: number;

    constructor(data?: IGetAllTaskDtoForMoblie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.totalTime = _data["totalTime"];
            this.totalTimeInSec = _data["totalTimeInSec"];
            this.creationDay = _data["creationDay"] ? DateTime.fromISO(_data["creationDay"].toString()) : undefined as any;
            if (Array.isArray(_data["daysListDtos"])) {
                this.daysListDtos = [] as any;
                for (let item of _data["daysListDtos"])
                    this.daysListDtos!.push(DaysListDto.fromJS(item));
            }
            this.userTaskId = _data["userTaskId"];
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            this.totalTaskTrackedTime = _data["totalTaskTrackedTime"];
            this.taskStatus = _data["taskStatus"];
            this.isManualTimeSheet = _data["isManualTimeSheet"];
            this.taskDescription = _data["taskDescription"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taskIdList"])) {
                this.taskIdList = [] as any;
                for (let item of _data["taskIdList"])
                    this.taskIdList!.push(item);
            }
            if (Array.isArray(_data["fromDate"])) {
                this.fromDate = [] as any;
                for (let item of _data["fromDate"])
                    this.fromDate!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["toDate"])) {
                this.toDate = [] as any;
                for (let item of _data["toDate"])
                    this.toDate!.push(DateTime.fromISO(item));
            }
            this.timesheetStatus = _data["timesheetStatus"];
            this.approvalName = _data["approvalName"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllTaskDtoForMoblie {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTaskDtoForMoblie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["totalTime"] = this.totalTime;
        data["totalTimeInSec"] = this.totalTimeInSec;
        data["creationDay"] = this.creationDay ? this.creationDay.toString() : undefined as any;
        if (Array.isArray(this.daysListDtos)) {
            data["daysListDtos"] = [];
            for (let item of this.daysListDtos)
                data["daysListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["userTaskId"] = this.userTaskId;
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        data["totalTaskTrackedTime"] = this.totalTaskTrackedTime;
        data["taskStatus"] = this.taskStatus;
        data["isManualTimeSheet"] = this.isManualTimeSheet;
        data["taskDescription"] = this.taskDescription;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        if (Array.isArray(this.taskIdList)) {
            data["taskIdList"] = [];
            for (let item of this.taskIdList)
                data["taskIdList"].push(item);
        }
        if (Array.isArray(this.fromDate)) {
            data["fromDate"] = [];
            for (let item of this.fromDate)
                data["fromDate"].push(item.toString());
        }
        if (Array.isArray(this.toDate)) {
            data["toDate"] = [];
            for (let item of this.toDate)
                data["toDate"].push(item.toString());
        }
        data["timesheetStatus"] = this.timesheetStatus;
        data["approvalName"] = this.approvalName;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["billabilityStatus"] = this.billabilityStatus;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllTaskDtoForMoblie {
    taskName: string | undefined;
    totalTime: string;
    totalTimeInSec: string | undefined;
    creationDay: DateTime | undefined;
    daysListDtos: DaysListDto[] | undefined;
    userTaskId: number;
    taskHistoryDate: DateTime[] | undefined;
    totalTaskTrackedTime: string;
    taskStatus: number | undefined;
    isManualTimeSheet: boolean;
    taskDescription: string | undefined;
    projectCreationDate: DateTime | undefined;
    taskIdList: number[] | undefined;
    fromDate: DateTime[] | undefined;
    toDate: DateTime[] | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    approvalName: string | undefined;
    includeInTimesheet: boolean;
    billabilityStatus: number | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    id: number;
}

export class GetAllTimeSheetsForMobileDto implements IGetAllTimeSheetsForMobileDto {
    timeSheetDtos!: TimeSheetDto[] | undefined;
    maxCount!: number;
    pendingCount!: number;
    id!: number;

    constructor(data?: IGetAllTimeSheetsForMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timeSheetDtos"])) {
                this.timeSheetDtos = [] as any;
                for (let item of _data["timeSheetDtos"])
                    this.timeSheetDtos!.push(TimeSheetDto.fromJS(item));
            }
            this.maxCount = _data["maxCount"];
            this.pendingCount = _data["pendingCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllTimeSheetsForMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTimeSheetsForMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeSheetDtos)) {
            data["timeSheetDtos"] = [];
            for (let item of this.timeSheetDtos)
                data["timeSheetDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxCount"] = this.maxCount;
        data["pendingCount"] = this.pendingCount;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllTimeSheetsForMobileDto {
    timeSheetDtos: TimeSheetDto[] | undefined;
    maxCount: number;
    pendingCount: number;
    id: number;
}

export class GetAllUserActivityDto implements IGetAllUserActivityDto {
    userActivityDetails!: UserActivityTempGetAllDto[] | undefined;
    totalCnt!: number;

    constructor(data?: IGetAllUserActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userActivityDetails"])) {
                this.userActivityDetails = [] as any;
                for (let item of _data["userActivityDetails"])
                    this.userActivityDetails!.push(UserActivityTempGetAllDto.fromJS(item));
            }
            this.totalCnt = _data["totalCnt"];
        }
    }

    static fromJS(data: any): GetAllUserActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userActivityDetails)) {
            data["userActivityDetails"] = [];
            for (let item of this.userActivityDetails)
                data["userActivityDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCnt"] = this.totalCnt;
        return data;
    }
}

export interface IGetAllUserActivityDto {
    userActivityDetails: UserActivityTempGetAllDto[] | undefined;
    totalCnt: number;
}

export class GetApplicationsDto implements IGetApplicationsDto {
    applicationName!: string | undefined;
    icon!: string | undefined;
    productivityTypes!: ProductivityTypes;
    userId!: number;
    projectId!: number | undefined;
    orgnizationUnitId!: number | undefined;
    tenantId!: number;
    applicationSpendTime!: string | undefined;
    applicationCategoryId!: number;
    id!: number | undefined;

    constructor(data?: IGetApplicationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.icon = _data["icon"];
            this.productivityTypes = _data["productivityTypes"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.orgnizationUnitId = _data["orgnizationUnitId"];
            this.tenantId = _data["tenantId"];
            this.applicationSpendTime = _data["applicationSpendTime"];
            this.applicationCategoryId = _data["applicationCategoryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetApplicationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["icon"] = this.icon;
        data["productivityTypes"] = this.productivityTypes;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["orgnizationUnitId"] = this.orgnizationUnitId;
        data["tenantId"] = this.tenantId;
        data["applicationSpendTime"] = this.applicationSpendTime;
        data["applicationCategoryId"] = this.applicationCategoryId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetApplicationsDto {
    applicationName: string | undefined;
    icon: string | undefined;
    productivityTypes: ProductivityTypes;
    userId: number;
    projectId: number | undefined;
    orgnizationUnitId: number | undefined;
    tenantId: number;
    applicationSpendTime: string | undefined;
    applicationCategoryId: number;
    id: number | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;
    azureSignalRUrl!: string | undefined;
    webAppVersion!: string | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : undefined as any;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : undefined as any;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : undefined as any;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : undefined as any;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : undefined as any;
            this.azureSignalRUrl = _data["azureSignalRUrl"];
            this.webAppVersion = _data["webAppVersion"];
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : undefined as any;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined as any;
        data["azureSignalRUrl"] = this.azureSignalRUrl;
        data["webAppVersion"] = this.webAppVersion;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
    azureSignalRUrl: string | undefined;
    webAppVersion: string | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data;
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : undefined as any;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : undefined as any;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : undefined as any;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetHeaderForUserDto implements IGetHeaderForUserDto {
    fullName!: string | undefined;
    profileImage!: string | undefined;
    email!: string | undefined;
    status!: UserStatusEnum;
    lastLocation!: string | undefined;
    role!: string[] | undefined;

    constructor(data?: IGetHeaderForUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.profileImage = _data["profileImage"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.lastLocation = _data["lastLocation"];
            if (Array.isArray(_data["role"])) {
                this.role = [] as any;
                for (let item of _data["role"])
                    this.role!.push(item);
            }
        }
    }

    static fromJS(data: any): GetHeaderForUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHeaderForUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["profileImage"] = this.profileImage;
        data["email"] = this.email;
        data["status"] = this.status;
        data["lastLocation"] = this.lastLocation;
        if (Array.isArray(this.role)) {
            data["role"] = [];
            for (let item of this.role)
                data["role"].push(item);
        }
        return data;
    }
}

export interface IGetHeaderForUserDto {
    fullName: string | undefined;
    profileImage: string | undefined;
    email: string | undefined;
    status: UserStatusEnum;
    lastLocation: string | undefined;
    role: string[] | undefined;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : undefined as any;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetLocationIpAddress implements IGetLocationIpAddress {
    tenantId!: number;
    userId!: number;
    publicIPAddress!: string | undefined;
    privateIPAddress!: string | undefined;
    longitude!: string | undefined;
    latitude!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IGetLocationIpAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.publicIPAddress = _data["publicIPAddress"];
            this.privateIPAddress = _data["privateIPAddress"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetLocationIpAddress {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationIpAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["publicIPAddress"] = this.publicIPAddress;
        data["privateIPAddress"] = this.privateIPAddress;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IGetLocationIpAddress {
    tenantId: number;
    userId: number;
    publicIPAddress: string | undefined;
    privateIPAddress: string | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
    creationTime: DateTime;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : undefined as any;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : undefined as any;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetReportHistoryData implements IGetReportHistoryData {
    tenantId!: number;
    userId!: number;
    reportName!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    fileUrl!: string | undefined;
    fileSize!: string | undefined;
    userFileName!: string | undefined;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IGetReportHistoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.reportName = _data["reportName"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.fileUrl = _data["fileUrl"];
            this.fileSize = _data["fileSize"];
            this.userFileName = _data["userFileName"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetReportHistoryData {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportHistoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["reportName"] = this.reportName;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["fileUrl"] = this.fileUrl;
        data["fileSize"] = this.fileSize;
        data["userFileName"] = this.userFileName;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetReportHistoryData {
    tenantId: number;
    userId: number;
    reportName: string | undefined;
    startDate: DateTime;
    endDate: DateTime;
    fileUrl: string | undefined;
    fileSize: string | undefined;
    userFileName: string | undefined;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
    permissions!: string[] | undefined;
    tenantId!: number | undefined;

    constructor(data?: IGetRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GetRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IGetRolesInput {
    permissions: string[] | undefined;
    tenantId: number | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetTaskEsstimateHoursByTaskId implements IGetTaskEsstimateHoursByTaskId {
    estimatedHours!: number | undefined;
    taskState!: string | undefined;

    constructor(data?: IGetTaskEsstimateHoursByTaskId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedHours = _data["estimatedHours"];
            this.taskState = _data["taskState"];
        }
    }

    static fromJS(data: any): GetTaskEsstimateHoursByTaskId {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskEsstimateHoursByTaskId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedHours"] = this.estimatedHours;
        data["taskState"] = this.taskState;
        return data;
    }
}

export interface IGetTaskEsstimateHoursByTaskId {
    estimatedHours: number | undefined;
    taskState: string | undefined;
}

export class GetTaskLogDto implements IGetTaskLogDto {
    startDateTime!: DateTime | undefined;
    endDateTime!: DateTime | undefined;
    timeSpan!: string | undefined;
    timeSpanInSec!: string | undefined;
    isManualAddTask!: boolean;
    creationTime!: DateTime;
    isManualAddedFromTimeTracking!: boolean;
    isTimerNotIncludeTimesheet!: boolean;

    constructor(data?: IGetTaskLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.timeSpan = _data["timeSpan"];
            this.timeSpanInSec = _data["timeSpanInSec"];
            this.isManualAddTask = _data["isManualAddTask"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.isManualAddedFromTimeTracking = _data["isManualAddedFromTimeTracking"];
            this.isTimerNotIncludeTimesheet = _data["isTimerNotIncludeTimesheet"];
        }
    }

    static fromJS(data: any): GetTaskLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["timeSpan"] = this.timeSpan;
        data["timeSpanInSec"] = this.timeSpanInSec;
        data["isManualAddTask"] = this.isManualAddTask;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["isManualAddedFromTimeTracking"] = this.isManualAddedFromTimeTracking;
        data["isTimerNotIncludeTimesheet"] = this.isTimerNotIncludeTimesheet;
        return data;
    }
}

export interface IGetTaskLogDto {
    startDateTime: DateTime | undefined;
    endDateTime: DateTime | undefined;
    timeSpan: string | undefined;
    timeSpanInSec: string | undefined;
    isManualAddTask: boolean;
    creationTime: DateTime;
    isManualAddedFromTimeTracking: boolean;
    isTimerNotIncludeTimesheet: boolean;
}

export class GetTaskMobileDto implements IGetTaskMobileDto {
    taskName!: string | undefined;
    totalTime!: string;
    totalTimeInSecond!: number;
    creationDay!: DateTime;
    userTaskId!: number;
    taskStatus!: number | undefined;
    isManualTimeSheet!: boolean;
    taskDescription!: string | undefined;
    projectCreationDate!: DateTime | undefined;
    taskIdList!: number[] | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    approvalName!: string | undefined;
    includeInTimesheet!: boolean;
    billabilityStatus!: number | undefined;
    id!: number;

    constructor(data?: IGetTaskMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.totalTime = _data["totalTime"];
            this.totalTimeInSecond = _data["totalTimeInSecond"];
            this.creationDay = _data["creationDay"] ? DateTime.fromISO(_data["creationDay"].toString()) : undefined as any;
            this.userTaskId = _data["userTaskId"];
            this.taskStatus = _data["taskStatus"];
            this.isManualTimeSheet = _data["isManualTimeSheet"];
            this.taskDescription = _data["taskDescription"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["taskIdList"])) {
                this.taskIdList = [] as any;
                for (let item of _data["taskIdList"])
                    this.taskIdList!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.timesheetStatus = _data["timesheetStatus"];
            this.approvalName = _data["approvalName"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetTaskMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["totalTime"] = this.totalTime;
        data["totalTimeInSecond"] = this.totalTimeInSecond;
        data["creationDay"] = this.creationDay ? this.creationDay.toString() : undefined as any;
        data["userTaskId"] = this.userTaskId;
        data["taskStatus"] = this.taskStatus;
        data["isManualTimeSheet"] = this.isManualTimeSheet;
        data["taskDescription"] = this.taskDescription;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        if (Array.isArray(this.taskIdList)) {
            data["taskIdList"] = [];
            for (let item of this.taskIdList)
                data["taskIdList"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["timesheetStatus"] = this.timesheetStatus;
        data["approvalName"] = this.approvalName;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["billabilityStatus"] = this.billabilityStatus;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetTaskMobileDto {
    taskName: string | undefined;
    totalTime: string;
    totalTimeInSecond: number;
    creationDay: DateTime;
    userTaskId: number;
    taskStatus: number | undefined;
    isManualTimeSheet: boolean;
    taskDescription: string | undefined;
    projectCreationDate: DateTime | undefined;
    taskIdList: number[] | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    approvalName: string | undefined;
    includeInTimesheet: boolean;
    billabilityStatus: number | undefined;
    id: number;
}

export class GetTeamsTimeSheetForMobileDto implements IGetTeamsTimeSheetForMobileDto {
    result!: TimeSheetDto[] | undefined;
    totalCnt!: number;
    pendingCount!: number;

    constructor(data?: IGetTeamsTimeSheetForMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TimeSheetDto.fromJS(item));
            }
            this.totalCnt = _data["totalCnt"];
            this.pendingCount = _data["pendingCount"];
        }
    }

    static fromJS(data: any): GetTeamsTimeSheetForMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTeamsTimeSheetForMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCnt"] = this.totalCnt;
        data["pendingCount"] = this.pendingCount;
        return data;
    }
}

export interface IGetTeamsTimeSheetForMobileDto {
    result: TimeSheetDto[] | undefined;
    totalCnt: number;
    pendingCount: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetTimeOffCommentsDto implements IGetTimeOffCommentsDto {
    userName!: string | undefined;
    userImage!: string | undefined;
    commentDate!: DateTime;
    comment!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGetTimeOffCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.commentDate = _data["commentDate"] ? DateTime.fromISO(_data["commentDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetTimeOffCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTimeOffCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["commentDate"] = this.commentDate ? this.commentDate.toString() : undefined as any;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetTimeOffCommentsDto {
    userName: string | undefined;
    userImage: string | undefined;
    commentDate: DateTime;
    comment: string | undefined;
    id: number | undefined;
}

export class GetTimesheetLevelCommentDto implements IGetTimesheetLevelCommentDto {
    timesheetLevelCommentId!: number;
    commentDate!: DateTime;
    userImage!: string | undefined;
    userName!: string | undefined;
    comments!: string | undefined;

    constructor(data?: IGetTimesheetLevelCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheetLevelCommentId = _data["timesheetLevelCommentId"];
            this.commentDate = _data["commentDate"] ? DateTime.fromISO(_data["commentDate"].toString()) : undefined as any;
            this.userImage = _data["userImage"];
            this.userName = _data["userName"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GetTimesheetLevelCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTimesheetLevelCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheetLevelCommentId"] = this.timesheetLevelCommentId;
        data["commentDate"] = this.commentDate ? this.commentDate.toString() : undefined as any;
        data["userImage"] = this.userImage;
        data["userName"] = this.userName;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGetTimesheetLevelCommentDto {
    timesheetLevelCommentId: number;
    commentDate: DateTime;
    userImage: string | undefined;
    userName: string | undefined;
    comments: string | undefined;
}

export class GetTimesheetTasksMobile implements IGetTimesheetTasksMobile {
    creationDay!: DateTime;
    totalTime!: string;
    totalTimeInSecond!: number;
    tasks!: GetTaskMobileDto[] | undefined;

    constructor(data?: IGetTimesheetTasksMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationDay = _data["creationDay"] ? DateTime.fromISO(_data["creationDay"].toString()) : undefined as any;
            this.totalTime = _data["totalTime"];
            this.totalTimeInSecond = _data["totalTimeInSecond"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(GetTaskMobileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTimesheetTasksMobile {
        data = typeof data === 'object' ? data : {};
        let result = new GetTimesheetTasksMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationDay"] = this.creationDay ? this.creationDay.toString() : undefined as any;
        data["totalTime"] = this.totalTime;
        data["totalTimeInSecond"] = this.totalTimeInSecond;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTimesheetTasksMobile {
    creationDay: DateTime;
    totalTime: string;
    totalTimeInSecond: number;
    tasks: GetTaskMobileDto[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: DateTime;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : undefined as any;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toString() : undefined as any;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: DateTime;
    friends: FriendDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    profilePicture!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.profilePicture = _data["profilePicture"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["profilePicture"] = this.profilePicture;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    profilePicture: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserForEditOutputDesig implements IGetUserForEditOutputDesig {
    profilePictureId!: string | undefined;
    profilePicture!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allDesignationUnits!: DesignationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;

    constructor(data?: IGetUserForEditOutputDesig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.profilePicture = _data["profilePicture"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allDesignationUnits"])) {
                this.allDesignationUnits = [] as any;
                for (let item of _data["allDesignationUnits"])
                    this.allDesignationUnits!.push(DesignationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutputDesig {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutputDesig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["profilePicture"] = this.profilePicture;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allDesignationUnits)) {
            data["allDesignationUnits"] = [];
            for (let item of this.allDesignationUnits)
                data["allDesignationUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data;
    }
}

export interface IGetUserForEditOutputDesig {
    profilePictureId: string | undefined;
    profilePicture: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allDesignationUnits: DesignationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserForEditOutputForFlutter implements IGetUserForEditOutputForFlutter {
    profilePictureId!: string | undefined;
    profilePicture!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    managerName!: string | undefined;

    constructor(data?: IGetUserForEditOutputForFlutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.profilePicture = _data["profilePicture"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
            this.managerName = _data["managerName"];
        }
    }

    static fromJS(data: any): GetUserForEditOutputForFlutter {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutputForFlutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["profilePicture"] = this.profilePicture;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["managerName"] = this.managerName;
        return data;
    }
}

export interface IGetUserForEditOutputForFlutter {
    profilePictureId: string | undefined;
    profilePicture: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    managerName: string | undefined;
}

export class GetUserInfoDto implements IGetUserInfoDto {
    fullName!: string | undefined;
    roleName!: string | undefined;
    computerName!: string | undefined;
    arrivedTime!: string | undefined;

    constructor(data?: IGetUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.roleName = _data["roleName"];
            this.computerName = _data["computerName"];
            this.arrivedTime = _data["arrivedTime"];
        }
    }

    static fromJS(data: any): GetUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["roleName"] = this.roleName;
        data["computerName"] = this.computerName;
        data["arrivedTime"] = this.arrivedTime;
        return data;
    }
}

export interface IGetUserInfoDto {
    fullName: string | undefined;
    roleName: string | undefined;
    computerName: string | undefined;
    arrivedTime: string | undefined;
}

export class GetUserLocationInfoDto implements IGetUserLocationInfoDto {
    userName!: string | undefined;
    userRole!: string | undefined;
    ipAddress!: string | undefined;
    lastWorkedTime!: string | undefined;
    userDeviceName!: string | undefined;
    address!: string | undefined;
    userProfileImage!: string | undefined;
    projectId!: number | undefined;
    orgnizationId!: number;
    latitude!: string | undefined;
    longitude!: string | undefined;
    userstatus!: UserStatusEnum;
    id!: number | undefined;

    constructor(data?: IGetUserLocationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.ipAddress = _data["ipAddress"];
            this.lastWorkedTime = _data["lastWorkedTime"];
            this.userDeviceName = _data["userDeviceName"];
            this.address = _data["address"];
            this.userProfileImage = _data["userProfileImage"];
            this.projectId = _data["projectId"];
            this.orgnizationId = _data["orgnizationId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.userstatus = _data["userstatus"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserLocationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLocationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["ipAddress"] = this.ipAddress;
        data["lastWorkedTime"] = this.lastWorkedTime;
        data["userDeviceName"] = this.userDeviceName;
        data["address"] = this.address;
        data["userProfileImage"] = this.userProfileImage;
        data["projectId"] = this.projectId;
        data["orgnizationId"] = this.orgnizationId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["userstatus"] = this.userstatus;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetUserLocationInfoDto {
    userName: string | undefined;
    userRole: string | undefined;
    ipAddress: string | undefined;
    lastWorkedTime: string | undefined;
    userDeviceName: string | undefined;
    address: string | undefined;
    userProfileImage: string | undefined;
    projectId: number | undefined;
    orgnizationId: number;
    latitude: string | undefined;
    longitude: string | undefined;
    userstatus: UserStatusEnum;
    id: number | undefined;
}

export class GetUserLocationInfoWithWorkDto implements IGetUserLocationInfoWithWorkDto {
    userName!: string | undefined;
    userRole!: string | undefined;
    ipAddress!: string | undefined;
    lastWorkedTime!: DateTime;
    userDeviceName!: string | undefined;
    address!: string | undefined;
    userProfileImage!: string | undefined;
    projectId!: number | undefined;
    orgnizationId!: number;
    latitude!: string | undefined;
    longitude!: string | undefined;
    userstatus!: UserStatusEnum;
    userLiveLocation!: string | undefined;
    workingType!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGetUserLocationInfoWithWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.ipAddress = _data["ipAddress"];
            this.lastWorkedTime = _data["lastWorkedTime"] ? DateTime.fromISO(_data["lastWorkedTime"].toString()) : undefined as any;
            this.userDeviceName = _data["userDeviceName"];
            this.address = _data["address"];
            this.userProfileImage = _data["userProfileImage"];
            this.projectId = _data["projectId"];
            this.orgnizationId = _data["orgnizationId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.userstatus = _data["userstatus"];
            this.userLiveLocation = _data["userLiveLocation"];
            this.workingType = _data["workingType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserLocationInfoWithWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLocationInfoWithWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["ipAddress"] = this.ipAddress;
        data["lastWorkedTime"] = this.lastWorkedTime ? this.lastWorkedTime.toString() : undefined as any;
        data["userDeviceName"] = this.userDeviceName;
        data["address"] = this.address;
        data["userProfileImage"] = this.userProfileImage;
        data["projectId"] = this.projectId;
        data["orgnizationId"] = this.orgnizationId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["userstatus"] = this.userstatus;
        data["userLiveLocation"] = this.userLiveLocation;
        data["workingType"] = this.workingType;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetUserLocationInfoWithWorkDto {
    userName: string | undefined;
    userRole: string | undefined;
    ipAddress: string | undefined;
    lastWorkedTime: DateTime;
    userDeviceName: string | undefined;
    address: string | undefined;
    userProfileImage: string | undefined;
    projectId: number | undefined;
    orgnizationId: number;
    latitude: string | undefined;
    longitude: string | undefined;
    userstatus: UserStatusEnum;
    userLiveLocation: string | undefined;
    workingType: string | undefined;
    id: number | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUserStatusDto implements IGetUserStatusDto {
    userStatus!: UserStatusEnum;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: IGetUserStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userStatus = _data["userStatus"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetUserStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userStatus"] = this.userStatus;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        return data;
    }
}

export interface IGetUserStatusDto {
    userStatus: UserStatusEnum;
    startTime: DateTime;
    endTime: DateTime;
}

export class GetUserWiseScreenShotDto implements IGetUserWiseScreenShotDto {
    userName!: string | undefined;
    currentApplicationName!: string | undefined;
    icon!: string | undefined;
    categoryName!: string | undefined;
    status!: string | undefined;
    totalActiveTime!: string;
    hourlyActiveTimes!: HourlyActiveItemDto[] | undefined;
    userScreenShotFile!: ScreenShotCreateOrEditDto[] | undefined;

    constructor(data?: IGetUserWiseScreenShotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.currentApplicationName = _data["currentApplicationName"];
            this.icon = _data["icon"];
            this.categoryName = _data["categoryName"];
            this.status = _data["status"];
            this.totalActiveTime = _data["totalActiveTime"];
            if (Array.isArray(_data["hourlyActiveTimes"])) {
                this.hourlyActiveTimes = [] as any;
                for (let item of _data["hourlyActiveTimes"])
                    this.hourlyActiveTimes!.push(HourlyActiveItemDto.fromJS(item));
            }
            if (Array.isArray(_data["userScreenShotFile"])) {
                this.userScreenShotFile = [] as any;
                for (let item of _data["userScreenShotFile"])
                    this.userScreenShotFile!.push(ScreenShotCreateOrEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserWiseScreenShotDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserWiseScreenShotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["currentApplicationName"] = this.currentApplicationName;
        data["icon"] = this.icon;
        data["categoryName"] = this.categoryName;
        data["status"] = this.status;
        data["totalActiveTime"] = this.totalActiveTime;
        if (Array.isArray(this.hourlyActiveTimes)) {
            data["hourlyActiveTimes"] = [];
            for (let item of this.hourlyActiveTimes)
                data["hourlyActiveTimes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userScreenShotFile)) {
            data["userScreenShotFile"] = [];
            for (let item of this.userScreenShotFile)
                data["userScreenShotFile"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserWiseScreenShotDto {
    userName: string | undefined;
    currentApplicationName: string | undefined;
    icon: string | undefined;
    categoryName: string | undefined;
    status: string | undefined;
    totalActiveTime: string;
    hourlyActiveTimes: HourlyActiveItemDto[] | undefined;
    userScreenShotFile: ScreenShotCreateOrEditDto[] | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class HolidayDtoExcel implements IHolidayDtoExcel {
    holidayDate!: string | undefined;
    name!: string | undefined;
    location!: string | undefined;
    description!: string | undefined;

    constructor(data?: IHolidayDtoExcel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayDate = _data["holidayDate"];
            this.name = _data["name"];
            this.location = _data["location"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HolidayDtoExcel {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDtoExcel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayDate"] = this.holidayDate;
        data["name"] = this.name;
        data["location"] = this.location;
        data["description"] = this.description;
        return data;
    }
}

export interface IHolidayDtoExcel {
    holidayDate: string | undefined;
    name: string | undefined;
    location: string | undefined;
    description: string | undefined;
}

export class Holidays implements IHolidays {
    weekdays!: DateTime;
    isHoliday!: boolean;

    constructor(data?: IHolidays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekdays = _data["weekdays"] ? DateTime.fromISO(_data["weekdays"].toString()) : undefined as any;
            this.isHoliday = _data["isHoliday"];
        }
    }

    static fromJS(data: any): Holidays {
        data = typeof data === 'object' ? data : {};
        let result = new Holidays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekdays"] = this.weekdays ? this.weekdays.toString() : undefined as any;
        data["isHoliday"] = this.isHoliday;
        return data;
    }
}

export interface IHolidays {
    weekdays: DateTime;
    isHoliday: boolean;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : undefined as any;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : undefined as any;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined as any;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : undefined as any;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;
    userPasswordSettings!: UserPasswordSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : undefined as any;
            this.userPasswordSettings = _data["userPasswordSettings"] ? UserPasswordSettingsEditDto.fromJS(_data["userPasswordSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : undefined as any;
        data["userPasswordSettings"] = this.userPasswordSettings ? this.userPasswordSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
    userPasswordSettings: UserPasswordSettingsEditDto;
}

export class HourlyActiveItemDto implements IHourlyActiveItemDto {
    startTime!: string;
    endTime!: string;
    activeTime!: string;

    constructor(data?: IHourlyActiveItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.activeTime = _data["activeTime"];
        }
    }

    static fromJS(data: any): HourlyActiveItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyActiveItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["activeTime"] = this.activeTime;
        return data;
    }
}

export interface IHourlyActiveItemDto {
    startTime: string;
    endTime: string;
    activeTime: string;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    UnprocessableContent = 431,
    Locked = 451,
    FailedDependency = 500,
    UpgradeRequired = 501,
    PreconditionRequired = 502,
    TooManyRequests = 503,
    RequestHeaderFieldsTooLarge = 504,
    UnavailableForLegalReasons = 505,
    InternalServerError = 506,
    NotImplemented = 507,
    BadGateway = 508,
    ServiceUnavailable = 510,
    GatewayTimeout = 511,
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (_data["attributes"]) {
                (this as any).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        ((this as any).attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : undefined as any;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined as any;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (_data["attributes"]) {
                (this as any).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        ((this as any).attributes as any)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class IdNameDto implements IIdNameDto {
    id!: number;
    name!: string | undefined;
    countryCode!: number;

    constructor(data?: IIdNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): IdNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IIdNameDto {
    id: number;
    name: string | undefined;
    countryCode: number;
}

export class IdentityProviderDto implements IIdentityProviderDto {
    displayName!: string | undefined;
    providerLogo!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authorizationEndpoint!: string | undefined;
    userInformationEndpoint!: string | undefined;
    tokenEndpoint!: string | undefined;
    claimsIssuer!: string | undefined;
    providerName!: string | undefined;
    isConfigured!: boolean;
    isActive!: boolean;
    tenantId!: number | undefined;
    companyDomainName!: string | undefined;
    appTenantId!: string | undefined;
    id!: number;

    constructor(data?: IIdentityProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.providerLogo = _data["providerLogo"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authorizationEndpoint = _data["authorizationEndpoint"];
            this.userInformationEndpoint = _data["userInformationEndpoint"];
            this.tokenEndpoint = _data["tokenEndpoint"];
            this.claimsIssuer = _data["claimsIssuer"];
            this.providerName = _data["providerName"];
            this.isConfigured = _data["isConfigured"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.companyDomainName = _data["companyDomainName"];
            this.appTenantId = _data["appTenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdentityProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["providerLogo"] = this.providerLogo;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authorizationEndpoint"] = this.authorizationEndpoint;
        data["userInformationEndpoint"] = this.userInformationEndpoint;
        data["tokenEndpoint"] = this.tokenEndpoint;
        data["claimsIssuer"] = this.claimsIssuer;
        data["providerName"] = this.providerName;
        data["isConfigured"] = this.isConfigured;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["companyDomainName"] = this.companyDomainName;
        data["appTenantId"] = this.appTenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IIdentityProviderDto {
    displayName: string | undefined;
    providerLogo: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    authorizationEndpoint: string | undefined;
    userInformationEndpoint: string | undefined;
    tokenEndpoint: string | undefined;
    claimsIssuer: string | undefined;
    providerName: string | undefined;
    isConfigured: boolean;
    isActive: boolean;
    tenantId: number | undefined;
    companyDomainName: string | undefined;
    appTenantId: string | undefined;
    id: number;
}

export enum IdleTimeIntervalType {
    Min3 = 1,
    Min5 = 2,
    Min10 = 3,
    Min15 = 4,
    Min20 = 5,
    Min30 = 6,
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ImporsenatedUserDetails implements IImporsenatedUserDetails {
    employeeId!: string | undefined;
    employeeName!: string | undefined;
    employeeEmail!: string | undefined;
    id!: string | undefined;

    constructor(data?: IImporsenatedUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeEmail = _data["employeeEmail"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ImporsenatedUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ImporsenatedUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeEmail"] = this.employeeEmail;
        data["id"] = this.id;
        return data;
    }
}

export interface IImporsenatedUserDetails {
    employeeId: string | undefined;
    employeeName: string | undefined;
    employeeEmail: string | undefined;
    id: string | undefined;
}

export class InActiveUserDto implements IInActiveUserDto {
    userName!: string | undefined;
    userRole!: string[] | undefined;
    userImage!: string | undefined;
    emailAddress!: string | undefined;
    contactNumber!: string | undefined;
    projectName!: string | undefined;
    projectIcon!: string | undefined;
    orgnizationName!: string | undefined;
    projectTaskState!: string | undefined;
    projectId!: number;
    orgnizationId!: number;
    productiveTime!: string | undefined;
    inTimeProsTime!: string | undefined;
    arrivedAt!: string | undefined;
    leftAt!: string | undefined;
    atWork!: string | undefined;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    userLocation!: string | undefined;
    productivityTypeId!: number | undefined;
    arriveDateTime!: DateTime | undefined;
    leftDateTime!: DateTime | undefined;
    userStatusId!: UserStatusEnum;
    id!: number;

    constructor(data?: IInActiveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userImage = _data["userImage"];
            this.emailAddress = _data["emailAddress"];
            this.contactNumber = _data["contactNumber"];
            this.projectName = _data["projectName"];
            this.projectIcon = _data["projectIcon"];
            this.orgnizationName = _data["orgnizationName"];
            this.projectTaskState = _data["projectTaskState"];
            this.projectId = _data["projectId"];
            this.orgnizationId = _data["orgnizationId"];
            this.productiveTime = _data["productiveTime"];
            this.inTimeProsTime = _data["inTimeProsTime"];
            this.arrivedAt = _data["arrivedAt"];
            this.leftAt = _data["leftAt"];
            this.atWork = _data["atWork"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.userLocation = _data["userLocation"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.arriveDateTime = _data["arriveDateTime"] ? DateTime.fromISO(_data["arriveDateTime"].toString()) : undefined as any;
            this.leftDateTime = _data["leftDateTime"] ? DateTime.fromISO(_data["leftDateTime"].toString()) : undefined as any;
            this.userStatusId = _data["userStatusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InActiveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new InActiveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userImage"] = this.userImage;
        data["emailAddress"] = this.emailAddress;
        data["contactNumber"] = this.contactNumber;
        data["projectName"] = this.projectName;
        data["projectIcon"] = this.projectIcon;
        data["orgnizationName"] = this.orgnizationName;
        data["projectTaskState"] = this.projectTaskState;
        data["projectId"] = this.projectId;
        data["orgnizationId"] = this.orgnizationId;
        data["productiveTime"] = this.productiveTime;
        data["inTimeProsTime"] = this.inTimeProsTime;
        data["arrivedAt"] = this.arrivedAt;
        data["leftAt"] = this.leftAt;
        data["atWork"] = this.atWork;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["userLocation"] = this.userLocation;
        data["productivityTypeId"] = this.productivityTypeId;
        data["arriveDateTime"] = this.arriveDateTime ? this.arriveDateTime.toString() : undefined as any;
        data["leftDateTime"] = this.leftDateTime ? this.leftDateTime.toString() : undefined as any;
        data["userStatusId"] = this.userStatusId;
        data["id"] = this.id;
        return data;
    }
}

export interface IInActiveUserDto {
    userName: string | undefined;
    userRole: string[] | undefined;
    userImage: string | undefined;
    emailAddress: string | undefined;
    contactNumber: string | undefined;
    projectName: string | undefined;
    projectIcon: string | undefined;
    orgnizationName: string | undefined;
    projectTaskState: string | undefined;
    projectId: number;
    orgnizationId: number;
    productiveTime: string | undefined;
    inTimeProsTime: string | undefined;
    arrivedAt: string | undefined;
    leftAt: string | undefined;
    atWork: string | undefined;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    userLocation: string | undefined;
    productivityTypeId: number | undefined;
    arriveDateTime: DateTime | undefined;
    leftDateTime: DateTime | undefined;
    userStatusId: UserStatusEnum;
    id: number;
}

export class InActiveUserWithWorkTypeDto implements IInActiveUserWithWorkTypeDto {
    userName!: string | undefined;
    userRole!: string[] | undefined;
    userImage!: string | undefined;
    emailAddress!: string | undefined;
    contactNumber!: string | undefined;
    projectName!: string | undefined;
    projectIcon!: string | undefined;
    orgnizationName!: string | undefined;
    projectTaskState!: string | undefined;
    projectId!: number;
    orgnizationId!: number;
    productiveTime!: string | undefined;
    inTimeProsTime!: string | undefined;
    arrivedAt!: string | undefined;
    leftAt!: string | undefined;
    atWork!: string | undefined;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    userLocation!: string | undefined;
    productivityTypeId!: number | undefined;
    arriveDateTime!: DateTime | undefined;
    leftDateTime!: DateTime | undefined;
    userStatusId!: UserStatusEnum;
    workingType!: string | undefined;
    id!: number;

    constructor(data?: IInActiveUserWithWorkTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userImage = _data["userImage"];
            this.emailAddress = _data["emailAddress"];
            this.contactNumber = _data["contactNumber"];
            this.projectName = _data["projectName"];
            this.projectIcon = _data["projectIcon"];
            this.orgnizationName = _data["orgnizationName"];
            this.projectTaskState = _data["projectTaskState"];
            this.projectId = _data["projectId"];
            this.orgnizationId = _data["orgnizationId"];
            this.productiveTime = _data["productiveTime"];
            this.inTimeProsTime = _data["inTimeProsTime"];
            this.arrivedAt = _data["arrivedAt"];
            this.leftAt = _data["leftAt"];
            this.atWork = _data["atWork"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.userLocation = _data["userLocation"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.arriveDateTime = _data["arriveDateTime"] ? DateTime.fromISO(_data["arriveDateTime"].toString()) : undefined as any;
            this.leftDateTime = _data["leftDateTime"] ? DateTime.fromISO(_data["leftDateTime"].toString()) : undefined as any;
            this.userStatusId = _data["userStatusId"];
            this.workingType = _data["workingType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InActiveUserWithWorkTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InActiveUserWithWorkTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userImage"] = this.userImage;
        data["emailAddress"] = this.emailAddress;
        data["contactNumber"] = this.contactNumber;
        data["projectName"] = this.projectName;
        data["projectIcon"] = this.projectIcon;
        data["orgnizationName"] = this.orgnizationName;
        data["projectTaskState"] = this.projectTaskState;
        data["projectId"] = this.projectId;
        data["orgnizationId"] = this.orgnizationId;
        data["productiveTime"] = this.productiveTime;
        data["inTimeProsTime"] = this.inTimeProsTime;
        data["arrivedAt"] = this.arrivedAt;
        data["leftAt"] = this.leftAt;
        data["atWork"] = this.atWork;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["userLocation"] = this.userLocation;
        data["productivityTypeId"] = this.productivityTypeId;
        data["arriveDateTime"] = this.arriveDateTime ? this.arriveDateTime.toString() : undefined as any;
        data["leftDateTime"] = this.leftDateTime ? this.leftDateTime.toString() : undefined as any;
        data["userStatusId"] = this.userStatusId;
        data["workingType"] = this.workingType;
        data["id"] = this.id;
        return data;
    }
}

export interface IInActiveUserWithWorkTypeDto {
    userName: string | undefined;
    userRole: string[] | undefined;
    userImage: string | undefined;
    emailAddress: string | undefined;
    contactNumber: string | undefined;
    projectName: string | undefined;
    projectIcon: string | undefined;
    orgnizationName: string | undefined;
    projectTaskState: string | undefined;
    projectId: number;
    orgnizationId: number;
    productiveTime: string | undefined;
    inTimeProsTime: string | undefined;
    arrivedAt: string | undefined;
    leftAt: string | undefined;
    atWork: string | undefined;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    userLocation: string | undefined;
    productivityTypeId: number | undefined;
    arriveDateTime: DateTime | undefined;
    leftDateTime: DateTime | undefined;
    userStatusId: UserStatusEnum;
    workingType: string | undefined;
    id: number;
}

export class IncludeTimesheetDto implements IIncludeTimesheetDto {
    taskId!: number;
    includeTimesheet!: boolean;

    constructor(data?: IIncludeTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.includeTimesheet = _data["includeTimesheet"];
        }
    }

    static fromJS(data: any): IncludeTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncludeTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["includeTimesheet"] = this.includeTimesheet;
        return data;
    }
}

export interface IIncludeTimesheetDto {
    taskId: number;
    includeTimesheet: boolean;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class InputAddManualTimeDto implements IInputAddManualTimeDto {
    userId!: number;
    tenantId!: number;
    projectId!: number | undefined;
    userProjectTaskId!: number | undefined;
    manualAddTime!: string;
    manualAddDate!: DateTime;
    myTimeSheetId!: number | undefined;
    isRejectedTimesheet!: boolean;

    constructor(data?: IInputAddManualTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.manualAddTime = _data["manualAddTime"];
            this.manualAddDate = _data["manualAddDate"] ? DateTime.fromISO(_data["manualAddDate"].toString()) : undefined as any;
            this.myTimeSheetId = _data["myTimeSheetId"];
            this.isRejectedTimesheet = _data["isRejectedTimesheet"];
        }
    }

    static fromJS(data: any): InputAddManualTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputAddManualTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["manualAddTime"] = this.manualAddTime;
        data["manualAddDate"] = this.manualAddDate ? this.manualAddDate.toString() : undefined as any;
        data["myTimeSheetId"] = this.myTimeSheetId;
        data["isRejectedTimesheet"] = this.isRejectedTimesheet;
        return data;
    }
}

export interface IInputAddManualTimeDto {
    userId: number;
    tenantId: number;
    projectId: number | undefined;
    userProjectTaskId: number | undefined;
    manualAddTime: string;
    manualAddDate: DateTime;
    myTimeSheetId: number | undefined;
    isRejectedTimesheet: boolean;
}

export class InputAfterApprovedTimesheetSendNotificationToClientDto implements IInputAfterApprovedTimesheetSendNotificationToClientDto {
    timesheetId!: number[] | undefined;

    constructor(data?: IInputAfterApprovedTimesheetSendNotificationToClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timesheetId"])) {
                this.timesheetId = [] as any;
                for (let item of _data["timesheetId"])
                    this.timesheetId!.push(item);
            }
        }
    }

    static fromJS(data: any): InputAfterApprovedTimesheetSendNotificationToClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputAfterApprovedTimesheetSendNotificationToClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timesheetId)) {
            data["timesheetId"] = [];
            for (let item of this.timesheetId)
                data["timesheetId"].push(item);
        }
        return data;
    }
}

export interface IInputAfterApprovedTimesheetSendNotificationToClientDto {
    timesheetId: number[] | undefined;
}

export class InputManualAddTimesheet implements IInputManualAddTimesheet {
    taskId!: number;
    totalSeconds!: number;
    taskName!: string | undefined;
    projectId!: number;
    taskJobId!: number | undefined;
    billabilityStatus!: number;
    description!: string | undefined;
    comment!: string | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    descriptionDate!: DateTime | undefined;
    taskState!: TaskStateType;
    timesheetId!: number[] | undefined;
    isCheck!: boolean;
    isManualTimesheet!: boolean;

    constructor(data?: IInputManualAddTimesheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.totalSeconds = _data["totalSeconds"];
            this.taskName = _data["taskName"];
            this.projectId = _data["projectId"];
            this.taskJobId = _data["taskJobId"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.description = _data["description"];
            this.comment = _data["comment"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.descriptionDate = _data["descriptionDate"] ? DateTime.fromISO(_data["descriptionDate"].toString()) : undefined as any;
            this.taskState = _data["taskState"];
            if (Array.isArray(_data["timesheetId"])) {
                this.timesheetId = [] as any;
                for (let item of _data["timesheetId"])
                    this.timesheetId!.push(item);
            }
            this.isCheck = _data["isCheck"];
            this.isManualTimesheet = _data["isManualTimesheet"];
        }
    }

    static fromJS(data: any): InputManualAddTimesheet {
        data = typeof data === 'object' ? data : {};
        let result = new InputManualAddTimesheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["totalSeconds"] = this.totalSeconds;
        data["taskName"] = this.taskName;
        data["projectId"] = this.projectId;
        data["taskJobId"] = this.taskJobId;
        data["billabilityStatus"] = this.billabilityStatus;
        data["description"] = this.description;
        data["comment"] = this.comment;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["descriptionDate"] = this.descriptionDate ? this.descriptionDate.toString() : undefined as any;
        data["taskState"] = this.taskState;
        if (Array.isArray(this.timesheetId)) {
            data["timesheetId"] = [];
            for (let item of this.timesheetId)
                data["timesheetId"].push(item);
        }
        data["isCheck"] = this.isCheck;
        data["isManualTimesheet"] = this.isManualTimesheet;
        return data;
    }
}

export interface IInputManualAddTimesheet {
    taskId: number;
    totalSeconds: number;
    taskName: string | undefined;
    projectId: number;
    taskJobId: number | undefined;
    billabilityStatus: number;
    description: string | undefined;
    comment: string | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    descriptionDate: DateTime | undefined;
    taskState: TaskStateType;
    timesheetId: number[] | undefined;
    isCheck: boolean;
    isManualTimesheet: boolean;
}

export class InputManuallyCalculationUserCalculation implements IInputManuallyCalculationUserCalculation {
    userId!: number;
    tenantId!: number;
    year!: number;
    month!: number;
    day!: number;
    loopCount!: number;
    calenderDate!: DateTime;

    constructor(data?: IInputManuallyCalculationUserCalculation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
            this.loopCount = _data["loopCount"];
            this.calenderDate = _data["calenderDate"] ? DateTime.fromISO(_data["calenderDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InputManuallyCalculationUserCalculation {
        data = typeof data === 'object' ? data : {};
        let result = new InputManuallyCalculationUserCalculation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        data["loopCount"] = this.loopCount;
        data["calenderDate"] = this.calenderDate ? this.calenderDate.toString() : undefined as any;
        return data;
    }
}

export interface IInputManuallyCalculationUserCalculation {
    userId: number;
    tenantId: number;
    year: number;
    month: number;
    day: number;
    loopCount: number;
    calenderDate: DateTime;
}

export class InputProjectLevelCheckUnCheckDto implements IInputProjectLevelCheckUnCheckDto {
    tenantId!: number;
    projectId!: number;
    taskJobId!: number;
    isCheck!: boolean;

    constructor(data?: IInputProjectLevelCheckUnCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.taskJobId = _data["taskJobId"];
            this.isCheck = _data["isCheck"];
        }
    }

    static fromJS(data: any): InputProjectLevelCheckUnCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputProjectLevelCheckUnCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["taskJobId"] = this.taskJobId;
        data["isCheck"] = this.isCheck;
        return data;
    }
}

export interface IInputProjectLevelCheckUnCheckDto {
    tenantId: number;
    projectId: number;
    taskJobId: number;
    isCheck: boolean;
}

export class InputReSubmiteRejectedTimesheetDto implements IInputReSubmiteRejectedTimesheetDto {
    tenantId!: number;
    userId!: number;
    projectId!: number;
    timesheetId!: number;
    fromDate!: DateTime;
    toDate!: DateTime;
    currentTime!: DateTime;
    timeSheetDate!: DateTime;
    timesheetInvoiceFromDate!: DateTime;
    timesheetInvoiceToDate!: DateTime;
    requiredHours!: string;
    submittedHours!: string;
    billedHours!: string;
    timesheetType!: ProjectTimesheetFrequencyEnum;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    includeTimesheetDetails!: IncludeTimesheetDto[] | undefined;

    constructor(data?: IInputReSubmiteRejectedTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.timesheetId = _data["timesheetId"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.currentTime = _data["currentTime"] ? DateTime.fromISO(_data["currentTime"].toString()) : undefined as any;
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.timesheetInvoiceFromDate = _data["timesheetInvoiceFromDate"] ? DateTime.fromISO(_data["timesheetInvoiceFromDate"].toString()) : undefined as any;
            this.timesheetInvoiceToDate = _data["timesheetInvoiceToDate"] ? DateTime.fromISO(_data["timesheetInvoiceToDate"].toString()) : undefined as any;
            this.requiredHours = _data["requiredHours"];
            this.submittedHours = _data["submittedHours"];
            this.billedHours = _data["billedHours"];
            this.timesheetType = _data["timesheetType"];
            this.timesheetStatus = _data["timesheetStatus"];
            if (Array.isArray(_data["includeTimesheetDetails"])) {
                this.includeTimesheetDetails = [] as any;
                for (let item of _data["includeTimesheetDetails"])
                    this.includeTimesheetDetails!.push(IncludeTimesheetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputReSubmiteRejectedTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputReSubmiteRejectedTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["timesheetId"] = this.timesheetId;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["currentTime"] = this.currentTime ? this.currentTime.toString() : undefined as any;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["timesheetInvoiceFromDate"] = this.timesheetInvoiceFromDate ? this.timesheetInvoiceFromDate.toString() : undefined as any;
        data["timesheetInvoiceToDate"] = this.timesheetInvoiceToDate ? this.timesheetInvoiceToDate.toString() : undefined as any;
        data["requiredHours"] = this.requiredHours;
        data["submittedHours"] = this.submittedHours;
        data["billedHours"] = this.billedHours;
        data["timesheetType"] = this.timesheetType;
        data["timesheetStatus"] = this.timesheetStatus;
        if (Array.isArray(this.includeTimesheetDetails)) {
            data["includeTimesheetDetails"] = [];
            for (let item of this.includeTimesheetDetails)
                data["includeTimesheetDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInputReSubmiteRejectedTimesheetDto {
    tenantId: number;
    userId: number;
    projectId: number;
    timesheetId: number;
    fromDate: DateTime;
    toDate: DateTime;
    currentTime: DateTime;
    timeSheetDate: DateTime;
    timesheetInvoiceFromDate: DateTime;
    timesheetInvoiceToDate: DateTime;
    requiredHours: string;
    submittedHours: string;
    billedHours: string;
    timesheetType: ProjectTimesheetFrequencyEnum;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    includeTimesheetDetails: IncludeTimesheetDto[] | undefined;
}

export class InputSendTimesheetDto implements IInputSendTimesheetDto {
    tenantId!: number;
    userId!: number;
    projectId!: number;
    timesheetId!: number;
    timeZoneOffset!: number;
    requiredHours!: string;
    submittedHours!: string;
    billedHours!: string;
    timeSheetDate!: DateTime;
    fromDate!: DateTime;
    toDate!: DateTime;
    currentTime!: DateTime;
    timesheetInvoiceFromDate!: DateTime;
    timesheetInvoiceToDate!: DateTime;
    timesheetType!: ProjectTimesheetFrequencyEnum;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    includeTimesheetDetails!: IncludeTimesheetDto[] | undefined;

    constructor(data?: IInputSendTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.timesheetId = _data["timesheetId"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.requiredHours = _data["requiredHours"];
            this.submittedHours = _data["submittedHours"];
            this.billedHours = _data["billedHours"];
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.currentTime = _data["currentTime"] ? DateTime.fromISO(_data["currentTime"].toString()) : undefined as any;
            this.timesheetInvoiceFromDate = _data["timesheetInvoiceFromDate"] ? DateTime.fromISO(_data["timesheetInvoiceFromDate"].toString()) : undefined as any;
            this.timesheetInvoiceToDate = _data["timesheetInvoiceToDate"] ? DateTime.fromISO(_data["timesheetInvoiceToDate"].toString()) : undefined as any;
            this.timesheetType = _data["timesheetType"];
            this.timesheetStatus = _data["timesheetStatus"];
            if (Array.isArray(_data["includeTimesheetDetails"])) {
                this.includeTimesheetDetails = [] as any;
                for (let item of _data["includeTimesheetDetails"])
                    this.includeTimesheetDetails!.push(IncludeTimesheetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputSendTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputSendTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["timesheetId"] = this.timesheetId;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["requiredHours"] = this.requiredHours;
        data["submittedHours"] = this.submittedHours;
        data["billedHours"] = this.billedHours;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["currentTime"] = this.currentTime ? this.currentTime.toString() : undefined as any;
        data["timesheetInvoiceFromDate"] = this.timesheetInvoiceFromDate ? this.timesheetInvoiceFromDate.toString() : undefined as any;
        data["timesheetInvoiceToDate"] = this.timesheetInvoiceToDate ? this.timesheetInvoiceToDate.toString() : undefined as any;
        data["timesheetType"] = this.timesheetType;
        data["timesheetStatus"] = this.timesheetStatus;
        if (Array.isArray(this.includeTimesheetDetails)) {
            data["includeTimesheetDetails"] = [];
            for (let item of this.includeTimesheetDetails)
                data["includeTimesheetDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInputSendTimesheetDto {
    tenantId: number;
    userId: number;
    projectId: number;
    timesheetId: number;
    timeZoneOffset: number;
    requiredHours: string;
    submittedHours: string;
    billedHours: string;
    timeSheetDate: DateTime;
    fromDate: DateTime;
    toDate: DateTime;
    currentTime: DateTime;
    timesheetInvoiceFromDate: DateTime;
    timesheetInvoiceToDate: DateTime;
    timesheetType: ProjectTimesheetFrequencyEnum;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    includeTimesheetDetails: IncludeTimesheetDto[] | undefined;
}

export class InputSubmittedTimesheetDto implements IInputSubmittedTimesheetDto {
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;

    constructor(data?: IInputSubmittedTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InputSubmittedTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputSubmittedTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        return data;
    }
}

export interface IInputSubmittedTimesheetDto {
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
}

export class InputTaskJobMasterDto implements IInputTaskJobMasterDto {
    tenantId!: number;
    taskId!: number;
    taskMasterId!: number;
    taskJobId!: number;
    projectId!: number | undefined;
    jobName!: string | undefined;
    masterTaskName!: string | undefined;
    isSeed!: boolean;

    constructor(data?: IInputTaskJobMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
            this.taskMasterId = _data["taskMasterId"];
            this.taskJobId = _data["taskJobId"];
            this.projectId = _data["projectId"];
            this.jobName = _data["jobName"];
            this.masterTaskName = _data["masterTaskName"];
            this.isSeed = _data["isSeed"];
        }
    }

    static fromJS(data: any): InputTaskJobMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputTaskJobMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        data["taskMasterId"] = this.taskMasterId;
        data["taskJobId"] = this.taskJobId;
        data["projectId"] = this.projectId;
        data["jobName"] = this.jobName;
        data["masterTaskName"] = this.masterTaskName;
        data["isSeed"] = this.isSeed;
        return data;
    }
}

export interface IInputTaskJobMasterDto {
    tenantId: number;
    taskId: number;
    taskMasterId: number;
    taskJobId: number;
    projectId: number | undefined;
    jobName: string | undefined;
    masterTaskName: string | undefined;
    isSeed: boolean;
}

export class InputTotalUses implements IInputTotalUses {
    filter!: string | undefined;
    userId!: number[] | undefined;
    projectId!: number[] | undefined;
    orgUnitId!: number[] | undefined;
    filterDate!: DateTime;
    timeZoneOffset!: number;

    constructor(data?: IInputTotalUses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            if (Array.isArray(_data["orgUnitId"])) {
                this.orgUnitId = [] as any;
                for (let item of _data["orgUnitId"])
                    this.orgUnitId!.push(item);
            }
            this.filterDate = _data["filterDate"] ? DateTime.fromISO(_data["filterDate"].toString()) : undefined as any;
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): InputTotalUses {
        data = typeof data === 'object' ? data : {};
        let result = new InputTotalUses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (Array.isArray(this.orgUnitId)) {
            data["orgUnitId"] = [];
            for (let item of this.orgUnitId)
                data["orgUnitId"].push(item);
        }
        data["filterDate"] = this.filterDate ? this.filterDate.toString() : undefined as any;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }
}

export interface IInputTotalUses {
    filter: string | undefined;
    userId: number[] | undefined;
    projectId: number[] | undefined;
    orgUnitId: number[] | undefined;
    filterDate: DateTime;
    timeZoneOffset: number;
}

export class InputTotalUsesForFlutter implements IInputTotalUsesForFlutter {
    filter!: string | undefined;
    tenantId!: number;
    userId!: number | undefined;
    projectId!: number;
    orgUnitId!: number;
    filterDate!: DateTime;
    timeZoneOffset!: number;

    constructor(data?: IInputTotalUsesForFlutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.orgUnitId = _data["orgUnitId"];
            this.filterDate = _data["filterDate"] ? DateTime.fromISO(_data["filterDate"].toString()) : undefined as any;
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): InputTotalUsesForFlutter {
        data = typeof data === 'object' ? data : {};
        let result = new InputTotalUsesForFlutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["orgUnitId"] = this.orgUnitId;
        data["filterDate"] = this.filterDate ? this.filterDate.toString() : undefined as any;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }
}

export interface IInputTotalUsesForFlutter {
    filter: string | undefined;
    tenantId: number;
    userId: number | undefined;
    projectId: number;
    orgUnitId: number;
    filterDate: DateTime;
    timeZoneOffset: number;
}

export class InputUpdateTaskDescriptionBaseOnDateDto implements IInputUpdateTaskDescriptionBaseOnDateDto {
    tenantId!: number;
    taskId!: number;
    taskAssignUserId!: number;
    descriptionDate!: DateTime;
    description!: string | undefined;
    dayWisebillability!: ProjectBillingType;

    constructor(data?: IInputUpdateTaskDescriptionBaseOnDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
            this.taskAssignUserId = _data["taskAssignUserId"];
            this.descriptionDate = _data["descriptionDate"] ? DateTime.fromISO(_data["descriptionDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.dayWisebillability = _data["dayWisebillability"];
        }
    }

    static fromJS(data: any): InputUpdateTaskDescriptionBaseOnDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputUpdateTaskDescriptionBaseOnDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        data["taskAssignUserId"] = this.taskAssignUserId;
        data["descriptionDate"] = this.descriptionDate ? this.descriptionDate.toString() : undefined as any;
        data["description"] = this.description;
        data["dayWisebillability"] = this.dayWisebillability;
        return data;
    }
}

export interface IInputUpdateTaskDescriptionBaseOnDateDto {
    tenantId: number;
    taskId: number;
    taskAssignUserId: number;
    descriptionDate: DateTime;
    description: string | undefined;
    dayWisebillability: ProjectBillingType;
}

export class InputeAddManualTask implements IInputeAddManualTask {
    id!: number;
    projectId!: number;
    projectTaskId!: number;
    startTime!: DateTime;
    endTime!: DateTime;
    taskName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: IInputeAddManualTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectTaskId = _data["projectTaskId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.taskName = _data["taskName"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): InputeAddManualTask {
        data = typeof data === 'object' ? data : {};
        let result = new InputeAddManualTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectTaskId"] = this.projectTaskId;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["taskName"] = this.taskName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IInputeAddManualTask {
    id: number;
    projectId: number;
    projectTaskId: number;
    startTime: DateTime;
    endTime: DateTime;
    taskName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
}

export class InputeAttandanceReport implements IInputeAttandanceReport {
    userId!: (number | undefined)[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    projectId!: (number | undefined)[] | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    billabilityStatus!: (number | undefined)[] | undefined;
    timesheetGroupByReportType!: TimesheetReportGroupByType;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    inputReportType!: ReportType;
    timeZoneOffset!: number;
    fileName!: string | undefined;

    constructor(data?: IInputeAttandanceReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["billabilityStatus"])) {
                this.billabilityStatus = [] as any;
                for (let item of _data["billabilityStatus"])
                    this.billabilityStatus!.push(item);
            }
            this.timesheetGroupByReportType = _data["timesheetGroupByReportType"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.inputReportType = _data["inputReportType"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): InputeAttandanceReport {
        data = typeof data === 'object' ? data : {};
        let result = new InputeAttandanceReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.billabilityStatus)) {
            data["billabilityStatus"] = [];
            for (let item of this.billabilityStatus)
                data["billabilityStatus"].push(item);
        }
        data["timesheetGroupByReportType"] = this.timesheetGroupByReportType;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["inputReportType"] = this.inputReportType;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IInputeAttandanceReport {
    userId: (number | undefined)[] | undefined;
    currentUserId: number;
    tenantId: number;
    projectId: (number | undefined)[] | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    billabilityStatus: (number | undefined)[] | undefined;
    timesheetGroupByReportType: TimesheetReportGroupByType;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    inputReportType: ReportType;
    timeZoneOffset: number;
    fileName: string | undefined;
}

export class InputeCalculationTimeAndAttendanceDto implements IInputeCalculationTimeAndAttendanceDto {
    userId!: number;
    tenantId!: number;
    calenderDate!: DateTime;
    timeZoneOffset!: number;
    currentDate!: DateTime;
    prodCalDate!: DateTime;
    weekRange!: DateTime[] | undefined;

    constructor(data?: IInputeCalculationTimeAndAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.calenderDate = _data["calenderDate"] ? DateTime.fromISO(_data["calenderDate"].toString()) : undefined as any;
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.currentDate = _data["currentDate"] ? DateTime.fromISO(_data["currentDate"].toString()) : undefined as any;
            this.prodCalDate = _data["prodCalDate"] ? DateTime.fromISO(_data["prodCalDate"].toString()) : undefined as any;
            if (Array.isArray(_data["weekRange"])) {
                this.weekRange = [] as any;
                for (let item of _data["weekRange"])
                    this.weekRange!.push(DateTime.fromISO(item));
            }
        }
    }

    static fromJS(data: any): InputeCalculationTimeAndAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputeCalculationTimeAndAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["calenderDate"] = this.calenderDate ? this.calenderDate.toString() : undefined as any;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["currentDate"] = this.currentDate ? this.currentDate.toString() : undefined as any;
        data["prodCalDate"] = this.prodCalDate ? this.prodCalDate.toString() : undefined as any;
        if (Array.isArray(this.weekRange)) {
            data["weekRange"] = [];
            for (let item of this.weekRange)
                data["weekRange"].push(item.toString());
        }
        return data;
    }
}

export interface IInputeCalculationTimeAndAttendanceDto {
    userId: number;
    tenantId: number;
    calenderDate: DateTime;
    timeZoneOffset: number;
    currentDate: DateTime;
    prodCalDate: DateTime;
    weekRange: DateTime[] | undefined;
}

export class InputeCreateOrEditTimesheetDto implements IInputeCreateOrEditTimesheetDto {
    projectId!: number;
    timeSheetDateTime!: DateTime;
    userId!: number;
    tenantId!: number;
    totalWeekTaskTime!: string;
    taskListDtos!: TaskListDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IInputeCreateOrEditTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.timeSheetDateTime = _data["timeSheetDateTime"] ? DateTime.fromISO(_data["timeSheetDateTime"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.totalWeekTaskTime = _data["totalWeekTaskTime"];
            if (Array.isArray(_data["taskListDtos"])) {
                this.taskListDtos = [] as any;
                for (let item of _data["taskListDtos"])
                    this.taskListDtos!.push(TaskListDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InputeCreateOrEditTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputeCreateOrEditTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["timeSheetDateTime"] = this.timeSheetDateTime ? this.timeSheetDateTime.toString() : undefined as any;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["totalWeekTaskTime"] = this.totalWeekTaskTime;
        if (Array.isArray(this.taskListDtos)) {
            data["taskListDtos"] = [];
            for (let item of this.taskListDtos)
                data["taskListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IInputeCreateOrEditTimesheetDto {
    projectId: number;
    timeSheetDateTime: DateTime;
    userId: number;
    tenantId: number;
    totalWeekTaskTime: string;
    taskListDtos: TaskListDto[] | undefined;
    id: number | undefined;
}

export class InputeDateWiseAttendenceReport implements IInputeDateWiseAttendenceReport {
    userId!: (number | undefined)[] | undefined;
    projectId!: (number | undefined)[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    billabilityStatus!: (number | undefined)[] | undefined;
    timesheetGroupByReportType!: TimesheetReportGroupByType;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    inputReportType!: ReportType;
    timeZoneOffset!: number;
    fileName!: string | undefined;

    constructor(data?: IInputeDateWiseAttendenceReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["billabilityStatus"])) {
                this.billabilityStatus = [] as any;
                for (let item of _data["billabilityStatus"])
                    this.billabilityStatus!.push(item);
            }
            this.timesheetGroupByReportType = _data["timesheetGroupByReportType"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.inputReportType = _data["inputReportType"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): InputeDateWiseAttendenceReport {
        data = typeof data === 'object' ? data : {};
        let result = new InputeDateWiseAttendenceReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.billabilityStatus)) {
            data["billabilityStatus"] = [];
            for (let item of this.billabilityStatus)
                data["billabilityStatus"].push(item);
        }
        data["timesheetGroupByReportType"] = this.timesheetGroupByReportType;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["inputReportType"] = this.inputReportType;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IInputeDateWiseAttendenceReport {
    userId: (number | undefined)[] | undefined;
    projectId: (number | undefined)[] | undefined;
    currentUserId: number;
    tenantId: number;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    billabilityStatus: (number | undefined)[] | undefined;
    timesheetGroupByReportType: TimesheetReportGroupByType;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    inputReportType: ReportType;
    timeZoneOffset: number;
    fileName: string | undefined;
}

export class InputeLeaveReport implements IInputeLeaveReport {
    userId!: (number | undefined)[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    projectId!: (number | undefined)[] | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    billabilityStatus!: (number | undefined)[] | undefined;
    timesheetGroupByReportType!: TimesheetReportGroupByType;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    inputReportType!: ReportType;
    timeZoneOffset!: number;
    fileName!: string | undefined;

    constructor(data?: IInputeLeaveReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["billabilityStatus"])) {
                this.billabilityStatus = [] as any;
                for (let item of _data["billabilityStatus"])
                    this.billabilityStatus!.push(item);
            }
            this.timesheetGroupByReportType = _data["timesheetGroupByReportType"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.inputReportType = _data["inputReportType"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): InputeLeaveReport {
        data = typeof data === 'object' ? data : {};
        let result = new InputeLeaveReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.billabilityStatus)) {
            data["billabilityStatus"] = [];
            for (let item of this.billabilityStatus)
                data["billabilityStatus"].push(item);
        }
        data["timesheetGroupByReportType"] = this.timesheetGroupByReportType;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["inputReportType"] = this.inputReportType;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IInputeLeaveReport {
    userId: (number | undefined)[] | undefined;
    currentUserId: number;
    tenantId: number;
    projectId: (number | undefined)[] | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    billabilityStatus: (number | undefined)[] | undefined;
    timesheetGroupByReportType: TimesheetReportGroupByType;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    inputReportType: ReportType;
    timeZoneOffset: number;
    fileName: string | undefined;
}

export class InputeTeamMemberWiseAttendenceReport implements IInputeTeamMemberWiseAttendenceReport {
    userId!: (number | undefined)[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    projectId!: (number | undefined)[] | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    billabilityStatus!: (number | undefined)[] | undefined;
    timesheetGroupByReportType!: TimesheetReportGroupByType;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    inputReportType!: ReportType;
    timeZoneOffset!: number;
    fileName!: string | undefined;

    constructor(data?: IInputeTeamMemberWiseAttendenceReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["billabilityStatus"])) {
                this.billabilityStatus = [] as any;
                for (let item of _data["billabilityStatus"])
                    this.billabilityStatus!.push(item);
            }
            this.timesheetGroupByReportType = _data["timesheetGroupByReportType"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.inputReportType = _data["inputReportType"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): InputeTeamMemberWiseAttendenceReport {
        data = typeof data === 'object' ? data : {};
        let result = new InputeTeamMemberWiseAttendenceReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.billabilityStatus)) {
            data["billabilityStatus"] = [];
            for (let item of this.billabilityStatus)
                data["billabilityStatus"].push(item);
        }
        data["timesheetGroupByReportType"] = this.timesheetGroupByReportType;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["inputReportType"] = this.inputReportType;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IInputeTeamMemberWiseAttendenceReport {
    userId: (number | undefined)[] | undefined;
    currentUserId: number;
    tenantId: number;
    projectId: (number | undefined)[] | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    billabilityStatus: (number | undefined)[] | undefined;
    timesheetGroupByReportType: TimesheetReportGroupByType;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    inputReportType: ReportType;
    timeZoneOffset: number;
    fileName: string | undefined;
}

export class InputeTeamTimesheet implements IInputeTeamTimesheet {
    userId!: (number | undefined)[] | undefined;
    projectId!: (number | undefined)[] | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    timesheetId!: number;
    includeMine!: boolean;
    sortByNewestOnTop!: boolean;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    isSummary!: boolean;
    isExport!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IInputeTeamTimesheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.timesheetId = _data["timesheetId"];
            this.includeMine = _data["includeMine"];
            this.sortByNewestOnTop = _data["sortByNewestOnTop"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.isSummary = _data["isSummary"];
            this.isExport = _data["isExport"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): InputeTeamTimesheet {
        data = typeof data === 'object' ? data : {};
        let result = new InputeTeamTimesheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["timesheetId"] = this.timesheetId;
        data["includeMine"] = this.includeMine;
        data["sortByNewestOnTop"] = this.sortByNewestOnTop;
        data["timesheetStatus"] = this.timesheetStatus;
        data["isSummary"] = this.isSummary;
        data["isExport"] = this.isExport;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IInputeTeamTimesheet {
    userId: (number | undefined)[] | undefined;
    projectId: (number | undefined)[] | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    timesheetId: number;
    includeMine: boolean;
    sortByNewestOnTop: boolean;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    isSummary: boolean;
    isExport: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class InputeTimesheetReport implements IInputeTimesheetReport {
    userId!: (number | undefined)[] | undefined;
    projectId!: (number | undefined)[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    billabilityStatus!: (number | undefined)[] | undefined;
    timesheetGroupByReportType!: TimesheetReportGroupByType;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    inputReportType!: ReportType;
    timeZoneOffset!: number;
    fileName!: string | undefined;

    constructor(data?: IInputeTimesheetReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["billabilityStatus"])) {
                this.billabilityStatus = [] as any;
                for (let item of _data["billabilityStatus"])
                    this.billabilityStatus!.push(item);
            }
            this.timesheetGroupByReportType = _data["timesheetGroupByReportType"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.inputReportType = _data["inputReportType"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): InputeTimesheetReport {
        data = typeof data === 'object' ? data : {};
        let result = new InputeTimesheetReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.billabilityStatus)) {
            data["billabilityStatus"] = [];
            for (let item of this.billabilityStatus)
                data["billabilityStatus"].push(item);
        }
        data["timesheetGroupByReportType"] = this.timesheetGroupByReportType;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["inputReportType"] = this.inputReportType;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IInputeTimesheetReport {
    userId: (number | undefined)[] | undefined;
    projectId: (number | undefined)[] | undefined;
    currentUserId: number;
    tenantId: number;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    billabilityStatus: (number | undefined)[] | undefined;
    timesheetGroupByReportType: TimesheetReportGroupByType;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    inputReportType: ReportType;
    timeZoneOffset: number;
    fileName: string | undefined;
}

export class InputeTypeWiseCategoryAndApplicationDto implements IInputeTypeWiseCategoryAndApplicationDto {
    tenantId!: number;
    userId!: number;
    productivityTypes!: ProductivityTypes;
    isAllTypes!: boolean | undefined;
    calenderDate!: DateTime;
    timeZoneOffSet!: number;

    constructor(data?: IInputeTypeWiseCategoryAndApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.productivityTypes = _data["productivityTypes"];
            this.isAllTypes = _data["isAllTypes"];
            this.calenderDate = _data["calenderDate"] ? DateTime.fromISO(_data["calenderDate"].toString()) : undefined as any;
            this.timeZoneOffSet = _data["timeZoneOffSet"];
        }
    }

    static fromJS(data: any): InputeTypeWiseCategoryAndApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputeTypeWiseCategoryAndApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["productivityTypes"] = this.productivityTypes;
        data["isAllTypes"] = this.isAllTypes;
        data["calenderDate"] = this.calenderDate ? this.calenderDate.toString() : undefined as any;
        data["timeZoneOffSet"] = this.timeZoneOffSet;
        return data;
    }
}

export interface IInputeTypeWiseCategoryAndApplicationDto {
    tenantId: number;
    userId: number;
    productivityTypes: ProductivityTypes;
    isAllTypes: boolean | undefined;
    calenderDate: DateTime;
    timeZoneOffSet: number;
}

export class InputeUsagePerEmployee implements IInputeUsagePerEmployee {
    applicationId!: number;
    filterDate!: DateTime;
    filter!: string | undefined;
    userId!: (number | undefined)[] | undefined;
    projectId!: (number | undefined)[] | undefined;
    orgUnitId!: (number | undefined)[] | undefined;
    isManager!: boolean;
    userIDFromScreenshotSignalR!: number | undefined;
    isDashboard!: boolean;
    timeZoneOffset!: number;

    constructor(data?: IInputeUsagePerEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.filterDate = _data["filterDate"] ? DateTime.fromISO(_data["filterDate"].toString()) : undefined as any;
            this.filter = _data["filter"];
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            if (Array.isArray(_data["orgUnitId"])) {
                this.orgUnitId = [] as any;
                for (let item of _data["orgUnitId"])
                    this.orgUnitId!.push(item);
            }
            this.isManager = _data["isManager"];
            this.userIDFromScreenshotSignalR = _data["userIDFromScreenshotSignalR"];
            this.isDashboard = _data["isDashboard"];
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): InputeUsagePerEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new InputeUsagePerEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["filterDate"] = this.filterDate ? this.filterDate.toString() : undefined as any;
        data["filter"] = this.filter;
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (Array.isArray(this.orgUnitId)) {
            data["orgUnitId"] = [];
            for (let item of this.orgUnitId)
                data["orgUnitId"].push(item);
        }
        data["isManager"] = this.isManager;
        data["userIDFromScreenshotSignalR"] = this.userIDFromScreenshotSignalR;
        data["isDashboard"] = this.isDashboard;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }
}

export interface IInputeUsagePerEmployee {
    applicationId: number;
    filterDate: DateTime;
    filter: string | undefined;
    userId: (number | undefined)[] | undefined;
    projectId: (number | undefined)[] | undefined;
    orgUnitId: (number | undefined)[] | undefined;
    isManager: boolean;
    userIDFromScreenshotSignalR: number | undefined;
    isDashboard: boolean;
    timeZoneOffset: number;
}

export class InputeUserProfileImageDto implements IInputeUserProfileImageDto {
    userId!: number;
    tenantId!: number | undefined;
    profileImage!: string | undefined;

    constructor(data?: IInputeUserProfileImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): InputeUserProfileImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputeUserProfileImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IInputeUserProfileImageDto {
    userId: number;
    tenantId: number | undefined;
    profileImage: string | undefined;
}

export class InputeWorkStatusReport implements IInputeWorkStatusReport {
    userId!: (number | undefined)[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    projectId!: (number | undefined)[] | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    billabilityStatus!: (number | undefined)[] | undefined;
    timesheetGroupByReportType!: TimesheetReportGroupByType;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    inputReportType!: ReportType;
    timeZoneOffset!: number;
    fileName!: string | undefined;

    constructor(data?: IInputeWorkStatusReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["billabilityStatus"])) {
                this.billabilityStatus = [] as any;
                for (let item of _data["billabilityStatus"])
                    this.billabilityStatus!.push(item);
            }
            this.timesheetGroupByReportType = _data["timesheetGroupByReportType"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.inputReportType = _data["inputReportType"];
            this.timeZoneOffset = _data["timeZoneOffset"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): InputeWorkStatusReport {
        data = typeof data === 'object' ? data : {};
        let result = new InputeWorkStatusReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.billabilityStatus)) {
            data["billabilityStatus"] = [];
            for (let item of this.billabilityStatus)
                data["billabilityStatus"].push(item);
        }
        data["timesheetGroupByReportType"] = this.timesheetGroupByReportType;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["inputReportType"] = this.inputReportType;
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IInputeWorkStatusReport {
    userId: (number | undefined)[] | undefined;
    currentUserId: number;
    tenantId: number;
    projectId: (number | undefined)[] | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    billabilityStatus: (number | undefined)[] | undefined;
    timesheetGroupByReportType: TimesheetReportGroupByType;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    inputReportType: ReportType;
    timeZoneOffset: number;
    fileName: string | undefined;
}

export class InsertOrUpdateAllValuesInput implements IInsertOrUpdateAllValuesInput {
    items!: InsertOrUpdateAllValuesInputItem[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InsertOrUpdateAllValuesInputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInput {
    items: InsertOrUpdateAllValuesInputItem[] | undefined;
}

export class InsertOrUpdateAllValuesInputItem implements IInsertOrUpdateAllValuesInputItem {
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    values!: string[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInputItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInputItem {
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    values: string[] | undefined;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : undefined as any;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : undefined as any;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export enum IntegrationAuthType {
    OAuth = 1,
    ApiKey = 2,
}

export class IntegrationCatalogItemDto implements IIntegrationCatalogItemDto {
    provider!: IntegrationProvider;
    name!: string | undefined;
    description!: string | undefined;
    iconUrl!: string | undefined;
    authType!: IntegrationAuthType;
    isComingSoon!: boolean;
    canManage!: boolean;
    connectedProjectCount!: number | undefined;
    connectedAccountCount!: number | undefined;
    connection!: IntegrationConnectionDto;

    constructor(data?: IIntegrationCatalogItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.iconUrl = _data["iconUrl"];
            this.authType = _data["authType"];
            this.isComingSoon = _data["isComingSoon"];
            this.canManage = _data["canManage"];
            this.connectedProjectCount = _data["connectedProjectCount"];
            this.connectedAccountCount = _data["connectedAccountCount"];
            this.connection = _data["connection"] ? IntegrationConnectionDto.fromJS(_data["connection"]) : undefined as any;
        }
    }

    static fromJS(data: any): IntegrationCatalogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationCatalogItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["name"] = this.name;
        data["description"] = this.description;
        data["iconUrl"] = this.iconUrl;
        data["authType"] = this.authType;
        data["isComingSoon"] = this.isComingSoon;
        data["canManage"] = this.canManage;
        data["connectedProjectCount"] = this.connectedProjectCount;
        data["connectedAccountCount"] = this.connectedAccountCount;
        data["connection"] = this.connection ? this.connection.toJSON() : undefined as any;
        return data;
    }
}

export interface IIntegrationCatalogItemDto {
    provider: IntegrationProvider;
    name: string | undefined;
    description: string | undefined;
    iconUrl: string | undefined;
    authType: IntegrationAuthType;
    isComingSoon: boolean;
    canManage: boolean;
    connectedProjectCount: number | undefined;
    connectedAccountCount: number | undefined;
    connection: IntegrationConnectionDto;
}

export class IntegrationConnectionDto implements IIntegrationConnectionDto {
    id!: number;
    provider!: IntegrationProvider;
    authType!: IntegrationAuthType;
    status!: IntegrationConnectionStatus;
    licenseAllocation!: IntegrationLicenseAllocation;
    clientId!: number | undefined;
    clientName!: string | undefined;
    comment!: string | undefined;
    externalAccountId!: string | undefined;
    externalAccountEmail!: string | undefined;
    externalAccountName!: string | undefined;
    scopes!: string | undefined;
    tokenExpiresAtUtc!: DateTime | undefined;
    lastValidatedAtUtc!: DateTime | undefined;
    lastValidationError!: string | undefined;
    isConnected!: boolean;
    linkedByUserId!: number | undefined;
    linkedByUserName!: string | undefined;
    linkedByUserEmail!: string | undefined;
    tokensUsed!: number | undefined;
    tokensAvailable!: number | undefined;
    tokenUsageFetchedAtUtc!: DateTime | undefined;

    constructor(data?: IIntegrationConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provider = _data["provider"];
            this.authType = _data["authType"];
            this.status = _data["status"];
            this.licenseAllocation = _data["licenseAllocation"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.comment = _data["comment"];
            this.externalAccountId = _data["externalAccountId"];
            this.externalAccountEmail = _data["externalAccountEmail"];
            this.externalAccountName = _data["externalAccountName"];
            this.scopes = _data["scopes"];
            this.tokenExpiresAtUtc = _data["tokenExpiresAtUtc"] ? DateTime.fromISO(_data["tokenExpiresAtUtc"].toString()) : undefined as any;
            this.lastValidatedAtUtc = _data["lastValidatedAtUtc"] ? DateTime.fromISO(_data["lastValidatedAtUtc"].toString()) : undefined as any;
            this.lastValidationError = _data["lastValidationError"];
            this.isConnected = _data["isConnected"];
            this.linkedByUserId = _data["linkedByUserId"];
            this.linkedByUserName = _data["linkedByUserName"];
            this.linkedByUserEmail = _data["linkedByUserEmail"];
            this.tokensUsed = _data["tokensUsed"];
            this.tokensAvailable = _data["tokensAvailable"];
            this.tokenUsageFetchedAtUtc = _data["tokenUsageFetchedAtUtc"] ? DateTime.fromISO(_data["tokenUsageFetchedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): IntegrationConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provider"] = this.provider;
        data["authType"] = this.authType;
        data["status"] = this.status;
        data["licenseAllocation"] = this.licenseAllocation;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["comment"] = this.comment;
        data["externalAccountId"] = this.externalAccountId;
        data["externalAccountEmail"] = this.externalAccountEmail;
        data["externalAccountName"] = this.externalAccountName;
        data["scopes"] = this.scopes;
        data["tokenExpiresAtUtc"] = this.tokenExpiresAtUtc ? this.tokenExpiresAtUtc.toString() : undefined as any;
        data["lastValidatedAtUtc"] = this.lastValidatedAtUtc ? this.lastValidatedAtUtc.toString() : undefined as any;
        data["lastValidationError"] = this.lastValidationError;
        data["isConnected"] = this.isConnected;
        data["linkedByUserId"] = this.linkedByUserId;
        data["linkedByUserName"] = this.linkedByUserName;
        data["linkedByUserEmail"] = this.linkedByUserEmail;
        data["tokensUsed"] = this.tokensUsed;
        data["tokensAvailable"] = this.tokensAvailable;
        data["tokenUsageFetchedAtUtc"] = this.tokenUsageFetchedAtUtc ? this.tokenUsageFetchedAtUtc.toString() : undefined as any;
        return data;
    }
}

export interface IIntegrationConnectionDto {
    id: number;
    provider: IntegrationProvider;
    authType: IntegrationAuthType;
    status: IntegrationConnectionStatus;
    licenseAllocation: IntegrationLicenseAllocation;
    clientId: number | undefined;
    clientName: string | undefined;
    comment: string | undefined;
    externalAccountId: string | undefined;
    externalAccountEmail: string | undefined;
    externalAccountName: string | undefined;
    scopes: string | undefined;
    tokenExpiresAtUtc: DateTime | undefined;
    lastValidatedAtUtc: DateTime | undefined;
    lastValidationError: string | undefined;
    isConnected: boolean;
    linkedByUserId: number | undefined;
    linkedByUserName: string | undefined;
    linkedByUserEmail: string | undefined;
    tokensUsed: number | undefined;
    tokensAvailable: number | undefined;
    tokenUsageFetchedAtUtc: DateTime | undefined;
}

export enum IntegrationConnectionStatus {
    Disconnected = 0,
    Connected = 1,
    Expired = 2,
    Error = 3,
}

export enum IntegrationLicenseAllocation {
    MyCompany = 1,
    Client = 2,
}

export class IntegrationOAuthBeginResultDto implements IIntegrationOAuthBeginResultDto {
    authorizationUrl!: string | undefined;
    state!: string | undefined;
    provider!: IntegrationProvider;

    constructor(data?: IIntegrationOAuthBeginResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationUrl = _data["authorizationUrl"];
            this.state = _data["state"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): IntegrationOAuthBeginResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationOAuthBeginResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationUrl"] = this.authorizationUrl;
        data["state"] = this.state;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IIntegrationOAuthBeginResultDto {
    authorizationUrl: string | undefined;
    state: string | undefined;
    provider: IntegrationProvider;
}

export enum IntegrationProvider {
    Outlook = 1,
    Keka = 2,
    ChatGpt = 3,
    Claude = 4,
    GitHubCopilot = 5,
    Cursor = 6,
    AzureDevOps = 7,
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: DateTime;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : undefined as any;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : undefined as any;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: DateTime;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class IsCheckTimesheetFlag implements IIsCheckTimesheetFlag {
    isInvalidHours!: boolean;
    isTimesheetSubmited!: boolean;

    constructor(data?: IIsCheckTimesheetFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInvalidHours = _data["isInvalidHours"];
            this.isTimesheetSubmited = _data["isTimesheetSubmited"];
        }
    }

    static fromJS(data: any): IsCheckTimesheetFlag {
        data = typeof data === 'object' ? data : {};
        let result = new IsCheckTimesheetFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInvalidHours"] = this.isInvalidHours;
        data["isTimesheetSubmited"] = this.isTimesheetSubmited;
        return data;
    }
}

export interface IIsCheckTimesheetFlag {
    isInvalidHours: boolean;
    isTimesheetSubmited: boolean;
}

export class IsSocialLoginDto implements IIsSocialLoginDto {
    issocial!: number;

    constructor(data?: IIsSocialLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issocial = _data["issocial"];
        }
    }

    static fromJS(data: any): IsSocialLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsSocialLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issocial"] = this.issocial;
        return data;
    }
}

export interface IIsSocialLoginDto {
    issocial: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class IsTimesheetSubmiteDto implements IIsTimesheetSubmiteDto {
    userId!: number;
    tenantId!: number;
    taskDate!: DateTime;

    constructor(data?: IIsTimesheetSubmiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.taskDate = _data["taskDate"] ? DateTime.fromISO(_data["taskDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): IsTimesheetSubmiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsTimesheetSubmiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["taskDate"] = this.taskDate ? this.taskDate.toString() : undefined as any;
        return data;
    }
}

export interface IIsTimesheetSubmiteDto {
    userId: number;
    tenantId: number;
    taskDate: DateTime;
}

export enum IsUserType {
    AllUsers = 1,
    ActiveUsers = 2,
    ArchivedUsers = 3,
    DeletedUsers = 4,
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class KekaAccessDto implements IKekaAccessDto {
    isApprover!: boolean;
    isSuperAdmin!: boolean;
    canView!: boolean;

    constructor(data?: IKekaAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isApprover = _data["isApprover"];
            this.isSuperAdmin = _data["isSuperAdmin"];
            this.canView = _data["canView"];
        }
    }

    static fromJS(data: any): KekaAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new KekaAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isApprover"] = this.isApprover;
        data["isSuperAdmin"] = this.isSuperAdmin;
        data["canView"] = this.canView;
        return data;
    }
}

export interface IKekaAccessDto {
    isApprover: boolean;
    isSuperAdmin: boolean;
    canView: boolean;
}

export class KekaJobStatusDto implements IKekaJobStatusDto {
    name!: string | undefined;
    kind!: string | undefined;
    state!: string | undefined;
    schedule!: string | undefined;
    lastRunTime!: DateTime | undefined;
    nextRunTime!: DateTime | undefined;
    time!: DateTime | undefined;
    durationMs!: number | undefined;
    error!: string | undefined;

    constructor(data?: IKekaJobStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kind = _data["kind"];
            this.state = _data["state"];
            this.schedule = _data["schedule"];
            this.lastRunTime = _data["lastRunTime"] ? DateTime.fromISO(_data["lastRunTime"].toString()) : undefined as any;
            this.nextRunTime = _data["nextRunTime"] ? DateTime.fromISO(_data["nextRunTime"].toString()) : undefined as any;
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : undefined as any;
            this.durationMs = _data["durationMs"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): KekaJobStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new KekaJobStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kind"] = this.kind;
        data["state"] = this.state;
        data["schedule"] = this.schedule;
        data["lastRunTime"] = this.lastRunTime ? this.lastRunTime.toString() : undefined as any;
        data["nextRunTime"] = this.nextRunTime ? this.nextRunTime.toString() : undefined as any;
        data["time"] = this.time ? this.time.toString() : undefined as any;
        data["durationMs"] = this.durationMs;
        data["error"] = this.error;
        return data;
    }
}

export interface IKekaJobStatusDto {
    name: string | undefined;
    kind: string | undefined;
    state: string | undefined;
    schedule: string | undefined;
    lastRunTime: DateTime | undefined;
    nextRunTime: DateTime | undefined;
    time: DateTime | undefined;
    durationMs: number | undefined;
    error: string | undefined;
}

export class KekaManagerApprovalDto implements IKekaManagerApprovalDto {
    projectId!: number;
    projectName!: string | undefined;
    fromProjectId!: number | undefined;
    changeType!: KekaMemberChangeType;
    managerId!: number;
    userIds!: number[] | undefined;
    approverIds!: number[] | undefined;
    status!: KekaManagerApprovalStatus;
    approvedBy!: number | undefined;
    approvedByName!: string | undefined;
    approvedTime!: DateTime | undefined;
    comment!: string | undefined;
    syncedTime!: DateTime | undefined;
    syncError!: string | undefined;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IKekaManagerApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.fromProjectId = _data["fromProjectId"];
            this.changeType = _data["changeType"];
            this.managerId = _data["managerId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["approverIds"])) {
                this.approverIds = [] as any;
                for (let item of _data["approverIds"])
                    this.approverIds!.push(item);
            }
            this.status = _data["status"];
            this.approvedBy = _data["approvedBy"];
            this.approvedByName = _data["approvedByName"];
            this.approvedTime = _data["approvedTime"] ? DateTime.fromISO(_data["approvedTime"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.syncedTime = _data["syncedTime"] ? DateTime.fromISO(_data["syncedTime"].toString()) : undefined as any;
            this.syncError = _data["syncError"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KekaManagerApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new KekaManagerApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["fromProjectId"] = this.fromProjectId;
        data["changeType"] = this.changeType;
        data["managerId"] = this.managerId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.approverIds)) {
            data["approverIds"] = [];
            for (let item of this.approverIds)
                data["approverIds"].push(item);
        }
        data["status"] = this.status;
        data["approvedBy"] = this.approvedBy;
        data["approvedByName"] = this.approvedByName;
        data["approvedTime"] = this.approvedTime ? this.approvedTime.toString() : undefined as any;
        data["comment"] = this.comment;
        data["syncedTime"] = this.syncedTime ? this.syncedTime.toString() : undefined as any;
        data["syncError"] = this.syncError;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IKekaManagerApprovalDto {
    projectId: number;
    projectName: string | undefined;
    fromProjectId: number | undefined;
    changeType: KekaMemberChangeType;
    managerId: number;
    userIds: number[] | undefined;
    approverIds: number[] | undefined;
    status: KekaManagerApprovalStatus;
    approvedBy: number | undefined;
    approvedByName: string | undefined;
    approvedTime: DateTime | undefined;
    comment: string | undefined;
    syncedTime: DateTime | undefined;
    syncError: string | undefined;
    creationTime: DateTime;
    id: number;
}

export enum KekaManagerApprovalStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum KekaMemberChangeType {
    Added = 1,
    Updated = 2,
    Moved = 3,
}

export class KekaSyncApprovalItemDto implements IKekaSyncApprovalItemDto {
    id!: number;
    projectName!: string | undefined;
    memberCount!: number;
    approvedTime!: DateTime | undefined;
    syncedTime!: DateTime | undefined;
    syncError!: string | undefined;

    constructor(data?: IKekaSyncApprovalItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.memberCount = _data["memberCount"];
            this.approvedTime = _data["approvedTime"] ? DateTime.fromISO(_data["approvedTime"].toString()) : undefined as any;
            this.syncedTime = _data["syncedTime"] ? DateTime.fromISO(_data["syncedTime"].toString()) : undefined as any;
            this.syncError = _data["syncError"];
        }
    }

    static fromJS(data: any): KekaSyncApprovalItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new KekaSyncApprovalItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["memberCount"] = this.memberCount;
        data["approvedTime"] = this.approvedTime ? this.approvedTime.toString() : undefined as any;
        data["syncedTime"] = this.syncedTime ? this.syncedTime.toString() : undefined as any;
        data["syncError"] = this.syncError;
        return data;
    }
}

export interface IKekaSyncApprovalItemDto {
    id: number;
    projectName: string | undefined;
    memberCount: number;
    approvedTime: DateTime | undefined;
    syncedTime: DateTime | undefined;
    syncError: string | undefined;
}

export class KekaSyncReportDto implements IKekaSyncReportDto {
    isConnected!: boolean;
    connectionStatus!: string | undefined;
    connectedAccount!: string | undefined;
    lastValidatedTime!: DateTime | undefined;
    lastValidationError!: string | undefined;
    userSyncEnabled!: boolean;
    holidaySyncEnabled!: boolean;
    leaveSyncEnabled!: boolean;
    dottedLineManagerUpdateEnabled!: boolean;
    pendingApprovals!: number;
    approvedApprovals!: number;
    rejectedApprovals!: number;
    syncedApprovals!: number;
    failedApprovals!: number;
    recentApprovalSyncs!: KekaSyncApprovalItemDto[] | undefined;
    jobs!: KekaJobStatusDto[] | undefined;
    jobsUnavailableReason!: string | undefined;

    constructor(data?: IKekaSyncReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConnected = _data["isConnected"];
            this.connectionStatus = _data["connectionStatus"];
            this.connectedAccount = _data["connectedAccount"];
            this.lastValidatedTime = _data["lastValidatedTime"] ? DateTime.fromISO(_data["lastValidatedTime"].toString()) : undefined as any;
            this.lastValidationError = _data["lastValidationError"];
            this.userSyncEnabled = _data["userSyncEnabled"];
            this.holidaySyncEnabled = _data["holidaySyncEnabled"];
            this.leaveSyncEnabled = _data["leaveSyncEnabled"];
            this.dottedLineManagerUpdateEnabled = _data["dottedLineManagerUpdateEnabled"];
            this.pendingApprovals = _data["pendingApprovals"];
            this.approvedApprovals = _data["approvedApprovals"];
            this.rejectedApprovals = _data["rejectedApprovals"];
            this.syncedApprovals = _data["syncedApprovals"];
            this.failedApprovals = _data["failedApprovals"];
            if (Array.isArray(_data["recentApprovalSyncs"])) {
                this.recentApprovalSyncs = [] as any;
                for (let item of _data["recentApprovalSyncs"])
                    this.recentApprovalSyncs!.push(KekaSyncApprovalItemDto.fromJS(item));
            }
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(KekaJobStatusDto.fromJS(item));
            }
            this.jobsUnavailableReason = _data["jobsUnavailableReason"];
        }
    }

    static fromJS(data: any): KekaSyncReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new KekaSyncReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConnected"] = this.isConnected;
        data["connectionStatus"] = this.connectionStatus;
        data["connectedAccount"] = this.connectedAccount;
        data["lastValidatedTime"] = this.lastValidatedTime ? this.lastValidatedTime.toString() : undefined as any;
        data["lastValidationError"] = this.lastValidationError;
        data["userSyncEnabled"] = this.userSyncEnabled;
        data["holidaySyncEnabled"] = this.holidaySyncEnabled;
        data["leaveSyncEnabled"] = this.leaveSyncEnabled;
        data["dottedLineManagerUpdateEnabled"] = this.dottedLineManagerUpdateEnabled;
        data["pendingApprovals"] = this.pendingApprovals;
        data["approvedApprovals"] = this.approvedApprovals;
        data["rejectedApprovals"] = this.rejectedApprovals;
        data["syncedApprovals"] = this.syncedApprovals;
        data["failedApprovals"] = this.failedApprovals;
        if (Array.isArray(this.recentApprovalSyncs)) {
            data["recentApprovalSyncs"] = [];
            for (let item of this.recentApprovalSyncs)
                data["recentApprovalSyncs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item ? item.toJSON() : undefined as any);
        }
        data["jobsUnavailableReason"] = this.jobsUnavailableReason;
        return data;
    }
}

export interface IKekaSyncReportDto {
    isConnected: boolean;
    connectionStatus: string | undefined;
    connectedAccount: string | undefined;
    lastValidatedTime: DateTime | undefined;
    lastValidationError: string | undefined;
    userSyncEnabled: boolean;
    holidaySyncEnabled: boolean;
    leaveSyncEnabled: boolean;
    dottedLineManagerUpdateEnabled: boolean;
    pendingApprovals: number;
    approvedApprovals: number;
    rejectedApprovals: number;
    syncedApprovals: number;
    failedApprovals: number;
    recentApprovalSyncs: KekaSyncApprovalItemDto[] | undefined;
    jobs: KekaJobStatusDto[] | undefined;
    jobsUnavailableReason: string | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class LeaveByUserDto implements ILeaveByUserDto {
    id!: number;
    year!: DateTime;
    userId!: number;
    tenantId!: number;
    jan!: number;
    feb!: number;
    mar!: number;
    apr!: number;
    may!: number;
    jun!: number;
    jul!: number;
    aug!: number;
    sept!: number;
    nov!: number;
    dec!: number;
    oct!: number;
    creationTime!: DateTime;

    constructor(data?: ILeaveByUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"] ? DateTime.fromISO(_data["year"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.jan = _data["jan"];
            this.feb = _data["feb"];
            this.mar = _data["mar"];
            this.apr = _data["apr"];
            this.may = _data["may"];
            this.jun = _data["jun"];
            this.jul = _data["jul"];
            this.aug = _data["aug"];
            this.sept = _data["sept"];
            this.nov = _data["nov"];
            this.dec = _data["dec"];
            this.oct = _data["oct"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LeaveByUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveByUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year ? this.year.toString() : undefined as any;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["jan"] = this.jan;
        data["feb"] = this.feb;
        data["mar"] = this.mar;
        data["apr"] = this.apr;
        data["may"] = this.may;
        data["jun"] = this.jun;
        data["jul"] = this.jul;
        data["aug"] = this.aug;
        data["sept"] = this.sept;
        data["nov"] = this.nov;
        data["dec"] = this.dec;
        data["oct"] = this.oct;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface ILeaveByUserDto {
    id: number;
    year: DateTime;
    userId: number;
    tenantId: number;
    jan: number;
    feb: number;
    mar: number;
    apr: number;
    may: number;
    jun: number;
    jul: number;
    aug: number;
    sept: number;
    nov: number;
    dec: number;
    oct: number;
    creationTime: DateTime;
}

export class LeaveDays implements ILeaveDays {
    weekdays!: DateTime;
    isLeave!: boolean;

    constructor(data?: ILeaveDays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekdays = _data["weekdays"] ? DateTime.fromISO(_data["weekdays"].toString()) : undefined as any;
            this.isLeave = _data["isLeave"];
        }
    }

    static fromJS(data: any): LeaveDays {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveDays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekdays"] = this.weekdays ? this.weekdays.toString() : undefined as any;
        data["isLeave"] = this.isLeave;
        return data;
    }
}

export interface ILeaveDays {
    weekdays: DateTime;
    isLeave: boolean;
}

export class LeaveDto implements ILeaveDto {
    totalLeave!: number | undefined;
    leavesPerMonth!: number;
    paidLeave!: number | undefined;
    year!: string | undefined;
    userId!: number;
    tenantId!: number;
    diff!: number;

    constructor(data?: ILeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLeave = _data["totalLeave"];
            this.leavesPerMonth = _data["leavesPerMonth"];
            this.paidLeave = _data["paidLeave"];
            this.year = _data["year"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.diff = _data["diff"];
        }
    }

    static fromJS(data: any): LeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLeave"] = this.totalLeave;
        data["leavesPerMonth"] = this.leavesPerMonth;
        data["paidLeave"] = this.paidLeave;
        data["year"] = this.year;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["diff"] = this.diff;
        return data;
    }
}

export interface ILeaveDto {
    totalLeave: number | undefined;
    leavesPerMonth: number;
    paidLeave: number | undefined;
    year: string | undefined;
    userId: number;
    tenantId: number;
    diff: number;
}

export enum LeaveType {
    HalfDay = 1,
    FullDay = 2,
}

export class LeaveValiditityDto implements ILeaveValiditityDto {
    isDuplicate!: boolean;
    isToDateHoliday!: boolean;
    isFromDateHoliday!: boolean;

    constructor(data?: ILeaveValiditityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDuplicate = _data["isDuplicate"];
            this.isToDateHoliday = _data["isToDateHoliday"];
            this.isFromDateHoliday = _data["isFromDateHoliday"];
        }
    }

    static fromJS(data: any): LeaveValiditityDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveValiditityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDuplicate"] = this.isDuplicate;
        data["isToDateHoliday"] = this.isToDateHoliday;
        data["isFromDateHoliday"] = this.isFromDateHoliday;
        return data;
    }
}

export interface ILeaveValiditityDto {
    isDuplicate: boolean;
    isToDateHoliday: boolean;
    isFromDateHoliday: boolean;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfDesignationUnitDto implements IListResultDtoOfDesignationUnitDto {
    items!: DesignationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfDesignationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DesignationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDesignationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDesignationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDesignationUnitDto {
    items: DesignationUnitDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyDto implements IListResultDtoOfDynamicEntityPropertyDto {
    items!: DynamicEntityPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyDto {
    items: DynamicEntityPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyValueDto implements IListResultDtoOfDynamicEntityPropertyValueDto {
    items!: DynamicEntityPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyValueDto {
    items: DynamicEntityPropertyValueDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyDto implements IListResultDtoOfDynamicPropertyDto {
    items!: DynamicPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyDto {
    items: DynamicPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyValueDto implements IListResultDtoOfDynamicPropertyValueDto {
    items!: DynamicPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyValueDto {
    items: DynamicPropertyValueDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfGetAllAvailableWebhooksOutput implements IListResultDtoOfGetAllAvailableWebhooksOutput {
    items!: GetAllAvailableWebhooksOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllAvailableWebhooksOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllAvailableWebhooksOutput {
    items: GetAllAvailableWebhooksOutput[] | undefined;
}

export class ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput implements IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items!: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllEntitiesHasDynamicPropertyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;
}

export class ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput implements IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items!: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;
}

export class ListResultDtoOfGetAllSubscriptionsOutput implements IListResultDtoOfGetAllSubscriptionsOutput {
    items!: GetAllSubscriptionsOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSubscriptionsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSubscriptionsOutput {
    items: GetAllSubscriptionsOutput[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class ListSelectTimeSheet implements IListSelectTimeSheet {
    dayDate!: string | undefined;
    date!: DateTime;
    dateJS!: DateTime;
    task!: string | undefined;
    taskJobName!: string | undefined;
    hours!: string | undefined;
    description!: string | undefined;
    billability!: ProjectBillingType;
    showInTimesheet!: boolean;
    userTaskId!: number;
    timesheetId!: number;
    approvalLevelTimesheetStatus!: number;
    isAccess!: boolean;
    timesheetSubmitDate!: DateTime;
    reasonId!: number;
    projectBillingType!: ProjectBillingType;

    constructor(data?: IListSelectTimeSheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayDate = _data["dayDate"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.dateJS = _data["dateJS"] ? DateTime.fromISO(_data["dateJS"].toString()) : undefined as any;
            this.task = _data["task"];
            this.taskJobName = _data["taskJobName"];
            this.hours = _data["hours"];
            this.description = _data["description"];
            this.billability = _data["billability"];
            this.showInTimesheet = _data["showInTimesheet"];
            this.userTaskId = _data["userTaskId"];
            this.timesheetId = _data["timesheetId"];
            this.approvalLevelTimesheetStatus = _data["approvalLevelTimesheetStatus"];
            this.isAccess = _data["isAccess"];
            this.timesheetSubmitDate = _data["timesheetSubmitDate"] ? DateTime.fromISO(_data["timesheetSubmitDate"].toString()) : undefined as any;
            this.reasonId = _data["reasonId"];
            this.projectBillingType = _data["projectBillingType"];
        }
    }

    static fromJS(data: any): ListSelectTimeSheet {
        data = typeof data === 'object' ? data : {};
        let result = new ListSelectTimeSheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayDate"] = this.dayDate;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["dateJS"] = this.dateJS ? this.dateJS.toString() : undefined as any;
        data["task"] = this.task;
        data["taskJobName"] = this.taskJobName;
        data["hours"] = this.hours;
        data["description"] = this.description;
        data["billability"] = this.billability;
        data["showInTimesheet"] = this.showInTimesheet;
        data["userTaskId"] = this.userTaskId;
        data["timesheetId"] = this.timesheetId;
        data["approvalLevelTimesheetStatus"] = this.approvalLevelTimesheetStatus;
        data["isAccess"] = this.isAccess;
        data["timesheetSubmitDate"] = this.timesheetSubmitDate ? this.timesheetSubmitDate.toString() : undefined as any;
        data["reasonId"] = this.reasonId;
        data["projectBillingType"] = this.projectBillingType;
        return data;
    }
}

export interface IListSelectTimeSheet {
    dayDate: string | undefined;
    date: DateTime;
    dateJS: DateTime;
    task: string | undefined;
    taskJobName: string | undefined;
    hours: string | undefined;
    description: string | undefined;
    billability: ProjectBillingType;
    showInTimesheet: boolean;
    userTaskId: number;
    timesheetId: number;
    approvalLevelTimesheetStatus: number;
    isAccess: boolean;
    timesheetSubmitDate: DateTime;
    reasonId: number;
    projectBillingType: ProjectBillingType;
}

export class LiveScreenshotCreateSignalRDto implements ILiveScreenshotCreateSignalRDto {
    tenantId!: number | undefined;
    userId!: number;
    screenShotUrl!: string | undefined;
    screenShotThumbnail!: string | undefined;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    liveUserStatus!: number;
    creationTime!: DateTime;

    constructor(data?: ILiveScreenshotCreateSignalRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.screenShotUrl = _data["screenShotUrl"];
            this.screenShotThumbnail = _data["screenShotThumbnail"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.liveUserStatus = _data["liveUserStatus"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LiveScreenshotCreateSignalRDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiveScreenshotCreateSignalRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["screenShotUrl"] = this.screenShotUrl;
        data["screenShotThumbnail"] = this.screenShotThumbnail;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["liveUserStatus"] = this.liveUserStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface ILiveScreenshotCreateSignalRDto {
    tenantId: number | undefined;
    userId: number;
    screenShotUrl: string | undefined;
    screenShotThumbnail: string | undefined;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    liveUserStatus: number;
    creationTime: DateTime;
}

export class LocalCurrencyData implements ILocalCurrencyData {
    currencyCode!: string | undefined;
    currencyRate!: number;

    constructor(data?: ILocalCurrencyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.currencyRate = _data["currencyRate"];
        }
    }

    static fromJS(data: any): LocalCurrencyData {
        data = typeof data === 'object' ? data : {};
        let result = new LocalCurrencyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["currencyRate"] = this.currencyRate;
        return data;
    }
}

export interface ILocalCurrencyData {
    currencyCode: string | undefined;
    currencyRate: number;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class Location implements ILocation {
    displayName!: string | undefined;
    locationType!: string | undefined;
    uniqueIdType!: string | undefined;
    coordinates!: Coordinates;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.locationType = _data["locationType"];
            this.uniqueIdType = _data["uniqueIdType"];
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : undefined as any;
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["locationType"] = this.locationType;
        data["uniqueIdType"] = this.uniqueIdType;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : undefined as any;
        return data;
    }
}

export interface ILocation {
    displayName: string | undefined;
    locationType: string | undefined;
    uniqueIdType: string | undefined;
    coordinates: Coordinates;
}

export class LocationEmailReceiverDto implements ILocationEmailReceiverDto {
    location!: string | undefined;
    locationId!: number;
    userList!: UserDetailsDto[] | undefined;

    constructor(data?: ILocationEmailReceiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationEmailReceiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationEmailReceiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocationEmailReceiverDto {
    location: string | undefined;
    locationId: number;
    userList: UserDetailsDto[] | undefined;
}

export class LocationSetting implements ILocationSetting {
    tenantId!: number;
    groupName!: string | undefined;
    orgName!: string | undefined;
    owner!: string | undefined;
    city!: number;
    state!: number;
    zipCode!: string | undefined;
    countryId!: number | undefined;
    mailInterval!: MailIntervalType;
    emailDispatchTime!: DateTime;
    isDefault!: boolean;
    timeZone!: string | undefined;
    emailRecipients!: string | undefined;
    day!: Days;
    monthlyDate!: number;
    longitude!: string | undefined;
    latitude!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILocationSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.groupName = _data["groupName"];
            this.orgName = _data["orgName"];
            this.owner = _data["owner"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.mailInterval = _data["mailInterval"];
            this.emailDispatchTime = _data["emailDispatchTime"] ? DateTime.fromISO(_data["emailDispatchTime"].toString()) : undefined as any;
            this.isDefault = _data["isDefault"];
            this.timeZone = _data["timeZone"];
            this.emailRecipients = _data["emailRecipients"];
            this.day = _data["day"];
            this.monthlyDate = _data["monthlyDate"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationSetting {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["groupName"] = this.groupName;
        data["orgName"] = this.orgName;
        data["owner"] = this.owner;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["mailInterval"] = this.mailInterval;
        data["emailDispatchTime"] = this.emailDispatchTime ? this.emailDispatchTime.toString() : undefined as any;
        data["isDefault"] = this.isDefault;
        data["timeZone"] = this.timeZone;
        data["emailRecipients"] = this.emailRecipients;
        data["day"] = this.day;
        data["monthlyDate"] = this.monthlyDate;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationSetting {
    tenantId: number;
    groupName: string | undefined;
    orgName: string | undefined;
    owner: string | undefined;
    city: number;
    state: number;
    zipCode: string | undefined;
    countryId: number | undefined;
    mailInterval: MailIntervalType;
    emailDispatchTime: DateTime;
    isDefault: boolean;
    timeZone: string | undefined;
    emailRecipients: string | undefined;
    day: Days;
    monthlyDate: number;
    longitude: string | undefined;
    latitude: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LocationSettingCreateOrEdit implements ILocationSettingCreateOrEdit {
    tenantId!: number;
    groupName!: string | undefined;
    orgName!: string | undefined;
    owner!: string | undefined;
    city!: number;
    state!: number;
    zipCode!: string | undefined;
    countryId!: number;
    mailInterval!: MailIntervalType;
    emailDispatchTime!: DateTime;
    isDefault!: boolean;
    timeZone!: string | undefined;
    emailRecipients!: string | undefined;
    day!: Days;
    monthlyDate!: number;
    longitude!: string | undefined;
    latitude!: string | undefined;
    id!: number | undefined;

    constructor(data?: ILocationSettingCreateOrEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.groupName = _data["groupName"];
            this.orgName = _data["orgName"];
            this.owner = _data["owner"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.mailInterval = _data["mailInterval"];
            this.emailDispatchTime = _data["emailDispatchTime"] ? DateTime.fromISO(_data["emailDispatchTime"].toString()) : undefined as any;
            this.isDefault = _data["isDefault"];
            this.timeZone = _data["timeZone"];
            this.emailRecipients = _data["emailRecipients"];
            this.day = _data["day"];
            this.monthlyDate = _data["monthlyDate"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationSettingCreateOrEdit {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSettingCreateOrEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["groupName"] = this.groupName;
        data["orgName"] = this.orgName;
        data["owner"] = this.owner;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["mailInterval"] = this.mailInterval;
        data["emailDispatchTime"] = this.emailDispatchTime ? this.emailDispatchTime.toString() : undefined as any;
        data["isDefault"] = this.isDefault;
        data["timeZone"] = this.timeZone;
        data["emailRecipients"] = this.emailRecipients;
        data["day"] = this.day;
        data["monthlyDate"] = this.monthlyDate;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationSettingCreateOrEdit {
    tenantId: number;
    groupName: string | undefined;
    orgName: string | undefined;
    owner: string | undefined;
    city: number;
    state: number;
    zipCode: string | undefined;
    countryId: number;
    mailInterval: MailIntervalType;
    emailDispatchTime: DateTime;
    isDefault: boolean;
    timeZone: string | undefined;
    emailRecipients: string | undefined;
    day: Days;
    monthlyDate: number;
    longitude: string | undefined;
    latitude: string | undefined;
    id: number | undefined;
}

export class LocationSettingInfoDto implements ILocationSettingInfoDto {
    id!: number;
    tenantId!: number;
    locationFlag!: string | undefined;
    location!: number;
    countryName!: string | undefined;
    orgAddress!: string | undefined;
    owner!: string | undefined;
    emailReportTime!: DateTime;
    mailInterval!: MailIntervalType;
    groupName!: string | undefined;
    isDefault!: boolean;
    timeZone!: string | undefined;
    emailRecipients!: string | undefined;
    day!: Days;
    monthlyDate!: number;
    locationName!: string | undefined;

    constructor(data?: ILocationSettingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.locationFlag = _data["locationFlag"];
            this.location = _data["location"];
            this.countryName = _data["countryName"];
            this.orgAddress = _data["orgAddress"];
            this.owner = _data["owner"];
            this.emailReportTime = _data["emailReportTime"] ? DateTime.fromISO(_data["emailReportTime"].toString()) : undefined as any;
            this.mailInterval = _data["mailInterval"];
            this.groupName = _data["groupName"];
            this.isDefault = _data["isDefault"];
            this.timeZone = _data["timeZone"];
            this.emailRecipients = _data["emailRecipients"];
            this.day = _data["day"];
            this.monthlyDate = _data["monthlyDate"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): LocationSettingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSettingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["locationFlag"] = this.locationFlag;
        data["location"] = this.location;
        data["countryName"] = this.countryName;
        data["orgAddress"] = this.orgAddress;
        data["owner"] = this.owner;
        data["emailReportTime"] = this.emailReportTime ? this.emailReportTime.toString() : undefined as any;
        data["mailInterval"] = this.mailInterval;
        data["groupName"] = this.groupName;
        data["isDefault"] = this.isDefault;
        data["timeZone"] = this.timeZone;
        data["emailRecipients"] = this.emailRecipients;
        data["day"] = this.day;
        data["monthlyDate"] = this.monthlyDate;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface ILocationSettingInfoDto {
    id: number;
    tenantId: number;
    locationFlag: string | undefined;
    location: number;
    countryName: string | undefined;
    orgAddress: string | undefined;
    owner: string | undefined;
    emailReportTime: DateTime;
    mailInterval: MailIntervalType;
    groupName: string | undefined;
    isDefault: boolean;
    timeZone: string | undefined;
    emailRecipients: string | undefined;
    day: Days;
    monthlyDate: number;
    locationName: string | undefined;
}

export enum MailIntervalType {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class ManualActivityTime implements IManualActivityTime {
    tenantId!: number;
    userId!: number;
    user!: User;
    userActivityTempId!: string | undefined;
    userActivityTemp!: UserActivityTemp;
    totalTimeSpend!: string;
    projectId!: number | undefined;
    project!: Projects;
    userProjectTaskId!: number | undefined;
    userProjectTask!: UserProjectTask;
    productivityTypeId!: number | undefined;
    productivityType!: ProductivityType;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    isManualTimeFlag!: number | undefined;
    description!: string | undefined;
    dateAppliedFor!: DateTime | undefined;
    taskCategoryId!: number | undefined;
    platform!: ManualEntryPlatform;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IManualActivityTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.userActivityTempId = _data["userActivityTempId"];
            this.userActivityTemp = _data["userActivityTemp"] ? UserActivityTemp.fromJS(_data["userActivityTemp"]) : undefined as any;
            this.totalTimeSpend = _data["totalTimeSpend"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.userProjectTask = _data["userProjectTask"] ? UserProjectTask.fromJS(_data["userProjectTask"]) : undefined as any;
            this.productivityTypeId = _data["productivityTypeId"];
            this.productivityType = _data["productivityType"] ? ProductivityType.fromJS(_data["productivityType"]) : undefined as any;
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.isManualTimeFlag = _data["isManualTimeFlag"];
            this.description = _data["description"];
            this.dateAppliedFor = _data["dateAppliedFor"] ? DateTime.fromISO(_data["dateAppliedFor"].toString()) : undefined as any;
            this.taskCategoryId = _data["taskCategoryId"];
            this.platform = _data["platform"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManualActivityTime {
        data = typeof data === 'object' ? data : {};
        let result = new ManualActivityTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["userActivityTempId"] = this.userActivityTempId;
        data["userActivityTemp"] = this.userActivityTemp ? this.userActivityTemp.toJSON() : undefined as any;
        data["totalTimeSpend"] = this.totalTimeSpend;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["userProjectTask"] = this.userProjectTask ? this.userProjectTask.toJSON() : undefined as any;
        data["productivityTypeId"] = this.productivityTypeId;
        data["productivityType"] = this.productivityType ? this.productivityType.toJSON() : undefined as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["isManualTimeFlag"] = this.isManualTimeFlag;
        data["description"] = this.description;
        data["dateAppliedFor"] = this.dateAppliedFor ? this.dateAppliedFor.toString() : undefined as any;
        data["taskCategoryId"] = this.taskCategoryId;
        data["platform"] = this.platform;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IManualActivityTime {
    tenantId: number;
    userId: number;
    user: User;
    userActivityTempId: string | undefined;
    userActivityTemp: UserActivityTemp;
    totalTimeSpend: string;
    projectId: number | undefined;
    project: Projects;
    userProjectTaskId: number | undefined;
    userProjectTask: UserProjectTask;
    productivityTypeId: number | undefined;
    productivityType: ProductivityType;
    startDateTime: DateTime;
    endDateTime: DateTime;
    isManualTimeFlag: number | undefined;
    description: string | undefined;
    dateAppliedFor: DateTime | undefined;
    taskCategoryId: number | undefined;
    platform: ManualEntryPlatform;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ManualEntryDto implements IManualEntryDto {
    productivityType!: number | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    description!: string | undefined;
    projectId!: number | undefined;
    taskId!: number | undefined;
    isApproved!: boolean;
    userId!: number | undefined;
    taskCategoryId!: number | undefined;
    id!: number;

    constructor(data?: IManualEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productivityType = _data["productivityType"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.taskId = _data["taskId"];
            this.isApproved = _data["isApproved"];
            this.userId = _data["userId"];
            this.taskCategoryId = _data["taskCategoryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ManualEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productivityType"] = this.productivityType;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["taskId"] = this.taskId;
        data["isApproved"] = this.isApproved;
        data["userId"] = this.userId;
        data["taskCategoryId"] = this.taskCategoryId;
        data["id"] = this.id;
        return data;
    }
}

export interface IManualEntryDto {
    productivityType: number | undefined;
    startTime: DateTime;
    endTime: DateTime;
    description: string | undefined;
    projectId: number | undefined;
    taskId: number | undefined;
    isApproved: boolean;
    userId: number | undefined;
    taskCategoryId: number | undefined;
    id: number;
}

export enum ManualEntryPlatform {
    Web = 1,
    Mobile = 2,
}

export class ManualTaskForTimesheet implements IManualTaskForTimesheet {
    taskId!: number;
    taskName!: string | undefined;
    taskStateId!: number | undefined;
    billableType!: ProjectBillingType;

    constructor(data?: IManualTaskForTimesheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.taskStateId = _data["taskStateId"];
            this.billableType = _data["billableType"];
        }
    }

    static fromJS(data: any): ManualTaskForTimesheet {
        data = typeof data === 'object' ? data : {};
        let result = new ManualTaskForTimesheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["taskStateId"] = this.taskStateId;
        data["billableType"] = this.billableType;
        return data;
    }
}

export interface IManualTaskForTimesheet {
    taskId: number;
    taskName: string | undefined;
    taskStateId: number | undefined;
    billableType: ProjectBillingType;
}

export class ManuallyCalculationTimeAndAttendanceDto implements IManuallyCalculationTimeAndAttendanceDto {
    reportDate!: DateTime;
    employeeName!: string | undefined;
    location!: string | undefined;
    checkIn!: string | undefined;
    checkOut!: string | undefined;
    timeAtWork!: string;
    activeTime!: string;
    idealTime!: string;

    constructor(data?: IManuallyCalculationTimeAndAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : undefined as any;
            this.employeeName = _data["employeeName"];
            this.location = _data["location"];
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
            this.timeAtWork = _data["timeAtWork"];
            this.activeTime = _data["activeTime"];
            this.idealTime = _data["idealTime"];
        }
    }

    static fromJS(data: any): ManuallyCalculationTimeAndAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManuallyCalculationTimeAndAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : undefined as any;
        data["employeeName"] = this.employeeName;
        data["location"] = this.location;
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        data["timeAtWork"] = this.timeAtWork;
        data["activeTime"] = this.activeTime;
        data["idealTime"] = this.idealTime;
        return data;
    }
}

export interface IManuallyCalculationTimeAndAttendanceDto {
    reportDate: DateTime;
    employeeName: string | undefined;
    location: string | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    timeAtWork: string;
    activeTime: string;
    idealTime: string;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class MarkTaskInputDto implements IMarkTaskInputDto {
    projectTaskId!: number;
    tenantId!: number;
    userId!: number;

    constructor(data?: IMarkTaskInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTaskId = _data["projectTaskId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkTaskInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTaskInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTaskId"] = this.projectTaskId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkTaskInputDto {
    projectTaskId: number;
    tenantId: number;
    userId: number;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class MemberAllocationDetailDto implements IMemberAllocationDetailDto {
    userId!: number;
    name!: string | undefined;
    role!: string | undefined;
    profileImage!: string | undefined;
    joiningDate!: string | undefined;
    experienceYears!: number;
    experienceMonths!: number;
    experience!: string | undefined;
    currentBillingStatus!: string | undefined;
    availableFrom!: string | undefined;
    availabilityStatus!: AvailabilityStatus;
    currentProjects!: number;
    assignedLearningPathCount!: number;
    cvFileName!: string | undefined;
    cvFilePath!: string | undefined;
    cvFileType!: string | undefined;
    cvFileSize!: number;
    allocations!: UserProjectAllocationDto[] | undefined;

    constructor(data?: IMemberAllocationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.profileImage = _data["profileImage"];
            this.joiningDate = _data["joiningDate"];
            this.experienceYears = _data["experienceYears"];
            this.experienceMonths = _data["experienceMonths"];
            this.experience = _data["experience"];
            this.currentBillingStatus = _data["currentBillingStatus"];
            this.availableFrom = _data["availableFrom"];
            this.availabilityStatus = _data["availabilityStatus"];
            this.currentProjects = _data["currentProjects"];
            this.assignedLearningPathCount = _data["assignedLearningPathCount"];
            this.cvFileName = _data["cvFileName"];
            this.cvFilePath = _data["cvFilePath"];
            this.cvFileType = _data["cvFileType"];
            this.cvFileSize = _data["cvFileSize"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(UserProjectAllocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberAllocationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberAllocationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["role"] = this.role;
        data["profileImage"] = this.profileImage;
        data["joiningDate"] = this.joiningDate;
        data["experienceYears"] = this.experienceYears;
        data["experienceMonths"] = this.experienceMonths;
        data["experience"] = this.experience;
        data["currentBillingStatus"] = this.currentBillingStatus;
        data["availableFrom"] = this.availableFrom;
        data["availabilityStatus"] = this.availabilityStatus;
        data["currentProjects"] = this.currentProjects;
        data["assignedLearningPathCount"] = this.assignedLearningPathCount;
        data["cvFileName"] = this.cvFileName;
        data["cvFilePath"] = this.cvFilePath;
        data["cvFileType"] = this.cvFileType;
        data["cvFileSize"] = this.cvFileSize;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMemberAllocationDetailDto {
    userId: number;
    name: string | undefined;
    role: string | undefined;
    profileImage: string | undefined;
    joiningDate: string | undefined;
    experienceYears: number;
    experienceMonths: number;
    experience: string | undefined;
    currentBillingStatus: string | undefined;
    availableFrom: string | undefined;
    availabilityStatus: AvailabilityStatus;
    currentProjects: number;
    assignedLearningPathCount: number;
    cvFileName: string | undefined;
    cvFilePath: string | undefined;
    cvFileType: string | undefined;
    cvFileSize: number;
    allocations: UserProjectAllocationDto[] | undefined;
}

export class MemberAllocationListDto implements IMemberAllocationListDto {
    id!: number;
    name!: string | undefined;
    role!: string | undefined;
    department!: string | undefined;
    percentAllocated!: number;
    totalExperience!: string | undefined;
    profileImage!: string | undefined;
    experienceYears!: number;
    experienceMonths!: number;

    constructor(data?: IMemberAllocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.department = _data["department"];
            this.percentAllocated = _data["percentAllocated"];
            this.totalExperience = _data["totalExperience"];
            this.profileImage = _data["profileImage"];
            this.experienceYears = _data["experienceYears"];
            this.experienceMonths = _data["experienceMonths"];
        }
    }

    static fromJS(data: any): MemberAllocationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberAllocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        data["department"] = this.department;
        data["percentAllocated"] = this.percentAllocated;
        data["totalExperience"] = this.totalExperience;
        data["profileImage"] = this.profileImage;
        data["experienceYears"] = this.experienceYears;
        data["experienceMonths"] = this.experienceMonths;
        return data;
    }
}

export interface IMemberAllocationListDto {
    id: number;
    name: string | undefined;
    role: string | undefined;
    department: string | undefined;
    percentAllocated: number;
    totalExperience: string | undefined;
    profileImage: string | undefined;
    experienceYears: number;
    experienceMonths: number;
}

export class MemberAllocationProjectLookupDto implements IMemberAllocationProjectLookupDto {
    id!: number;
    name!: string | undefined;
    isBillable!: boolean;

    constructor(data?: IMemberAllocationProjectLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): MemberAllocationProjectLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberAllocationProjectLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isBillable"] = this.isBillable;
        return data;
    }
}

export interface IMemberAllocationProjectLookupDto {
    id: number;
    name: string | undefined;
    isBillable: boolean;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class MobileGetTaskStatusInput implements IMobileGetTaskStatusInput {
    userId!: number;
    tenantId!: number;
    filterProjectIds!: number[] | undefined;
    filterTask!: string | undefined;

    constructor(data?: IMobileGetTaskStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["filterProjectIds"])) {
                this.filterProjectIds = [] as any;
                for (let item of _data["filterProjectIds"])
                    this.filterProjectIds!.push(item);
            }
            this.filterTask = _data["filterTask"];
        }
    }

    static fromJS(data: any): MobileGetTaskStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new MobileGetTaskStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.filterProjectIds)) {
            data["filterProjectIds"] = [];
            for (let item of this.filterProjectIds)
                data["filterProjectIds"].push(item);
        }
        data["filterTask"] = this.filterTask;
        return data;
    }
}

export interface IMobileGetTaskStatusInput {
    userId: number;
    tenantId: number;
    filterProjectIds: number[] | undefined;
    filterTask: string | undefined;
}

export class MobileNotificationInputDto implements IMobileNotificationInputDto {
    tenantId!: number | undefined;
    userId!: number | undefined;
    notifyIcon!: string | undefined;
    notifyMessage!: string | undefined;
    description!: string | undefined;
    module!: string | undefined;
    moduleId!: NotificationModule;
    isRead!: boolean;
    id!: number;

    constructor(data?: IMobileNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.notifyIcon = _data["notifyIcon"];
            this.notifyMessage = _data["notifyMessage"];
            this.description = _data["description"];
            this.module = _data["module"];
            this.moduleId = _data["moduleId"];
            this.isRead = _data["isRead"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MobileNotificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobileNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["notifyIcon"] = this.notifyIcon;
        data["notifyMessage"] = this.notifyMessage;
        data["description"] = this.description;
        data["module"] = this.module;
        data["moduleId"] = this.moduleId;
        data["isRead"] = this.isRead;
        data["id"] = this.id;
        return data;
    }
}

export interface IMobileNotificationInputDto {
    tenantId: number | undefined;
    userId: number | undefined;
    notifyIcon: string | undefined;
    notifyMessage: string | undefined;
    description: string | undefined;
    module: string | undefined;
    moduleId: NotificationModule;
    isRead: boolean;
    id: number;
}

export class MonthViewDto implements IMonthViewDto {
    outPutMonthViewDetails!: OutPutMonthViewDto[] | undefined;
    holidayList!: Holidays[] | undefined;
    leavesList!: LeaveDays[] | undefined;
    headerSubmitedHours!: string;

    constructor(data?: IMonthViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["outPutMonthViewDetails"])) {
                this.outPutMonthViewDetails = [] as any;
                for (let item of _data["outPutMonthViewDetails"])
                    this.outPutMonthViewDetails!.push(OutPutMonthViewDto.fromJS(item));
            }
            if (Array.isArray(_data["holidayList"])) {
                this.holidayList = [] as any;
                for (let item of _data["holidayList"])
                    this.holidayList!.push(Holidays.fromJS(item));
            }
            if (Array.isArray(_data["leavesList"])) {
                this.leavesList = [] as any;
                for (let item of _data["leavesList"])
                    this.leavesList!.push(LeaveDays.fromJS(item));
            }
            this.headerSubmitedHours = _data["headerSubmitedHours"];
        }
    }

    static fromJS(data: any): MonthViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.outPutMonthViewDetails)) {
            data["outPutMonthViewDetails"] = [];
            for (let item of this.outPutMonthViewDetails)
                data["outPutMonthViewDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayList)) {
            data["holidayList"] = [];
            for (let item of this.holidayList)
                data["holidayList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.leavesList)) {
            data["leavesList"] = [];
            for (let item of this.leavesList)
                data["leavesList"].push(item ? item.toJSON() : undefined as any);
        }
        data["headerSubmitedHours"] = this.headerSubmitedHours;
        return data;
    }
}

export interface IMonthViewDto {
    outPutMonthViewDetails: OutPutMonthViewDto[] | undefined;
    holidayList: Holidays[] | undefined;
    leavesList: LeaveDays[] | undefined;
    headerSubmitedHours: string;
}

export class MonthlyCalculationData implements IMonthlyCalculationData {
    date!: DateTime;
    calculatedata!: OutPutTimeAndAttendanceUserDaillyCalculationDto;
    isWorkingDays!: boolean;
    isPublicHoliday!: boolean;

    constructor(data?: IMonthlyCalculationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.calculatedata = _data["calculatedata"] ? OutPutTimeAndAttendanceUserDaillyCalculationDto.fromJS(_data["calculatedata"]) : undefined as any;
            this.isWorkingDays = _data["isWorkingDays"];
            this.isPublicHoliday = _data["isPublicHoliday"];
        }
    }

    static fromJS(data: any): MonthlyCalculationData {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyCalculationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["calculatedata"] = this.calculatedata ? this.calculatedata.toJSON() : undefined as any;
        data["isWorkingDays"] = this.isWorkingDays;
        data["isPublicHoliday"] = this.isPublicHoliday;
        return data;
    }
}

export interface IMonthlyCalculationData {
    date: DateTime;
    calculatedata: OutPutTimeAndAttendanceUserDaillyCalculationDto;
    isWorkingDays: boolean;
    isPublicHoliday: boolean;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class MyProfileOutput implements IMyProfileOutput {
    onBoardingId!: number;
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    roleName!: string[] | undefined;
    managerName!: string | undefined;
    designation!: string | undefined;
    emailAddress!: string | undefined;
    password!: string | undefined;
    imagePath!: string | undefined;
    fullName!: string | undefined;
    flag!: boolean;
    employeeId!: string | undefined;

    constructor(data?: IMyProfileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onBoardingId = _data["onBoardingId"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["roleName"])) {
                this.roleName = [] as any;
                for (let item of _data["roleName"])
                    this.roleName!.push(item);
            }
            this.managerName = _data["managerName"];
            this.designation = _data["designation"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.imagePath = _data["imagePath"];
            this.fullName = _data["fullName"];
            this.flag = _data["flag"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): MyProfileOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MyProfileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onBoardingId"] = this.onBoardingId;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.roleName)) {
            data["roleName"] = [];
            for (let item of this.roleName)
                data["roleName"].push(item);
        }
        data["managerName"] = this.managerName;
        data["designation"] = this.designation;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["imagePath"] = this.imagePath;
        data["fullName"] = this.fullName;
        data["flag"] = this.flag;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IMyProfileOutput {
    onBoardingId: number;
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    roleName: string[] | undefined;
    managerName: string | undefined;
    designation: string | undefined;
    emailAddress: string | undefined;
    password: string | undefined;
    imagePath: string | undefined;
    fullName: string | undefined;
    flag: boolean;
    employeeId: string | undefined;
}

export class MyTimesheetGridDto implements IMyTimesheetGridDto {
    myTimesheetGridDetails!: PagedResultDtoOfTimeSheetDto;
    myTimesheetHeaderFiledDetails!: MyTimesheetHeaderFiledDto;

    constructor(data?: IMyTimesheetGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myTimesheetGridDetails = _data["myTimesheetGridDetails"] ? PagedResultDtoOfTimeSheetDto.fromJS(_data["myTimesheetGridDetails"]) : undefined as any;
            this.myTimesheetHeaderFiledDetails = _data["myTimesheetHeaderFiledDetails"] ? MyTimesheetHeaderFiledDto.fromJS(_data["myTimesheetHeaderFiledDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): MyTimesheetGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimesheetGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myTimesheetGridDetails"] = this.myTimesheetGridDetails ? this.myTimesheetGridDetails.toJSON() : undefined as any;
        data["myTimesheetHeaderFiledDetails"] = this.myTimesheetHeaderFiledDetails ? this.myTimesheetHeaderFiledDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IMyTimesheetGridDto {
    myTimesheetGridDetails: PagedResultDtoOfTimeSheetDto;
    myTimesheetHeaderFiledDetails: MyTimesheetHeaderFiledDto;
}

export class MyTimesheetHeaderFiledDto implements IMyTimesheetHeaderFiledDto {
    pendingTimesheet!: number;
    rejectedTimesheet!: number;
    submitedTimesheet!: number;

    constructor(data?: IMyTimesheetHeaderFiledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingTimesheet = _data["pendingTimesheet"];
            this.rejectedTimesheet = _data["rejectedTimesheet"];
            this.submitedTimesheet = _data["submitedTimesheet"];
        }
    }

    static fromJS(data: any): MyTimesheetHeaderFiledDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimesheetHeaderFiledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingTimesheet"] = this.pendingTimesheet;
        data["rejectedTimesheet"] = this.rejectedTimesheet;
        data["submitedTimesheet"] = this.submitedTimesheet;
        return data;
    }
}

export interface IMyTimesheetHeaderFiledDto {
    pendingTimesheet: number;
    rejectedTimesheet: number;
    submitedTimesheet: number;
}

export class MyTimesheetStatsDto implements IMyTimesheetStatsDto {
    totalPendingTimesheets!: number;
    totalRejectedTimesheets!: number;

    constructor(data?: IMyTimesheetStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPendingTimesheets = _data["totalPendingTimesheets"];
            this.totalRejectedTimesheets = _data["totalRejectedTimesheets"];
        }
    }

    static fromJS(data: any): MyTimesheetStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimesheetStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPendingTimesheets"] = this.totalPendingTimesheets;
        data["totalRejectedTimesheets"] = this.totalRejectedTimesheets;
        return data;
    }
}

export interface IMyTimesheetStatsDto {
    totalPendingTimesheets: number;
    totalRejectedTimesheets: number;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueOrganization implements INameValueOrganization {
    name!: string | undefined;
    value!: string | undefined;
    role!: string | undefined;
    emailId!: string | undefined;
    profilePictureId!: string | undefined;
    profileImage!: string | undefined;

    constructor(data?: INameValueOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.role = _data["role"];
            this.emailId = _data["emailId"];
            this.profilePictureId = _data["profilePictureId"];
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): NameValueOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["role"] = this.role;
        data["emailId"] = this.emailId;
        data["profilePictureId"] = this.profilePictureId;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface INameValueOrganization {
    name: string | undefined;
    value: string | undefined;
    role: string | undefined;
    emailId: string | undefined;
    profilePictureId: string | undefined;
    profileImage: string | undefined;
}

export class NextLevelApprovalDto implements INextLevelApprovalDto {
    nextLevelUserName!: string | undefined;
    nextLevelUserImage!: string | undefined;
    nextLevelUserRole!: string | undefined;

    constructor(data?: INextLevelApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextLevelUserName = _data["nextLevelUserName"];
            this.nextLevelUserImage = _data["nextLevelUserImage"];
            this.nextLevelUserRole = _data["nextLevelUserRole"];
        }
    }

    static fromJS(data: any): NextLevelApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new NextLevelApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextLevelUserName"] = this.nextLevelUserName;
        data["nextLevelUserImage"] = this.nextLevelUserImage;
        data["nextLevelUserRole"] = this.nextLevelUserRole;
        return data;
    }
}

export interface INextLevelApprovalDto {
    nextLevelUserName: string | undefined;
    nextLevelUserImage: string | undefined;
    nextLevelUserRole: string | undefined;
}

export class NonBillableReasonDto implements INonBillableReasonDto {
    id!: number;
    reason!: string | undefined;
    projectId!: number;
    tenantId!: number;
    isSeed!: boolean;

    constructor(data?: INonBillableReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.projectId = _data["projectId"];
            this.tenantId = _data["tenantId"];
            this.isSeed = _data["isSeed"];
        }
    }

    static fromJS(data: any): NonBillableReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonBillableReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["projectId"] = this.projectId;
        data["tenantId"] = this.tenantId;
        data["isSeed"] = this.isSeed;
        return data;
    }
}

export interface INonBillableReasonDto {
    id: number;
    reason: string | undefined;
    projectId: number;
    tenantId: number;
    isSeed: boolean;
}

export class NotFIllTImesheet implements INotFIllTImesheet {
    userId!: number;
    projectName!: string | undefined;
    employeeName!: string | undefined;
    employeeId!: string | undefined;
    projectRole!: string | undefined;
    timesheetStatus!: string | undefined;
    timesheetDate!: DateTime;
    date!: DateTime;
    isWorkingDay!: boolean;

    constructor(data?: INotFIllTImesheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectName = _data["projectName"];
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.projectRole = _data["projectRole"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.timesheetDate = _data["timesheetDate"] ? DateTime.fromISO(_data["timesheetDate"].toString()) : undefined as any;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.isWorkingDay = _data["isWorkingDay"];
        }
    }

    static fromJS(data: any): NotFIllTImesheet {
        data = typeof data === 'object' ? data : {};
        let result = new NotFIllTImesheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectName"] = this.projectName;
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["projectRole"] = this.projectRole;
        data["timesheetStatus"] = this.timesheetStatus;
        data["timesheetDate"] = this.timesheetDate ? this.timesheetDate.toString() : undefined as any;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["isWorkingDay"] = this.isWorkingDay;
        return data;
    }
}

export interface INotFIllTImesheet {
    userId: number;
    projectName: string | undefined;
    employeeName: string | undefined;
    employeeId: string | undefined;
    projectRole: string | undefined;
    timesheetStatus: string | undefined;
    timesheetDate: DateTime;
    date: DateTime;
    isWorkingDay: boolean;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationModule {
    CheckIn = 1,
    CheckOut = 2,
    Project = 3,
    Timesheet = 4,
    TimeOff = 5,
    Task = 6,
}

export class NotificationRequest implements INotificationRequest {
    text!: string | undefined;
    badge!: number;
    tags!: string[] | undefined;
    silent!: boolean;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.badge = _data["badge"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.silent = _data["silent"];
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["badge"] = this.badge;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["silent"] = this.silent;
        return data;
    }
}

export interface INotificationRequest {
    text: string | undefined;
    badge: number;
    tags: string[] | undefined;
    silent: boolean;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class NumberOfEmployeeDto implements INumberOfEmployeeDto {
    totalEmployee!: number;
    checkInCount!: number;
    slackCount!: number;
    currentlyInActiveUserCount!: number;

    constructor(data?: INumberOfEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEmployee = _data["totalEmployee"];
            this.checkInCount = _data["checkInCount"];
            this.slackCount = _data["slackCount"];
            this.currentlyInActiveUserCount = _data["currentlyInActiveUserCount"];
        }
    }

    static fromJS(data: any): NumberOfEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberOfEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEmployee"] = this.totalEmployee;
        data["checkInCount"] = this.checkInCount;
        data["slackCount"] = this.slackCount;
        data["currentlyInActiveUserCount"] = this.currentlyInActiveUserCount;
        return data;
    }
}

export interface INumberOfEmployeeDto {
    totalEmployee: number;
    checkInCount: number;
    slackCount: number;
    currentlyInActiveUserCount: number;
}

export class OfflineScreenShotDataForMacDto implements IOfflineScreenShotDataForMacDto {
    tenantId!: number | undefined;
    userId!: number | undefined;
    screenShotUrl!: string | undefined;
    blobContainerName!: string | undefined;
    screenShotTime!: string | undefined;
    appName!: string | undefined;
    appIcon!: string | undefined;
    isLiveScreenShot!: boolean;
    mouseClick!: number;
    keyBoardPress!: number;
    screenShotInterval!: number;
    machineName!: string | undefined;
    screenShotThumbnail!: string | undefined;

    constructor(data?: IOfflineScreenShotDataForMacDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.screenShotUrl = _data["screenShotUrl"];
            this.blobContainerName = _data["blobContainerName"];
            this.screenShotTime = _data["screenShotTime"];
            this.appName = _data["appName"];
            this.appIcon = _data["appIcon"];
            this.isLiveScreenShot = _data["isLiveScreenShot"];
            this.mouseClick = _data["mouseClick"];
            this.keyBoardPress = _data["keyBoardPress"];
            this.screenShotInterval = _data["screenShotInterval"];
            this.machineName = _data["machineName"];
            this.screenShotThumbnail = _data["screenShotThumbnail"];
        }
    }

    static fromJS(data: any): OfflineScreenShotDataForMacDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineScreenShotDataForMacDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["screenShotUrl"] = this.screenShotUrl;
        data["blobContainerName"] = this.blobContainerName;
        data["screenShotTime"] = this.screenShotTime;
        data["appName"] = this.appName;
        data["appIcon"] = this.appIcon;
        data["isLiveScreenShot"] = this.isLiveScreenShot;
        data["mouseClick"] = this.mouseClick;
        data["keyBoardPress"] = this.keyBoardPress;
        data["screenShotInterval"] = this.screenShotInterval;
        data["machineName"] = this.machineName;
        data["screenShotThumbnail"] = this.screenShotThumbnail;
        return data;
    }
}

export interface IOfflineScreenShotDataForMacDto {
    tenantId: number | undefined;
    userId: number | undefined;
    screenShotUrl: string | undefined;
    blobContainerName: string | undefined;
    screenShotTime: string | undefined;
    appName: string | undefined;
    appIcon: string | undefined;
    isLiveScreenShot: boolean;
    mouseClick: number;
    keyBoardPress: number;
    screenShotInterval: number;
    machineName: string | undefined;
    screenShotThumbnail: string | undefined;
}

export class OfflineScreenShotDto implements IOfflineScreenShotDto {
    dataFile!: OfflineScreenShotDataForMacDto[] | undefined;

    constructor(data?: IOfflineScreenShotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataFile"])) {
                this.dataFile = [] as any;
                for (let item of _data["dataFile"])
                    this.dataFile!.push(OfflineScreenShotDataForMacDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfflineScreenShotDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineScreenShotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataFile)) {
            data["dataFile"] = [];
            for (let item of this.dataFile)
                data["dataFile"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOfflineScreenShotDto {
    dataFile: OfflineScreenShotDataForMacDto[] | undefined;
}

export enum OfflineTimeType {
    Enable = 1,
    Disable = 2,
    ApproveOnly = 3,
}

export class OfflineUserDto implements IOfflineUserDto {
    tenantId!: number;
    userId!: number;
    userStatusId!: UserStatusEnum;
    creationTime!: DateTime;

    constructor(data?: IOfflineUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userStatusId = _data["userStatusId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OfflineUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userStatusId"] = this.userStatusId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IOfflineUserDto {
    tenantId: number;
    userId: number;
    userStatusId: UserStatusEnum;
    creationTime: DateTime;
}

export class OfflineUserStatusDto implements IOfflineUserStatusDto {
    dataFile!: OfflineUserDto[] | undefined;

    constructor(data?: IOfflineUserStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataFile"])) {
                this.dataFile = [] as any;
                for (let item of _data["dataFile"])
                    this.dataFile!.push(OfflineUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfflineUserStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineUserStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataFile)) {
            data["dataFile"] = [];
            for (let item of this.dataFile)
                data["dataFile"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOfflineUserStatusDto {
    dataFile: OfflineUserDto[] | undefined;
}

export class OnBoardingCreateOrEditDto implements IOnBoardingCreateOrEditDto {
    organizationName!: string | undefined;
    industryType!: string | undefined;
    teamSizeId!: number | undefined;
    userId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IOnBoardingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.industryType = _data["industryType"];
            this.teamSizeId = _data["teamSizeId"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OnBoardingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnBoardingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["industryType"] = this.industryType;
        data["teamSizeId"] = this.teamSizeId;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOnBoardingCreateOrEditDto {
    organizationName: string | undefined;
    industryType: string | undefined;
    teamSizeId: number | undefined;
    userId: number | undefined;
    id: number | undefined;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
}

export class OpenIdKeyDto implements IOpenIdKeyDto {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IOpenIdKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): OpenIdKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IOpenIdKeyDto {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class OragnizationDescriptionDto implements IOragnizationDescriptionDto {
    organizationUnitId!: number;
    description!: string | undefined;
    flag!: string | undefined;
    tenantId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IOragnizationDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.flag = _data["flag"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OragnizationDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OragnizationDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["flag"] = this.flag;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOragnizationDescriptionDto {
    organizationUnitId: number;
    description: string | undefined;
    flag: string | undefined;
    tenantId: number | undefined;
    id: number | undefined;
}

export class OrganizationUnit implements IOrganizationUnit {
    tenantId!: number | undefined;
    parent!: OrganizationUnit;
    parentId!: number | undefined;
    code!: string;
    displayName!: string;
    children!: OrganizationUnit[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.parent = _data["parent"] ? OrganizationUnit.fromJS(_data["parent"]) : undefined as any;
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(OrganizationUnit.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnit {
    tenantId: number | undefined;
    parent: OrganizationUnit;
    parentId: number | undefined;
    code: string;
    displayName: string;
    children: OrganizationUnit[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    profileImage!: string | undefined;
    tenantId!: number;
    oragnizationDescriptions!: OragnizationDescriptionDto;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.profileImage = _data["profileImage"];
            this.tenantId = _data["tenantId"];
            this.oragnizationDescriptions = _data["oragnizationDescriptions"] ? OragnizationDescriptionDto.fromJS(_data["oragnizationDescriptions"]) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["profileImage"] = this.profileImage;
        data["tenantId"] = this.tenantId;
        data["oragnizationDescriptions"] = this.oragnizationDescriptions ? this.oragnizationDescriptions.toJSON() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    profileImage: string | undefined;
    tenantId: number;
    oragnizationDescriptions: OragnizationDescriptionDto;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    profileImage!: string | undefined;
    addedTime!: DateTime;
    userRoles!: string | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.profileImage = _data["profileImage"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : undefined as any;
            this.userRoles = _data["userRoles"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["profileImage"] = this.profileImage;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : undefined as any;
        data["userRoles"] = this.userRoles;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    profileImage: string | undefined;
    addedTime: DateTime;
    userRoles: string | undefined;
    id: number;
}

export class Organizer implements IOrganizer {
    emailAddress!: EmailAddress;

    constructor(data?: IOrganizer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"] ? EmailAddress.fromJS(_data["emailAddress"]) : undefined as any;
        }
    }

    static fromJS(data: any): Organizer {
        data = typeof data === 'object' ? data : {};
        let result = new Organizer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress ? this.emailAddress.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganizer {
    emailAddress: EmailAddress;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class OutPutDayViewDto implements IOutPutDayViewDto {
    outPutGetAllTaskDetails!: OutPutGetAllTaskDetailDto[] | undefined;
    holidayList!: Holidays[] | undefined;
    leavesList!: LeaveDays[] | undefined;
    headerSubmitedHours!: string;

    constructor(data?: IOutPutDayViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["outPutGetAllTaskDetails"])) {
                this.outPutGetAllTaskDetails = [] as any;
                for (let item of _data["outPutGetAllTaskDetails"])
                    this.outPutGetAllTaskDetails!.push(OutPutGetAllTaskDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["holidayList"])) {
                this.holidayList = [] as any;
                for (let item of _data["holidayList"])
                    this.holidayList!.push(Holidays.fromJS(item));
            }
            if (Array.isArray(_data["leavesList"])) {
                this.leavesList = [] as any;
                for (let item of _data["leavesList"])
                    this.leavesList!.push(LeaveDays.fromJS(item));
            }
            this.headerSubmitedHours = _data["headerSubmitedHours"];
        }
    }

    static fromJS(data: any): OutPutDayViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutDayViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.outPutGetAllTaskDetails)) {
            data["outPutGetAllTaskDetails"] = [];
            for (let item of this.outPutGetAllTaskDetails)
                data["outPutGetAllTaskDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayList)) {
            data["holidayList"] = [];
            for (let item of this.holidayList)
                data["holidayList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.leavesList)) {
            data["leavesList"] = [];
            for (let item of this.leavesList)
                data["leavesList"].push(item ? item.toJSON() : undefined as any);
        }
        data["headerSubmitedHours"] = this.headerSubmitedHours;
        return data;
    }
}

export interface IOutPutDayViewDto {
    outPutGetAllTaskDetails: OutPutGetAllTaskDetailDto[] | undefined;
    holidayList: Holidays[] | undefined;
    leavesList: LeaveDays[] | undefined;
    headerSubmitedHours: string;
}

export class OutPutGetAllTaskDetailDto implements IOutPutGetAllTaskDetailDto {
    userTaskId!: number;
    taskStatus!: number | undefined;
    taskJobId!: number | undefined;
    billabilityStatus!: number | undefined;
    totalTime!: string;
    totalTaskTrackedTime!: string;
    taskName!: string | undefined;
    jobName!: string | undefined;
    taskDescription!: string | undefined;
    isManualTimeSheet!: boolean;
    includeInTimesheet!: boolean;
    isTaskDelete!: boolean;
    creationDay!: DateTime | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    projectCreationDate!: DateTime | undefined;
    fromDate!: DateTime[] | undefined;
    toDate!: DateTime[] | undefined;
    projectBillingType!: ProjectBillingType;
    daysListDtos!: DaysListDto[] | undefined;
    taskHistoryDate!: DateTime[] | undefined;
    projectBillingTypeAccess!: boolean;
    id!: number;

    constructor(data?: IOutPutGetAllTaskDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTaskId = _data["userTaskId"];
            this.taskStatus = _data["taskStatus"];
            this.taskJobId = _data["taskJobId"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.totalTime = _data["totalTime"];
            this.totalTaskTrackedTime = _data["totalTaskTrackedTime"];
            this.taskName = _data["taskName"];
            this.jobName = _data["jobName"];
            this.taskDescription = _data["taskDescription"];
            this.isManualTimeSheet = _data["isManualTimeSheet"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.isTaskDelete = _data["isTaskDelete"];
            this.creationDay = _data["creationDay"] ? DateTime.fromISO(_data["creationDay"].toString()) : undefined as any;
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["fromDate"])) {
                this.fromDate = [] as any;
                for (let item of _data["fromDate"])
                    this.fromDate!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["toDate"])) {
                this.toDate = [] as any;
                for (let item of _data["toDate"])
                    this.toDate!.push(DateTime.fromISO(item));
            }
            this.projectBillingType = _data["projectBillingType"];
            if (Array.isArray(_data["daysListDtos"])) {
                this.daysListDtos = [] as any;
                for (let item of _data["daysListDtos"])
                    this.daysListDtos!.push(DaysListDto.fromJS(item));
            }
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            this.projectBillingTypeAccess = _data["projectBillingTypeAccess"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutPutGetAllTaskDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutGetAllTaskDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTaskId"] = this.userTaskId;
        data["taskStatus"] = this.taskStatus;
        data["taskJobId"] = this.taskJobId;
        data["billabilityStatus"] = this.billabilityStatus;
        data["totalTime"] = this.totalTime;
        data["totalTaskTrackedTime"] = this.totalTaskTrackedTime;
        data["taskName"] = this.taskName;
        data["jobName"] = this.jobName;
        data["taskDescription"] = this.taskDescription;
        data["isManualTimeSheet"] = this.isManualTimeSheet;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["isTaskDelete"] = this.isTaskDelete;
        data["creationDay"] = this.creationDay ? this.creationDay.toString() : undefined as any;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        if (Array.isArray(this.fromDate)) {
            data["fromDate"] = [];
            for (let item of this.fromDate)
                data["fromDate"].push(item.toString());
        }
        if (Array.isArray(this.toDate)) {
            data["toDate"] = [];
            for (let item of this.toDate)
                data["toDate"].push(item.toString());
        }
        data["projectBillingType"] = this.projectBillingType;
        if (Array.isArray(this.daysListDtos)) {
            data["daysListDtos"] = [];
            for (let item of this.daysListDtos)
                data["daysListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        data["projectBillingTypeAccess"] = this.projectBillingTypeAccess;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutPutGetAllTaskDetailDto {
    userTaskId: number;
    taskStatus: number | undefined;
    taskJobId: number | undefined;
    billabilityStatus: number | undefined;
    totalTime: string;
    totalTaskTrackedTime: string;
    taskName: string | undefined;
    jobName: string | undefined;
    taskDescription: string | undefined;
    isManualTimeSheet: boolean;
    includeInTimesheet: boolean;
    isTaskDelete: boolean;
    creationDay: DateTime | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    projectCreationDate: DateTime | undefined;
    fromDate: DateTime[] | undefined;
    toDate: DateTime[] | undefined;
    projectBillingType: ProjectBillingType;
    daysListDtos: DaysListDto[] | undefined;
    taskHistoryDate: DateTime[] | undefined;
    projectBillingTypeAccess: boolean;
    id: number;
}

export class OutPutGetApplicationsDetailsDto implements IOutPutGetApplicationsDetailsDto {
    userId!: number | undefined;
    tenantId!: number;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    applicationType!: ApplicationTypeEnum;
    totalTimeSpend!: string;
    startTime!: DateTime | undefined;
    isWebSite!: boolean;

    constructor(data?: IOutPutGetApplicationsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.applicationType = _data["applicationType"];
            this.totalTimeSpend = _data["totalTimeSpend"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.isWebSite = _data["isWebSite"];
        }
    }

    static fromJS(data: any): OutPutGetApplicationsDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutGetApplicationsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["applicationType"] = this.applicationType;
        data["totalTimeSpend"] = this.totalTimeSpend;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["isWebSite"] = this.isWebSite;
        return data;
    }
}

export interface IOutPutGetApplicationsDetailsDto {
    userId: number | undefined;
    tenantId: number;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    applicationType: ApplicationTypeEnum;
    totalTimeSpend: string;
    startTime: DateTime | undefined;
    isWebSite: boolean;
}

export class OutPutGetApprovalGridDataDto implements IOutPutGetApprovalGridDataDto {
    pageCount!: number;
    totalCount!: number;
    headerDetail!: ApprovalHeaderFiledDto;
    timesheetApprovalDetails!: ApprovalGridDataDto[] | undefined;

    constructor(data?: IOutPutGetApprovalGridDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.totalCount = _data["totalCount"];
            this.headerDetail = _data["headerDetail"] ? ApprovalHeaderFiledDto.fromJS(_data["headerDetail"]) : undefined as any;
            if (Array.isArray(_data["timesheetApprovalDetails"])) {
                this.timesheetApprovalDetails = [] as any;
                for (let item of _data["timesheetApprovalDetails"])
                    this.timesheetApprovalDetails!.push(ApprovalGridDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutPutGetApprovalGridDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutGetApprovalGridDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["totalCount"] = this.totalCount;
        data["headerDetail"] = this.headerDetail ? this.headerDetail.toJSON() : undefined as any;
        if (Array.isArray(this.timesheetApprovalDetails)) {
            data["timesheetApprovalDetails"] = [];
            for (let item of this.timesheetApprovalDetails)
                data["timesheetApprovalDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOutPutGetApprovalGridDataDto {
    pageCount: number;
    totalCount: number;
    headerDetail: ApprovalHeaderFiledDto;
    timesheetApprovalDetails: ApprovalGridDataDto[] | undefined;
}

export class OutPutGetTaskDescriptionHistoryDto implements IOutPutGetTaskDescriptionHistoryDto {
    description!: string | undefined;
    taskId!: number;
    userId!: number;
    descriptionDate!: DateTime;
    taskBillingType!: ProjectBillingType;

    constructor(data?: IOutPutGetTaskDescriptionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.taskId = _data["taskId"];
            this.userId = _data["userId"];
            this.descriptionDate = _data["descriptionDate"] ? DateTime.fromISO(_data["descriptionDate"].toString()) : undefined as any;
            this.taskBillingType = _data["taskBillingType"];
        }
    }

    static fromJS(data: any): OutPutGetTaskDescriptionHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutGetTaskDescriptionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["taskId"] = this.taskId;
        data["userId"] = this.userId;
        data["descriptionDate"] = this.descriptionDate ? this.descriptionDate.toString() : undefined as any;
        data["taskBillingType"] = this.taskBillingType;
        return data;
    }
}

export interface IOutPutGetTaskDescriptionHistoryDto {
    description: string | undefined;
    taskId: number;
    userId: number;
    descriptionDate: DateTime;
    taskBillingType: ProjectBillingType;
}

export class OutPutMonthViewDto implements IOutPutMonthViewDto {
    projectId!: number;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    projectCreationDate!: DateTime;
    projectStartDate!: DateTime;
    projectEndDate!: DateTime;
    daysListDtos!: DaysListDto[] | undefined;
    perDayTotalTime!: string;
    totalTime!: string;
    taskHistoryDate!: DateTime[] | undefined;
    id!: number;

    constructor(data?: IOutPutMonthViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectStartDate = _data["projectStartDate"] ? DateTime.fromISO(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["daysListDtos"])) {
                this.daysListDtos = [] as any;
                for (let item of _data["daysListDtos"])
                    this.daysListDtos!.push(DaysListDto.fromJS(item));
            }
            this.perDayTotalTime = _data["perDayTotalTime"];
            this.totalTime = _data["totalTime"];
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutPutMonthViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutMonthViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        if (Array.isArray(this.daysListDtos)) {
            data["daysListDtos"] = [];
            for (let item of this.daysListDtos)
                data["daysListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["perDayTotalTime"] = this.perDayTotalTime;
        data["totalTime"] = this.totalTime;
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IOutPutMonthViewDto {
    projectId: number;
    projectName: string | undefined;
    projectImage: string | undefined;
    projectCreationDate: DateTime;
    projectStartDate: DateTime;
    projectEndDate: DateTime;
    daysListDtos: DaysListDto[] | undefined;
    perDayTotalTime: string;
    totalTime: string;
    taskHistoryDate: DateTime[] | undefined;
    id: number;
}

export class OutPutProjectLevelTaskDetailsDto implements IOutPutProjectLevelTaskDetailsDto {
    projectId!: number;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    projectIsActive!: boolean;
    projectIsArchived!: boolean;
    projectCreationDate!: DateTime;
    projectStartDate!: DateTime;
    projectEndDate!: DateTime | undefined;
    projectCurrentStatus!: ProjectStatus;
    employeeProjectStartDate!: DateTime;
    employeeProjectEndDate!: DateTime;
    billableType!: ProjectBillingType;
    totalTime!: string;
    perDayTotalTime!: string;
    userRole!: string[] | undefined;
    taskHistoryDate!: DateTime[] | undefined;
    daysListDtos!: DaysListDto[] | undefined;
    holidaysList!: Holidays[] | undefined;
    timesheetSubmissionFrequency!: ProjectTimesheetFrequencyEnum;
    projectLevelCheckInCategory!: ProjectLevelCheckInCategoryDto[] | undefined;
    projectBillingTypeAccess!: boolean;
    projectBillableType!: ProjectBillingType;
    allocationPercentage!: number;

    constructor(data?: IOutPutProjectLevelTaskDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.projectIsActive = _data["projectIsActive"];
            this.projectIsArchived = _data["projectIsArchived"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectStartDate = _data["projectStartDate"] ? DateTime.fromISO(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.billableType = _data["billableType"];
            this.totalTime = _data["totalTime"];
            this.perDayTotalTime = _data["perDayTotalTime"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["daysListDtos"])) {
                this.daysListDtos = [] as any;
                for (let item of _data["daysListDtos"])
                    this.daysListDtos!.push(DaysListDto.fromJS(item));
            }
            if (Array.isArray(_data["holidaysList"])) {
                this.holidaysList = [] as any;
                for (let item of _data["holidaysList"])
                    this.holidaysList!.push(Holidays.fromJS(item));
            }
            this.timesheetSubmissionFrequency = _data["timesheetSubmissionFrequency"];
            if (Array.isArray(_data["projectLevelCheckInCategory"])) {
                this.projectLevelCheckInCategory = [] as any;
                for (let item of _data["projectLevelCheckInCategory"])
                    this.projectLevelCheckInCategory!.push(ProjectLevelCheckInCategoryDto.fromJS(item));
            }
            this.projectBillingTypeAccess = _data["projectBillingTypeAccess"];
            this.projectBillableType = _data["projectBillableType"];
            this.allocationPercentage = _data["allocationPercentage"];
        }
    }

    static fromJS(data: any): OutPutProjectLevelTaskDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutProjectLevelTaskDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["projectIsActive"] = this.projectIsActive;
        data["projectIsArchived"] = this.projectIsArchived;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["billableType"] = this.billableType;
        data["totalTime"] = this.totalTime;
        data["perDayTotalTime"] = this.perDayTotalTime;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        if (Array.isArray(this.daysListDtos)) {
            data["daysListDtos"] = [];
            for (let item of this.daysListDtos)
                data["daysListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidaysList)) {
            data["holidaysList"] = [];
            for (let item of this.holidaysList)
                data["holidaysList"].push(item ? item.toJSON() : undefined as any);
        }
        data["timesheetSubmissionFrequency"] = this.timesheetSubmissionFrequency;
        if (Array.isArray(this.projectLevelCheckInCategory)) {
            data["projectLevelCheckInCategory"] = [];
            for (let item of this.projectLevelCheckInCategory)
                data["projectLevelCheckInCategory"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectBillingTypeAccess"] = this.projectBillingTypeAccess;
        data["projectBillableType"] = this.projectBillableType;
        data["allocationPercentage"] = this.allocationPercentage;
        return data;
    }
}

export interface IOutPutProjectLevelTaskDetailsDto {
    projectId: number;
    projectName: string | undefined;
    projectImage: string | undefined;
    projectIsActive: boolean;
    projectIsArchived: boolean;
    projectCreationDate: DateTime;
    projectStartDate: DateTime;
    projectEndDate: DateTime | undefined;
    projectCurrentStatus: ProjectStatus;
    employeeProjectStartDate: DateTime;
    employeeProjectEndDate: DateTime;
    billableType: ProjectBillingType;
    totalTime: string;
    perDayTotalTime: string;
    userRole: string[] | undefined;
    taskHistoryDate: DateTime[] | undefined;
    daysListDtos: DaysListDto[] | undefined;
    holidaysList: Holidays[] | undefined;
    timesheetSubmissionFrequency: ProjectTimesheetFrequencyEnum;
    projectLevelCheckInCategory: ProjectLevelCheckInCategoryDto[] | undefined;
    projectBillingTypeAccess: boolean;
    projectBillableType: ProjectBillingType;
    allocationPercentage: number;
}

export class OutPutSendTimesheetDto implements IOutPutSendTimesheetDto {
    isTimesheetSubmited!: boolean;

    constructor(data?: IOutPutSendTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTimesheetSubmited = _data["isTimesheetSubmited"];
        }
    }

    static fromJS(data: any): OutPutSendTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutSendTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTimesheetSubmited"] = this.isTimesheetSubmited;
        return data;
    }
}

export interface IOutPutSendTimesheetDto {
    isTimesheetSubmited: boolean;
}

export class OutPutSubmittedTimesheetDto implements IOutPutSubmittedTimesheetDto {
    myTimesheetGridDetails!: PagedResultDtoOfSubmittedTimesheetGridDetailDto;
    headerDetail!: SubmittedTimesheetHeaderDetailDto;

    constructor(data?: IOutPutSubmittedTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myTimesheetGridDetails = _data["myTimesheetGridDetails"] ? PagedResultDtoOfSubmittedTimesheetGridDetailDto.fromJS(_data["myTimesheetGridDetails"]) : undefined as any;
            this.headerDetail = _data["headerDetail"] ? SubmittedTimesheetHeaderDetailDto.fromJS(_data["headerDetail"]) : undefined as any;
        }
    }

    static fromJS(data: any): OutPutSubmittedTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutSubmittedTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myTimesheetGridDetails"] = this.myTimesheetGridDetails ? this.myTimesheetGridDetails.toJSON() : undefined as any;
        data["headerDetail"] = this.headerDetail ? this.headerDetail.toJSON() : undefined as any;
        return data;
    }
}

export interface IOutPutSubmittedTimesheetDto {
    myTimesheetGridDetails: PagedResultDtoOfSubmittedTimesheetGridDetailDto;
    headerDetail: SubmittedTimesheetHeaderDetailDto;
}

export class OutPutSubmittedTimesheetTaskDetailDto implements IOutPutSubmittedTimesheetTaskDetailDto {
    userTaskId!: number;
    timesheetId!: number | undefined;
    taskJobId!: number | undefined;
    taskJobName!: string | undefined;
    taskStatus!: number | undefined;
    billabilityStatus!: number | undefined;
    taskName!: string | undefined;
    taskDescription!: string | undefined;
    approvalName!: string | undefined;
    isManualTimeSheet!: boolean;
    includeInTimesheet!: boolean;
    totalTime!: string;
    totalTaskTrackedTime!: string;
    creationDay!: DateTime;
    projectCreationDate!: DateTime;
    employeeProjectStartDate!: DateTime;
    employeeProjectEndDate!: DateTime;
    projectBillingType!: ProjectBillingType;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    taskHistoryDate!: DateTime[] | undefined;
    dayListDtos!: DaysListDto[] | undefined;
    holidayslist!: Holidays[] | undefined;
    taskWiseDescriptions!: TaskWiseDescription[] | undefined;
    reasons!: TaskWiseNonBillableReason[] | undefined;
    id!: number;

    constructor(data?: IOutPutSubmittedTimesheetTaskDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTaskId = _data["userTaskId"];
            this.timesheetId = _data["timesheetId"];
            this.taskJobId = _data["taskJobId"];
            this.taskJobName = _data["taskJobName"];
            this.taskStatus = _data["taskStatus"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.taskName = _data["taskName"];
            this.taskDescription = _data["taskDescription"];
            this.approvalName = _data["approvalName"];
            this.isManualTimeSheet = _data["isManualTimeSheet"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.totalTime = _data["totalTime"];
            this.totalTaskTrackedTime = _data["totalTaskTrackedTime"];
            this.creationDay = _data["creationDay"] ? DateTime.fromISO(_data["creationDay"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.projectBillingType = _data["projectBillingType"];
            this.timesheetStatus = _data["timesheetStatus"];
            if (Array.isArray(_data["taskHistoryDate"])) {
                this.taskHistoryDate = [] as any;
                for (let item of _data["taskHistoryDate"])
                    this.taskHistoryDate!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["dayListDtos"])) {
                this.dayListDtos = [] as any;
                for (let item of _data["dayListDtos"])
                    this.dayListDtos!.push(DaysListDto.fromJS(item));
            }
            if (Array.isArray(_data["holidayslist"])) {
                this.holidayslist = [] as any;
                for (let item of _data["holidayslist"])
                    this.holidayslist!.push(Holidays.fromJS(item));
            }
            if (Array.isArray(_data["taskWiseDescriptions"])) {
                this.taskWiseDescriptions = [] as any;
                for (let item of _data["taskWiseDescriptions"])
                    this.taskWiseDescriptions!.push(TaskWiseDescription.fromJS(item));
            }
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(TaskWiseNonBillableReason.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutPutSubmittedTimesheetTaskDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutSubmittedTimesheetTaskDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTaskId"] = this.userTaskId;
        data["timesheetId"] = this.timesheetId;
        data["taskJobId"] = this.taskJobId;
        data["taskJobName"] = this.taskJobName;
        data["taskStatus"] = this.taskStatus;
        data["billabilityStatus"] = this.billabilityStatus;
        data["taskName"] = this.taskName;
        data["taskDescription"] = this.taskDescription;
        data["approvalName"] = this.approvalName;
        data["isManualTimeSheet"] = this.isManualTimeSheet;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["totalTime"] = this.totalTime;
        data["totalTaskTrackedTime"] = this.totalTaskTrackedTime;
        data["creationDay"] = this.creationDay ? this.creationDay.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["projectBillingType"] = this.projectBillingType;
        data["timesheetStatus"] = this.timesheetStatus;
        if (Array.isArray(this.taskHistoryDate)) {
            data["taskHistoryDate"] = [];
            for (let item of this.taskHistoryDate)
                data["taskHistoryDate"].push(item.toString());
        }
        if (Array.isArray(this.dayListDtos)) {
            data["dayListDtos"] = [];
            for (let item of this.dayListDtos)
                data["dayListDtos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.holidayslist)) {
            data["holidayslist"] = [];
            for (let item of this.holidayslist)
                data["holidayslist"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taskWiseDescriptions)) {
            data["taskWiseDescriptions"] = [];
            for (let item of this.taskWiseDescriptions)
                data["taskWiseDescriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IOutPutSubmittedTimesheetTaskDetailDto {
    userTaskId: number;
    timesheetId: number | undefined;
    taskJobId: number | undefined;
    taskJobName: string | undefined;
    taskStatus: number | undefined;
    billabilityStatus: number | undefined;
    taskName: string | undefined;
    taskDescription: string | undefined;
    approvalName: string | undefined;
    isManualTimeSheet: boolean;
    includeInTimesheet: boolean;
    totalTime: string;
    totalTaskTrackedTime: string;
    creationDay: DateTime;
    projectCreationDate: DateTime;
    employeeProjectStartDate: DateTime;
    employeeProjectEndDate: DateTime;
    projectBillingType: ProjectBillingType;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    taskHistoryDate: DateTime[] | undefined;
    dayListDtos: DaysListDto[] | undefined;
    holidayslist: Holidays[] | undefined;
    taskWiseDescriptions: TaskWiseDescription[] | undefined;
    reasons: TaskWiseNonBillableReason[] | undefined;
    id: number;
}

export class OutPutTaskJobDto implements IOutPutTaskJobDto {
    tenantId!: number;
    taskId!: number | undefined;
    taskJobId!: number;
    projectId!: number | undefined;
    jobName!: string | undefined;
    masterTaskName!: string | undefined;
    isSeed!: boolean;
    isCheck!: boolean;
    isDeleted!: boolean;

    constructor(data?: IOutPutTaskJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
            this.taskJobId = _data["taskJobId"];
            this.projectId = _data["projectId"];
            this.jobName = _data["jobName"];
            this.masterTaskName = _data["masterTaskName"];
            this.isSeed = _data["isSeed"];
            this.isCheck = _data["isCheck"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OutPutTaskJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutTaskJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        data["taskJobId"] = this.taskJobId;
        data["projectId"] = this.projectId;
        data["jobName"] = this.jobName;
        data["masterTaskName"] = this.masterTaskName;
        data["isSeed"] = this.isSeed;
        data["isCheck"] = this.isCheck;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IOutPutTaskJobDto {
    tenantId: number;
    taskId: number | undefined;
    taskJobId: number;
    projectId: number | undefined;
    jobName: string | undefined;
    masterTaskName: string | undefined;
    isSeed: boolean;
    isCheck: boolean;
    isDeleted: boolean;
}

export class OutPutTimeAndAttendanceUserDaillyCalculationDto implements IOutPutTimeAndAttendanceUserDaillyCalculationDto {
    userId!: number;
    tenantId!: number;
    calculationDate!: DateTime;
    productivityTime!: string;
    effectiveness!: number;
    productivity!: number;
    trackedTime!: string;
    rank!: number;
    timeAtWork!: string;
    arrivalTime!: DateTime;
    leftTime!: string | undefined;
    leftDateTime!: DateTime | undefined;
    productivityBarStartTime!: DateTime;
    isPRodTimePresent!: boolean;
    minimumUsererWorkingHours!: number;
    workStartDate!: DateTime;
    workEndDate!: DateTime;
    productivityPercentage!: number;
    avarageTimeAtWork!: string;
    avarageTrackedTime!: string;
    avarageProductivityTime!: string;

    constructor(data?: IOutPutTimeAndAttendanceUserDaillyCalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.calculationDate = _data["calculationDate"] ? DateTime.fromISO(_data["calculationDate"].toString()) : undefined as any;
            this.productivityTime = _data["productivityTime"];
            this.effectiveness = _data["effectiveness"];
            this.productivity = _data["productivity"];
            this.trackedTime = _data["trackedTime"];
            this.rank = _data["rank"];
            this.timeAtWork = _data["timeAtWork"];
            this.arrivalTime = _data["arrivalTime"] ? DateTime.fromISO(_data["arrivalTime"].toString()) : undefined as any;
            this.leftTime = _data["leftTime"];
            this.leftDateTime = _data["leftDateTime"] ? DateTime.fromISO(_data["leftDateTime"].toString()) : undefined as any;
            this.productivityBarStartTime = _data["productivityBarStartTime"] ? DateTime.fromISO(_data["productivityBarStartTime"].toString()) : undefined as any;
            this.isPRodTimePresent = _data["isPRodTimePresent"];
            this.minimumUsererWorkingHours = _data["minimumUsererWorkingHours"];
            this.workStartDate = _data["workStartDate"] ? DateTime.fromISO(_data["workStartDate"].toString()) : undefined as any;
            this.workEndDate = _data["workEndDate"] ? DateTime.fromISO(_data["workEndDate"].toString()) : undefined as any;
            this.productivityPercentage = _data["productivityPercentage"];
            this.avarageTimeAtWork = _data["avarageTimeAtWork"];
            this.avarageTrackedTime = _data["avarageTrackedTime"];
            this.avarageProductivityTime = _data["avarageProductivityTime"];
        }
    }

    static fromJS(data: any): OutPutTimeAndAttendanceUserDaillyCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutTimeAndAttendanceUserDaillyCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["calculationDate"] = this.calculationDate ? this.calculationDate.toString() : undefined as any;
        data["productivityTime"] = this.productivityTime;
        data["effectiveness"] = this.effectiveness;
        data["productivity"] = this.productivity;
        data["trackedTime"] = this.trackedTime;
        data["rank"] = this.rank;
        data["timeAtWork"] = this.timeAtWork;
        data["arrivalTime"] = this.arrivalTime ? this.arrivalTime.toString() : undefined as any;
        data["leftTime"] = this.leftTime;
        data["leftDateTime"] = this.leftDateTime ? this.leftDateTime.toString() : undefined as any;
        data["productivityBarStartTime"] = this.productivityBarStartTime ? this.productivityBarStartTime.toString() : undefined as any;
        data["isPRodTimePresent"] = this.isPRodTimePresent;
        data["minimumUsererWorkingHours"] = this.minimumUsererWorkingHours;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toString() : undefined as any;
        data["workEndDate"] = this.workEndDate ? this.workEndDate.toString() : undefined as any;
        data["productivityPercentage"] = this.productivityPercentage;
        data["avarageTimeAtWork"] = this.avarageTimeAtWork;
        data["avarageTrackedTime"] = this.avarageTrackedTime;
        data["avarageProductivityTime"] = this.avarageProductivityTime;
        return data;
    }
}

export interface IOutPutTimeAndAttendanceUserDaillyCalculationDto {
    userId: number;
    tenantId: number;
    calculationDate: DateTime;
    productivityTime: string;
    effectiveness: number;
    productivity: number;
    trackedTime: string;
    rank: number;
    timeAtWork: string;
    arrivalTime: DateTime;
    leftTime: string | undefined;
    leftDateTime: DateTime | undefined;
    productivityBarStartTime: DateTime;
    isPRodTimePresent: boolean;
    minimumUsererWorkingHours: number;
    workStartDate: DateTime;
    workEndDate: DateTime;
    productivityPercentage: number;
    avarageTimeAtWork: string;
    avarageTrackedTime: string;
    avarageProductivityTime: string;
}

export class OutPutTimesheetApprovalDto implements IOutPutTimesheetApprovalDto {
    timesheetApprovalDetails!: TimeSheetDetailDto[] | undefined;
    headerDetail!: TeamTimesheetHeaderFiledDto;
    pageCount!: number;
    totalCount!: number;
    id!: number;

    constructor(data?: IOutPutTimesheetApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timesheetApprovalDetails"])) {
                this.timesheetApprovalDetails = [] as any;
                for (let item of _data["timesheetApprovalDetails"])
                    this.timesheetApprovalDetails!.push(TimeSheetDetailDto.fromJS(item));
            }
            this.headerDetail = _data["headerDetail"] ? TeamTimesheetHeaderFiledDto.fromJS(_data["headerDetail"]) : undefined as any;
            this.pageCount = _data["pageCount"];
            this.totalCount = _data["totalCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutPutTimesheetApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutTimesheetApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timesheetApprovalDetails)) {
            data["timesheetApprovalDetails"] = [];
            for (let item of this.timesheetApprovalDetails)
                data["timesheetApprovalDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["headerDetail"] = this.headerDetail ? this.headerDetail.toJSON() : undefined as any;
        data["pageCount"] = this.pageCount;
        data["totalCount"] = this.totalCount;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutPutTimesheetApprovalDto {
    timesheetApprovalDetails: TimeSheetDetailDto[] | undefined;
    headerDetail: TeamTimesheetHeaderFiledDto;
    pageCount: number;
    totalCount: number;
    id: number;
}

export class OutPutWeekViewDetailsDto implements IOutPutWeekViewDetailsDto {
    outPutProjectLevelTaskDetails!: OutPutProjectLevelTaskDetailsDto[] | undefined;
    headerSubmitedHours!: string;

    constructor(data?: IOutPutWeekViewDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["outPutProjectLevelTaskDetails"])) {
                this.outPutProjectLevelTaskDetails = [] as any;
                for (let item of _data["outPutProjectLevelTaskDetails"])
                    this.outPutProjectLevelTaskDetails!.push(OutPutProjectLevelTaskDetailsDto.fromJS(item));
            }
            this.headerSubmitedHours = _data["headerSubmitedHours"];
        }
    }

    static fromJS(data: any): OutPutWeekViewDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutPutWeekViewDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.outPutProjectLevelTaskDetails)) {
            data["outPutProjectLevelTaskDetails"] = [];
            for (let item of this.outPutProjectLevelTaskDetails)
                data["outPutProjectLevelTaskDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["headerSubmitedHours"] = this.headerSubmitedHours;
        return data;
    }
}

export interface IOutPutWeekViewDetailsDto {
    outPutProjectLevelTaskDetails: OutPutProjectLevelTaskDetailsDto[] | undefined;
    headerSubmitedHours: string;
}

export class OutlookAuthUrlResponseDto implements IOutlookAuthUrlResponseDto {
    outlookAuthUrl!: string | undefined;

    constructor(data?: IOutlookAuthUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outlookAuthUrl = _data["outlookAuthUrl"];
        }
    }

    static fromJS(data: any): OutlookAuthUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookAuthUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outlookAuthUrl"] = this.outlookAuthUrl;
        return data;
    }
}

export interface IOutlookAuthUrlResponseDto {
    outlookAuthUrl: string | undefined;
}

export class OutlookCalendarEventDto implements IOutlookCalendarEventDto {
    odataContext!: string | undefined;
    odataNextLink!: string | undefined;
    value!: OutlookCalendarEventItem[] | undefined;

    constructor(data?: IOutlookCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataNextLink = _data["@odata.nextLink"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(OutlookCalendarEventItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutlookCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.nextLink"] = this.odataNextLink;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOutlookCalendarEventDto {
    odataContext: string | undefined;
    odataNextLink: string | undefined;
    value: OutlookCalendarEventItem[] | undefined;
}

export class OutlookCalendarEventItem implements IOutlookCalendarEventItem {
    odataEtag!: string | undefined;
    id!: string | undefined;
    createdDateTime!: DateTime;
    lastModifiedDateTime!: DateTime;
    changeKey!: string | undefined;
    categories!: any[] | undefined;
    transactionId!: string | undefined;
    originalStartTimeZone!: string | undefined;
    originalEndTimeZone!: string | undefined;
    iCalUId!: string | undefined;
    reminderMinutesBeforeStart!: number;
    isReminderOn!: boolean;
    hasAttachments!: boolean;
    subject!: string | undefined;
    bodyPreview!: string | undefined;
    importance!: string | undefined;
    sensitivity!: string | undefined;
    isAllDay!: boolean;
    isCancelled!: boolean;
    isOrganizer!: boolean;
    responseRequested!: boolean;
    seriesMasterId!: any;
    showAs!: string | undefined;
    type!: string | undefined;
    webLink!: string | undefined;
    onlineMeetingUrl!: any;
    isOnlineMeeting!: boolean;
    onlineMeetingProvider!: string | undefined;
    allowNewTimeProposals!: boolean;
    isDraft!: boolean;
    hideAttendees!: boolean;
    responseStatus!: ResponseStatus;
    body!: Body;
    start!: Start;
    end!: End;
    location!: Location;
    locations!: any[] | undefined;
    recurrence!: Recurrence;
    attendees!: any[] | undefined;
    organizer!: Organizer;
    onlineMeeting!: any;
    calendarodataAssociationLink!: string | undefined;
    calendarodataNavigationLink!: string | undefined;

    constructor(data?: IOutlookCalendarEventItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataEtag = _data["@odata.etag"];
            this.id = _data["id"];
            this.createdDateTime = _data["createdDateTime"] ? DateTime.fromISO(_data["createdDateTime"].toString()) : undefined as any;
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? DateTime.fromISO(_data["lastModifiedDateTime"].toString()) : undefined as any;
            this.changeKey = _data["changeKey"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            this.transactionId = _data["transactionId"];
            this.originalStartTimeZone = _data["originalStartTimeZone"];
            this.originalEndTimeZone = _data["originalEndTimeZone"];
            this.iCalUId = _data["iCalUId"];
            this.reminderMinutesBeforeStart = _data["reminderMinutesBeforeStart"];
            this.isReminderOn = _data["isReminderOn"];
            this.hasAttachments = _data["hasAttachments"];
            this.subject = _data["subject"];
            this.bodyPreview = _data["bodyPreview"];
            this.importance = _data["importance"];
            this.sensitivity = _data["sensitivity"];
            this.isAllDay = _data["isAllDay"];
            this.isCancelled = _data["isCancelled"];
            this.isOrganizer = _data["isOrganizer"];
            this.responseRequested = _data["responseRequested"];
            this.seriesMasterId = _data["seriesMasterId"];
            this.showAs = _data["showAs"];
            this.type = _data["type"];
            this.webLink = _data["webLink"];
            this.onlineMeetingUrl = _data["onlineMeetingUrl"];
            this.isOnlineMeeting = _data["isOnlineMeeting"];
            this.onlineMeetingProvider = _data["onlineMeetingProvider"];
            this.allowNewTimeProposals = _data["allowNewTimeProposals"];
            this.isDraft = _data["isDraft"];
            this.hideAttendees = _data["hideAttendees"];
            this.responseStatus = _data["responseStatus"] ? ResponseStatus.fromJS(_data["responseStatus"]) : undefined as any;
            this.body = _data["body"] ? Body.fromJS(_data["body"]) : undefined as any;
            this.start = _data["start"] ? Start.fromJS(_data["start"]) : undefined as any;
            this.end = _data["end"] ? End.fromJS(_data["end"]) : undefined as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : undefined as any;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
            this.recurrence = _data["recurrence"] ? Recurrence.fromJS(_data["recurrence"]) : undefined as any;
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(item);
            }
            this.organizer = _data["organizer"] ? Organizer.fromJS(_data["organizer"]) : undefined as any;
            this.onlineMeeting = _data["onlineMeeting"];
            this.calendarodataAssociationLink = _data["calendar@odata.associationLink"];
            this.calendarodataNavigationLink = _data["calendar@odata.navigationLink"];
        }
    }

    static fromJS(data: any): OutlookCalendarEventItem {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookCalendarEventItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.etag"] = this.odataEtag;
        data["id"] = this.id;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toString() : undefined as any;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toString() : undefined as any;
        data["changeKey"] = this.changeKey;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        data["transactionId"] = this.transactionId;
        data["originalStartTimeZone"] = this.originalStartTimeZone;
        data["originalEndTimeZone"] = this.originalEndTimeZone;
        data["iCalUId"] = this.iCalUId;
        data["reminderMinutesBeforeStart"] = this.reminderMinutesBeforeStart;
        data["isReminderOn"] = this.isReminderOn;
        data["hasAttachments"] = this.hasAttachments;
        data["subject"] = this.subject;
        data["bodyPreview"] = this.bodyPreview;
        data["importance"] = this.importance;
        data["sensitivity"] = this.sensitivity;
        data["isAllDay"] = this.isAllDay;
        data["isCancelled"] = this.isCancelled;
        data["isOrganizer"] = this.isOrganizer;
        data["responseRequested"] = this.responseRequested;
        data["seriesMasterId"] = this.seriesMasterId;
        data["showAs"] = this.showAs;
        data["type"] = this.type;
        data["webLink"] = this.webLink;
        data["onlineMeetingUrl"] = this.onlineMeetingUrl;
        data["isOnlineMeeting"] = this.isOnlineMeeting;
        data["onlineMeetingProvider"] = this.onlineMeetingProvider;
        data["allowNewTimeProposals"] = this.allowNewTimeProposals;
        data["isDraft"] = this.isDraft;
        data["hideAttendees"] = this.hideAttendees;
        data["responseStatus"] = this.responseStatus ? this.responseStatus.toJSON() : undefined as any;
        data["body"] = this.body ? this.body.toJSON() : undefined as any;
        data["start"] = this.start ? this.start.toJSON() : undefined as any;
        data["end"] = this.end ? this.end.toJSON() : undefined as any;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : undefined as any;
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item);
        }
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined as any;
        data["onlineMeeting"] = this.onlineMeeting;
        data["calendar@odata.associationLink"] = this.calendarodataAssociationLink;
        data["calendar@odata.navigationLink"] = this.calendarodataNavigationLink;
        return data;
    }
}

export interface IOutlookCalendarEventItem {
    odataEtag: string | undefined;
    id: string | undefined;
    createdDateTime: DateTime;
    lastModifiedDateTime: DateTime;
    changeKey: string | undefined;
    categories: any[] | undefined;
    transactionId: string | undefined;
    originalStartTimeZone: string | undefined;
    originalEndTimeZone: string | undefined;
    iCalUId: string | undefined;
    reminderMinutesBeforeStart: number;
    isReminderOn: boolean;
    hasAttachments: boolean;
    subject: string | undefined;
    bodyPreview: string | undefined;
    importance: string | undefined;
    sensitivity: string | undefined;
    isAllDay: boolean;
    isCancelled: boolean;
    isOrganizer: boolean;
    responseRequested: boolean;
    seriesMasterId: any;
    showAs: string | undefined;
    type: string | undefined;
    webLink: string | undefined;
    onlineMeetingUrl: any;
    isOnlineMeeting: boolean;
    onlineMeetingProvider: string | undefined;
    allowNewTimeProposals: boolean;
    isDraft: boolean;
    hideAttendees: boolean;
    responseStatus: ResponseStatus;
    body: Body;
    start: Start;
    end: End;
    location: Location;
    locations: any[] | undefined;
    recurrence: Recurrence;
    attendees: any[] | undefined;
    organizer: Organizer;
    onlineMeeting: any;
    calendarodataAssociationLink: string | undefined;
    calendarodataNavigationLink: string | undefined;
}

export class OutlookEventInputDto implements IOutlookEventInputDto {
    subject!: string | undefined;
    start!: EventDateTimeTimeZone;
    end!: EventDateTimeTimeZone;
    body!: EventBody;
    location!: EventLocation;
    isAllDay!: boolean;
    recurrence!: EventPatternedRecurrence;

    constructor(data?: IOutlookEventInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.start = _data["start"] ? EventDateTimeTimeZone.fromJS(_data["start"]) : undefined as any;
            this.end = _data["end"] ? EventDateTimeTimeZone.fromJS(_data["end"]) : undefined as any;
            this.body = _data["body"] ? EventBody.fromJS(_data["body"]) : undefined as any;
            this.location = _data["location"] ? EventLocation.fromJS(_data["location"]) : undefined as any;
            this.isAllDay = _data["isAllDay"];
            this.recurrence = _data["recurrence"] ? EventPatternedRecurrence.fromJS(_data["recurrence"]) : undefined as any;
        }
    }

    static fromJS(data: any): OutlookEventInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookEventInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["start"] = this.start ? this.start.toJSON() : undefined as any;
        data["end"] = this.end ? this.end.toJSON() : undefined as any;
        data["body"] = this.body ? this.body.toJSON() : undefined as any;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["isAllDay"] = this.isAllDay;
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : undefined as any;
        return data;
    }
}

export interface IOutlookEventInputDto {
    subject: string | undefined;
    start: EventDateTimeTimeZone;
    end: EventDateTimeTimeZone;
    body: EventBody;
    location: EventLocation;
    isAllDay: boolean;
    recurrence: EventPatternedRecurrence;
}

export class OutlookEventWithUserInputDto implements IOutlookEventWithUserInputDto {
    email!: string | undefined;
    outlookEventId!: string | undefined;
    userId!: number;
    systemEventID!: number;
    outlookEventInput!: OutlookEventInputDto;

    constructor(data?: IOutlookEventWithUserInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.outlookEventId = _data["outlookEventId"];
            this.userId = _data["userId"];
            this.systemEventID = _data["systemEventID"];
            this.outlookEventInput = _data["outlookEventInput"] ? OutlookEventInputDto.fromJS(_data["outlookEventInput"]) : undefined as any;
        }
    }

    static fromJS(data: any): OutlookEventWithUserInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookEventWithUserInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["outlookEventId"] = this.outlookEventId;
        data["userId"] = this.userId;
        data["systemEventID"] = this.systemEventID;
        data["outlookEventInput"] = this.outlookEventInput ? this.outlookEventInput.toJSON() : undefined as any;
        return data;
    }
}

export interface IOutlookEventWithUserInputDto {
    email: string | undefined;
    outlookEventId: string | undefined;
    userId: number;
    systemEventID: number;
    outlookEventInput: OutlookEventInputDto;
}

export class OutlookLinkedAccountDto implements IOutlookLinkedAccountDto {
    email!: string | undefined;
    name!: string | undefined;
    isActive!: boolean;
    id!: number;

    constructor(data?: IOutlookLinkedAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutlookLinkedAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookLinkedAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutlookLinkedAccountDto {
    email: string | undefined;
    name: string | undefined;
    isActive: boolean;
    id: number;
}

export class OutlookTokenInfoDto implements IOutlookTokenInfoDto {
    email!: string | undefined;
    name!: string | undefined;
    tokeninfo!: string | undefined;
    userId!: number;
    refreshToken!: string | undefined;
    isActive!: boolean;
    id!: number;

    constructor(data?: IOutlookTokenInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.tokeninfo = _data["tokeninfo"];
            this.userId = _data["userId"];
            this.refreshToken = _data["refreshToken"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutlookTokenInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutlookTokenInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["tokeninfo"] = this.tokeninfo;
        data["userId"] = this.userId;
        data["refreshToken"] = this.refreshToken;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutlookTokenInfoDto {
    email: string | undefined;
    name: string | undefined;
    tokeninfo: string | undefined;
    userId: number;
    refreshToken: string | undefined;
    isActive: boolean;
    id: number;
}

export class OutputGetTaskCategoriesDropdownDto implements IOutputGetTaskCategoriesDropdownDto {
    taskJobId!: number;
    taskJobName!: string | undefined;
    projectId!: number | undefined;
    isCheck!: boolean;

    constructor(data?: IOutputGetTaskCategoriesDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskJobId = _data["taskJobId"];
            this.taskJobName = _data["taskJobName"];
            this.projectId = _data["projectId"];
            this.isCheck = _data["isCheck"];
        }
    }

    static fromJS(data: any): OutputGetTaskCategoriesDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputGetTaskCategoriesDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskJobId"] = this.taskJobId;
        data["taskJobName"] = this.taskJobName;
        data["projectId"] = this.projectId;
        data["isCheck"] = this.isCheck;
        return data;
    }
}

export interface IOutputGetTaskCategoriesDropdownDto {
    taskJobId: number;
    taskJobName: string | undefined;
    projectId: number | undefined;
    isCheck: boolean;
}

export class OutputTeamTrackingDto implements IOutputTeamTrackingDto {
    name!: string | undefined;
    surname!: string | undefined;
    readonly fullName!: string | undefined;
    profileImage!: string | undefined;
    organizationUnitName!: string | undefined;
    taskName!: string | undefined;
    tenantId!: number | undefined;
    checkIn!: DateTime | undefined;
    checkOut!: DateTime | undefined;
    applicationName!: string | undefined;
    icon!: string | undefined;
    applicationStatus!: string | undefined;
    taskDescription!: string | undefined;
    spendTime!: string | undefined;
    userLiveLocation!: string | undefined;
    internetProvider!: string | undefined;
    internetSpeed!: string | undefined;
    userStatusId!: UserStatusEnum;
    projectImage!: string | undefined;
    projectName!: string | undefined;
    screenCapture!: boolean;
    roleNames!: string[] | undefined;
    managerId!: number | undefined;
    addressLine2!: string | undefined;
    workingType!: WorkFromType;
    longitude!: string | undefined;
    latitude!: string | undefined;
    deviceNameWithOs!: string | undefined;
    userDeviseVersion!: string | undefined;
    activeTime!: string;
    id!: number;

    constructor(data?: IOutputTeamTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            (this as any).fullName = _data["fullName"];
            this.profileImage = _data["profileImage"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.taskName = _data["taskName"];
            this.tenantId = _data["tenantId"];
            this.checkIn = _data["checkIn"] ? DateTime.fromISO(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? DateTime.fromISO(_data["checkOut"].toString()) : undefined as any;
            this.applicationName = _data["applicationName"];
            this.icon = _data["icon"];
            this.applicationStatus = _data["applicationStatus"];
            this.taskDescription = _data["taskDescription"];
            this.spendTime = _data["spendTime"];
            this.userLiveLocation = _data["userLiveLocation"];
            this.internetProvider = _data["internetProvider"];
            this.internetSpeed = _data["internetSpeed"];
            this.userStatusId = _data["userStatusId"];
            this.projectImage = _data["projectImage"];
            this.projectName = _data["projectName"];
            this.screenCapture = _data["screenCapture"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.managerId = _data["managerId"];
            this.addressLine2 = _data["addressLine2"];
            this.workingType = _data["workingType"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.deviceNameWithOs = _data["deviceNameWithOs"];
            this.userDeviseVersion = _data["userDeviseVersion"];
            this.activeTime = _data["activeTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OutputTeamTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputTeamTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["profileImage"] = this.profileImage;
        data["organizationUnitName"] = this.organizationUnitName;
        data["taskName"] = this.taskName;
        data["tenantId"] = this.tenantId;
        data["checkIn"] = this.checkIn ? this.checkIn.toString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toString() : undefined as any;
        data["applicationName"] = this.applicationName;
        data["icon"] = this.icon;
        data["applicationStatus"] = this.applicationStatus;
        data["taskDescription"] = this.taskDescription;
        data["spendTime"] = this.spendTime;
        data["userLiveLocation"] = this.userLiveLocation;
        data["internetProvider"] = this.internetProvider;
        data["internetSpeed"] = this.internetSpeed;
        data["userStatusId"] = this.userStatusId;
        data["projectImage"] = this.projectImage;
        data["projectName"] = this.projectName;
        data["screenCapture"] = this.screenCapture;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["managerId"] = this.managerId;
        data["addressLine2"] = this.addressLine2;
        data["workingType"] = this.workingType;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["deviceNameWithOs"] = this.deviceNameWithOs;
        data["userDeviseVersion"] = this.userDeviseVersion;
        data["activeTime"] = this.activeTime;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutputTeamTrackingDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    profileImage: string | undefined;
    organizationUnitName: string | undefined;
    taskName: string | undefined;
    tenantId: number | undefined;
    checkIn: DateTime | undefined;
    checkOut: DateTime | undefined;
    applicationName: string | undefined;
    icon: string | undefined;
    applicationStatus: string | undefined;
    taskDescription: string | undefined;
    spendTime: string | undefined;
    userLiveLocation: string | undefined;
    internetProvider: string | undefined;
    internetSpeed: string | undefined;
    userStatusId: UserStatusEnum;
    projectImage: string | undefined;
    projectName: string | undefined;
    screenCapture: boolean;
    roleNames: string[] | undefined;
    managerId: number | undefined;
    addressLine2: string | undefined;
    workingType: WorkFromType;
    longitude: string | undefined;
    latitude: string | undefined;
    deviceNameWithOs: string | undefined;
    userDeviseVersion: string | undefined;
    activeTime: string;
    id: number;
}

export class OverAllSummaryDto implements IOverAllSummaryDto {
    userId!: number;
    projectId!: number;
    projectName!: string | undefined;
    employeeName!: string | undefined;
    emailAddress!: string | undefined;
    employeeId!: string | undefined;
    projectRole!: string | undefined;
    timesheetDate!: string | undefined;
    taskName!: string | undefined;
    estimateHours!: string | undefined;
    loggedHours!: number;
    billedHours!: number;
    requiredHours!: number;
    taskBillability!: number | undefined;
    status!: string | undefined;
    comment!: string | undefined;
    timesheetId!: number;
    timesheetStatus!: string | undefined;
    taskJobName!: string | undefined;
    taskNonBillabityReason!: string | undefined;

    constructor(data?: IOverAllSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.employeeName = _data["employeeName"];
            this.emailAddress = _data["emailAddress"];
            this.employeeId = _data["employeeId"];
            this.projectRole = _data["projectRole"];
            this.timesheetDate = _data["timesheetDate"];
            this.taskName = _data["taskName"];
            this.estimateHours = _data["estimateHours"];
            this.loggedHours = _data["loggedHours"];
            this.billedHours = _data["billedHours"];
            this.requiredHours = _data["requiredHours"];
            this.taskBillability = _data["taskBillability"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.timesheetId = _data["timesheetId"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.taskJobName = _data["taskJobName"];
            this.taskNonBillabityReason = _data["taskNonBillabityReason"];
        }
    }

    static fromJS(data: any): OverAllSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverAllSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["employeeName"] = this.employeeName;
        data["emailAddress"] = this.emailAddress;
        data["employeeId"] = this.employeeId;
        data["projectRole"] = this.projectRole;
        data["timesheetDate"] = this.timesheetDate;
        data["taskName"] = this.taskName;
        data["estimateHours"] = this.estimateHours;
        data["loggedHours"] = this.loggedHours;
        data["billedHours"] = this.billedHours;
        data["requiredHours"] = this.requiredHours;
        data["taskBillability"] = this.taskBillability;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["timesheetId"] = this.timesheetId;
        data["timesheetStatus"] = this.timesheetStatus;
        data["taskJobName"] = this.taskJobName;
        data["taskNonBillabityReason"] = this.taskNonBillabityReason;
        return data;
    }
}

export interface IOverAllSummaryDto {
    userId: number;
    projectId: number;
    projectName: string | undefined;
    employeeName: string | undefined;
    emailAddress: string | undefined;
    employeeId: string | undefined;
    projectRole: string | undefined;
    timesheetDate: string | undefined;
    taskName: string | undefined;
    estimateHours: string | undefined;
    loggedHours: number;
    billedHours: number;
    requiredHours: number;
    taskBillability: number | undefined;
    status: string | undefined;
    comment: string | undefined;
    timesheetId: number;
    timesheetStatus: string | undefined;
    taskJobName: string | undefined;
    taskNonBillabityReason: string | undefined;
}

export class OverAllSummaryRootDto implements IOverAllSummaryRootDto {
    attendanceReportOverAllSummaryDto!: AttendanceReportOverAllSummaryDto;
    overAllSummarySheetReport!: OverAllSummarySheetReport;

    constructor(data?: IOverAllSummaryRootDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceReportOverAllSummaryDto = _data["attendanceReportOverAllSummaryDto"] ? AttendanceReportOverAllSummaryDto.fromJS(_data["attendanceReportOverAllSummaryDto"]) : undefined as any;
            this.overAllSummarySheetReport = _data["overAllSummarySheetReport"] ? OverAllSummarySheetReport.fromJS(_data["overAllSummarySheetReport"]) : undefined as any;
        }
    }

    static fromJS(data: any): OverAllSummaryRootDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverAllSummaryRootDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceReportOverAllSummaryDto"] = this.attendanceReportOverAllSummaryDto ? this.attendanceReportOverAllSummaryDto.toJSON() : undefined as any;
        data["overAllSummarySheetReport"] = this.overAllSummarySheetReport ? this.overAllSummarySheetReport.toJSON() : undefined as any;
        return data;
    }
}

export interface IOverAllSummaryRootDto {
    attendanceReportOverAllSummaryDto: AttendanceReportOverAllSummaryDto;
    overAllSummarySheetReport: OverAllSummarySheetReport;
}

export class OverAllSummarySheetReport implements IOverAllSummarySheetReport {
    attendanceDuration!: string | undefined;
    exportType!: string | undefined;
    employeeDetails!: EmployeeDetailsList[] | undefined;

    constructor(data?: IOverAllSummarySheetReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDuration = _data["attendanceDuration"];
            this.exportType = _data["exportType"];
            if (Array.isArray(_data["employeeDetails"])) {
                this.employeeDetails = [] as any;
                for (let item of _data["employeeDetails"])
                    this.employeeDetails!.push(EmployeeDetailsList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverAllSummarySheetReport {
        data = typeof data === 'object' ? data : {};
        let result = new OverAllSummarySheetReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDuration"] = this.attendanceDuration;
        data["exportType"] = this.exportType;
        if (Array.isArray(this.employeeDetails)) {
            data["employeeDetails"] = [];
            for (let item of this.employeeDetails)
                data["employeeDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOverAllSummarySheetReport {
    attendanceDuration: string | undefined;
    exportType: string | undefined;
    employeeDetails: EmployeeDetailsList[] | undefined;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class PagedResultDtoOfActiveUserDto implements IPagedResultDtoOfActiveUserDto {
    totalCount!: number;
    items!: ActiveUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfActiveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActiveUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActiveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActiveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfActiveUserDto {
    totalCount: number;
    items: ActiveUserDto[] | undefined;
}

export class PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto implements IPagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto {
    totalCount!: number;
    items!: AddAwayTimeGetAllDtoApprovalDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddAwayTimeGetAllDtoApprovalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAddAwayTimeGetAllDtoApprovalDto {
    totalCount: number;
    items: AddAwayTimeGetAllDtoApprovalDto[] | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfGetAllSendAttemptsOutput implements IPagedResultDtoOfGetAllSendAttemptsOutput {
    totalCount!: number;
    items!: GetAllSendAttemptsOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllSendAttemptsOutput {
    totalCount: number;
    items: GetAllSendAttemptsOutput[] | undefined;
}

export class PagedResultDtoOfGetApplicationsDto implements IPagedResultDtoOfGetApplicationsDto {
    totalCount!: number;
    items!: GetApplicationsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetApplicationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetApplicationsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetApplicationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetApplicationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetApplicationsDto {
    totalCount: number;
    items: GetApplicationsDto[] | undefined;
}

export class PagedResultDtoOfImporsenatedUserDetails implements IPagedResultDtoOfImporsenatedUserDetails {
    totalCount!: number;
    items!: ImporsenatedUserDetails[] | undefined;

    constructor(data?: IPagedResultDtoOfImporsenatedUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImporsenatedUserDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfImporsenatedUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfImporsenatedUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfImporsenatedUserDetails {
    totalCount: number;
    items: ImporsenatedUserDetails[] | undefined;
}

export class PagedResultDtoOfInActiveUserDto implements IPagedResultDtoOfInActiveUserDto {
    totalCount!: number;
    items!: InActiveUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInActiveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InActiveUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInActiveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInActiveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfInActiveUserDto {
    totalCount: number;
    items: InActiveUserDto[] | undefined;
}

export class PagedResultDtoOfInActiveUserWithWorkTypeDto implements IPagedResultDtoOfInActiveUserWithWorkTypeDto {
    totalCount!: number;
    items!: InActiveUserWithWorkTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInActiveUserWithWorkTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InActiveUserWithWorkTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInActiveUserWithWorkTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInActiveUserWithWorkTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfInActiveUserWithWorkTypeDto {
    totalCount: number;
    items: InActiveUserWithWorkTypeDto[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfMemberAllocationListDto implements IPagedResultDtoOfMemberAllocationListDto {
    totalCount!: number;
    items!: MemberAllocationListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMemberAllocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MemberAllocationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMemberAllocationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMemberAllocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMemberAllocationListDto {
    totalCount: number;
    items: MemberAllocationListDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfNameValueOrganization implements IPagedResultDtoOfNameValueOrganization {
    totalCount!: number;
    items!: NameValueOrganization[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueOrganization.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueOrganization {
    totalCount: number;
    items: NameValueOrganization[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfOutPutGetApprovalGridDataDto implements IPagedResultDtoOfOutPutGetApprovalGridDataDto {
    totalCount!: number;
    items!: OutPutGetApprovalGridDataDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOutPutGetApprovalGridDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutPutGetApprovalGridDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOutPutGetApprovalGridDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOutPutGetApprovalGridDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOutPutGetApprovalGridDataDto {
    totalCount: number;
    items: OutPutGetApprovalGridDataDto[] | undefined;
}

export class PagedResultDtoOfOutPutTimesheetApprovalDto implements IPagedResultDtoOfOutPutTimesheetApprovalDto {
    totalCount!: number;
    items!: OutPutTimesheetApprovalDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOutPutTimesheetApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutPutTimesheetApprovalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOutPutTimesheetApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOutPutTimesheetApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOutPutTimesheetApprovalDto {
    totalCount: number;
    items: OutPutTimesheetApprovalDto[] | undefined;
}

export class PagedResultDtoOfOutputTeamTrackingDto implements IPagedResultDtoOfOutputTeamTrackingDto {
    totalCount!: number;
    items!: OutputTeamTrackingDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOutputTeamTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutputTeamTrackingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOutputTeamTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOutputTeamTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfOutputTeamTrackingDto {
    totalCount: number;
    items: OutputTeamTrackingDto[] | undefined;
}

export class PagedResultDtoOfPendingTimeDto implements IPagedResultDtoOfPendingTimeDto {
    totalCount!: number;
    items!: PendingTimeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPendingTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PendingTimeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPendingTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPendingTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfPendingTimeDto {
    totalCount: number;
    items: PendingTimeDto[] | undefined;
}

export class PagedResultDtoOfServiceCalendarEventDto implements IPagedResultDtoOfServiceCalendarEventDto {
    totalCount!: number;
    items!: ServiceCalendarEventDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCalendarEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfServiceCalendarEventDto {
    totalCount: number;
    items: ServiceCalendarEventDto[] | undefined;
}

export class PagedResultDtoOfSubmittedTimesheetGridDetailDto implements IPagedResultDtoOfSubmittedTimesheetGridDetailDto {
    totalCount!: number;
    items!: SubmittedTimesheetGridDetailDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubmittedTimesheetGridDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubmittedTimesheetGridDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubmittedTimesheetGridDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubmittedTimesheetGridDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSubmittedTimesheetGridDetailDto {
    totalCount: number;
    items: SubmittedTimesheetGridDetailDto[] | undefined;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class PagedResultDtoOfTeamTaskDto implements IPagedResultDtoOfTeamTaskDto {
    totalCount!: number;
    items!: TeamTaskDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTeamTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TeamTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTeamTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTeamTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTeamTaskDto {
    totalCount: number;
    items: TeamTaskDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfTimeSheetDto implements IPagedResultDtoOfTimeSheetDto {
    totalCount!: number;
    items!: TimeSheetDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTimeSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimeSheetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTimeSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTimeSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTimeSheetDto {
    totalCount: number;
    items: TimeSheetDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
    totalCount!: number;
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
    totalCount: number;
    items: UserLoginAttemptDto[] | undefined;
}

export class PagedResultDtoOfUserProjectManagerDto implements IPagedResultDtoOfUserProjectManagerDto {
    totalCount!: number;
    items!: UserProjectManagerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserProjectManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserProjectManagerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserProjectManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserProjectManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserProjectManagerDto {
    totalCount: number;
    items: UserProjectManagerDto[] | undefined;
}

export class PagedResultDtoOfUserProjectTaskDto implements IPagedResultDtoOfUserProjectTaskDto {
    totalCount!: number;
    items!: UserProjectTaskDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserProjectTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserProjectTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserProjectTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserProjectTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserProjectTaskDto {
    totalCount: number;
    items: UserProjectTaskDto[] | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class Pattern implements IPattern {
    type!: string | undefined;
    interval!: number;
    month!: number;
    dayOfMonth!: number;
    daysOfWeek!: string[] | undefined;
    firstDayOfWeek!: string | undefined;
    index!: string | undefined;

    constructor(data?: IPattern) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.interval = _data["interval"];
            this.month = _data["month"];
            this.dayOfMonth = _data["dayOfMonth"];
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): Pattern {
        data = typeof data === 'object' ? data : {};
        let result = new Pattern();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["interval"] = this.interval;
        data["month"] = this.month;
        data["dayOfMonth"] = this.dayOfMonth;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["index"] = this.index;
        return data;
    }
}

export interface IPattern {
    type: string | undefined;
    interval: number;
    month: number;
    dayOfMonth: number;
    daysOfWeek: string[] | undefined;
    firstDayOfWeek: string | undefined;
    index: string | undefined;
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;
    disabledFundings!: string[] | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.demoUsername = _data["demoUsername"];
            this.demoPassword = _data["demoPassword"];
            if (Array.isArray(_data["disabledFundings"])) {
                this.disabledFundings = [] as any;
                for (let item of _data["disabledFundings"])
                    this.disabledFundings!.push(item);
            }
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        if (Array.isArray(this.disabledFundings)) {
            data["disabledFundings"] = [];
            for (let item of this.disabledFundings)
                data["disabledFundings"].push(item);
        }
        return data;
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
    disabledFundings: string[] | undefined;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto;
    additionalPrice!: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : undefined as any;
            this.additionalPrice = _data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export class PendingApplicationInfo implements IPendingApplicationInfo {
    fullName!: string | undefined;
    userImage!: string | undefined;
    submittedOn!: DateTime;
    startIdealTime!: DateTime;
    endIdealTime!: DateTime;
    productivityType!: number | undefined;
    description!: string | undefined;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    id!: number | undefined;

    constructor(data?: IPendingApplicationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.userImage = _data["userImage"];
            this.submittedOn = _data["submittedOn"] ? DateTime.fromISO(_data["submittedOn"].toString()) : undefined as any;
            this.startIdealTime = _data["startIdealTime"] ? DateTime.fromISO(_data["startIdealTime"].toString()) : undefined as any;
            this.endIdealTime = _data["endIdealTime"] ? DateTime.fromISO(_data["endIdealTime"].toString()) : undefined as any;
            this.productivityType = _data["productivityType"];
            this.description = _data["description"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendingApplicationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PendingApplicationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["userImage"] = this.userImage;
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toString() : undefined as any;
        data["startIdealTime"] = this.startIdealTime ? this.startIdealTime.toString() : undefined as any;
        data["endIdealTime"] = this.endIdealTime ? this.endIdealTime.toString() : undefined as any;
        data["productivityType"] = this.productivityType;
        data["description"] = this.description;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendingApplicationInfo {
    fullName: string | undefined;
    userImage: string | undefined;
    submittedOn: DateTime;
    startIdealTime: DateTime;
    endIdealTime: DateTime;
    productivityType: number | undefined;
    description: string | undefined;
    projectName: string | undefined;
    projectImage: string | undefined;
    id: number | undefined;
}

export class PendingApproveDeclienCount implements IPendingApproveDeclienCount {
    approveCount!: number;
    pendingCount!: number;
    declienCount!: number;

    constructor(data?: IPendingApproveDeclienCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approveCount = _data["approveCount"];
            this.pendingCount = _data["pendingCount"];
            this.declienCount = _data["declienCount"];
        }
    }

    static fromJS(data: any): PendingApproveDeclienCount {
        data = typeof data === 'object' ? data : {};
        let result = new PendingApproveDeclienCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approveCount"] = this.approveCount;
        data["pendingCount"] = this.pendingCount;
        data["declienCount"] = this.declienCount;
        return data;
    }
}

export interface IPendingApproveDeclienCount {
    approveCount: number;
    pendingCount: number;
    declienCount: number;
}

export class PendingTimeDto implements IPendingTimeDto {
    projectCount!: number;
    productiveTime!: string | undefined;
    unProductiveTime!: string | undefined;
    neutralTime!: string | undefined;
    pendingApplicationInfos!: PendingApplicationInfo[] | undefined;
    id!: number | undefined;

    constructor(data?: IPendingTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectCount = _data["projectCount"];
            this.productiveTime = _data["productiveTime"];
            this.unProductiveTime = _data["unProductiveTime"];
            this.neutralTime = _data["neutralTime"];
            if (Array.isArray(_data["pendingApplicationInfos"])) {
                this.pendingApplicationInfos = [] as any;
                for (let item of _data["pendingApplicationInfos"])
                    this.pendingApplicationInfos!.push(PendingApplicationInfo.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendingTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCount"] = this.projectCount;
        data["productiveTime"] = this.productiveTime;
        data["unProductiveTime"] = this.unProductiveTime;
        data["neutralTime"] = this.neutralTime;
        if (Array.isArray(this.pendingApplicationInfos)) {
            data["pendingApplicationInfos"] = [];
            for (let item of this.pendingApplicationInfos)
                data["pendingApplicationInfos"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPendingTimeDto {
    projectCount: number;
    productiveTime: string | undefined;
    unProductiveTime: string | undefined;
    neutralTime: string | undefined;
    pendingApplicationInfos: PendingApplicationInfo[] | undefined;
    id: number | undefined;
}

export enum Platform {
    Ios = 1,
    Android = 2,
}

export class ProdData implements IProdData {
    id!: number;
    key!: string | undefined;
    val!: number;
    val2!: number;

    constructor(data?: IProdData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.val = _data["val"];
            this.val2 = _data["val2"];
        }
    }

    static fromJS(data: any): ProdData {
        data = typeof data === 'object' ? data : {};
        let result = new ProdData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["val"] = this.val;
        data["val2"] = this.val2;
        return data;
    }
}

export interface IProdData {
    id: number;
    key: string | undefined;
    val: number;
    val2: number;
}

export class ProductServiceTypeDto implements IProductServiceTypeDto {
    name!: string | undefined;
    code!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProductServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductServiceTypeDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export enum ProductType {
    AllProducts = 1,
    ArchivedProducts = 2,
    DeletedProducts = 3,
}

export class ProductiveApplicationDto implements IProductiveApplicationDto {
    filterType!: ApplocationDetails[] | undefined;

    constructor(data?: IProductiveApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filterType"])) {
                this.filterType = [] as any;
                for (let item of _data["filterType"])
                    this.filterType!.push(ApplocationDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductiveApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductiveApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filterType)) {
            data["filterType"] = [];
            for (let item of this.filterType)
                data["filterType"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductiveApplicationDto {
    filterType: ApplocationDetails[] | undefined;
}

export class ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto implements IProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto {
    categoryIcon!: string | undefined;
    applicationCount!: number;
    categoryName!: string | undefined;

    constructor(data?: IProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryIcon = _data["categoryIcon"];
            this.applicationCount = _data["applicationCount"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryIcon"] = this.categoryIcon;
        data["applicationCount"] = this.applicationCount;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface IProductiveUnproductiveNeutralTypeWiseCategoryAndApplicationDto {
    categoryIcon: string | undefined;
    applicationCount: number;
    categoryName: string | undefined;
}

export class ProductivityBarDetailInfo implements IProductivityBarDetailInfo {
    productivityBarDto!: ProductivityChartDto[] | undefined;
    manualAddEntryDto!: ManualEntryDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IProductivityBarDetailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productivityBarDto"])) {
                this.productivityBarDto = [] as any;
                for (let item of _data["productivityBarDto"])
                    this.productivityBarDto!.push(ProductivityChartDto.fromJS(item));
            }
            if (Array.isArray(_data["manualAddEntryDto"])) {
                this.manualAddEntryDto = [] as any;
                for (let item of _data["manualAddEntryDto"])
                    this.manualAddEntryDto!.push(ManualEntryDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductivityBarDetailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityBarDetailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productivityBarDto)) {
            data["productivityBarDto"] = [];
            for (let item of this.productivityBarDto)
                data["productivityBarDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.manualAddEntryDto)) {
            data["manualAddEntryDto"] = [];
            for (let item of this.manualAddEntryDto)
                data["manualAddEntryDto"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProductivityBarDetailInfo {
    productivityBarDto: ProductivityChartDto[] | undefined;
    manualAddEntryDto: ManualEntryDto[] | undefined;
    id: number | undefined;
}

export class ProductivityBarReport implements IProductivityBarReport {
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    userIds!: number[] | undefined;
    currentUserId!: number;
    tenantId!: number;
    timesheetSaveAsReportType!: TimesheetReportSaveAsType;
    fileName!: string | undefined;
    reportHistoryId!: number;

    constructor(data?: IProductivityBarReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            this.timesheetSaveAsReportType = _data["timesheetSaveAsReportType"];
            this.fileName = _data["fileName"];
            this.reportHistoryId = _data["reportHistoryId"];
        }
    }

    static fromJS(data: any): ProductivityBarReport {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityBarReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        data["timesheetSaveAsReportType"] = this.timesheetSaveAsReportType;
        data["fileName"] = this.fileName;
        data["reportHistoryId"] = this.reportHistoryId;
        return data;
    }
}

export interface IProductivityBarReport {
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    userIds: number[] | undefined;
    currentUserId: number;
    tenantId: number;
    timesheetSaveAsReportType: TimesheetReportSaveAsType;
    fileName: string | undefined;
    reportHistoryId: number;
}

export class ProductivityBarReportDto implements IProductivityBarReportDto {
    dateTime!: DateTime;
    employeeId!: string | undefined;
    userId!: number;
    name!: string | undefined;
    email!: string | undefined;
    roles!: string | undefined;
    group!: string | undefined;
    interval!: string | undefined;
    application!: string | undefined;
    productivity!: string | undefined;
    time!: string | undefined;

    constructor(data?: IProductivityBarReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : undefined as any;
            this.employeeId = _data["employeeId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.roles = _data["roles"];
            this.group = _data["group"];
            this.interval = _data["interval"];
            this.application = _data["application"];
            this.productivity = _data["productivity"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): ProductivityBarReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityBarReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : undefined as any;
        data["employeeId"] = this.employeeId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["roles"] = this.roles;
        data["group"] = this.group;
        data["interval"] = this.interval;
        data["application"] = this.application;
        data["productivity"] = this.productivity;
        data["time"] = this.time;
        return data;
    }
}

export interface IProductivityBarReportDto {
    dateTime: DateTime;
    employeeId: string | undefined;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    roles: string | undefined;
    group: string | undefined;
    interval: string | undefined;
    application: string | undefined;
    productivity: string | undefined;
    time: string | undefined;
}

export class ProductivityBarStartTimeDto implements IProductivityBarStartTimeDto {
    startTime!: DateTime;
    isPresent!: boolean;

    constructor(data?: IProductivityBarStartTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.isPresent = _data["isPresent"];
        }
    }

    static fromJS(data: any): ProductivityBarStartTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityBarStartTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["isPresent"] = this.isPresent;
        return data;
    }
}

export interface IProductivityBarStartTimeDto {
    startTime: DateTime;
    isPresent: boolean;
}

export class ProductivityCalculationWeekDto implements IProductivityCalculationWeekDto {
    productivityBarDetailInfo!: ProductivityBarDetailInfo;
    productivityBarDate!: DateTime;
    trackedTime!: string | undefined;
    userWiseProductiveUnproductiveAndNuetralTimeDto!: UserWiseProductiveUnproductiveAndNuetralDTO;
    userId!: number;

    constructor(data?: IProductivityCalculationWeekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productivityBarDetailInfo = _data["productivityBarDetailInfo"] ? ProductivityBarDetailInfo.fromJS(_data["productivityBarDetailInfo"]) : undefined as any;
            this.productivityBarDate = _data["productivityBarDate"] ? DateTime.fromISO(_data["productivityBarDate"].toString()) : undefined as any;
            this.trackedTime = _data["trackedTime"];
            this.userWiseProductiveUnproductiveAndNuetralTimeDto = _data["userWiseProductiveUnproductiveAndNuetralTimeDto"] ? UserWiseProductiveUnproductiveAndNuetralDTO.fromJS(_data["userWiseProductiveUnproductiveAndNuetralTimeDto"]) : undefined as any;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ProductivityCalculationWeekDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityCalculationWeekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productivityBarDetailInfo"] = this.productivityBarDetailInfo ? this.productivityBarDetailInfo.toJSON() : undefined as any;
        data["productivityBarDate"] = this.productivityBarDate ? this.productivityBarDate.toString() : undefined as any;
        data["trackedTime"] = this.trackedTime;
        data["userWiseProductiveUnproductiveAndNuetralTimeDto"] = this.userWiseProductiveUnproductiveAndNuetralTimeDto ? this.userWiseProductiveUnproductiveAndNuetralTimeDto.toJSON() : undefined as any;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IProductivityCalculationWeekDto {
    productivityBarDetailInfo: ProductivityBarDetailInfo;
    productivityBarDate: DateTime;
    trackedTime: string | undefined;
    userWiseProductiveUnproductiveAndNuetralTimeDto: UserWiseProductiveUnproductiveAndNuetralDTO;
    userId: number;
}

export class ProductivityChartDto implements IProductivityChartDto {
    startPointDate!: DateTime;
    dataChart!: ChartPrductiveUnProductiveValueDto;
    productivityInfo!: ApplicationAndTime[] | undefined;
    unProductivityInfo!: ApplicationAndTime[] | undefined;
    neutralInfo!: ApplicationAndTime[] | undefined;
    privateTimeInfo!: ApplicationAndTime[] | undefined;
    userId!: number;
    id!: number | undefined;

    constructor(data?: IProductivityChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startPointDate = _data["startPointDate"] ? DateTime.fromISO(_data["startPointDate"].toString()) : undefined as any;
            this.dataChart = _data["dataChart"] ? ChartPrductiveUnProductiveValueDto.fromJS(_data["dataChart"]) : undefined as any;
            if (Array.isArray(_data["productivityInfo"])) {
                this.productivityInfo = [] as any;
                for (let item of _data["productivityInfo"])
                    this.productivityInfo!.push(ApplicationAndTime.fromJS(item));
            }
            if (Array.isArray(_data["unProductivityInfo"])) {
                this.unProductivityInfo = [] as any;
                for (let item of _data["unProductivityInfo"])
                    this.unProductivityInfo!.push(ApplicationAndTime.fromJS(item));
            }
            if (Array.isArray(_data["neutralInfo"])) {
                this.neutralInfo = [] as any;
                for (let item of _data["neutralInfo"])
                    this.neutralInfo!.push(ApplicationAndTime.fromJS(item));
            }
            if (Array.isArray(_data["privateTimeInfo"])) {
                this.privateTimeInfo = [] as any;
                for (let item of _data["privateTimeInfo"])
                    this.privateTimeInfo!.push(ApplicationAndTime.fromJS(item));
            }
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductivityChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startPointDate"] = this.startPointDate ? this.startPointDate.toString() : undefined as any;
        data["dataChart"] = this.dataChart ? this.dataChart.toJSON() : undefined as any;
        if (Array.isArray(this.productivityInfo)) {
            data["productivityInfo"] = [];
            for (let item of this.productivityInfo)
                data["productivityInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unProductivityInfo)) {
            data["unProductivityInfo"] = [];
            for (let item of this.unProductivityInfo)
                data["unProductivityInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.neutralInfo)) {
            data["neutralInfo"] = [];
            for (let item of this.neutralInfo)
                data["neutralInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.privateTimeInfo)) {
            data["privateTimeInfo"] = [];
            for (let item of this.privateTimeInfo)
                data["privateTimeInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductivityChartDto {
    startPointDate: DateTime;
    dataChart: ChartPrductiveUnProductiveValueDto;
    productivityInfo: ApplicationAndTime[] | undefined;
    unProductivityInfo: ApplicationAndTime[] | undefined;
    neutralInfo: ApplicationAndTime[] | undefined;
    privateTimeInfo: ApplicationAndTime[] | undefined;
    userId: number;
    id: number | undefined;
}

export class ProductivityFormulaDto implements IProductivityFormulaDto {
    id!: number;
    tenantId!: number;
    includeProductiveTime!: boolean;
    includeNeutralTime!: boolean;
    productivityCalculationBasedOn!: number;

    constructor(data?: IProductivityFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.includeProductiveTime = _data["includeProductiveTime"];
            this.includeNeutralTime = _data["includeNeutralTime"];
            this.productivityCalculationBasedOn = _data["productivityCalculationBasedOn"];
        }
    }

    static fromJS(data: any): ProductivityFormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["includeProductiveTime"] = this.includeProductiveTime;
        data["includeNeutralTime"] = this.includeNeutralTime;
        data["productivityCalculationBasedOn"] = this.productivityCalculationBasedOn;
        return data;
    }
}

export interface IProductivityFormulaDto {
    id: number;
    tenantId: number;
    includeProductiveTime: boolean;
    includeNeutralTime: boolean;
    productivityCalculationBasedOn: number;
}

export class ProductivityJsonUploadDto implements IProductivityJsonUploadDto {
    name!: string | undefined;
    barJson!: string | undefined;

    constructor(data?: IProductivityJsonUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.barJson = _data["barJson"];
        }
    }

    static fromJS(data: any): ProductivityJsonUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityJsonUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["barJson"] = this.barJson;
        return data;
    }
}

export interface IProductivityJsonUploadDto {
    name: string | undefined;
    barJson: string | undefined;
}

export class ProductivityType implements IProductivityType {
    name!: string;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProductivityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductivityType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductivityType {
    name: string;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ProductivityTypeDto implements IProductivityTypeDto {
    name!: string | undefined;
    code!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProductivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductivityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductivityTypeDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export class ProductivityTypeGetAllDto implements IProductivityTypeGetAllDto {
    name!: string | undefined;
    code!: string | undefined;
    id!: number;

    constructor(data?: IProductivityTypeGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductivityTypeGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityTypeGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductivityTypeGetAllDto {
    name: string | undefined;
    code: string | undefined;
    id: number;
}

export enum ProductivityTypes {
    Productive = 1,
    Unproductive = 2,
    Neutral = 3,
}

export class ProgressDto implements IProgressDto {
    jobId!: string | undefined;
    progress!: number;

    constructor(data?: IProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): ProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IProgressDto {
    jobId: string | undefined;
    progress: number;
}

export class ProjectAllocationInfo implements IProjectAllocationInfo {
    projectId!: number;
    projectName!: string | undefined;
    projectRole!: string | undefined;
    usersMonthlyHours!: number;
    projectBillingType!: ProjectBillingType;

    constructor(data?: IProjectAllocationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectRole = _data["projectRole"];
            this.usersMonthlyHours = _data["usersMonthlyHours"];
            this.projectBillingType = _data["projectBillingType"];
        }
    }

    static fromJS(data: any): ProjectAllocationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAllocationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectRole"] = this.projectRole;
        data["usersMonthlyHours"] = this.usersMonthlyHours;
        data["projectBillingType"] = this.projectBillingType;
        return data;
    }
}

export interface IProjectAllocationInfo {
    projectId: number;
    projectName: string | undefined;
    projectRole: string | undefined;
    usersMonthlyHours: number;
    projectBillingType: ProjectBillingType;
}

export enum ProjectBillingType {
    Billable = 1,
    NonBillable = 2,
}

export class ProjectClientApproversDto implements IProjectClientApproversDto {
    projectId!: number;
    clientId!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    isPrimary!: boolean;
    clientContactRoleId!: number;
    clientContactId!: number;
    userId!: number;
    approvalWindowOne!: number | undefined;
    approvalWindowInOne!: ApprovalWindowInEnum;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProjectClientApproversDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPrimary = _data["isPrimary"];
            this.clientContactRoleId = _data["clientContactRoleId"];
            this.clientContactId = _data["clientContactId"];
            this.userId = _data["userId"];
            this.approvalWindowOne = _data["approvalWindowOne"];
            this.approvalWindowInOne = _data["approvalWindowInOne"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectClientApproversDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectClientApproversDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isPrimary"] = this.isPrimary;
        data["clientContactRoleId"] = this.clientContactRoleId;
        data["clientContactId"] = this.clientContactId;
        data["userId"] = this.userId;
        data["approvalWindowOne"] = this.approvalWindowOne;
        data["approvalWindowInOne"] = this.approvalWindowInOne;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectClientApproversDto {
    projectId: number;
    clientId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    isPrimary: boolean;
    clientContactRoleId: number;
    clientContactId: number;
    userId: number;
    approvalWindowOne: number | undefined;
    approvalWindowInOne: ApprovalWindowInEnum;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ProjectCreateOrEditDto implements IProjectCreateOrEditDto {
    tenantId!: number;
    name!: string;
    projectImage!: string | undefined;
    tags!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    clientId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    isActive!: boolean;
    projectType!: number;
    projectBillingType!: ProjectBillingType;
    singleRatePerHour!: number;
    firstApprover!: number[] | undefined;
    secondApprover!: number[] | undefined;
    flatRate!: number | undefined;
    projectStatus!: ProjectStatus;
    projectTeams!: ProjectTeamCreateOrEditDto[] | undefined;
    projectProductServices!: ProjectProductServiceCreateOrEditDto[] | undefined;
    hrslogged!: number;
    unbilllablehrs!: number;
    unbilllamount!: number;
    lastInvoice!: string | undefined;
    hourlyBudget!: number;
    projectTimeSheet!: ProjectTimeSheetCreateEditDto;
    projectClientApprovers!: ProjectClientApproversDto[] | undefined;
    projectTimeOff!: ProjectTimeOffCreateOrEditDto;
    assignedProgramManager!: number;
    assignedProjectManager!: number[] | undefined;
    projectURL!: string | undefined;
    devProjectName!: string | undefined;
    personalAccessToken!: string | undefined;
    tokenStartDate!: DateTime | undefined;
    tokenExpireDate!: DateTime | undefined;
    updatedProjectTimesheetTimeline!: UpdateProjectTimesheetTimeLineDto[] | undefined;
    billabilityStatusAuthority!: boolean;
    id!: number | undefined;

    constructor(data?: IProjectCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.projectImage = _data["projectImage"];
            this.tags = _data["tags"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.clientId = _data["clientId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.projectType = _data["projectType"];
            this.projectBillingType = _data["projectBillingType"];
            this.singleRatePerHour = _data["singleRatePerHour"];
            if (Array.isArray(_data["firstApprover"])) {
                this.firstApprover = [] as any;
                for (let item of _data["firstApprover"])
                    this.firstApprover!.push(item);
            }
            if (Array.isArray(_data["secondApprover"])) {
                this.secondApprover = [] as any;
                for (let item of _data["secondApprover"])
                    this.secondApprover!.push(item);
            }
            this.flatRate = _data["flatRate"];
            this.projectStatus = _data["projectStatus"];
            if (Array.isArray(_data["projectTeams"])) {
                this.projectTeams = [] as any;
                for (let item of _data["projectTeams"])
                    this.projectTeams!.push(ProjectTeamCreateOrEditDto.fromJS(item));
            }
            if (Array.isArray(_data["projectProductServices"])) {
                this.projectProductServices = [] as any;
                for (let item of _data["projectProductServices"])
                    this.projectProductServices!.push(ProjectProductServiceCreateOrEditDto.fromJS(item));
            }
            this.hrslogged = _data["hrslogged"];
            this.unbilllablehrs = _data["unbilllablehrs"];
            this.unbilllamount = _data["unbilllamount"];
            this.lastInvoice = _data["lastInvoice"];
            this.hourlyBudget = _data["hourlyBudget"];
            this.projectTimeSheet = _data["projectTimeSheet"] ? ProjectTimeSheetCreateEditDto.fromJS(_data["projectTimeSheet"]) : undefined as any;
            if (Array.isArray(_data["projectClientApprovers"])) {
                this.projectClientApprovers = [] as any;
                for (let item of _data["projectClientApprovers"])
                    this.projectClientApprovers!.push(ProjectClientApproversDto.fromJS(item));
            }
            this.projectTimeOff = _data["projectTimeOff"] ? ProjectTimeOffCreateOrEditDto.fromJS(_data["projectTimeOff"]) : undefined as any;
            this.assignedProgramManager = _data["assignedProgramManager"];
            if (Array.isArray(_data["assignedProjectManager"])) {
                this.assignedProjectManager = [] as any;
                for (let item of _data["assignedProjectManager"])
                    this.assignedProjectManager!.push(item);
            }
            this.projectURL = _data["projectURL"];
            this.devProjectName = _data["devProjectName"];
            this.personalAccessToken = _data["personalAccessToken"];
            this.tokenStartDate = _data["tokenStartDate"] ? DateTime.fromISO(_data["tokenStartDate"].toString()) : undefined as any;
            this.tokenExpireDate = _data["tokenExpireDate"] ? DateTime.fromISO(_data["tokenExpireDate"].toString()) : undefined as any;
            if (Array.isArray(_data["updatedProjectTimesheetTimeline"])) {
                this.updatedProjectTimesheetTimeline = [] as any;
                for (let item of _data["updatedProjectTimesheetTimeline"])
                    this.updatedProjectTimesheetTimeline!.push(UpdateProjectTimesheetTimeLineDto.fromJS(item));
            }
            this.billabilityStatusAuthority = _data["billabilityStatusAuthority"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["projectImage"] = this.projectImage;
        data["tags"] = this.tags;
        data["code"] = this.code;
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isActive"] = this.isActive;
        data["projectType"] = this.projectType;
        data["projectBillingType"] = this.projectBillingType;
        data["singleRatePerHour"] = this.singleRatePerHour;
        if (Array.isArray(this.firstApprover)) {
            data["firstApprover"] = [];
            for (let item of this.firstApprover)
                data["firstApprover"].push(item);
        }
        if (Array.isArray(this.secondApprover)) {
            data["secondApprover"] = [];
            for (let item of this.secondApprover)
                data["secondApprover"].push(item);
        }
        data["flatRate"] = this.flatRate;
        data["projectStatus"] = this.projectStatus;
        if (Array.isArray(this.projectTeams)) {
            data["projectTeams"] = [];
            for (let item of this.projectTeams)
                data["projectTeams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectProductServices)) {
            data["projectProductServices"] = [];
            for (let item of this.projectProductServices)
                data["projectProductServices"].push(item ? item.toJSON() : undefined as any);
        }
        data["hrslogged"] = this.hrslogged;
        data["unbilllablehrs"] = this.unbilllablehrs;
        data["unbilllamount"] = this.unbilllamount;
        data["lastInvoice"] = this.lastInvoice;
        data["hourlyBudget"] = this.hourlyBudget;
        data["projectTimeSheet"] = this.projectTimeSheet ? this.projectTimeSheet.toJSON() : undefined as any;
        if (Array.isArray(this.projectClientApprovers)) {
            data["projectClientApprovers"] = [];
            for (let item of this.projectClientApprovers)
                data["projectClientApprovers"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectTimeOff"] = this.projectTimeOff ? this.projectTimeOff.toJSON() : undefined as any;
        data["assignedProgramManager"] = this.assignedProgramManager;
        if (Array.isArray(this.assignedProjectManager)) {
            data["assignedProjectManager"] = [];
            for (let item of this.assignedProjectManager)
                data["assignedProjectManager"].push(item);
        }
        data["projectURL"] = this.projectURL;
        data["devProjectName"] = this.devProjectName;
        data["personalAccessToken"] = this.personalAccessToken;
        data["tokenStartDate"] = this.tokenStartDate ? this.tokenStartDate.toString() : undefined as any;
        data["tokenExpireDate"] = this.tokenExpireDate ? this.tokenExpireDate.toString() : undefined as any;
        if (Array.isArray(this.updatedProjectTimesheetTimeline)) {
            data["updatedProjectTimesheetTimeline"] = [];
            for (let item of this.updatedProjectTimesheetTimeline)
                data["updatedProjectTimesheetTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        data["billabilityStatusAuthority"] = this.billabilityStatusAuthority;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectCreateOrEditDto {
    tenantId: number;
    name: string;
    projectImage: string | undefined;
    tags: string | undefined;
    code: string | undefined;
    description: string | undefined;
    clientId: number | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    isActive: boolean;
    projectType: number;
    projectBillingType: ProjectBillingType;
    singleRatePerHour: number;
    firstApprover: number[] | undefined;
    secondApprover: number[] | undefined;
    flatRate: number | undefined;
    projectStatus: ProjectStatus;
    projectTeams: ProjectTeamCreateOrEditDto[] | undefined;
    projectProductServices: ProjectProductServiceCreateOrEditDto[] | undefined;
    hrslogged: number;
    unbilllablehrs: number;
    unbilllamount: number;
    lastInvoice: string | undefined;
    hourlyBudget: number;
    projectTimeSheet: ProjectTimeSheetCreateEditDto;
    projectClientApprovers: ProjectClientApproversDto[] | undefined;
    projectTimeOff: ProjectTimeOffCreateOrEditDto;
    assignedProgramManager: number;
    assignedProjectManager: number[] | undefined;
    projectURL: string | undefined;
    devProjectName: string | undefined;
    personalAccessToken: string | undefined;
    tokenStartDate: DateTime | undefined;
    tokenExpireDate: DateTime | undefined;
    updatedProjectTimesheetTimeline: UpdateProjectTimesheetTimeLineDto[] | undefined;
    billabilityStatusAuthority: boolean;
    id: number | undefined;
}

export class ProjectDetailsDto implements IProjectDetailsDto {
    projectName!: string | undefined;
    projectImage!: string | undefined;
    projectStartDate!: DateTime | undefined;
    projectEndDate!: DateTime | undefined;
    projectStatus!: ProjectStatus;
    clientName!: string | undefined;
    clientImage!: string | undefined;
    clientEmail!: string | undefined;
    clientMobile!: string | undefined;

    constructor(data?: IProjectDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.projectStartDate = _data["projectStartDate"] ? DateTime.fromISO(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.projectStatus = _data["projectStatus"];
            this.clientName = _data["clientName"];
            this.clientImage = _data["clientImage"];
            this.clientEmail = _data["clientEmail"];
            this.clientMobile = _data["clientMobile"];
        }
    }

    static fromJS(data: any): ProjectDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["projectStatus"] = this.projectStatus;
        data["clientName"] = this.clientName;
        data["clientImage"] = this.clientImage;
        data["clientEmail"] = this.clientEmail;
        data["clientMobile"] = this.clientMobile;
        return data;
    }
}

export interface IProjectDetailsDto {
    projectName: string | undefined;
    projectImage: string | undefined;
    projectStartDate: DateTime | undefined;
    projectEndDate: DateTime | undefined;
    projectStatus: ProjectStatus;
    clientName: string | undefined;
    clientImage: string | undefined;
    clientEmail: string | undefined;
    clientMobile: string | undefined;
}

export class ProjectDocumentDto implements IProjectDocumentDto {
    projectId!: number;
    fileName!: string | undefined;
    filePath!: string | undefined;
    fileSize!: number;
    fileType!: string | undefined;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IProjectDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.fileSize = _data["fileSize"];
            this.fileType = _data["fileType"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectDocumentDto {
    projectId: number;
    fileName: string | undefined;
    filePath: string | undefined;
    fileSize: number;
    fileType: string | undefined;
    creationTime: DateTime;
    id: number;
}

export class ProjectDto implements IProjectDto {
    tenantId!: number;
    name!: string | undefined;
    projectImageURL!: string | undefined;
    tags!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    clientId!: number;
    startDate!: DateTime;
    endDate!: DateTime;
    isActive!: boolean;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.projectImageURL = _data["projectImageURL"];
            this.tags = _data["tags"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.clientId = _data["clientId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["projectImageURL"] = this.projectImageURL;
        data["tags"] = this.tags;
        data["code"] = this.code;
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProjectDto {
    tenantId: number;
    name: string | undefined;
    projectImageURL: string | undefined;
    tags: string | undefined;
    code: string | undefined;
    description: string | undefined;
    clientId: number;
    startDate: DateTime;
    endDate: DateTime;
    isActive: boolean;
}

export class ProjectDtoForFlutter implements IProjectDtoForFlutter {
    id!: number | undefined;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    billableProjectType!: number;
    billableAccess!: boolean;

    constructor(data?: IProjectDtoForFlutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.billableProjectType = _data["billableProjectType"];
            this.billableAccess = _data["billableAccess"];
        }
    }

    static fromJS(data: any): ProjectDtoForFlutter {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDtoForFlutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["billableProjectType"] = this.billableProjectType;
        data["billableAccess"] = this.billableAccess;
        return data;
    }
}

export interface IProjectDtoForFlutter {
    id: number | undefined;
    projectName: string | undefined;
    projectImage: string | undefined;
    billableProjectType: number;
    billableAccess: boolean;
}

export class ProjectGetAllDto implements IProjectGetAllDto {
    tenantId!: number;
    name!: string | undefined;
    projectImage!: string | undefined;
    tags!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    isActive!: string | undefined;
    userId!: number | undefined;
    lastModificationTime!: string | undefined;
    isDeleted!: boolean;
    isDelete!: string | undefined;
    clientName!: string | undefined;
    client!: ClientDto;
    modifiedUserName!: string | undefined;
    clientImage!: string | undefined;
    clientEmail!: string | undefined;
    phoneNumber!: number;
    projectType!: number;
    projectBillingType!: ProjectBillingType;
    singleRatePerHour!: number;
    flatRate!: number | undefined;
    teamMembers!: ProjectTeamGetAllDto[] | undefined;
    approvers!: ProjectTeamGetAllDto[] | undefined;
    tenantProductService!: TenantProductServiceDto[] | undefined;
    projectTaskCount!: number;
    projectStatus!: ProjectStatus;
    hrslogged!: number;
    unbilllablehrs!: number;
    unbilllamount!: number;
    lastInvoice!: string | undefined;
    hourlyBudget!: number;
    projectTimeSheet!: ProjectTimeSheetGetAllDto;
    isTimeSheetSubmitted!: boolean;
    projectClientApprovers!: ProjectClientApproversDto[] | undefined;
    projectTimeOff!: ProjectTimeOffGetAllDto;
    createdBy!: UserListDto;
    projectCreationDate!: DateTime;
    assignedProgramManagerData!: UserListDto;
    assignedProgramManager!: number;
    assignedProjectManager!: UserListDto[] | undefined;
    clientId!: number | undefined;
    billedHours!: string;
    projectURL!: string | undefined;
    devProjectName!: string | undefined;
    personalAccessToken!: string | undefined;
    isArchived!: boolean;
    creationTime!: DateTime;
    billabilityStatusAuthority!: boolean;
    id!: number;

    constructor(data?: IProjectGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.projectImage = _data["projectImage"];
            this.tags = _data["tags"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.userId = _data["userId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.isDeleted = _data["isDeleted"];
            this.isDelete = _data["isDelete"];
            this.clientName = _data["clientName"];
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : undefined as any;
            this.modifiedUserName = _data["modifiedUserName"];
            this.clientImage = _data["clientImage"];
            this.clientEmail = _data["clientEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.projectType = _data["projectType"];
            this.projectBillingType = _data["projectBillingType"];
            this.singleRatePerHour = _data["singleRatePerHour"];
            this.flatRate = _data["flatRate"];
            if (Array.isArray(_data["teamMembers"])) {
                this.teamMembers = [] as any;
                for (let item of _data["teamMembers"])
                    this.teamMembers!.push(ProjectTeamGetAllDto.fromJS(item));
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(ProjectTeamGetAllDto.fromJS(item));
            }
            if (Array.isArray(_data["tenantProductService"])) {
                this.tenantProductService = [] as any;
                for (let item of _data["tenantProductService"])
                    this.tenantProductService!.push(TenantProductServiceDto.fromJS(item));
            }
            this.projectTaskCount = _data["projectTaskCount"];
            this.projectStatus = _data["projectStatus"];
            this.hrslogged = _data["hrslogged"];
            this.unbilllablehrs = _data["unbilllablehrs"];
            this.unbilllamount = _data["unbilllamount"];
            this.lastInvoice = _data["lastInvoice"];
            this.hourlyBudget = _data["hourlyBudget"];
            this.projectTimeSheet = _data["projectTimeSheet"] ? ProjectTimeSheetGetAllDto.fromJS(_data["projectTimeSheet"]) : undefined as any;
            this.isTimeSheetSubmitted = _data["isTimeSheetSubmitted"];
            if (Array.isArray(_data["projectClientApprovers"])) {
                this.projectClientApprovers = [] as any;
                for (let item of _data["projectClientApprovers"])
                    this.projectClientApprovers!.push(ProjectClientApproversDto.fromJS(item));
            }
            this.projectTimeOff = _data["projectTimeOff"] ? ProjectTimeOffGetAllDto.fromJS(_data["projectTimeOff"]) : undefined as any;
            this.createdBy = _data["createdBy"] ? UserListDto.fromJS(_data["createdBy"]) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.assignedProgramManagerData = _data["assignedProgramManagerData"] ? UserListDto.fromJS(_data["assignedProgramManagerData"]) : undefined as any;
            this.assignedProgramManager = _data["assignedProgramManager"];
            if (Array.isArray(_data["assignedProjectManager"])) {
                this.assignedProjectManager = [] as any;
                for (let item of _data["assignedProjectManager"])
                    this.assignedProjectManager!.push(UserListDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
            this.billedHours = _data["billedHours"];
            this.projectURL = _data["projectURL"];
            this.devProjectName = _data["devProjectName"];
            this.personalAccessToken = _data["personalAccessToken"];
            this.isArchived = _data["isArchived"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.billabilityStatusAuthority = _data["billabilityStatusAuthority"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["projectImage"] = this.projectImage;
        data["tags"] = this.tags;
        data["code"] = this.code;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isActive"] = this.isActive;
        data["userId"] = this.userId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["isDeleted"] = this.isDeleted;
        data["isDelete"] = this.isDelete;
        data["clientName"] = this.clientName;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["modifiedUserName"] = this.modifiedUserName;
        data["clientImage"] = this.clientImage;
        data["clientEmail"] = this.clientEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["projectType"] = this.projectType;
        data["projectBillingType"] = this.projectBillingType;
        data["singleRatePerHour"] = this.singleRatePerHour;
        data["flatRate"] = this.flatRate;
        if (Array.isArray(this.teamMembers)) {
            data["teamMembers"] = [];
            for (let item of this.teamMembers)
                data["teamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tenantProductService)) {
            data["tenantProductService"] = [];
            for (let item of this.tenantProductService)
                data["tenantProductService"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectTaskCount"] = this.projectTaskCount;
        data["projectStatus"] = this.projectStatus;
        data["hrslogged"] = this.hrslogged;
        data["unbilllablehrs"] = this.unbilllablehrs;
        data["unbilllamount"] = this.unbilllamount;
        data["lastInvoice"] = this.lastInvoice;
        data["hourlyBudget"] = this.hourlyBudget;
        data["projectTimeSheet"] = this.projectTimeSheet ? this.projectTimeSheet.toJSON() : undefined as any;
        data["isTimeSheetSubmitted"] = this.isTimeSheetSubmitted;
        if (Array.isArray(this.projectClientApprovers)) {
            data["projectClientApprovers"] = [];
            for (let item of this.projectClientApprovers)
                data["projectClientApprovers"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectTimeOff"] = this.projectTimeOff ? this.projectTimeOff.toJSON() : undefined as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["assignedProgramManagerData"] = this.assignedProgramManagerData ? this.assignedProgramManagerData.toJSON() : undefined as any;
        data["assignedProgramManager"] = this.assignedProgramManager;
        if (Array.isArray(this.assignedProjectManager)) {
            data["assignedProjectManager"] = [];
            for (let item of this.assignedProjectManager)
                data["assignedProjectManager"].push(item ? item.toJSON() : undefined as any);
        }
        data["clientId"] = this.clientId;
        data["billedHours"] = this.billedHours;
        data["projectURL"] = this.projectURL;
        data["devProjectName"] = this.devProjectName;
        data["personalAccessToken"] = this.personalAccessToken;
        data["isArchived"] = this.isArchived;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["billabilityStatusAuthority"] = this.billabilityStatusAuthority;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectGetAllDto {
    tenantId: number;
    name: string | undefined;
    projectImage: string | undefined;
    tags: string | undefined;
    code: string | undefined;
    description: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    isActive: string | undefined;
    userId: number | undefined;
    lastModificationTime: string | undefined;
    isDeleted: boolean;
    isDelete: string | undefined;
    clientName: string | undefined;
    client: ClientDto;
    modifiedUserName: string | undefined;
    clientImage: string | undefined;
    clientEmail: string | undefined;
    phoneNumber: number;
    projectType: number;
    projectBillingType: ProjectBillingType;
    singleRatePerHour: number;
    flatRate: number | undefined;
    teamMembers: ProjectTeamGetAllDto[] | undefined;
    approvers: ProjectTeamGetAllDto[] | undefined;
    tenantProductService: TenantProductServiceDto[] | undefined;
    projectTaskCount: number;
    projectStatus: ProjectStatus;
    hrslogged: number;
    unbilllablehrs: number;
    unbilllamount: number;
    lastInvoice: string | undefined;
    hourlyBudget: number;
    projectTimeSheet: ProjectTimeSheetGetAllDto;
    isTimeSheetSubmitted: boolean;
    projectClientApprovers: ProjectClientApproversDto[] | undefined;
    projectTimeOff: ProjectTimeOffGetAllDto;
    createdBy: UserListDto;
    projectCreationDate: DateTime;
    assignedProgramManagerData: UserListDto;
    assignedProgramManager: number;
    assignedProjectManager: UserListDto[] | undefined;
    clientId: number | undefined;
    billedHours: string;
    projectURL: string | undefined;
    devProjectName: string | undefined;
    personalAccessToken: string | undefined;
    isArchived: boolean;
    creationTime: DateTime;
    billabilityStatusAuthority: boolean;
    id: number;
}

export class ProjectInfo implements IProjectInfo {
    projectId!: number;
    projectName!: string | undefined;
    projectImg!: string | undefined;

    constructor(data?: IProjectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectImg = _data["projectImg"];
        }
    }

    static fromJS(data: any): ProjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectImg"] = this.projectImg;
        return data;
    }
}

export interface IProjectInfo {
    projectId: number;
    projectName: string | undefined;
    projectImg: string | undefined;
}

export class ProjectLevelCheckInCategoryDto implements IProjectLevelCheckInCategoryDto {
    categoryId!: number;
    isCheckIn!: boolean;

    constructor(data?: IProjectLevelCheckInCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.isCheckIn = _data["isCheckIn"];
        }
    }

    static fromJS(data: any): ProjectLevelCheckInCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLevelCheckInCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["isCheckIn"] = this.isCheckIn;
        return data;
    }
}

export interface IProjectLevelCheckInCategoryDto {
    categoryId: number;
    isCheckIn: boolean;
}

export class ProjectLevelCommentDto implements IProjectLevelCommentDto {
    userId!: number;
    tenantId!: number;
    projectId!: number;
    comment!: string | undefined;

    constructor(data?: IProjectLevelCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ProjectLevelCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLevelCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IProjectLevelCommentDto {
    userId: number;
    tenantId: number;
    projectId: number;
    comment: string | undefined;
}

export class ProjectLevelShowInTimesheetDto implements IProjectLevelShowInTimesheetDto {
    userId!: number;
    tenantId!: number;
    userProjectTaskId!: number | undefined;
    projectId!: number | undefined;
    includeInTimesheet!: boolean;
    timeSheetId!: number;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;

    constructor(data?: IProjectLevelShowInTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.projectId = _data["projectId"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.timeSheetId = _data["timeSheetId"];
            this.timesheetFrequency = _data["timesheetFrequency"];
        }
    }

    static fromJS(data: any): ProjectLevelShowInTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLevelShowInTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["projectId"] = this.projectId;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["timeSheetId"] = this.timeSheetId;
        data["timesheetFrequency"] = this.timesheetFrequency;
        return data;
    }
}

export interface IProjectLevelShowInTimesheetDto {
    userId: number;
    tenantId: number;
    userProjectTaskId: number | undefined;
    projectId: number | undefined;
    includeInTimesheet: boolean;
    timeSheetId: number;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
}

export class ProjectLevelShowInTimesheetDtoForMobile implements IProjectLevelShowInTimesheetDtoForMobile {
    userId!: number;
    tenantId!: number;
    userProjectTaskId!: number | undefined;
    projectId!: number | undefined;
    includeInTimesheet!: boolean;
    timeSheetId!: number;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;

    constructor(data?: IProjectLevelShowInTimesheetDtoForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.projectId = _data["projectId"];
            this.includeInTimesheet = _data["includeInTimesheet"];
            this.timeSheetId = _data["timeSheetId"];
            this.timesheetFrequency = _data["timesheetFrequency"];
        }
    }

    static fromJS(data: any): ProjectLevelShowInTimesheetDtoForMobile {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLevelShowInTimesheetDtoForMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["projectId"] = this.projectId;
        data["includeInTimesheet"] = this.includeInTimesheet;
        data["timeSheetId"] = this.timeSheetId;
        data["timesheetFrequency"] = this.timesheetFrequency;
        return data;
    }
}

export interface IProjectLevelShowInTimesheetDtoForMobile {
    userId: number;
    tenantId: number;
    userProjectTaskId: number | undefined;
    projectId: number | undefined;
    includeInTimesheet: boolean;
    timeSheetId: number;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
}

export class ProjectListViewSummaryDto implements IProjectListViewSummaryDto {
    timesheetId!: number;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    projectStartDate!: DateTime;
    projectEndDate!: DateTime;
    projectCreationDate!: DateTime;
    projectType!: ProjectBillingType;
    projectId!: number;
    projectTimesheetFrequency!: ProjectTimesheetFrequencyEnum;
    userList!: UserDetailsDto[] | undefined;
    currentUserRole!: string | undefined;
    projectIsActive!: boolean;
    projectArchived!: boolean;

    constructor(data?: IProjectListViewSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheetId = _data["timesheetId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.projectStartDate = _data["projectStartDate"] ? DateTime.fromISO(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectType = _data["projectType"];
            this.projectId = _data["projectId"];
            this.projectTimesheetFrequency = _data["projectTimesheetFrequency"];
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList!.push(UserDetailsDto.fromJS(item));
            }
            this.currentUserRole = _data["currentUserRole"];
            this.projectIsActive = _data["projectIsActive"];
            this.projectArchived = _data["projectArchived"];
        }
    }

    static fromJS(data: any): ProjectListViewSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListViewSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheetId"] = this.timesheetId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectType"] = this.projectType;
        data["projectId"] = this.projectId;
        data["projectTimesheetFrequency"] = this.projectTimesheetFrequency;
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentUserRole"] = this.currentUserRole;
        data["projectIsActive"] = this.projectIsActive;
        data["projectArchived"] = this.projectArchived;
        return data;
    }
}

export interface IProjectListViewSummaryDto {
    timesheetId: number;
    projectName: string | undefined;
    projectImage: string | undefined;
    projectStartDate: DateTime;
    projectEndDate: DateTime;
    projectCreationDate: DateTime;
    projectType: ProjectBillingType;
    projectId: number;
    projectTimesheetFrequency: ProjectTimesheetFrequencyEnum;
    userList: UserDetailsDto[] | undefined;
    currentUserRole: string | undefined;
    projectIsActive: boolean;
    projectArchived: boolean;
}

export class ProjectMemberImagesDto implements IProjectMemberImagesDto {
    name!: string | undefined;
    userList!: UserDetailsDto[] | undefined;

    constructor(data?: IProjectMemberImagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectMemberImagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMemberImagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectMemberImagesDto {
    name: string | undefined;
    userList: UserDetailsDto[] | undefined;
}

export class ProjectProductServiceCreateOrEditDto implements IProjectProductServiceCreateOrEditDto {
    tenantId!: number;
    projectId!: number | undefined;
    tenantProductServiceId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    isDeleted!: boolean;
    projectBillingServiceRate!: number;
    id!: number | undefined;

    constructor(data?: IProjectProductServiceCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.tenantProductServiceId = _data["tenantProductServiceId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.projectBillingServiceRate = _data["projectBillingServiceRate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectProductServiceCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectProductServiceCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["tenantProductServiceId"] = this.tenantProductServiceId;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["projectBillingServiceRate"] = this.projectBillingServiceRate;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectProductServiceCreateOrEditDto {
    tenantId: number;
    projectId: number | undefined;
    tenantProductServiceId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    isDeleted: boolean;
    projectBillingServiceRate: number;
    id: number | undefined;
}

export class ProjectProjectManagerDto implements IProjectProjectManagerDto {
    tenantId!: number;
    projectId!: number;
    userId!: number;
    id!: number;

    constructor(data?: IProjectProjectManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectProjectManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectProjectManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectProjectManagerDto {
    tenantId: number;
    projectId: number;
    userId: number;
    id: number;
}

export class ProjectRestorMessageDto implements IProjectRestorMessageDto {
    id!: number;
    projectName!: string | undefined;
    isRestored!: boolean;

    constructor(data?: IProjectRestorMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.isRestored = _data["isRestored"];
        }
    }

    static fromJS(data: any): ProjectRestorMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRestorMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["isRestored"] = this.isRestored;
        return data;
    }
}

export interface IProjectRestorMessageDto {
    id: number;
    projectName: string | undefined;
    isRestored: boolean;
}

export enum ProjectStatus {
    New = 1,
    Active = 2,
    Completed = 3,
    Closed = 4,
}

export class ProjectTaskCreateOrEditDto implements IProjectTaskCreateOrEditDto {
    tenantId!: number;
    name!: string;
    projectId!: number | undefined;
    userId!: number;
    taskTypeId!: number | undefined;
    taskStateId!: number | undefined;
    reproSteps!: string | undefined;
    systemInfo!: string | undefined;
    taskPriorityId!: number | undefined;
    taskSeverityId!: number | undefined;
    taskActivityId!: number | undefined;
    originalEstimateHr!: number;
    remainingEstimateHr!: number;
    completedEstimateHr!: number;
    targetEndDate!: DateTime;
    userData!: UserListDto;
    projectData!: ProjectCreateOrEditDto;
    taskDiscussion!: TaskDiscussionCreateOrEditDto;
    taskDiscussionData!: TaskDiscussionCreateOrEditDto[] | undefined;
    isTimeSheet!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IProjectTaskCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.taskTypeId = _data["taskTypeId"];
            this.taskStateId = _data["taskStateId"];
            this.reproSteps = _data["reproSteps"];
            this.systemInfo = _data["systemInfo"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.originalEstimateHr = _data["originalEstimateHr"];
            this.remainingEstimateHr = _data["remainingEstimateHr"];
            this.completedEstimateHr = _data["completedEstimateHr"];
            this.targetEndDate = _data["targetEndDate"] ? DateTime.fromISO(_data["targetEndDate"].toString()) : undefined as any;
            this.userData = _data["userData"] ? UserListDto.fromJS(_data["userData"]) : undefined as any;
            this.projectData = _data["projectData"] ? ProjectCreateOrEditDto.fromJS(_data["projectData"]) : undefined as any;
            this.taskDiscussion = _data["taskDiscussion"] ? TaskDiscussionCreateOrEditDto.fromJS(_data["taskDiscussion"]) : undefined as any;
            if (Array.isArray(_data["taskDiscussionData"])) {
                this.taskDiscussionData = [] as any;
                for (let item of _data["taskDiscussionData"])
                    this.taskDiscussionData!.push(TaskDiscussionCreateOrEditDto.fromJS(item));
            }
            this.isTimeSheet = _data["isTimeSheet"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTaskCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["taskTypeId"] = this.taskTypeId;
        data["taskStateId"] = this.taskStateId;
        data["reproSteps"] = this.reproSteps;
        data["systemInfo"] = this.systemInfo;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskActivityId"] = this.taskActivityId;
        data["originalEstimateHr"] = this.originalEstimateHr;
        data["remainingEstimateHr"] = this.remainingEstimateHr;
        data["completedEstimateHr"] = this.completedEstimateHr;
        data["targetEndDate"] = this.targetEndDate ? this.targetEndDate.toString() : undefined as any;
        data["userData"] = this.userData ? this.userData.toJSON() : undefined as any;
        data["projectData"] = this.projectData ? this.projectData.toJSON() : undefined as any;
        data["taskDiscussion"] = this.taskDiscussion ? this.taskDiscussion.toJSON() : undefined as any;
        if (Array.isArray(this.taskDiscussionData)) {
            data["taskDiscussionData"] = [];
            for (let item of this.taskDiscussionData)
                data["taskDiscussionData"].push(item ? item.toJSON() : undefined as any);
        }
        data["isTimeSheet"] = this.isTimeSheet;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTaskCreateOrEditDto {
    tenantId: number;
    name: string;
    projectId: number | undefined;
    userId: number;
    taskTypeId: number | undefined;
    taskStateId: number | undefined;
    reproSteps: string | undefined;
    systemInfo: string | undefined;
    taskPriorityId: number | undefined;
    taskSeverityId: number | undefined;
    taskActivityId: number | undefined;
    originalEstimateHr: number;
    remainingEstimateHr: number;
    completedEstimateHr: number;
    targetEndDate: DateTime;
    userData: UserListDto;
    projectData: ProjectCreateOrEditDto;
    taskDiscussion: TaskDiscussionCreateOrEditDto;
    taskDiscussionData: TaskDiscussionCreateOrEditDto[] | undefined;
    isTimeSheet: boolean | undefined;
    id: number | undefined;
}

export class ProjectTaskDto implements IProjectTaskDto {
    tenantId!: number;
    name!: string | undefined;
    projectId!: number;
    userId!: number;
    taskTypeId!: number;
    taskStateId!: number;
    reproSteps!: string | undefined;
    systemInfo!: string | undefined;
    taskPriorityId!: number;
    taskSeverityId!: number;
    taskActivityId!: number;
    originalEstimateHr!: number;
    remainingEstimateHr!: number;
    completedEstimateHr!: number;
    startDate!: DateTime;
    targetEndDate!: DateTime;
    actualEndDate!: DateTime;

    constructor(data?: IProjectTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.taskTypeId = _data["taskTypeId"];
            this.taskStateId = _data["taskStateId"];
            this.reproSteps = _data["reproSteps"];
            this.systemInfo = _data["systemInfo"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.originalEstimateHr = _data["originalEstimateHr"];
            this.remainingEstimateHr = _data["remainingEstimateHr"];
            this.completedEstimateHr = _data["completedEstimateHr"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.targetEndDate = _data["targetEndDate"] ? DateTime.fromISO(_data["targetEndDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? DateTime.fromISO(_data["actualEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["taskTypeId"] = this.taskTypeId;
        data["taskStateId"] = this.taskStateId;
        data["reproSteps"] = this.reproSteps;
        data["systemInfo"] = this.systemInfo;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskActivityId"] = this.taskActivityId;
        data["originalEstimateHr"] = this.originalEstimateHr;
        data["remainingEstimateHr"] = this.remainingEstimateHr;
        data["completedEstimateHr"] = this.completedEstimateHr;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["targetEndDate"] = this.targetEndDate ? this.targetEndDate.toString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toString() : undefined as any;
        return data;
    }
}

export interface IProjectTaskDto {
    tenantId: number;
    name: string | undefined;
    projectId: number;
    userId: number;
    taskTypeId: number;
    taskStateId: number;
    reproSteps: string | undefined;
    systemInfo: string | undefined;
    taskPriorityId: number;
    taskSeverityId: number;
    taskActivityId: number;
    originalEstimateHr: number;
    remainingEstimateHr: number;
    completedEstimateHr: number;
    startDate: DateTime;
    targetEndDate: DateTime;
    actualEndDate: DateTime;
}

export class ProjectTaskGetAllDto implements IProjectTaskGetAllDto {
    tenantId!: number;
    name!: string | undefined;
    userId!: number;
    taskTypeName!: string | undefined;
    taskStateName!: string | undefined;
    reproSteps!: string | undefined;
    systemInfo!: string | undefined;
    taskPriorityName!: string | undefined;
    projectName!: string | undefined;
    userName!: string | undefined;
    taskSeverityName!: string | undefined;
    taskActivityName!: string | undefined;
    originalEstimateHr!: number;
    remainingEstimateHr!: number;
    completedEstimateHr!: number;
    startDate!: DateTime;
    targetEndDate!: DateTime;
    actualEndDate!: DateTime;
    isDeleted!: boolean;
    isDelete!: string | undefined;
    lastModificationTime!: string | undefined;
    creatorId!: number | undefined;
    userData!: UserListDto;
    projectData!: ProjectGetAllDto;
    taskDiscussion!: TaskDiscussionCreateOrEditDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IProjectTaskGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.taskTypeName = _data["taskTypeName"];
            this.taskStateName = _data["taskStateName"];
            this.reproSteps = _data["reproSteps"];
            this.systemInfo = _data["systemInfo"];
            this.taskPriorityName = _data["taskPriorityName"];
            this.projectName = _data["projectName"];
            this.userName = _data["userName"];
            this.taskSeverityName = _data["taskSeverityName"];
            this.taskActivityName = _data["taskActivityName"];
            this.originalEstimateHr = _data["originalEstimateHr"];
            this.remainingEstimateHr = _data["remainingEstimateHr"];
            this.completedEstimateHr = _data["completedEstimateHr"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.targetEndDate = _data["targetEndDate"] ? DateTime.fromISO(_data["targetEndDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? DateTime.fromISO(_data["actualEndDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.isDelete = _data["isDelete"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.creatorId = _data["creatorId"];
            this.userData = _data["userData"] ? UserListDto.fromJS(_data["userData"]) : undefined as any;
            this.projectData = _data["projectData"] ? ProjectGetAllDto.fromJS(_data["projectData"]) : undefined as any;
            if (Array.isArray(_data["taskDiscussion"])) {
                this.taskDiscussion = [] as any;
                for (let item of _data["taskDiscussion"])
                    this.taskDiscussion!.push(TaskDiscussionCreateOrEditDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTaskGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["taskTypeName"] = this.taskTypeName;
        data["taskStateName"] = this.taskStateName;
        data["reproSteps"] = this.reproSteps;
        data["systemInfo"] = this.systemInfo;
        data["taskPriorityName"] = this.taskPriorityName;
        data["projectName"] = this.projectName;
        data["userName"] = this.userName;
        data["taskSeverityName"] = this.taskSeverityName;
        data["taskActivityName"] = this.taskActivityName;
        data["originalEstimateHr"] = this.originalEstimateHr;
        data["remainingEstimateHr"] = this.remainingEstimateHr;
        data["completedEstimateHr"] = this.completedEstimateHr;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["targetEndDate"] = this.targetEndDate ? this.targetEndDate.toString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["isDelete"] = this.isDelete;
        data["lastModificationTime"] = this.lastModificationTime;
        data["creatorId"] = this.creatorId;
        data["userData"] = this.userData ? this.userData.toJSON() : undefined as any;
        data["projectData"] = this.projectData ? this.projectData.toJSON() : undefined as any;
        if (Array.isArray(this.taskDiscussion)) {
            data["taskDiscussion"] = [];
            for (let item of this.taskDiscussion)
                data["taskDiscussion"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTaskGetAllDto {
    tenantId: number;
    name: string | undefined;
    userId: number;
    taskTypeName: string | undefined;
    taskStateName: string | undefined;
    reproSteps: string | undefined;
    systemInfo: string | undefined;
    taskPriorityName: string | undefined;
    projectName: string | undefined;
    userName: string | undefined;
    taskSeverityName: string | undefined;
    taskActivityName: string | undefined;
    originalEstimateHr: number;
    remainingEstimateHr: number;
    completedEstimateHr: number;
    startDate: DateTime;
    targetEndDate: DateTime;
    actualEndDate: DateTime;
    isDeleted: boolean;
    isDelete: string | undefined;
    lastModificationTime: string | undefined;
    creatorId: number | undefined;
    userData: UserListDto;
    projectData: ProjectGetAllDto;
    taskDiscussion: TaskDiscussionCreateOrEditDto[] | undefined;
    id: number | undefined;
}

export class ProjectTaskInput implements IProjectTaskInput {
    projectIds!: number[] | undefined;
    projectTaskIds!: number[] | undefined;
    taskNameSearch!: string | undefined;
    statusId!: number | undefined;
    isTimesheet!: boolean;

    constructor(data?: IProjectTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["projectTaskIds"])) {
                this.projectTaskIds = [] as any;
                for (let item of _data["projectTaskIds"])
                    this.projectTaskIds!.push(item);
            }
            this.taskNameSearch = _data["taskNameSearch"];
            this.statusId = _data["statusId"];
            this.isTimesheet = _data["isTimesheet"];
        }
    }

    static fromJS(data: any): ProjectTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.projectTaskIds)) {
            data["projectTaskIds"] = [];
            for (let item of this.projectTaskIds)
                data["projectTaskIds"].push(item);
        }
        data["taskNameSearch"] = this.taskNameSearch;
        data["statusId"] = this.statusId;
        data["isTimesheet"] = this.isTimesheet;
        return data;
    }
}

export interface IProjectTaskInput {
    projectIds: number[] | undefined;
    projectTaskIds: number[] | undefined;
    taskNameSearch: string | undefined;
    statusId: number | undefined;
    isTimesheet: boolean;
}

export class ProjectTaskStatus implements IProjectTaskStatus {
    tenantId!: number;
    userId!: number;
    userStatus!: UserStatusEnum;
    creationTime!: DateTime | undefined;

    constructor(data?: IProjectTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userStatus = _data["userStatus"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userStatus"] = this.userStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IProjectTaskStatus {
    tenantId: number;
    userId: number;
    userStatus: UserStatusEnum;
    creationTime: DateTime | undefined;
}

export class ProjectTeamCreateOrEditDto implements IProjectTeamCreateOrEditDto {
    tenantId!: number;
    projectId!: number | undefined;
    userId!: number;
    startDate!: DateTime;
    endDate!: DateTime;
    isDeleted!: boolean;
    userBillingRate!: number;
    people!: UserListDto;
    projectRole!: string | undefined;
    weeklyMaxHrs!: number;
    weeklyMinHrs!: number;
    id!: number | undefined;

    constructor(data?: IProjectTeamCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.userBillingRate = _data["userBillingRate"];
            this.people = _data["people"] ? UserListDto.fromJS(_data["people"]) : undefined as any;
            this.projectRole = _data["projectRole"];
            this.weeklyMaxHrs = _data["weeklyMaxHrs"];
            this.weeklyMinHrs = _data["weeklyMinHrs"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTeamCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userBillingRate"] = this.userBillingRate;
        data["people"] = this.people ? this.people.toJSON() : undefined as any;
        data["projectRole"] = this.projectRole;
        data["weeklyMaxHrs"] = this.weeklyMaxHrs;
        data["weeklyMinHrs"] = this.weeklyMinHrs;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTeamCreateOrEditDto {
    tenantId: number;
    projectId: number | undefined;
    userId: number;
    startDate: DateTime;
    endDate: DateTime;
    isDeleted: boolean;
    userBillingRate: number;
    people: UserListDto;
    projectRole: string | undefined;
    weeklyMaxHrs: number;
    weeklyMinHrs: number;
    id: number | undefined;
}

export class ProjectTeamGetAllDto implements IProjectTeamGetAllDto {
    name!: string | undefined;
    surname!: string | undefined;
    readonly fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    approvertype!: number;
    profilePictureId!: string | undefined;
    profileImage!: string | undefined;
    isEmailConfirmed!: boolean;
    userId!: number;
    isDeleted!: boolean;
    userBillingRate!: number;
    projectRole!: string | undefined;
    weeklyMaxHrs!: number;
    weeklyMinHrs!: number;
    startDate!: DateTime;
    joiningDate!: DateTime;
    userStatusId!: UserStatusEnum;
    endDate!: DateTime;
    organizationUnitName!: string | undefined;
    billedHourse!: string;
    projectName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProjectTeamGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            (this as any).fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.approvertype = _data["approvertype"];
            this.profilePictureId = _data["profilePictureId"];
            this.profileImage = _data["profileImage"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.userId = _data["userId"];
            this.isDeleted = _data["isDeleted"];
            this.userBillingRate = _data["userBillingRate"];
            this.projectRole = _data["projectRole"];
            this.weeklyMaxHrs = _data["weeklyMaxHrs"];
            this.weeklyMinHrs = _data["weeklyMinHrs"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.joiningDate = _data["joiningDate"] ? DateTime.fromISO(_data["joiningDate"].toString()) : undefined as any;
            this.userStatusId = _data["userStatusId"];
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.organizationUnitName = _data["organizationUnitName"];
            this.billedHourse = _data["billedHourse"];
            this.projectName = _data["projectName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTeamGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["approvertype"] = this.approvertype;
        data["profilePictureId"] = this.profilePictureId;
        data["profileImage"] = this.profileImage;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["userId"] = this.userId;
        data["isDeleted"] = this.isDeleted;
        data["userBillingRate"] = this.userBillingRate;
        data["projectRole"] = this.projectRole;
        data["weeklyMaxHrs"] = this.weeklyMaxHrs;
        data["weeklyMinHrs"] = this.weeklyMinHrs;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toString() : undefined as any;
        data["userStatusId"] = this.userStatusId;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["organizationUnitName"] = this.organizationUnitName;
        data["billedHourse"] = this.billedHourse;
        data["projectName"] = this.projectName;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTeamGetAllDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    approvertype: number;
    profilePictureId: string | undefined;
    profileImage: string | undefined;
    isEmailConfirmed: boolean;
    userId: number;
    isDeleted: boolean;
    userBillingRate: number;
    projectRole: string | undefined;
    weeklyMaxHrs: number;
    weeklyMinHrs: number;
    startDate: DateTime;
    joiningDate: DateTime;
    userStatusId: UserStatusEnum;
    endDate: DateTime;
    organizationUnitName: string | undefined;
    billedHourse: string;
    projectName: string | undefined;
    id: number | undefined;
}

export class ProjectTimeOffCreateOrEditDto implements IProjectTimeOffCreateOrEditDto {
    tenantId!: number;
    projectId!: number;
    approverIdLevelOne!: number | undefined;
    approvalWindowOne!: number | undefined;
    approvalWindowInOne!: ApprovalWindowInEnum;
    approverIdLevelTwo!: number | undefined;
    approvalWindowTwo!: number | undefined;
    approvalWindowInTwo!: ApprovalWindowInEnum;
    approverIdLevelThree!: number | undefined;
    approvalWindowThree!: number | undefined;
    approvalWindowInThree!: ApprovalWindowInEnum;
    approverIdLevelFour!: number | undefined;
    approvalWindowFour!: number | undefined;
    approvalWindowInFour!: ApprovalWindowInEnum;
    approverIdLevelFive!: number | undefined;
    approvalWindowFive!: number | undefined;
    approvalWindowInFive!: ApprovalWindowInEnum;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IProjectTimeOffCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.approverIdLevelOne = _data["approverIdLevelOne"];
            this.approvalWindowOne = _data["approvalWindowOne"];
            this.approvalWindowInOne = _data["approvalWindowInOne"];
            this.approverIdLevelTwo = _data["approverIdLevelTwo"];
            this.approvalWindowTwo = _data["approvalWindowTwo"];
            this.approvalWindowInTwo = _data["approvalWindowInTwo"];
            this.approverIdLevelThree = _data["approverIdLevelThree"];
            this.approvalWindowThree = _data["approvalWindowThree"];
            this.approvalWindowInThree = _data["approvalWindowInThree"];
            this.approverIdLevelFour = _data["approverIdLevelFour"];
            this.approvalWindowFour = _data["approvalWindowFour"];
            this.approvalWindowInFour = _data["approvalWindowInFour"];
            this.approverIdLevelFive = _data["approverIdLevelFive"];
            this.approvalWindowFive = _data["approvalWindowFive"];
            this.approvalWindowInFive = _data["approvalWindowInFive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTimeOffCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeOffCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["approverIdLevelOne"] = this.approverIdLevelOne;
        data["approvalWindowOne"] = this.approvalWindowOne;
        data["approvalWindowInOne"] = this.approvalWindowInOne;
        data["approverIdLevelTwo"] = this.approverIdLevelTwo;
        data["approvalWindowTwo"] = this.approvalWindowTwo;
        data["approvalWindowInTwo"] = this.approvalWindowInTwo;
        data["approverIdLevelThree"] = this.approverIdLevelThree;
        data["approvalWindowThree"] = this.approvalWindowThree;
        data["approvalWindowInThree"] = this.approvalWindowInThree;
        data["approverIdLevelFour"] = this.approverIdLevelFour;
        data["approvalWindowFour"] = this.approvalWindowFour;
        data["approvalWindowInFour"] = this.approvalWindowInFour;
        data["approverIdLevelFive"] = this.approverIdLevelFive;
        data["approvalWindowFive"] = this.approvalWindowFive;
        data["approvalWindowInFive"] = this.approvalWindowInFive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTimeOffCreateOrEditDto {
    tenantId: number;
    projectId: number;
    approverIdLevelOne: number | undefined;
    approvalWindowOne: number | undefined;
    approvalWindowInOne: ApprovalWindowInEnum;
    approverIdLevelTwo: number | undefined;
    approvalWindowTwo: number | undefined;
    approvalWindowInTwo: ApprovalWindowInEnum;
    approverIdLevelThree: number | undefined;
    approvalWindowThree: number | undefined;
    approvalWindowInThree: ApprovalWindowInEnum;
    approverIdLevelFour: number | undefined;
    approvalWindowFour: number | undefined;
    approvalWindowInFour: ApprovalWindowInEnum;
    approverIdLevelFive: number | undefined;
    approvalWindowFive: number | undefined;
    approvalWindowInFive: ApprovalWindowInEnum;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ProjectTimeOffGetAllDto implements IProjectTimeOffGetAllDto {
    tenantId!: number;
    projectId!: number;
    approverIdLevelOne!: number | undefined;
    approverLevelOne!: UserListDto;
    approvalWindowOne!: number | undefined;
    approvalWindowInOne!: ApprovalWindowInEnum;
    approverIdLevelTwo!: number | undefined;
    approverLevelTwo!: UserListDto;
    approvalWindowTwo!: number | undefined;
    approvalWindowInTwo!: ApprovalWindowInEnum;
    approverIdLevelThree!: number | undefined;
    approverLevelThree!: UserListDto;
    approvalWindowThree!: number | undefined;
    approvalWindowInThree!: ApprovalWindowInEnum;
    approverIdLevelFour!: number | undefined;
    approverLevelFour!: UserListDto;
    approvalWindowFour!: number | undefined;
    approvalWindowInFour!: ApprovalWindowInEnum;
    approverIdLevelFive!: number | undefined;
    approverLevelFive!: UserListDto;
    approvalWindowFive!: number | undefined;
    approvalWindowInFive!: ApprovalWindowInEnum;

    constructor(data?: IProjectTimeOffGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.approverIdLevelOne = _data["approverIdLevelOne"];
            this.approverLevelOne = _data["approverLevelOne"] ? UserListDto.fromJS(_data["approverLevelOne"]) : undefined as any;
            this.approvalWindowOne = _data["approvalWindowOne"];
            this.approvalWindowInOne = _data["approvalWindowInOne"];
            this.approverIdLevelTwo = _data["approverIdLevelTwo"];
            this.approverLevelTwo = _data["approverLevelTwo"] ? UserListDto.fromJS(_data["approverLevelTwo"]) : undefined as any;
            this.approvalWindowTwo = _data["approvalWindowTwo"];
            this.approvalWindowInTwo = _data["approvalWindowInTwo"];
            this.approverIdLevelThree = _data["approverIdLevelThree"];
            this.approverLevelThree = _data["approverLevelThree"] ? UserListDto.fromJS(_data["approverLevelThree"]) : undefined as any;
            this.approvalWindowThree = _data["approvalWindowThree"];
            this.approvalWindowInThree = _data["approvalWindowInThree"];
            this.approverIdLevelFour = _data["approverIdLevelFour"];
            this.approverLevelFour = _data["approverLevelFour"] ? UserListDto.fromJS(_data["approverLevelFour"]) : undefined as any;
            this.approvalWindowFour = _data["approvalWindowFour"];
            this.approvalWindowInFour = _data["approvalWindowInFour"];
            this.approverIdLevelFive = _data["approverIdLevelFive"];
            this.approverLevelFive = _data["approverLevelFive"] ? UserListDto.fromJS(_data["approverLevelFive"]) : undefined as any;
            this.approvalWindowFive = _data["approvalWindowFive"];
            this.approvalWindowInFive = _data["approvalWindowInFive"];
        }
    }

    static fromJS(data: any): ProjectTimeOffGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeOffGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["approverIdLevelOne"] = this.approverIdLevelOne;
        data["approverLevelOne"] = this.approverLevelOne ? this.approverLevelOne.toJSON() : undefined as any;
        data["approvalWindowOne"] = this.approvalWindowOne;
        data["approvalWindowInOne"] = this.approvalWindowInOne;
        data["approverIdLevelTwo"] = this.approverIdLevelTwo;
        data["approverLevelTwo"] = this.approverLevelTwo ? this.approverLevelTwo.toJSON() : undefined as any;
        data["approvalWindowTwo"] = this.approvalWindowTwo;
        data["approvalWindowInTwo"] = this.approvalWindowInTwo;
        data["approverIdLevelThree"] = this.approverIdLevelThree;
        data["approverLevelThree"] = this.approverLevelThree ? this.approverLevelThree.toJSON() : undefined as any;
        data["approvalWindowThree"] = this.approvalWindowThree;
        data["approvalWindowInThree"] = this.approvalWindowInThree;
        data["approverIdLevelFour"] = this.approverIdLevelFour;
        data["approverLevelFour"] = this.approverLevelFour ? this.approverLevelFour.toJSON() : undefined as any;
        data["approvalWindowFour"] = this.approvalWindowFour;
        data["approvalWindowInFour"] = this.approvalWindowInFour;
        data["approverIdLevelFive"] = this.approverIdLevelFive;
        data["approverLevelFive"] = this.approverLevelFive ? this.approverLevelFive.toJSON() : undefined as any;
        data["approvalWindowFive"] = this.approvalWindowFive;
        data["approvalWindowInFive"] = this.approvalWindowInFive;
        return data;
    }
}

export interface IProjectTimeOffGetAllDto {
    tenantId: number;
    projectId: number;
    approverIdLevelOne: number | undefined;
    approverLevelOne: UserListDto;
    approvalWindowOne: number | undefined;
    approvalWindowInOne: ApprovalWindowInEnum;
    approverIdLevelTwo: number | undefined;
    approverLevelTwo: UserListDto;
    approvalWindowTwo: number | undefined;
    approvalWindowInTwo: ApprovalWindowInEnum;
    approverIdLevelThree: number | undefined;
    approverLevelThree: UserListDto;
    approvalWindowThree: number | undefined;
    approvalWindowInThree: ApprovalWindowInEnum;
    approverIdLevelFour: number | undefined;
    approverLevelFour: UserListDto;
    approvalWindowFour: number | undefined;
    approvalWindowInFour: ApprovalWindowInEnum;
    approverIdLevelFive: number | undefined;
    approverLevelFive: UserListDto;
    approvalWindowFive: number | undefined;
    approvalWindowInFive: ApprovalWindowInEnum;
}

export class ProjectTimeSheetCreateEditDto implements IProjectTimeSheetCreateEditDto {
    tenantId!: number;
    submissionFrequency!: ProjectTimesheetFrequencyEnum;
    approverIdLevelOne!: number | undefined;
    approvalWindowOne!: number | undefined;
    approvalWindowInOne!: ApprovalWindowInEnum;
    approverIdLevelTwo!: number | undefined;
    approvalWindowTwo!: number | undefined;
    approvalWindowInTwo!: ApprovalWindowInEnum;
    approverIdLevelThree!: number | undefined;
    approvalWindowThree!: number | undefined;
    approvalWindowInThree!: ApprovalWindowInEnum;
    approverIdLevelFour!: number | undefined;
    approvalWindowFour!: number | undefined;
    approvalWindowInFour!: ApprovalWindowInEnum;
    approverIdLevelFive!: number | undefined;
    approvalWindowFive!: number | undefined;
    approvalWindowInFive!: ApprovalWindowInEnum;
    taskAccountabilityInMinutes!: number;
    notificationAlertInMinutes!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IProjectTimeSheetCreateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.submissionFrequency = _data["submissionFrequency"];
            this.approverIdLevelOne = _data["approverIdLevelOne"];
            this.approvalWindowOne = _data["approvalWindowOne"];
            this.approvalWindowInOne = _data["approvalWindowInOne"];
            this.approverIdLevelTwo = _data["approverIdLevelTwo"];
            this.approvalWindowTwo = _data["approvalWindowTwo"];
            this.approvalWindowInTwo = _data["approvalWindowInTwo"];
            this.approverIdLevelThree = _data["approverIdLevelThree"];
            this.approvalWindowThree = _data["approvalWindowThree"];
            this.approvalWindowInThree = _data["approvalWindowInThree"];
            this.approverIdLevelFour = _data["approverIdLevelFour"];
            this.approvalWindowFour = _data["approvalWindowFour"];
            this.approvalWindowInFour = _data["approvalWindowInFour"];
            this.approverIdLevelFive = _data["approverIdLevelFive"];
            this.approvalWindowFive = _data["approvalWindowFive"];
            this.approvalWindowInFive = _data["approvalWindowInFive"];
            this.taskAccountabilityInMinutes = _data["taskAccountabilityInMinutes"];
            this.notificationAlertInMinutes = _data["notificationAlertInMinutes"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTimeSheetCreateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeSheetCreateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["submissionFrequency"] = this.submissionFrequency;
        data["approverIdLevelOne"] = this.approverIdLevelOne;
        data["approvalWindowOne"] = this.approvalWindowOne;
        data["approvalWindowInOne"] = this.approvalWindowInOne;
        data["approverIdLevelTwo"] = this.approverIdLevelTwo;
        data["approvalWindowTwo"] = this.approvalWindowTwo;
        data["approvalWindowInTwo"] = this.approvalWindowInTwo;
        data["approverIdLevelThree"] = this.approverIdLevelThree;
        data["approvalWindowThree"] = this.approvalWindowThree;
        data["approvalWindowInThree"] = this.approvalWindowInThree;
        data["approverIdLevelFour"] = this.approverIdLevelFour;
        data["approvalWindowFour"] = this.approvalWindowFour;
        data["approvalWindowInFour"] = this.approvalWindowInFour;
        data["approverIdLevelFive"] = this.approverIdLevelFive;
        data["approvalWindowFive"] = this.approvalWindowFive;
        data["approvalWindowInFive"] = this.approvalWindowInFive;
        data["taskAccountabilityInMinutes"] = this.taskAccountabilityInMinutes;
        data["notificationAlertInMinutes"] = this.notificationAlertInMinutes;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTimeSheetCreateEditDto {
    tenantId: number;
    submissionFrequency: ProjectTimesheetFrequencyEnum;
    approverIdLevelOne: number | undefined;
    approvalWindowOne: number | undefined;
    approvalWindowInOne: ApprovalWindowInEnum;
    approverIdLevelTwo: number | undefined;
    approvalWindowTwo: number | undefined;
    approvalWindowInTwo: ApprovalWindowInEnum;
    approverIdLevelThree: number | undefined;
    approvalWindowThree: number | undefined;
    approvalWindowInThree: ApprovalWindowInEnum;
    approverIdLevelFour: number | undefined;
    approvalWindowFour: number | undefined;
    approvalWindowInFour: ApprovalWindowInEnum;
    approverIdLevelFive: number | undefined;
    approvalWindowFive: number | undefined;
    approvalWindowInFive: ApprovalWindowInEnum;
    taskAccountabilityInMinutes: number;
    notificationAlertInMinutes: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ProjectTimeSheetGetAllDto implements IProjectTimeSheetGetAllDto {
    tenantId!: number;
    submissionFrequency!: ProjectTimesheetFrequencyEnum;
    approverLevelOne!: UserListDto;
    approvalWindowOne!: number | undefined;
    approvalWindowInOne!: ApprovalWindowInEnum;
    approverLevelTwo!: UserListDto;
    approvalWindowTwo!: number | undefined;
    approvalWindowInTwo!: ApprovalWindowInEnum;
    approverLevelThree!: UserListDto;
    approvalWindowThree!: number | undefined;
    approvalWindowInThree!: ApprovalWindowInEnum;
    approverLevelFour!: UserListDto;
    approvalWindowFour!: number | undefined;
    approvalWindowInFour!: ApprovalWindowInEnum;
    approverLevelFive!: UserListDto;
    approvalWindowFive!: number | undefined;
    approvalWindowInFive!: ApprovalWindowInEnum;
    taskAccountabilityInMinutes!: number;
    notificationAlertInMinutes!: number;

    constructor(data?: IProjectTimeSheetGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.submissionFrequency = _data["submissionFrequency"];
            this.approverLevelOne = _data["approverLevelOne"] ? UserListDto.fromJS(_data["approverLevelOne"]) : undefined as any;
            this.approvalWindowOne = _data["approvalWindowOne"];
            this.approvalWindowInOne = _data["approvalWindowInOne"];
            this.approverLevelTwo = _data["approverLevelTwo"] ? UserListDto.fromJS(_data["approverLevelTwo"]) : undefined as any;
            this.approvalWindowTwo = _data["approvalWindowTwo"];
            this.approvalWindowInTwo = _data["approvalWindowInTwo"];
            this.approverLevelThree = _data["approverLevelThree"] ? UserListDto.fromJS(_data["approverLevelThree"]) : undefined as any;
            this.approvalWindowThree = _data["approvalWindowThree"];
            this.approvalWindowInThree = _data["approvalWindowInThree"];
            this.approverLevelFour = _data["approverLevelFour"] ? UserListDto.fromJS(_data["approverLevelFour"]) : undefined as any;
            this.approvalWindowFour = _data["approvalWindowFour"];
            this.approvalWindowInFour = _data["approvalWindowInFour"];
            this.approverLevelFive = _data["approverLevelFive"] ? UserListDto.fromJS(_data["approverLevelFive"]) : undefined as any;
            this.approvalWindowFive = _data["approvalWindowFive"];
            this.approvalWindowInFive = _data["approvalWindowInFive"];
            this.taskAccountabilityInMinutes = _data["taskAccountabilityInMinutes"];
            this.notificationAlertInMinutes = _data["notificationAlertInMinutes"];
        }
    }

    static fromJS(data: any): ProjectTimeSheetGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeSheetGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["submissionFrequency"] = this.submissionFrequency;
        data["approverLevelOne"] = this.approverLevelOne ? this.approverLevelOne.toJSON() : undefined as any;
        data["approvalWindowOne"] = this.approvalWindowOne;
        data["approvalWindowInOne"] = this.approvalWindowInOne;
        data["approverLevelTwo"] = this.approverLevelTwo ? this.approverLevelTwo.toJSON() : undefined as any;
        data["approvalWindowTwo"] = this.approvalWindowTwo;
        data["approvalWindowInTwo"] = this.approvalWindowInTwo;
        data["approverLevelThree"] = this.approverLevelThree ? this.approverLevelThree.toJSON() : undefined as any;
        data["approvalWindowThree"] = this.approvalWindowThree;
        data["approvalWindowInThree"] = this.approvalWindowInThree;
        data["approverLevelFour"] = this.approverLevelFour ? this.approverLevelFour.toJSON() : undefined as any;
        data["approvalWindowFour"] = this.approvalWindowFour;
        data["approvalWindowInFour"] = this.approvalWindowInFour;
        data["approverLevelFive"] = this.approverLevelFive ? this.approverLevelFive.toJSON() : undefined as any;
        data["approvalWindowFive"] = this.approvalWindowFive;
        data["approvalWindowInFive"] = this.approvalWindowInFive;
        data["taskAccountabilityInMinutes"] = this.taskAccountabilityInMinutes;
        data["notificationAlertInMinutes"] = this.notificationAlertInMinutes;
        return data;
    }
}

export interface IProjectTimeSheetGetAllDto {
    tenantId: number;
    submissionFrequency: ProjectTimesheetFrequencyEnum;
    approverLevelOne: UserListDto;
    approvalWindowOne: number | undefined;
    approvalWindowInOne: ApprovalWindowInEnum;
    approverLevelTwo: UserListDto;
    approvalWindowTwo: number | undefined;
    approvalWindowInTwo: ApprovalWindowInEnum;
    approverLevelThree: UserListDto;
    approvalWindowThree: number | undefined;
    approvalWindowInThree: ApprovalWindowInEnum;
    approverLevelFour: UserListDto;
    approvalWindowFour: number | undefined;
    approvalWindowInFour: ApprovalWindowInEnum;
    approverLevelFive: UserListDto;
    approvalWindowFive: number | undefined;
    approvalWindowInFive: ApprovalWindowInEnum;
    taskAccountabilityInMinutes: number;
    notificationAlertInMinutes: number;
}

export class ProjectTimeSheets implements IProjectTimeSheets {
    tenantId!: number;
    project!: Projects;
    projectId!: number;
    submissionFrequency!: ProjectTimesheetFrequencyEnum;
    approverIdLevelOne!: number | undefined;
    approverLevelOne!: User;
    approvalWindowOne!: number | undefined;
    approvalWindowInOne!: ApprovalWindowInEnum;
    approverIdLevelTwo!: number | undefined;
    approverLevelTwo!: User;
    approvalWindowTwo!: number | undefined;
    approvalWindowInTwo!: ApprovalWindowInEnum;
    approverIdLevelThree!: number | undefined;
    approverLevelThree!: User;
    approvalWindowThree!: number | undefined;
    approvalWindowInThree!: ApprovalWindowInEnum;
    approverIdLevelFour!: number | undefined;
    approverLevelFour!: User;
    approvalWindowFour!: number | undefined;
    approvalWindowInFour!: ApprovalWindowInEnum;
    approverIdLevelFive!: number | undefined;
    approverLevelFive!: User;
    approvalWindowFive!: number | undefined;
    approvalWindowInFive!: ApprovalWindowInEnum;
    taskAccountabilityInMinutes!: number;
    notificationAlertInMinutes!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProjectTimeSheets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.projectId = _data["projectId"];
            this.submissionFrequency = _data["submissionFrequency"];
            this.approverIdLevelOne = _data["approverIdLevelOne"];
            this.approverLevelOne = _data["approverLevelOne"] ? User.fromJS(_data["approverLevelOne"]) : undefined as any;
            this.approvalWindowOne = _data["approvalWindowOne"];
            this.approvalWindowInOne = _data["approvalWindowInOne"];
            this.approverIdLevelTwo = _data["approverIdLevelTwo"];
            this.approverLevelTwo = _data["approverLevelTwo"] ? User.fromJS(_data["approverLevelTwo"]) : undefined as any;
            this.approvalWindowTwo = _data["approvalWindowTwo"];
            this.approvalWindowInTwo = _data["approvalWindowInTwo"];
            this.approverIdLevelThree = _data["approverIdLevelThree"];
            this.approverLevelThree = _data["approverLevelThree"] ? User.fromJS(_data["approverLevelThree"]) : undefined as any;
            this.approvalWindowThree = _data["approvalWindowThree"];
            this.approvalWindowInThree = _data["approvalWindowInThree"];
            this.approverIdLevelFour = _data["approverIdLevelFour"];
            this.approverLevelFour = _data["approverLevelFour"] ? User.fromJS(_data["approverLevelFour"]) : undefined as any;
            this.approvalWindowFour = _data["approvalWindowFour"];
            this.approvalWindowInFour = _data["approvalWindowInFour"];
            this.approverIdLevelFive = _data["approverIdLevelFive"];
            this.approverLevelFive = _data["approverLevelFive"] ? User.fromJS(_data["approverLevelFive"]) : undefined as any;
            this.approvalWindowFive = _data["approvalWindowFive"];
            this.approvalWindowInFive = _data["approvalWindowInFive"];
            this.taskAccountabilityInMinutes = _data["taskAccountabilityInMinutes"];
            this.notificationAlertInMinutes = _data["notificationAlertInMinutes"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectTimeSheets {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeSheets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["projectId"] = this.projectId;
        data["submissionFrequency"] = this.submissionFrequency;
        data["approverIdLevelOne"] = this.approverIdLevelOne;
        data["approverLevelOne"] = this.approverLevelOne ? this.approverLevelOne.toJSON() : undefined as any;
        data["approvalWindowOne"] = this.approvalWindowOne;
        data["approvalWindowInOne"] = this.approvalWindowInOne;
        data["approverIdLevelTwo"] = this.approverIdLevelTwo;
        data["approverLevelTwo"] = this.approverLevelTwo ? this.approverLevelTwo.toJSON() : undefined as any;
        data["approvalWindowTwo"] = this.approvalWindowTwo;
        data["approvalWindowInTwo"] = this.approvalWindowInTwo;
        data["approverIdLevelThree"] = this.approverIdLevelThree;
        data["approverLevelThree"] = this.approverLevelThree ? this.approverLevelThree.toJSON() : undefined as any;
        data["approvalWindowThree"] = this.approvalWindowThree;
        data["approvalWindowInThree"] = this.approvalWindowInThree;
        data["approverIdLevelFour"] = this.approverIdLevelFour;
        data["approverLevelFour"] = this.approverLevelFour ? this.approverLevelFour.toJSON() : undefined as any;
        data["approvalWindowFour"] = this.approvalWindowFour;
        data["approvalWindowInFour"] = this.approvalWindowInFour;
        data["approverIdLevelFive"] = this.approverIdLevelFive;
        data["approverLevelFive"] = this.approverLevelFive ? this.approverLevelFive.toJSON() : undefined as any;
        data["approvalWindowFive"] = this.approvalWindowFive;
        data["approvalWindowInFive"] = this.approvalWindowInFive;
        data["taskAccountabilityInMinutes"] = this.taskAccountabilityInMinutes;
        data["notificationAlertInMinutes"] = this.notificationAlertInMinutes;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectTimeSheets {
    tenantId: number;
    project: Projects;
    projectId: number;
    submissionFrequency: ProjectTimesheetFrequencyEnum;
    approverIdLevelOne: number | undefined;
    approverLevelOne: User;
    approvalWindowOne: number | undefined;
    approvalWindowInOne: ApprovalWindowInEnum;
    approverIdLevelTwo: number | undefined;
    approverLevelTwo: User;
    approvalWindowTwo: number | undefined;
    approvalWindowInTwo: ApprovalWindowInEnum;
    approverIdLevelThree: number | undefined;
    approverLevelThree: User;
    approvalWindowThree: number | undefined;
    approvalWindowInThree: ApprovalWindowInEnum;
    approverIdLevelFour: number | undefined;
    approverLevelFour: User;
    approvalWindowFour: number | undefined;
    approvalWindowInFour: ApprovalWindowInEnum;
    approverIdLevelFive: number | undefined;
    approverLevelFive: User;
    approvalWindowFive: number | undefined;
    approvalWindowInFive: ApprovalWindowInEnum;
    taskAccountabilityInMinutes: number;
    notificationAlertInMinutes: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum ProjectTimesheetFrequencyEnum {
    None = 0,
    BiMonthly = 1,
    Monthly = 2,
    Weekly = 3,
    Daily = 4,
}

export class ProjectTimesheetStatusDto implements IProjectTimesheetStatusDto {
    projectName!: string | undefined;
    pendingDates!: string[] | undefined;
    isTimesheetReminderEnable!: boolean;
    projectId!: number;

    constructor(data?: IProjectTimesheetStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["pendingDates"])) {
                this.pendingDates = [] as any;
                for (let item of _data["pendingDates"])
                    this.pendingDates!.push(item);
            }
            this.isTimesheetReminderEnable = _data["isTimesheetReminderEnable"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectTimesheetStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimesheetStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        if (Array.isArray(this.pendingDates)) {
            data["pendingDates"] = [];
            for (let item of this.pendingDates)
                data["pendingDates"].push(item);
        }
        data["isTimesheetReminderEnable"] = this.isTimesheetReminderEnable;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectTimesheetStatusDto {
    projectName: string | undefined;
    pendingDates: string[] | undefined;
    isTimesheetReminderEnable: boolean;
    projectId: number;
}

export enum ProjectType {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export class ProjectTypeCountDto implements IProjectTypeCountDto {
    name!: string | undefined;
    value!: number;

    constructor(data?: IProjectTypeCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProjectTypeCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IProjectTypeCountDto {
    name: string | undefined;
    value: number;
}

export class ProjectUsers implements IProjectUsers {
    project!: Projects;
    id!: number;

    constructor(data?: IProjectUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectUsers {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUsers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjectUsers {
    project: Projects;
    id: number;
}

export class Projects implements IProjects {
    tenantId!: number;
    name!: string;
    projectImage!: string | undefined;
    tags!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    clientId!: number | undefined;
    client!: Client;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    isActive!: boolean;
    lastModifierUserId!: number | undefined;
    lastModifiedUser!: User;
    projectType!: number;
    projectBillingType!: ProjectBillingType;
    singleRatePerHour!: number;
    flatRate!: number | undefined;
    hrslogged!: number;
    unbilllablehrs!: number;
    unbilllamount!: number;
    lastInvoice!: string | undefined;
    isArchived!: boolean;
    projectStatus!: ProjectStatus;
    hourlyBudget!: number;
    projectTimeSheet!: ProjectTimeSheets;
    assignedProgramManager!: number;
    projectURL!: string | undefined;
    devProjectName!: string | undefined;
    personalAccessToken!: string | undefined;
    tokenStartDate!: DateTime | undefined;
    tokenExpireDate!: DateTime | undefined;
    billabilityStatusAuthority!: boolean;
    isTimesheetReminderEnable!: boolean;
    isBackDatedTimesheetEnable!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.projectImage = _data["projectImage"];
            this.tags = _data["tags"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : undefined as any;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifiedUser = _data["lastModifiedUser"] ? User.fromJS(_data["lastModifiedUser"]) : undefined as any;
            this.projectType = _data["projectType"];
            this.projectBillingType = _data["projectBillingType"];
            this.singleRatePerHour = _data["singleRatePerHour"];
            this.flatRate = _data["flatRate"];
            this.hrslogged = _data["hrslogged"];
            this.unbilllablehrs = _data["unbilllablehrs"];
            this.unbilllamount = _data["unbilllamount"];
            this.lastInvoice = _data["lastInvoice"];
            this.isArchived = _data["isArchived"];
            this.projectStatus = _data["projectStatus"];
            this.hourlyBudget = _data["hourlyBudget"];
            this.projectTimeSheet = _data["projectTimeSheet"] ? ProjectTimeSheets.fromJS(_data["projectTimeSheet"]) : undefined as any;
            this.assignedProgramManager = _data["assignedProgramManager"];
            this.projectURL = _data["projectURL"];
            this.devProjectName = _data["devProjectName"];
            this.personalAccessToken = _data["personalAccessToken"];
            this.tokenStartDate = _data["tokenStartDate"] ? DateTime.fromISO(_data["tokenStartDate"].toString()) : undefined as any;
            this.tokenExpireDate = _data["tokenExpireDate"] ? DateTime.fromISO(_data["tokenExpireDate"].toString()) : undefined as any;
            this.billabilityStatusAuthority = _data["billabilityStatusAuthority"];
            this.isTimesheetReminderEnable = _data["isTimesheetReminderEnable"];
            this.isBackDatedTimesheetEnable = _data["isBackDatedTimesheetEnable"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Projects {
        data = typeof data === 'object' ? data : {};
        let result = new Projects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["projectImage"] = this.projectImage;
        data["tags"] = this.tags;
        data["code"] = this.code;
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["isActive"] = this.isActive;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifiedUser"] = this.lastModifiedUser ? this.lastModifiedUser.toJSON() : undefined as any;
        data["projectType"] = this.projectType;
        data["projectBillingType"] = this.projectBillingType;
        data["singleRatePerHour"] = this.singleRatePerHour;
        data["flatRate"] = this.flatRate;
        data["hrslogged"] = this.hrslogged;
        data["unbilllablehrs"] = this.unbilllablehrs;
        data["unbilllamount"] = this.unbilllamount;
        data["lastInvoice"] = this.lastInvoice;
        data["isArchived"] = this.isArchived;
        data["projectStatus"] = this.projectStatus;
        data["hourlyBudget"] = this.hourlyBudget;
        data["projectTimeSheet"] = this.projectTimeSheet ? this.projectTimeSheet.toJSON() : undefined as any;
        data["assignedProgramManager"] = this.assignedProgramManager;
        data["projectURL"] = this.projectURL;
        data["devProjectName"] = this.devProjectName;
        data["personalAccessToken"] = this.personalAccessToken;
        data["tokenStartDate"] = this.tokenStartDate ? this.tokenStartDate.toString() : undefined as any;
        data["tokenExpireDate"] = this.tokenExpireDate ? this.tokenExpireDate.toString() : undefined as any;
        data["billabilityStatusAuthority"] = this.billabilityStatusAuthority;
        data["isTimesheetReminderEnable"] = this.isTimesheetReminderEnable;
        data["isBackDatedTimesheetEnable"] = this.isBackDatedTimesheetEnable;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProjects {
    tenantId: number;
    name: string;
    projectImage: string | undefined;
    tags: string | undefined;
    code: string | undefined;
    description: string | undefined;
    clientId: number | undefined;
    client: Client;
    startDate: DateTime;
    endDate: DateTime | undefined;
    isActive: boolean;
    lastModifierUserId: number | undefined;
    lastModifiedUser: User;
    projectType: number;
    projectBillingType: ProjectBillingType;
    singleRatePerHour: number;
    flatRate: number | undefined;
    hrslogged: number;
    unbilllablehrs: number;
    unbilllamount: number;
    lastInvoice: string | undefined;
    isArchived: boolean;
    projectStatus: ProjectStatus;
    hourlyBudget: number;
    projectTimeSheet: ProjectTimeSheets;
    assignedProgramManager: number;
    projectURL: string | undefined;
    devProjectName: string | undefined;
    personalAccessToken: string | undefined;
    tokenStartDate: DateTime | undefined;
    tokenExpireDate: DateTime | undefined;
    billabilityStatusAuthority: boolean;
    isTimesheetReminderEnable: boolean;
    isBackDatedTimesheetEnable: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PublicHolidayCacheDto implements IPublicHolidayCacheDto {
    id!: number;
    tenantId!: number;
    holidayDate!: DateTime;
    toHolidayDate!: DateTime | undefined;
    holidayName!: string | undefined;
    holidayDescription!: string | undefined;
    locationSettingId!: number | undefined;

    constructor(data?: IPublicHolidayCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.holidayDate = _data["holidayDate"] ? DateTime.fromISO(_data["holidayDate"].toString()) : undefined as any;
            this.toHolidayDate = _data["toHolidayDate"] ? DateTime.fromISO(_data["toHolidayDate"].toString()) : undefined as any;
            this.holidayName = _data["holidayName"];
            this.holidayDescription = _data["holidayDescription"];
            this.locationSettingId = _data["locationSettingId"];
        }
    }

    static fromJS(data: any): PublicHolidayCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toString() : undefined as any;
        data["toHolidayDate"] = this.toHolidayDate ? this.toHolidayDate.toString() : undefined as any;
        data["holidayName"] = this.holidayName;
        data["holidayDescription"] = this.holidayDescription;
        data["locationSettingId"] = this.locationSettingId;
        return data;
    }
}

export interface IPublicHolidayCacheDto {
    id: number;
    tenantId: number;
    holidayDate: DateTime;
    toHolidayDate: DateTime | undefined;
    holidayName: string | undefined;
    holidayDescription: string | undefined;
    locationSettingId: number | undefined;
}

export class PublicHolidayCreateOrEditDto implements IPublicHolidayCreateOrEditDto {
    tenantId!: number;
    holidayDate!: DateTime;
    toHolidayDate!: DateTime | undefined;
    holidayName!: string | undefined;
    isFloater!: boolean;
    holidayDescription!: string | undefined;
    locationSettingId!: number | undefined;
    locationName!: string | undefined;
    locationGroupName!: string | undefined;
    multipleLocationGroupName!: string[] | undefined;
    multipleLocationName!: string[] | undefined;
    multipleLocationIds!: number[] | undefined;
    id!: number | undefined;

    constructor(data?: IPublicHolidayCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.holidayDate = _data["holidayDate"] ? DateTime.fromISO(_data["holidayDate"].toString()) : undefined as any;
            this.toHolidayDate = _data["toHolidayDate"] ? DateTime.fromISO(_data["toHolidayDate"].toString()) : undefined as any;
            this.holidayName = _data["holidayName"];
            this.isFloater = _data["isFloater"];
            this.holidayDescription = _data["holidayDescription"];
            this.locationSettingId = _data["locationSettingId"];
            this.locationName = _data["locationName"];
            this.locationGroupName = _data["locationGroupName"];
            if (Array.isArray(_data["multipleLocationGroupName"])) {
                this.multipleLocationGroupName = [] as any;
                for (let item of _data["multipleLocationGroupName"])
                    this.multipleLocationGroupName!.push(item);
            }
            if (Array.isArray(_data["multipleLocationName"])) {
                this.multipleLocationName = [] as any;
                for (let item of _data["multipleLocationName"])
                    this.multipleLocationName!.push(item);
            }
            if (Array.isArray(_data["multipleLocationIds"])) {
                this.multipleLocationIds = [] as any;
                for (let item of _data["multipleLocationIds"])
                    this.multipleLocationIds!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PublicHolidayCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toString() : undefined as any;
        data["toHolidayDate"] = this.toHolidayDate ? this.toHolidayDate.toString() : undefined as any;
        data["holidayName"] = this.holidayName;
        data["isFloater"] = this.isFloater;
        data["holidayDescription"] = this.holidayDescription;
        data["locationSettingId"] = this.locationSettingId;
        data["locationName"] = this.locationName;
        data["locationGroupName"] = this.locationGroupName;
        if (Array.isArray(this.multipleLocationGroupName)) {
            data["multipleLocationGroupName"] = [];
            for (let item of this.multipleLocationGroupName)
                data["multipleLocationGroupName"].push(item);
        }
        if (Array.isArray(this.multipleLocationName)) {
            data["multipleLocationName"] = [];
            for (let item of this.multipleLocationName)
                data["multipleLocationName"].push(item);
        }
        if (Array.isArray(this.multipleLocationIds)) {
            data["multipleLocationIds"] = [];
            for (let item of this.multipleLocationIds)
                data["multipleLocationIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPublicHolidayCreateOrEditDto {
    tenantId: number;
    holidayDate: DateTime;
    toHolidayDate: DateTime | undefined;
    holidayName: string | undefined;
    isFloater: boolean;
    holidayDescription: string | undefined;
    locationSettingId: number | undefined;
    locationName: string | undefined;
    locationGroupName: string | undefined;
    multipleLocationGroupName: string[] | undefined;
    multipleLocationName: string[] | undefined;
    multipleLocationIds: number[] | undefined;
    id: number | undefined;
}

export class PublicHolidayLocationCacheDto implements IPublicHolidayLocationCacheDto {
    id!: number;
    tenantId!: number;
    holidayId!: number;
    locationId!: number;

    constructor(data?: IPublicHolidayLocationCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.holidayId = _data["holidayId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): PublicHolidayLocationCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayLocationCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["holidayId"] = this.holidayId;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IPublicHolidayLocationCacheDto {
    id: number;
    tenantId: number;
    holidayId: number;
    locationId: number;
}

export class Range implements IRange {
    type!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    recurrenceTimeZone!: string | undefined;
    numberOfOccurrences!: number;

    constructor(data?: IRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.recurrenceTimeZone = _data["recurrenceTimeZone"];
            this.numberOfOccurrences = _data["numberOfOccurrences"];
        }
    }

    static fromJS(data: any): Range {
        data = typeof data === 'object' ? data : {};
        let result = new Range();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["recurrenceTimeZone"] = this.recurrenceTimeZone;
        data["numberOfOccurrences"] = this.numberOfOccurrences;
        return data;
    }
}

export interface IRange {
    type: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    recurrenceTimeZone: string | undefined;
    numberOfOccurrences: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class Recurrence implements IRecurrence {
    pattern!: Pattern;
    range!: Range;

    constructor(data?: IRecurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"] ? Pattern.fromJS(_data["pattern"]) : undefined as any;
            this.range = _data["range"] ? Range.fromJS(_data["range"]) : undefined as any;
        }
    }

    static fromJS(data: any): Recurrence {
        data = typeof data === 'object' ? data : {};
        let result = new Recurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern ? this.pattern.toJSON() : undefined as any;
        data["range"] = this.range ? this.range.toJSON() : undefined as any;
        return data;
    }
}

export interface IRecurrence {
    pattern: Pattern;
    range: Range;
}

export enum RecurrencePatternType {
    Daily = 0,
    Weekly = 1,
    AbsoluteMonthly = 2,
    RelativeMonthly = 3,
    AbsoluteYearly = 4,
    RelativeYearly = 5,
}

export enum RecurrenceRangeType {
    EndDate = 0,
    NoEnd = 1,
    Numbered = 2,
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;
    fullName!: string | undefined;
    isExternalLogin!: boolean;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
            this.fullName = _data["fullName"];
            this.isExternalLogin = _data["isExternalLogin"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        data["fullName"] = this.fullName;
        data["isExternalLogin"] = this.isExternalLogin;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
    fullName: string | undefined;
    isExternalLogin: boolean;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class RejectKekaManagerApprovalInput implements IRejectKekaManagerApprovalInput {
    comment!: string | undefined;
    id!: number;

    constructor(data?: IRejectKekaManagerApprovalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RejectKekaManagerApprovalInput {
        data = typeof data === 'object' ? data : {};
        let result = new RejectKekaManagerApprovalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }
}

export interface IRejectKekaManagerApprovalInput {
    comment: string | undefined;
    id: number;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class ReportExportData implements IReportExportData {
    subReportType!: TimesheetReportGroupByType;
    reportData!: any;
    fileName!: string | undefined;
    reportSaveAsType!: TimesheetReportSaveAsType;
    isExcelFile!: boolean;
    fileUrl!: string | undefined;
    fileContent!: string | undefined;

    constructor(data?: IReportExportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subReportType = _data["subReportType"];
            this.reportData = _data["reportData"];
            this.fileName = _data["fileName"];
            this.reportSaveAsType = _data["reportSaveAsType"];
            this.isExcelFile = _data["isExcelFile"];
            this.fileUrl = _data["fileUrl"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): ReportExportData {
        data = typeof data === 'object' ? data : {};
        let result = new ReportExportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subReportType"] = this.subReportType;
        data["reportData"] = this.reportData;
        data["fileName"] = this.fileName;
        data["reportSaveAsType"] = this.reportSaveAsType;
        data["isExcelFile"] = this.isExcelFile;
        data["fileUrl"] = this.fileUrl;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IReportExportData {
    subReportType: TimesheetReportGroupByType;
    reportData: any;
    fileName: string | undefined;
    reportSaveAsType: TimesheetReportSaveAsType;
    isExcelFile: boolean;
    fileUrl: string | undefined;
    fileContent: string | undefined;
}

export enum ReportType {
    OverAllSummary = 1,
    TaskWise = 2,
    DateWise = 3,
    EmployeeWise = 4,
}

export enum ReportTypeEnum {
    Timesheet = 1,
    LeaveReport = 2,
    Attendance = 3,
    Productivity = 4,
    ProjectAllocation = 5,
    ProjectionvsActual = 6,
}

export class ReportingManagerList implements IReportingManagerList {
    name!: string | undefined;
    surName!: string | undefined;
    profilePhoto!: string | undefined;
    employeeId!: string | undefined;
    userName!: string | undefined;
    roles!: UserListRoleDto[] | undefined;
    emailAddress!: string | undefined;
    organizationUnit!: string | undefined;
    count!: number;
    id!: number;

    constructor(data?: IReportingManagerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surName = _data["surName"];
            this.profilePhoto = _data["profilePhoto"];
            this.employeeId = _data["employeeId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.emailAddress = _data["emailAddress"];
            this.organizationUnit = _data["organizationUnit"];
            this.count = _data["count"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportingManagerList {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingManagerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surName"] = this.surName;
        data["profilePhoto"] = this.profilePhoto;
        data["employeeId"] = this.employeeId;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["emailAddress"] = this.emailAddress;
        data["organizationUnit"] = this.organizationUnit;
        data["count"] = this.count;
        data["id"] = this.id;
        return data;
    }
}

export interface IReportingManagerList {
    name: string | undefined;
    surName: string | undefined;
    profilePhoto: string | undefined;
    employeeId: string | undefined;
    userName: string | undefined;
    roles: UserListRoleDto[] | undefined;
    emailAddress: string | undefined;
    organizationUnit: string | undefined;
    count: number;
    id: number;
}

export enum RequestSource {
    FromElectron = 1,
    FromWindows = 2,
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class ResponseStatus implements IResponseStatus {
    response!: string | undefined;
    time!: DateTime;

    constructor(data?: IResponseStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        data["time"] = this.time ? this.time.toString() : undefined as any;
        return data;
    }
}

export interface IResponseStatus {
    response: string | undefined;
    time: DateTime;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: DateTime;
    id: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class RootRealTime implements IRootRealTime {
    summary!: Summary;
    addresses!: Addresses[] | undefined;

    constructor(data?: IRootRealTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? Summary.fromJS(_data["summary"]) : undefined as any;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Addresses.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RootRealTime {
        data = typeof data === 'object' ? data : {};
        let result = new RootRealTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRootRealTime {
    summary: Summary;
    addresses: Addresses[] | undefined;
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.application = _data["application"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export enum ScreenShotCaptureTime {
    Three = 3,
    Five = 5,
    Ten = 10,
    Fifteen = 15,
    Twenty = 20,
    Thirty = 30,
}

export class ScreenShotCreateOrEditDto implements IScreenShotCreateOrEditDto {
    tenantId!: number | undefined;
    screenShotUrl!: string | undefined;
    screenShotThumbnail!: string | undefined;
    userId!: number | undefined;
    blobContainerName!: string | undefined;
    screenShotTime!: string | undefined;
    appName!: string | undefined;
    appIcon!: string | undefined;
    id!: number;
    isLiveScreenShot!: boolean;
    mouseClick!: number;
    keyBoardPress!: number;
    screenShotInterval!: number;
    captureScreenShotTime!: string | undefined;
    creationTime!: DateTime;
    machineName!: string | undefined;
    isUserInfo!: boolean;
    surname!: string | undefined;
    name!: string | undefined;
    profileImage!: string | undefined;

    constructor(data?: IScreenShotCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.screenShotUrl = _data["screenShotUrl"];
            this.screenShotThumbnail = _data["screenShotThumbnail"];
            this.userId = _data["userId"];
            this.blobContainerName = _data["blobContainerName"];
            this.screenShotTime = _data["screenShotTime"];
            this.appName = _data["appName"];
            this.appIcon = _data["appIcon"];
            this.id = _data["id"];
            this.isLiveScreenShot = _data["isLiveScreenShot"];
            this.mouseClick = _data["mouseClick"];
            this.keyBoardPress = _data["keyBoardPress"];
            this.screenShotInterval = _data["screenShotInterval"];
            this.captureScreenShotTime = _data["captureScreenShotTime"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.machineName = _data["machineName"];
            this.isUserInfo = _data["isUserInfo"];
            this.surname = _data["surname"];
            this.name = _data["name"];
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): ScreenShotCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenShotCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["screenShotUrl"] = this.screenShotUrl;
        data["screenShotThumbnail"] = this.screenShotThumbnail;
        data["userId"] = this.userId;
        data["blobContainerName"] = this.blobContainerName;
        data["screenShotTime"] = this.screenShotTime;
        data["appName"] = this.appName;
        data["appIcon"] = this.appIcon;
        data["id"] = this.id;
        data["isLiveScreenShot"] = this.isLiveScreenShot;
        data["mouseClick"] = this.mouseClick;
        data["keyBoardPress"] = this.keyBoardPress;
        data["screenShotInterval"] = this.screenShotInterval;
        data["captureScreenShotTime"] = this.captureScreenShotTime;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["machineName"] = this.machineName;
        data["isUserInfo"] = this.isUserInfo;
        data["surname"] = this.surname;
        data["name"] = this.name;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IScreenShotCreateOrEditDto {
    tenantId: number | undefined;
    screenShotUrl: string | undefined;
    screenShotThumbnail: string | undefined;
    userId: number | undefined;
    blobContainerName: string | undefined;
    screenShotTime: string | undefined;
    appName: string | undefined;
    appIcon: string | undefined;
    id: number;
    isLiveScreenShot: boolean;
    mouseClick: number;
    keyBoardPress: number;
    screenShotInterval: number;
    captureScreenShotTime: string | undefined;
    creationTime: DateTime;
    machineName: string | undefined;
    isUserInfo: boolean;
    surname: string | undefined;
    name: string | undefined;
    profileImage: string | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : undefined as any;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : undefined as any;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : undefined as any;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : undefined as any;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : undefined as any;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : undefined as any;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendForApprovalTimesheetDto implements ISendForApprovalTimesheetDto {
    tenantId!: number;
    timeSheetDate!: DateTime | undefined;
    projectId!: number | undefined;
    requiredHours!: string;
    submittedHours!: string;
    billedHours!: string;
    userId!: number | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    fromDate!: DateTime;
    toDate!: DateTime;
    timesheetType!: ProjectTimesheetFrequencyEnum;
    includeTimesheetDetails!: IncludeTimesheetDto[] | undefined;
    timesheetId!: number;
    currentTime!: DateTime;
    timesheetInvoiceFromDate!: DateTime;
    timesheetInvoiceToDate!: DateTime;

    constructor(data?: ISendForApprovalTimesheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.requiredHours = _data["requiredHours"];
            this.submittedHours = _data["submittedHours"];
            this.billedHours = _data["billedHours"];
            this.userId = _data["userId"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.timesheetType = _data["timesheetType"];
            if (Array.isArray(_data["includeTimesheetDetails"])) {
                this.includeTimesheetDetails = [] as any;
                for (let item of _data["includeTimesheetDetails"])
                    this.includeTimesheetDetails!.push(IncludeTimesheetDto.fromJS(item));
            }
            this.timesheetId = _data["timesheetId"];
            this.currentTime = _data["currentTime"] ? DateTime.fromISO(_data["currentTime"].toString()) : undefined as any;
            this.timesheetInvoiceFromDate = _data["timesheetInvoiceFromDate"] ? DateTime.fromISO(_data["timesheetInvoiceFromDate"].toString()) : undefined as any;
            this.timesheetInvoiceToDate = _data["timesheetInvoiceToDate"] ? DateTime.fromISO(_data["timesheetInvoiceToDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SendForApprovalTimesheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendForApprovalTimesheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["projectId"] = this.projectId;
        data["requiredHours"] = this.requiredHours;
        data["submittedHours"] = this.submittedHours;
        data["billedHours"] = this.billedHours;
        data["userId"] = this.userId;
        data["timesheetStatus"] = this.timesheetStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["timesheetType"] = this.timesheetType;
        if (Array.isArray(this.includeTimesheetDetails)) {
            data["includeTimesheetDetails"] = [];
            for (let item of this.includeTimesheetDetails)
                data["includeTimesheetDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["timesheetId"] = this.timesheetId;
        data["currentTime"] = this.currentTime ? this.currentTime.toString() : undefined as any;
        data["timesheetInvoiceFromDate"] = this.timesheetInvoiceFromDate ? this.timesheetInvoiceFromDate.toString() : undefined as any;
        data["timesheetInvoiceToDate"] = this.timesheetInvoiceToDate ? this.timesheetInvoiceToDate.toString() : undefined as any;
        return data;
    }
}

export interface ISendForApprovalTimesheetDto {
    tenantId: number;
    timeSheetDate: DateTime | undefined;
    projectId: number | undefined;
    requiredHours: string;
    submittedHours: string;
    billedHours: string;
    userId: number | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    fromDate: DateTime;
    toDate: DateTime;
    timesheetType: ProjectTimesheetFrequencyEnum;
    includeTimesheetDetails: IncludeTimesheetDto[] | undefined;
    timesheetId: number;
    currentTime: DateTime;
    timesheetInvoiceFromDate: DateTime;
    timesheetInvoiceToDate: DateTime;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SendReminderDto implements ISendReminderDto {
    userTimesheetStatus!: UserAndTimesheetStatus[] | undefined;
    notificationMessage!: string | undefined;
    projectName!: string | undefined;
    timesheetFromDate!: DateTime;
    timesheetToDate!: DateTime;

    constructor(data?: ISendReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userTimesheetStatus"])) {
                this.userTimesheetStatus = [] as any;
                for (let item of _data["userTimesheetStatus"])
                    this.userTimesheetStatus!.push(UserAndTimesheetStatus.fromJS(item));
            }
            this.notificationMessage = _data["notificationMessage"];
            this.projectName = _data["projectName"];
            this.timesheetFromDate = _data["timesheetFromDate"] ? DateTime.fromISO(_data["timesheetFromDate"].toString()) : undefined as any;
            this.timesheetToDate = _data["timesheetToDate"] ? DateTime.fromISO(_data["timesheetToDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SendReminderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendReminderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userTimesheetStatus)) {
            data["userTimesheetStatus"] = [];
            for (let item of this.userTimesheetStatus)
                data["userTimesheetStatus"].push(item ? item.toJSON() : undefined as any);
        }
        data["notificationMessage"] = this.notificationMessage;
        data["projectName"] = this.projectName;
        data["timesheetFromDate"] = this.timesheetFromDate ? this.timesheetFromDate.toString() : undefined as any;
        data["timesheetToDate"] = this.timesheetToDate ? this.timesheetToDate.toString() : undefined as any;
        return data;
    }
}

export interface ISendReminderDto {
    userTimesheetStatus: UserAndTimesheetStatus[] | undefined;
    notificationMessage: string | undefined;
    projectName: string | undefined;
    timesheetFromDate: DateTime;
    timesheetToDate: DateTime;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SendTimesheetToClient implements ISendTimesheetToClient {
    timesheetId!: number[] | undefined;

    constructor(data?: ISendTimesheetToClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timesheetId"])) {
                this.timesheetId = [] as any;
                for (let item of _data["timesheetId"])
                    this.timesheetId!.push(item);
            }
        }
    }

    static fromJS(data: any): SendTimesheetToClient {
        data = typeof data === 'object' ? data : {};
        let result = new SendTimesheetToClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timesheetId)) {
            data["timesheetId"] = [];
            for (let item of this.timesheetId)
                data["timesheetId"].push(item);
        }
        return data;
    }
}

export interface ISendTimesheetToClient {
    timesheetId: number[] | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class ServiceCalendarEventDto implements IServiceCalendarEventDto {
    systemEventId!: number;
    userId!: number;
    calendarType!: CalendarServiceProviderType;
    serviceProviderEventId!: string | undefined;
    serviceProviderEventDetails!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IServiceCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemEventId = _data["systemEventId"];
            this.userId = _data["userId"];
            this.calendarType = _data["calendarType"];
            this.serviceProviderEventId = _data["serviceProviderEventId"];
            this.serviceProviderEventDetails = _data["serviceProviderEventDetails"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ServiceCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEventId"] = this.systemEventId;
        data["userId"] = this.userId;
        data["calendarType"] = this.calendarType;
        data["serviceProviderEventId"] = this.serviceProviderEventId;
        data["serviceProviderEventDetails"] = this.serviceProviderEventDetails;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IServiceCalendarEventDto {
    systemEventId: number;
    userId: number;
    calendarType: CalendarServiceProviderType;
    serviceProviderEventId: string | undefined;
    serviceProviderEventDetails: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum ServiceType {
    AllServices = 1,
    ArchivedServices = 2,
    DeletedServices = 3,
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class SetNotificationAsReadOutput implements ISetNotificationAsReadOutput {
    success!: boolean;

    constructor(data?: ISetNotificationAsReadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SetNotificationAsReadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SetNotificationAsReadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISetNotificationAsReadOutput {
    success: boolean;
}

export class SetUserStatusDto implements ISetUserStatusDto {
    userId!: number;
    tenantId!: number | undefined;
    userStatus!: UserStatusEnum;
    creationTime!: DateTime | undefined;

    constructor(data?: ISetUserStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.userStatus = _data["userStatus"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SetUserStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["userStatus"] = this.userStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface ISetUserStatusDto {
    userId: number;
    tenantId: number | undefined;
    userStatus: UserStatusEnum;
    creationTime: DateTime | undefined;
}

export class Setting implements ISetting {
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class Start implements IStart {
    dateTime!: DateTime;
    timeZone!: string | undefined;

    constructor(data?: IStart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): Start {
        data = typeof data === 'object' ? data : {};
        let result = new Start();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : undefined as any;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IStart {
    dateTime: DateTime;
    timeZone: string | undefined;
}

export class StateMasterDto implements IStateMasterDto {
    name!: string | undefined;
    country_id!: number;
    country_code!: string | undefined;
    country_name!: string | undefined;
    ctate_code!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    id!: number;

    constructor(data?: IStateMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.country_id = _data["country_id"];
            this.country_code = _data["country_code"];
            this.country_name = _data["country_name"];
            this.ctate_code = _data["ctate_code"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StateMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["country_id"] = this.country_id;
        data["country_code"] = this.country_code;
        data["country_name"] = this.country_name;
        data["ctate_code"] = this.ctate_code;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["id"] = this.id;
        return data;
    }
}

export interface IStateMasterDto {
    name: string | undefined;
    country_id: number;
    country_code: string | undefined;
    country_name: string | undefined;
    ctate_code: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    id: number;
}

export class StatusDate implements IStatusDate {
    status!: string | undefined;
    dateTime!: DateTime;

    constructor(data?: IStatusDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StatusDate {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : undefined as any;
        return data;
    }
}

export interface IStatusDate {
    status: string | undefined;
    dateTime: DateTime;
}

export class StoreImageOnBlobDto implements IStoreImageOnBlobDto {
    imgBase64String!: string | undefined;
    subStorePath!: string | undefined;
    imgName!: string | undefined;
    requestSource!: RequestSource;
    tenantId!: number;
    userId!: number;
    mgtToken!: string | undefined;
    id!: number | undefined;

    constructor(data?: IStoreImageOnBlobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgBase64String = _data["imgBase64String"];
            this.subStorePath = _data["subStorePath"];
            this.imgName = _data["imgName"];
            this.requestSource = _data["requestSource"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.mgtToken = _data["mgtToken"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StoreImageOnBlobDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreImageOnBlobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imgBase64String"] = this.imgBase64String;
        data["subStorePath"] = this.subStorePath;
        data["imgName"] = this.imgName;
        data["requestSource"] = this.requestSource;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["mgtToken"] = this.mgtToken;
        data["id"] = this.id;
        return data;
    }
}

export interface IStoreImageOnBlobDto {
    imgBase64String: string | undefined;
    subStorePath: string | undefined;
    imgName: string | undefined;
    requestSource: RequestSource;
    tenantId: number;
    userId: number;
    mgtToken: string | undefined;
    id: number | undefined;
}

export class StoreProjectDocumentOnBlobDto implements IStoreProjectDocumentOnBlobDto {
    tenantId!: number;
    projectId!: number;
    fileName!: string | undefined;
    fileBase64String!: string | undefined;
    contentType!: string | undefined;

    constructor(data?: IStoreProjectDocumentOnBlobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.fileName = _data["fileName"];
            this.fileBase64String = _data["fileBase64String"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): StoreProjectDocumentOnBlobDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreProjectDocumentOnBlobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["fileName"] = this.fileName;
        data["fileBase64String"] = this.fileBase64String;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IStoreProjectDocumentOnBlobDto {
    tenantId: number;
    projectId: number;
    fileName: string | undefined;
    fileBase64String: string | undefined;
    contentType: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
    paymentId!: number;
    successUrl!: string | undefined;
    cancelUrl!: string | undefined;

    constructor(data?: IStripeCreatePaymentSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    }

    static fromJS(data: any): StripeCreatePaymentSessionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    }
}

export interface IStripeCreatePaymentSessionInput {
    paymentId: number;
    successUrl: string | undefined;
    cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
    paymentDone!: boolean;
    paymentType!: EditionPaymentType;
    tenantId!: number;

    constructor(data?: IStripePaymentResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDone = _data["paymentDone"];
            this.paymentType = _data["paymentType"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): StripePaymentResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        data["paymentType"] = this.paymentType;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IStripePaymentResultOutput {
    paymentDone: boolean;
    paymentType: EditionPaymentType;
    tenantId: number;
}

export class SubmittedTimesheetGridDetailDto implements ISubmittedTimesheetGridDetailDto {
    userId!: number;
    userName!: string | undefined;
    userRole!: string[] | undefined;
    userProfileImage!: string | undefined;
    userEmailAddress!: string | undefined;
    employeeId!: string | undefined;
    projectId!: number;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    projectType!: ProjectBillingType;
    projectCurrentStatus!: ProjectStatus;
    projectCreationDate!: DateTime;
    projectEndDate!: DateTime | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    billedHours!: string;
    requiredHours!: string;
    submitedHours!: string;
    submitedDate!: DateTime | undefined;
    timeSheetDate!: DateTime | undefined;
    fromDate!: DateTime;
    toDate!: DateTime;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    isRejectedForMyTimesheetLevelFlag!: boolean;
    unReadCount!: number;
    timesheetApprovalDtos!: TimesheetApprovalDto[] | undefined;
    dateWiseTimesheetIds!: TimesheetIdsDateWise[] | undefined;
    taskCount!: number;
    submissionFrequency!: ProjectTimesheetFrequencyEnum;
    invoiceTimesheetSubmissionFrequency!: ProjectTimesheetFrequencyEnum;
    id!: number;

    constructor(data?: ISubmittedTimesheetGridDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userProfileImage = _data["userProfileImage"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.employeeId = _data["employeeId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.projectType = _data["projectType"];
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.billedHours = _data["billedHours"];
            this.requiredHours = _data["requiredHours"];
            this.submitedHours = _data["submitedHours"];
            this.submitedDate = _data["submitedDate"] ? DateTime.fromISO(_data["submitedDate"].toString()) : undefined as any;
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.timesheetStatus = _data["timesheetStatus"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            this.isRejectedForMyTimesheetLevelFlag = _data["isRejectedForMyTimesheetLevelFlag"];
            this.unReadCount = _data["unReadCount"];
            if (Array.isArray(_data["timesheetApprovalDtos"])) {
                this.timesheetApprovalDtos = [] as any;
                for (let item of _data["timesheetApprovalDtos"])
                    this.timesheetApprovalDtos!.push(TimesheetApprovalDto.fromJS(item));
            }
            if (Array.isArray(_data["dateWiseTimesheetIds"])) {
                this.dateWiseTimesheetIds = [] as any;
                for (let item of _data["dateWiseTimesheetIds"])
                    this.dateWiseTimesheetIds!.push(TimesheetIdsDateWise.fromJS(item));
            }
            this.taskCount = _data["taskCount"];
            this.submissionFrequency = _data["submissionFrequency"];
            this.invoiceTimesheetSubmissionFrequency = _data["invoiceTimesheetSubmissionFrequency"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubmittedTimesheetGridDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedTimesheetGridDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userProfileImage"] = this.userProfileImage;
        data["userEmailAddress"] = this.userEmailAddress;
        data["employeeId"] = this.employeeId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["projectType"] = this.projectType;
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["billedHours"] = this.billedHours;
        data["requiredHours"] = this.requiredHours;
        data["submitedHours"] = this.submitedHours;
        data["submitedDate"] = this.submitedDate ? this.submitedDate.toString() : undefined as any;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["timesheetStatus"] = this.timesheetStatus;
        data["timesheetFrequency"] = this.timesheetFrequency;
        data["isRejectedForMyTimesheetLevelFlag"] = this.isRejectedForMyTimesheetLevelFlag;
        data["unReadCount"] = this.unReadCount;
        if (Array.isArray(this.timesheetApprovalDtos)) {
            data["timesheetApprovalDtos"] = [];
            for (let item of this.timesheetApprovalDtos)
                data["timesheetApprovalDtos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dateWiseTimesheetIds)) {
            data["dateWiseTimesheetIds"] = [];
            for (let item of this.dateWiseTimesheetIds)
                data["dateWiseTimesheetIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["taskCount"] = this.taskCount;
        data["submissionFrequency"] = this.submissionFrequency;
        data["invoiceTimesheetSubmissionFrequency"] = this.invoiceTimesheetSubmissionFrequency;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubmittedTimesheetGridDetailDto {
    userId: number;
    userName: string | undefined;
    userRole: string[] | undefined;
    userProfileImage: string | undefined;
    userEmailAddress: string | undefined;
    employeeId: string | undefined;
    projectId: number;
    projectName: string | undefined;
    projectImage: string | undefined;
    projectType: ProjectBillingType;
    projectCurrentStatus: ProjectStatus;
    projectCreationDate: DateTime;
    projectEndDate: DateTime | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    billedHours: string;
    requiredHours: string;
    submitedHours: string;
    submitedDate: DateTime | undefined;
    timeSheetDate: DateTime | undefined;
    fromDate: DateTime;
    toDate: DateTime;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    isRejectedForMyTimesheetLevelFlag: boolean;
    unReadCount: number;
    timesheetApprovalDtos: TimesheetApprovalDto[] | undefined;
    dateWiseTimesheetIds: TimesheetIdsDateWise[] | undefined;
    taskCount: number;
    submissionFrequency: ProjectTimesheetFrequencyEnum;
    invoiceTimesheetSubmissionFrequency: ProjectTimesheetFrequencyEnum;
    id: number;
}

export class SubmittedTimesheetHeaderDetailDto implements ISubmittedTimesheetHeaderDetailDto {
    pendingTimesheet!: number;
    rejectedTimesheet!: number;

    constructor(data?: ISubmittedTimesheetHeaderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingTimesheet = _data["pendingTimesheet"];
            this.rejectedTimesheet = _data["rejectedTimesheet"];
        }
    }

    static fromJS(data: any): SubmittedTimesheetHeaderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedTimesheetHeaderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingTimesheet"] = this.pendingTimesheet;
        data["rejectedTimesheet"] = this.rejectedTimesheet;
        return data;
    }
}

export interface ISubmittedTimesheetHeaderDetailDto {
    pendingTimesheet: number;
    rejectedTimesheet: number;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class SubscriptionMgtDataDto implements ISubscriptionMgtDataDto {
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    numberOfUser!: number | undefined;

    constructor(data?: ISubscriptionMgtDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.numberOfUser = _data["numberOfUser"];
        }
    }

    static fromJS(data: any): SubscriptionMgtDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionMgtDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["numberOfUser"] = this.numberOfUser;
        return data;
    }
}

export interface ISubscriptionMgtDataDto {
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    numberOfUser: number | undefined;
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    description!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;
    amount!: number;
    editionId!: number;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    editionPaymentType!: EditionPaymentType;
    id!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.tenantId = _data["tenantId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.payerId = _data["payerId"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.status = _data["status"];
            this.isRecurring = _data["isRecurring"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["editionPaymentType"] = this.editionPaymentType;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentDto {
    description: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
    amount: number;
    editionId: number;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    payerId: string | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    editionPaymentType: EditionPaymentType;
    id: number;
}

export enum SubscriptionPaymentGatewayType {
    Paypal = 1,
    Stripe = 2,
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number;
    editionId!: number;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    externalPaymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.payerId = _data["payerId"];
            this.status = _data["status"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.tenantId = _data["tenantId"];
            this.invoiceNo = _data["invoiceNo"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    externalPaymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum SubscriptionPaymentStatus {
    NotPaid = 1,
    Paid = 2,
    Failed = 3,
    Cancelled = 4,
    Completed = 5,
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class Summary implements ISummary {
    queryTime!: number;
    numResults!: number;

    constructor(data?: ISummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queryTime = _data["queryTime"];
            this.numResults = _data["numResults"];
        }
    }

    static fromJS(data: any): Summary {
        data = typeof data === 'object' ? data : {};
        let result = new Summary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryTime"] = this.queryTime;
        data["numResults"] = this.numResults;
        return data;
    }
}

export interface ISummary {
    queryTime: number;
    numResults: number;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class TakeScreenShotDto implements ITakeScreenShotDto {
    filePath!: string | undefined;
    appName!: string | undefined;
    appIcon!: string | undefined;
    screenShotTime!: string | undefined;
    userName!: string | undefined;
    userProfileImage!: string | undefined;

    constructor(data?: ITakeScreenShotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"];
            this.appName = _data["appName"];
            this.appIcon = _data["appIcon"];
            this.screenShotTime = _data["screenShotTime"];
            this.userName = _data["userName"];
            this.userProfileImage = _data["userProfileImage"];
        }
    }

    static fromJS(data: any): TakeScreenShotDto {
        data = typeof data === 'object' ? data : {};
        let result = new TakeScreenShotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["appName"] = this.appName;
        data["appIcon"] = this.appIcon;
        data["screenShotTime"] = this.screenShotTime;
        data["userName"] = this.userName;
        data["userProfileImage"] = this.userProfileImage;
        return data;
    }
}

export interface ITakeScreenShotDto {
    filePath: string | undefined;
    appName: string | undefined;
    appIcon: string | undefined;
    screenShotTime: string | undefined;
    userName: string | undefined;
    userProfileImage: string | undefined;
}

export class TaskActivity implements ITaskActivity {
    name!: string | undefined;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITaskActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskActivity {
        data = typeof data === 'object' ? data : {};
        let result = new TaskActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskActivity {
    name: string | undefined;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TaskAttachmentDto implements ITaskAttachmentDto {
    taskId!: number;
    fileName!: string | undefined;
    downloadurl!: string | undefined;

    constructor(data?: ITaskAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.fileName = _data["fileName"];
            this.downloadurl = _data["downloadurl"];
        }
    }

    static fromJS(data: any): TaskAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["fileName"] = this.fileName;
        data["downloadurl"] = this.downloadurl;
        return data;
    }
}

export interface ITaskAttachmentDto {
    taskId: number;
    fileName: string | undefined;
    downloadurl: string | undefined;
}

export class TaskDiscussionCreateOrEditDto implements ITaskDiscussionCreateOrEditDto {
    tenantId!: number;
    projectTaskId!: number | undefined;
    userId!: number | undefined;
    discussion!: string | undefined;
    id!: number;

    constructor(data?: ITaskDiscussionCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectTaskId = _data["projectTaskId"];
            this.userId = _data["userId"];
            this.discussion = _data["discussion"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskDiscussionCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDiscussionCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectTaskId"] = this.projectTaskId;
        data["userId"] = this.userId;
        data["discussion"] = this.discussion;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskDiscussionCreateOrEditDto {
    tenantId: number;
    projectTaskId: number | undefined;
    userId: number | undefined;
    discussion: string | undefined;
    id: number;
}

export class TaskDto implements ITaskDto {
    taskId!: number;
    taskName!: string | undefined;
    taskDescription!: string | undefined;
    taskStatusId!: number | undefined;
    billableType!: ProjectBillingType;
    totalTrackedTime!: string;
    startingTime!: DateTime | undefined;
    estimateHour!: string | undefined;
    isParentShow!: boolean;
    isShow!: boolean;

    constructor(data?: ITaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.taskDescription = _data["taskDescription"];
            this.taskStatusId = _data["taskStatusId"];
            this.billableType = _data["billableType"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.startingTime = _data["startingTime"] ? DateTime.fromISO(_data["startingTime"].toString()) : undefined as any;
            this.estimateHour = _data["estimateHour"];
            this.isParentShow = _data["isParentShow"];
            this.isShow = _data["isShow"];
        }
    }

    static fromJS(data: any): TaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["taskDescription"] = this.taskDescription;
        data["taskStatusId"] = this.taskStatusId;
        data["billableType"] = this.billableType;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["startingTime"] = this.startingTime ? this.startingTime.toString() : undefined as any;
        data["estimateHour"] = this.estimateHour;
        data["isParentShow"] = this.isParentShow;
        data["isShow"] = this.isShow;
        return data;
    }
}

export interface ITaskDto {
    taskId: number;
    taskName: string | undefined;
    taskDescription: string | undefined;
    taskStatusId: number | undefined;
    billableType: ProjectBillingType;
    totalTrackedTime: string;
    startingTime: DateTime | undefined;
    estimateHour: string | undefined;
    isParentShow: boolean;
    isShow: boolean;
}

export class TaskHistoryStartAndEndTimeDto implements ITaskHistoryStartAndEndTimeDto {
    id!: number;
    startTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    isManualAddTask!: boolean;
    userName!: string | undefined;
    userImage!: string | undefined;
    projectTaskId!: number;
    userDetailsArray!: UserDetailsDto[] | undefined;

    constructor(data?: ITaskHistoryStartAndEndTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.isManualAddTask = _data["isManualAddTask"];
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.projectTaskId = _data["projectTaskId"];
            if (Array.isArray(_data["userDetailsArray"])) {
                this.userDetailsArray = [] as any;
                for (let item of _data["userDetailsArray"])
                    this.userDetailsArray!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskHistoryStartAndEndTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskHistoryStartAndEndTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["isManualAddTask"] = this.isManualAddTask;
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["projectTaskId"] = this.projectTaskId;
        if (Array.isArray(this.userDetailsArray)) {
            data["userDetailsArray"] = [];
            for (let item of this.userDetailsArray)
                data["userDetailsArray"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskHistoryStartAndEndTimeDto {
    id: number;
    startTime: DateTime | undefined;
    endTime: DateTime | undefined;
    isManualAddTask: boolean;
    userName: string | undefined;
    userImage: string | undefined;
    projectTaskId: number;
    userDetailsArray: UserDetailsDto[] | undefined;
}

export class TaskInfoDto implements ITaskInfoDto {
    projectId!: number;
    taskName!: string | undefined;
    projectName!: string | undefined;
    projectInEmployeeStartDate!: DateTime | undefined;
    projectInEmployeeEndDate!: DateTime | undefined;

    constructor(data?: ITaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.taskName = _data["taskName"];
            this.projectName = _data["projectName"];
            this.projectInEmployeeStartDate = _data["projectInEmployeeStartDate"] ? DateTime.fromISO(_data["projectInEmployeeStartDate"].toString()) : undefined as any;
            this.projectInEmployeeEndDate = _data["projectInEmployeeEndDate"] ? DateTime.fromISO(_data["projectInEmployeeEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["taskName"] = this.taskName;
        data["projectName"] = this.projectName;
        data["projectInEmployeeStartDate"] = this.projectInEmployeeStartDate ? this.projectInEmployeeStartDate.toString() : undefined as any;
        data["projectInEmployeeEndDate"] = this.projectInEmployeeEndDate ? this.projectInEmployeeEndDate.toString() : undefined as any;
        return data;
    }
}

export interface ITaskInfoDto {
    projectId: number;
    taskName: string | undefined;
    projectName: string | undefined;
    projectInEmployeeStartDate: DateTime | undefined;
    projectInEmployeeEndDate: DateTime | undefined;
}

export class TaskJob implements ITaskJob {
    tenantId!: number;
    jobName!: string | undefined;
    projectId!: number | undefined;
    project!: Projects;
    isSeed!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITaskJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.jobName = _data["jobName"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.isSeed = _data["isSeed"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskJob {
        data = typeof data === 'object' ? data : {};
        let result = new TaskJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["jobName"] = this.jobName;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["isSeed"] = this.isSeed;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskJob {
    tenantId: number;
    jobName: string | undefined;
    projectId: number | undefined;
    project: Projects;
    isSeed: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TaskListDto implements ITaskListDto {
    taskId!: number;
    spendTime!: string;
    includeTimesheet!: boolean;
    manualTimesheetId!: number;

    constructor(data?: ITaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.spendTime = _data["spendTime"];
            this.includeTimesheet = _data["includeTimesheet"];
            this.manualTimesheetId = _data["manualTimesheetId"];
        }
    }

    static fromJS(data: any): TaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["spendTime"] = this.spendTime;
        data["includeTimesheet"] = this.includeTimesheet;
        data["manualTimesheetId"] = this.manualTimesheetId;
        return data;
    }
}

export interface ITaskListDto {
    taskId: number;
    spendTime: string;
    includeTimesheet: boolean;
    manualTimesheetId: number;
}

export class TaskLogDto implements ITaskLogDto {
    taskId!: number;
    taskStatus!: TaskStatus;
    userId!: number;
    statTime!: DateTime;
    endTime!: DateTime;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: ITaskLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskStatus = _data["taskStatus"];
            this.userId = _data["userId"];
            this.statTime = _data["statTime"] ? DateTime.fromISO(_data["statTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskStatus"] = this.taskStatus;
        data["userId"] = this.userId;
        data["statTime"] = this.statTime ? this.statTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskLogDto {
    taskId: number;
    taskStatus: TaskStatus;
    userId: number;
    statTime: DateTime;
    endTime: DateTime;
    tenantId: number | undefined;
    id: number;
}

export class TaskLogOutPutDto implements ITaskLogOutPutDto {
    originalEstimateHr!: string;
    remainingEstimateHr!: string;
    completedEstimateHr!: string;
    totalSpentTime!: string;
    originalEstimateHrInSec!: string | undefined;
    remainingEstimateHrInSec!: string | undefined;
    completedEstimateHrInSec!: string | undefined;
    totalSpentTimeInSec!: string | undefined;
    taskStateId!: number | undefined;
    taskActivityId!: number | undefined;
    taskPriorityId!: number | undefined;
    projectId!: number | undefined;
    taskName!: string | undefined;
    taskDescription!: string | undefined;
    taskSeverityId!: number | undefined;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    taskLogs!: GetTaskLogDto[] | undefined;
    id!: number;

    constructor(data?: ITaskLogOutPutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalEstimateHr = _data["originalEstimateHr"];
            this.remainingEstimateHr = _data["remainingEstimateHr"];
            this.completedEstimateHr = _data["completedEstimateHr"];
            this.totalSpentTime = _data["totalSpentTime"];
            this.originalEstimateHrInSec = _data["originalEstimateHrInSec"];
            this.remainingEstimateHrInSec = _data["remainingEstimateHrInSec"];
            this.completedEstimateHrInSec = _data["completedEstimateHrInSec"];
            this.totalSpentTimeInSec = _data["totalSpentTimeInSec"];
            this.taskStateId = _data["taskStateId"];
            this.taskActivityId = _data["taskActivityId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.projectId = _data["projectId"];
            this.taskName = _data["taskName"];
            this.taskDescription = _data["taskDescription"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            if (Array.isArray(_data["taskLogs"])) {
                this.taskLogs = [] as any;
                for (let item of _data["taskLogs"])
                    this.taskLogs!.push(GetTaskLogDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskLogOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalEstimateHr"] = this.originalEstimateHr;
        data["remainingEstimateHr"] = this.remainingEstimateHr;
        data["completedEstimateHr"] = this.completedEstimateHr;
        data["totalSpentTime"] = this.totalSpentTime;
        data["originalEstimateHrInSec"] = this.originalEstimateHrInSec;
        data["remainingEstimateHrInSec"] = this.remainingEstimateHrInSec;
        data["completedEstimateHrInSec"] = this.completedEstimateHrInSec;
        data["totalSpentTimeInSec"] = this.totalSpentTimeInSec;
        data["taskStateId"] = this.taskStateId;
        data["taskActivityId"] = this.taskActivityId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["projectId"] = this.projectId;
        data["taskName"] = this.taskName;
        data["taskDescription"] = this.taskDescription;
        data["taskSeverityId"] = this.taskSeverityId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        if (Array.isArray(this.taskLogs)) {
            data["taskLogs"] = [];
            for (let item of this.taskLogs)
                data["taskLogs"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskLogOutPutDto {
    originalEstimateHr: string;
    remainingEstimateHr: string;
    completedEstimateHr: string;
    totalSpentTime: string;
    originalEstimateHrInSec: string | undefined;
    remainingEstimateHrInSec: string | undefined;
    completedEstimateHrInSec: string | undefined;
    totalSpentTimeInSec: string | undefined;
    taskStateId: number | undefined;
    taskActivityId: number | undefined;
    taskPriorityId: number | undefined;
    projectId: number | undefined;
    taskName: string | undefined;
    taskDescription: string | undefined;
    taskSeverityId: number | undefined;
    projectName: string | undefined;
    projectImage: string | undefined;
    taskLogs: GetTaskLogDto[] | undefined;
    id: number;
}

export class TaskPriority implements ITaskPriority {
    name!: string | undefined;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITaskPriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskPriority {
        data = typeof data === 'object' ? data : {};
        let result = new TaskPriority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskPriority {
    name: string | undefined;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TaskSeverity implements ITaskSeverity {
    name!: string | undefined;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITaskSeverity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskSeverity {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSeverity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskSeverity {
    name: string | undefined;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TaskState implements ITaskState {
    name!: string | undefined;
    code!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITaskState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskState {
        data = typeof data === 'object' ? data : {};
        let result = new TaskState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskState {
    name: string | undefined;
    code: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum TaskStateType {
    New = 1,
    InProgress = 2,
    OverDue = 3,
    Completed = 4,
}

export enum TaskStatus {
    Created = 0,
    WaitingForActivation = 1,
    WaitingToRun = 2,
    Running = 3,
    WaitingForChildrenToComplete = 4,
    RanToCompletion = 5,
    Canceled = 6,
    Faulted = 7,
}

export class TaskStatusCountDto implements ITaskStatusCountDto {
    new!: number;
    active!: number;
    resolved!: number;
    close!: number;

    constructor(data?: ITaskStatusCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.new = _data["new"];
            this.active = _data["active"];
            this.resolved = _data["resolved"];
            this.close = _data["close"];
        }
    }

    static fromJS(data: any): TaskStatusCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["new"] = this.new;
        data["active"] = this.active;
        data["resolved"] = this.resolved;
        data["close"] = this.close;
        return data;
    }
}

export interface ITaskStatusCountDto {
    new: number;
    active: number;
    resolved: number;
    close: number;
}

export class TaskWiseDescription implements ITaskWiseDescription {
    taskDate!: DateTime;
    taskDescription!: string | undefined;
    taskdaywiseBillingtype!: ProjectBillingType;
    taskId!: number;

    constructor(data?: ITaskWiseDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskDate = _data["taskDate"] ? DateTime.fromISO(_data["taskDate"].toString()) : undefined as any;
            this.taskDescription = _data["taskDescription"];
            this.taskdaywiseBillingtype = _data["taskdaywiseBillingtype"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): TaskWiseDescription {
        data = typeof data === 'object' ? data : {};
        let result = new TaskWiseDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskDate"] = this.taskDate ? this.taskDate.toString() : undefined as any;
        data["taskDescription"] = this.taskDescription;
        data["taskdaywiseBillingtype"] = this.taskdaywiseBillingtype;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ITaskWiseDescription {
    taskDate: DateTime;
    taskDescription: string | undefined;
    taskdaywiseBillingtype: ProjectBillingType;
    taskId: number;
}

export class TaskWiseNonBillableReason implements ITaskWiseNonBillableReason {
    taskDate!: DateTime;
    reasonId!: number;
    taskId!: number;

    constructor(data?: ITaskWiseNonBillableReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskDate = _data["taskDate"] ? DateTime.fromISO(_data["taskDate"].toString()) : undefined as any;
            this.reasonId = _data["reasonId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): TaskWiseNonBillableReason {
        data = typeof data === 'object' ? data : {};
        let result = new TaskWiseNonBillableReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskDate"] = this.taskDate ? this.taskDate.toString() : undefined as any;
        data["reasonId"] = this.reasonId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ITaskWiseNonBillableReason {
    taskDate: DateTime;
    reasonId: number;
    taskId: number;
}

export class TeamCountDto implements ITeamCountDto {
    totalMember!: number;
    totalProject!: number;
    pendingProject!: number;
    completedProject!: number;
    leaveRequest!: number;
    absentEmployee!: number;
    lateEmployee!: number;
    arrivedEmployee!: number;

    constructor(data?: ITeamCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMember = _data["totalMember"];
            this.totalProject = _data["totalProject"];
            this.pendingProject = _data["pendingProject"];
            this.completedProject = _data["completedProject"];
            this.leaveRequest = _data["leaveRequest"];
            this.absentEmployee = _data["absentEmployee"];
            this.lateEmployee = _data["lateEmployee"];
            this.arrivedEmployee = _data["arrivedEmployee"];
        }
    }

    static fromJS(data: any): TeamCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMember"] = this.totalMember;
        data["totalProject"] = this.totalProject;
        data["pendingProject"] = this.pendingProject;
        data["completedProject"] = this.completedProject;
        data["leaveRequest"] = this.leaveRequest;
        data["absentEmployee"] = this.absentEmployee;
        data["lateEmployee"] = this.lateEmployee;
        data["arrivedEmployee"] = this.arrivedEmployee;
        return data;
    }
}

export interface ITeamCountDto {
    totalMember: number;
    totalProject: number;
    pendingProject: number;
    completedProject: number;
    leaveRequest: number;
    absentEmployee: number;
    lateEmployee: number;
    arrivedEmployee: number;
}

export class TeamDetailDto implements ITeamDetailDto {
    userId!: number | undefined;
    projectId!: number;
    orgnizationId!: number;
    userName!: string | undefined;
    userImage!: string | undefined;
    userRole!: string | undefined;
    userStatus!: string | undefined;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    applicationName!: string | undefined;
    applicationImage!: string | undefined;
    applicationStatus!: string | undefined;
    screenshot!: string | undefined;
    joinDate!: DateTime;
    deviceType!: number;
    deviceName!: string | undefined;
    projectDescription!: string | undefined;
    calculation!: CalculationTimeAndAttendanceDto;

    constructor(data?: ITeamDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.orgnizationId = _data["orgnizationId"];
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.userRole = _data["userRole"];
            this.userStatus = _data["userStatus"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.applicationName = _data["applicationName"];
            this.applicationImage = _data["applicationImage"];
            this.applicationStatus = _data["applicationStatus"];
            this.screenshot = _data["screenshot"];
            this.joinDate = _data["joinDate"] ? DateTime.fromISO(_data["joinDate"].toString()) : undefined as any;
            this.deviceType = _data["deviceType"];
            this.deviceName = _data["deviceName"];
            this.projectDescription = _data["projectDescription"];
            this.calculation = _data["calculation"] ? CalculationTimeAndAttendanceDto.fromJS(_data["calculation"]) : undefined as any;
        }
    }

    static fromJS(data: any): TeamDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["orgnizationId"] = this.orgnizationId;
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["userRole"] = this.userRole;
        data["userStatus"] = this.userStatus;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["applicationName"] = this.applicationName;
        data["applicationImage"] = this.applicationImage;
        data["applicationStatus"] = this.applicationStatus;
        data["screenshot"] = this.screenshot;
        data["joinDate"] = this.joinDate ? this.joinDate.toString() : undefined as any;
        data["deviceType"] = this.deviceType;
        data["deviceName"] = this.deviceName;
        data["projectDescription"] = this.projectDescription;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        return data;
    }
}

export interface ITeamDetailDto {
    userId: number | undefined;
    projectId: number;
    orgnizationId: number;
    userName: string | undefined;
    userImage: string | undefined;
    userRole: string | undefined;
    userStatus: string | undefined;
    projectName: string | undefined;
    projectImage: string | undefined;
    applicationName: string | undefined;
    applicationImage: string | undefined;
    applicationStatus: string | undefined;
    screenshot: string | undefined;
    joinDate: DateTime;
    deviceType: number;
    deviceName: string | undefined;
    projectDescription: string | undefined;
    calculation: CalculationTimeAndAttendanceDto;
}

export class TeamMemberDto implements ITeamMemberDto {
    userName!: string | undefined;
    userRole!: string[] | undefined;
    userJoinDate!: DateTime;
    userProfileImage!: string | undefined;
    userEmail!: string | undefined;
    userOrganizationName!: string | undefined;
    id!: number;

    constructor(data?: ITeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userJoinDate = _data["userJoinDate"] ? DateTime.fromISO(_data["userJoinDate"].toString()) : undefined as any;
            this.userProfileImage = _data["userProfileImage"];
            this.userEmail = _data["userEmail"];
            this.userOrganizationName = _data["userOrganizationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userJoinDate"] = this.userJoinDate ? this.userJoinDate.toString() : undefined as any;
        data["userProfileImage"] = this.userProfileImage;
        data["userEmail"] = this.userEmail;
        data["userOrganizationName"] = this.userOrganizationName;
        data["id"] = this.id;
        return data;
    }
}

export interface ITeamMemberDto {
    userName: string | undefined;
    userRole: string[] | undefined;
    userJoinDate: DateTime;
    userProfileImage: string | undefined;
    userEmail: string | undefined;
    userOrganizationName: string | undefined;
    id: number;
}

export class TeamProfileImageDto implements ITeamProfileImageDto {
    image!: string | undefined;
    fullName!: string | undefined;
    projectRole!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: ITeamProfileImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.fullName = _data["fullName"];
            this.projectRole = _data["projectRole"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TeamProfileImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamProfileImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["fullName"] = this.fullName;
        data["projectRole"] = this.projectRole;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITeamProfileImageDto {
    image: string | undefined;
    fullName: string | undefined;
    projectRole: string | undefined;
    emailAddress: string | undefined;
}

export class TeamTaskDto implements ITeamTaskDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    taskId!: number | undefined;
    projectBillableType!: ProjectBillingType;
    taskName!: string | undefined;
    comments!: string | undefined;
    projectImage!: string | undefined;
    taskBillableType!: ProjectBillingType;
    userId!: number | undefined;
    userName!: string | undefined;
    taskStatusId!: number | undefined;
    originalEstimateHr!: number | undefined;
    totalTrackedTime!: number;
    userProfilePicture!: string | undefined;
    userStatusId!: UserStatusEnum;
    userRole!: string[] | undefined;
    isDeleteTask!: boolean;
    isCurrentTaskActive!: boolean;
    taskSeverityId!: number;
    taskPriorityId!: number;
    taskActivityId!: number;
    recordsCount!: number;
    status!: string | undefined;
    severity!: string | undefined;
    description!: string | undefined;
    remainingWork!: number;
    linkDescription!: string | undefined;
    workItemType!: string | undefined;
    taskWorkTypeId!: WorkItemTypeEnum;
    activity!: string | undefined;
    isDevOps!: boolean;
    devOpsTaskId!: number | undefined;

    constructor(data?: ITeamTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.taskId = _data["taskId"];
            this.projectBillableType = _data["projectBillableType"];
            this.taskName = _data["taskName"];
            this.comments = _data["comments"];
            this.projectImage = _data["projectImage"];
            this.taskBillableType = _data["taskBillableType"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.taskStatusId = _data["taskStatusId"];
            this.originalEstimateHr = _data["originalEstimateHr"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.userProfilePicture = _data["userProfilePicture"];
            this.userStatusId = _data["userStatusId"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.isDeleteTask = _data["isDeleteTask"];
            this.isCurrentTaskActive = _data["isCurrentTaskActive"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.recordsCount = _data["recordsCount"];
            this.status = _data["status"];
            this.severity = _data["severity"];
            this.description = _data["description"];
            this.remainingWork = _data["remainingWork"];
            this.linkDescription = _data["linkDescription"];
            this.workItemType = _data["workItemType"];
            this.taskWorkTypeId = _data["taskWorkTypeId"];
            this.activity = _data["activity"];
            this.isDevOps = _data["isDevOps"];
            this.devOpsTaskId = _data["devOpsTaskId"];
        }
    }

    static fromJS(data: any): TeamTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["taskId"] = this.taskId;
        data["projectBillableType"] = this.projectBillableType;
        data["taskName"] = this.taskName;
        data["comments"] = this.comments;
        data["projectImage"] = this.projectImage;
        data["taskBillableType"] = this.taskBillableType;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["taskStatusId"] = this.taskStatusId;
        data["originalEstimateHr"] = this.originalEstimateHr;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["userProfilePicture"] = this.userProfilePicture;
        data["userStatusId"] = this.userStatusId;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["isDeleteTask"] = this.isDeleteTask;
        data["isCurrentTaskActive"] = this.isCurrentTaskActive;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskActivityId"] = this.taskActivityId;
        data["recordsCount"] = this.recordsCount;
        data["status"] = this.status;
        data["severity"] = this.severity;
        data["description"] = this.description;
        data["remainingWork"] = this.remainingWork;
        data["linkDescription"] = this.linkDescription;
        data["workItemType"] = this.workItemType;
        data["taskWorkTypeId"] = this.taskWorkTypeId;
        data["activity"] = this.activity;
        data["isDevOps"] = this.isDevOps;
        data["devOpsTaskId"] = this.devOpsTaskId;
        return data;
    }
}

export interface ITeamTaskDto {
    projectId: number | undefined;
    projectName: string | undefined;
    taskId: number | undefined;
    projectBillableType: ProjectBillingType;
    taskName: string | undefined;
    comments: string | undefined;
    projectImage: string | undefined;
    taskBillableType: ProjectBillingType;
    userId: number | undefined;
    userName: string | undefined;
    taskStatusId: number | undefined;
    originalEstimateHr: number | undefined;
    totalTrackedTime: number;
    userProfilePicture: string | undefined;
    userStatusId: UserStatusEnum;
    userRole: string[] | undefined;
    isDeleteTask: boolean;
    isCurrentTaskActive: boolean;
    taskSeverityId: number;
    taskPriorityId: number;
    taskActivityId: number;
    recordsCount: number;
    status: string | undefined;
    severity: string | undefined;
    description: string | undefined;
    remainingWork: number;
    linkDescription: string | undefined;
    workItemType: string | undefined;
    taskWorkTypeId: WorkItemTypeEnum;
    activity: string | undefined;
    isDevOps: boolean;
    devOpsTaskId: number | undefined;
}

export class TeamTaskResult implements ITeamTaskResult {
    items!: TeamTaskDto[] | undefined;
    count!: number;

    constructor(data?: ITeamTaskResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TeamTaskDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TeamTaskResult {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTaskResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface ITeamTaskResult {
    items: TeamTaskDto[] | undefined;
    count: number;
}

export class TeamTimesheetHeaderFiledDto implements ITeamTimesheetHeaderFiledDto {
    loggedHours!: string;
    billedHours!: string;
    pendingTimesheet!: number;
    overdueTimesheet!: number;

    constructor(data?: ITeamTimesheetHeaderFiledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loggedHours = _data["loggedHours"];
            this.billedHours = _data["billedHours"];
            this.pendingTimesheet = _data["pendingTimesheet"];
            this.overdueTimesheet = _data["overdueTimesheet"];
        }
    }

    static fromJS(data: any): TeamTimesheetHeaderFiledDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTimesheetHeaderFiledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loggedHours"] = this.loggedHours;
        data["billedHours"] = this.billedHours;
        data["pendingTimesheet"] = this.pendingTimesheet;
        data["overdueTimesheet"] = this.overdueTimesheet;
        return data;
    }
}

export interface ITeamTimesheetHeaderFiledDto {
    loggedHours: string;
    billedHours: string;
    pendingTimesheet: number;
    overdueTimesheet: number;
}

export class TeamUsers implements ITeamUsers {
    id!: number;
    fullName!: string | undefined;
    profileImage!: string | undefined;
    role!: string[] | undefined;
    managerId!: number | undefined;
    userWorkingDay!: UserWorkingDays;

    constructor(data?: ITeamUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.profileImage = _data["profileImage"];
            if (Array.isArray(_data["role"])) {
                this.role = [] as any;
                for (let item of _data["role"])
                    this.role!.push(item);
            }
            this.managerId = _data["managerId"];
            this.userWorkingDay = _data["userWorkingDay"] ? UserWorkingDays.fromJS(_data["userWorkingDay"]) : undefined as any;
        }
    }

    static fromJS(data: any): TeamUsers {
        data = typeof data === 'object' ? data : {};
        let result = new TeamUsers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["profileImage"] = this.profileImage;
        if (Array.isArray(this.role)) {
            data["role"] = [];
            for (let item of this.role)
                data["role"].push(item);
        }
        data["managerId"] = this.managerId;
        data["userWorkingDay"] = this.userWorkingDay ? this.userWorkingDay.toJSON() : undefined as any;
        return data;
    }
}

export interface ITeamUsers {
    id: number;
    fullName: string | undefined;
    profileImage: string | undefined;
    role: string[] | undefined;
    managerId: number | undefined;
    userWorkingDay: UserWorkingDays;
}

export class TeamWorkingStatus implements ITeamWorkingStatus {
    workFromOfficeCount!: number;
    workFromHomeCount!: number;
    workFromRemote!: number;
    offlineEmployeeCount!: number;
    totalNoOfEmployee!: number;
    workFromUnkown!: number;

    constructor(data?: ITeamWorkingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFromOfficeCount = _data["workFromOfficeCount"];
            this.workFromHomeCount = _data["workFromHomeCount"];
            this.workFromRemote = _data["workFromRemote"];
            this.offlineEmployeeCount = _data["offlineEmployeeCount"];
            this.totalNoOfEmployee = _data["totalNoOfEmployee"];
            this.workFromUnkown = _data["workFromUnkown"];
        }
    }

    static fromJS(data: any): TeamWorkingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TeamWorkingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFromOfficeCount"] = this.workFromOfficeCount;
        data["workFromHomeCount"] = this.workFromHomeCount;
        data["workFromRemote"] = this.workFromRemote;
        data["offlineEmployeeCount"] = this.offlineEmployeeCount;
        data["totalNoOfEmployee"] = this.totalNoOfEmployee;
        data["workFromUnkown"] = this.workFromUnkown;
        return data;
    }
}

export interface ITeamWorkingStatus {
    workFromOfficeCount: number;
    workFromHomeCount: number;
    workFromRemote: number;
    offlineEmployeeCount: number;
    totalNoOfEmployee: number;
    workFromUnkown: number;
}

export class Tenant implements ITenant {
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    customCssId!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: Edition;
    editionId!: number | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    deleterUser!: User;
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.customCssId = _data["customCssId"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : undefined as any;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : undefined as any;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : undefined as any;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customCssId"] = this.customCssId;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined as any;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenant {
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantCreationVerifyEmailAndCompanyName implements ITenantCreationVerifyEmailAndCompanyName {
    isCompany!: boolean;
    isEmailAddress!: boolean;

    constructor(data?: ITenantCreationVerifyEmailAndCompanyName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCompany = _data["isCompany"];
            this.isEmailAddress = _data["isEmailAddress"];
        }
    }

    static fromJS(data: any): TenantCreationVerifyEmailAndCompanyName {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreationVerifyEmailAndCompanyName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompany"] = this.isCompany;
        data["isEmailAddress"] = this.isEmailAddress;
        return data;
    }
}

export interface ITenantCreationVerifyEmailAndCompanyName {
    isCompany: boolean;
    isEmailAddress: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    outboundEmailEnabled!: boolean | undefined;
    graphTenantId!: string | undefined;
    graphClientId!: string | undefined;
    graphClientSecret!: string | undefined;
    graphSenderUserPrincipalName!: string | undefined;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.outboundEmailEnabled = _data["outboundEmailEnabled"];
            this.graphTenantId = _data["graphTenantId"];
            this.graphClientId = _data["graphClientId"];
            this.graphClientSecret = _data["graphClientSecret"];
            this.graphSenderUserPrincipalName = _data["graphSenderUserPrincipalName"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["outboundEmailEnabled"] = this.outboundEmailEnabled;
        data["graphTenantId"] = this.graphTenantId;
        data["graphClientId"] = this.graphClientId;
        data["graphClientSecret"] = this.graphClientSecret;
        data["graphSenderUserPrincipalName"] = this.graphSenderUserPrincipalName;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    outboundEmailEnabled: boolean | undefined;
    graphTenantId: string | undefined;
    graphClientId: string | undefined;
    graphClientSecret: string | undefined;
    graphSenderUserPrincipalName: string | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    featureValues!: NameValueDto[] | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : undefined as any;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : undefined as any;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    featureValues: NameValueDto[] | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityTypeName!: string | undefined;
    entityId!: any;
    severity!: NotificationSeverity;
    creationTime!: DateTime;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : undefined as any;
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityTypeName: string | undefined;
    entityId: any;
    severity: NotificationSeverity;
    creationTime: DateTime;
    id: string;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantProductServiceCreateOrEditDto implements ITenantProductServiceCreateOrEditDto {
    tenantId!: number;
    name!: string;
    code!: string;
    rate!: number;
    productServiceImage!: string | undefined;
    description!: string | undefined;
    productServiceTypeId!: number;
    isBillable!: boolean;
    isAddToNewProject!: boolean;
    taxes!: TenantProductServiceTaxesDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ITenantProductServiceCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.rate = _data["rate"];
            this.productServiceImage = _data["productServiceImage"];
            this.description = _data["description"];
            this.productServiceTypeId = _data["productServiceTypeId"];
            this.isBillable = _data["isBillable"];
            this.isAddToNewProject = _data["isAddToNewProject"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TenantProductServiceTaxesDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantProductServiceCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantProductServiceCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["rate"] = this.rate;
        data["productServiceImage"] = this.productServiceImage;
        data["description"] = this.description;
        data["productServiceTypeId"] = this.productServiceTypeId;
        data["isBillable"] = this.isBillable;
        data["isAddToNewProject"] = this.isAddToNewProject;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantProductServiceCreateOrEditDto {
    tenantId: number;
    name: string;
    code: string;
    rate: number;
    productServiceImage: string | undefined;
    description: string | undefined;
    productServiceTypeId: number;
    isBillable: boolean;
    isAddToNewProject: boolean;
    taxes: TenantProductServiceTaxesDto[] | undefined;
    id: number | undefined;
}

export class TenantProductServiceDto implements ITenantProductServiceDto {
    tenantId!: number;
    name!: string | undefined;
    code!: string | undefined;
    rate!: number;
    rateString!: string | undefined;
    productServiceImage!: string | undefined;
    description!: string | undefined;
    productServiceTypeId!: number;
    tenantProductServiceId!: number;
    projectBillingServiceRate!: number;
    isBillable!: boolean;
    isAddToNewProject!: boolean;
    taxes!: TenantProductServiceTaxesDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ITenantProductServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.rate = _data["rate"];
            this.rateString = _data["rateString"];
            this.productServiceImage = _data["productServiceImage"];
            this.description = _data["description"];
            this.productServiceTypeId = _data["productServiceTypeId"];
            this.tenantProductServiceId = _data["tenantProductServiceId"];
            this.projectBillingServiceRate = _data["projectBillingServiceRate"];
            this.isBillable = _data["isBillable"];
            this.isAddToNewProject = _data["isAddToNewProject"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TenantProductServiceTaxesDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantProductServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantProductServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["rate"] = this.rate;
        data["rateString"] = this.rateString;
        data["productServiceImage"] = this.productServiceImage;
        data["description"] = this.description;
        data["productServiceTypeId"] = this.productServiceTypeId;
        data["tenantProductServiceId"] = this.tenantProductServiceId;
        data["projectBillingServiceRate"] = this.projectBillingServiceRate;
        data["isBillable"] = this.isBillable;
        data["isAddToNewProject"] = this.isAddToNewProject;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantProductServiceDto {
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    rate: number;
    rateString: string | undefined;
    productServiceImage: string | undefined;
    description: string | undefined;
    productServiceTypeId: number;
    tenantProductServiceId: number;
    projectBillingServiceRate: number;
    isBillable: boolean;
    isAddToNewProject: boolean;
    taxes: TenantProductServiceTaxesDto[] | undefined;
    id: number | undefined;
}

export class TenantProductServiceGetAllDto implements ITenantProductServiceGetAllDto {
    lastModifiedUser!: UserListDto;
    productServiceType!: ProductServiceTypeDto;
    rate!: number;
    rateString!: string | undefined;
    tenantId!: number;
    name!: string | undefined;
    code!: string | undefined;
    productServiceImage!: string | undefined;
    description!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifiedUserName!: string | undefined;
    isDeleted!: boolean;
    isDelete!: string | undefined;
    producServiceTypeName!: string | undefined;
    productServiceTypeId!: number;
    tenantProductServiceId!: number;
    isBillable!: boolean;
    isAddToNewProject!: boolean;
    taxes!: TenantProductServiceTaxesDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ITenantProductServiceGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastModifiedUser = _data["lastModifiedUser"] ? UserListDto.fromJS(_data["lastModifiedUser"]) : undefined as any;
            this.productServiceType = _data["productServiceType"] ? ProductServiceTypeDto.fromJS(_data["productServiceType"]) : undefined as any;
            this.rate = _data["rate"];
            this.rateString = _data["rateString"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.productServiceImage = _data["productServiceImage"];
            this.description = _data["description"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifiedUserName = _data["lastModifiedUserName"];
            this.isDeleted = _data["isDeleted"];
            this.isDelete = _data["isDelete"];
            this.producServiceTypeName = _data["producServiceTypeName"];
            this.productServiceTypeId = _data["productServiceTypeId"];
            this.tenantProductServiceId = _data["tenantProductServiceId"];
            this.isBillable = _data["isBillable"];
            this.isAddToNewProject = _data["isAddToNewProject"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TenantProductServiceTaxesDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantProductServiceGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantProductServiceGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModifiedUser"] = this.lastModifiedUser ? this.lastModifiedUser.toJSON() : undefined as any;
        data["productServiceType"] = this.productServiceType ? this.productServiceType.toJSON() : undefined as any;
        data["rate"] = this.rate;
        data["rateString"] = this.rateString;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["productServiceImage"] = this.productServiceImage;
        data["description"] = this.description;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifiedUserName"] = this.lastModifiedUserName;
        data["isDeleted"] = this.isDeleted;
        data["isDelete"] = this.isDelete;
        data["producServiceTypeName"] = this.producServiceTypeName;
        data["productServiceTypeId"] = this.productServiceTypeId;
        data["tenantProductServiceId"] = this.tenantProductServiceId;
        data["isBillable"] = this.isBillable;
        data["isAddToNewProject"] = this.isAddToNewProject;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantProductServiceGetAllDto {
    lastModifiedUser: UserListDto;
    productServiceType: ProductServiceTypeDto;
    rate: number;
    rateString: string | undefined;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    productServiceImage: string | undefined;
    description: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifiedUserName: string | undefined;
    isDeleted: boolean;
    isDelete: string | undefined;
    producServiceTypeName: string | undefined;
    productServiceTypeId: number;
    tenantProductServiceId: number;
    isBillable: boolean;
    isAddToNewProject: boolean;
    taxes: TenantProductServiceTaxesDto[] | undefined;
    id: number | undefined;
}

export class TenantProductServiceTaxesDto implements ITenantProductServiceTaxesDto {
    taxName!: string;
    taxRate!: number;
    taxNumber!: number;
    tenantId!: number;
    productServiceId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ITenantProductServiceTaxesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxName = _data["taxName"];
            this.taxRate = _data["taxRate"];
            this.taxNumber = _data["taxNumber"];
            this.tenantId = _data["tenantId"];
            this.productServiceId = _data["productServiceId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantProductServiceTaxesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantProductServiceTaxesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxName"] = this.taxName;
        data["taxRate"] = this.taxRate;
        data["taxNumber"] = this.taxNumber;
        data["tenantId"] = this.tenantId;
        data["productServiceId"] = this.productServiceId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantProductServiceTaxesDto {
    taxName: string;
    taxRate: number;
    taxNumber: number;
    tenantId: number;
    productServiceId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    oktaIdentityProvider!: IdentityProviderDto;
    adfsIdentityProvider!: IdentityProviderDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : undefined as any;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : undefined as any;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : undefined as any;
            this.oktaIdentityProvider = _data["oktaIdentityProvider"] ? IdentityProviderDto.fromJS(_data["oktaIdentityProvider"]) : undefined as any;
            this.adfsIdentityProvider = _data["adfsIdentityProvider"] ? IdentityProviderDto.fromJS(_data["adfsIdentityProvider"]) : undefined as any;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : undefined as any;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : undefined as any;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined as any;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : undefined as any;
        data["oktaIdentityProvider"] = this.oktaIdentityProvider ? this.oktaIdentityProvider.toJSON() : undefined as any;
        data["adfsIdentityProvider"] = this.adfsIdentityProvider ? this.adfsIdentityProvider.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : undefined as any;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    oktaIdentityProvider: IdentityProviderDto;
    adfsIdentityProvider: IdentityProviderDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserIdDto implements ITenantUserIdDto {
    tenantId!: number | undefined;
    userId!: number | undefined;
    checkRole!: number;

    constructor(data?: ITenantUserIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.checkRole = _data["checkRole"];
        }
    }

    static fromJS(data: any): TenantUserIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["checkRole"] = this.checkRole;
        return data;
    }
}

export interface ITenantUserIdDto {
    tenantId: number | undefined;
    userId: number | undefined;
    checkRole: number;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    isOktaAuthenticationEnabled!: boolean;
    isAdfsAuthenticationEnabled!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.isOktaAuthenticationEnabled = _data["isOktaAuthenticationEnabled"];
            this.isAdfsAuthenticationEnabled = _data["isAdfsAuthenticationEnabled"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["isOktaAuthenticationEnabled"] = this.isOktaAuthenticationEnabled;
        data["isAdfsAuthenticationEnabled"] = this.isAdfsAuthenticationEnabled;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    isOktaAuthenticationEnabled: boolean;
    isAdfsAuthenticationEnabled: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class ThemeDto implements IThemeDto {
    themeMode!: ThemeMode;

    constructor(data?: IThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.themeMode = _data["themeMode"];
        }
    }

    static fromJS(data: any): ThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeMode"] = this.themeMode;
        return data;
    }
}

export interface IThemeDto {
    themeMode: ThemeMode;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    minimizeDesktopHeaderType!: string | undefined;
    headerSkin!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
            this.headerSkin = _data["headerSkin"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        data["headerSkin"] = this.headerSkin;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    minimizeDesktopHeaderType: string | undefined;
    headerSkin: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;
    darkMode!: boolean;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
            this.darkMode = _data["darkMode"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["darkMode"] = this.darkMode;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
    darkMode: boolean;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export enum ThemeMode {
    Dark = 0,
    Light = 1,
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : undefined as any;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : undefined as any;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : undefined as any;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : undefined as any;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : undefined as any;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : undefined as any;
        data["header"] = this.header ? this.header.toJSON() : undefined as any;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : undefined as any;
        data["menu"] = this.menu ? this.menu.toJSON() : undefined as any;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined as any;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStlye!: string | undefined;
    containerStyle!: string | undefined;
    subContainerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStlye = _data["titleStlye"];
            this.containerStyle = _data["containerStyle"];
            this.subContainerStyle = _data["subContainerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStlye"] = this.titleStlye;
        data["containerStyle"] = this.containerStyle;
        data["subContainerStyle"] = this.subContainerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStlye: string | undefined;
    containerStyle: string | undefined;
    subContainerStyle: string | undefined;
}

export enum TimeAndAttendanceEnum {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class TimeAndAttendanceHeaderDetails implements ITimeAndAttendanceHeaderDetails {
    organizationUnitName!: string | undefined;
    workingType!: WorkFromType;
    approveCount!: number;
    pendingCount!: number;
    declienCount!: number;
    workStartDate!: DateTime | undefined;
    workEndDate!: DateTime | undefined;
    timeZoneAbbrevation!: string | undefined;
    timeZoneFullString!: string | undefined;
    timeZoneInGMT!: string | undefined;

    constructor(data?: ITimeAndAttendanceHeaderDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitName = _data["organizationUnitName"];
            this.workingType = _data["workingType"];
            this.approveCount = _data["approveCount"];
            this.pendingCount = _data["pendingCount"];
            this.declienCount = _data["declienCount"];
            this.workStartDate = _data["workStartDate"] ? DateTime.fromISO(_data["workStartDate"].toString()) : undefined as any;
            this.workEndDate = _data["workEndDate"] ? DateTime.fromISO(_data["workEndDate"].toString()) : undefined as any;
            this.timeZoneAbbrevation = _data["timeZoneAbbrevation"];
            this.timeZoneFullString = _data["timeZoneFullString"];
            this.timeZoneInGMT = _data["timeZoneInGMT"];
        }
    }

    static fromJS(data: any): TimeAndAttendanceHeaderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAndAttendanceHeaderDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitName"] = this.organizationUnitName;
        data["workingType"] = this.workingType;
        data["approveCount"] = this.approveCount;
        data["pendingCount"] = this.pendingCount;
        data["declienCount"] = this.declienCount;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toString() : undefined as any;
        data["workEndDate"] = this.workEndDate ? this.workEndDate.toString() : undefined as any;
        data["timeZoneAbbrevation"] = this.timeZoneAbbrevation;
        data["timeZoneFullString"] = this.timeZoneFullString;
        data["timeZoneInGMT"] = this.timeZoneInGMT;
        return data;
    }
}

export interface ITimeAndAttendanceHeaderDetails {
    organizationUnitName: string | undefined;
    workingType: WorkFromType;
    approveCount: number;
    pendingCount: number;
    declienCount: number;
    workStartDate: DateTime | undefined;
    workEndDate: DateTime | undefined;
    timeZoneAbbrevation: string | undefined;
    timeZoneFullString: string | undefined;
    timeZoneInGMT: string | undefined;
}

export class TimeAndAttendanceUserInfoDto implements ITimeAndAttendanceUserInfoDto {
    userId!: number;
    userName!: string | undefined;
    profileImage!: string | undefined;
    userRole!: string[] | undefined;
    userStatus!: string | undefined;
    deviceName!: string | undefined;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    productivityType!: number | undefined;
    location!: string | undefined;
    deviceType!: number;
    projectName!: string | undefined;
    projectDescription!: string | undefined;
    projectIcon!: string | undefined;
    employeeId!: string | undefined;
    userCurrentLocation!: string | undefined;
    userStatusId!: UserStatusEnum;
    taskStateId!: number | undefined;
    longitude!: string | undefined;
    latitude!: string | undefined;

    constructor(data?: ITimeAndAttendanceUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.profileImage = _data["profileImage"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.userStatus = _data["userStatus"];
            this.deviceName = _data["deviceName"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.productivityType = _data["productivityType"];
            this.location = _data["location"];
            this.deviceType = _data["deviceType"];
            this.projectName = _data["projectName"];
            this.projectDescription = _data["projectDescription"];
            this.projectIcon = _data["projectIcon"];
            this.employeeId = _data["employeeId"];
            this.userCurrentLocation = _data["userCurrentLocation"];
            this.userStatusId = _data["userStatusId"];
            this.taskStateId = _data["taskStateId"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): TimeAndAttendanceUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAndAttendanceUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["profileImage"] = this.profileImage;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["userStatus"] = this.userStatus;
        data["deviceName"] = this.deviceName;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["productivityType"] = this.productivityType;
        data["location"] = this.location;
        data["deviceType"] = this.deviceType;
        data["projectName"] = this.projectName;
        data["projectDescription"] = this.projectDescription;
        data["projectIcon"] = this.projectIcon;
        data["employeeId"] = this.employeeId;
        data["userCurrentLocation"] = this.userCurrentLocation;
        data["userStatusId"] = this.userStatusId;
        data["taskStateId"] = this.taskStateId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

export interface ITimeAndAttendanceUserInfoDto {
    userId: number;
    userName: string | undefined;
    profileImage: string | undefined;
    userRole: string[] | undefined;
    userStatus: string | undefined;
    deviceName: string | undefined;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    productivityType: number | undefined;
    location: string | undefined;
    deviceType: number;
    projectName: string | undefined;
    projectDescription: string | undefined;
    projectIcon: string | undefined;
    employeeId: string | undefined;
    userCurrentLocation: string | undefined;
    userStatusId: UserStatusEnum;
    taskStateId: number | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
}

export class TimeOffASummaryDto implements ITimeOffASummaryDto {
    userId!: number;
    employeeName!: string | undefined;
    employeeEmail!: string | undefined;
    employeeId!: string | undefined;
    paid_Leave_Sick!: number;
    paid_Leave_RestDay!: number;
    paid_Leave_Out_Off_Office!: number;
    paid_Leave_Parental!: number;
    paid_Leave_Vacation!: number;
    paid_Leave_Half_Day!: number;
    paid_Leave_Total!: number;
    available_Balance!: number;
    unPaidLeave_Booked!: number;
    unPaidLeave_Unknown!: number;
    unPaidLeave_Total!: number;
    awayTime_Conference!: number;
    awayTime_Business_trip!: number;
    awayTime_Total!: number;
    overAll!: number;

    constructor(data?: ITimeOffASummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.employeeName = _data["employeeName"];
            this.employeeEmail = _data["employeeEmail"];
            this.employeeId = _data["employeeId"];
            this.paid_Leave_Sick = _data["paid_Leave_Sick"];
            this.paid_Leave_RestDay = _data["paid_Leave_RestDay"];
            this.paid_Leave_Out_Off_Office = _data["paid_Leave_Out_Off_Office"];
            this.paid_Leave_Parental = _data["paid_Leave_Parental"];
            this.paid_Leave_Vacation = _data["paid_Leave_Vacation"];
            this.paid_Leave_Half_Day = _data["paid_Leave_Half_Day"];
            this.paid_Leave_Total = _data["paid_Leave_Total"];
            this.available_Balance = _data["available_Balance"];
            this.unPaidLeave_Booked = _data["unPaidLeave_Booked"];
            this.unPaidLeave_Unknown = _data["unPaidLeave_Unknown"];
            this.unPaidLeave_Total = _data["unPaidLeave_Total"];
            this.awayTime_Conference = _data["awayTime_Conference"];
            this.awayTime_Business_trip = _data["awayTime_Business_trip"];
            this.awayTime_Total = _data["awayTime_Total"];
            this.overAll = _data["overAll"];
        }
    }

    static fromJS(data: any): TimeOffASummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOffASummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["employeeName"] = this.employeeName;
        data["employeeEmail"] = this.employeeEmail;
        data["employeeId"] = this.employeeId;
        data["paid_Leave_Sick"] = this.paid_Leave_Sick;
        data["paid_Leave_RestDay"] = this.paid_Leave_RestDay;
        data["paid_Leave_Out_Off_Office"] = this.paid_Leave_Out_Off_Office;
        data["paid_Leave_Parental"] = this.paid_Leave_Parental;
        data["paid_Leave_Vacation"] = this.paid_Leave_Vacation;
        data["paid_Leave_Half_Day"] = this.paid_Leave_Half_Day;
        data["paid_Leave_Total"] = this.paid_Leave_Total;
        data["available_Balance"] = this.available_Balance;
        data["unPaidLeave_Booked"] = this.unPaidLeave_Booked;
        data["unPaidLeave_Unknown"] = this.unPaidLeave_Unknown;
        data["unPaidLeave_Total"] = this.unPaidLeave_Total;
        data["awayTime_Conference"] = this.awayTime_Conference;
        data["awayTime_Business_trip"] = this.awayTime_Business_trip;
        data["awayTime_Total"] = this.awayTime_Total;
        data["overAll"] = this.overAll;
        return data;
    }
}

export interface ITimeOffASummaryDto {
    userId: number;
    employeeName: string | undefined;
    employeeEmail: string | undefined;
    employeeId: string | undefined;
    paid_Leave_Sick: number;
    paid_Leave_RestDay: number;
    paid_Leave_Out_Off_Office: number;
    paid_Leave_Parental: number;
    paid_Leave_Vacation: number;
    paid_Leave_Half_Day: number;
    paid_Leave_Total: number;
    available_Balance: number;
    unPaidLeave_Booked: number;
    unPaidLeave_Unknown: number;
    unPaidLeave_Total: number;
    awayTime_Conference: number;
    awayTime_Business_trip: number;
    awayTime_Total: number;
    overAll: number;
}

export class TimeOffDetailReport implements ITimeOffDetailReport {
    userId!: number;
    employeeName!: string | undefined;
    employeeEmail!: string | undefined;
    employeeId!: string | undefined;
    awayTimeTypeList!: AwayTimeType;
    leavePeriod_From!: DateTime;
    leavePeroid_To!: DateTime;
    project!: string | undefined;
    day_Taken!: number;
    status!: AddTimeStatus;
    approvedBy!: string | undefined;
    reasonForLeave!: string | undefined;
    leaveDate!: DateTime;
    submittedDate!: DateTime | undefined;

    constructor(data?: ITimeOffDetailReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.employeeName = _data["employeeName"];
            this.employeeEmail = _data["employeeEmail"];
            this.employeeId = _data["employeeId"];
            this.awayTimeTypeList = _data["awayTimeTypeList"];
            this.leavePeriod_From = _data["leavePeriod_From"] ? DateTime.fromISO(_data["leavePeriod_From"].toString()) : undefined as any;
            this.leavePeroid_To = _data["leavePeroid_To"] ? DateTime.fromISO(_data["leavePeroid_To"].toString()) : undefined as any;
            this.project = _data["project"];
            this.day_Taken = _data["day_Taken"];
            this.status = _data["status"];
            this.approvedBy = _data["approvedBy"];
            this.reasonForLeave = _data["reasonForLeave"];
            this.leaveDate = _data["leaveDate"] ? DateTime.fromISO(_data["leaveDate"].toString()) : undefined as any;
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TimeOffDetailReport {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOffDetailReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["employeeName"] = this.employeeName;
        data["employeeEmail"] = this.employeeEmail;
        data["employeeId"] = this.employeeId;
        data["awayTimeTypeList"] = this.awayTimeTypeList;
        data["leavePeriod_From"] = this.leavePeriod_From ? this.leavePeriod_From.toString() : undefined as any;
        data["leavePeroid_To"] = this.leavePeroid_To ? this.leavePeroid_To.toString() : undefined as any;
        data["project"] = this.project;
        data["day_Taken"] = this.day_Taken;
        data["status"] = this.status;
        data["approvedBy"] = this.approvedBy;
        data["reasonForLeave"] = this.reasonForLeave;
        data["leaveDate"] = this.leaveDate ? this.leaveDate.toString() : undefined as any;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : undefined as any;
        return data;
    }
}

export interface ITimeOffDetailReport {
    userId: number;
    employeeName: string | undefined;
    employeeEmail: string | undefined;
    employeeId: string | undefined;
    awayTimeTypeList: AwayTimeType;
    leavePeriod_From: DateTime;
    leavePeroid_To: DateTime;
    project: string | undefined;
    day_Taken: number;
    status: AddTimeStatus;
    approvedBy: string | undefined;
    reasonForLeave: string | undefined;
    leaveDate: DateTime;
    submittedDate: DateTime | undefined;
}

export class TimeOffLeaveDto implements ITimeOffLeaveDto {
    availablePaidLeaves!: number;
    bookedLeaves!: number;
    balanceAfterBooked!: number;
    estimatedLeaves!: number;
    projectList!: ProjectInfo[] | undefined;

    constructor(data?: ITimeOffLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availablePaidLeaves = _data["availablePaidLeaves"];
            this.bookedLeaves = _data["bookedLeaves"];
            this.balanceAfterBooked = _data["balanceAfterBooked"];
            this.estimatedLeaves = _data["estimatedLeaves"];
            if (Array.isArray(_data["projectList"])) {
                this.projectList = [] as any;
                for (let item of _data["projectList"])
                    this.projectList!.push(ProjectInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeOffLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOffLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availablePaidLeaves"] = this.availablePaidLeaves;
        data["bookedLeaves"] = this.bookedLeaves;
        data["balanceAfterBooked"] = this.balanceAfterBooked;
        data["estimatedLeaves"] = this.estimatedLeaves;
        if (Array.isArray(this.projectList)) {
            data["projectList"] = [];
            for (let item of this.projectList)
                data["projectList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimeOffLeaveDto {
    availablePaidLeaves: number;
    bookedLeaves: number;
    balanceAfterBooked: number;
    estimatedLeaves: number;
    projectList: ProjectInfo[] | undefined;
}

export class TimeOffReportDto implements ITimeOffReportDto {
    leaveDuration!: string | undefined;
    exportType!: string | undefined;
    timeOffSummary!: TimeOffASummaryDto[] | undefined;
    timeOffDetails!: TimeOffDetailReport[] | undefined;

    constructor(data?: ITimeOffReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveDuration = _data["leaveDuration"];
            this.exportType = _data["exportType"];
            if (Array.isArray(_data["timeOffSummary"])) {
                this.timeOffSummary = [] as any;
                for (let item of _data["timeOffSummary"])
                    this.timeOffSummary!.push(TimeOffASummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["timeOffDetails"])) {
                this.timeOffDetails = [] as any;
                for (let item of _data["timeOffDetails"])
                    this.timeOffDetails!.push(TimeOffDetailReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeOffReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOffReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveDuration"] = this.leaveDuration;
        data["exportType"] = this.exportType;
        if (Array.isArray(this.timeOffSummary)) {
            data["timeOffSummary"] = [];
            for (let item of this.timeOffSummary)
                data["timeOffSummary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.timeOffDetails)) {
            data["timeOffDetails"] = [];
            for (let item of this.timeOffDetails)
                data["timeOffDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimeOffReportDto {
    leaveDuration: string | undefined;
    exportType: string | undefined;
    timeOffSummary: TimeOffASummaryDto[] | undefined;
    timeOffDetails: TimeOffDetailReport[] | undefined;
}

export class TimeSheetDetailDto implements ITimeSheetDetailDto {
    id!: number;
    submitedDate!: DateTime | undefined;
    timeSheetDate!: DateTime | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    requiredHours!: string;
    submitedHours!: string;
    billedHours!: string;
    userId!: number | undefined;
    userName!: string | undefined;
    userEmailAddress!: string | undefined;
    userProfileImage!: string | undefined;
    userRole!: string[] | undefined;
    user!: UserListDto;
    projectImage!: string | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    projectType!: ProjectBillingType;
    projectCurrentStatus!: ProjectStatus;
    fromDate!: DateTime;
    toDate!: DateTime;
    projectCreationDate!: DateTime | undefined;
    projectEndDate!: DateTime | undefined;
    leave!: number;
    isAdmin!: boolean;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    unReadCount!: number;
    isNextLevelClient!: boolean;
    employeeId!: string | undefined;
    userStatusId!: UserStatusEnum;
    dateWiseTimesheetIds!: TimesheetIdsDateWise[] | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag!: boolean;
    timesheetApprovalDtos!: TimesheetApprovalDto[] | undefined;

    constructor(data?: ITimeSheetDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submitedDate = _data["submitedDate"] ? DateTime.fromISO(_data["submitedDate"].toString()) : undefined as any;
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.requiredHours = _data["requiredHours"];
            this.submitedHours = _data["submitedHours"];
            this.billedHours = _data["billedHours"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userProfileImage = _data["userProfileImage"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.user = _data["user"] ? UserListDto.fromJS(_data["user"]) : undefined as any;
            this.projectImage = _data["projectImage"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.projectType = _data["projectType"];
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.leave = _data["leave"];
            this.isAdmin = _data["isAdmin"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            this.unReadCount = _data["unReadCount"];
            this.isNextLevelClient = _data["isNextLevelClient"];
            this.employeeId = _data["employeeId"];
            this.userStatusId = _data["userStatusId"];
            if (Array.isArray(_data["dateWiseTimesheetIds"])) {
                this.dateWiseTimesheetIds = [] as any;
                for (let item of _data["dateWiseTimesheetIds"])
                    this.dateWiseTimesheetIds!.push(TimesheetIdsDateWise.fromJS(item));
            }
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.isRejectedForMyTimesheetLevelFlag = _data["isRejectedForMyTimesheetLevelFlag"];
            if (Array.isArray(_data["timesheetApprovalDtos"])) {
                this.timesheetApprovalDtos = [] as any;
                for (let item of _data["timesheetApprovalDtos"])
                    this.timesheetApprovalDtos!.push(TimesheetApprovalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeSheetDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submitedDate"] = this.submitedDate ? this.submitedDate.toString() : undefined as any;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["requiredHours"] = this.requiredHours;
        data["submitedHours"] = this.submitedHours;
        data["billedHours"] = this.billedHours;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userProfileImage"] = this.userProfileImage;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["projectImage"] = this.projectImage;
        data["timesheetStatus"] = this.timesheetStatus;
        data["projectType"] = this.projectType;
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["leave"] = this.leave;
        data["isAdmin"] = this.isAdmin;
        data["timesheetFrequency"] = this.timesheetFrequency;
        data["unReadCount"] = this.unReadCount;
        data["isNextLevelClient"] = this.isNextLevelClient;
        data["employeeId"] = this.employeeId;
        data["userStatusId"] = this.userStatusId;
        if (Array.isArray(this.dateWiseTimesheetIds)) {
            data["dateWiseTimesheetIds"] = [];
            for (let item of this.dateWiseTimesheetIds)
                data["dateWiseTimesheetIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["isRejectedForMyTimesheetLevelFlag"] = this.isRejectedForMyTimesheetLevelFlag;
        if (Array.isArray(this.timesheetApprovalDtos)) {
            data["timesheetApprovalDtos"] = [];
            for (let item of this.timesheetApprovalDtos)
                data["timesheetApprovalDtos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimeSheetDetailDto {
    id: number;
    submitedDate: DateTime | undefined;
    timeSheetDate: DateTime | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    requiredHours: string;
    submitedHours: string;
    billedHours: string;
    userId: number | undefined;
    userName: string | undefined;
    userEmailAddress: string | undefined;
    userProfileImage: string | undefined;
    userRole: string[] | undefined;
    user: UserListDto;
    projectImage: string | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    projectType: ProjectBillingType;
    projectCurrentStatus: ProjectStatus;
    fromDate: DateTime;
    toDate: DateTime;
    projectCreationDate: DateTime | undefined;
    projectEndDate: DateTime | undefined;
    leave: number;
    isAdmin: boolean;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    unReadCount: number;
    isNextLevelClient: boolean;
    employeeId: string | undefined;
    userStatusId: UserStatusEnum;
    dateWiseTimesheetIds: TimesheetIdsDateWise[] | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag: boolean;
    timesheetApprovalDtos: TimesheetApprovalDto[] | undefined;
}

export class TimeSheetDto implements ITimeSheetDto {
    submitedDate!: DateTime | undefined;
    timeSheetDate!: DateTime | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    requiredHours!: string;
    submitedHours!: string;
    billedHours!: string;
    userId!: number | undefined;
    userName!: string | undefined;
    userEmailAddress!: string | undefined;
    userProfileImage!: string | undefined;
    userRole!: string[] | undefined;
    user!: UserListDto;
    projectImage!: string | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;
    projectType!: ProjectBillingType;
    projectCurrentStatus!: ProjectStatus;
    fromDate!: DateTime;
    toDate!: DateTime;
    projectCreationDate!: DateTime | undefined;
    projectEndDate!: DateTime | undefined;
    leave!: number;
    isAdmin!: boolean;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    unReadCount!: number;
    isNextLevelClient!: boolean;
    employeeId!: string | undefined;
    userStatusId!: UserStatusEnum;
    dateWiseTimesheetIds!: TimesheetIdsDateWise[] | undefined;
    employeeProjectStartDate!: DateTime | undefined;
    employeeProjectEndDate!: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag!: boolean;
    timesheetApprovalDtos!: TimesheetApprovalDto[] | undefined;
    id!: number;

    constructor(data?: ITimeSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitedDate = _data["submitedDate"] ? DateTime.fromISO(_data["submitedDate"].toString()) : undefined as any;
            this.timeSheetDate = _data["timeSheetDate"] ? DateTime.fromISO(_data["timeSheetDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.requiredHours = _data["requiredHours"];
            this.submitedHours = _data["submitedHours"];
            this.billedHours = _data["billedHours"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userProfileImage = _data["userProfileImage"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.user = _data["user"] ? UserListDto.fromJS(_data["user"]) : undefined as any;
            this.projectImage = _data["projectImage"];
            this.timesheetStatus = _data["timesheetStatus"];
            this.projectType = _data["projectType"];
            this.projectCurrentStatus = _data["projectCurrentStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.projectCreationDate = _data["projectCreationDate"] ? DateTime.fromISO(_data["projectCreationDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.leave = _data["leave"];
            this.isAdmin = _data["isAdmin"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            this.unReadCount = _data["unReadCount"];
            this.isNextLevelClient = _data["isNextLevelClient"];
            this.employeeId = _data["employeeId"];
            this.userStatusId = _data["userStatusId"];
            if (Array.isArray(_data["dateWiseTimesheetIds"])) {
                this.dateWiseTimesheetIds = [] as any;
                for (let item of _data["dateWiseTimesheetIds"])
                    this.dateWiseTimesheetIds!.push(TimesheetIdsDateWise.fromJS(item));
            }
            this.employeeProjectStartDate = _data["employeeProjectStartDate"] ? DateTime.fromISO(_data["employeeProjectStartDate"].toString()) : undefined as any;
            this.employeeProjectEndDate = _data["employeeProjectEndDate"] ? DateTime.fromISO(_data["employeeProjectEndDate"].toString()) : undefined as any;
            this.isRejectedForMyTimesheetLevelFlag = _data["isRejectedForMyTimesheetLevelFlag"];
            if (Array.isArray(_data["timesheetApprovalDtos"])) {
                this.timesheetApprovalDtos = [] as any;
                for (let item of _data["timesheetApprovalDtos"])
                    this.timesheetApprovalDtos!.push(TimesheetApprovalDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TimeSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitedDate"] = this.submitedDate ? this.submitedDate.toString() : undefined as any;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["requiredHours"] = this.requiredHours;
        data["submitedHours"] = this.submitedHours;
        data["billedHours"] = this.billedHours;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userProfileImage"] = this.userProfileImage;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["projectImage"] = this.projectImage;
        data["timesheetStatus"] = this.timesheetStatus;
        data["projectType"] = this.projectType;
        data["projectCurrentStatus"] = this.projectCurrentStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["projectCreationDate"] = this.projectCreationDate ? this.projectCreationDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["leave"] = this.leave;
        data["isAdmin"] = this.isAdmin;
        data["timesheetFrequency"] = this.timesheetFrequency;
        data["unReadCount"] = this.unReadCount;
        data["isNextLevelClient"] = this.isNextLevelClient;
        data["employeeId"] = this.employeeId;
        data["userStatusId"] = this.userStatusId;
        if (Array.isArray(this.dateWiseTimesheetIds)) {
            data["dateWiseTimesheetIds"] = [];
            for (let item of this.dateWiseTimesheetIds)
                data["dateWiseTimesheetIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["employeeProjectStartDate"] = this.employeeProjectStartDate ? this.employeeProjectStartDate.toString() : undefined as any;
        data["employeeProjectEndDate"] = this.employeeProjectEndDate ? this.employeeProjectEndDate.toString() : undefined as any;
        data["isRejectedForMyTimesheetLevelFlag"] = this.isRejectedForMyTimesheetLevelFlag;
        if (Array.isArray(this.timesheetApprovalDtos)) {
            data["timesheetApprovalDtos"] = [];
            for (let item of this.timesheetApprovalDtos)
                data["timesheetApprovalDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITimeSheetDto {
    submitedDate: DateTime | undefined;
    timeSheetDate: DateTime | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    requiredHours: string;
    submitedHours: string;
    billedHours: string;
    userId: number | undefined;
    userName: string | undefined;
    userEmailAddress: string | undefined;
    userProfileImage: string | undefined;
    userRole: string[] | undefined;
    user: UserListDto;
    projectImage: string | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
    projectType: ProjectBillingType;
    projectCurrentStatus: ProjectStatus;
    fromDate: DateTime;
    toDate: DateTime;
    projectCreationDate: DateTime | undefined;
    projectEndDate: DateTime | undefined;
    leave: number;
    isAdmin: boolean;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    unReadCount: number;
    isNextLevelClient: boolean;
    employeeId: string | undefined;
    userStatusId: UserStatusEnum;
    dateWiseTimesheetIds: TimesheetIdsDateWise[] | undefined;
    employeeProjectStartDate: DateTime | undefined;
    employeeProjectEndDate: DateTime | undefined;
    isRejectedForMyTimesheetLevelFlag: boolean;
    timesheetApprovalDtos: TimesheetApprovalDto[] | undefined;
    id: number;
}

export enum TimesheetAndApprovalStatusEnum {
    Approved = 1,
    Pending = 2,
    Rejected = 3,
    OverdueForApproval = 4,
    NotSubmitted = 5,
    OnLeave = 6,
}

export class TimesheetApprovalDto implements ITimesheetApprovalDto {
    userName!: string | undefined;
    userImage!: string | undefined;
    timesheetSendDate!: DateTime | undefined;
    approvalName!: string | undefined;
    approvalImage!: string | undefined;
    approvalRole!: string[] | undefined;
    approvalLastModificationDate!: DateTime | undefined;
    approvalStatus!: TimesheetAndApprovalStatusEnum;
    isCurrentTimesheetApprovedApproval!: boolean;
    sequenceId!: number | undefined;
    timesheetId!: number | undefined;

    constructor(data?: ITimesheetApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.timesheetSendDate = _data["timesheetSendDate"] ? DateTime.fromISO(_data["timesheetSendDate"].toString()) : undefined as any;
            this.approvalName = _data["approvalName"];
            this.approvalImage = _data["approvalImage"];
            if (Array.isArray(_data["approvalRole"])) {
                this.approvalRole = [] as any;
                for (let item of _data["approvalRole"])
                    this.approvalRole!.push(item);
            }
            this.approvalLastModificationDate = _data["approvalLastModificationDate"] ? DateTime.fromISO(_data["approvalLastModificationDate"].toString()) : undefined as any;
            this.approvalStatus = _data["approvalStatus"];
            this.isCurrentTimesheetApprovedApproval = _data["isCurrentTimesheetApprovedApproval"];
            this.sequenceId = _data["sequenceId"];
            this.timesheetId = _data["timesheetId"];
        }
    }

    static fromJS(data: any): TimesheetApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["timesheetSendDate"] = this.timesheetSendDate ? this.timesheetSendDate.toString() : undefined as any;
        data["approvalName"] = this.approvalName;
        data["approvalImage"] = this.approvalImage;
        if (Array.isArray(this.approvalRole)) {
            data["approvalRole"] = [];
            for (let item of this.approvalRole)
                data["approvalRole"].push(item);
        }
        data["approvalLastModificationDate"] = this.approvalLastModificationDate ? this.approvalLastModificationDate.toString() : undefined as any;
        data["approvalStatus"] = this.approvalStatus;
        data["isCurrentTimesheetApprovedApproval"] = this.isCurrentTimesheetApprovedApproval;
        data["sequenceId"] = this.sequenceId;
        data["timesheetId"] = this.timesheetId;
        return data;
    }
}

export interface ITimesheetApprovalDto {
    userName: string | undefined;
    userImage: string | undefined;
    timesheetSendDate: DateTime | undefined;
    approvalName: string | undefined;
    approvalImage: string | undefined;
    approvalRole: string[] | undefined;
    approvalLastModificationDate: DateTime | undefined;
    approvalStatus: TimesheetAndApprovalStatusEnum;
    isCurrentTimesheetApprovedApproval: boolean;
    sequenceId: number | undefined;
    timesheetId: number | undefined;
}

export class TimesheetApprovalHistoryDto implements ITimesheetApprovalHistoryDto {
    userName!: string | undefined;
    userImage!: string | undefined;
    approvalName!: string | undefined;
    approvalImage!: string | undefined;
    sequenceId!: number | undefined;
    isCurrentTimesheetApprovedApproval!: boolean;
    timesheetSendDate!: DateTime | undefined;
    approvalLastModificationDate!: DateTime | undefined;
    approvalStatus!: TimesheetAndApprovalStatusEnum;
    approvalRole!: string[] | undefined;

    constructor(data?: ITimesheetApprovalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.approvalName = _data["approvalName"];
            this.approvalImage = _data["approvalImage"];
            this.sequenceId = _data["sequenceId"];
            this.isCurrentTimesheetApprovedApproval = _data["isCurrentTimesheetApprovedApproval"];
            this.timesheetSendDate = _data["timesheetSendDate"] ? DateTime.fromISO(_data["timesheetSendDate"].toString()) : undefined as any;
            this.approvalLastModificationDate = _data["approvalLastModificationDate"] ? DateTime.fromISO(_data["approvalLastModificationDate"].toString()) : undefined as any;
            this.approvalStatus = _data["approvalStatus"];
            if (Array.isArray(_data["approvalRole"])) {
                this.approvalRole = [] as any;
                for (let item of _data["approvalRole"])
                    this.approvalRole!.push(item);
            }
        }
    }

    static fromJS(data: any): TimesheetApprovalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetApprovalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["approvalName"] = this.approvalName;
        data["approvalImage"] = this.approvalImage;
        data["sequenceId"] = this.sequenceId;
        data["isCurrentTimesheetApprovedApproval"] = this.isCurrentTimesheetApprovedApproval;
        data["timesheetSendDate"] = this.timesheetSendDate ? this.timesheetSendDate.toString() : undefined as any;
        data["approvalLastModificationDate"] = this.approvalLastModificationDate ? this.approvalLastModificationDate.toString() : undefined as any;
        data["approvalStatus"] = this.approvalStatus;
        if (Array.isArray(this.approvalRole)) {
            data["approvalRole"] = [];
            for (let item of this.approvalRole)
                data["approvalRole"].push(item);
        }
        return data;
    }
}

export interface ITimesheetApprovalHistoryDto {
    userName: string | undefined;
    userImage: string | undefined;
    approvalName: string | undefined;
    approvalImage: string | undefined;
    sequenceId: number | undefined;
    isCurrentTimesheetApprovedApproval: boolean;
    timesheetSendDate: DateTime | undefined;
    approvalLastModificationDate: DateTime | undefined;
    approvalStatus: TimesheetAndApprovalStatusEnum;
    approvalRole: string[] | undefined;
}

export class TimesheetApprovalPermissionDto implements ITimesheetApprovalPermissionDto {
    tenantId!: number | undefined;
    name!: string[] | undefined;
    isGranted!: boolean;
    discriminator!: string | undefined;
    roleId!: number | undefined;
    userId!: number | undefined;
    creationTime!: DateTime;
    isCreate!: boolean;

    constructor(data?: ITimesheetApprovalPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(item);
            }
            this.isGranted = _data["isGranted"];
            this.discriminator = _data["discriminator"];
            this.roleId = _data["roleId"];
            this.userId = _data["userId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.isCreate = _data["isCreate"];
        }
    }

    static fromJS(data: any): TimesheetApprovalPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetApprovalPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        data["isGranted"] = this.isGranted;
        data["discriminator"] = this.discriminator;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["isCreate"] = this.isCreate;
        return data;
    }
}

export interface ITimesheetApprovalPermissionDto {
    tenantId: number | undefined;
    name: string[] | undefined;
    isGranted: boolean;
    discriminator: string | undefined;
    roleId: number | undefined;
    userId: number | undefined;
    creationTime: DateTime;
    isCreate: boolean;
}

export class TimesheetCompletionStatusDto implements ITimesheetCompletionStatusDto {
    allTimesheetsCompleted!: boolean;
    unfilledProjects!: ProjectTimesheetStatusDto[] | undefined;

    constructor(data?: ITimesheetCompletionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allTimesheetsCompleted = _data["allTimesheetsCompleted"];
            if (Array.isArray(_data["unfilledProjects"])) {
                this.unfilledProjects = [] as any;
                for (let item of _data["unfilledProjects"])
                    this.unfilledProjects!.push(ProjectTimesheetStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetCompletionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetCompletionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allTimesheetsCompleted"] = this.allTimesheetsCompleted;
        if (Array.isArray(this.unfilledProjects)) {
            data["unfilledProjects"] = [];
            for (let item of this.unfilledProjects)
                data["unfilledProjects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimesheetCompletionStatusDto {
    allTimesheetsCompleted: boolean;
    unfilledProjects: ProjectTimesheetStatusDto[] | undefined;
}

export class TimesheetFrequencyDto implements ITimesheetFrequencyDto {
    submissionFrequency!: ProjectTimesheetFrequencyEnum;
    weeklyMinHrs!: number;
    loggedHours!: number;

    constructor(data?: ITimesheetFrequencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionFrequency = _data["submissionFrequency"];
            this.weeklyMinHrs = _data["weeklyMinHrs"];
            this.loggedHours = _data["loggedHours"];
        }
    }

    static fromJS(data: any): TimesheetFrequencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetFrequencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionFrequency"] = this.submissionFrequency;
        data["weeklyMinHrs"] = this.weeklyMinHrs;
        data["loggedHours"] = this.loggedHours;
        return data;
    }
}

export interface ITimesheetFrequencyDto {
    submissionFrequency: ProjectTimesheetFrequencyEnum;
    weeklyMinHrs: number;
    loggedHours: number;
}

export class TimesheetIdsDateWise implements ITimesheetIdsDateWise {
    timesheetId!: number;
    timesheetSubmitDate!: DateTime;
    isAccess!: boolean;
    approvalLevelTimesheetStatus!: TimesheetAndApprovalStatusEnum;
    fromDate!: DateTime;
    toDate!: DateTime;
    userId!: number | undefined;
    projectId!: number | undefined;

    constructor(data?: ITimesheetIdsDateWise) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheetId = _data["timesheetId"];
            this.timesheetSubmitDate = _data["timesheetSubmitDate"] ? DateTime.fromISO(_data["timesheetSubmitDate"].toString()) : undefined as any;
            this.isAccess = _data["isAccess"];
            this.approvalLevelTimesheetStatus = _data["approvalLevelTimesheetStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): TimesheetIdsDateWise {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetIdsDateWise();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheetId"] = this.timesheetId;
        data["timesheetSubmitDate"] = this.timesheetSubmitDate ? this.timesheetSubmitDate.toString() : undefined as any;
        data["isAccess"] = this.isAccess;
        data["approvalLevelTimesheetStatus"] = this.approvalLevelTimesheetStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ITimesheetIdsDateWise {
    timesheetId: number;
    timesheetSubmitDate: DateTime;
    isAccess: boolean;
    approvalLevelTimesheetStatus: TimesheetAndApprovalStatusEnum;
    fromDate: DateTime;
    toDate: DateTime;
    userId: number | undefined;
    projectId: number | undefined;
}

export class TimesheetIdsDateWiseDto implements ITimesheetIdsDateWiseDto {
    timesheetId!: number;
    timesheetSubmitDate!: DateTime;
    isAccess!: boolean;
    approvalLevelTimesheetStatus!: TimesheetAndApprovalStatusEnum;
    fromDate!: DateTime;
    toDate!: DateTime;
    userId!: number | undefined;
    projectId!: number | undefined;

    constructor(data?: ITimesheetIdsDateWiseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheetId = _data["timesheetId"];
            this.timesheetSubmitDate = _data["timesheetSubmitDate"] ? DateTime.fromISO(_data["timesheetSubmitDate"].toString()) : undefined as any;
            this.isAccess = _data["isAccess"];
            this.approvalLevelTimesheetStatus = _data["approvalLevelTimesheetStatus"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): TimesheetIdsDateWiseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetIdsDateWiseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheetId"] = this.timesheetId;
        data["timesheetSubmitDate"] = this.timesheetSubmitDate ? this.timesheetSubmitDate.toString() : undefined as any;
        data["isAccess"] = this.isAccess;
        data["approvalLevelTimesheetStatus"] = this.approvalLevelTimesheetStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ITimesheetIdsDateWiseDto {
    timesheetId: number;
    timesheetSubmitDate: DateTime;
    isAccess: boolean;
    approvalLevelTimesheetStatus: TimesheetAndApprovalStatusEnum;
    fromDate: DateTime;
    toDate: DateTime;
    userId: number | undefined;
    projectId: number | undefined;
}

export class TimesheetLevelApprovalDto implements ITimesheetLevelApprovalDto {
    userName!: string | undefined;
    userImage!: string | undefined;
    timesheetSendDate!: DateTime | undefined;
    approvalName!: string | undefined;
    approvalImage!: string | undefined;
    approvalRole!: string[] | undefined;
    approvalLastModificationDate!: DateTime | undefined;
    approvalStatus!: TimesheetAndApprovalStatusEnum;
    isCurrentTimesheetApprovedApproval!: boolean;
    sequenceId!: number | undefined;
    timesheetId!: number | undefined;

    constructor(data?: ITimesheetLevelApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.timesheetSendDate = _data["timesheetSendDate"] ? DateTime.fromISO(_data["timesheetSendDate"].toString()) : undefined as any;
            this.approvalName = _data["approvalName"];
            this.approvalImage = _data["approvalImage"];
            if (Array.isArray(_data["approvalRole"])) {
                this.approvalRole = [] as any;
                for (let item of _data["approvalRole"])
                    this.approvalRole!.push(item);
            }
            this.approvalLastModificationDate = _data["approvalLastModificationDate"] ? DateTime.fromISO(_data["approvalLastModificationDate"].toString()) : undefined as any;
            this.approvalStatus = _data["approvalStatus"];
            this.isCurrentTimesheetApprovedApproval = _data["isCurrentTimesheetApprovedApproval"];
            this.sequenceId = _data["sequenceId"];
            this.timesheetId = _data["timesheetId"];
        }
    }

    static fromJS(data: any): TimesheetLevelApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetLevelApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["timesheetSendDate"] = this.timesheetSendDate ? this.timesheetSendDate.toString() : undefined as any;
        data["approvalName"] = this.approvalName;
        data["approvalImage"] = this.approvalImage;
        if (Array.isArray(this.approvalRole)) {
            data["approvalRole"] = [];
            for (let item of this.approvalRole)
                data["approvalRole"].push(item);
        }
        data["approvalLastModificationDate"] = this.approvalLastModificationDate ? this.approvalLastModificationDate.toString() : undefined as any;
        data["approvalStatus"] = this.approvalStatus;
        data["isCurrentTimesheetApprovedApproval"] = this.isCurrentTimesheetApprovedApproval;
        data["sequenceId"] = this.sequenceId;
        data["timesheetId"] = this.timesheetId;
        return data;
    }
}

export interface ITimesheetLevelApprovalDto {
    userName: string | undefined;
    userImage: string | undefined;
    timesheetSendDate: DateTime | undefined;
    approvalName: string | undefined;
    approvalImage: string | undefined;
    approvalRole: string[] | undefined;
    approvalLastModificationDate: DateTime | undefined;
    approvalStatus: TimesheetAndApprovalStatusEnum;
    isCurrentTimesheetApprovedApproval: boolean;
    sequenceId: number | undefined;
    timesheetId: number | undefined;
}

export enum TimesheetReportGroupByType {
    Overall_Summary = 1,
    Employee_Wise = 2,
    Date_Wise = 3,
    WorkingSatus = 4,
    NotFillTimesheet = 5,
    DateWiseNew = 6,
    TaskWise = 7,
    ProjectAllocation = 8,
    ProjectionvsActual = 9,
}

export enum TimesheetReportSaveAsType {
    Export_To_Excel = 1,
    Export_To_PDF = 2,
}

export class TimesheetStatesDto implements ITimesheetStatesDto {
    minHrs!: number;
    loggedHours!: number;
    billedHours!: number;
    submissionFrequency!: ProjectTimesheetFrequencyEnum;
    invoiceTimesheetSubmissionFrequency!: ProjectTimesheetFrequencyEnum;

    constructor(data?: ITimesheetStatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minHrs = _data["minHrs"];
            this.loggedHours = _data["loggedHours"];
            this.billedHours = _data["billedHours"];
            this.submissionFrequency = _data["submissionFrequency"];
            this.invoiceTimesheetSubmissionFrequency = _data["invoiceTimesheetSubmissionFrequency"];
        }
    }

    static fromJS(data: any): TimesheetStatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetStatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minHrs"] = this.minHrs;
        data["loggedHours"] = this.loggedHours;
        data["billedHours"] = this.billedHours;
        data["submissionFrequency"] = this.submissionFrequency;
        data["invoiceTimesheetSubmissionFrequency"] = this.invoiceTimesheetSubmissionFrequency;
        return data;
    }
}

export interface ITimesheetStatesDto {
    minHrs: number;
    loggedHours: number;
    billedHours: number;
    submissionFrequency: ProjectTimesheetFrequencyEnum;
    invoiceTimesheetSubmissionFrequency: ProjectTimesheetFrequencyEnum;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class TrackWorkingDetailCreateOrEditDto implements ITrackWorkingDetailCreateOrEditDto {
    tenantId!: number;
    locationSettingId!: number | undefined;
    isWorkMon!: boolean;
    isWorkTue!: boolean;
    isWorkWed!: boolean;
    isWorkThu!: boolean;
    isWorkFri!: boolean;
    isWorkSat!: boolean;
    isWorkSun!: boolean;
    isWorkFlex!: boolean;
    workStartDate!: DateTime | undefined;
    workEndDate!: DateTime | undefined;
    isTrackMon!: boolean;
    isTrackTue!: boolean;
    isTrackWed!: boolean;
    isTrackThu!: boolean;
    isTrackFri!: boolean;
    isTrackSat!: boolean;
    isTrackSun!: boolean;
    trackStartDate!: DateTime | undefined;
    trackEndDate!: DateTime | undefined;
    timeZone!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITrackWorkingDetailCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.locationSettingId = _data["locationSettingId"];
            this.isWorkMon = _data["isWorkMon"];
            this.isWorkTue = _data["isWorkTue"];
            this.isWorkWed = _data["isWorkWed"];
            this.isWorkThu = _data["isWorkThu"];
            this.isWorkFri = _data["isWorkFri"];
            this.isWorkSat = _data["isWorkSat"];
            this.isWorkSun = _data["isWorkSun"];
            this.isWorkFlex = _data["isWorkFlex"];
            this.workStartDate = _data["workStartDate"] ? DateTime.fromISO(_data["workStartDate"].toString()) : undefined as any;
            this.workEndDate = _data["workEndDate"] ? DateTime.fromISO(_data["workEndDate"].toString()) : undefined as any;
            this.isTrackMon = _data["isTrackMon"];
            this.isTrackTue = _data["isTrackTue"];
            this.isTrackWed = _data["isTrackWed"];
            this.isTrackThu = _data["isTrackThu"];
            this.isTrackFri = _data["isTrackFri"];
            this.isTrackSat = _data["isTrackSat"];
            this.isTrackSun = _data["isTrackSun"];
            this.trackStartDate = _data["trackStartDate"] ? DateTime.fromISO(_data["trackStartDate"].toString()) : undefined as any;
            this.trackEndDate = _data["trackEndDate"] ? DateTime.fromISO(_data["trackEndDate"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrackWorkingDetailCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackWorkingDetailCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["locationSettingId"] = this.locationSettingId;
        data["isWorkMon"] = this.isWorkMon;
        data["isWorkTue"] = this.isWorkTue;
        data["isWorkWed"] = this.isWorkWed;
        data["isWorkThu"] = this.isWorkThu;
        data["isWorkFri"] = this.isWorkFri;
        data["isWorkSat"] = this.isWorkSat;
        data["isWorkSun"] = this.isWorkSun;
        data["isWorkFlex"] = this.isWorkFlex;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toString() : undefined as any;
        data["workEndDate"] = this.workEndDate ? this.workEndDate.toString() : undefined as any;
        data["isTrackMon"] = this.isTrackMon;
        data["isTrackTue"] = this.isTrackTue;
        data["isTrackWed"] = this.isTrackWed;
        data["isTrackThu"] = this.isTrackThu;
        data["isTrackFri"] = this.isTrackFri;
        data["isTrackSat"] = this.isTrackSat;
        data["isTrackSun"] = this.isTrackSun;
        data["trackStartDate"] = this.trackStartDate ? this.trackStartDate.toString() : undefined as any;
        data["trackEndDate"] = this.trackEndDate ? this.trackEndDate.toString() : undefined as any;
        data["timeZone"] = this.timeZone;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrackWorkingDetailCreateOrEditDto {
    tenantId: number;
    locationSettingId: number | undefined;
    isWorkMon: boolean;
    isWorkTue: boolean;
    isWorkWed: boolean;
    isWorkThu: boolean;
    isWorkFri: boolean;
    isWorkSat: boolean;
    isWorkSun: boolean;
    isWorkFlex: boolean;
    workStartDate: DateTime | undefined;
    workEndDate: DateTime | undefined;
    isTrackMon: boolean;
    isTrackTue: boolean;
    isTrackWed: boolean;
    isTrackThu: boolean;
    isTrackFri: boolean;
    isTrackSat: boolean;
    isTrackSun: boolean;
    trackStartDate: DateTime | undefined;
    trackEndDate: DateTime | undefined;
    timeZone: string | undefined;
    id: number | undefined;
}

export class TrackedApplicationByDateDto implements ITrackedApplicationByDateDto {
    trackedDate!: DateTime;
    applications!: TrackedApplicationDataDto[] | undefined;

    constructor(data?: ITrackedApplicationByDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedDate = _data["trackedDate"] ? DateTime.fromISO(_data["trackedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(TrackedApplicationDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackedApplicationByDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedApplicationByDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedDate"] = this.trackedDate ? this.trackedDate.toString() : undefined as any;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrackedApplicationByDateDto {
    trackedDate: DateTime;
    applications: TrackedApplicationDataDto[] | undefined;
}

export class TrackedApplicationDataDto implements ITrackedApplicationDataDto {
    applicationName!: string | undefined;
    appIcon!: string | undefined;
    timeSpent!: string;
    productivityTypeId!: number | undefined;
    startDateTime!: DateTime;

    constructor(data?: ITrackedApplicationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.appIcon = _data["appIcon"];
            this.timeSpent = _data["timeSpent"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TrackedApplicationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedApplicationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["appIcon"] = this.appIcon;
        data["timeSpent"] = this.timeSpent;
        data["productivityTypeId"] = this.productivityTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        return data;
    }
}

export interface ITrackedApplicationDataDto {
    applicationName: string | undefined;
    appIcon: string | undefined;
    timeSpent: string;
    productivityTypeId: number | undefined;
    startDateTime: DateTime;
}

export class TrailRequesDto implements ITrailRequesDto {
    emailAddress!: string | undefined;
    tenancyName!: string | undefined;
    editionName!: string | undefined;
    createDate!: DateTime;
    id!: number;

    constructor(data?: ITrailRequesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.tenancyName = _data["tenancyName"];
            this.editionName = _data["editionName"];
            this.createDate = _data["createDate"] ? DateTime.fromISO(_data["createDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrailRequesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrailRequesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["tenancyName"] = this.tenancyName;
        data["editionName"] = this.editionName;
        data["createDate"] = this.createDate ? this.createDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrailRequesDto {
    emailAddress: string | undefined;
    tenancyName: string | undefined;
    editionName: string | undefined;
    createDate: DateTime;
    id: number;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
    accessToken!: string | undefined;
    accessTokenSecret!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ITwitterGetAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenSecret = _data["accessTokenSecret"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): TwitterGetAccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetAccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenSecret"] = this.accessTokenSecret;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITwitterGetAccessTokenResponse {
    accessToken: string | undefined;
    accessTokenSecret: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
    token!: string | undefined;
    secret!: string | undefined;
    confirmed!: boolean;
    redirectUrl!: string | undefined;

    constructor(data?: ITwitterGetRequestTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.secret = _data["secret"];
            this.confirmed = _data["confirmed"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TwitterGetRequestTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetRequestTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["secret"] = this.secret;
        data["confirmed"] = this.confirmed;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITwitterGetRequestTokenResponse {
    token: string | undefined;
    secret: string | undefined;
    confirmed: boolean;
    redirectUrl: string | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : undefined as any;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : undefined as any;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UniversalSearchItemDto implements IUniversalSearchItemDto {
    id!: string | undefined;
    category!: string | undefined;
    title!: string | undefined;
    subtitle!: string | undefined;
    route!: string | undefined;
    navigationState!: { [key: string]: any; } | undefined;
    queryParams!: { [key: string]: string; } | undefined;

    constructor(data?: IUniversalSearchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.route = _data["route"];
            if (_data["navigationState"]) {
                this.navigationState = {} as any;
                for (let key in _data["navigationState"]) {
                    if (_data["navigationState"].hasOwnProperty(key))
                        (this.navigationState as any)![key] = _data["navigationState"][key];
                }
            }
            if (_data["queryParams"]) {
                this.queryParams = {} as any;
                for (let key in _data["queryParams"]) {
                    if (_data["queryParams"].hasOwnProperty(key))
                        (this.queryParams as any)![key] = _data["queryParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): UniversalSearchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UniversalSearchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["route"] = this.route;
        if (this.navigationState) {
            data["navigationState"] = {};
            for (let key in this.navigationState) {
                if (this.navigationState.hasOwnProperty(key))
                    (data["navigationState"] as any)[key] = (this.navigationState as any)[key];
            }
        }
        if (this.queryParams) {
            data["queryParams"] = {};
            for (let key in this.queryParams) {
                if (this.queryParams.hasOwnProperty(key))
                    (data["queryParams"] as any)[key] = (this.queryParams as any)[key];
            }
        }
        return data;
    }
}

export interface IUniversalSearchItemDto {
    id: string | undefined;
    category: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    route: string | undefined;
    navigationState: { [key: string]: any; } | undefined;
    queryParams: { [key: string]: string; } | undefined;
}

export class UniversalSearchResultDto implements IUniversalSearchResultDto {
    items!: UniversalSearchItemDto[] | undefined;

    constructor(data?: IUniversalSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UniversalSearchItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UniversalSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UniversalSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUniversalSearchResultDto {
    items: UniversalSearchItemDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateDesignationUnitInput implements IUpdateDesignationUnitInput {
    id!: number;
    displayName!: string;
    designationDescription!: DesignationDescriptionDto;

    constructor(data?: IUpdateDesignationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.designationDescription = _data["designationDescription"] ? DesignationDescriptionDto.fromJS(_data["designationDescription"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateDesignationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDesignationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["designationDescription"] = this.designationDescription ? this.designationDescription.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateDesignationUnitInput {
    id: number;
    displayName: string;
    designationDescription: DesignationDescriptionDto;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;
    oragnizationDescription!: OragnizationDescriptionDto;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.oragnizationDescription = _data["oragnizationDescription"] ? OragnizationDescriptionDto.fromJS(_data["oragnizationDescription"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["oragnizationDescription"] = this.oragnizationDescription ? this.oragnizationDescription.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
    oragnizationDescription: OragnizationDescriptionDto;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    useGravatarProfilePicture!: boolean;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
    useGravatarProfilePicture: boolean;
}

export class UpdateProjectTimesheetTimeLineDto implements IUpdateProjectTimesheetTimeLineDto {
    existingApprovalId!: number;
    newApprovalId!: number;
    action!: string | undefined;
    sequenceNo!: number;

    constructor(data?: IUpdateProjectTimesheetTimeLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingApprovalId = _data["existingApprovalId"];
            this.newApprovalId = _data["newApprovalId"];
            this.action = _data["action"];
            this.sequenceNo = _data["sequenceNo"];
        }
    }

    static fromJS(data: any): UpdateProjectTimesheetTimeLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectTimesheetTimeLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingApprovalId"] = this.existingApprovalId;
        data["newApprovalId"] = this.newApprovalId;
        data["action"] = this.action;
        data["sequenceNo"] = this.sequenceNo;
        return data;
    }
}

export interface IUpdateProjectTimesheetTimeLineDto {
    existingApprovalId: number;
    newApprovalId: number;
    action: string | undefined;
    sequenceNo: number;
}

export class UpdateReminderSettingDto implements IUpdateReminderSettingDto {
    projectId!: number;
    isTimesheetReminderEnable!: boolean;
    isBackDatedTimesheetEnable!: boolean;

    constructor(data?: IUpdateReminderSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isTimesheetReminderEnable = _data["isTimesheetReminderEnable"];
            this.isBackDatedTimesheetEnable = _data["isBackDatedTimesheetEnable"];
        }
    }

    static fromJS(data: any): UpdateReminderSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReminderSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isTimesheetReminderEnable"] = this.isTimesheetReminderEnable;
        data["isBackDatedTimesheetEnable"] = this.isBackDatedTimesheetEnable;
        return data;
    }
}

export interface IUpdateReminderSettingDto {
    projectId: number;
    isTimesheetReminderEnable: boolean;
    isBackDatedTimesheetEnable: boolean;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UpdateThemeDto implements IUpdateThemeDto {
    themeMode!: ThemeMode;

    constructor(data?: IUpdateThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.themeMode = _data["themeMode"];
        }
    }

    static fromJS(data: any): UpdateThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeMode"] = this.themeMode;
        return data;
    }
}

export interface IUpdateThemeDto {
    themeMode: ThemeMode;
}

export class UpdateUserDetailsDto implements IUpdateUserDetailsDto {
    userIds!: number[] | undefined;
    tenantId!: number;
    lastUpdatedDate!: DateTime;
    userType!: UserType;

    constructor(data?: IUpdateUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.tenantId = _data["tenantId"];
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? DateTime.fromISO(_data["lastUpdatedDate"].toString()) : undefined as any;
            this.userType = _data["userType"];
        }
    }

    static fromJS(data: any): UpdateUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["tenantId"] = this.tenantId;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toString() : undefined as any;
        data["userType"] = this.userType;
        return data;
    }
}

export interface IUpdateUserDetailsDto {
    userIds: number[] | undefined;
    tenantId: number;
    lastUpdatedDate: DateTime;
    userType: UserType;
}

export class UpdateUserForFlutter implements IUpdateUserForFlutter {
    userId!: number;
    tenantId!: number;
    surname!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IUpdateUserForFlutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UpdateUserForFlutter {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserForFlutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IUpdateUserForFlutter {
    userId: number;
    tenantId: number;
    surname: string | undefined;
    userName: string | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UploadProjectDocumentInput implements IUploadProjectDocumentInput {
    projectId!: number;
    tenantId!: number;
    fileName!: string | undefined;
    fileBase64String!: string | undefined;
    contentType!: string | undefined;
    fileSize!: number;

    constructor(data?: IUploadProjectDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.tenantId = _data["tenantId"];
            this.fileName = _data["fileName"];
            this.fileBase64String = _data["fileBase64String"];
            this.contentType = _data["contentType"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): UploadProjectDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProjectDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["tenantId"] = this.tenantId;
        data["fileName"] = this.fileName;
        data["fileBase64String"] = this.fileBase64String;
        data["contentType"] = this.contentType;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IUploadProjectDocumentInput {
    projectId: number;
    tenantId: number;
    fileName: string | undefined;
    fileBase64String: string | undefined;
    contentType: string | undefined;
    fileSize: number;
}

export class UploadTimeAndAttendanceDataOnBlobDto implements IUploadTimeAndAttendanceDataOnBlobDto {
    fileData!: string | undefined;
    fileName!: string | undefined;
    tenantId!: number;

    constructor(data?: IUploadTimeAndAttendanceDataOnBlobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileData = _data["fileData"];
            this.fileName = _data["fileName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UploadTimeAndAttendanceDataOnBlobDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadTimeAndAttendanceDataOnBlobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileData"] = this.fileData;
        data["fileName"] = this.fileName;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUploadTimeAndAttendanceDataOnBlobDto {
    fileData: string | undefined;
    fileName: string | undefined;
    tenantId: number;
}

export class UploadUserCvDto implements IUploadUserCvDto {
    userId!: number;
    cvFileName!: string;
    cvFilePath!: string;
    cvFileType!: string | undefined;
    cvFileSize!: number;

    constructor(data?: IUploadUserCvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.cvFileName = _data["cvFileName"];
            this.cvFilePath = _data["cvFilePath"];
            this.cvFileType = _data["cvFileType"];
            this.cvFileSize = _data["cvFileSize"];
        }
    }

    static fromJS(data: any): UploadUserCvDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadUserCvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["cvFileName"] = this.cvFileName;
        data["cvFilePath"] = this.cvFilePath;
        data["cvFileType"] = this.cvFileType;
        data["cvFileSize"] = this.cvFileSize;
        return data;
    }
}

export interface IUploadUserCvDto {
    userId: number;
    cvFileName: string;
    cvFilePath: string;
    cvFileType: string | undefined;
    cvFileSize: number;
}

export class UsagePerEmployeeDto implements IUsagePerEmployeeDto {
    userId!: number;
    userName!: string | undefined;
    totalTimeSpend!: string;
    teamName!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    orgnizationId!: number[] | undefined;
    projectId!: (number | undefined)[] | undefined;
    profileImage!: string | undefined;

    constructor(data?: IUsagePerEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.totalTimeSpend = _data["totalTimeSpend"];
            this.teamName = _data["teamName"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["orgnizationId"])) {
                this.orgnizationId = [] as any;
                for (let item of _data["orgnizationId"])
                    this.orgnizationId!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): UsagePerEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsagePerEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["totalTimeSpend"] = this.totalTimeSpend;
        data["teamName"] = this.teamName;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        if (Array.isArray(this.orgnizationId)) {
            data["orgnizationId"] = [];
            for (let item of this.orgnizationId)
                data["orgnizationId"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IUsagePerEmployeeDto {
    userId: number;
    userName: string | undefined;
    totalTimeSpend: string;
    teamName: string | undefined;
    startDate: DateTime;
    endDate: DateTime;
    orgnizationId: number[] | undefined;
    projectId: (number | undefined)[] | undefined;
    profileImage: string | undefined;
}

export class User implements IUser {
    profilePictureId!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    signInTokenExpireTimeUtc!: DateTime | undefined;
    signInToken!: string | undefined;
    googleAuthenticatorKey!: string | undefined;
    organizationUnits!: UserOrganizationUnit[] | undefined;
    fullName!: string | undefined;
    profileImage!: string | undefined;
    addressLine1!: string | undefined;
    addressLine2!: string | undefined;
    city!: number;
    state!: number;
    countryId!: number | undefined;
    managerId!: number | undefined;
    organizationId!: number;
    isArchived!: boolean;
    birthDate!: DateTime | undefined;
    reportingLocation!: number;
    clientPassword!: string | undefined;
    userTimeZone!: string | undefined;
    employeeId!: string | undefined;
    designationId!: number | undefined;
    companyJoinDate!: DateTime | undefined;
    emailSentDate!: DateTime | undefined;
    itpJoiningDate!: DateTime | undefined;
    onProbation!: boolean;
    isAutomatedTimesheetEnabled!: boolean;
    cost!: number | undefined;
    readonly kekaUserId!: string | undefined;
    themeMode!: ThemeMode;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    authenticationSource!: string | undefined;
    userName!: string;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"] ? DateTime.fromISO(_data["signInTokenExpireTimeUtc"].toString()) : undefined as any;
            this.signInToken = _data["signInToken"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(UserOrganizationUnit.fromJS(item));
            }
            this.fullName = _data["fullName"];
            this.profileImage = _data["profileImage"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.countryId = _data["countryId"];
            this.managerId = _data["managerId"];
            this.organizationId = _data["organizationId"];
            this.isArchived = _data["isArchived"];
            this.birthDate = _data["birthDate"] ? DateTime.fromISO(_data["birthDate"].toString()) : undefined as any;
            this.reportingLocation = _data["reportingLocation"];
            this.clientPassword = _data["clientPassword"];
            this.userTimeZone = _data["userTimeZone"];
            this.employeeId = _data["employeeId"];
            this.designationId = _data["designationId"];
            this.companyJoinDate = _data["companyJoinDate"] ? DateTime.fromISO(_data["companyJoinDate"].toString()) : undefined as any;
            this.emailSentDate = _data["emailSentDate"] ? DateTime.fromISO(_data["emailSentDate"].toString()) : undefined as any;
            this.itpJoiningDate = _data["itpJoiningDate"] ? DateTime.fromISO(_data["itpJoiningDate"].toString()) : undefined as any;
            this.onProbation = _data["onProbation"];
            this.isAutomatedTimesheetEnabled = _data["isAutomatedTimesheetEnabled"];
            this.cost = _data["cost"];
            (this as any).kekaUserId = _data["kekaUserId"];
            this.themeMode = _data["themeMode"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : undefined as any;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : undefined as any;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toString() : undefined as any;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item ? item.toJSON() : undefined as any);
        }
        data["fullName"] = this.fullName;
        data["profileImage"] = this.profileImage;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["countryId"] = this.countryId;
        data["managerId"] = this.managerId;
        data["organizationId"] = this.organizationId;
        data["isArchived"] = this.isArchived;
        data["birthDate"] = this.birthDate ? this.birthDate.toString() : undefined as any;
        data["reportingLocation"] = this.reportingLocation;
        data["clientPassword"] = this.clientPassword;
        data["userTimeZone"] = this.userTimeZone;
        data["employeeId"] = this.employeeId;
        data["designationId"] = this.designationId;
        data["companyJoinDate"] = this.companyJoinDate ? this.companyJoinDate.toString() : undefined as any;
        data["emailSentDate"] = this.emailSentDate ? this.emailSentDate.toString() : undefined as any;
        data["itpJoiningDate"] = this.itpJoiningDate ? this.itpJoiningDate.toString() : undefined as any;
        data["onProbation"] = this.onProbation;
        data["isAutomatedTimesheetEnabled"] = this.isAutomatedTimesheetEnabled;
        data["cost"] = this.cost;
        data["kekaUserId"] = this.kekaUserId;
        data["themeMode"] = this.themeMode;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined as any;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : undefined as any;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUser {
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: DateTime | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    organizationUnits: UserOrganizationUnit[] | undefined;
    fullName: string | undefined;
    profileImage: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: number;
    state: number;
    countryId: number | undefined;
    managerId: number | undefined;
    organizationId: number;
    isArchived: boolean;
    birthDate: DateTime | undefined;
    reportingLocation: number;
    clientPassword: string | undefined;
    userTimeZone: string | undefined;
    employeeId: string | undefined;
    designationId: number | undefined;
    companyJoinDate: DateTime | undefined;
    emailSentDate: DateTime | undefined;
    itpJoiningDate: DateTime | undefined;
    onProbation: boolean;
    isAutomatedTimesheetEnabled: boolean;
    cost: number | undefined;
    kekaUserId: string | undefined;
    themeMode: ThemeMode;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserActiveWindowDetailDto implements IUserActiveWindowDetailDto {
    tenantId!: number | undefined;
    userId!: number;
    applicationName!: string | undefined;
    activeWindowTitle!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    dateTrackedFor!: string | undefined;

    constructor(data?: IUserActiveWindowDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.applicationName = _data["applicationName"];
            this.activeWindowTitle = _data["activeWindowTitle"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.dateTrackedFor = _data["dateTrackedFor"];
        }
    }

    static fromJS(data: any): UserActiveWindowDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActiveWindowDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["applicationName"] = this.applicationName;
        data["activeWindowTitle"] = this.activeWindowTitle;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["dateTrackedFor"] = this.dateTrackedFor;
        return data;
    }
}

export interface IUserActiveWindowDetailDto {
    tenantId: number | undefined;
    userId: number;
    applicationName: string | undefined;
    activeWindowTitle: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    dateTrackedFor: string | undefined;
}

export class UserActivityDtoForFlutter implements IUserActivityDtoForFlutter {
    applicationName!: string | undefined;
    applicationId!: number | undefined;
    applicationTypeId!: number | undefined;
    icon!: string | undefined;
    count!: string | undefined;
    spendTime!: string;
    agentApplicationId!: number;

    constructor(data?: IUserActivityDtoForFlutter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.applicationId = _data["applicationId"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.icon = _data["icon"];
            this.count = _data["count"];
            this.spendTime = _data["spendTime"];
            this.agentApplicationId = _data["agentApplicationId"];
        }
    }

    static fromJS(data: any): UserActivityDtoForFlutter {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDtoForFlutter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["applicationId"] = this.applicationId;
        data["applicationTypeId"] = this.applicationTypeId;
        data["icon"] = this.icon;
        data["count"] = this.count;
        data["spendTime"] = this.spendTime;
        data["agentApplicationId"] = this.agentApplicationId;
        return data;
    }
}

export interface IUserActivityDtoForFlutter {
    applicationName: string | undefined;
    applicationId: number | undefined;
    applicationTypeId: number | undefined;
    icon: string | undefined;
    count: string | undefined;
    spendTime: string;
    agentApplicationId: number;
}

export class UserActivityTemp implements IUserActivityTemp {
    tenantId!: number;
    userId!: number | undefined;
    user!: User;
    applicationName!: string | undefined;
    applicationId!: number | undefined;
    applications!: Applications;
    applicationTypeId!: number | undefined;
    applicationType!: ApplicationType;
    browserName!: string | undefined;
    browserId!: number | undefined;
    browser!: Browser;
    productivityTypeId!: number | undefined;
    productivityType!: ProductivityType;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    icon!: string | undefined;
    isWebSite!: boolean;
    parentWebURL!: string | undefined;
    webSiteIcon!: string | undefined;
    screenShotComments!: string | undefined;
    isAssigned!: boolean;
    totalTimeSpend!: string;
    projectId!: number | undefined;
    project!: Projects;
    userProjectTaskId!: number | undefined;
    userProjectTask!: UserProjectTask;
    description!: string | undefined;
    isManualTimeFlag!: number | undefined;
    internetProvider!: string | undefined;
    internetSpeed!: string | undefined;
    deviceTypeId!: number | undefined;
    deviceType!: DeviceType;
    latitude!: string | undefined;
    longitude!: string | undefined;
    sublocality!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserActivityTemp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.applicationName = _data["applicationName"];
            this.applicationId = _data["applicationId"];
            this.applications = _data["applications"] ? Applications.fromJS(_data["applications"]) : undefined as any;
            this.applicationTypeId = _data["applicationTypeId"];
            this.applicationType = _data["applicationType"] ? ApplicationType.fromJS(_data["applicationType"]) : undefined as any;
            this.browserName = _data["browserName"];
            this.browserId = _data["browserId"];
            this.browser = _data["browser"] ? Browser.fromJS(_data["browser"]) : undefined as any;
            this.productivityTypeId = _data["productivityTypeId"];
            this.productivityType = _data["productivityType"] ? ProductivityType.fromJS(_data["productivityType"]) : undefined as any;
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.icon = _data["icon"];
            this.isWebSite = _data["isWebSite"];
            this.parentWebURL = _data["parentWebURL"];
            this.webSiteIcon = _data["webSiteIcon"];
            this.screenShotComments = _data["screenShotComments"];
            this.isAssigned = _data["isAssigned"];
            this.totalTimeSpend = _data["totalTimeSpend"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.userProjectTask = _data["userProjectTask"] ? UserProjectTask.fromJS(_data["userProjectTask"]) : undefined as any;
            this.description = _data["description"];
            this.isManualTimeFlag = _data["isManualTimeFlag"];
            this.internetProvider = _data["internetProvider"];
            this.internetSpeed = _data["internetSpeed"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceType = _data["deviceType"] ? DeviceType.fromJS(_data["deviceType"]) : undefined as any;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.sublocality = _data["sublocality"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserActivityTemp {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityTemp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["applicationName"] = this.applicationName;
        data["applicationId"] = this.applicationId;
        data["applications"] = this.applications ? this.applications.toJSON() : undefined as any;
        data["applicationTypeId"] = this.applicationTypeId;
        data["applicationType"] = this.applicationType ? this.applicationType.toJSON() : undefined as any;
        data["browserName"] = this.browserName;
        data["browserId"] = this.browserId;
        data["browser"] = this.browser ? this.browser.toJSON() : undefined as any;
        data["productivityTypeId"] = this.productivityTypeId;
        data["productivityType"] = this.productivityType ? this.productivityType.toJSON() : undefined as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["icon"] = this.icon;
        data["isWebSite"] = this.isWebSite;
        data["parentWebURL"] = this.parentWebURL;
        data["webSiteIcon"] = this.webSiteIcon;
        data["screenShotComments"] = this.screenShotComments;
        data["isAssigned"] = this.isAssigned;
        data["totalTimeSpend"] = this.totalTimeSpend;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["userProjectTask"] = this.userProjectTask ? this.userProjectTask.toJSON() : undefined as any;
        data["description"] = this.description;
        data["isManualTimeFlag"] = this.isManualTimeFlag;
        data["internetProvider"] = this.internetProvider;
        data["internetSpeed"] = this.internetSpeed;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : undefined as any;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["sublocality"] = this.sublocality;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserActivityTemp {
    tenantId: number;
    userId: number | undefined;
    user: User;
    applicationName: string | undefined;
    applicationId: number | undefined;
    applications: Applications;
    applicationTypeId: number | undefined;
    applicationType: ApplicationType;
    browserName: string | undefined;
    browserId: number | undefined;
    browser: Browser;
    productivityTypeId: number | undefined;
    productivityType: ProductivityType;
    startDateTime: DateTime;
    endDateTime: DateTime;
    icon: string | undefined;
    isWebSite: boolean;
    parentWebURL: string | undefined;
    webSiteIcon: string | undefined;
    screenShotComments: string | undefined;
    isAssigned: boolean;
    totalTimeSpend: string;
    projectId: number | undefined;
    project: Projects;
    userProjectTaskId: number | undefined;
    userProjectTask: UserProjectTask;
    description: string | undefined;
    isManualTimeFlag: number | undefined;
    internetProvider: string | undefined;
    internetSpeed: string | undefined;
    deviceTypeId: number | undefined;
    deviceType: DeviceType;
    latitude: string | undefined;
    longitude: string | undefined;
    sublocality: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserActivityTempCreateOrEditDto implements IUserActivityTempCreateOrEditDto {
    tenantId!: number;
    userId!: number | undefined;
    applicationName!: string | undefined;
    applicationId!: number | undefined;
    applicationTypeId!: number | undefined;
    browserName!: string | undefined;
    browserId!: number | undefined;
    productivityTypeId!: number | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    icon!: string | undefined;
    count!: string | undefined;
    isWebSite!: boolean;
    parentWebURL!: string | undefined;
    webSiteIcon!: string | undefined;
    spendTime!: string;
    agentApplicationId!: number;
    projectId!: number | undefined;
    userProjectTaskId!: number | undefined;
    description!: string | undefined;
    internetProvider!: string | undefined;
    internetSpeed!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    sublocality!: string | undefined;
    deviceTypeId!: number;
    creationTime!: DateTime;
    windowsTrackingData!: WindowsTrackingDataDto[] | undefined;
    dateAppliedFor!: DateTime | undefined;
    taskCategoryId!: number | undefined;
    platform!: ManualEntryPlatform;
    id!: number;

    constructor(data?: IUserActivityTempCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.applicationName = _data["applicationName"];
            this.applicationId = _data["applicationId"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.browserName = _data["browserName"];
            this.browserId = _data["browserId"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.icon = _data["icon"];
            this.count = _data["count"];
            this.isWebSite = _data["isWebSite"];
            this.parentWebURL = _data["parentWebURL"];
            this.webSiteIcon = _data["webSiteIcon"];
            this.spendTime = _data["spendTime"];
            this.agentApplicationId = _data["agentApplicationId"];
            this.projectId = _data["projectId"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.description = _data["description"];
            this.internetProvider = _data["internetProvider"];
            this.internetSpeed = _data["internetSpeed"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.sublocality = _data["sublocality"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["windowsTrackingData"])) {
                this.windowsTrackingData = [] as any;
                for (let item of _data["windowsTrackingData"])
                    this.windowsTrackingData!.push(WindowsTrackingDataDto.fromJS(item));
            }
            this.dateAppliedFor = _data["dateAppliedFor"] ? DateTime.fromISO(_data["dateAppliedFor"].toString()) : undefined as any;
            this.taskCategoryId = _data["taskCategoryId"];
            this.platform = _data["platform"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserActivityTempCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityTempCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["applicationName"] = this.applicationName;
        data["applicationId"] = this.applicationId;
        data["applicationTypeId"] = this.applicationTypeId;
        data["browserName"] = this.browserName;
        data["browserId"] = this.browserId;
        data["productivityTypeId"] = this.productivityTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["icon"] = this.icon;
        data["count"] = this.count;
        data["isWebSite"] = this.isWebSite;
        data["parentWebURL"] = this.parentWebURL;
        data["webSiteIcon"] = this.webSiteIcon;
        data["spendTime"] = this.spendTime;
        data["agentApplicationId"] = this.agentApplicationId;
        data["projectId"] = this.projectId;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["description"] = this.description;
        data["internetProvider"] = this.internetProvider;
        data["internetSpeed"] = this.internetSpeed;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["sublocality"] = this.sublocality;
        data["deviceTypeId"] = this.deviceTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        if (Array.isArray(this.windowsTrackingData)) {
            data["windowsTrackingData"] = [];
            for (let item of this.windowsTrackingData)
                data["windowsTrackingData"].push(item ? item.toJSON() : undefined as any);
        }
        data["dateAppliedFor"] = this.dateAppliedFor ? this.dateAppliedFor.toString() : undefined as any;
        data["taskCategoryId"] = this.taskCategoryId;
        data["platform"] = this.platform;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserActivityTempCreateOrEditDto {
    tenantId: number;
    userId: number | undefined;
    applicationName: string | undefined;
    applicationId: number | undefined;
    applicationTypeId: number | undefined;
    browserName: string | undefined;
    browserId: number | undefined;
    productivityTypeId: number | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    icon: string | undefined;
    count: string | undefined;
    isWebSite: boolean;
    parentWebURL: string | undefined;
    webSiteIcon: string | undefined;
    spendTime: string;
    agentApplicationId: number;
    projectId: number | undefined;
    userProjectTaskId: number | undefined;
    description: string | undefined;
    internetProvider: string | undefined;
    internetSpeed: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    sublocality: string | undefined;
    deviceTypeId: number;
    creationTime: DateTime;
    windowsTrackingData: WindowsTrackingDataDto[] | undefined;
    dateAppliedFor: DateTime | undefined;
    taskCategoryId: number | undefined;
    platform: ManualEntryPlatform;
    id: number;
}

export class UserActivityTempGetAllDto implements IUserActivityTempGetAllDto {
    tenantId!: number;
    userId!: number | undefined;
    applicationName!: string | undefined;
    applicationId!: number | undefined;
    applicationTypeId!: number | undefined;
    browserName!: string | undefined;
    browserId!: number | undefined;
    productivityTypeId!: number | undefined;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    icon!: string | undefined;
    isWebSite!: boolean;
    parentWebURL!: string | undefined;
    webSiteIcon!: string | undefined;
    isAssigned!: boolean;
    screenShotComments!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    sublocality!: string | undefined;
    deviceTypeId!: number;
    totalCount!: number | undefined;
    id!: number;

    constructor(data?: IUserActivityTempGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.applicationName = _data["applicationName"];
            this.applicationId = _data["applicationId"];
            this.applicationTypeId = _data["applicationTypeId"];
            this.browserName = _data["browserName"];
            this.browserId = _data["browserId"];
            this.productivityTypeId = _data["productivityTypeId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.icon = _data["icon"];
            this.isWebSite = _data["isWebSite"];
            this.parentWebURL = _data["parentWebURL"];
            this.webSiteIcon = _data["webSiteIcon"];
            this.isAssigned = _data["isAssigned"];
            this.screenShotComments = _data["screenShotComments"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.sublocality = _data["sublocality"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.totalCount = _data["totalCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserActivityTempGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityTempGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["applicationName"] = this.applicationName;
        data["applicationId"] = this.applicationId;
        data["applicationTypeId"] = this.applicationTypeId;
        data["browserName"] = this.browserName;
        data["browserId"] = this.browserId;
        data["productivityTypeId"] = this.productivityTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["icon"] = this.icon;
        data["isWebSite"] = this.isWebSite;
        data["parentWebURL"] = this.parentWebURL;
        data["webSiteIcon"] = this.webSiteIcon;
        data["isAssigned"] = this.isAssigned;
        data["screenShotComments"] = this.screenShotComments;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["sublocality"] = this.sublocality;
        data["deviceTypeId"] = this.deviceTypeId;
        data["totalCount"] = this.totalCount;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserActivityTempGetAllDto {
    tenantId: number;
    userId: number | undefined;
    applicationName: string | undefined;
    applicationId: number | undefined;
    applicationTypeId: number | undefined;
    browserName: string | undefined;
    browserId: number | undefined;
    productivityTypeId: number | undefined;
    startDateTime: DateTime;
    endDateTime: DateTime;
    icon: string | undefined;
    isWebSite: boolean;
    parentWebURL: string | undefined;
    webSiteIcon: string | undefined;
    isAssigned: boolean;
    screenShotComments: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    sublocality: string | undefined;
    deviceTypeId: number;
    totalCount: number | undefined;
    id: number;
}

export class UserAllocationDto implements IUserAllocationDto {
    id!: number;
    userName!: string | undefined;
    profileImage!: string | undefined;
    designationName!: string | undefined;
    projectAllocations!: ProjectAllocationInfo[] | undefined;
    totalAllocationPercentage!: number;
    totalHours!: number;

    constructor(data?: IUserAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.profileImage = _data["profileImage"];
            this.designationName = _data["designationName"];
            if (Array.isArray(_data["projectAllocations"])) {
                this.projectAllocations = [] as any;
                for (let item of _data["projectAllocations"])
                    this.projectAllocations!.push(ProjectAllocationInfo.fromJS(item));
            }
            this.totalAllocationPercentage = _data["totalAllocationPercentage"];
            this.totalHours = _data["totalHours"];
        }
    }

    static fromJS(data: any): UserAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["profileImage"] = this.profileImage;
        data["designationName"] = this.designationName;
        if (Array.isArray(this.projectAllocations)) {
            data["projectAllocations"] = [];
            for (let item of this.projectAllocations)
                data["projectAllocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAllocationPercentage"] = this.totalAllocationPercentage;
        data["totalHours"] = this.totalHours;
        return data;
    }
}

export interface IUserAllocationDto {
    id: number;
    userName: string | undefined;
    profileImage: string | undefined;
    designationName: string | undefined;
    projectAllocations: ProjectAllocationInfo[] | undefined;
    totalAllocationPercentage: number;
    totalHours: number;
}

export class UserAllocationFilterDto implements IUserAllocationFilterDto {
    employeeName!: string | undefined;
    projectName!: string | undefined;
    designationId!: number | undefined;
    filterDate!: DateTime | undefined;
    month!: number | undefined;
    year!: number | undefined;
    projectBillingType!: ProjectBillingType;
    projectTypeId!: number | undefined;

    constructor(data?: IUserAllocationFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.projectName = _data["projectName"];
            this.designationId = _data["designationId"];
            this.filterDate = _data["filterDate"] ? DateTime.fromISO(_data["filterDate"].toString()) : undefined as any;
            this.month = _data["month"];
            this.year = _data["year"];
            this.projectBillingType = _data["projectBillingType"];
            this.projectTypeId = _data["projectTypeId"];
        }
    }

    static fromJS(data: any): UserAllocationFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAllocationFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["projectName"] = this.projectName;
        data["designationId"] = this.designationId;
        data["filterDate"] = this.filterDate ? this.filterDate.toString() : undefined as any;
        data["month"] = this.month;
        data["year"] = this.year;
        data["projectBillingType"] = this.projectBillingType;
        data["projectTypeId"] = this.projectTypeId;
        return data;
    }
}

export interface IUserAllocationFilterDto {
    employeeName: string | undefined;
    projectName: string | undefined;
    designationId: number | undefined;
    filterDate: DateTime | undefined;
    month: number | undefined;
    year: number | undefined;
    projectBillingType: ProjectBillingType;
    projectTypeId: number | undefined;
}

export class UserAndTimesheetStatus implements IUserAndTimesheetStatus {
    userIds!: number;
    timesheetId!: number;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;

    constructor(data?: IUserAndTimesheetStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIds = _data["userIds"];
            this.timesheetId = _data["timesheetId"];
            this.timesheetStatus = _data["timesheetStatus"];
        }
    }

    static fromJS(data: any): UserAndTimesheetStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserAndTimesheetStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIds"] = this.userIds;
        data["timesheetId"] = this.timesheetId;
        data["timesheetStatus"] = this.timesheetStatus;
        return data;
    }
}

export interface IUserAndTimesheetStatus {
    userIds: number;
    timesheetId: number;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
}

export class UserApplication implements IUserApplication {
    tenantId!: number;
    userId!: number;
    user!: User;
    productivityTypeId!: number | undefined;
    productivityType!: ProductivityType;
    projectId!: number | undefined;
    project!: Projects;
    agentApplicationId!: number | undefined;
    agentApplication!: AgentApplication;
    applicationCategoryId!: number | undefined;
    applicationCategory!: ApplicationCategorys;
    organizationUnitId!: number | undefined;
    organizationUnit!: OrganizationUnit;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.productivityTypeId = _data["productivityTypeId"];
            this.productivityType = _data["productivityType"] ? ProductivityType.fromJS(_data["productivityType"]) : undefined as any;
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.agentApplicationId = _data["agentApplicationId"];
            this.agentApplication = _data["agentApplication"] ? AgentApplication.fromJS(_data["agentApplication"]) : undefined as any;
            this.applicationCategoryId = _data["applicationCategoryId"];
            this.applicationCategory = _data["applicationCategory"] ? ApplicationCategorys.fromJS(_data["applicationCategory"]) : undefined as any;
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnit.fromJS(_data["organizationUnit"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserApplication {
        data = typeof data === 'object' ? data : {};
        let result = new UserApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["productivityTypeId"] = this.productivityTypeId;
        data["productivityType"] = this.productivityType ? this.productivityType.toJSON() : undefined as any;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["agentApplicationId"] = this.agentApplicationId;
        data["agentApplication"] = this.agentApplication ? this.agentApplication.toJSON() : undefined as any;
        data["applicationCategoryId"] = this.applicationCategoryId;
        data["applicationCategory"] = this.applicationCategory ? this.applicationCategory.toJSON() : undefined as any;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserApplication {
    tenantId: number;
    userId: number;
    user: User;
    productivityTypeId: number | undefined;
    productivityType: ProductivityType;
    projectId: number | undefined;
    project: Projects;
    agentApplicationId: number | undefined;
    agentApplication: AgentApplication;
    applicationCategoryId: number | undefined;
    applicationCategory: ApplicationCategorys;
    organizationUnitId: number | undefined;
    organizationUnit: OrganizationUnit;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserCategoryDto implements IUserCategoryDto {
    count!: number;
    percentage!: number;

    constructor(data?: IUserCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): UserCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IUserCategoryDto {
    count: number;
    percentage: number;
}

export class UserClaim implements IUserClaim {
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserCurrentStateCheckInCheckOutDto implements IUserCurrentStateCheckInCheckOutDto {
    userCurrentStatus!: UserStatusEnum;
    time!: DateTime | undefined;
    lastCheckInTime!: DateTime | undefined;
    offset!: number;

    constructor(data?: IUserCurrentStateCheckInCheckOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCurrentStatus = _data["userCurrentStatus"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : undefined as any;
            this.lastCheckInTime = _data["lastCheckInTime"] ? DateTime.fromISO(_data["lastCheckInTime"].toString()) : undefined as any;
            this.offset = _data["offset"];
        }
    }

    static fromJS(data: any): UserCurrentStateCheckInCheckOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCurrentStateCheckInCheckOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCurrentStatus"] = this.userCurrentStatus;
        data["time"] = this.time ? this.time.toString() : undefined as any;
        data["lastCheckInTime"] = this.lastCheckInTime ? this.lastCheckInTime.toString() : undefined as any;
        data["offset"] = this.offset;
        return data;
    }
}

export interface IUserCurrentStateCheckInCheckOutDto {
    userCurrentStatus: UserStatusEnum;
    time: DateTime | undefined;
    lastCheckInTime: DateTime | undefined;
    offset: number;
}

export class UserCurrentTaskActiveInfoDto implements IUserCurrentTaskActiveInfoDto {
    taskName!: string | undefined;
    startTime!: DateTime | undefined;
    timerTime!: string;

    constructor(data?: IUserCurrentTaskActiveInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.timerTime = _data["timerTime"];
        }
    }

    static fromJS(data: any): UserCurrentTaskActiveInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCurrentTaskActiveInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["timerTime"] = this.timerTime;
        return data;
    }
}

export interface IUserCurrentTaskActiveInfoDto {
    taskName: string | undefined;
    startTime: DateTime | undefined;
    timerTime: string;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    id: number;
}

export class UserDetailsDto implements IUserDetailsDto {
    userId!: number;
    userImage!: string | undefined;
    userName!: string | undefined;
    approvalLevelId!: number | undefined;
    timesheetId!: number;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;

    constructor(data?: IUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userImage = _data["userImage"];
            this.userName = _data["userName"];
            this.approvalLevelId = _data["approvalLevelId"];
            this.timesheetId = _data["timesheetId"];
            this.timesheetStatus = _data["timesheetStatus"];
        }
    }

    static fromJS(data: any): UserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userImage"] = this.userImage;
        data["userName"] = this.userName;
        data["approvalLevelId"] = this.approvalLevelId;
        data["timesheetId"] = this.timesheetId;
        data["timesheetStatus"] = this.timesheetStatus;
        return data;
    }
}

export interface IUserDetailsDto {
    userId: number;
    userImage: string | undefined;
    userName: string | undefined;
    approvalLevelId: number | undefined;
    timesheetId: number;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
}

export class UserDeviceCreareOrEditDto implements IUserDeviceCreareOrEditDto {
    tenantId!: number;
    userId!: number;
    deviceName!: string | undefined;
    operatingSystem!: string | undefined;
    macAddress!: string | undefined;
    publicIPAddress!: string | undefined;
    privateIPAddress!: string | undefined;
    deviceTypeId!: number;
    userDeviseVersion!: string | undefined;
    buildNumber!: string | undefined;
    isElectronApp!: boolean;
    id!: number;

    constructor(data?: IUserDeviceCreareOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.deviceName = _data["deviceName"];
            this.operatingSystem = _data["operatingSystem"];
            this.macAddress = _data["macAddress"];
            this.publicIPAddress = _data["publicIPAddress"];
            this.privateIPAddress = _data["privateIPAddress"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.userDeviseVersion = _data["userDeviseVersion"];
            this.buildNumber = _data["buildNumber"];
            this.isElectronApp = _data["isElectronApp"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDeviceCreareOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceCreareOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["deviceName"] = this.deviceName;
        data["operatingSystem"] = this.operatingSystem;
        data["macAddress"] = this.macAddress;
        data["publicIPAddress"] = this.publicIPAddress;
        data["privateIPAddress"] = this.privateIPAddress;
        data["deviceTypeId"] = this.deviceTypeId;
        data["userDeviseVersion"] = this.userDeviseVersion;
        data["buildNumber"] = this.buildNumber;
        data["isElectronApp"] = this.isElectronApp;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDeviceCreareOrEditDto {
    tenantId: number;
    userId: number;
    deviceName: string | undefined;
    operatingSystem: string | undefined;
    macAddress: string | undefined;
    publicIPAddress: string | undefined;
    privateIPAddress: string | undefined;
    deviceTypeId: number;
    userDeviseVersion: string | undefined;
    buildNumber: string | undefined;
    isElectronApp: boolean;
    id: number;
}

export class UserDto implements IUserDto {
    userId!: number;
    tenantId!: number;
    name!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserDto {
    userId: number;
    tenantId: number;
    name: string | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;
    profileImage!: string | undefined;
    addressLine1!: string | undefined;
    addressLine2!: string | undefined;
    city!: number;
    cityName!: string | undefined;
    state!: number;
    countryId!: number | undefined;
    managerId!: number | undefined;
    organizationId!: number;
    leavesPerMonth!: number | undefined;
    year!: string | undefined;
    creationTime!: DateTime;
    birthDate!: DateTime | undefined;
    reportingLocation!: number;
    isEmailConfirmed!: boolean;
    userTimeZone!: string | undefined;
    employeeId!: string | undefined;
    designationId!: number | undefined;
    companyJoinDate!: DateTime | undefined;
    emailSentDate!: DateTime | undefined;
    itpJoiningDate!: DateTime | undefined;
    onProbation!: boolean;
    isAutomatedTimesheetEnabled!: boolean;
    cost!: number | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.profileImage = _data["profileImage"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.cityName = _data["cityName"];
            this.state = _data["state"];
            this.countryId = _data["countryId"];
            this.managerId = _data["managerId"];
            this.organizationId = _data["organizationId"];
            this.leavesPerMonth = _data["leavesPerMonth"];
            this.year = _data["year"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.birthDate = _data["birthDate"] ? DateTime.fromISO(_data["birthDate"].toString()) : undefined as any;
            this.reportingLocation = _data["reportingLocation"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.userTimeZone = _data["userTimeZone"];
            this.employeeId = _data["employeeId"];
            this.designationId = _data["designationId"];
            this.companyJoinDate = _data["companyJoinDate"] ? DateTime.fromISO(_data["companyJoinDate"].toString()) : undefined as any;
            this.emailSentDate = _data["emailSentDate"] ? DateTime.fromISO(_data["emailSentDate"].toString()) : undefined as any;
            this.itpJoiningDate = _data["itpJoiningDate"] ? DateTime.fromISO(_data["itpJoiningDate"].toString()) : undefined as any;
            this.onProbation = _data["onProbation"];
            this.isAutomatedTimesheetEnabled = _data["isAutomatedTimesheetEnabled"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["profileImage"] = this.profileImage;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["cityName"] = this.cityName;
        data["state"] = this.state;
        data["countryId"] = this.countryId;
        data["managerId"] = this.managerId;
        data["organizationId"] = this.organizationId;
        data["leavesPerMonth"] = this.leavesPerMonth;
        data["year"] = this.year;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toString() : undefined as any;
        data["reportingLocation"] = this.reportingLocation;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["userTimeZone"] = this.userTimeZone;
        data["employeeId"] = this.employeeId;
        data["designationId"] = this.designationId;
        data["companyJoinDate"] = this.companyJoinDate ? this.companyJoinDate.toString() : undefined as any;
        data["emailSentDate"] = this.emailSentDate ? this.emailSentDate.toString() : undefined as any;
        data["itpJoiningDate"] = this.itpJoiningDate ? this.itpJoiningDate.toString() : undefined as any;
        data["onProbation"] = this.onProbation;
        data["isAutomatedTimesheetEnabled"] = this.isAutomatedTimesheetEnabled;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    profileImage: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    city: number;
    cityName: string | undefined;
    state: number;
    countryId: number | undefined;
    managerId: number | undefined;
    organizationId: number;
    leavesPerMonth: number | undefined;
    year: string | undefined;
    creationTime: DateTime;
    birthDate: DateTime | undefined;
    reportingLocation: number;
    isEmailConfirmed: boolean;
    userTimeZone: string | undefined;
    employeeId: string | undefined;
    designationId: number | undefined;
    companyJoinDate: DateTime | undefined;
    emailSentDate: DateTime | undefined;
    itpJoiningDate: DateTime | undefined;
    onProbation: boolean;
    isAutomatedTimesheetEnabled: boolean;
    cost: number | undefined;
}

export class UserEmailReportSetting implements IUserEmailReportSetting {
    tenantId!: number;
    userId!: number;
    reportName!: string | undefined;
    recipients!: string | undefined;
    day!: Days;
    mailInterval!: MailIntervalType;
    emailDispatchTime!: DateTime | undefined;
    monthlyDate!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserEmailReportSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.reportName = _data["reportName"];
            this.recipients = _data["recipients"];
            this.day = _data["day"];
            this.mailInterval = _data["mailInterval"];
            this.emailDispatchTime = _data["emailDispatchTime"] ? DateTime.fromISO(_data["emailDispatchTime"].toString()) : undefined as any;
            this.monthlyDate = _data["monthlyDate"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserEmailReportSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailReportSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["reportName"] = this.reportName;
        data["recipients"] = this.recipients;
        data["day"] = this.day;
        data["mailInterval"] = this.mailInterval;
        data["emailDispatchTime"] = this.emailDispatchTime ? this.emailDispatchTime.toString() : undefined as any;
        data["monthlyDate"] = this.monthlyDate;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserEmailReportSetting {
    tenantId: number;
    userId: number;
    reportName: string | undefined;
    recipients: string | undefined;
    day: Days;
    mailInterval: MailIntervalType;
    emailDispatchTime: DateTime | undefined;
    monthlyDate: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserEmailSettingCreateOrEditDto implements IUserEmailSettingCreateOrEditDto {
    tenantId!: number | undefined;
    userId!: number;
    reportName!: string | undefined;
    recipients!: string | undefined;
    day!: Days;
    mailInterval!: MailIntervalType;
    emailDispatchTime!: DateTime | undefined;
    monthlyDate!: number;
    id!: number | undefined;

    constructor(data?: IUserEmailSettingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.reportName = _data["reportName"];
            this.recipients = _data["recipients"];
            this.day = _data["day"];
            this.mailInterval = _data["mailInterval"];
            this.emailDispatchTime = _data["emailDispatchTime"] ? DateTime.fromISO(_data["emailDispatchTime"].toString()) : undefined as any;
            this.monthlyDate = _data["monthlyDate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserEmailSettingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailSettingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["reportName"] = this.reportName;
        data["recipients"] = this.recipients;
        data["day"] = this.day;
        data["mailInterval"] = this.mailInterval;
        data["emailDispatchTime"] = this.emailDispatchTime ? this.emailDispatchTime.toString() : undefined as any;
        data["monthlyDate"] = this.monthlyDate;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserEmailSettingCreateOrEditDto {
    tenantId: number | undefined;
    userId: number;
    reportName: string | undefined;
    recipients: string | undefined;
    day: Days;
    mailInterval: MailIntervalType;
    emailDispatchTime: DateTime | undefined;
    monthlyDate: number;
    id: number | undefined;
}

export class UserInvalidUplodDto implements IUserInvalidUplodDto {
    name!: string | undefined;
    userJson!: string | undefined;

    constructor(data?: IUserInvalidUplodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userJson = _data["userJson"];
        }
    }

    static fromJS(data: any): UserInvalidUplodDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvalidUplodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userJson"] = this.userJson;
        return data;
    }
}

export interface IUserInvalidUplodDto {
    name: string | undefined;
    userJson: string | undefined;
}

export class UserLeaveDatewithLevel implements IUserLeaveDatewithLevel {
    timesheetlevel!: string | undefined;
    reportingManagerLevel!: string | undefined;
    projectId!: number;
    leavelevel!: string | undefined;
    projectname!: string | undefined;
    projectrole!: string | undefined;
    projectManager!: boolean;
    projectTypeId!: number;
    isActive!: boolean;
    isDeleted!: boolean;
    isArchive!: boolean;

    constructor(data?: IUserLeaveDatewithLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheetlevel = _data["timesheetlevel"];
            this.reportingManagerLevel = _data["reportingManagerLevel"];
            this.projectId = _data["projectId"];
            this.leavelevel = _data["leavelevel"];
            this.projectname = _data["projectname"];
            this.projectrole = _data["projectrole"];
            this.projectManager = _data["projectManager"];
            this.projectTypeId = _data["projectTypeId"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.isArchive = _data["isArchive"];
        }
    }

    static fromJS(data: any): UserLeaveDatewithLevel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLeaveDatewithLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheetlevel"] = this.timesheetlevel;
        data["reportingManagerLevel"] = this.reportingManagerLevel;
        data["projectId"] = this.projectId;
        data["leavelevel"] = this.leavelevel;
        data["projectname"] = this.projectname;
        data["projectrole"] = this.projectrole;
        data["projectManager"] = this.projectManager;
        data["projectTypeId"] = this.projectTypeId;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isArchive"] = this.isArchive;
        return data;
    }
}

export interface IUserLeaveDatewithLevel {
    timesheetlevel: string | undefined;
    reportingManagerLevel: string | undefined;
    projectId: number;
    leavelevel: string | undefined;
    projectname: string | undefined;
    projectrole: string | undefined;
    projectManager: boolean;
    projectTypeId: number;
    isActive: boolean;
    isDeleted: boolean;
    isArchive: boolean;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    readonly fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    profileImage!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    isActiveProjectMember!: boolean;
    creationTime!: DateTime;
    organizationUnitName!: string | undefined;
    deviceNameWeb!: number[] | undefined;
    taskName!: string | undefined;
    userTaskStatus!: number | undefined;
    tenantId!: number | undefined;
    checkIn!: DateTime | undefined;
    checkOut!: DateTime | undefined;
    applicationName!: string | undefined;
    icon!: string | undefined;
    applicationStatus!: string | undefined;
    taskDescription!: string | undefined;
    organizationId!: number;
    projectId!: number[] | undefined;
    spendTime!: string | undefined;
    userLiveLocation!: string | undefined;
    userManager!: string | undefined;
    userManagerEmail!: string | undefined;
    managerId!: number | undefined;
    internetProvider!: string | undefined;
    internetSpeed!: string | undefined;
    microsoftLogin!: boolean;
    googleLogin!: boolean;
    inTimeProsLogin!: boolean;
    userStatusId!: UserStatusEnum;
    leaveBalanceAfterBooked!: number;
    isAllowClient!: boolean;
    addressLine1!: string | undefined;
    addressLine2!: string | undefined;
    reportingLocationName!: string | undefined;
    reportingLocation!: number;
    isArchived!: boolean;
    isDeleted!: boolean;
    isDeletedFromMember!: boolean;
    birthDate!: DateTime | undefined;
    roleNames!: string[] | undefined;
    cityName!: string | undefined;
    city!: number;
    clientPassword!: string | undefined;
    workingType!: WorkFromType;
    projectImage!: string | undefined;
    projectName!: string | undefined;
    password!: string | undefined;
    employeeId!: string | undefined;
    companyJoinDate!: DateTime | undefined;
    emailSentDate!: DateTime | undefined;
    itpJoiningDate!: DateTime | undefined;
    screenCapture!: boolean;
    userDeviseVersion!: string | undefined;
    userTimeZone!: string | undefined;
    deviceNameWithOs!: string | undefined;
    arrivedAt!: string | undefined;
    leftAt!: string | undefined;
    currentlyUsing!: string | undefined;
    sublocality!: string | undefined;
    designationId!: number | undefined;
    lastUpdatedDate!: DateTime;
    lastUserType!: UserType;
    appleLogin!: boolean;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            (this as any).fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.profileImage = _data["profileImage"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.isActiveProjectMember = _data["isActiveProjectMember"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.organizationUnitName = _data["organizationUnitName"];
            if (Array.isArray(_data["deviceNameWeb"])) {
                this.deviceNameWeb = [] as any;
                for (let item of _data["deviceNameWeb"])
                    this.deviceNameWeb!.push(item);
            }
            this.taskName = _data["taskName"];
            this.userTaskStatus = _data["userTaskStatus"];
            this.tenantId = _data["tenantId"];
            this.checkIn = _data["checkIn"] ? DateTime.fromISO(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? DateTime.fromISO(_data["checkOut"].toString()) : undefined as any;
            this.applicationName = _data["applicationName"];
            this.icon = _data["icon"];
            this.applicationStatus = _data["applicationStatus"];
            this.taskDescription = _data["taskDescription"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            this.spendTime = _data["spendTime"];
            this.userLiveLocation = _data["userLiveLocation"];
            this.userManager = _data["userManager"];
            this.userManagerEmail = _data["userManagerEmail"];
            this.managerId = _data["managerId"];
            this.internetProvider = _data["internetProvider"];
            this.internetSpeed = _data["internetSpeed"];
            this.microsoftLogin = _data["microsoftLogin"];
            this.googleLogin = _data["googleLogin"];
            this.inTimeProsLogin = _data["inTimeProsLogin"];
            this.userStatusId = _data["userStatusId"];
            this.leaveBalanceAfterBooked = _data["leaveBalanceAfterBooked"];
            this.isAllowClient = _data["isAllowClient"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.reportingLocationName = _data["reportingLocationName"];
            this.reportingLocation = _data["reportingLocation"];
            this.isArchived = _data["isArchived"];
            this.isDeleted = _data["isDeleted"];
            this.isDeletedFromMember = _data["isDeletedFromMember"];
            this.birthDate = _data["birthDate"] ? DateTime.fromISO(_data["birthDate"].toString()) : undefined as any;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.cityName = _data["cityName"];
            this.city = _data["city"];
            this.clientPassword = _data["clientPassword"];
            this.workingType = _data["workingType"];
            this.projectImage = _data["projectImage"];
            this.projectName = _data["projectName"];
            this.password = _data["password"];
            this.employeeId = _data["employeeId"];
            this.companyJoinDate = _data["companyJoinDate"] ? DateTime.fromISO(_data["companyJoinDate"].toString()) : undefined as any;
            this.emailSentDate = _data["emailSentDate"] ? DateTime.fromISO(_data["emailSentDate"].toString()) : undefined as any;
            this.itpJoiningDate = _data["itpJoiningDate"] ? DateTime.fromISO(_data["itpJoiningDate"].toString()) : undefined as any;
            this.screenCapture = _data["screenCapture"];
            this.userDeviseVersion = _data["userDeviseVersion"];
            this.userTimeZone = _data["userTimeZone"];
            this.deviceNameWithOs = _data["deviceNameWithOs"];
            this.arrivedAt = _data["arrivedAt"];
            this.leftAt = _data["leftAt"];
            this.currentlyUsing = _data["currentlyUsing"];
            this.sublocality = _data["sublocality"];
            this.designationId = _data["designationId"];
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? DateTime.fromISO(_data["lastUpdatedDate"].toString()) : undefined as any;
            this.lastUserType = _data["lastUserType"];
            this.appleLogin = _data["appleLogin"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["profileImage"] = this.profileImage;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["isActive"] = this.isActive;
        data["isActiveProjectMember"] = this.isActiveProjectMember;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["organizationUnitName"] = this.organizationUnitName;
        if (Array.isArray(this.deviceNameWeb)) {
            data["deviceNameWeb"] = [];
            for (let item of this.deviceNameWeb)
                data["deviceNameWeb"].push(item);
        }
        data["taskName"] = this.taskName;
        data["userTaskStatus"] = this.userTaskStatus;
        data["tenantId"] = this.tenantId;
        data["checkIn"] = this.checkIn ? this.checkIn.toString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toString() : undefined as any;
        data["applicationName"] = this.applicationName;
        data["icon"] = this.icon;
        data["applicationStatus"] = this.applicationStatus;
        data["taskDescription"] = this.taskDescription;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["spendTime"] = this.spendTime;
        data["userLiveLocation"] = this.userLiveLocation;
        data["userManager"] = this.userManager;
        data["userManagerEmail"] = this.userManagerEmail;
        data["managerId"] = this.managerId;
        data["internetProvider"] = this.internetProvider;
        data["internetSpeed"] = this.internetSpeed;
        data["microsoftLogin"] = this.microsoftLogin;
        data["googleLogin"] = this.googleLogin;
        data["inTimeProsLogin"] = this.inTimeProsLogin;
        data["userStatusId"] = this.userStatusId;
        data["leaveBalanceAfterBooked"] = this.leaveBalanceAfterBooked;
        data["isAllowClient"] = this.isAllowClient;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["reportingLocationName"] = this.reportingLocationName;
        data["reportingLocation"] = this.reportingLocation;
        data["isArchived"] = this.isArchived;
        data["isDeleted"] = this.isDeleted;
        data["isDeletedFromMember"] = this.isDeletedFromMember;
        data["birthDate"] = this.birthDate ? this.birthDate.toString() : undefined as any;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["cityName"] = this.cityName;
        data["city"] = this.city;
        data["clientPassword"] = this.clientPassword;
        data["workingType"] = this.workingType;
        data["projectImage"] = this.projectImage;
        data["projectName"] = this.projectName;
        data["password"] = this.password;
        data["employeeId"] = this.employeeId;
        data["companyJoinDate"] = this.companyJoinDate ? this.companyJoinDate.toString() : undefined as any;
        data["emailSentDate"] = this.emailSentDate ? this.emailSentDate.toString() : undefined as any;
        data["itpJoiningDate"] = this.itpJoiningDate ? this.itpJoiningDate.toString() : undefined as any;
        data["screenCapture"] = this.screenCapture;
        data["userDeviseVersion"] = this.userDeviseVersion;
        data["userTimeZone"] = this.userTimeZone;
        data["deviceNameWithOs"] = this.deviceNameWithOs;
        data["arrivedAt"] = this.arrivedAt;
        data["leftAt"] = this.leftAt;
        data["currentlyUsing"] = this.currentlyUsing;
        data["sublocality"] = this.sublocality;
        data["designationId"] = this.designationId;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toString() : undefined as any;
        data["lastUserType"] = this.lastUserType;
        data["appleLogin"] = this.appleLogin;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    profileImage: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    isActiveProjectMember: boolean;
    creationTime: DateTime;
    organizationUnitName: string | undefined;
    deviceNameWeb: number[] | undefined;
    taskName: string | undefined;
    userTaskStatus: number | undefined;
    tenantId: number | undefined;
    checkIn: DateTime | undefined;
    checkOut: DateTime | undefined;
    applicationName: string | undefined;
    icon: string | undefined;
    applicationStatus: string | undefined;
    taskDescription: string | undefined;
    organizationId: number;
    projectId: number[] | undefined;
    spendTime: string | undefined;
    userLiveLocation: string | undefined;
    userManager: string | undefined;
    userManagerEmail: string | undefined;
    managerId: number | undefined;
    internetProvider: string | undefined;
    internetSpeed: string | undefined;
    microsoftLogin: boolean;
    googleLogin: boolean;
    inTimeProsLogin: boolean;
    userStatusId: UserStatusEnum;
    leaveBalanceAfterBooked: number;
    isAllowClient: boolean;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    reportingLocationName: string | undefined;
    reportingLocation: number;
    isArchived: boolean;
    isDeleted: boolean;
    isDeletedFromMember: boolean;
    birthDate: DateTime | undefined;
    roleNames: string[] | undefined;
    cityName: string | undefined;
    city: number;
    clientPassword: string | undefined;
    workingType: WorkFromType;
    projectImage: string | undefined;
    projectName: string | undefined;
    password: string | undefined;
    employeeId: string | undefined;
    companyJoinDate: DateTime | undefined;
    emailSentDate: DateTime | undefined;
    itpJoiningDate: DateTime | undefined;
    screenCapture: boolean;
    userDeviseVersion: string | undefined;
    userTimeZone: string | undefined;
    deviceNameWithOs: string | undefined;
    arrivedAt: string | undefined;
    leftAt: string | undefined;
    currentlyUsing: string | undefined;
    sublocality: string | undefined;
    designationId: number | undefined;
    lastUpdatedDate: DateTime;
    lastUserType: UserType;
    appleLogin: boolean;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserListWorkingStatus implements IUserListWorkingStatus {
    teamTrackingDetail!: PagedResultDtoOfOutputTeamTrackingDto;
    teamTrackingHeader!: TeamWorkingStatus;

    constructor(data?: IUserListWorkingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamTrackingDetail = _data["teamTrackingDetail"] ? PagedResultDtoOfOutputTeamTrackingDto.fromJS(_data["teamTrackingDetail"]) : undefined as any;
            this.teamTrackingHeader = _data["teamTrackingHeader"] ? TeamWorkingStatus.fromJS(_data["teamTrackingHeader"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserListWorkingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserListWorkingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamTrackingDetail"] = this.teamTrackingDetail ? this.teamTrackingDetail.toJSON() : undefined as any;
        data["teamTrackingHeader"] = this.teamTrackingHeader ? this.teamTrackingHeader.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserListWorkingStatus {
    teamTrackingDetail: PagedResultDtoOfOutputTeamTrackingDto;
    teamTrackingHeader: TeamWorkingStatus;
}

export class UserLocationTrackingViewMoreDetail implements IUserLocationTrackingViewMoreDetail {
    userName!: string | undefined;
    userRole!: string | undefined;
    address!: string | undefined;
    enterTime!: DateTime | undefined;
    exitTime!: DateTime | undefined;
    timeSpend!: string | undefined;
    profileImage!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUserLocationTrackingViewMoreDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.address = _data["address"];
            this.enterTime = _data["enterTime"] ? DateTime.fromISO(_data["enterTime"].toString()) : undefined as any;
            this.exitTime = _data["exitTime"] ? DateTime.fromISO(_data["exitTime"].toString()) : undefined as any;
            this.timeSpend = _data["timeSpend"];
            this.profileImage = _data["profileImage"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLocationTrackingViewMoreDetail {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocationTrackingViewMoreDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["address"] = this.address;
        data["enterTime"] = this.enterTime ? this.enterTime.toString() : undefined as any;
        data["exitTime"] = this.exitTime ? this.exitTime.toString() : undefined as any;
        data["timeSpend"] = this.timeSpend;
        data["profileImage"] = this.profileImage;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLocationTrackingViewMoreDetail {
    userName: string | undefined;
    userRole: string | undefined;
    address: string | undefined;
    enterTime: DateTime | undefined;
    exitTime: DateTime | undefined;
    timeSpend: string | undefined;
    profileImage: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    id: number | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserLogin implements IUserLogin {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;
    id!: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserLoginAttemptOnboardingDto implements IUserLoginAttemptOnboardingDto {
    onboardingCount!: number;
    userLoginAttemptCount!: number;
    checkRoleCount!: number;
    companyDetailCount!: boolean;
    orgnizationCount!: boolean;
    inviteTeamCount!: boolean;
    isShowDownloadPopup!: boolean;

    constructor(data?: IUserLoginAttemptOnboardingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onboardingCount = _data["onboardingCount"];
            this.userLoginAttemptCount = _data["userLoginAttemptCount"];
            this.checkRoleCount = _data["checkRoleCount"];
            this.companyDetailCount = _data["companyDetailCount"];
            this.orgnizationCount = _data["orgnizationCount"];
            this.inviteTeamCount = _data["inviteTeamCount"];
            this.isShowDownloadPopup = _data["isShowDownloadPopup"];
        }
    }

    static fromJS(data: any): UserLoginAttemptOnboardingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptOnboardingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onboardingCount"] = this.onboardingCount;
        data["userLoginAttemptCount"] = this.userLoginAttemptCount;
        data["checkRoleCount"] = this.checkRoleCount;
        data["companyDetailCount"] = this.companyDetailCount;
        data["orgnizationCount"] = this.orgnizationCount;
        data["inviteTeamCount"] = this.inviteTeamCount;
        data["isShowDownloadPopup"] = this.isShowDownloadPopup;
        return data;
    }
}

export interface IUserLoginAttemptOnboardingDto {
    onboardingCount: number;
    userLoginAttemptCount: number;
    checkRoleCount: number;
    companyDetailCount: boolean;
    orgnizationCount: boolean;
    inviteTeamCount: boolean;
    isShowDownloadPopup: boolean;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    userRole!: string[] | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    userRole: string[] | undefined;
    id: number;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : undefined as any;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (this as any).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (this as any).targetNotifiersList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined as any;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class UserOrganizationUnit implements IUserOrganizationUnit {
    tenantId!: number | undefined;
    userId!: number;
    organizationUnitId!: number;
    isDeleted!: boolean;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isDeleted = _data["isDeleted"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserOrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserOrganizationUnit {
    tenantId: number | undefined;
    userId: number;
    organizationUnitId: number;
    isDeleted: boolean;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserOutlookCalendarEventDto implements IUserOutlookCalendarEventDto {
    systemEventId!: number | undefined;
    userId!: number;
    outlookEventId!: string | undefined;
    outlookEventDetails!: string | undefined;
    outlookEventItem!: OutlookCalendarEventItem;
    lastChangeDateTime!: DateTime;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserOutlookCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemEventId = _data["systemEventId"];
            this.userId = _data["userId"];
            this.outlookEventId = _data["outlookEventId"];
            this.outlookEventDetails = _data["outlookEventDetails"];
            this.outlookEventItem = _data["outlookEventItem"] ? OutlookCalendarEventItem.fromJS(_data["outlookEventItem"]) : undefined as any;
            this.lastChangeDateTime = _data["lastChangeDateTime"] ? DateTime.fromISO(_data["lastChangeDateTime"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserOutlookCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOutlookCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemEventId"] = this.systemEventId;
        data["userId"] = this.userId;
        data["outlookEventId"] = this.outlookEventId;
        data["outlookEventDetails"] = this.outlookEventDetails;
        data["outlookEventItem"] = this.outlookEventItem ? this.outlookEventItem.toJSON() : undefined as any;
        data["lastChangeDateTime"] = this.lastChangeDateTime ? this.lastChangeDateTime.toString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserOutlookCalendarEventDto {
    systemEventId: number | undefined;
    userId: number;
    outlookEventId: string | undefined;
    outlookEventDetails: string | undefined;
    outlookEventItem: OutlookCalendarEventItem;
    lastChangeDateTime: DateTime;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPasswordSettingsEditDto implements IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange!: boolean;
    checkingLastXPasswordCount!: number;
    enablePasswordExpiration!: boolean;
    passwordExpirationDayCount!: number;

    constructor(data?: IUserPasswordSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableCheckingLastXPasswordWhenPasswordChange = _data["enableCheckingLastXPasswordWhenPasswordChange"];
            this.checkingLastXPasswordCount = _data["checkingLastXPasswordCount"];
            this.enablePasswordExpiration = _data["enablePasswordExpiration"];
            this.passwordExpirationDayCount = _data["passwordExpirationDayCount"];
        }
    }

    static fromJS(data: any): UserPasswordSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableCheckingLastXPasswordWhenPasswordChange"] = this.enableCheckingLastXPasswordWhenPasswordChange;
        data["checkingLastXPasswordCount"] = this.checkingLastXPasswordCount;
        data["enablePasswordExpiration"] = this.enablePasswordExpiration;
        data["passwordExpirationDayCount"] = this.passwordExpirationDayCount;
        return data;
    }
}

export interface IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange: boolean;
    checkingLastXPasswordCount: number;
    enablePasswordExpiration: boolean;
    passwordExpirationDayCount: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId!: number;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserProjectAllocationDto implements IUserProjectAllocationDto {
    id!: number;
    projectTeamId!: number | undefined;
    userId!: number;
    projectId!: number;
    projectName!: string | undefined;
    isBillable!: boolean;
    allocationPercentage!: number;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    description!: string | undefined;

    constructor(data?: IUserProjectAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectTeamId = _data["projectTeamId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.isBillable = _data["isBillable"];
            this.allocationPercentage = _data["allocationPercentage"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UserProjectAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectTeamId"] = this.projectTeamId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["isBillable"] = this.isBillable;
        data["allocationPercentage"] = this.allocationPercentage;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["description"] = this.description;
        return data;
    }
}

export interface IUserProjectAllocationDto {
    id: number;
    projectTeamId: number | undefined;
    userId: number;
    projectId: number;
    projectName: string | undefined;
    isBillable: boolean;
    allocationPercentage: number;
    startDate: DateTime;
    endDate: DateTime | undefined;
    description: string | undefined;
}

export class UserProjectManagerDto implements IUserProjectManagerDto {
    userId!: number;
    userName!: string | undefined;
    projects!: UserProjectManagerItemDto[] | undefined;

    constructor(data?: IUserProjectManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(UserProjectManagerItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProjectManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserProjectManagerDto {
    userId: number;
    userName: string | undefined;
    projects: UserProjectManagerItemDto[] | undefined;
}

export class UserProjectManagerItemDto implements IUserProjectManagerItemDto {
    projectId!: number;
    projectName!: string | undefined;
    managerIds!: number[] | undefined;
    managerNames!: string[] | undefined;
    isRecentlyChanged!: boolean;
    isRecentlyAdded!: boolean;
    isRecentlyRemoved!: boolean;
    isManagerRecentlyChanged!: boolean;
    previousManagerNames!: string[] | undefined;
    changedTime!: DateTime | undefined;

    constructor(data?: IUserProjectManagerItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["managerIds"])) {
                this.managerIds = [] as any;
                for (let item of _data["managerIds"])
                    this.managerIds!.push(item);
            }
            if (Array.isArray(_data["managerNames"])) {
                this.managerNames = [] as any;
                for (let item of _data["managerNames"])
                    this.managerNames!.push(item);
            }
            this.isRecentlyChanged = _data["isRecentlyChanged"];
            this.isRecentlyAdded = _data["isRecentlyAdded"];
            this.isRecentlyRemoved = _data["isRecentlyRemoved"];
            this.isManagerRecentlyChanged = _data["isManagerRecentlyChanged"];
            if (Array.isArray(_data["previousManagerNames"])) {
                this.previousManagerNames = [] as any;
                for (let item of _data["previousManagerNames"])
                    this.previousManagerNames!.push(item);
            }
            this.changedTime = _data["changedTime"] ? DateTime.fromISO(_data["changedTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserProjectManagerItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectManagerItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.managerIds)) {
            data["managerIds"] = [];
            for (let item of this.managerIds)
                data["managerIds"].push(item);
        }
        if (Array.isArray(this.managerNames)) {
            data["managerNames"] = [];
            for (let item of this.managerNames)
                data["managerNames"].push(item);
        }
        data["isRecentlyChanged"] = this.isRecentlyChanged;
        data["isRecentlyAdded"] = this.isRecentlyAdded;
        data["isRecentlyRemoved"] = this.isRecentlyRemoved;
        data["isManagerRecentlyChanged"] = this.isManagerRecentlyChanged;
        if (Array.isArray(this.previousManagerNames)) {
            data["previousManagerNames"] = [];
            for (let item of this.previousManagerNames)
                data["previousManagerNames"].push(item);
        }
        data["changedTime"] = this.changedTime ? this.changedTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserProjectManagerItemDto {
    projectId: number;
    projectName: string | undefined;
    managerIds: number[] | undefined;
    managerNames: string[] | undefined;
    isRecentlyChanged: boolean;
    isRecentlyAdded: boolean;
    isRecentlyRemoved: boolean;
    isManagerRecentlyChanged: boolean;
    previousManagerNames: string[] | undefined;
    changedTime: DateTime | undefined;
}

export class UserProjectTask implements IUserProjectTask {
    projectId!: number | undefined;
    project!: Projects;
    taskName!: string;
    assignedUserId!: number;
    assignedUser!: User;
    taskStateId!: number | undefined;
    taskState!: TaskState;
    repoSteps!: string | undefined;
    systemInformation!: string | undefined;
    taskPriorityId!: number | undefined;
    taskPriority!: TaskPriority;
    taskSeverityId!: number | undefined;
    taskSeverity!: TaskSeverity;
    taskActivityId!: number | undefined;
    taskActivity!: TaskActivity;
    originalEstimatedHours!: number | undefined;
    remainingHours!: number | undefined;
    completedHours!: number | undefined;
    totalTrackedTime!: number;
    comments!: string | undefined;
    recentTasktStartTime!: DateTime | undefined;
    recentTasktStopTime!: DateTime | undefined;
    tenantId!: number | undefined;
    isManualTimesheet!: boolean;
    billabilityStatus!: number | undefined;
    userId!: number | undefined;
    projectBillingType!: ProjectBillingType;
    isOverdueMailSent!: boolean;
    taskWorkTypeId!: WorkItemTypeEnum;
    devOpsTaskId!: number | undefined;
    isOutlooktask!: boolean;
    taskJobId!: number | undefined;
    taskJob!: TaskJob;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserProjectTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Projects.fromJS(_data["project"]) : undefined as any;
            this.taskName = _data["taskName"];
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUser = _data["assignedUser"] ? User.fromJS(_data["assignedUser"]) : undefined as any;
            this.taskStateId = _data["taskStateId"];
            this.taskState = _data["taskState"] ? TaskState.fromJS(_data["taskState"]) : undefined as any;
            this.repoSteps = _data["repoSteps"];
            this.systemInformation = _data["systemInformation"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskPriority = _data["taskPriority"] ? TaskPriority.fromJS(_data["taskPriority"]) : undefined as any;
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskSeverity = _data["taskSeverity"] ? TaskSeverity.fromJS(_data["taskSeverity"]) : undefined as any;
            this.taskActivityId = _data["taskActivityId"];
            this.taskActivity = _data["taskActivity"] ? TaskActivity.fromJS(_data["taskActivity"]) : undefined as any;
            this.originalEstimatedHours = _data["originalEstimatedHours"];
            this.remainingHours = _data["remainingHours"];
            this.completedHours = _data["completedHours"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.comments = _data["comments"];
            this.recentTasktStartTime = _data["recentTasktStartTime"] ? DateTime.fromISO(_data["recentTasktStartTime"].toString()) : undefined as any;
            this.recentTasktStopTime = _data["recentTasktStopTime"] ? DateTime.fromISO(_data["recentTasktStopTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.isManualTimesheet = _data["isManualTimesheet"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.userId = _data["userId"];
            this.projectBillingType = _data["projectBillingType"];
            this.isOverdueMailSent = _data["isOverdueMailSent"];
            this.taskWorkTypeId = _data["taskWorkTypeId"];
            this.devOpsTaskId = _data["devOpsTaskId"];
            this.isOutlooktask = _data["isOutlooktask"];
            this.taskJobId = _data["taskJobId"];
            this.taskJob = _data["taskJob"] ? TaskJob.fromJS(_data["taskJob"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProjectTask {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["taskName"] = this.taskName;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : undefined as any;
        data["taskStateId"] = this.taskStateId;
        data["taskState"] = this.taskState ? this.taskState.toJSON() : undefined as any;
        data["repoSteps"] = this.repoSteps;
        data["systemInformation"] = this.systemInformation;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskPriority"] = this.taskPriority ? this.taskPriority.toJSON() : undefined as any;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskSeverity"] = this.taskSeverity ? this.taskSeverity.toJSON() : undefined as any;
        data["taskActivityId"] = this.taskActivityId;
        data["taskActivity"] = this.taskActivity ? this.taskActivity.toJSON() : undefined as any;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        data["remainingHours"] = this.remainingHours;
        data["completedHours"] = this.completedHours;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["comments"] = this.comments;
        data["recentTasktStartTime"] = this.recentTasktStartTime ? this.recentTasktStartTime.toString() : undefined as any;
        data["recentTasktStopTime"] = this.recentTasktStopTime ? this.recentTasktStopTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["isManualTimesheet"] = this.isManualTimesheet;
        data["billabilityStatus"] = this.billabilityStatus;
        data["userId"] = this.userId;
        data["projectBillingType"] = this.projectBillingType;
        data["isOverdueMailSent"] = this.isOverdueMailSent;
        data["taskWorkTypeId"] = this.taskWorkTypeId;
        data["devOpsTaskId"] = this.devOpsTaskId;
        data["isOutlooktask"] = this.isOutlooktask;
        data["taskJobId"] = this.taskJobId;
        data["taskJob"] = this.taskJob ? this.taskJob.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserProjectTask {
    projectId: number | undefined;
    project: Projects;
    taskName: string;
    assignedUserId: number;
    assignedUser: User;
    taskStateId: number | undefined;
    taskState: TaskState;
    repoSteps: string | undefined;
    systemInformation: string | undefined;
    taskPriorityId: number | undefined;
    taskPriority: TaskPriority;
    taskSeverityId: number | undefined;
    taskSeverity: TaskSeverity;
    taskActivityId: number | undefined;
    taskActivity: TaskActivity;
    originalEstimatedHours: number | undefined;
    remainingHours: number | undefined;
    completedHours: number | undefined;
    totalTrackedTime: number;
    comments: string | undefined;
    recentTasktStartTime: DateTime | undefined;
    recentTasktStopTime: DateTime | undefined;
    tenantId: number | undefined;
    isManualTimesheet: boolean;
    billabilityStatus: number | undefined;
    userId: number | undefined;
    projectBillingType: ProjectBillingType;
    isOverdueMailSent: boolean;
    taskWorkTypeId: WorkItemTypeEnum;
    devOpsTaskId: number | undefined;
    isOutlooktask: boolean;
    taskJobId: number | undefined;
    taskJob: TaskJob;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserProjectTaskDetailsDto implements IUserProjectTaskDetailsDto {
    totalProjects!: number;
    totalTrackedTime!: string;
    arrivalTime!: DateTime;
    timeAtWork!: string;

    constructor(data?: IUserProjectTaskDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProjects = _data["totalProjects"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.arrivalTime = _data["arrivalTime"] ? DateTime.fromISO(_data["arrivalTime"].toString()) : undefined as any;
            this.timeAtWork = _data["timeAtWork"];
        }
    }

    static fromJS(data: any): UserProjectTaskDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProjects"] = this.totalProjects;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["arrivalTime"] = this.arrivalTime ? this.arrivalTime.toString() : undefined as any;
        data["timeAtWork"] = this.timeAtWork;
        return data;
    }
}

export interface IUserProjectTaskDetailsDto {
    totalProjects: number;
    totalTrackedTime: string;
    arrivalTime: DateTime;
    timeAtWork: string;
}

export class UserProjectTaskDto implements IUserProjectTaskDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    projectDescription!: string | undefined;
    esstimatedhours!: number;
    loggedhours!: number;
    remainingHours!: number;
    projectImage!: string | undefined;
    totalTime!: string;
    userStatusId!: UserStatusEnum;
    userTaskList!: UserTaskDto[] | undefined;
    taskList!: TaskDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IUserProjectTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectDescription = _data["projectDescription"];
            this.esstimatedhours = _data["esstimatedhours"];
            this.loggedhours = _data["loggedhours"];
            this.remainingHours = _data["remainingHours"];
            this.projectImage = _data["projectImage"];
            this.totalTime = _data["totalTime"];
            this.userStatusId = _data["userStatusId"];
            if (Array.isArray(_data["userTaskList"])) {
                this.userTaskList = [] as any;
                for (let item of _data["userTaskList"])
                    this.userTaskList!.push(UserTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["taskList"])) {
                this.taskList = [] as any;
                for (let item of _data["taskList"])
                    this.taskList!.push(TaskDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProjectTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectDescription"] = this.projectDescription;
        data["esstimatedhours"] = this.esstimatedhours;
        data["loggedhours"] = this.loggedhours;
        data["remainingHours"] = this.remainingHours;
        data["projectImage"] = this.projectImage;
        data["totalTime"] = this.totalTime;
        data["userStatusId"] = this.userStatusId;
        if (Array.isArray(this.userTaskList)) {
            data["userTaskList"] = [];
            for (let item of this.userTaskList)
                data["userTaskList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taskList)) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserProjectTaskDto {
    projectId: number | undefined;
    projectName: string | undefined;
    projectDescription: string | undefined;
    esstimatedhours: number;
    loggedhours: number;
    remainingHours: number;
    projectImage: string | undefined;
    totalTime: string;
    userStatusId: UserStatusEnum;
    userTaskList: UserTaskDto[] | undefined;
    taskList: TaskDto[] | undefined;
    id: number | undefined;
}

export class UserProjectTaskInputDto implements IUserProjectTaskInputDto {
    projectId!: number;
    taskName!: string | undefined;
    assignedUserId!: number;
    taskStateId!: number | undefined;
    repoSteps!: string | undefined;
    systemInformation!: string | undefined;
    userProjectTaskId!: number | undefined;
    taskPriorityId!: number | undefined;
    taskSeverityId!: number | undefined;
    taskActivityId!: number | undefined;
    originalEstimatedHours!: number | undefined;
    remainingHours!: number | undefined;
    completedHours!: number | undefined;
    comments!: string | undefined;
    totalTrackedTime!: string | undefined;
    startTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    billabilityStatus!: number | undefined;
    projectBillingType!: ProjectBillingType;
    previousUserId!: number | undefined;
    taskWorkTypeId!: WorkItemTypeEnum;
    files!: AddAttachmentInput[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserProjectTaskInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.taskName = _data["taskName"];
            this.assignedUserId = _data["assignedUserId"];
            this.taskStateId = _data["taskStateId"];
            this.repoSteps = _data["repoSteps"];
            this.systemInformation = _data["systemInformation"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.originalEstimatedHours = _data["originalEstimatedHours"];
            this.remainingHours = _data["remainingHours"];
            this.completedHours = _data["completedHours"];
            this.comments = _data["comments"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.projectBillingType = _data["projectBillingType"];
            this.previousUserId = _data["previousUserId"];
            this.taskWorkTypeId = _data["taskWorkTypeId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AddAttachmentInput.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProjectTaskInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["taskName"] = this.taskName;
        data["assignedUserId"] = this.assignedUserId;
        data["taskStateId"] = this.taskStateId;
        data["repoSteps"] = this.repoSteps;
        data["systemInformation"] = this.systemInformation;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskActivityId"] = this.taskActivityId;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        data["remainingHours"] = this.remainingHours;
        data["completedHours"] = this.completedHours;
        data["comments"] = this.comments;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["billabilityStatus"] = this.billabilityStatus;
        data["projectBillingType"] = this.projectBillingType;
        data["previousUserId"] = this.previousUserId;
        data["taskWorkTypeId"] = this.taskWorkTypeId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserProjectTaskInputDto {
    projectId: number;
    taskName: string | undefined;
    assignedUserId: number;
    taskStateId: number | undefined;
    repoSteps: string | undefined;
    systemInformation: string | undefined;
    userProjectTaskId: number | undefined;
    taskPriorityId: number | undefined;
    taskSeverityId: number | undefined;
    taskActivityId: number | undefined;
    originalEstimatedHours: number | undefined;
    remainingHours: number | undefined;
    completedHours: number | undefined;
    comments: string | undefined;
    totalTrackedTime: string | undefined;
    startTime: DateTime | undefined;
    endTime: DateTime | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    billabilityStatus: number | undefined;
    projectBillingType: ProjectBillingType;
    previousUserId: number | undefined;
    taskWorkTypeId: WorkItemTypeEnum;
    files: AddAttachmentInput[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserProjectTaskInputDtoForMobile implements IUserProjectTaskInputDtoForMobile {
    projectId!: number;
    taskName!: string | undefined;
    assignedUserId!: number;
    taskStateId!: number | undefined;
    repoSteps!: string | undefined;
    systemInformation!: string | undefined;
    userProjectTaskId!: number | undefined;
    taskPriorityId!: number | undefined;
    taskSeverityId!: number | undefined;
    taskActivityId!: number | undefined;
    originalEstimatedHours!: number | undefined;
    remainingHours!: number | undefined;
    completedHours!: number | undefined;
    comments!: string | undefined;
    totalTrackedTime!: string | undefined;
    startTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    billabilityStatus!: number | undefined;
    projectBillingType!: ProjectBillingType;
    files!: AddAttachmentInput[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserProjectTaskInputDtoForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.taskName = _data["taskName"];
            this.assignedUserId = _data["assignedUserId"];
            this.taskStateId = _data["taskStateId"];
            this.repoSteps = _data["repoSteps"];
            this.systemInformation = _data["systemInformation"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.originalEstimatedHours = _data["originalEstimatedHours"];
            this.remainingHours = _data["remainingHours"];
            this.completedHours = _data["completedHours"];
            this.comments = _data["comments"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.projectBillingType = _data["projectBillingType"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AddAttachmentInput.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProjectTaskInputDtoForMobile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskInputDtoForMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["taskName"] = this.taskName;
        data["assignedUserId"] = this.assignedUserId;
        data["taskStateId"] = this.taskStateId;
        data["repoSteps"] = this.repoSteps;
        data["systemInformation"] = this.systemInformation;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskActivityId"] = this.taskActivityId;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        data["remainingHours"] = this.remainingHours;
        data["completedHours"] = this.completedHours;
        data["comments"] = this.comments;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["billabilityStatus"] = this.billabilityStatus;
        data["projectBillingType"] = this.projectBillingType;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserProjectTaskInputDtoForMobile {
    projectId: number;
    taskName: string | undefined;
    assignedUserId: number;
    taskStateId: number | undefined;
    repoSteps: string | undefined;
    systemInformation: string | undefined;
    userProjectTaskId: number | undefined;
    taskPriorityId: number | undefined;
    taskSeverityId: number | undefined;
    taskActivityId: number | undefined;
    originalEstimatedHours: number | undefined;
    remainingHours: number | undefined;
    completedHours: number | undefined;
    comments: string | undefined;
    totalTrackedTime: string | undefined;
    startTime: DateTime | undefined;
    endTime: DateTime | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    billabilityStatus: number | undefined;
    projectBillingType: ProjectBillingType;
    files: AddAttachmentInput[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserProjectTaskInputFromAgentDto implements IUserProjectTaskInputFromAgentDto {
    projectId!: number;
    taskName!: string | undefined;
    taskStateId!: number | undefined;
    repoSteps!: string | undefined;
    userProjectTaskId!: number | undefined;
    taskPriorityId!: number | undefined;
    taskSeverityId!: number | undefined;
    taskActivityId!: number | undefined;
    originalEstimatedHours!: number | undefined;
    remainingHours!: number | undefined;
    completedHours!: number | undefined;
    comments!: string | undefined;
    totalTrackedTime!: string | undefined;
    startTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    billabilityStatus!: number | undefined;
    projectName!: string | undefined;
    userProfileImage!: string | undefined;

    constructor(data?: IUserProjectTaskInputFromAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.taskName = _data["taskName"];
            this.taskStateId = _data["taskStateId"];
            this.repoSteps = _data["repoSteps"];
            this.userProjectTaskId = _data["userProjectTaskId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.originalEstimatedHours = _data["originalEstimatedHours"];
            this.remainingHours = _data["remainingHours"];
            this.completedHours = _data["completedHours"];
            this.comments = _data["comments"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.projectName = _data["projectName"];
            this.userProfileImage = _data["userProfileImage"];
        }
    }

    static fromJS(data: any): UserProjectTaskInputFromAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskInputFromAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["taskName"] = this.taskName;
        data["taskStateId"] = this.taskStateId;
        data["repoSteps"] = this.repoSteps;
        data["userProjectTaskId"] = this.userProjectTaskId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskActivityId"] = this.taskActivityId;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        data["remainingHours"] = this.remainingHours;
        data["completedHours"] = this.completedHours;
        data["comments"] = this.comments;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["billabilityStatus"] = this.billabilityStatus;
        data["projectName"] = this.projectName;
        data["userProfileImage"] = this.userProfileImage;
        return data;
    }
}

export interface IUserProjectTaskInputFromAgentDto {
    projectId: number;
    taskName: string | undefined;
    taskStateId: number | undefined;
    repoSteps: string | undefined;
    userProjectTaskId: number | undefined;
    taskPriorityId: number | undefined;
    taskSeverityId: number | undefined;
    taskActivityId: number | undefined;
    originalEstimatedHours: number | undefined;
    remainingHours: number | undefined;
    completedHours: number | undefined;
    comments: string | undefined;
    totalTrackedTime: string | undefined;
    startTime: DateTime | undefined;
    endTime: DateTime | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    billabilityStatus: number | undefined;
    projectName: string | undefined;
    userProfileImage: string | undefined;
}

export class UserProjectTaskListDto implements IUserProjectTaskListDto {
    projectName!: string | undefined;
    projectImage!: string | undefined;
    taskName!: string | undefined;
    taskDescription!: string | undefined;
    taskStateId!: number | undefined;
    taskStatusId!: number | undefined;
    startTime!: DateTime | undefined;
    endTime!: DateTime | undefined;

    constructor(data?: IUserProjectTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.taskName = _data["taskName"];
            this.taskDescription = _data["taskDescription"];
            this.taskStateId = _data["taskStateId"];
            this.taskStatusId = _data["taskStatusId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserProjectTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["taskName"] = this.taskName;
        data["taskDescription"] = this.taskDescription;
        data["taskStateId"] = this.taskStateId;
        data["taskStatusId"] = this.taskStatusId;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserProjectTaskListDto {
    projectName: string | undefined;
    projectImage: string | undefined;
    taskName: string | undefined;
    taskDescription: string | undefined;
    taskStateId: number | undefined;
    taskStatusId: number | undefined;
    startTime: DateTime | undefined;
    endTime: DateTime | undefined;
}

export class UserProjectTaskLiveStreamingDto implements IUserProjectTaskLiveStreamingDto {
    id!: number;
    assignedUserId!: number;
    tenantId!: number | undefined;
    taskName!: string | undefined;
    comments!: string | undefined;
    taskStateId!: number | undefined;
    originalEstimatedHours!: number | undefined;

    constructor(data?: IUserProjectTaskLiveStreamingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedUserId = _data["assignedUserId"];
            this.tenantId = _data["tenantId"];
            this.taskName = _data["taskName"];
            this.comments = _data["comments"];
            this.taskStateId = _data["taskStateId"];
            this.originalEstimatedHours = _data["originalEstimatedHours"];
        }
    }

    static fromJS(data: any): UserProjectTaskLiveStreamingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProjectTaskLiveStreamingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedUserId"] = this.assignedUserId;
        data["tenantId"] = this.tenantId;
        data["taskName"] = this.taskName;
        data["comments"] = this.comments;
        data["taskStateId"] = this.taskStateId;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        return data;
    }
}

export interface IUserProjectTaskLiveStreamingDto {
    id: number;
    assignedUserId: number;
    tenantId: number | undefined;
    taskName: string | undefined;
    comments: string | undefined;
    taskStateId: number | undefined;
    originalEstimatedHours: number | undefined;
}

export class UserRealTimeLocationCreateOrEditDto implements IUserRealTimeLocationCreateOrEditDto {
    latitude!: string | undefined;
    longitude!: string | undefined;
    usersId!: number;
    sublocality!: string | undefined;
    lastModifiedDate!: string | undefined;
    tenantId!: number;
    city!: string | undefined;
    state!: string | undefined;
    postcode!: string | undefined;
    country!: string | undefined;
    country_code!: string | undefined;
    exiteDateTime!: DateTime | undefined;
    spendTime!: string | undefined;
    timezoneAbbreviation!: string | undefined;
    timezoneFullString!: string | undefined;
    timezoneInGMT!: string | undefined;
    userName!: string | undefined;
    surname!: string | undefined;
    creationTime!: DateTime;
    workFromType!: WorkFromType;
    id!: number;

    constructor(data?: IUserRealTimeLocationCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.usersId = _data["usersId"];
            this.sublocality = _data["sublocality"];
            this.lastModifiedDate = _data["lastModifiedDate"];
            this.tenantId = _data["tenantId"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postcode = _data["postcode"];
            this.country = _data["country"];
            this.country_code = _data["country_code"];
            this.exiteDateTime = _data["exiteDateTime"] ? DateTime.fromISO(_data["exiteDateTime"].toString()) : undefined as any;
            this.spendTime = _data["spendTime"];
            this.timezoneAbbreviation = _data["timezoneAbbreviation"];
            this.timezoneFullString = _data["timezoneFullString"];
            this.timezoneInGMT = _data["timezoneInGMT"];
            this.userName = _data["userName"];
            this.surname = _data["surname"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.workFromType = _data["workFromType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRealTimeLocationCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRealTimeLocationCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["usersId"] = this.usersId;
        data["sublocality"] = this.sublocality;
        data["lastModifiedDate"] = this.lastModifiedDate;
        data["tenantId"] = this.tenantId;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["country"] = this.country;
        data["country_code"] = this.country_code;
        data["exiteDateTime"] = this.exiteDateTime ? this.exiteDateTime.toString() : undefined as any;
        data["spendTime"] = this.spendTime;
        data["timezoneAbbreviation"] = this.timezoneAbbreviation;
        data["timezoneFullString"] = this.timezoneFullString;
        data["timezoneInGMT"] = this.timezoneInGMT;
        data["userName"] = this.userName;
        data["surname"] = this.surname;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["workFromType"] = this.workFromType;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserRealTimeLocationCreateOrEditDto {
    latitude: string | undefined;
    longitude: string | undefined;
    usersId: number;
    sublocality: string | undefined;
    lastModifiedDate: string | undefined;
    tenantId: number;
    city: string | undefined;
    state: string | undefined;
    postcode: string | undefined;
    country: string | undefined;
    country_code: string | undefined;
    exiteDateTime: DateTime | undefined;
    spendTime: string | undefined;
    timezoneAbbreviation: string | undefined;
    timezoneFullString: string | undefined;
    timezoneInGMT: string | undefined;
    userName: string | undefined;
    surname: string | undefined;
    creationTime: DateTime;
    workFromType: WorkFromType;
    id: number;
}

export class UserReminderDto implements IUserReminderDto {
    timesheetId!: number;
    userId!: number;
    userImage!: string | undefined;
    userName!: string | undefined;
    userRole!: string | undefined;
    timesheetStatus!: TimesheetAndApprovalStatusEnum;

    constructor(data?: IUserReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheetId = _data["timesheetId"];
            this.userId = _data["userId"];
            this.userImage = _data["userImage"];
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.timesheetStatus = _data["timesheetStatus"];
        }
    }

    static fromJS(data: any): UserReminderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReminderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheetId"] = this.timesheetId;
        data["userId"] = this.userId;
        data["userImage"] = this.userImage;
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["timesheetStatus"] = this.timesheetStatus;
        return data;
    }
}

export interface IUserReminderDto {
    timesheetId: number;
    userId: number;
    userImage: string | undefined;
    userName: string | undefined;
    userRole: string | undefined;
    timesheetStatus: TimesheetAndApprovalStatusEnum;
}

export class UserRole implements IUserRole {
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class UserScreenShotCountBasedOnSlot implements IUserScreenShotCountBasedOnSlot {
    userName!: string | undefined;
    usereEmail!: string | undefined;
    intervalStart!: string;
    intervalEnd!: string;
    screenShotCount!: number;

    constructor(data?: IUserScreenShotCountBasedOnSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.usereEmail = _data["usereEmail"];
            this.intervalStart = _data["intervalStart"];
            this.intervalEnd = _data["intervalEnd"];
            this.screenShotCount = _data["screenShotCount"];
        }
    }

    static fromJS(data: any): UserScreenShotCountBasedOnSlot {
        data = typeof data === 'object' ? data : {};
        let result = new UserScreenShotCountBasedOnSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["usereEmail"] = this.usereEmail;
        data["intervalStart"] = this.intervalStart;
        data["intervalEnd"] = this.intervalEnd;
        data["screenShotCount"] = this.screenShotCount;
        return data;
    }
}

export interface IUserScreenShotCountBasedOnSlot {
    userName: string | undefined;
    usereEmail: string | undefined;
    intervalStart: string;
    intervalEnd: string;
    screenShotCount: number;
}

export class UserScreenShotCountBasedOnSlotGroup implements IUserScreenShotCountBasedOnSlotGroup {
    intervalStart!: string;
    intervalEnd!: string;
    listOfUser!: UserScreenShotCountBasedOnSlot[] | undefined;

    constructor(data?: IUserScreenShotCountBasedOnSlotGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intervalStart = _data["intervalStart"];
            this.intervalEnd = _data["intervalEnd"];
            if (Array.isArray(_data["listOfUser"])) {
                this.listOfUser = [] as any;
                for (let item of _data["listOfUser"])
                    this.listOfUser!.push(UserScreenShotCountBasedOnSlot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserScreenShotCountBasedOnSlotGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserScreenShotCountBasedOnSlotGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intervalStart"] = this.intervalStart;
        data["intervalEnd"] = this.intervalEnd;
        if (Array.isArray(this.listOfUser)) {
            data["listOfUser"] = [];
            for (let item of this.listOfUser)
                data["listOfUser"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserScreenShotCountBasedOnSlotGroup {
    intervalStart: string;
    intervalEnd: string;
    listOfUser: UserScreenShotCountBasedOnSlot[] | undefined;
}

export class UserServerDateAndTimezone implements IUserServerDateAndTimezone {
    serverDate!: DateTime;
    userTimeZone!: string | undefined;

    constructor(data?: IUserServerDateAndTimezone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverDate = _data["serverDate"] ? DateTime.fromISO(_data["serverDate"].toString()) : undefined as any;
            this.userTimeZone = _data["userTimeZone"];
        }
    }

    static fromJS(data: any): UserServerDateAndTimezone {
        data = typeof data === 'object' ? data : {};
        let result = new UserServerDateAndTimezone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverDate"] = this.serverDate ? this.serverDate.toString() : undefined as any;
        data["userTimeZone"] = this.userTimeZone;
        return data;
    }
}

export interface IUserServerDateAndTimezone {
    serverDate: DateTime;
    userTimeZone: string | undefined;
}

export class UserStatus implements IUserStatus {
    tenantId!: number;
    statusStartDate!: DateTime;
    statusEndDate!: DateTime;
    userId!: number | undefined;
    userStatusId!: UserStatusEnum;
    employee!: User;
    statusStartTime!: string | undefined;
    statusEndTime!: string | undefined;
    totalTime!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.statusStartDate = _data["statusStartDate"] ? DateTime.fromISO(_data["statusStartDate"].toString()) : undefined as any;
            this.statusEndDate = _data["statusEndDate"] ? DateTime.fromISO(_data["statusEndDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.userStatusId = _data["userStatusId"];
            this.employee = _data["employee"] ? User.fromJS(_data["employee"]) : undefined as any;
            this.statusStartTime = _data["statusStartTime"];
            this.statusEndTime = _data["statusEndTime"];
            this.totalTime = _data["totalTime"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toString() : undefined as any;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["userStatusId"] = this.userStatusId;
        data["employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        data["statusStartTime"] = this.statusStartTime;
        data["statusEndTime"] = this.statusEndTime;
        data["totalTime"] = this.totalTime;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserStatus {
    tenantId: number;
    statusStartDate: DateTime;
    statusEndDate: DateTime;
    userId: number | undefined;
    userStatusId: UserStatusEnum;
    employee: User;
    statusStartTime: string | undefined;
    statusEndTime: string | undefined;
    totalTime: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserStatusDto implements IUserStatusDto {
    tenantId!: number;
    statusStartDate!: DateTime;
    statusEndDate!: DateTime;
    userId!: number | undefined;
    userStatusId!: UserStatusEnum;
    statusStartTime!: string | undefined;
    statusEndTime!: string | undefined;
    totalHours!: string | undefined;
    creationTime!: DateTime;
    id!: number | undefined;

    constructor(data?: IUserStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.statusStartDate = _data["statusStartDate"] ? DateTime.fromISO(_data["statusStartDate"].toString()) : undefined as any;
            this.statusEndDate = _data["statusEndDate"] ? DateTime.fromISO(_data["statusEndDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.userStatusId = _data["userStatusId"];
            this.statusStartTime = _data["statusStartTime"];
            this.statusEndTime = _data["statusEndTime"];
            this.totalHours = _data["totalHours"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toString() : undefined as any;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toString() : undefined as any;
        data["userId"] = this.userId;
        data["userStatusId"] = this.userStatusId;
        data["statusStartTime"] = this.statusStartTime;
        data["statusEndTime"] = this.statusEndTime;
        data["totalHours"] = this.totalHours;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserStatusDto {
    tenantId: number;
    statusStartDate: DateTime;
    statusEndDate: DateTime;
    userId: number | undefined;
    userStatusId: UserStatusEnum;
    statusStartTime: string | undefined;
    statusEndTime: string | undefined;
    totalHours: string | undefined;
    creationTime: DateTime;
    id: number | undefined;
}

export enum UserStatusEnum {
    Busy = 1,
    Idle = 2,
    Meeting = 3,
    Online = 4,
    Offline = 5,
    PrivateTime = 6,
}

export class UserTaskDto implements IUserTaskDto {
    taskId!: number;
    taskName!: string | undefined;
    taskDescription!: string | undefined;
    totalTrackedTime!: number;
    taskStateId!: number | undefined;
    taskStatusId!: number | undefined;
    startTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    originalEstimatedHours!: number | undefined;
    assignedUserId!: number;
    assignedToUserName!: string | undefined;
    assignedToUserRole!: string | undefined;
    assignedToUserStatus!: UserStatusEnum;
    assignedToUserImage!: string | undefined;
    billableType!: ProjectBillingType;
    isManualTimesheet!: boolean;
    billabilityStatus!: number | undefined;
    agentTotalTrackedTime!: string;
    totalCompletedHours!: string;
    agentTotalTrackedTimeString!: string | undefined;
    taskSeverityId!: number;
    taskPriorityId!: number;
    taskActivityId!: number;
    completedHours!: number | undefined;
    creationTime!: DateTime;
    updatedTime!: DateTime;
    isOutlooktask!: boolean;

    constructor(data?: IUserTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.taskDescription = _data["taskDescription"];
            this.totalTrackedTime = _data["totalTrackedTime"];
            this.taskStateId = _data["taskStateId"];
            this.taskStatusId = _data["taskStatusId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
            this.originalEstimatedHours = _data["originalEstimatedHours"];
            this.assignedUserId = _data["assignedUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.assignedToUserRole = _data["assignedToUserRole"];
            this.assignedToUserStatus = _data["assignedToUserStatus"];
            this.assignedToUserImage = _data["assignedToUserImage"];
            this.billableType = _data["billableType"];
            this.isManualTimesheet = _data["isManualTimesheet"];
            this.billabilityStatus = _data["billabilityStatus"];
            this.agentTotalTrackedTime = _data["agentTotalTrackedTime"];
            this.totalCompletedHours = _data["totalCompletedHours"];
            this.agentTotalTrackedTimeString = _data["agentTotalTrackedTimeString"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.taskActivityId = _data["taskActivityId"];
            this.completedHours = _data["completedHours"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.updatedTime = _data["updatedTime"] ? DateTime.fromISO(_data["updatedTime"].toString()) : undefined as any;
            this.isOutlooktask = _data["isOutlooktask"];
        }
    }

    static fromJS(data: any): UserTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["taskDescription"] = this.taskDescription;
        data["totalTrackedTime"] = this.totalTrackedTime;
        data["taskStateId"] = this.taskStateId;
        data["taskStatusId"] = this.taskStatusId;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["assignedToUserRole"] = this.assignedToUserRole;
        data["assignedToUserStatus"] = this.assignedToUserStatus;
        data["assignedToUserImage"] = this.assignedToUserImage;
        data["billableType"] = this.billableType;
        data["isManualTimesheet"] = this.isManualTimesheet;
        data["billabilityStatus"] = this.billabilityStatus;
        data["agentTotalTrackedTime"] = this.agentTotalTrackedTime;
        data["totalCompletedHours"] = this.totalCompletedHours;
        data["agentTotalTrackedTimeString"] = this.agentTotalTrackedTimeString;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["taskActivityId"] = this.taskActivityId;
        data["completedHours"] = this.completedHours;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["updatedTime"] = this.updatedTime ? this.updatedTime.toString() : undefined as any;
        data["isOutlooktask"] = this.isOutlooktask;
        return data;
    }
}

export interface IUserTaskDto {
    taskId: number;
    taskName: string | undefined;
    taskDescription: string | undefined;
    totalTrackedTime: number;
    taskStateId: number | undefined;
    taskStatusId: number | undefined;
    startTime: DateTime | undefined;
    endTime: DateTime | undefined;
    originalEstimatedHours: number | undefined;
    assignedUserId: number;
    assignedToUserName: string | undefined;
    assignedToUserRole: string | undefined;
    assignedToUserStatus: UserStatusEnum;
    assignedToUserImage: string | undefined;
    billableType: ProjectBillingType;
    isManualTimesheet: boolean;
    billabilityStatus: number | undefined;
    agentTotalTrackedTime: string;
    totalCompletedHours: string;
    agentTotalTrackedTimeString: string | undefined;
    taskSeverityId: number;
    taskPriorityId: number;
    taskActivityId: number;
    completedHours: number | undefined;
    creationTime: DateTime;
    updatedTime: DateTime;
    isOutlooktask: boolean;
}

export class UserTaskHistoryDetailsDto implements IUserTaskHistoryDetailsDto {
    estimatedHours!: string;
    completedHours!: string;
    estimatedHoursTotalSec!: number | undefined;
    completedHoursTotalSec!: number | undefined;
    startAndEndTimeList!: TaskHistoryStartAndEndTimeDto[] | undefined;

    constructor(data?: IUserTaskHistoryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedHours = _data["estimatedHours"];
            this.completedHours = _data["completedHours"];
            this.estimatedHoursTotalSec = _data["estimatedHoursTotalSec"];
            this.completedHoursTotalSec = _data["completedHoursTotalSec"];
            if (Array.isArray(_data["startAndEndTimeList"])) {
                this.startAndEndTimeList = [] as any;
                for (let item of _data["startAndEndTimeList"])
                    this.startAndEndTimeList!.push(TaskHistoryStartAndEndTimeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserTaskHistoryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskHistoryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedHours"] = this.estimatedHours;
        data["completedHours"] = this.completedHours;
        data["estimatedHoursTotalSec"] = this.estimatedHoursTotalSec;
        data["completedHoursTotalSec"] = this.completedHoursTotalSec;
        if (Array.isArray(this.startAndEndTimeList)) {
            data["startAndEndTimeList"] = [];
            for (let item of this.startAndEndTimeList)
                data["startAndEndTimeList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserTaskHistoryDetailsDto {
    estimatedHours: string;
    completedHours: string;
    estimatedHoursTotalSec: number | undefined;
    completedHoursTotalSec: number | undefined;
    startAndEndTimeList: TaskHistoryStartAndEndTimeDto[] | undefined;
}

export class UserTaskHistoryInput implements IUserTaskHistoryInput {
    projectTaskId!: number[] | undefined;
    userId!: number;
    isTeamTask!: boolean;

    constructor(data?: IUserTaskHistoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectTaskId"])) {
                this.projectTaskId = [] as any;
                for (let item of _data["projectTaskId"])
                    this.projectTaskId!.push(item);
            }
            this.userId = _data["userId"];
            this.isTeamTask = _data["isTeamTask"];
        }
    }

    static fromJS(data: any): UserTaskHistoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskHistoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectTaskId)) {
            data["projectTaskId"] = [];
            for (let item of this.projectTaskId)
                data["projectTaskId"].push(item);
        }
        data["userId"] = this.userId;
        data["isTeamTask"] = this.isTeamTask;
        return data;
    }
}

export interface IUserTaskHistoryInput {
    projectTaskId: number[] | undefined;
    userId: number;
    isTeamTask: boolean;
}

export class UserTaskInputDto implements IUserTaskInputDto {
    projectTaskId!: number;
    projectId!: number;
    isTimerStopped!: boolean;
    tenantId!: number;
    userId!: number;
    taskstateId!: number;
    isBagroundJoCall!: boolean;
    creationTime!: DateTime | undefined;

    constructor(data?: IUserTaskInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTaskId = _data["projectTaskId"];
            this.projectId = _data["projectId"];
            this.isTimerStopped = _data["isTimerStopped"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.taskstateId = _data["taskstateId"];
            this.isBagroundJoCall = _data["isBagroundJoCall"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserTaskInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTaskId"] = this.projectTaskId;
        data["projectId"] = this.projectId;
        data["isTimerStopped"] = this.isTimerStopped;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["taskstateId"] = this.taskstateId;
        data["isBagroundJoCall"] = this.isBagroundJoCall;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserTaskInputDto {
    projectTaskId: number;
    projectId: number;
    isTimerStopped: boolean;
    tenantId: number;
    userId: number;
    taskstateId: number;
    isBagroundJoCall: boolean;
    creationTime: DateTime | undefined;
}

export class UserTaskInputDtoAgentMidNight implements IUserTaskInputDtoAgentMidNight {
    projectTaskId!: number;
    projectId!: number;
    isTimerStopped!: boolean;
    tenantId!: number;
    userId!: number;
    taskstateId!: number;
    isBagroundJoCall!: boolean;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: IUserTaskInputDtoAgentMidNight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTaskId = _data["projectTaskId"];
            this.projectId = _data["projectId"];
            this.isTimerStopped = _data["isTimerStopped"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.taskstateId = _data["taskstateId"];
            this.isBagroundJoCall = _data["isBagroundJoCall"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserTaskInputDtoAgentMidNight {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskInputDtoAgentMidNight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTaskId"] = this.projectTaskId;
        data["projectId"] = this.projectId;
        data["isTimerStopped"] = this.isTimerStopped;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["taskstateId"] = this.taskstateId;
        data["isBagroundJoCall"] = this.isBagroundJoCall;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserTaskInputDtoAgentMidNight {
    projectTaskId: number;
    projectId: number;
    isTimerStopped: boolean;
    tenantId: number;
    userId: number;
    taskstateId: number;
    isBagroundJoCall: boolean;
    startTime: DateTime;
    endTime: DateTime;
}

export class UserTaskListDashBoard implements IUserTaskListDashBoard {
    projectName!: string | undefined;
    projectImage!: string | undefined;
    taskName!: string | undefined;
    taskActivityId!: number | undefined;
    billableType!: number | undefined;
    totalCompletedHours!: number | undefined;
    taskStatusId!: number | undefined;
    taskSeverityId!: number | undefined;
    taskPriorityId!: number | undefined;
    originalEstimatedHours!: number | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserTaskListDashBoard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.taskName = _data["taskName"];
            this.taskActivityId = _data["taskActivityId"];
            this.billableType = _data["billableType"];
            this.totalCompletedHours = _data["totalCompletedHours"];
            this.taskStatusId = _data["taskStatusId"];
            this.taskSeverityId = _data["taskSeverityId"];
            this.taskPriorityId = _data["taskPriorityId"];
            this.originalEstimatedHours = _data["originalEstimatedHours"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserTaskListDashBoard {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskListDashBoard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["taskName"] = this.taskName;
        data["taskActivityId"] = this.taskActivityId;
        data["billableType"] = this.billableType;
        data["totalCompletedHours"] = this.totalCompletedHours;
        data["taskStatusId"] = this.taskStatusId;
        data["taskSeverityId"] = this.taskSeverityId;
        data["taskPriorityId"] = this.taskPriorityId;
        data["originalEstimatedHours"] = this.originalEstimatedHours;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserTaskListDashBoard {
    projectName: string | undefined;
    projectImage: string | undefined;
    taskName: string | undefined;
    taskActivityId: number | undefined;
    billableType: number | undefined;
    totalCompletedHours: number | undefined;
    taskStatusId: number | undefined;
    taskSeverityId: number | undefined;
    taskPriorityId: number | undefined;
    originalEstimatedHours: number | undefined;
    creationTime: DateTime;
}

export class UserTaskTimeCreateOrEditDto implements IUserTaskTimeCreateOrEditDto {
    tenantId!: number | undefined;
    projectTaskId!: number | undefined;
    projectId!: number | undefined;
    userId!: number | undefined;
    taskStatusId!: number | undefined;
    startDateTime!: DateTime | undefined;
    endDateTime!: DateTime | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    timeSpan!: string | undefined;
    days!: string | undefined;
    isManualTask!: boolean | undefined;
    creationDate!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUserTaskTimeCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectTaskId = _data["projectTaskId"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.taskStatusId = _data["taskStatusId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.timeSpan = _data["timeSpan"];
            this.days = _data["days"];
            this.isManualTask = _data["isManualTask"];
            this.creationDate = _data["creationDate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserTaskTimeCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskTimeCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectTaskId"] = this.projectTaskId;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["taskStatusId"] = this.taskStatusId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["timeSpan"] = this.timeSpan;
        data["days"] = this.days;
        data["isManualTask"] = this.isManualTask;
        data["creationDate"] = this.creationDate;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserTaskTimeCreateOrEditDto {
    tenantId: number | undefined;
    projectTaskId: number | undefined;
    projectId: number | undefined;
    userId: number | undefined;
    taskStatusId: number | undefined;
    startDateTime: DateTime | undefined;
    endDateTime: DateTime | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    timeSpan: string | undefined;
    days: string | undefined;
    isManualTask: boolean | undefined;
    creationDate: string | undefined;
    id: number | undefined;
}

export class UserTenantRolesDto implements IUserTenantRolesDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserTenantRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserTenantRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTenantRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserTenantRolesDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserTimeZoneDto implements IUserTimeZoneDto {
    timeZoneAbbrevation!: string | undefined;
    timeZoneFullString!: string | undefined;
    timeZoneInGMT!: string | undefined;
    id!: number;

    constructor(data?: IUserTimeZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneAbbrevation = _data["timeZoneAbbrevation"];
            this.timeZoneFullString = _data["timeZoneFullString"];
            this.timeZoneInGMT = _data["timeZoneInGMT"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserTimeZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTimeZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneAbbrevation"] = this.timeZoneAbbrevation;
        data["timeZoneFullString"] = this.timeZoneFullString;
        data["timeZoneInGMT"] = this.timeZoneInGMT;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserTimeZoneDto {
    timeZoneAbbrevation: string | undefined;
    timeZoneFullString: string | undefined;
    timeZoneInGMT: string | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: DateTime | undefined;
    id!: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: DateTime | undefined;
    id: number;
}

export class UserTrackDaySettingCreateOrEditDto implements IUserTrackDaySettingCreateOrEditDto {
    tenantId!: number | undefined;
    userId!: number;
    isTrackMon!: boolean;
    isTrackTue!: boolean;
    isTrackWed!: boolean;
    isTrackThu!: boolean;
    isTrackFri!: boolean;
    isTrackSat!: boolean;
    isTrackSun!: boolean;
    trackStartDate!: DateTime | undefined;
    trackEndDate!: DateTime | undefined;
    isFlexTrackWorkHrs!: boolean;
    id!: number | undefined;

    constructor(data?: IUserTrackDaySettingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isTrackMon = _data["isTrackMon"];
            this.isTrackTue = _data["isTrackTue"];
            this.isTrackWed = _data["isTrackWed"];
            this.isTrackThu = _data["isTrackThu"];
            this.isTrackFri = _data["isTrackFri"];
            this.isTrackSat = _data["isTrackSat"];
            this.isTrackSun = _data["isTrackSun"];
            this.trackStartDate = _data["trackStartDate"] ? DateTime.fromISO(_data["trackStartDate"].toString()) : undefined as any;
            this.trackEndDate = _data["trackEndDate"] ? DateTime.fromISO(_data["trackEndDate"].toString()) : undefined as any;
            this.isFlexTrackWorkHrs = _data["isFlexTrackWorkHrs"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserTrackDaySettingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrackDaySettingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isTrackMon"] = this.isTrackMon;
        data["isTrackTue"] = this.isTrackTue;
        data["isTrackWed"] = this.isTrackWed;
        data["isTrackThu"] = this.isTrackThu;
        data["isTrackFri"] = this.isTrackFri;
        data["isTrackSat"] = this.isTrackSat;
        data["isTrackSun"] = this.isTrackSun;
        data["trackStartDate"] = this.trackStartDate ? this.trackStartDate.toString() : undefined as any;
        data["trackEndDate"] = this.trackEndDate ? this.trackEndDate.toString() : undefined as any;
        data["isFlexTrackWorkHrs"] = this.isFlexTrackWorkHrs;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserTrackDaySettingCreateOrEditDto {
    tenantId: number | undefined;
    userId: number;
    isTrackMon: boolean;
    isTrackTue: boolean;
    isTrackWed: boolean;
    isTrackThu: boolean;
    isTrackFri: boolean;
    isTrackSat: boolean;
    isTrackSun: boolean;
    trackStartDate: DateTime | undefined;
    trackEndDate: DateTime | undefined;
    isFlexTrackWorkHrs: boolean;
    id: number | undefined;
}

export class UserTrackOtherSettingCreateOrEditDto implements IUserTrackOtherSettingCreateOrEditDto {
    tenantId!: number | undefined;
    userId!: number;
    isOwner!: boolean;
    isNwPrjCreate!: boolean;
    isPrjCost!: boolean;
    isCollSec!: boolean;
    isProjectSec!: boolean;
    isWrkSch!: boolean;
    isAbsCal!: boolean;
    isHideSS!: boolean;
    isReportSec!: boolean;
    isExptSec!: boolean;
    isHideInvSec!: boolean;
    id!: number | undefined;

    constructor(data?: IUserTrackOtherSettingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isOwner = _data["isOwner"];
            this.isNwPrjCreate = _data["isNwPrjCreate"];
            this.isPrjCost = _data["isPrjCost"];
            this.isCollSec = _data["isCollSec"];
            this.isProjectSec = _data["isProjectSec"];
            this.isWrkSch = _data["isWrkSch"];
            this.isAbsCal = _data["isAbsCal"];
            this.isHideSS = _data["isHideSS"];
            this.isReportSec = _data["isReportSec"];
            this.isExptSec = _data["isExptSec"];
            this.isHideInvSec = _data["isHideInvSec"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserTrackOtherSettingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrackOtherSettingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isOwner"] = this.isOwner;
        data["isNwPrjCreate"] = this.isNwPrjCreate;
        data["isPrjCost"] = this.isPrjCost;
        data["isCollSec"] = this.isCollSec;
        data["isProjectSec"] = this.isProjectSec;
        data["isWrkSch"] = this.isWrkSch;
        data["isAbsCal"] = this.isAbsCal;
        data["isHideSS"] = this.isHideSS;
        data["isReportSec"] = this.isReportSec;
        data["isExptSec"] = this.isExptSec;
        data["isHideInvSec"] = this.isHideInvSec;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserTrackOtherSettingCreateOrEditDto {
    tenantId: number | undefined;
    userId: number;
    isOwner: boolean;
    isNwPrjCreate: boolean;
    isPrjCost: boolean;
    isCollSec: boolean;
    isProjectSec: boolean;
    isWrkSch: boolean;
    isAbsCal: boolean;
    isHideSS: boolean;
    isReportSec: boolean;
    isExptSec: boolean;
    isHideInvSec: boolean;
    id: number | undefined;
}

export class UserTrackScreenSettingCreateOrEditDto implements IUserTrackScreenSettingCreateOrEditDto {
    tenantId!: number | undefined;
    userId!: number;
    enableScreenShot!: boolean;
    isBlurScreen!: boolean;
    captureQuality!: CaptureQualityType;
    screenCaptureInterval!: number;
    id!: number | undefined;

    constructor(data?: IUserTrackScreenSettingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.enableScreenShot = _data["enableScreenShot"];
            this.isBlurScreen = _data["isBlurScreen"];
            this.captureQuality = _data["captureQuality"];
            this.screenCaptureInterval = _data["screenCaptureInterval"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserTrackScreenSettingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrackScreenSettingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["enableScreenShot"] = this.enableScreenShot;
        data["isBlurScreen"] = this.isBlurScreen;
        data["captureQuality"] = this.captureQuality;
        data["screenCaptureInterval"] = this.screenCaptureInterval;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserTrackScreenSettingCreateOrEditDto {
    tenantId: number | undefined;
    userId: number;
    enableScreenShot: boolean;
    isBlurScreen: boolean;
    captureQuality: CaptureQualityType;
    screenCaptureInterval: number;
    id: number | undefined;
}

export class UserTrackingSettingCreateOrEditDto implements IUserTrackingSettingCreateOrEditDto {
    tenantId!: number | undefined;
    userId!: number;
    isAppTrack!: boolean;
    isUrlTrack!: boolean;
    isWinTitle!: boolean;
    isPrivateTime!: boolean;
    isMobTimeSync!: boolean;
    isMouseClick!: boolean;
    isMouseMove!: boolean;
    isCalSync!: boolean;
    idleTimeInterval!: IdleTimeIntervalType;
    offlineTime!: OfflineTimeType;
    id!: number | undefined;

    constructor(data?: IUserTrackingSettingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isAppTrack = _data["isAppTrack"];
            this.isUrlTrack = _data["isUrlTrack"];
            this.isWinTitle = _data["isWinTitle"];
            this.isPrivateTime = _data["isPrivateTime"];
            this.isMobTimeSync = _data["isMobTimeSync"];
            this.isMouseClick = _data["isMouseClick"];
            this.isMouseMove = _data["isMouseMove"];
            this.isCalSync = _data["isCalSync"];
            this.idleTimeInterval = _data["idleTimeInterval"];
            this.offlineTime = _data["offlineTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserTrackingSettingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrackingSettingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isAppTrack"] = this.isAppTrack;
        data["isUrlTrack"] = this.isUrlTrack;
        data["isWinTitle"] = this.isWinTitle;
        data["isPrivateTime"] = this.isPrivateTime;
        data["isMobTimeSync"] = this.isMobTimeSync;
        data["isMouseClick"] = this.isMouseClick;
        data["isMouseMove"] = this.isMouseMove;
        data["isCalSync"] = this.isCalSync;
        data["idleTimeInterval"] = this.idleTimeInterval;
        data["offlineTime"] = this.offlineTime;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserTrackingSettingCreateOrEditDto {
    tenantId: number | undefined;
    userId: number;
    isAppTrack: boolean;
    isUrlTrack: boolean;
    isWinTitle: boolean;
    isPrivateTime: boolean;
    isMobTimeSync: boolean;
    isMouseClick: boolean;
    isMouseMove: boolean;
    isCalSync: boolean;
    idleTimeInterval: IdleTimeIntervalType;
    offlineTime: OfflineTimeType;
    id: number | undefined;
}

export enum UserType {
    Deleted = 1,
    Archived = 2,
    Restored = 3,
}

export class UserUtilizationDashboardDto implements IUserUtilizationDashboardDto {
    totalUsers!: number;
    usersOnBench!: UserCategoryDto;
    billableUsers!: UserCategoryDto;
    nonBillableUsers!: UserCategoryDto;
    trainingUsers!: UserCategoryDto;
    partiallyEngagedUsers!: UserCategoryDto;

    constructor(data?: IUserUtilizationDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUsers = _data["totalUsers"];
            this.usersOnBench = _data["usersOnBench"] ? UserCategoryDto.fromJS(_data["usersOnBench"]) : undefined as any;
            this.billableUsers = _data["billableUsers"] ? UserCategoryDto.fromJS(_data["billableUsers"]) : undefined as any;
            this.nonBillableUsers = _data["nonBillableUsers"] ? UserCategoryDto.fromJS(_data["nonBillableUsers"]) : undefined as any;
            this.trainingUsers = _data["trainingUsers"] ? UserCategoryDto.fromJS(_data["trainingUsers"]) : undefined as any;
            this.partiallyEngagedUsers = _data["partiallyEngagedUsers"] ? UserCategoryDto.fromJS(_data["partiallyEngagedUsers"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserUtilizationDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserUtilizationDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUsers"] = this.totalUsers;
        data["usersOnBench"] = this.usersOnBench ? this.usersOnBench.toJSON() : undefined as any;
        data["billableUsers"] = this.billableUsers ? this.billableUsers.toJSON() : undefined as any;
        data["nonBillableUsers"] = this.nonBillableUsers ? this.nonBillableUsers.toJSON() : undefined as any;
        data["trainingUsers"] = this.trainingUsers ? this.trainingUsers.toJSON() : undefined as any;
        data["partiallyEngagedUsers"] = this.partiallyEngagedUsers ? this.partiallyEngagedUsers.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserUtilizationDashboardDto {
    totalUsers: number;
    usersOnBench: UserCategoryDto;
    billableUsers: UserCategoryDto;
    nonBillableUsers: UserCategoryDto;
    trainingUsers: UserCategoryDto;
    partiallyEngagedUsers: UserCategoryDto;
}

export class UserWiseLiveScreenShotDto implements IUserWiseLiveScreenShotDto {
    userId!: number;
    userName!: string | undefined;
    userImage!: string | undefined;
    userRole!: string | undefined;
    userOrgnizationName!: string | undefined;
    userLocation!: string | undefined;
    userOfficeLocation!: string | undefined;
    screenShotUrl!: string | undefined;
    projectName!: ProjectDto[] | undefined;
    projectIcon!: string | undefined;
    taskName!: string | undefined;
    taskDescription!: string | undefined;
    applicationName!: string | undefined;
    applicationIcon!: string | undefined;
    applicationType!: string | undefined;
    userStatus!: UserStatusEnum;
    leftTime!: DateTime | undefined;
    creationTime!: DateTime | undefined;

    constructor(data?: IUserWiseLiveScreenShotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userImage = _data["userImage"];
            this.userRole = _data["userRole"];
            this.userOrgnizationName = _data["userOrgnizationName"];
            this.userLocation = _data["userLocation"];
            this.userOfficeLocation = _data["userOfficeLocation"];
            this.screenShotUrl = _data["screenShotUrl"];
            if (Array.isArray(_data["projectName"])) {
                this.projectName = [] as any;
                for (let item of _data["projectName"])
                    this.projectName!.push(ProjectDto.fromJS(item));
            }
            this.projectIcon = _data["projectIcon"];
            this.taskName = _data["taskName"];
            this.taskDescription = _data["taskDescription"];
            this.applicationName = _data["applicationName"];
            this.applicationIcon = _data["applicationIcon"];
            this.applicationType = _data["applicationType"];
            this.userStatus = _data["userStatus"];
            this.leftTime = _data["leftTime"] ? DateTime.fromISO(_data["leftTime"].toString()) : undefined as any;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserWiseLiveScreenShotDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWiseLiveScreenShotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userImage"] = this.userImage;
        data["userRole"] = this.userRole;
        data["userOrgnizationName"] = this.userOrgnizationName;
        data["userLocation"] = this.userLocation;
        data["userOfficeLocation"] = this.userOfficeLocation;
        data["screenShotUrl"] = this.screenShotUrl;
        if (Array.isArray(this.projectName)) {
            data["projectName"] = [];
            for (let item of this.projectName)
                data["projectName"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectIcon"] = this.projectIcon;
        data["taskName"] = this.taskName;
        data["taskDescription"] = this.taskDescription;
        data["applicationName"] = this.applicationName;
        data["applicationIcon"] = this.applicationIcon;
        data["applicationType"] = this.applicationType;
        data["userStatus"] = this.userStatus;
        data["leftTime"] = this.leftTime ? this.leftTime.toString() : undefined as any;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IUserWiseLiveScreenShotDto {
    userId: number;
    userName: string | undefined;
    userImage: string | undefined;
    userRole: string | undefined;
    userOrgnizationName: string | undefined;
    userLocation: string | undefined;
    userOfficeLocation: string | undefined;
    screenShotUrl: string | undefined;
    projectName: ProjectDto[] | undefined;
    projectIcon: string | undefined;
    taskName: string | undefined;
    taskDescription: string | undefined;
    applicationName: string | undefined;
    applicationIcon: string | undefined;
    applicationType: string | undefined;
    userStatus: UserStatusEnum;
    leftTime: DateTime | undefined;
    creationTime: DateTime | undefined;
}

export class UserWiseOrgnizationDto implements IUserWiseOrgnizationDto {
    tenantId!: number | undefined;
    userId!: number;
    orgnizationId!: number;
    orgnizationName!: string | undefined;

    constructor(data?: IUserWiseOrgnizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.orgnizationId = _data["orgnizationId"];
            this.orgnizationName = _data["orgnizationName"];
        }
    }

    static fromJS(data: any): UserWiseOrgnizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWiseOrgnizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["orgnizationId"] = this.orgnizationId;
        data["orgnizationName"] = this.orgnizationName;
        return data;
    }
}

export interface IUserWiseOrgnizationDto {
    tenantId: number | undefined;
    userId: number;
    orgnizationId: number;
    orgnizationName: string | undefined;
}

export class UserWiseProductiveUnproductiveAndNuetralDTO implements IUserWiseProductiveUnproductiveAndNuetralDTO {
    productive!: number;
    unProductive!: number;
    nuetral!: number;
    date!: DateTime | undefined;
    userId!: number;

    constructor(data?: IUserWiseProductiveUnproductiveAndNuetralDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productive = _data["productive"];
            this.unProductive = _data["unProductive"];
            this.nuetral = _data["nuetral"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserWiseProductiveUnproductiveAndNuetralDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserWiseProductiveUnproductiveAndNuetralDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productive"] = this.productive;
        data["unProductive"] = this.unProductive;
        data["nuetral"] = this.nuetral;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserWiseProductiveUnproductiveAndNuetralDTO {
    productive: number;
    unProductive: number;
    nuetral: number;
    date: DateTime | undefined;
    userId: number;
}

export class UserWiseProductiveUnproductiveAndNuetralTimeDto implements IUserWiseProductiveUnproductiveAndNuetralTimeDto {
    productiveTime!: string;
    unProductiveTime!: string;
    nuetralTime!: string;
    date!: DateTime | undefined;
    userId!: number;

    constructor(data?: IUserWiseProductiveUnproductiveAndNuetralTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productiveTime = _data["productiveTime"];
            this.unProductiveTime = _data["unProductiveTime"];
            this.nuetralTime = _data["nuetralTime"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserWiseProductiveUnproductiveAndNuetralTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWiseProductiveUnproductiveAndNuetralTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productiveTime"] = this.productiveTime;
        data["unProductiveTime"] = this.unProductiveTime;
        data["nuetralTime"] = this.nuetralTime;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserWiseProductiveUnproductiveAndNuetralTimeDto {
    productiveTime: string;
    unProductiveTime: string;
    nuetralTime: string;
    date: DateTime | undefined;
    userId: number;
}

export class UserWorkDaySetting implements IUserWorkDaySetting {
    tenantId!: number;
    userId!: number;
    isWorkMon!: boolean;
    isWorkTue!: boolean;
    isWorkWed!: boolean;
    isWorkThu!: boolean;
    isWorkFri!: boolean;
    isWorkSat!: boolean;
    isWorkSun!: boolean;
    workStartDate!: DateTime | undefined;
    workEndDate!: DateTime | undefined;
    isFlexWorkHrs!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserWorkDaySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isWorkMon = _data["isWorkMon"];
            this.isWorkTue = _data["isWorkTue"];
            this.isWorkWed = _data["isWorkWed"];
            this.isWorkThu = _data["isWorkThu"];
            this.isWorkFri = _data["isWorkFri"];
            this.isWorkSat = _data["isWorkSat"];
            this.isWorkSun = _data["isWorkSun"];
            this.workStartDate = _data["workStartDate"] ? DateTime.fromISO(_data["workStartDate"].toString()) : undefined as any;
            this.workEndDate = _data["workEndDate"] ? DateTime.fromISO(_data["workEndDate"].toString()) : undefined as any;
            this.isFlexWorkHrs = _data["isFlexWorkHrs"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : undefined as any;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWorkDaySetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserWorkDaySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isWorkMon"] = this.isWorkMon;
        data["isWorkTue"] = this.isWorkTue;
        data["isWorkWed"] = this.isWorkWed;
        data["isWorkThu"] = this.isWorkThu;
        data["isWorkFri"] = this.isWorkFri;
        data["isWorkSat"] = this.isWorkSat;
        data["isWorkSun"] = this.isWorkSun;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toString() : undefined as any;
        data["workEndDate"] = this.workEndDate ? this.workEndDate.toString() : undefined as any;
        data["isFlexWorkHrs"] = this.isFlexWorkHrs;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : undefined as any;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserWorkDaySetting {
    tenantId: number;
    userId: number;
    isWorkMon: boolean;
    isWorkTue: boolean;
    isWorkWed: boolean;
    isWorkThu: boolean;
    isWorkFri: boolean;
    isWorkSat: boolean;
    isWorkSun: boolean;
    workStartDate: DateTime | undefined;
    workEndDate: DateTime | undefined;
    isFlexWorkHrs: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserWorkDaySettingCreateOrEditDto implements IUserWorkDaySettingCreateOrEditDto {
    tenantId!: number | undefined;
    userId!: number;
    isWorkMon!: boolean;
    isWorkTue!: boolean;
    isWorkWed!: boolean;
    isWorkThu!: boolean;
    isWorkFri!: boolean;
    isWorkSat!: boolean;
    isWorkSun!: boolean;
    workStartDate!: DateTime | undefined;
    workEndDate!: DateTime | undefined;
    isFlexWorkHrs!: boolean;
    id!: number | undefined;

    constructor(data?: IUserWorkDaySettingCreateOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isWorkMon = _data["isWorkMon"];
            this.isWorkTue = _data["isWorkTue"];
            this.isWorkWed = _data["isWorkWed"];
            this.isWorkThu = _data["isWorkThu"];
            this.isWorkFri = _data["isWorkFri"];
            this.isWorkSat = _data["isWorkSat"];
            this.isWorkSun = _data["isWorkSun"];
            this.workStartDate = _data["workStartDate"] ? DateTime.fromISO(_data["workStartDate"].toString()) : undefined as any;
            this.workEndDate = _data["workEndDate"] ? DateTime.fromISO(_data["workEndDate"].toString()) : undefined as any;
            this.isFlexWorkHrs = _data["isFlexWorkHrs"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWorkDaySettingCreateOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWorkDaySettingCreateOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isWorkMon"] = this.isWorkMon;
        data["isWorkTue"] = this.isWorkTue;
        data["isWorkWed"] = this.isWorkWed;
        data["isWorkThu"] = this.isWorkThu;
        data["isWorkFri"] = this.isWorkFri;
        data["isWorkSat"] = this.isWorkSat;
        data["isWorkSun"] = this.isWorkSun;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toString() : undefined as any;
        data["workEndDate"] = this.workEndDate ? this.workEndDate.toString() : undefined as any;
        data["isFlexWorkHrs"] = this.isFlexWorkHrs;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserWorkDaySettingCreateOrEditDto {
    tenantId: number | undefined;
    userId: number;
    isWorkMon: boolean;
    isWorkTue: boolean;
    isWorkWed: boolean;
    isWorkThu: boolean;
    isWorkFri: boolean;
    isWorkSat: boolean;
    isWorkSun: boolean;
    workStartDate: DateTime | undefined;
    workEndDate: DateTime | undefined;
    isFlexWorkHrs: boolean;
    id: number | undefined;
}

export class UserWorkingDays implements IUserWorkingDays {
    isWorkMon!: boolean;
    isWorkTue!: boolean;
    isWorkWed!: boolean;
    isWorkThu!: boolean;
    isWorkFri!: boolean;
    isWorkSat!: boolean;
    isWorkSun!: boolean;

    constructor(data?: IUserWorkingDays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isWorkMon = _data["isWorkMon"];
            this.isWorkTue = _data["isWorkTue"];
            this.isWorkWed = _data["isWorkWed"];
            this.isWorkThu = _data["isWorkThu"];
            this.isWorkFri = _data["isWorkFri"];
            this.isWorkSat = _data["isWorkSat"];
            this.isWorkSun = _data["isWorkSun"];
        }
    }

    static fromJS(data: any): UserWorkingDays {
        data = typeof data === 'object' ? data : {};
        let result = new UserWorkingDays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isWorkMon"] = this.isWorkMon;
        data["isWorkTue"] = this.isWorkTue;
        data["isWorkWed"] = this.isWorkWed;
        data["isWorkThu"] = this.isWorkThu;
        data["isWorkFri"] = this.isWorkFri;
        data["isWorkSat"] = this.isWorkSat;
        data["isWorkSun"] = this.isWorkSun;
        return data;
    }
}

export interface IUserWorkingDays {
    isWorkMon: boolean;
    isWorkTue: boolean;
    isWorkWed: boolean;
    isWorkThu: boolean;
    isWorkFri: boolean;
    isWorkSat: boolean;
    isWorkSun: boolean;
}

export class UserWorkingStatus implements IUserWorkingStatus {
    workingFrom!: WorkFromType[] | undefined;
    sublocality!: string | undefined;
    date!: DateTime;

    constructor(data?: IUserWorkingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workingFrom"])) {
                this.workingFrom = [] as any;
                for (let item of _data["workingFrom"])
                    this.workingFrom!.push(item);
            }
            this.sublocality = _data["sublocality"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserWorkingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserWorkingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workingFrom)) {
            data["workingFrom"] = [];
            for (let item of this.workingFrom)
                data["workingFrom"].push(item);
        }
        data["sublocality"] = this.sublocality;
        data["date"] = this.date ? this.date.toString() : undefined as any;
        return data;
    }
}

export interface IUserWorkingStatus {
    workingFrom: WorkFromType[] | undefined;
    sublocality: string | undefined;
    date: DateTime;
}

export class UsersCalendarDto implements IUsersCalendarDto {
    awayTimes!: AddAwayTimeGetAllDto[] | undefined;
    teamUsers!: TeamUsers[] | undefined;

    constructor(data?: IUsersCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["awayTimes"])) {
                this.awayTimes = [] as any;
                for (let item of _data["awayTimes"])
                    this.awayTimes!.push(AddAwayTimeGetAllDto.fromJS(item));
            }
            if (Array.isArray(_data["teamUsers"])) {
                this.teamUsers = [] as any;
                for (let item of _data["teamUsers"])
                    this.teamUsers!.push(TeamUsers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.awayTimes)) {
            data["awayTimes"] = [];
            for (let item of this.awayTimes)
                data["awayTimes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teamUsers)) {
            data["teamUsers"] = [];
            for (let item of this.teamUsers)
                data["teamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUsersCalendarDto {
    awayTimes: AddAwayTimeGetAllDto[] | undefined;
    teamUsers: TeamUsers[] | undefined;
}

export class UsersToDesignationUnitInput implements IUsersToDesignationUnitInput {
    userIds!: number[] | undefined;
    designationUnitId!: number;

    constructor(data?: IUsersToDesignationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.designationUnitId = _data["designationUnitId"];
        }
    }

    static fromJS(data: any): UsersToDesignationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToDesignationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["designationUnitId"] = this.designationUnitId;
        return data;
    }
}

export interface IUsersToDesignationUnitInput {
    userIds: number[] | undefined;
    designationUnitId: number;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class ValueTupleOfDateTimeDateTime implements IValueTupleOfDateTimeDateTime {
    item1!: DateTime;
    item2!: DateTime;

    constructor(data?: IValueTupleOfDateTimeDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? DateTime.fromISO(_data["item1"].toString()) : undefined as any;
            this.item2 = _data["item2"] ? DateTime.fromISO(_data["item2"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ValueTupleOfDateTimeDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfDateTimeDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toString() : undefined as any;
        data["item2"] = this.item2 ? this.item2.toString() : undefined as any;
        return data;
    }
}

export interface IValueTupleOfDateTimeDateTime {
    item1: DateTime;
    item2: DateTime;
}

export class ValueTupleOfDateTimeDateTimeTimeZoneInfo implements IValueTupleOfDateTimeDateTimeTimeZoneInfo {
    item1!: DateTime;
    item2!: DateTime;
    item3!: any;

    constructor(data?: IValueTupleOfDateTimeDateTimeTimeZoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? DateTime.fromISO(_data["item1"].toString()) : undefined as any;
            this.item2 = _data["item2"] ? DateTime.fromISO(_data["item2"].toString()) : undefined as any;
            this.item3 = _data["item3"];
        }
    }

    static fromJS(data: any): ValueTupleOfDateTimeDateTimeTimeZoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfDateTimeDateTimeTimeZoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toString() : undefined as any;
        data["item2"] = this.item2 ? this.item2.toString() : undefined as any;
        data["item3"] = this.item3;
        return data;
    }
}

export interface IValueTupleOfDateTimeDateTimeTimeZoneInfo {
    item1: DateTime;
    item2: DateTime;
    item3: any;
}

export class ValueTupleOfStringListOfInt64 implements IValueTupleOfStringListOfInt64 {
    item1!: string | undefined;
    item2!: number[] | undefined;

    constructor(data?: IValueTupleOfStringListOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            if (Array.isArray(_data["item2"])) {
                this.item2 = [] as any;
                for (let item of _data["item2"])
                    this.item2!.push(item);
            }
        }
    }

    static fromJS(data: any): ValueTupleOfStringListOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfStringListOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        if (Array.isArray(this.item2)) {
            data["item2"] = [];
            for (let item of this.item2)
                data["item2"].push(item);
        }
        return data;
    }
}

export interface IValueTupleOfStringListOfInt64 {
    item1: string | undefined;
    item2: number[] | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class ViewSummaryDto implements IViewSummaryDto {
    internalUseUserId!: number;
    projectId!: number;
    internalUseTimesheetId!: number;
    projectName!: string | undefined;
    projectImage!: string | undefined;
    projectStartDate!: DateTime;
    projectEndDate!: DateTime;
    timesheetFromDate!: DateTime;
    timesheetToDate!: DateTime;
    loggedHours!: string;
    billedHours!: string;
    requiredHours!: string;
    nextLevelUserName!: string | undefined;
    nextLevelUserImage!: string | undefined;
    nextLevelUserRole!: string | undefined;
    hoursOrDay!: number;
    leaves!: number;
    timesheetDate!: DateTime | undefined;
    approvalWindowType!: ApprovalWindowInEnum;
    timesheetFrequency!: ProjectTimesheetFrequencyEnum;
    userDetailsList!: UserDetailsDto[] | undefined;
    submittedUserList!: UserDetailsDto[] | undefined;
    pendingUserList!: UserDetailsDto[] | undefined;
    approvedUserList!: UserDetailsDto[] | undefined;
    nextLevelApprovalList!: NextLevelApprovalDto[] | undefined;
    rejectedUserList!: UserDetailsDto[] | undefined;
    dateWiseTimesheetIds!: TimesheetIdsDateWise[] | undefined;
    approvalDetails!: ApprovalDetailsDto[] | undefined;

    constructor(data?: IViewSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalUseUserId = _data["internalUseUserId"];
            this.projectId = _data["projectId"];
            this.internalUseTimesheetId = _data["internalUseTimesheetId"];
            this.projectName = _data["projectName"];
            this.projectImage = _data["projectImage"];
            this.projectStartDate = _data["projectStartDate"] ? DateTime.fromISO(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? DateTime.fromISO(_data["projectEndDate"].toString()) : undefined as any;
            this.timesheetFromDate = _data["timesheetFromDate"] ? DateTime.fromISO(_data["timesheetFromDate"].toString()) : undefined as any;
            this.timesheetToDate = _data["timesheetToDate"] ? DateTime.fromISO(_data["timesheetToDate"].toString()) : undefined as any;
            this.loggedHours = _data["loggedHours"];
            this.billedHours = _data["billedHours"];
            this.requiredHours = _data["requiredHours"];
            this.nextLevelUserName = _data["nextLevelUserName"];
            this.nextLevelUserImage = _data["nextLevelUserImage"];
            this.nextLevelUserRole = _data["nextLevelUserRole"];
            this.hoursOrDay = _data["hoursOrDay"];
            this.leaves = _data["leaves"];
            this.timesheetDate = _data["timesheetDate"] ? DateTime.fromISO(_data["timesheetDate"].toString()) : undefined as any;
            this.approvalWindowType = _data["approvalWindowType"];
            this.timesheetFrequency = _data["timesheetFrequency"];
            if (Array.isArray(_data["userDetailsList"])) {
                this.userDetailsList = [] as any;
                for (let item of _data["userDetailsList"])
                    this.userDetailsList!.push(UserDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["submittedUserList"])) {
                this.submittedUserList = [] as any;
                for (let item of _data["submittedUserList"])
                    this.submittedUserList!.push(UserDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["pendingUserList"])) {
                this.pendingUserList = [] as any;
                for (let item of _data["pendingUserList"])
                    this.pendingUserList!.push(UserDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["approvedUserList"])) {
                this.approvedUserList = [] as any;
                for (let item of _data["approvedUserList"])
                    this.approvedUserList!.push(UserDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["nextLevelApprovalList"])) {
                this.nextLevelApprovalList = [] as any;
                for (let item of _data["nextLevelApprovalList"])
                    this.nextLevelApprovalList!.push(NextLevelApprovalDto.fromJS(item));
            }
            if (Array.isArray(_data["rejectedUserList"])) {
                this.rejectedUserList = [] as any;
                for (let item of _data["rejectedUserList"])
                    this.rejectedUserList!.push(UserDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["dateWiseTimesheetIds"])) {
                this.dateWiseTimesheetIds = [] as any;
                for (let item of _data["dateWiseTimesheetIds"])
                    this.dateWiseTimesheetIds!.push(TimesheetIdsDateWise.fromJS(item));
            }
            if (Array.isArray(_data["approvalDetails"])) {
                this.approvalDetails = [] as any;
                for (let item of _data["approvalDetails"])
                    this.approvalDetails!.push(ApprovalDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ViewSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalUseUserId"] = this.internalUseUserId;
        data["projectId"] = this.projectId;
        data["internalUseTimesheetId"] = this.internalUseTimesheetId;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toString() : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toString() : undefined as any;
        data["timesheetFromDate"] = this.timesheetFromDate ? this.timesheetFromDate.toString() : undefined as any;
        data["timesheetToDate"] = this.timesheetToDate ? this.timesheetToDate.toString() : undefined as any;
        data["loggedHours"] = this.loggedHours;
        data["billedHours"] = this.billedHours;
        data["requiredHours"] = this.requiredHours;
        data["nextLevelUserName"] = this.nextLevelUserName;
        data["nextLevelUserImage"] = this.nextLevelUserImage;
        data["nextLevelUserRole"] = this.nextLevelUserRole;
        data["hoursOrDay"] = this.hoursOrDay;
        data["leaves"] = this.leaves;
        data["timesheetDate"] = this.timesheetDate ? this.timesheetDate.toString() : undefined as any;
        data["approvalWindowType"] = this.approvalWindowType;
        data["timesheetFrequency"] = this.timesheetFrequency;
        if (Array.isArray(this.userDetailsList)) {
            data["userDetailsList"] = [];
            for (let item of this.userDetailsList)
                data["userDetailsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.submittedUserList)) {
            data["submittedUserList"] = [];
            for (let item of this.submittedUserList)
                data["submittedUserList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pendingUserList)) {
            data["pendingUserList"] = [];
            for (let item of this.pendingUserList)
                data["pendingUserList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.approvedUserList)) {
            data["approvedUserList"] = [];
            for (let item of this.approvedUserList)
                data["approvedUserList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nextLevelApprovalList)) {
            data["nextLevelApprovalList"] = [];
            for (let item of this.nextLevelApprovalList)
                data["nextLevelApprovalList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rejectedUserList)) {
            data["rejectedUserList"] = [];
            for (let item of this.rejectedUserList)
                data["rejectedUserList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dateWiseTimesheetIds)) {
            data["dateWiseTimesheetIds"] = [];
            for (let item of this.dateWiseTimesheetIds)
                data["dateWiseTimesheetIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.approvalDetails)) {
            data["approvalDetails"] = [];
            for (let item of this.approvalDetails)
                data["approvalDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IViewSummaryDto {
    internalUseUserId: number;
    projectId: number;
    internalUseTimesheetId: number;
    projectName: string | undefined;
    projectImage: string | undefined;
    projectStartDate: DateTime;
    projectEndDate: DateTime;
    timesheetFromDate: DateTime;
    timesheetToDate: DateTime;
    loggedHours: string;
    billedHours: string;
    requiredHours: string;
    nextLevelUserName: string | undefined;
    nextLevelUserImage: string | undefined;
    nextLevelUserRole: string | undefined;
    hoursOrDay: number;
    leaves: number;
    timesheetDate: DateTime | undefined;
    approvalWindowType: ApprovalWindowInEnum;
    timesheetFrequency: ProjectTimesheetFrequencyEnum;
    userDetailsList: UserDetailsDto[] | undefined;
    submittedUserList: UserDetailsDto[] | undefined;
    pendingUserList: UserDetailsDto[] | undefined;
    approvedUserList: UserDetailsDto[] | undefined;
    nextLevelApprovalList: NextLevelApprovalDto[] | undefined;
    rejectedUserList: UserDetailsDto[] | undefined;
    dateWiseTimesheetIds: TimesheetIdsDateWise[] | undefined;
    approvalDetails: ApprovalDetailsDto[] | undefined;
}

export class WebhookEvent implements IWebhookEvent {
    webhookName!: string;
    data!: string | undefined;
    creationTime!: DateTime;
    tenantId!: number | undefined;
    isDeleted!: boolean;
    deletionTime!: DateTime | undefined;
    id!: string;

    constructor(data?: IWebhookEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookEvent {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IWebhookEvent {
    webhookName: string;
    data: string | undefined;
    creationTime: DateTime;
    tenantId: number | undefined;
    isDeleted: boolean;
    deletionTime: DateTime | undefined;
    id: string;
}

export class WebhookSubscription implements IWebhookSubscription {
    tenantId!: number | undefined;
    webhookUri!: string | undefined;
    secret!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    headers!: { [key: string]: string; } | undefined;
    id!: string;

    constructor(data?: IWebhookSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.webhookUri = _data["webhookUri"];
            this.secret = _data["secret"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            if (_data["headers"]) {
                this.headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        (this.headers as any)![key] = _data["headers"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["webhookUri"] = this.webhookUri;
        data["secret"] = this.secret;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (data["headers"] as any)[key] = (this.headers as any)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IWebhookSubscription {
    tenantId: number | undefined;
    webhookUri: string | undefined;
    secret: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    headers: { [key: string]: string; } | undefined;
    id: string;
}

export enum WeekIndex {
    First = 0,
    Second = 1,
    Third = 2,
    Fourth = 3,
    Last = 4,
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data;
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    id!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export class WindowsTrackingDataDto implements IWindowsTrackingDataDto {
    tenantId!: number | undefined;
    userActivityTempId!: number | undefined;
    windowsTracking!: string | undefined;

    constructor(data?: IWindowsTrackingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userActivityTempId = _data["userActivityTempId"];
            this.windowsTracking = _data["windowsTracking"];
        }
    }

    static fromJS(data: any): WindowsTrackingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new WindowsTrackingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userActivityTempId"] = this.userActivityTempId;
        data["windowsTracking"] = this.windowsTracking;
        return data;
    }
}

export interface IWindowsTrackingDataDto {
    tenantId: number | undefined;
    userActivityTempId: number | undefined;
    windowsTracking: string | undefined;
}

export enum WorkFromType {
    WorkFromHome = 1,
    WorkFromOffice = 2,
    WorkFromRemote = 3,
    Unknown = 4,
}

export enum WorkItemTypeEnum {
    Bug = 1,
    UserStory = 2,
    Feature = 3,
    Task = 4,
    TestCase = 5,
    TestPlan = 6,
    TestSuite = 7,
    Epic = 8,
    Issue = 9,
    Ticket = 10,
    Internal = 11,
}

export class WorkStatusUser implements IWorkStatusUser {
    fullName!: string | undefined;
    employeeId!: string | undefined;
    userstatus!: UserWorkingStatus[] | undefined;
    months!: string[] | undefined;
    days!: string[] | undefined;

    constructor(data?: IWorkStatusUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["userstatus"])) {
                this.userstatus = [] as any;
                for (let item of _data["userstatus"])
                    this.userstatus!.push(UserWorkingStatus.fromJS(item));
            }
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStatusUser {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStatusUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.userstatus)) {
            data["userstatus"] = [];
            for (let item of this.userstatus)
                data["userstatus"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        return data;
    }
}

export interface IWorkStatusUser {
    fullName: string | undefined;
    employeeId: string | undefined;
    userstatus: UserWorkingStatus[] | undefined;
    months: string[] | undefined;
    days: string[] | undefined;
}

export class WorkingTrack implements IWorkingTrack {
    isWorkMon!: boolean;
    isWorkTue!: boolean;
    isWorkWed!: boolean;
    isWorkThu!: boolean;
    isWorkFri!: boolean;
    isWorkSat!: boolean;
    isWorkSun!: boolean;
    startTime!: string;
    endTime!: string;
    city!: number;
    locationId!: number;
    userId!: number;

    constructor(data?: IWorkingTrack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isWorkMon = _data["isWorkMon"];
            this.isWorkTue = _data["isWorkTue"];
            this.isWorkWed = _data["isWorkWed"];
            this.isWorkThu = _data["isWorkThu"];
            this.isWorkFri = _data["isWorkFri"];
            this.isWorkSat = _data["isWorkSat"];
            this.isWorkSun = _data["isWorkSun"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.city = _data["city"];
            this.locationId = _data["locationId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): WorkingTrack {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingTrack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isWorkMon"] = this.isWorkMon;
        data["isWorkTue"] = this.isWorkTue;
        data["isWorkWed"] = this.isWorkWed;
        data["isWorkThu"] = this.isWorkThu;
        data["isWorkFri"] = this.isWorkFri;
        data["isWorkSat"] = this.isWorkSat;
        data["isWorkSun"] = this.isWorkSun;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["city"] = this.city;
        data["locationId"] = this.locationId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IWorkingTrack {
    isWorkMon: boolean;
    isWorkTue: boolean;
    isWorkWed: boolean;
    isWorkThu: boolean;
    isWorkFri: boolean;
    isWorkSat: boolean;
    isWorkSun: boolean;
    startTime: string;
    endTime: string;
    city: number;
    locationId: number;
    userId: number;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class OfflineApptrackingDataDto implements IOfflineApptrackingDataDto {
    dataFile!: UserActivityTempCreateOrEditDto[] | undefined;

    constructor(data?: IOfflineApptrackingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataFile"])) {
                this.dataFile = [] as any;
                for (let item of _data["dataFile"])
                    this.dataFile!.push(UserActivityTempCreateOrEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfflineApptrackingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineApptrackingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataFile)) {
            data["dataFile"] = [];
            for (let item of this.dataFile)
                data["dataFile"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOfflineApptrackingDataDto {
    dataFile: UserActivityTempCreateOrEditDto[] | undefined;
}

export class OfflineStopDto implements IOfflineStopDto {
    userId!: number;
    tenantId!: number;
    projectId!: number;
    taskId!: number;
    creationTime!: DateTime | undefined;

    constructor(data?: IOfflineStopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.taskId = _data["taskId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OfflineStopDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineStopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["taskId"] = this.taskId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : undefined as any;
        return data;
    }
}

export interface IOfflineStopDto {
    userId: number;
    tenantId: number;
    projectId: number;
    taskId: number;
    creationTime: DateTime | undefined;
}

export class ProddataResult implements IProddataResult {
    key!: string | undefined;
    val!: number;

    constructor(data?: IProddataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.val = _data["val"];
        }
    }

    static fromJS(data: any): ProddataResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProddataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["val"] = this.val;
        return data;
    }
}

export interface IProddataResult {
    key: string | undefined;
    val: number;
}

export enum LeaveTypeInfo {
    HalfDay = 1,
    FullDay = 2,
}

export enum ProjectType2 {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum ClientType2 {
    AllClients = 1,
    ArchivedClients = 2,
    DeletedClients = 3,
    TotalClients = 4,
}

export enum ClientType3 {
    AllClients = 1,
    ArchivedClients = 2,
    DeletedClients = 3,
    TotalClients = 4,
}

export enum ProjectType3 {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum Provider {
    Outlook = 1,
    Keka = 2,
    ChatGpt = 3,
    Claude = 4,
    GitHubCopilot = 5,
    Cursor = 6,
    AzureDevOps = 7,
}

export enum FileType {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export enum ProjectType4 {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum ProjectType5 {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum ProjectTypeForListView {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum ProjType {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum ProjectType6 {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum ProjectType7 {
    AllProjects = 1,
    ArchivedProjects = 2,
    DeletedProjects = 3,
}

export enum CalType {
    Google = 0,
    Outlook = 1,
    System = 2,
}

export enum CalType2 {
    Google = 0,
    Outlook = 1,
    System = 2,
}

export enum ProductType2 {
    AllProducts = 1,
    ArchivedProducts = 2,
    DeletedProducts = 3,
}

export enum ServiceType2 {
    AllServices = 1,
    ArchivedServices = 2,
    DeletedServices = 3,
}

export enum FileType2 {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export enum FileType3 {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in _data["Paypal"]) {
                    if (_data["Paypal"].hasOwnProperty(key))
                        (this.paypal as any)![key] = _data["Paypal"][key];
                }
            }
            if (_data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in _data["Stripe"]) {
                    if (_data["Stripe"].hasOwnProperty(key))
                        (this.stripe as any)![key] = _data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    (data["Paypal"] as any)[key] = (this.paypal as any)[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    (data["Stripe"] as any)[key] = (this.stripe as any)[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}